webpackJsonp([2],Array(836).concat([
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojione = __webpack_require__(922);

var _emojione2 = _interopRequireDefault(_emojione);

var _store = __webpack_require__(1000);

var _store2 = _interopRequireDefault(_store);

var _each = __webpack_require__(1001);

var _each2 = _interopRequireDefault(_each);

var _map = __webpack_require__(897);

var _map2 = _interopRequireDefault(_map);

var _omit = __webpack_require__(1071);

var _omit2 = _interopRequireDefault(_omit);

var _emoji = __webpack_require__(1107);

var _emoji2 = _interopRequireDefault(_emoji);

var _emoji3 = __webpack_require__(951);

var _emoji4 = _interopRequireDefault(_emoji3);

var _categories = __webpack_require__(1112);

var _categories2 = _interopRequireDefault(_categories);

var _createRowsSelector = __webpack_require__(1134);

var _createRowsSelector2 = _interopRequireDefault(_createRowsSelector);

var _createEmojisFromStrategy = __webpack_require__(1140);

var _createEmojisFromStrategy2 = _interopRequireDefault(_createEmojisFromStrategy);

var _constants = __webpack_require__(1141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Picker = function (_Component) {
  _inherits(Picker, _Component);

  function Picker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Picker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Picker.__proto__ || Object.getPrototypeOf(Picker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modifier: _store2.default.get("emoji-modifier") || "0",
      category: false,
      term: _this.props.search !== true ? _this.props.search : ""
    }, _this.setFocus = function (ev) {
      if (ev.target.id === "flags") {
        _this.categories[_this.state.category].children[0].focus();
      }
    }, _this._renderHeaderCategories = function () {
      return (0, _map2.default)(_this.props.categories, function (details, key) {
        return _react2.default.createElement(
          "li",
          {
            key: key,
            className: _this.state.category === key ? "active" : undefined
          },
          _react2.default.createElement(_emoji4.default, {
            id: key,
            role: "menuitem",
            ariaLabel: key + " category",
            shortname: ":" + details.emoji + ":",
            onSelect: function onSelect() {
              _this.categories.jumpToCategory(key);
            }
          })
        );
      });
    }, _this._renderCategories = function () {
      var rows = _this.rowsSelector(_this.props.categories, _this.state.emojis, _this.state.modifier, _this.props.search, _this.state.term);

      return _react2.default.createElement(
        "div",
        { className: "emoji-categories-wrapper" },
        _react2.default.createElement(_categories2.default, {
          nonce: _this.props.nonce,
          ref: _this._setCategoriesRef,
          rows: rows,
          modifier: _this.state.modifier,
          onActiveCategoryChange: _this._onActiveCategoryChange,
          onChange: _this.props.onChange,
          onModifierChange: _this._onModifierChange
        })
      );
    }, _this._setCategoriesRef = function (categories) {
      _this.categories = categories;
    }, _this._setSearchRef = function (ref) {
      _this.search = ref;
    }, _this._onActiveCategoryChange = function (category) {
      if (category !== _this.state.category) {
        _this.setState({ category: category });
      }
    }, _this._onModifierChange = function (modifier) {
      _this.setState({ modifier: modifier });
      _store2.default.set("emoji-modifier", modifier);
    }, _this._renderSearchInput = function () {
      if (_this.props.search === true) {
        return _react2.default.createElement(
          "div",
          { className: "emoji-search-wrapper" },
          _react2.default.createElement("input", {
            className: "emoji-search",
            type: "search",
            placeholder: _this.props.searchPlaceholder,
            ref: _this._setSearchRef,
            onChange: _this._updateSearchTerm,
            autoFocus: true
          })
        );
      }

      return null;
    }, _this._updateSearchTerm = function () {
      _this.setState({ term: _this.search.value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Picker, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.rowsSelector = (0, _createRowsSelector2.default)();

      (0, _each2.default)(this.props.emojione, function (value, key) {
        _emojione2.default[key] = value;
      });
      this.setState({ emojis: (0, _createEmojisFromStrategy2.default)(_emoji2.default) });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ category: this.categories.getActiveCategory() }); // eslint-disable-line
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.search !== nextProps.search) {
        this.setState({ term: this.props.search });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _omit2.default)(this.props, Object.keys(Picker.propTypes));
      var classes = "emoji-dialog";
      if (this.props.search === true) classes += " with-search";
      if (this.props.className) classes += " " + this.props.className;

      return _react2.default.createElement(
        "div",
        _extends({ className: classes, role: "dialog" }, props),
        _react2.default.createElement(
          "header",
          { className: "emoji-dialog-header", role: "menu" },
          _react2.default.createElement(
            "ul",
            { onBlur: this.setFocus },
            this._renderHeaderCategories()
          )
        ),
        this._renderSearchInput(),
        this._renderCategories()
      );
    }
  }]);

  return Picker;
}(_react.Component);

Picker.propTypes = {
  emojione: _propTypes2.default.shape({
    imageType: _propTypes2.default.string,
    sprites: _propTypes2.default.bool,
    imagePathSVGSprites: _propTypes2.default.string
  }),
  search: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  searchPlaceholder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  categories: _propTypes2.default.object
};
Picker.defaultProps = {
  search: "",
  searchPlaceholder: "Search…",
  categories: _constants.defaultCategories
};
exports.default = Picker;

/***/ }),
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 865 */,
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1028),
    getValue = __webpack_require__(1031);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(925),
    baseKeys = __webpack_require__(1012),
    isArrayLike = __webpack_require__(874);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(864),
    isKey = __webpack_require__(903),
    stringToPath = __webpack_require__(1060),
    toString = __webpack_require__(1063);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(421);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(928),
    isLength = __webpack_require__(894);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(904),
    baseAssignValue = __webpack_require__(943);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 883 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1018),
    listCacheDelete = __webpack_require__(1019),
    listCacheGet = __webpack_require__(1020),
    listCacheHas = __webpack_require__(1021),
    listCacheSet = __webpack_require__(1022);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(886);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1040);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(872),
    toKey = __webpack_require__(873);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 890 */,
/* 891 */,
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1007),
    isObjectLike = __webpack_require__(331);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(177),
    stubFalse = __webpack_require__(1008);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(185)(module)))

/***/ }),
/* 894 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 895 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 896 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(883),
    baseIteratee = __webpack_require__(929),
    baseMap = __webpack_require__(1070),
    isArray = __webpack_require__(864);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(884),
    stackClear = __webpack_require__(1023),
    stackDelete = __webpack_require__(1024),
    stackGet = __webpack_require__(1025),
    stackHas = __webpack_require__(1026),
    stackSet = __webpack_require__(1027);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866),
    root = __webpack_require__(177);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1032),
    mapCacheDelete = __webpack_require__(1039),
    mapCacheGet = __webpack_require__(1041),
    mapCacheHas = __webpack_require__(1042),
    mapCacheSet = __webpack_require__(1043);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 901 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1052),
    stubArray = __webpack_require__(938);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(864),
    isSymbol = __webpack_require__(421);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(943),
    eq = __webpack_require__(886);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(927);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(933);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

/* jshint maxerr: 10000 */
/* jslint unused: true */
/* jshint shadow: true */
/* jshint -W075 */
(function(ns){
    // this list must be ordered from largest length of the value array, index 0, to the shortest
    ns.emojioneList = {":kiss_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","1f469-2764-1f48b-1f469"],"fname":"1f469-2764-1f48b-1f469","uc":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","isCanonical": true},":couplekiss_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","1f469-2764-1f48b-1f469"],"fname":"1f469-2764-1f48b-1f469","uc":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","isCanonical": false},":kiss_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","1f468-2764-1f48b-1f468"],"fname":"1f468-2764-1f48b-1f468","uc":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","isCanonical": true},":couplekiss_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","1f468-2764-1f48b-1f468"],"fname":"1f468-2764-1f48b-1f468","uc":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","isCanonical": false},":family_mmbb:":{"unicode":["1f468-200d-1f468-200d-1f466-200d-1f466","1f468-1f468-1f466-1f466"],"fname":"1f468-1f468-1f466-1f466","uc":"1f468-200d-1f468-200d-1f466-200d-1f466","isCanonical": true},":family_mmgb:":{"unicode":["1f468-200d-1f468-200d-1f467-200d-1f466","1f468-1f468-1f467-1f466"],"fname":"1f468-1f468-1f467-1f466","uc":"1f468-200d-1f468-200d-1f467-200d-1f466","isCanonical": true},":family_mmgg:":{"unicode":["1f468-200d-1f468-200d-1f467-200d-1f467","1f468-1f468-1f467-1f467"],"fname":"1f468-1f468-1f467-1f467","uc":"1f468-200d-1f468-200d-1f467-200d-1f467","isCanonical": true},":family_mwbb:":{"unicode":["1f468-200d-1f469-200d-1f466-200d-1f466","1f468-1f469-1f466-1f466"],"fname":"1f468-1f469-1f466-1f466","uc":"1f468-200d-1f469-200d-1f466-200d-1f466","isCanonical": true},":family_mwgb:":{"unicode":["1f468-200d-1f469-200d-1f467-200d-1f466","1f468-1f469-1f467-1f466"],"fname":"1f468-1f469-1f467-1f466","uc":"1f468-200d-1f469-200d-1f467-200d-1f466","isCanonical": true},":family_mwgg:":{"unicode":["1f468-200d-1f469-200d-1f467-200d-1f467","1f468-1f469-1f467-1f467"],"fname":"1f468-1f469-1f467-1f467","uc":"1f468-200d-1f469-200d-1f467-200d-1f467","isCanonical": true},":family_wwbb:":{"unicode":["1f469-200d-1f469-200d-1f466-200d-1f466","1f469-1f469-1f466-1f466"],"fname":"1f469-1f469-1f466-1f466","uc":"1f469-200d-1f469-200d-1f466-200d-1f466","isCanonical": true},":family_wwgb:":{"unicode":["1f469-200d-1f469-200d-1f467-200d-1f466","1f469-1f469-1f467-1f466"],"fname":"1f469-1f469-1f467-1f466","uc":"1f469-200d-1f469-200d-1f467-200d-1f466","isCanonical": true},":family_wwgg:":{"unicode":["1f469-200d-1f469-200d-1f467-200d-1f467","1f469-1f469-1f467-1f467"],"fname":"1f469-1f469-1f467-1f467","uc":"1f469-200d-1f469-200d-1f467-200d-1f467","isCanonical": true},":couple_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f469","1f469-2764-1f469"],"fname":"1f469-2764-1f469","uc":"1f469-200d-2764-fe0f-200d-1f469","isCanonical": true},":couple_with_heart_ww:":{"unicode":["1f469-200d-2764-fe0f-200d-1f469","1f469-2764-1f469"],"fname":"1f469-2764-1f469","uc":"1f469-200d-2764-fe0f-200d-1f469","isCanonical": false},":couple_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f468","1f468-2764-1f468"],"fname":"1f468-2764-1f468","uc":"1f468-200d-2764-fe0f-200d-1f468","isCanonical": true},":couple_with_heart_mm:":{"unicode":["1f468-200d-2764-fe0f-200d-1f468","1f468-2764-1f468"],"fname":"1f468-2764-1f468","uc":"1f468-200d-2764-fe0f-200d-1f468","isCanonical": false},":family_mmb:":{"unicode":["1f468-200d-1f468-200d-1f466","1f468-1f468-1f466"],"fname":"1f468-1f468-1f466","uc":"1f468-200d-1f468-200d-1f466","isCanonical": true},":family_mmg:":{"unicode":["1f468-200d-1f468-200d-1f467","1f468-1f468-1f467"],"fname":"1f468-1f468-1f467","uc":"1f468-200d-1f468-200d-1f467","isCanonical": true},":family_mwg:":{"unicode":["1f468-200d-1f469-200d-1f467","1f468-1f469-1f467"],"fname":"1f468-1f469-1f467","uc":"1f468-200d-1f469-200d-1f467","isCanonical": true},":family_wwb:":{"unicode":["1f469-200d-1f469-200d-1f466","1f469-1f469-1f466"],"fname":"1f469-1f469-1f466","uc":"1f469-200d-1f469-200d-1f466","isCanonical": true},":family_wwg:":{"unicode":["1f469-200d-1f469-200d-1f467","1f469-1f469-1f467"],"fname":"1f469-1f469-1f467","uc":"1f469-200d-1f469-200d-1f467","isCanonical": true},":rainbow_flag:":{"unicode":["1f3f3-fe0f-200d-1f308","1f3f3-1f308"],"fname":"1f3f3-1f308","uc":"1f3f3-fe0f-200d-1f308","isCanonical": true},":gay_pride_flag:":{"unicode":["1f3f3-fe0f-200d-1f308","1f3f3-1f308"],"fname":"1f3f3-1f308","uc":"1f3f3-fe0f-200d-1f308","isCanonical": false},":eye_in_speech_bubble:":{"unicode":["1f441-200d-1f5e8","1f441-1f5e8"],"fname":"1f441-1f5e8","uc":"1f441-200d-1f5e8","isCanonical": true},":hash:":{"unicode":["0023-fe0f-20e3","0023-20e3"],"fname":"0023-20e3","uc":"0023-20e3","isCanonical": true},":zero:":{"unicode":["0030-fe0f-20e3","0030-20e3"],"fname":"0030-20e3","uc":"0030-20e3","isCanonical": true},":one:":{"unicode":["0031-fe0f-20e3","0031-20e3"],"fname":"0031-20e3","uc":"0031-20e3","isCanonical": true},":two:":{"unicode":["0032-fe0f-20e3","0032-20e3"],"fname":"0032-20e3","uc":"0032-20e3","isCanonical": true},":three:":{"unicode":["0033-fe0f-20e3","0033-20e3"],"fname":"0033-20e3","uc":"0033-20e3","isCanonical": true},":four:":{"unicode":["0034-fe0f-20e3","0034-20e3"],"fname":"0034-20e3","uc":"0034-20e3","isCanonical": true},":five:":{"unicode":["0035-fe0f-20e3","0035-20e3"],"fname":"0035-20e3","uc":"0035-20e3","isCanonical": true},":six:":{"unicode":["0036-fe0f-20e3","0036-20e3"],"fname":"0036-20e3","uc":"0036-20e3","isCanonical": true},":seven:":{"unicode":["0037-fe0f-20e3","0037-20e3"],"fname":"0037-20e3","uc":"0037-20e3","isCanonical": true},":eight:":{"unicode":["0038-fe0f-20e3","0038-20e3"],"fname":"0038-20e3","uc":"0038-20e3","isCanonical": true},":nine:":{"unicode":["0039-fe0f-20e3","0039-20e3"],"fname":"0039-20e3","uc":"0039-20e3","isCanonical": true},":asterisk:":{"unicode":["002a-fe0f-20e3","002a-20e3"],"fname":"002a-20e3","uc":"002a-20e3","isCanonical": true},":keycap_asterisk:":{"unicode":["002a-fe0f-20e3","002a-20e3"],"fname":"002a-20e3","uc":"002a-20e3","isCanonical": false},":handball_tone5:":{"unicode":["1f93e-1f3ff"],"fname":"1f93e-1f3ff","uc":"1f93e-1f3ff","isCanonical": true},":handball_tone4:":{"unicode":["1f93e-1f3fe"],"fname":"1f93e-1f3fe","uc":"1f93e-1f3fe","isCanonical": true},":handball_tone3:":{"unicode":["1f93e-1f3fd"],"fname":"1f93e-1f3fd","uc":"1f93e-1f3fd","isCanonical": true},":handball_tone2:":{"unicode":["1f93e-1f3fc"],"fname":"1f93e-1f3fc","uc":"1f93e-1f3fc","isCanonical": true},":handball_tone1:":{"unicode":["1f93e-1f3fb"],"fname":"1f93e-1f3fb","uc":"1f93e-1f3fb","isCanonical": true},":water_polo_tone5:":{"unicode":["1f93d-1f3ff"],"fname":"1f93d-1f3ff","uc":"1f93d-1f3ff","isCanonical": true},":water_polo_tone4:":{"unicode":["1f93d-1f3fe"],"fname":"1f93d-1f3fe","uc":"1f93d-1f3fe","isCanonical": true},":water_polo_tone3:":{"unicode":["1f93d-1f3fd"],"fname":"1f93d-1f3fd","uc":"1f93d-1f3fd","isCanonical": true},":water_polo_tone2:":{"unicode":["1f93d-1f3fc"],"fname":"1f93d-1f3fc","uc":"1f93d-1f3fc","isCanonical": true},":water_polo_tone1:":{"unicode":["1f93d-1f3fb"],"fname":"1f93d-1f3fb","uc":"1f93d-1f3fb","isCanonical": true},":wrestlers_tone5:":{"unicode":["1f93c-1f3ff"],"fname":"1f93c-1f3ff","uc":"1f93c-1f3ff","isCanonical": true},":wrestling_tone5:":{"unicode":["1f93c-1f3ff"],"fname":"1f93c-1f3ff","uc":"1f93c-1f3ff","isCanonical": false},":wrestlers_tone4:":{"unicode":["1f93c-1f3fe"],"fname":"1f93c-1f3fe","uc":"1f93c-1f3fe","isCanonical": true},":wrestling_tone4:":{"unicode":["1f93c-1f3fe"],"fname":"1f93c-1f3fe","uc":"1f93c-1f3fe","isCanonical": false},":wrestlers_tone3:":{"unicode":["1f93c-1f3fd"],"fname":"1f93c-1f3fd","uc":"1f93c-1f3fd","isCanonical": true},":wrestling_tone3:":{"unicode":["1f93c-1f3fd"],"fname":"1f93c-1f3fd","uc":"1f93c-1f3fd","isCanonical": false},":wrestlers_tone2:":{"unicode":["1f93c-1f3fc"],"fname":"1f93c-1f3fc","uc":"1f93c-1f3fc","isCanonical": true},":wrestling_tone2:":{"unicode":["1f93c-1f3fc"],"fname":"1f93c-1f3fc","uc":"1f93c-1f3fc","isCanonical": false},":wrestlers_tone1:":{"unicode":["1f93c-1f3fb"],"fname":"1f93c-1f3fb","uc":"1f93c-1f3fb","isCanonical": true},":wrestling_tone1:":{"unicode":["1f93c-1f3fb"],"fname":"1f93c-1f3fb","uc":"1f93c-1f3fb","isCanonical": false},":juggling_tone5:":{"unicode":["1f939-1f3ff"],"fname":"1f939-1f3ff","uc":"1f939-1f3ff","isCanonical": true},":juggler_tone5:":{"unicode":["1f939-1f3ff"],"fname":"1f939-1f3ff","uc":"1f939-1f3ff","isCanonical": false},":juggling_tone4:":{"unicode":["1f939-1f3fe"],"fname":"1f939-1f3fe","uc":"1f939-1f3fe","isCanonical": true},":juggler_tone4:":{"unicode":["1f939-1f3fe"],"fname":"1f939-1f3fe","uc":"1f939-1f3fe","isCanonical": false},":juggling_tone3:":{"unicode":["1f939-1f3fd"],"fname":"1f939-1f3fd","uc":"1f939-1f3fd","isCanonical": true},":juggler_tone3:":{"unicode":["1f939-1f3fd"],"fname":"1f939-1f3fd","uc":"1f939-1f3fd","isCanonical": false},":juggling_tone2:":{"unicode":["1f939-1f3fc"],"fname":"1f939-1f3fc","uc":"1f939-1f3fc","isCanonical": true},":juggler_tone2:":{"unicode":["1f939-1f3fc"],"fname":"1f939-1f3fc","uc":"1f939-1f3fc","isCanonical": false},":juggling_tone1:":{"unicode":["1f939-1f3fb"],"fname":"1f939-1f3fb","uc":"1f939-1f3fb","isCanonical": true},":juggler_tone1:":{"unicode":["1f939-1f3fb"],"fname":"1f939-1f3fb","uc":"1f939-1f3fb","isCanonical": false},":cartwheel_tone5:":{"unicode":["1f938-1f3ff"],"fname":"1f938-1f3ff","uc":"1f938-1f3ff","isCanonical": true},":person_doing_cartwheel_tone5:":{"unicode":["1f938-1f3ff"],"fname":"1f938-1f3ff","uc":"1f938-1f3ff","isCanonical": false},":cartwheel_tone4:":{"unicode":["1f938-1f3fe"],"fname":"1f938-1f3fe","uc":"1f938-1f3fe","isCanonical": true},":person_doing_cartwheel_tone4:":{"unicode":["1f938-1f3fe"],"fname":"1f938-1f3fe","uc":"1f938-1f3fe","isCanonical": false},":cartwheel_tone3:":{"unicode":["1f938-1f3fd"],"fname":"1f938-1f3fd","uc":"1f938-1f3fd","isCanonical": true},":person_doing_cartwheel_tone3:":{"unicode":["1f938-1f3fd"],"fname":"1f938-1f3fd","uc":"1f938-1f3fd","isCanonical": false},":cartwheel_tone2:":{"unicode":["1f938-1f3fc"],"fname":"1f938-1f3fc","uc":"1f938-1f3fc","isCanonical": true},":person_doing_cartwheel_tone2:":{"unicode":["1f938-1f3fc"],"fname":"1f938-1f3fc","uc":"1f938-1f3fc","isCanonical": false},":cartwheel_tone1:":{"unicode":["1f938-1f3fb"],"fname":"1f938-1f3fb","uc":"1f938-1f3fb","isCanonical": true},":person_doing_cartwheel_tone1:":{"unicode":["1f938-1f3fb"],"fname":"1f938-1f3fb","uc":"1f938-1f3fb","isCanonical": false},":shrug_tone5:":{"unicode":["1f937-1f3ff"],"fname":"1f937-1f3ff","uc":"1f937-1f3ff","isCanonical": true},":shrug_tone4:":{"unicode":["1f937-1f3fe"],"fname":"1f937-1f3fe","uc":"1f937-1f3fe","isCanonical": true},":shrug_tone3:":{"unicode":["1f937-1f3fd"],"fname":"1f937-1f3fd","uc":"1f937-1f3fd","isCanonical": true},":shrug_tone2:":{"unicode":["1f937-1f3fc"],"fname":"1f937-1f3fc","uc":"1f937-1f3fc","isCanonical": true},":shrug_tone1:":{"unicode":["1f937-1f3fb"],"fname":"1f937-1f3fb","uc":"1f937-1f3fb","isCanonical": true},":mrs_claus_tone5:":{"unicode":["1f936-1f3ff"],"fname":"1f936-1f3ff","uc":"1f936-1f3ff","isCanonical": true},":mother_christmas_tone5:":{"unicode":["1f936-1f3ff"],"fname":"1f936-1f3ff","uc":"1f936-1f3ff","isCanonical": false},":mrs_claus_tone4:":{"unicode":["1f936-1f3fe"],"fname":"1f936-1f3fe","uc":"1f936-1f3fe","isCanonical": true},":mother_christmas_tone4:":{"unicode":["1f936-1f3fe"],"fname":"1f936-1f3fe","uc":"1f936-1f3fe","isCanonical": false},":mrs_claus_tone3:":{"unicode":["1f936-1f3fd"],"fname":"1f936-1f3fd","uc":"1f936-1f3fd","isCanonical": true},":mother_christmas_tone3:":{"unicode":["1f936-1f3fd"],"fname":"1f936-1f3fd","uc":"1f936-1f3fd","isCanonical": false},":mrs_claus_tone2:":{"unicode":["1f936-1f3fc"],"fname":"1f936-1f3fc","uc":"1f936-1f3fc","isCanonical": true},":mother_christmas_tone2:":{"unicode":["1f936-1f3fc"],"fname":"1f936-1f3fc","uc":"1f936-1f3fc","isCanonical": false},":mrs_claus_tone1:":{"unicode":["1f936-1f3fb"],"fname":"1f936-1f3fb","uc":"1f936-1f3fb","isCanonical": true},":mother_christmas_tone1:":{"unicode":["1f936-1f3fb"],"fname":"1f936-1f3fb","uc":"1f936-1f3fb","isCanonical": false},":man_in_tuxedo_tone5:":{"unicode":["1f935-1f3ff"],"fname":"1f935-1f3ff","uc":"1f935-1f3ff","isCanonical": true},":tuxedo_tone5:":{"unicode":["1f935-1f3ff"],"fname":"1f935-1f3ff","uc":"1f935-1f3ff","isCanonical": false},":man_in_tuxedo_tone4:":{"unicode":["1f935-1f3fe"],"fname":"1f935-1f3fe","uc":"1f935-1f3fe","isCanonical": true},":tuxedo_tone4:":{"unicode":["1f935-1f3fe"],"fname":"1f935-1f3fe","uc":"1f935-1f3fe","isCanonical": false},":man_in_tuxedo_tone3:":{"unicode":["1f935-1f3fd"],"fname":"1f935-1f3fd","uc":"1f935-1f3fd","isCanonical": true},":tuxedo_tone3:":{"unicode":["1f935-1f3fd"],"fname":"1f935-1f3fd","uc":"1f935-1f3fd","isCanonical": false},":man_in_tuxedo_tone2:":{"unicode":["1f935-1f3fc"],"fname":"1f935-1f3fc","uc":"1f935-1f3fc","isCanonical": true},":tuxedo_tone2:":{"unicode":["1f935-1f3fc"],"fname":"1f935-1f3fc","uc":"1f935-1f3fc","isCanonical": false},":man_in_tuxedo_tone1:":{"unicode":["1f935-1f3fb"],"fname":"1f935-1f3fb","uc":"1f935-1f3fb","isCanonical": true},":tuxedo_tone1:":{"unicode":["1f935-1f3fb"],"fname":"1f935-1f3fb","uc":"1f935-1f3fb","isCanonical": false},":prince_tone5:":{"unicode":["1f934-1f3ff"],"fname":"1f934-1f3ff","uc":"1f934-1f3ff","isCanonical": true},":prince_tone4:":{"unicode":["1f934-1f3fe"],"fname":"1f934-1f3fe","uc":"1f934-1f3fe","isCanonical": true},":prince_tone3:":{"unicode":["1f934-1f3fd"],"fname":"1f934-1f3fd","uc":"1f934-1f3fd","isCanonical": true},":prince_tone2:":{"unicode":["1f934-1f3fc"],"fname":"1f934-1f3fc","uc":"1f934-1f3fc","isCanonical": true},":prince_tone1:":{"unicode":["1f934-1f3fb"],"fname":"1f934-1f3fb","uc":"1f934-1f3fb","isCanonical": true},":selfie_tone5:":{"unicode":["1f933-1f3ff"],"fname":"1f933-1f3ff","uc":"1f933-1f3ff","isCanonical": true},":selfie_tone4:":{"unicode":["1f933-1f3fe"],"fname":"1f933-1f3fe","uc":"1f933-1f3fe","isCanonical": true},":selfie_tone3:":{"unicode":["1f933-1f3fd"],"fname":"1f933-1f3fd","uc":"1f933-1f3fd","isCanonical": true},":selfie_tone2:":{"unicode":["1f933-1f3fc"],"fname":"1f933-1f3fc","uc":"1f933-1f3fc","isCanonical": true},":selfie_tone1:":{"unicode":["1f933-1f3fb"],"fname":"1f933-1f3fb","uc":"1f933-1f3fb","isCanonical": true},":pregnant_woman_tone5:":{"unicode":["1f930-1f3ff"],"fname":"1f930-1f3ff","uc":"1f930-1f3ff","isCanonical": true},":expecting_woman_tone5:":{"unicode":["1f930-1f3ff"],"fname":"1f930-1f3ff","uc":"1f930-1f3ff","isCanonical": false},":pregnant_woman_tone4:":{"unicode":["1f930-1f3fe"],"fname":"1f930-1f3fe","uc":"1f930-1f3fe","isCanonical": true},":expecting_woman_tone4:":{"unicode":["1f930-1f3fe"],"fname":"1f930-1f3fe","uc":"1f930-1f3fe","isCanonical": false},":pregnant_woman_tone3:":{"unicode":["1f930-1f3fd"],"fname":"1f930-1f3fd","uc":"1f930-1f3fd","isCanonical": true},":expecting_woman_tone3:":{"unicode":["1f930-1f3fd"],"fname":"1f930-1f3fd","uc":"1f930-1f3fd","isCanonical": false},":pregnant_woman_tone2:":{"unicode":["1f930-1f3fc"],"fname":"1f930-1f3fc","uc":"1f930-1f3fc","isCanonical": true},":expecting_woman_tone2:":{"unicode":["1f930-1f3fc"],"fname":"1f930-1f3fc","uc":"1f930-1f3fc","isCanonical": false},":pregnant_woman_tone1:":{"unicode":["1f930-1f3fb"],"fname":"1f930-1f3fb","uc":"1f930-1f3fb","isCanonical": true},":expecting_woman_tone1:":{"unicode":["1f930-1f3fb"],"fname":"1f930-1f3fb","uc":"1f930-1f3fb","isCanonical": false},":face_palm_tone5:":{"unicode":["1f926-1f3ff"],"fname":"1f926-1f3ff","uc":"1f926-1f3ff","isCanonical": true},":facepalm_tone5:":{"unicode":["1f926-1f3ff"],"fname":"1f926-1f3ff","uc":"1f926-1f3ff","isCanonical": false},":face_palm_tone4:":{"unicode":["1f926-1f3fe"],"fname":"1f926-1f3fe","uc":"1f926-1f3fe","isCanonical": true},":facepalm_tone4:":{"unicode":["1f926-1f3fe"],"fname":"1f926-1f3fe","uc":"1f926-1f3fe","isCanonical": false},":face_palm_tone3:":{"unicode":["1f926-1f3fd"],"fname":"1f926-1f3fd","uc":"1f926-1f3fd","isCanonical": true},":facepalm_tone3:":{"unicode":["1f926-1f3fd"],"fname":"1f926-1f3fd","uc":"1f926-1f3fd","isCanonical": false},":face_palm_tone2:":{"unicode":["1f926-1f3fc"],"fname":"1f926-1f3fc","uc":"1f926-1f3fc","isCanonical": true},":facepalm_tone2:":{"unicode":["1f926-1f3fc"],"fname":"1f926-1f3fc","uc":"1f926-1f3fc","isCanonical": false},":face_palm_tone1:":{"unicode":["1f926-1f3fb"],"fname":"1f926-1f3fb","uc":"1f926-1f3fb","isCanonical": true},":facepalm_tone1:":{"unicode":["1f926-1f3fb"],"fname":"1f926-1f3fb","uc":"1f926-1f3fb","isCanonical": false},":fingers_crossed_tone5:":{"unicode":["1f91e-1f3ff"],"fname":"1f91e-1f3ff","uc":"1f91e-1f3ff","isCanonical": true},":hand_with_index_and_middle_fingers_crossed_tone5:":{"unicode":["1f91e-1f3ff"],"fname":"1f91e-1f3ff","uc":"1f91e-1f3ff","isCanonical": false},":fingers_crossed_tone4:":{"unicode":["1f91e-1f3fe"],"fname":"1f91e-1f3fe","uc":"1f91e-1f3fe","isCanonical": true},":hand_with_index_and_middle_fingers_crossed_tone4:":{"unicode":["1f91e-1f3fe"],"fname":"1f91e-1f3fe","uc":"1f91e-1f3fe","isCanonical": false},":fingers_crossed_tone3:":{"unicode":["1f91e-1f3fd"],"fname":"1f91e-1f3fd","uc":"1f91e-1f3fd","isCanonical": true},":hand_with_index_and_middle_fingers_crossed_tone3:":{"unicode":["1f91e-1f3fd"],"fname":"1f91e-1f3fd","uc":"1f91e-1f3fd","isCanonical": false},":fingers_crossed_tone2:":{"unicode":["1f91e-1f3fc"],"fname":"1f91e-1f3fc","uc":"1f91e-1f3fc","isCanonical": true},":hand_with_index_and_middle_fingers_crossed_tone2:":{"unicode":["1f91e-1f3fc"],"fname":"1f91e-1f3fc","uc":"1f91e-1f3fc","isCanonical": false},":fingers_crossed_tone1:":{"unicode":["1f91e-1f3fb"],"fname":"1f91e-1f3fb","uc":"1f91e-1f3fb","isCanonical": true},":hand_with_index_and_middle_fingers_crossed_tone1:":{"unicode":["1f91e-1f3fb"],"fname":"1f91e-1f3fb","uc":"1f91e-1f3fb","isCanonical": false},":handshake_tone5:":{"unicode":["1f91d-1f3ff"],"fname":"1f91d-1f3ff","uc":"1f91d-1f3ff","isCanonical": true},":shaking_hands_tone5:":{"unicode":["1f91d-1f3ff"],"fname":"1f91d-1f3ff","uc":"1f91d-1f3ff","isCanonical": false},":handshake_tone4:":{"unicode":["1f91d-1f3fe"],"fname":"1f91d-1f3fe","uc":"1f91d-1f3fe","isCanonical": true},":shaking_hands_tone4:":{"unicode":["1f91d-1f3fe"],"fname":"1f91d-1f3fe","uc":"1f91d-1f3fe","isCanonical": false},":handshake_tone3:":{"unicode":["1f91d-1f3fd"],"fname":"1f91d-1f3fd","uc":"1f91d-1f3fd","isCanonical": true},":shaking_hands_tone3:":{"unicode":["1f91d-1f3fd"],"fname":"1f91d-1f3fd","uc":"1f91d-1f3fd","isCanonical": false},":handshake_tone2:":{"unicode":["1f91d-1f3fc"],"fname":"1f91d-1f3fc","uc":"1f91d-1f3fc","isCanonical": true},":shaking_hands_tone2:":{"unicode":["1f91d-1f3fc"],"fname":"1f91d-1f3fc","uc":"1f91d-1f3fc","isCanonical": false},":handshake_tone1:":{"unicode":["1f91d-1f3fb"],"fname":"1f91d-1f3fb","uc":"1f91d-1f3fb","isCanonical": true},":shaking_hands_tone1:":{"unicode":["1f91d-1f3fb"],"fname":"1f91d-1f3fb","uc":"1f91d-1f3fb","isCanonical": false},":right_facing_fist_tone5:":{"unicode":["1f91c-1f3ff"],"fname":"1f91c-1f3ff","uc":"1f91c-1f3ff","isCanonical": true},":right_fist_tone5:":{"unicode":["1f91c-1f3ff"],"fname":"1f91c-1f3ff","uc":"1f91c-1f3ff","isCanonical": false},":right_facing_fist_tone4:":{"unicode":["1f91c-1f3fe"],"fname":"1f91c-1f3fe","uc":"1f91c-1f3fe","isCanonical": true},":right_fist_tone4:":{"unicode":["1f91c-1f3fe"],"fname":"1f91c-1f3fe","uc":"1f91c-1f3fe","isCanonical": false},":right_facing_fist_tone3:":{"unicode":["1f91c-1f3fd"],"fname":"1f91c-1f3fd","uc":"1f91c-1f3fd","isCanonical": true},":right_fist_tone3:":{"unicode":["1f91c-1f3fd"],"fname":"1f91c-1f3fd","uc":"1f91c-1f3fd","isCanonical": false},":right_facing_fist_tone2:":{"unicode":["1f91c-1f3fc"],"fname":"1f91c-1f3fc","uc":"1f91c-1f3fc","isCanonical": true},":right_fist_tone2:":{"unicode":["1f91c-1f3fc"],"fname":"1f91c-1f3fc","uc":"1f91c-1f3fc","isCanonical": false},":right_facing_fist_tone1:":{"unicode":["1f91c-1f3fb"],"fname":"1f91c-1f3fb","uc":"1f91c-1f3fb","isCanonical": true},":right_fist_tone1:":{"unicode":["1f91c-1f3fb"],"fname":"1f91c-1f3fb","uc":"1f91c-1f3fb","isCanonical": false},":left_facing_fist_tone5:":{"unicode":["1f91b-1f3ff"],"fname":"1f91b-1f3ff","uc":"1f91b-1f3ff","isCanonical": true},":left_fist_tone5:":{"unicode":["1f91b-1f3ff"],"fname":"1f91b-1f3ff","uc":"1f91b-1f3ff","isCanonical": false},":left_facing_fist_tone4:":{"unicode":["1f91b-1f3fe"],"fname":"1f91b-1f3fe","uc":"1f91b-1f3fe","isCanonical": true},":left_fist_tone4:":{"unicode":["1f91b-1f3fe"],"fname":"1f91b-1f3fe","uc":"1f91b-1f3fe","isCanonical": false},":left_facing_fist_tone3:":{"unicode":["1f91b-1f3fd"],"fname":"1f91b-1f3fd","uc":"1f91b-1f3fd","isCanonical": true},":left_fist_tone3:":{"unicode":["1f91b-1f3fd"],"fname":"1f91b-1f3fd","uc":"1f91b-1f3fd","isCanonical": false},":left_facing_fist_tone2:":{"unicode":["1f91b-1f3fc"],"fname":"1f91b-1f3fc","uc":"1f91b-1f3fc","isCanonical": true},":left_fist_tone2:":{"unicode":["1f91b-1f3fc"],"fname":"1f91b-1f3fc","uc":"1f91b-1f3fc","isCanonical": false},":left_facing_fist_tone1:":{"unicode":["1f91b-1f3fb"],"fname":"1f91b-1f3fb","uc":"1f91b-1f3fb","isCanonical": true},":left_fist_tone1:":{"unicode":["1f91b-1f3fb"],"fname":"1f91b-1f3fb","uc":"1f91b-1f3fb","isCanonical": false},":raised_back_of_hand_tone5:":{"unicode":["1f91a-1f3ff"],"fname":"1f91a-1f3ff","uc":"1f91a-1f3ff","isCanonical": true},":back_of_hand_tone5:":{"unicode":["1f91a-1f3ff"],"fname":"1f91a-1f3ff","uc":"1f91a-1f3ff","isCanonical": false},":raised_back_of_hand_tone4:":{"unicode":["1f91a-1f3fe"],"fname":"1f91a-1f3fe","uc":"1f91a-1f3fe","isCanonical": true},":back_of_hand_tone4:":{"unicode":["1f91a-1f3fe"],"fname":"1f91a-1f3fe","uc":"1f91a-1f3fe","isCanonical": false},":raised_back_of_hand_tone3:":{"unicode":["1f91a-1f3fd"],"fname":"1f91a-1f3fd","uc":"1f91a-1f3fd","isCanonical": true},":back_of_hand_tone3:":{"unicode":["1f91a-1f3fd"],"fname":"1f91a-1f3fd","uc":"1f91a-1f3fd","isCanonical": false},":raised_back_of_hand_tone2:":{"unicode":["1f91a-1f3fc"],"fname":"1f91a-1f3fc","uc":"1f91a-1f3fc","isCanonical": true},":back_of_hand_tone2:":{"unicode":["1f91a-1f3fc"],"fname":"1f91a-1f3fc","uc":"1f91a-1f3fc","isCanonical": false},":raised_back_of_hand_tone1:":{"unicode":["1f91a-1f3fb"],"fname":"1f91a-1f3fb","uc":"1f91a-1f3fb","isCanonical": true},":back_of_hand_tone1:":{"unicode":["1f91a-1f3fb"],"fname":"1f91a-1f3fb","uc":"1f91a-1f3fb","isCanonical": false},":call_me_tone5:":{"unicode":["1f919-1f3ff"],"fname":"1f919-1f3ff","uc":"1f919-1f3ff","isCanonical": true},":call_me_hand_tone5:":{"unicode":["1f919-1f3ff"],"fname":"1f919-1f3ff","uc":"1f919-1f3ff","isCanonical": false},":call_me_tone4:":{"unicode":["1f919-1f3fe"],"fname":"1f919-1f3fe","uc":"1f919-1f3fe","isCanonical": true},":call_me_hand_tone4:":{"unicode":["1f919-1f3fe"],"fname":"1f919-1f3fe","uc":"1f919-1f3fe","isCanonical": false},":call_me_tone3:":{"unicode":["1f919-1f3fd"],"fname":"1f919-1f3fd","uc":"1f919-1f3fd","isCanonical": true},":call_me_hand_tone3:":{"unicode":["1f919-1f3fd"],"fname":"1f919-1f3fd","uc":"1f919-1f3fd","isCanonical": false},":call_me_tone2:":{"unicode":["1f919-1f3fc"],"fname":"1f919-1f3fc","uc":"1f919-1f3fc","isCanonical": true},":call_me_hand_tone2:":{"unicode":["1f919-1f3fc"],"fname":"1f919-1f3fc","uc":"1f919-1f3fc","isCanonical": false},":call_me_tone1:":{"unicode":["1f919-1f3fb"],"fname":"1f919-1f3fb","uc":"1f919-1f3fb","isCanonical": true},":call_me_hand_tone1:":{"unicode":["1f919-1f3fb"],"fname":"1f919-1f3fb","uc":"1f919-1f3fb","isCanonical": false},":metal_tone5:":{"unicode":["1f918-1f3ff"],"fname":"1f918-1f3ff","uc":"1f918-1f3ff","isCanonical": true},":sign_of_the_horns_tone5:":{"unicode":["1f918-1f3ff"],"fname":"1f918-1f3ff","uc":"1f918-1f3ff","isCanonical": false},":metal_tone4:":{"unicode":["1f918-1f3fe"],"fname":"1f918-1f3fe","uc":"1f918-1f3fe","isCanonical": true},":sign_of_the_horns_tone4:":{"unicode":["1f918-1f3fe"],"fname":"1f918-1f3fe","uc":"1f918-1f3fe","isCanonical": false},":metal_tone3:":{"unicode":["1f918-1f3fd"],"fname":"1f918-1f3fd","uc":"1f918-1f3fd","isCanonical": true},":sign_of_the_horns_tone3:":{"unicode":["1f918-1f3fd"],"fname":"1f918-1f3fd","uc":"1f918-1f3fd","isCanonical": false},":metal_tone2:":{"unicode":["1f918-1f3fc"],"fname":"1f918-1f3fc","uc":"1f918-1f3fc","isCanonical": true},":sign_of_the_horns_tone2:":{"unicode":["1f918-1f3fc"],"fname":"1f918-1f3fc","uc":"1f918-1f3fc","isCanonical": false},":metal_tone1:":{"unicode":["1f918-1f3fb"],"fname":"1f918-1f3fb","uc":"1f918-1f3fb","isCanonical": true},":sign_of_the_horns_tone1:":{"unicode":["1f918-1f3fb"],"fname":"1f918-1f3fb","uc":"1f918-1f3fb","isCanonical": false},":bath_tone5:":{"unicode":["1f6c0-1f3ff"],"fname":"1f6c0-1f3ff","uc":"1f6c0-1f3ff","isCanonical": true},":bath_tone4:":{"unicode":["1f6c0-1f3fe"],"fname":"1f6c0-1f3fe","uc":"1f6c0-1f3fe","isCanonical": true},":bath_tone3:":{"unicode":["1f6c0-1f3fd"],"fname":"1f6c0-1f3fd","uc":"1f6c0-1f3fd","isCanonical": true},":bath_tone2:":{"unicode":["1f6c0-1f3fc"],"fname":"1f6c0-1f3fc","uc":"1f6c0-1f3fc","isCanonical": true},":bath_tone1:":{"unicode":["1f6c0-1f3fb"],"fname":"1f6c0-1f3fb","uc":"1f6c0-1f3fb","isCanonical": true},":walking_tone5:":{"unicode":["1f6b6-1f3ff"],"fname":"1f6b6-1f3ff","uc":"1f6b6-1f3ff","isCanonical": true},":walking_tone4:":{"unicode":["1f6b6-1f3fe"],"fname":"1f6b6-1f3fe","uc":"1f6b6-1f3fe","isCanonical": true},":walking_tone3:":{"unicode":["1f6b6-1f3fd"],"fname":"1f6b6-1f3fd","uc":"1f6b6-1f3fd","isCanonical": true},":walking_tone2:":{"unicode":["1f6b6-1f3fc"],"fname":"1f6b6-1f3fc","uc":"1f6b6-1f3fc","isCanonical": true},":walking_tone1:":{"unicode":["1f6b6-1f3fb"],"fname":"1f6b6-1f3fb","uc":"1f6b6-1f3fb","isCanonical": true},":mountain_bicyclist_tone5:":{"unicode":["1f6b5-1f3ff"],"fname":"1f6b5-1f3ff","uc":"1f6b5-1f3ff","isCanonical": true},":mountain_bicyclist_tone4:":{"unicode":["1f6b5-1f3fe"],"fname":"1f6b5-1f3fe","uc":"1f6b5-1f3fe","isCanonical": true},":mountain_bicyclist_tone3:":{"unicode":["1f6b5-1f3fd"],"fname":"1f6b5-1f3fd","uc":"1f6b5-1f3fd","isCanonical": true},":mountain_bicyclist_tone2:":{"unicode":["1f6b5-1f3fc"],"fname":"1f6b5-1f3fc","uc":"1f6b5-1f3fc","isCanonical": true},":mountain_bicyclist_tone1:":{"unicode":["1f6b5-1f3fb"],"fname":"1f6b5-1f3fb","uc":"1f6b5-1f3fb","isCanonical": true},":bicyclist_tone5:":{"unicode":["1f6b4-1f3ff"],"fname":"1f6b4-1f3ff","uc":"1f6b4-1f3ff","isCanonical": true},":bicyclist_tone4:":{"unicode":["1f6b4-1f3fe"],"fname":"1f6b4-1f3fe","uc":"1f6b4-1f3fe","isCanonical": true},":bicyclist_tone3:":{"unicode":["1f6b4-1f3fd"],"fname":"1f6b4-1f3fd","uc":"1f6b4-1f3fd","isCanonical": true},":bicyclist_tone2:":{"unicode":["1f6b4-1f3fc"],"fname":"1f6b4-1f3fc","uc":"1f6b4-1f3fc","isCanonical": true},":bicyclist_tone1:":{"unicode":["1f6b4-1f3fb"],"fname":"1f6b4-1f3fb","uc":"1f6b4-1f3fb","isCanonical": true},":rowboat_tone5:":{"unicode":["1f6a3-1f3ff"],"fname":"1f6a3-1f3ff","uc":"1f6a3-1f3ff","isCanonical": true},":rowboat_tone4:":{"unicode":["1f6a3-1f3fe"],"fname":"1f6a3-1f3fe","uc":"1f6a3-1f3fe","isCanonical": true},":rowboat_tone3:":{"unicode":["1f6a3-1f3fd"],"fname":"1f6a3-1f3fd","uc":"1f6a3-1f3fd","isCanonical": true},":rowboat_tone2:":{"unicode":["1f6a3-1f3fc"],"fname":"1f6a3-1f3fc","uc":"1f6a3-1f3fc","isCanonical": true},":rowboat_tone1:":{"unicode":["1f6a3-1f3fb"],"fname":"1f6a3-1f3fb","uc":"1f6a3-1f3fb","isCanonical": true},":pray_tone5:":{"unicode":["1f64f-1f3ff"],"fname":"1f64f-1f3ff","uc":"1f64f-1f3ff","isCanonical": true},":pray_tone4:":{"unicode":["1f64f-1f3fe"],"fname":"1f64f-1f3fe","uc":"1f64f-1f3fe","isCanonical": true},":pray_tone3:":{"unicode":["1f64f-1f3fd"],"fname":"1f64f-1f3fd","uc":"1f64f-1f3fd","isCanonical": true},":pray_tone2:":{"unicode":["1f64f-1f3fc"],"fname":"1f64f-1f3fc","uc":"1f64f-1f3fc","isCanonical": true},":pray_tone1:":{"unicode":["1f64f-1f3fb"],"fname":"1f64f-1f3fb","uc":"1f64f-1f3fb","isCanonical": true},":person_with_pouting_face_tone5:":{"unicode":["1f64e-1f3ff"],"fname":"1f64e-1f3ff","uc":"1f64e-1f3ff","isCanonical": true},":person_with_pouting_face_tone4:":{"unicode":["1f64e-1f3fe"],"fname":"1f64e-1f3fe","uc":"1f64e-1f3fe","isCanonical": true},":person_with_pouting_face_tone3:":{"unicode":["1f64e-1f3fd"],"fname":"1f64e-1f3fd","uc":"1f64e-1f3fd","isCanonical": true},":person_with_pouting_face_tone2:":{"unicode":["1f64e-1f3fc"],"fname":"1f64e-1f3fc","uc":"1f64e-1f3fc","isCanonical": true},":person_with_pouting_face_tone1:":{"unicode":["1f64e-1f3fb"],"fname":"1f64e-1f3fb","uc":"1f64e-1f3fb","isCanonical": true},":person_frowning_tone5:":{"unicode":["1f64d-1f3ff"],"fname":"1f64d-1f3ff","uc":"1f64d-1f3ff","isCanonical": true},":person_frowning_tone4:":{"unicode":["1f64d-1f3fe"],"fname":"1f64d-1f3fe","uc":"1f64d-1f3fe","isCanonical": true},":person_frowning_tone3:":{"unicode":["1f64d-1f3fd"],"fname":"1f64d-1f3fd","uc":"1f64d-1f3fd","isCanonical": true},":person_frowning_tone2:":{"unicode":["1f64d-1f3fc"],"fname":"1f64d-1f3fc","uc":"1f64d-1f3fc","isCanonical": true},":person_frowning_tone1:":{"unicode":["1f64d-1f3fb"],"fname":"1f64d-1f3fb","uc":"1f64d-1f3fb","isCanonical": true},":raised_hands_tone5:":{"unicode":["1f64c-1f3ff"],"fname":"1f64c-1f3ff","uc":"1f64c-1f3ff","isCanonical": true},":raised_hands_tone4:":{"unicode":["1f64c-1f3fe"],"fname":"1f64c-1f3fe","uc":"1f64c-1f3fe","isCanonical": true},":raised_hands_tone3:":{"unicode":["1f64c-1f3fd"],"fname":"1f64c-1f3fd","uc":"1f64c-1f3fd","isCanonical": true},":raised_hands_tone2:":{"unicode":["1f64c-1f3fc"],"fname":"1f64c-1f3fc","uc":"1f64c-1f3fc","isCanonical": true},":raised_hands_tone1:":{"unicode":["1f64c-1f3fb"],"fname":"1f64c-1f3fb","uc":"1f64c-1f3fb","isCanonical": true},":raising_hand_tone5:":{"unicode":["1f64b-1f3ff"],"fname":"1f64b-1f3ff","uc":"1f64b-1f3ff","isCanonical": true},":raising_hand_tone4:":{"unicode":["1f64b-1f3fe"],"fname":"1f64b-1f3fe","uc":"1f64b-1f3fe","isCanonical": true},":raising_hand_tone3:":{"unicode":["1f64b-1f3fd"],"fname":"1f64b-1f3fd","uc":"1f64b-1f3fd","isCanonical": true},":raising_hand_tone2:":{"unicode":["1f64b-1f3fc"],"fname":"1f64b-1f3fc","uc":"1f64b-1f3fc","isCanonical": true},":raising_hand_tone1:":{"unicode":["1f64b-1f3fb"],"fname":"1f64b-1f3fb","uc":"1f64b-1f3fb","isCanonical": true},":bow_tone5:":{"unicode":["1f647-1f3ff"],"fname":"1f647-1f3ff","uc":"1f647-1f3ff","isCanonical": true},":bow_tone4:":{"unicode":["1f647-1f3fe"],"fname":"1f647-1f3fe","uc":"1f647-1f3fe","isCanonical": true},":bow_tone3:":{"unicode":["1f647-1f3fd"],"fname":"1f647-1f3fd","uc":"1f647-1f3fd","isCanonical": true},":bow_tone2:":{"unicode":["1f647-1f3fc"],"fname":"1f647-1f3fc","uc":"1f647-1f3fc","isCanonical": true},":bow_tone1:":{"unicode":["1f647-1f3fb"],"fname":"1f647-1f3fb","uc":"1f647-1f3fb","isCanonical": true},":ok_woman_tone5:":{"unicode":["1f646-1f3ff"],"fname":"1f646-1f3ff","uc":"1f646-1f3ff","isCanonical": true},":ok_woman_tone4:":{"unicode":["1f646-1f3fe"],"fname":"1f646-1f3fe","uc":"1f646-1f3fe","isCanonical": true},":ok_woman_tone3:":{"unicode":["1f646-1f3fd"],"fname":"1f646-1f3fd","uc":"1f646-1f3fd","isCanonical": true},":ok_woman_tone2:":{"unicode":["1f646-1f3fc"],"fname":"1f646-1f3fc","uc":"1f646-1f3fc","isCanonical": true},":ok_woman_tone1:":{"unicode":["1f646-1f3fb"],"fname":"1f646-1f3fb","uc":"1f646-1f3fb","isCanonical": true},":no_good_tone5:":{"unicode":["1f645-1f3ff"],"fname":"1f645-1f3ff","uc":"1f645-1f3ff","isCanonical": true},":no_good_tone4:":{"unicode":["1f645-1f3fe"],"fname":"1f645-1f3fe","uc":"1f645-1f3fe","isCanonical": true},":no_good_tone3:":{"unicode":["1f645-1f3fd"],"fname":"1f645-1f3fd","uc":"1f645-1f3fd","isCanonical": true},":no_good_tone2:":{"unicode":["1f645-1f3fc"],"fname":"1f645-1f3fc","uc":"1f645-1f3fc","isCanonical": true},":no_good_tone1:":{"unicode":["1f645-1f3fb"],"fname":"1f645-1f3fb","uc":"1f645-1f3fb","isCanonical": true},":vulcan_tone5:":{"unicode":["1f596-1f3ff"],"fname":"1f596-1f3ff","uc":"1f596-1f3ff","isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone5:":{"unicode":["1f596-1f3ff"],"fname":"1f596-1f3ff","uc":"1f596-1f3ff","isCanonical": false},":vulcan_tone4:":{"unicode":["1f596-1f3fe"],"fname":"1f596-1f3fe","uc":"1f596-1f3fe","isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone4:":{"unicode":["1f596-1f3fe"],"fname":"1f596-1f3fe","uc":"1f596-1f3fe","isCanonical": false},":vulcan_tone3:":{"unicode":["1f596-1f3fd"],"fname":"1f596-1f3fd","uc":"1f596-1f3fd","isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone3:":{"unicode":["1f596-1f3fd"],"fname":"1f596-1f3fd","uc":"1f596-1f3fd","isCanonical": false},":vulcan_tone2:":{"unicode":["1f596-1f3fc"],"fname":"1f596-1f3fc","uc":"1f596-1f3fc","isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone2:":{"unicode":["1f596-1f3fc"],"fname":"1f596-1f3fc","uc":"1f596-1f3fc","isCanonical": false},":vulcan_tone1:":{"unicode":["1f596-1f3fb"],"fname":"1f596-1f3fb","uc":"1f596-1f3fb","isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers_tone1:":{"unicode":["1f596-1f3fb"],"fname":"1f596-1f3fb","uc":"1f596-1f3fb","isCanonical": false},":middle_finger_tone5:":{"unicode":["1f595-1f3ff"],"fname":"1f595-1f3ff","uc":"1f595-1f3ff","isCanonical": true},":reversed_hand_with_middle_finger_extended_tone5:":{"unicode":["1f595-1f3ff"],"fname":"1f595-1f3ff","uc":"1f595-1f3ff","isCanonical": false},":middle_finger_tone4:":{"unicode":["1f595-1f3fe"],"fname":"1f595-1f3fe","uc":"1f595-1f3fe","isCanonical": true},":reversed_hand_with_middle_finger_extended_tone4:":{"unicode":["1f595-1f3fe"],"fname":"1f595-1f3fe","uc":"1f595-1f3fe","isCanonical": false},":middle_finger_tone3:":{"unicode":["1f595-1f3fd"],"fname":"1f595-1f3fd","uc":"1f595-1f3fd","isCanonical": true},":reversed_hand_with_middle_finger_extended_tone3:":{"unicode":["1f595-1f3fd"],"fname":"1f595-1f3fd","uc":"1f595-1f3fd","isCanonical": false},":middle_finger_tone2:":{"unicode":["1f595-1f3fc"],"fname":"1f595-1f3fc","uc":"1f595-1f3fc","isCanonical": true},":reversed_hand_with_middle_finger_extended_tone2:":{"unicode":["1f595-1f3fc"],"fname":"1f595-1f3fc","uc":"1f595-1f3fc","isCanonical": false},":middle_finger_tone1:":{"unicode":["1f595-1f3fb"],"fname":"1f595-1f3fb","uc":"1f595-1f3fb","isCanonical": true},":reversed_hand_with_middle_finger_extended_tone1:":{"unicode":["1f595-1f3fb"],"fname":"1f595-1f3fb","uc":"1f595-1f3fb","isCanonical": false},":hand_splayed_tone5:":{"unicode":["1f590-1f3ff"],"fname":"1f590-1f3ff","uc":"1f590-1f3ff","isCanonical": true},":raised_hand_with_fingers_splayed_tone5:":{"unicode":["1f590-1f3ff"],"fname":"1f590-1f3ff","uc":"1f590-1f3ff","isCanonical": false},":hand_splayed_tone4:":{"unicode":["1f590-1f3fe"],"fname":"1f590-1f3fe","uc":"1f590-1f3fe","isCanonical": true},":raised_hand_with_fingers_splayed_tone4:":{"unicode":["1f590-1f3fe"],"fname":"1f590-1f3fe","uc":"1f590-1f3fe","isCanonical": false},":hand_splayed_tone3:":{"unicode":["1f590-1f3fd"],"fname":"1f590-1f3fd","uc":"1f590-1f3fd","isCanonical": true},":raised_hand_with_fingers_splayed_tone3:":{"unicode":["1f590-1f3fd"],"fname":"1f590-1f3fd","uc":"1f590-1f3fd","isCanonical": false},":hand_splayed_tone2:":{"unicode":["1f590-1f3fc"],"fname":"1f590-1f3fc","uc":"1f590-1f3fc","isCanonical": true},":raised_hand_with_fingers_splayed_tone2:":{"unicode":["1f590-1f3fc"],"fname":"1f590-1f3fc","uc":"1f590-1f3fc","isCanonical": false},":hand_splayed_tone1:":{"unicode":["1f590-1f3fb"],"fname":"1f590-1f3fb","uc":"1f590-1f3fb","isCanonical": true},":raised_hand_with_fingers_splayed_tone1:":{"unicode":["1f590-1f3fb"],"fname":"1f590-1f3fb","uc":"1f590-1f3fb","isCanonical": false},":man_dancing_tone5:":{"unicode":["1f57a-1f3ff"],"fname":"1f57a-1f3ff","uc":"1f57a-1f3ff","isCanonical": true},":male_dancer_tone5:":{"unicode":["1f57a-1f3ff"],"fname":"1f57a-1f3ff","uc":"1f57a-1f3ff","isCanonical": false},":man_dancing_tone4:":{"unicode":["1f57a-1f3fe"],"fname":"1f57a-1f3fe","uc":"1f57a-1f3fe","isCanonical": true},":male_dancer_tone4:":{"unicode":["1f57a-1f3fe"],"fname":"1f57a-1f3fe","uc":"1f57a-1f3fe","isCanonical": false},":man_dancing_tone3:":{"unicode":["1f57a-1f3fd"],"fname":"1f57a-1f3fd","uc":"1f57a-1f3fd","isCanonical": true},":male_dancer_tone3:":{"unicode":["1f57a-1f3fd"],"fname":"1f57a-1f3fd","uc":"1f57a-1f3fd","isCanonical": false},":man_dancing_tone2:":{"unicode":["1f57a-1f3fc"],"fname":"1f57a-1f3fc","uc":"1f57a-1f3fc","isCanonical": true},":male_dancer_tone2:":{"unicode":["1f57a-1f3fc"],"fname":"1f57a-1f3fc","uc":"1f57a-1f3fc","isCanonical": false},":man_dancing_tone1:":{"unicode":["1f57a-1f3fb"],"fname":"1f57a-1f3fb","uc":"1f57a-1f3fb","isCanonical": true},":male_dancer_tone1:":{"unicode":["1f57a-1f3fb"],"fname":"1f57a-1f3fb","uc":"1f57a-1f3fb","isCanonical": false},":spy_tone5:":{"unicode":["1f575-1f3ff"],"fname":"1f575-1f3ff","uc":"1f575-1f3ff","isCanonical": true},":sleuth_or_spy_tone5:":{"unicode":["1f575-1f3ff"],"fname":"1f575-1f3ff","uc":"1f575-1f3ff","isCanonical": false},":spy_tone4:":{"unicode":["1f575-1f3fe"],"fname":"1f575-1f3fe","uc":"1f575-1f3fe","isCanonical": true},":sleuth_or_spy_tone4:":{"unicode":["1f575-1f3fe"],"fname":"1f575-1f3fe","uc":"1f575-1f3fe","isCanonical": false},":spy_tone3:":{"unicode":["1f575-1f3fd"],"fname":"1f575-1f3fd","uc":"1f575-1f3fd","isCanonical": true},":sleuth_or_spy_tone3:":{"unicode":["1f575-1f3fd"],"fname":"1f575-1f3fd","uc":"1f575-1f3fd","isCanonical": false},":spy_tone2:":{"unicode":["1f575-1f3fc"],"fname":"1f575-1f3fc","uc":"1f575-1f3fc","isCanonical": true},":sleuth_or_spy_tone2:":{"unicode":["1f575-1f3fc"],"fname":"1f575-1f3fc","uc":"1f575-1f3fc","isCanonical": false},":spy_tone1:":{"unicode":["1f575-1f3fb"],"fname":"1f575-1f3fb","uc":"1f575-1f3fb","isCanonical": true},":sleuth_or_spy_tone1:":{"unicode":["1f575-1f3fb"],"fname":"1f575-1f3fb","uc":"1f575-1f3fb","isCanonical": false},":muscle_tone5:":{"unicode":["1f4aa-1f3ff"],"fname":"1f4aa-1f3ff","uc":"1f4aa-1f3ff","isCanonical": true},":muscle_tone4:":{"unicode":["1f4aa-1f3fe"],"fname":"1f4aa-1f3fe","uc":"1f4aa-1f3fe","isCanonical": true},":muscle_tone3:":{"unicode":["1f4aa-1f3fd"],"fname":"1f4aa-1f3fd","uc":"1f4aa-1f3fd","isCanonical": true},":muscle_tone2:":{"unicode":["1f4aa-1f3fc"],"fname":"1f4aa-1f3fc","uc":"1f4aa-1f3fc","isCanonical": true},":muscle_tone1:":{"unicode":["1f4aa-1f3fb"],"fname":"1f4aa-1f3fb","uc":"1f4aa-1f3fb","isCanonical": true},":haircut_tone5:":{"unicode":["1f487-1f3ff"],"fname":"1f487-1f3ff","uc":"1f487-1f3ff","isCanonical": true},":haircut_tone4:":{"unicode":["1f487-1f3fe"],"fname":"1f487-1f3fe","uc":"1f487-1f3fe","isCanonical": true},":haircut_tone3:":{"unicode":["1f487-1f3fd"],"fname":"1f487-1f3fd","uc":"1f487-1f3fd","isCanonical": true},":haircut_tone2:":{"unicode":["1f487-1f3fc"],"fname":"1f487-1f3fc","uc":"1f487-1f3fc","isCanonical": true},":haircut_tone1:":{"unicode":["1f487-1f3fb"],"fname":"1f487-1f3fb","uc":"1f487-1f3fb","isCanonical": true},":massage_tone5:":{"unicode":["1f486-1f3ff"],"fname":"1f486-1f3ff","uc":"1f486-1f3ff","isCanonical": true},":massage_tone4:":{"unicode":["1f486-1f3fe"],"fname":"1f486-1f3fe","uc":"1f486-1f3fe","isCanonical": true},":massage_tone3:":{"unicode":["1f486-1f3fd"],"fname":"1f486-1f3fd","uc":"1f486-1f3fd","isCanonical": true},":massage_tone2:":{"unicode":["1f486-1f3fc"],"fname":"1f486-1f3fc","uc":"1f486-1f3fc","isCanonical": true},":massage_tone1:":{"unicode":["1f486-1f3fb"],"fname":"1f486-1f3fb","uc":"1f486-1f3fb","isCanonical": true},":nail_care_tone5:":{"unicode":["1f485-1f3ff"],"fname":"1f485-1f3ff","uc":"1f485-1f3ff","isCanonical": true},":nail_care_tone4:":{"unicode":["1f485-1f3fe"],"fname":"1f485-1f3fe","uc":"1f485-1f3fe","isCanonical": true},":nail_care_tone3:":{"unicode":["1f485-1f3fd"],"fname":"1f485-1f3fd","uc":"1f485-1f3fd","isCanonical": true},":nail_care_tone2:":{"unicode":["1f485-1f3fc"],"fname":"1f485-1f3fc","uc":"1f485-1f3fc","isCanonical": true},":nail_care_tone1:":{"unicode":["1f485-1f3fb"],"fname":"1f485-1f3fb","uc":"1f485-1f3fb","isCanonical": true},":dancer_tone5:":{"unicode":["1f483-1f3ff"],"fname":"1f483-1f3ff","uc":"1f483-1f3ff","isCanonical": true},":dancer_tone4:":{"unicode":["1f483-1f3fe"],"fname":"1f483-1f3fe","uc":"1f483-1f3fe","isCanonical": true},":dancer_tone3:":{"unicode":["1f483-1f3fd"],"fname":"1f483-1f3fd","uc":"1f483-1f3fd","isCanonical": true},":dancer_tone2:":{"unicode":["1f483-1f3fc"],"fname":"1f483-1f3fc","uc":"1f483-1f3fc","isCanonical": true},":dancer_tone1:":{"unicode":["1f483-1f3fb"],"fname":"1f483-1f3fb","uc":"1f483-1f3fb","isCanonical": true},":guardsman_tone5:":{"unicode":["1f482-1f3ff"],"fname":"1f482-1f3ff","uc":"1f482-1f3ff","isCanonical": true},":guardsman_tone4:":{"unicode":["1f482-1f3fe"],"fname":"1f482-1f3fe","uc":"1f482-1f3fe","isCanonical": true},":guardsman_tone3:":{"unicode":["1f482-1f3fd"],"fname":"1f482-1f3fd","uc":"1f482-1f3fd","isCanonical": true},":guardsman_tone2:":{"unicode":["1f482-1f3fc"],"fname":"1f482-1f3fc","uc":"1f482-1f3fc","isCanonical": true},":guardsman_tone1:":{"unicode":["1f482-1f3fb"],"fname":"1f482-1f3fb","uc":"1f482-1f3fb","isCanonical": true},":information_desk_person_tone5:":{"unicode":["1f481-1f3ff"],"fname":"1f481-1f3ff","uc":"1f481-1f3ff","isCanonical": true},":information_desk_person_tone4:":{"unicode":["1f481-1f3fe"],"fname":"1f481-1f3fe","uc":"1f481-1f3fe","isCanonical": true},":information_desk_person_tone3:":{"unicode":["1f481-1f3fd"],"fname":"1f481-1f3fd","uc":"1f481-1f3fd","isCanonical": true},":information_desk_person_tone2:":{"unicode":["1f481-1f3fc"],"fname":"1f481-1f3fc","uc":"1f481-1f3fc","isCanonical": true},":information_desk_person_tone1:":{"unicode":["1f481-1f3fb"],"fname":"1f481-1f3fb","uc":"1f481-1f3fb","isCanonical": true},":angel_tone5:":{"unicode":["1f47c-1f3ff"],"fname":"1f47c-1f3ff","uc":"1f47c-1f3ff","isCanonical": true},":angel_tone4:":{"unicode":["1f47c-1f3fe"],"fname":"1f47c-1f3fe","uc":"1f47c-1f3fe","isCanonical": true},":angel_tone3:":{"unicode":["1f47c-1f3fd"],"fname":"1f47c-1f3fd","uc":"1f47c-1f3fd","isCanonical": true},":angel_tone2:":{"unicode":["1f47c-1f3fc"],"fname":"1f47c-1f3fc","uc":"1f47c-1f3fc","isCanonical": true},":angel_tone1:":{"unicode":["1f47c-1f3fb"],"fname":"1f47c-1f3fb","uc":"1f47c-1f3fb","isCanonical": true},":princess_tone5:":{"unicode":["1f478-1f3ff"],"fname":"1f478-1f3ff","uc":"1f478-1f3ff","isCanonical": true},":princess_tone4:":{"unicode":["1f478-1f3fe"],"fname":"1f478-1f3fe","uc":"1f478-1f3fe","isCanonical": true},":princess_tone3:":{"unicode":["1f478-1f3fd"],"fname":"1f478-1f3fd","uc":"1f478-1f3fd","isCanonical": true},":princess_tone2:":{"unicode":["1f478-1f3fc"],"fname":"1f478-1f3fc","uc":"1f478-1f3fc","isCanonical": true},":princess_tone1:":{"unicode":["1f478-1f3fb"],"fname":"1f478-1f3fb","uc":"1f478-1f3fb","isCanonical": true},":construction_worker_tone5:":{"unicode":["1f477-1f3ff"],"fname":"1f477-1f3ff","uc":"1f477-1f3ff","isCanonical": true},":construction_worker_tone4:":{"unicode":["1f477-1f3fe"],"fname":"1f477-1f3fe","uc":"1f477-1f3fe","isCanonical": true},":construction_worker_tone3:":{"unicode":["1f477-1f3fd"],"fname":"1f477-1f3fd","uc":"1f477-1f3fd","isCanonical": true},":construction_worker_tone2:":{"unicode":["1f477-1f3fc"],"fname":"1f477-1f3fc","uc":"1f477-1f3fc","isCanonical": true},":construction_worker_tone1:":{"unicode":["1f477-1f3fb"],"fname":"1f477-1f3fb","uc":"1f477-1f3fb","isCanonical": true},":baby_tone5:":{"unicode":["1f476-1f3ff"],"fname":"1f476-1f3ff","uc":"1f476-1f3ff","isCanonical": true},":baby_tone4:":{"unicode":["1f476-1f3fe"],"fname":"1f476-1f3fe","uc":"1f476-1f3fe","isCanonical": true},":baby_tone3:":{"unicode":["1f476-1f3fd"],"fname":"1f476-1f3fd","uc":"1f476-1f3fd","isCanonical": true},":baby_tone2:":{"unicode":["1f476-1f3fc"],"fname":"1f476-1f3fc","uc":"1f476-1f3fc","isCanonical": true},":baby_tone1:":{"unicode":["1f476-1f3fb"],"fname":"1f476-1f3fb","uc":"1f476-1f3fb","isCanonical": true},":older_woman_tone5:":{"unicode":["1f475-1f3ff"],"fname":"1f475-1f3ff","uc":"1f475-1f3ff","isCanonical": true},":grandma_tone5:":{"unicode":["1f475-1f3ff"],"fname":"1f475-1f3ff","uc":"1f475-1f3ff","isCanonical": false},":older_woman_tone4:":{"unicode":["1f475-1f3fe"],"fname":"1f475-1f3fe","uc":"1f475-1f3fe","isCanonical": true},":grandma_tone4:":{"unicode":["1f475-1f3fe"],"fname":"1f475-1f3fe","uc":"1f475-1f3fe","isCanonical": false},":older_woman_tone3:":{"unicode":["1f475-1f3fd"],"fname":"1f475-1f3fd","uc":"1f475-1f3fd","isCanonical": true},":grandma_tone3:":{"unicode":["1f475-1f3fd"],"fname":"1f475-1f3fd","uc":"1f475-1f3fd","isCanonical": false},":older_woman_tone2:":{"unicode":["1f475-1f3fc"],"fname":"1f475-1f3fc","uc":"1f475-1f3fc","isCanonical": true},":grandma_tone2:":{"unicode":["1f475-1f3fc"],"fname":"1f475-1f3fc","uc":"1f475-1f3fc","isCanonical": false},":older_woman_tone1:":{"unicode":["1f475-1f3fb"],"fname":"1f475-1f3fb","uc":"1f475-1f3fb","isCanonical": true},":grandma_tone1:":{"unicode":["1f475-1f3fb"],"fname":"1f475-1f3fb","uc":"1f475-1f3fb","isCanonical": false},":older_man_tone5:":{"unicode":["1f474-1f3ff"],"fname":"1f474-1f3ff","uc":"1f474-1f3ff","isCanonical": true},":older_man_tone4:":{"unicode":["1f474-1f3fe"],"fname":"1f474-1f3fe","uc":"1f474-1f3fe","isCanonical": true},":older_man_tone3:":{"unicode":["1f474-1f3fd"],"fname":"1f474-1f3fd","uc":"1f474-1f3fd","isCanonical": true},":older_man_tone2:":{"unicode":["1f474-1f3fc"],"fname":"1f474-1f3fc","uc":"1f474-1f3fc","isCanonical": true},":older_man_tone1:":{"unicode":["1f474-1f3fb"],"fname":"1f474-1f3fb","uc":"1f474-1f3fb","isCanonical": true},":man_with_turban_tone5:":{"unicode":["1f473-1f3ff"],"fname":"1f473-1f3ff","uc":"1f473-1f3ff","isCanonical": true},":man_with_turban_tone4:":{"unicode":["1f473-1f3fe"],"fname":"1f473-1f3fe","uc":"1f473-1f3fe","isCanonical": true},":man_with_turban_tone3:":{"unicode":["1f473-1f3fd"],"fname":"1f473-1f3fd","uc":"1f473-1f3fd","isCanonical": true},":man_with_turban_tone2:":{"unicode":["1f473-1f3fc"],"fname":"1f473-1f3fc","uc":"1f473-1f3fc","isCanonical": true},":man_with_turban_tone1:":{"unicode":["1f473-1f3fb"],"fname":"1f473-1f3fb","uc":"1f473-1f3fb","isCanonical": true},":man_with_gua_pi_mao_tone5:":{"unicode":["1f472-1f3ff"],"fname":"1f472-1f3ff","uc":"1f472-1f3ff","isCanonical": true},":man_with_gua_pi_mao_tone4:":{"unicode":["1f472-1f3fe"],"fname":"1f472-1f3fe","uc":"1f472-1f3fe","isCanonical": true},":man_with_gua_pi_mao_tone3:":{"unicode":["1f472-1f3fd"],"fname":"1f472-1f3fd","uc":"1f472-1f3fd","isCanonical": true},":man_with_gua_pi_mao_tone2:":{"unicode":["1f472-1f3fc"],"fname":"1f472-1f3fc","uc":"1f472-1f3fc","isCanonical": true},":man_with_gua_pi_mao_tone1:":{"unicode":["1f472-1f3fb"],"fname":"1f472-1f3fb","uc":"1f472-1f3fb","isCanonical": true},":person_with_blond_hair_tone5:":{"unicode":["1f471-1f3ff"],"fname":"1f471-1f3ff","uc":"1f471-1f3ff","isCanonical": true},":person_with_blond_hair_tone4:":{"unicode":["1f471-1f3fe"],"fname":"1f471-1f3fe","uc":"1f471-1f3fe","isCanonical": true},":person_with_blond_hair_tone3:":{"unicode":["1f471-1f3fd"],"fname":"1f471-1f3fd","uc":"1f471-1f3fd","isCanonical": true},":person_with_blond_hair_tone2:":{"unicode":["1f471-1f3fc"],"fname":"1f471-1f3fc","uc":"1f471-1f3fc","isCanonical": true},":person_with_blond_hair_tone1:":{"unicode":["1f471-1f3fb"],"fname":"1f471-1f3fb","uc":"1f471-1f3fb","isCanonical": true},":bride_with_veil_tone5:":{"unicode":["1f470-1f3ff"],"fname":"1f470-1f3ff","uc":"1f470-1f3ff","isCanonical": true},":bride_with_veil_tone4:":{"unicode":["1f470-1f3fe"],"fname":"1f470-1f3fe","uc":"1f470-1f3fe","isCanonical": true},":bride_with_veil_tone3:":{"unicode":["1f470-1f3fd"],"fname":"1f470-1f3fd","uc":"1f470-1f3fd","isCanonical": true},":bride_with_veil_tone2:":{"unicode":["1f470-1f3fc"],"fname":"1f470-1f3fc","uc":"1f470-1f3fc","isCanonical": true},":bride_with_veil_tone1:":{"unicode":["1f470-1f3fb"],"fname":"1f470-1f3fb","uc":"1f470-1f3fb","isCanonical": true},":cop_tone5:":{"unicode":["1f46e-1f3ff"],"fname":"1f46e-1f3ff","uc":"1f46e-1f3ff","isCanonical": true},":cop_tone4:":{"unicode":["1f46e-1f3fe"],"fname":"1f46e-1f3fe","uc":"1f46e-1f3fe","isCanonical": true},":cop_tone3:":{"unicode":["1f46e-1f3fd"],"fname":"1f46e-1f3fd","uc":"1f46e-1f3fd","isCanonical": true},":cop_tone2:":{"unicode":["1f46e-1f3fc"],"fname":"1f46e-1f3fc","uc":"1f46e-1f3fc","isCanonical": true},":cop_tone1:":{"unicode":["1f46e-1f3fb"],"fname":"1f46e-1f3fb","uc":"1f46e-1f3fb","isCanonical": true},":woman_tone5:":{"unicode":["1f469-1f3ff"],"fname":"1f469-1f3ff","uc":"1f469-1f3ff","isCanonical": true},":woman_tone4:":{"unicode":["1f469-1f3fe"],"fname":"1f469-1f3fe","uc":"1f469-1f3fe","isCanonical": true},":woman_tone3:":{"unicode":["1f469-1f3fd"],"fname":"1f469-1f3fd","uc":"1f469-1f3fd","isCanonical": true},":woman_tone2:":{"unicode":["1f469-1f3fc"],"fname":"1f469-1f3fc","uc":"1f469-1f3fc","isCanonical": true},":woman_tone1:":{"unicode":["1f469-1f3fb"],"fname":"1f469-1f3fb","uc":"1f469-1f3fb","isCanonical": true},":man_tone5:":{"unicode":["1f468-1f3ff"],"fname":"1f468-1f3ff","uc":"1f468-1f3ff","isCanonical": true},":man_tone4:":{"unicode":["1f468-1f3fe"],"fname":"1f468-1f3fe","uc":"1f468-1f3fe","isCanonical": true},":man_tone3:":{"unicode":["1f468-1f3fd"],"fname":"1f468-1f3fd","uc":"1f468-1f3fd","isCanonical": true},":man_tone2:":{"unicode":["1f468-1f3fc"],"fname":"1f468-1f3fc","uc":"1f468-1f3fc","isCanonical": true},":man_tone1:":{"unicode":["1f468-1f3fb"],"fname":"1f468-1f3fb","uc":"1f468-1f3fb","isCanonical": true},":girl_tone5:":{"unicode":["1f467-1f3ff"],"fname":"1f467-1f3ff","uc":"1f467-1f3ff","isCanonical": true},":girl_tone4:":{"unicode":["1f467-1f3fe"],"fname":"1f467-1f3fe","uc":"1f467-1f3fe","isCanonical": true},":girl_tone3:":{"unicode":["1f467-1f3fd"],"fname":"1f467-1f3fd","uc":"1f467-1f3fd","isCanonical": true},":girl_tone2:":{"unicode":["1f467-1f3fc"],"fname":"1f467-1f3fc","uc":"1f467-1f3fc","isCanonical": true},":girl_tone1:":{"unicode":["1f467-1f3fb"],"fname":"1f467-1f3fb","uc":"1f467-1f3fb","isCanonical": true},":boy_tone5:":{"unicode":["1f466-1f3ff"],"fname":"1f466-1f3ff","uc":"1f466-1f3ff","isCanonical": true},":boy_tone4:":{"unicode":["1f466-1f3fe"],"fname":"1f466-1f3fe","uc":"1f466-1f3fe","isCanonical": true},":boy_tone3:":{"unicode":["1f466-1f3fd"],"fname":"1f466-1f3fd","uc":"1f466-1f3fd","isCanonical": true},":boy_tone2:":{"unicode":["1f466-1f3fc"],"fname":"1f466-1f3fc","uc":"1f466-1f3fc","isCanonical": true},":boy_tone1:":{"unicode":["1f466-1f3fb"],"fname":"1f466-1f3fb","uc":"1f466-1f3fb","isCanonical": true},":open_hands_tone5:":{"unicode":["1f450-1f3ff"],"fname":"1f450-1f3ff","uc":"1f450-1f3ff","isCanonical": true},":open_hands_tone4:":{"unicode":["1f450-1f3fe"],"fname":"1f450-1f3fe","uc":"1f450-1f3fe","isCanonical": true},":open_hands_tone3:":{"unicode":["1f450-1f3fd"],"fname":"1f450-1f3fd","uc":"1f450-1f3fd","isCanonical": true},":open_hands_tone2:":{"unicode":["1f450-1f3fc"],"fname":"1f450-1f3fc","uc":"1f450-1f3fc","isCanonical": true},":open_hands_tone1:":{"unicode":["1f450-1f3fb"],"fname":"1f450-1f3fb","uc":"1f450-1f3fb","isCanonical": true},":clap_tone5:":{"unicode":["1f44f-1f3ff"],"fname":"1f44f-1f3ff","uc":"1f44f-1f3ff","isCanonical": true},":clap_tone4:":{"unicode":["1f44f-1f3fe"],"fname":"1f44f-1f3fe","uc":"1f44f-1f3fe","isCanonical": true},":clap_tone3:":{"unicode":["1f44f-1f3fd"],"fname":"1f44f-1f3fd","uc":"1f44f-1f3fd","isCanonical": true},":clap_tone2:":{"unicode":["1f44f-1f3fc"],"fname":"1f44f-1f3fc","uc":"1f44f-1f3fc","isCanonical": true},":clap_tone1:":{"unicode":["1f44f-1f3fb"],"fname":"1f44f-1f3fb","uc":"1f44f-1f3fb","isCanonical": true},":thumbsdown_tone5:":{"unicode":["1f44e-1f3ff"],"fname":"1f44e-1f3ff","uc":"1f44e-1f3ff","isCanonical": true},":-1_tone5:":{"unicode":["1f44e-1f3ff"],"fname":"1f44e-1f3ff","uc":"1f44e-1f3ff","isCanonical": false},":thumbdown_tone5:":{"unicode":["1f44e-1f3ff"],"fname":"1f44e-1f3ff","uc":"1f44e-1f3ff","isCanonical": false},":thumbsdown_tone4:":{"unicode":["1f44e-1f3fe"],"fname":"1f44e-1f3fe","uc":"1f44e-1f3fe","isCanonical": true},":-1_tone4:":{"unicode":["1f44e-1f3fe"],"fname":"1f44e-1f3fe","uc":"1f44e-1f3fe","isCanonical": false},":thumbdown_tone4:":{"unicode":["1f44e-1f3fe"],"fname":"1f44e-1f3fe","uc":"1f44e-1f3fe","isCanonical": false},":thumbsdown_tone3:":{"unicode":["1f44e-1f3fd"],"fname":"1f44e-1f3fd","uc":"1f44e-1f3fd","isCanonical": true},":-1_tone3:":{"unicode":["1f44e-1f3fd"],"fname":"1f44e-1f3fd","uc":"1f44e-1f3fd","isCanonical": false},":thumbdown_tone3:":{"unicode":["1f44e-1f3fd"],"fname":"1f44e-1f3fd","uc":"1f44e-1f3fd","isCanonical": false},":thumbsdown_tone2:":{"unicode":["1f44e-1f3fc"],"fname":"1f44e-1f3fc","uc":"1f44e-1f3fc","isCanonical": true},":-1_tone2:":{"unicode":["1f44e-1f3fc"],"fname":"1f44e-1f3fc","uc":"1f44e-1f3fc","isCanonical": false},":thumbdown_tone2:":{"unicode":["1f44e-1f3fc"],"fname":"1f44e-1f3fc","uc":"1f44e-1f3fc","isCanonical": false},":thumbsdown_tone1:":{"unicode":["1f44e-1f3fb"],"fname":"1f44e-1f3fb","uc":"1f44e-1f3fb","isCanonical": true},":-1_tone1:":{"unicode":["1f44e-1f3fb"],"fname":"1f44e-1f3fb","uc":"1f44e-1f3fb","isCanonical": false},":thumbdown_tone1:":{"unicode":["1f44e-1f3fb"],"fname":"1f44e-1f3fb","uc":"1f44e-1f3fb","isCanonical": false},":thumbsup_tone5:":{"unicode":["1f44d-1f3ff"],"fname":"1f44d-1f3ff","uc":"1f44d-1f3ff","isCanonical": true},":+1_tone5:":{"unicode":["1f44d-1f3ff"],"fname":"1f44d-1f3ff","uc":"1f44d-1f3ff","isCanonical": false},":thumbup_tone5:":{"unicode":["1f44d-1f3ff"],"fname":"1f44d-1f3ff","uc":"1f44d-1f3ff","isCanonical": false},":thumbsup_tone4:":{"unicode":["1f44d-1f3fe"],"fname":"1f44d-1f3fe","uc":"1f44d-1f3fe","isCanonical": true},":+1_tone4:":{"unicode":["1f44d-1f3fe"],"fname":"1f44d-1f3fe","uc":"1f44d-1f3fe","isCanonical": false},":thumbup_tone4:":{"unicode":["1f44d-1f3fe"],"fname":"1f44d-1f3fe","uc":"1f44d-1f3fe","isCanonical": false},":thumbsup_tone3:":{"unicode":["1f44d-1f3fd"],"fname":"1f44d-1f3fd","uc":"1f44d-1f3fd","isCanonical": true},":+1_tone3:":{"unicode":["1f44d-1f3fd"],"fname":"1f44d-1f3fd","uc":"1f44d-1f3fd","isCanonical": false},":thumbup_tone3:":{"unicode":["1f44d-1f3fd"],"fname":"1f44d-1f3fd","uc":"1f44d-1f3fd","isCanonical": false},":thumbsup_tone2:":{"unicode":["1f44d-1f3fc"],"fname":"1f44d-1f3fc","uc":"1f44d-1f3fc","isCanonical": true},":+1_tone2:":{"unicode":["1f44d-1f3fc"],"fname":"1f44d-1f3fc","uc":"1f44d-1f3fc","isCanonical": false},":thumbup_tone2:":{"unicode":["1f44d-1f3fc"],"fname":"1f44d-1f3fc","uc":"1f44d-1f3fc","isCanonical": false},":thumbsup_tone1:":{"unicode":["1f44d-1f3fb"],"fname":"1f44d-1f3fb","uc":"1f44d-1f3fb","isCanonical": true},":+1_tone1:":{"unicode":["1f44d-1f3fb"],"fname":"1f44d-1f3fb","uc":"1f44d-1f3fb","isCanonical": false},":thumbup_tone1:":{"unicode":["1f44d-1f3fb"],"fname":"1f44d-1f3fb","uc":"1f44d-1f3fb","isCanonical": false},":ok_hand_tone5:":{"unicode":["1f44c-1f3ff"],"fname":"1f44c-1f3ff","uc":"1f44c-1f3ff","isCanonical": true},":ok_hand_tone4:":{"unicode":["1f44c-1f3fe"],"fname":"1f44c-1f3fe","uc":"1f44c-1f3fe","isCanonical": true},":ok_hand_tone3:":{"unicode":["1f44c-1f3fd"],"fname":"1f44c-1f3fd","uc":"1f44c-1f3fd","isCanonical": true},":ok_hand_tone2:":{"unicode":["1f44c-1f3fc"],"fname":"1f44c-1f3fc","uc":"1f44c-1f3fc","isCanonical": true},":ok_hand_tone1:":{"unicode":["1f44c-1f3fb"],"fname":"1f44c-1f3fb","uc":"1f44c-1f3fb","isCanonical": true},":wave_tone5:":{"unicode":["1f44b-1f3ff"],"fname":"1f44b-1f3ff","uc":"1f44b-1f3ff","isCanonical": true},":wave_tone4:":{"unicode":["1f44b-1f3fe"],"fname":"1f44b-1f3fe","uc":"1f44b-1f3fe","isCanonical": true},":wave_tone3:":{"unicode":["1f44b-1f3fd"],"fname":"1f44b-1f3fd","uc":"1f44b-1f3fd","isCanonical": true},":wave_tone2:":{"unicode":["1f44b-1f3fc"],"fname":"1f44b-1f3fc","uc":"1f44b-1f3fc","isCanonical": true},":wave_tone1:":{"unicode":["1f44b-1f3fb"],"fname":"1f44b-1f3fb","uc":"1f44b-1f3fb","isCanonical": true},":punch_tone5:":{"unicode":["1f44a-1f3ff"],"fname":"1f44a-1f3ff","uc":"1f44a-1f3ff","isCanonical": true},":punch_tone4:":{"unicode":["1f44a-1f3fe"],"fname":"1f44a-1f3fe","uc":"1f44a-1f3fe","isCanonical": true},":punch_tone3:":{"unicode":["1f44a-1f3fd"],"fname":"1f44a-1f3fd","uc":"1f44a-1f3fd","isCanonical": true},":punch_tone2:":{"unicode":["1f44a-1f3fc"],"fname":"1f44a-1f3fc","uc":"1f44a-1f3fc","isCanonical": true},":punch_tone1:":{"unicode":["1f44a-1f3fb"],"fname":"1f44a-1f3fb","uc":"1f44a-1f3fb","isCanonical": true},":point_right_tone5:":{"unicode":["1f449-1f3ff"],"fname":"1f449-1f3ff","uc":"1f449-1f3ff","isCanonical": true},":point_right_tone4:":{"unicode":["1f449-1f3fe"],"fname":"1f449-1f3fe","uc":"1f449-1f3fe","isCanonical": true},":point_right_tone3:":{"unicode":["1f449-1f3fd"],"fname":"1f449-1f3fd","uc":"1f449-1f3fd","isCanonical": true},":point_right_tone2:":{"unicode":["1f449-1f3fc"],"fname":"1f449-1f3fc","uc":"1f449-1f3fc","isCanonical": true},":point_right_tone1:":{"unicode":["1f449-1f3fb"],"fname":"1f449-1f3fb","uc":"1f449-1f3fb","isCanonical": true},":point_left_tone5:":{"unicode":["1f448-1f3ff"],"fname":"1f448-1f3ff","uc":"1f448-1f3ff","isCanonical": true},":point_left_tone4:":{"unicode":["1f448-1f3fe"],"fname":"1f448-1f3fe","uc":"1f448-1f3fe","isCanonical": true},":point_left_tone3:":{"unicode":["1f448-1f3fd"],"fname":"1f448-1f3fd","uc":"1f448-1f3fd","isCanonical": true},":point_left_tone2:":{"unicode":["1f448-1f3fc"],"fname":"1f448-1f3fc","uc":"1f448-1f3fc","isCanonical": true},":point_left_tone1:":{"unicode":["1f448-1f3fb"],"fname":"1f448-1f3fb","uc":"1f448-1f3fb","isCanonical": true},":point_down_tone5:":{"unicode":["1f447-1f3ff"],"fname":"1f447-1f3ff","uc":"1f447-1f3ff","isCanonical": true},":point_down_tone4:":{"unicode":["1f447-1f3fe"],"fname":"1f447-1f3fe","uc":"1f447-1f3fe","isCanonical": true},":point_down_tone3:":{"unicode":["1f447-1f3fd"],"fname":"1f447-1f3fd","uc":"1f447-1f3fd","isCanonical": true},":point_down_tone2:":{"unicode":["1f447-1f3fc"],"fname":"1f447-1f3fc","uc":"1f447-1f3fc","isCanonical": true},":point_down_tone1:":{"unicode":["1f447-1f3fb"],"fname":"1f447-1f3fb","uc":"1f447-1f3fb","isCanonical": true},":point_up_2_tone5:":{"unicode":["1f446-1f3ff"],"fname":"1f446-1f3ff","uc":"1f446-1f3ff","isCanonical": true},":point_up_2_tone4:":{"unicode":["1f446-1f3fe"],"fname":"1f446-1f3fe","uc":"1f446-1f3fe","isCanonical": true},":point_up_2_tone3:":{"unicode":["1f446-1f3fd"],"fname":"1f446-1f3fd","uc":"1f446-1f3fd","isCanonical": true},":point_up_2_tone2:":{"unicode":["1f446-1f3fc"],"fname":"1f446-1f3fc","uc":"1f446-1f3fc","isCanonical": true},":point_up_2_tone1:":{"unicode":["1f446-1f3fb"],"fname":"1f446-1f3fb","uc":"1f446-1f3fb","isCanonical": true},":nose_tone5:":{"unicode":["1f443-1f3ff"],"fname":"1f443-1f3ff","uc":"1f443-1f3ff","isCanonical": true},":nose_tone4:":{"unicode":["1f443-1f3fe"],"fname":"1f443-1f3fe","uc":"1f443-1f3fe","isCanonical": true},":nose_tone3:":{"unicode":["1f443-1f3fd"],"fname":"1f443-1f3fd","uc":"1f443-1f3fd","isCanonical": true},":nose_tone2:":{"unicode":["1f443-1f3fc"],"fname":"1f443-1f3fc","uc":"1f443-1f3fc","isCanonical": true},":nose_tone1:":{"unicode":["1f443-1f3fb"],"fname":"1f443-1f3fb","uc":"1f443-1f3fb","isCanonical": true},":ear_tone5:":{"unicode":["1f442-1f3ff"],"fname":"1f442-1f3ff","uc":"1f442-1f3ff","isCanonical": true},":ear_tone4:":{"unicode":["1f442-1f3fe"],"fname":"1f442-1f3fe","uc":"1f442-1f3fe","isCanonical": true},":ear_tone3:":{"unicode":["1f442-1f3fd"],"fname":"1f442-1f3fd","uc":"1f442-1f3fd","isCanonical": true},":ear_tone2:":{"unicode":["1f442-1f3fc"],"fname":"1f442-1f3fc","uc":"1f442-1f3fc","isCanonical": true},":ear_tone1:":{"unicode":["1f442-1f3fb"],"fname":"1f442-1f3fb","uc":"1f442-1f3fb","isCanonical": true},":lifter_tone5:":{"unicode":["1f3cb-1f3ff"],"fname":"1f3cb-1f3ff","uc":"1f3cb-1f3ff","isCanonical": true},":weight_lifter_tone5:":{"unicode":["1f3cb-1f3ff"],"fname":"1f3cb-1f3ff","uc":"1f3cb-1f3ff","isCanonical": false},":lifter_tone4:":{"unicode":["1f3cb-1f3fe"],"fname":"1f3cb-1f3fe","uc":"1f3cb-1f3fe","isCanonical": true},":weight_lifter_tone4:":{"unicode":["1f3cb-1f3fe"],"fname":"1f3cb-1f3fe","uc":"1f3cb-1f3fe","isCanonical": false},":lifter_tone3:":{"unicode":["1f3cb-1f3fd"],"fname":"1f3cb-1f3fd","uc":"1f3cb-1f3fd","isCanonical": true},":weight_lifter_tone3:":{"unicode":["1f3cb-1f3fd"],"fname":"1f3cb-1f3fd","uc":"1f3cb-1f3fd","isCanonical": false},":lifter_tone2:":{"unicode":["1f3cb-1f3fc"],"fname":"1f3cb-1f3fc","uc":"1f3cb-1f3fc","isCanonical": true},":weight_lifter_tone2:":{"unicode":["1f3cb-1f3fc"],"fname":"1f3cb-1f3fc","uc":"1f3cb-1f3fc","isCanonical": false},":lifter_tone1:":{"unicode":["1f3cb-1f3fb"],"fname":"1f3cb-1f3fb","uc":"1f3cb-1f3fb","isCanonical": true},":weight_lifter_tone1:":{"unicode":["1f3cb-1f3fb"],"fname":"1f3cb-1f3fb","uc":"1f3cb-1f3fb","isCanonical": false},":swimmer_tone5:":{"unicode":["1f3ca-1f3ff"],"fname":"1f3ca-1f3ff","uc":"1f3ca-1f3ff","isCanonical": true},":swimmer_tone4:":{"unicode":["1f3ca-1f3fe"],"fname":"1f3ca-1f3fe","uc":"1f3ca-1f3fe","isCanonical": true},":swimmer_tone3:":{"unicode":["1f3ca-1f3fd"],"fname":"1f3ca-1f3fd","uc":"1f3ca-1f3fd","isCanonical": true},":swimmer_tone2:":{"unicode":["1f3ca-1f3fc"],"fname":"1f3ca-1f3fc","uc":"1f3ca-1f3fc","isCanonical": true},":swimmer_tone1:":{"unicode":["1f3ca-1f3fb"],"fname":"1f3ca-1f3fb","uc":"1f3ca-1f3fb","isCanonical": true},":horse_racing_tone5:":{"unicode":["1f3c7-1f3ff"],"fname":"1f3c7-1f3ff","uc":"1f3c7-1f3ff","isCanonical": true},":horse_racing_tone4:":{"unicode":["1f3c7-1f3fe"],"fname":"1f3c7-1f3fe","uc":"1f3c7-1f3fe","isCanonical": true},":horse_racing_tone3:":{"unicode":["1f3c7-1f3fd"],"fname":"1f3c7-1f3fd","uc":"1f3c7-1f3fd","isCanonical": true},":horse_racing_tone2:":{"unicode":["1f3c7-1f3fc"],"fname":"1f3c7-1f3fc","uc":"1f3c7-1f3fc","isCanonical": true},":horse_racing_tone1:":{"unicode":["1f3c7-1f3fb"],"fname":"1f3c7-1f3fb","uc":"1f3c7-1f3fb","isCanonical": true},":surfer_tone5:":{"unicode":["1f3c4-1f3ff"],"fname":"1f3c4-1f3ff","uc":"1f3c4-1f3ff","isCanonical": true},":surfer_tone4:":{"unicode":["1f3c4-1f3fe"],"fname":"1f3c4-1f3fe","uc":"1f3c4-1f3fe","isCanonical": true},":surfer_tone3:":{"unicode":["1f3c4-1f3fd"],"fname":"1f3c4-1f3fd","uc":"1f3c4-1f3fd","isCanonical": true},":surfer_tone2:":{"unicode":["1f3c4-1f3fc"],"fname":"1f3c4-1f3fc","uc":"1f3c4-1f3fc","isCanonical": true},":surfer_tone1:":{"unicode":["1f3c4-1f3fb"],"fname":"1f3c4-1f3fb","uc":"1f3c4-1f3fb","isCanonical": true},":runner_tone5:":{"unicode":["1f3c3-1f3ff"],"fname":"1f3c3-1f3ff","uc":"1f3c3-1f3ff","isCanonical": true},":runner_tone4:":{"unicode":["1f3c3-1f3fe"],"fname":"1f3c3-1f3fe","uc":"1f3c3-1f3fe","isCanonical": true},":runner_tone3:":{"unicode":["1f3c3-1f3fd"],"fname":"1f3c3-1f3fd","uc":"1f3c3-1f3fd","isCanonical": true},":runner_tone2:":{"unicode":["1f3c3-1f3fc"],"fname":"1f3c3-1f3fc","uc":"1f3c3-1f3fc","isCanonical": true},":runner_tone1:":{"unicode":["1f3c3-1f3fb"],"fname":"1f3c3-1f3fb","uc":"1f3c3-1f3fb","isCanonical": true},":santa_tone5:":{"unicode":["1f385-1f3ff"],"fname":"1f385-1f3ff","uc":"1f385-1f3ff","isCanonical": true},":santa_tone4:":{"unicode":["1f385-1f3fe"],"fname":"1f385-1f3fe","uc":"1f385-1f3fe","isCanonical": true},":santa_tone3:":{"unicode":["1f385-1f3fd"],"fname":"1f385-1f3fd","uc":"1f385-1f3fd","isCanonical": true},":santa_tone2:":{"unicode":["1f385-1f3fc"],"fname":"1f385-1f3fc","uc":"1f385-1f3fc","isCanonical": true},":santa_tone1:":{"unicode":["1f385-1f3fb"],"fname":"1f385-1f3fb","uc":"1f385-1f3fb","isCanonical": true},":flag_zw:":{"unicode":["1f1ff-1f1fc"],"fname":"1f1ff-1f1fc","uc":"1f1ff-1f1fc","isCanonical": true},":zw:":{"unicode":["1f1ff-1f1fc"],"fname":"1f1ff-1f1fc","uc":"1f1ff-1f1fc","isCanonical": false},":flag_zm:":{"unicode":["1f1ff-1f1f2"],"fname":"1f1ff-1f1f2","uc":"1f1ff-1f1f2","isCanonical": true},":zm:":{"unicode":["1f1ff-1f1f2"],"fname":"1f1ff-1f1f2","uc":"1f1ff-1f1f2","isCanonical": false},":flag_za:":{"unicode":["1f1ff-1f1e6"],"fname":"1f1ff-1f1e6","uc":"1f1ff-1f1e6","isCanonical": true},":za:":{"unicode":["1f1ff-1f1e6"],"fname":"1f1ff-1f1e6","uc":"1f1ff-1f1e6","isCanonical": false},":flag_yt:":{"unicode":["1f1fe-1f1f9"],"fname":"1f1fe-1f1f9","uc":"1f1fe-1f1f9","isCanonical": true},":yt:":{"unicode":["1f1fe-1f1f9"],"fname":"1f1fe-1f1f9","uc":"1f1fe-1f1f9","isCanonical": false},":flag_ye:":{"unicode":["1f1fe-1f1ea"],"fname":"1f1fe-1f1ea","uc":"1f1fe-1f1ea","isCanonical": true},":ye:":{"unicode":["1f1fe-1f1ea"],"fname":"1f1fe-1f1ea","uc":"1f1fe-1f1ea","isCanonical": false},":flag_xk:":{"unicode":["1f1fd-1f1f0"],"fname":"1f1fd-1f1f0","uc":"1f1fd-1f1f0","isCanonical": true},":xk:":{"unicode":["1f1fd-1f1f0"],"fname":"1f1fd-1f1f0","uc":"1f1fd-1f1f0","isCanonical": false},":flag_ws:":{"unicode":["1f1fc-1f1f8"],"fname":"1f1fc-1f1f8","uc":"1f1fc-1f1f8","isCanonical": true},":ws:":{"unicode":["1f1fc-1f1f8"],"fname":"1f1fc-1f1f8","uc":"1f1fc-1f1f8","isCanonical": false},":flag_wf:":{"unicode":["1f1fc-1f1eb"],"fname":"1f1fc-1f1eb","uc":"1f1fc-1f1eb","isCanonical": true},":wf:":{"unicode":["1f1fc-1f1eb"],"fname":"1f1fc-1f1eb","uc":"1f1fc-1f1eb","isCanonical": false},":flag_vu:":{"unicode":["1f1fb-1f1fa"],"fname":"1f1fb-1f1fa","uc":"1f1fb-1f1fa","isCanonical": true},":vu:":{"unicode":["1f1fb-1f1fa"],"fname":"1f1fb-1f1fa","uc":"1f1fb-1f1fa","isCanonical": false},":flag_vn:":{"unicode":["1f1fb-1f1f3"],"fname":"1f1fb-1f1f3","uc":"1f1fb-1f1f3","isCanonical": true},":vn:":{"unicode":["1f1fb-1f1f3"],"fname":"1f1fb-1f1f3","uc":"1f1fb-1f1f3","isCanonical": false},":flag_vi:":{"unicode":["1f1fb-1f1ee"],"fname":"1f1fb-1f1ee","uc":"1f1fb-1f1ee","isCanonical": true},":vi:":{"unicode":["1f1fb-1f1ee"],"fname":"1f1fb-1f1ee","uc":"1f1fb-1f1ee","isCanonical": false},":flag_vg:":{"unicode":["1f1fb-1f1ec"],"fname":"1f1fb-1f1ec","uc":"1f1fb-1f1ec","isCanonical": true},":vg:":{"unicode":["1f1fb-1f1ec"],"fname":"1f1fb-1f1ec","uc":"1f1fb-1f1ec","isCanonical": false},":flag_ve:":{"unicode":["1f1fb-1f1ea"],"fname":"1f1fb-1f1ea","uc":"1f1fb-1f1ea","isCanonical": true},":ve:":{"unicode":["1f1fb-1f1ea"],"fname":"1f1fb-1f1ea","uc":"1f1fb-1f1ea","isCanonical": false},":flag_vc:":{"unicode":["1f1fb-1f1e8"],"fname":"1f1fb-1f1e8","uc":"1f1fb-1f1e8","isCanonical": true},":vc:":{"unicode":["1f1fb-1f1e8"],"fname":"1f1fb-1f1e8","uc":"1f1fb-1f1e8","isCanonical": false},":flag_va:":{"unicode":["1f1fb-1f1e6"],"fname":"1f1fb-1f1e6","uc":"1f1fb-1f1e6","isCanonical": true},":va:":{"unicode":["1f1fb-1f1e6"],"fname":"1f1fb-1f1e6","uc":"1f1fb-1f1e6","isCanonical": false},":flag_uz:":{"unicode":["1f1fa-1f1ff"],"fname":"1f1fa-1f1ff","uc":"1f1fa-1f1ff","isCanonical": true},":uz:":{"unicode":["1f1fa-1f1ff"],"fname":"1f1fa-1f1ff","uc":"1f1fa-1f1ff","isCanonical": false},":flag_uy:":{"unicode":["1f1fa-1f1fe"],"fname":"1f1fa-1f1fe","uc":"1f1fa-1f1fe","isCanonical": true},":uy:":{"unicode":["1f1fa-1f1fe"],"fname":"1f1fa-1f1fe","uc":"1f1fa-1f1fe","isCanonical": false},":flag_us:":{"unicode":["1f1fa-1f1f8"],"fname":"1f1fa-1f1f8","uc":"1f1fa-1f1f8","isCanonical": true},":us:":{"unicode":["1f1fa-1f1f8"],"fname":"1f1fa-1f1f8","uc":"1f1fa-1f1f8","isCanonical": false},":flag_um:":{"unicode":["1f1fa-1f1f2"],"fname":"1f1fa-1f1f2","uc":"1f1fa-1f1f2","isCanonical": true},":um:":{"unicode":["1f1fa-1f1f2"],"fname":"1f1fa-1f1f2","uc":"1f1fa-1f1f2","isCanonical": false},":flag_ug:":{"unicode":["1f1fa-1f1ec"],"fname":"1f1fa-1f1ec","uc":"1f1fa-1f1ec","isCanonical": true},":ug:":{"unicode":["1f1fa-1f1ec"],"fname":"1f1fa-1f1ec","uc":"1f1fa-1f1ec","isCanonical": false},":flag_ua:":{"unicode":["1f1fa-1f1e6"],"fname":"1f1fa-1f1e6","uc":"1f1fa-1f1e6","isCanonical": true},":ua:":{"unicode":["1f1fa-1f1e6"],"fname":"1f1fa-1f1e6","uc":"1f1fa-1f1e6","isCanonical": false},":flag_tz:":{"unicode":["1f1f9-1f1ff"],"fname":"1f1f9-1f1ff","uc":"1f1f9-1f1ff","isCanonical": true},":tz:":{"unicode":["1f1f9-1f1ff"],"fname":"1f1f9-1f1ff","uc":"1f1f9-1f1ff","isCanonical": false},":flag_tw:":{"unicode":["1f1f9-1f1fc"],"fname":"1f1f9-1f1fc","uc":"1f1f9-1f1fc","isCanonical": true},":tw:":{"unicode":["1f1f9-1f1fc"],"fname":"1f1f9-1f1fc","uc":"1f1f9-1f1fc","isCanonical": false},":flag_tv:":{"unicode":["1f1f9-1f1fb"],"fname":"1f1f9-1f1fb","uc":"1f1f9-1f1fb","isCanonical": true},":tuvalu:":{"unicode":["1f1f9-1f1fb"],"fname":"1f1f9-1f1fb","uc":"1f1f9-1f1fb","isCanonical": false},":flag_tt:":{"unicode":["1f1f9-1f1f9"],"fname":"1f1f9-1f1f9","uc":"1f1f9-1f1f9","isCanonical": true},":tt:":{"unicode":["1f1f9-1f1f9"],"fname":"1f1f9-1f1f9","uc":"1f1f9-1f1f9","isCanonical": false},":flag_tr:":{"unicode":["1f1f9-1f1f7"],"fname":"1f1f9-1f1f7","uc":"1f1f9-1f1f7","isCanonical": true},":tr:":{"unicode":["1f1f9-1f1f7"],"fname":"1f1f9-1f1f7","uc":"1f1f9-1f1f7","isCanonical": false},":flag_to:":{"unicode":["1f1f9-1f1f4"],"fname":"1f1f9-1f1f4","uc":"1f1f9-1f1f4","isCanonical": true},":to:":{"unicode":["1f1f9-1f1f4"],"fname":"1f1f9-1f1f4","uc":"1f1f9-1f1f4","isCanonical": false},":flag_tn:":{"unicode":["1f1f9-1f1f3"],"fname":"1f1f9-1f1f3","uc":"1f1f9-1f1f3","isCanonical": true},":tn:":{"unicode":["1f1f9-1f1f3"],"fname":"1f1f9-1f1f3","uc":"1f1f9-1f1f3","isCanonical": false},":flag_tm:":{"unicode":["1f1f9-1f1f2"],"fname":"1f1f9-1f1f2","uc":"1f1f9-1f1f2","isCanonical": true},":turkmenistan:":{"unicode":["1f1f9-1f1f2"],"fname":"1f1f9-1f1f2","uc":"1f1f9-1f1f2","isCanonical": false},":flag_tl:":{"unicode":["1f1f9-1f1f1"],"fname":"1f1f9-1f1f1","uc":"1f1f9-1f1f1","isCanonical": true},":tl:":{"unicode":["1f1f9-1f1f1"],"fname":"1f1f9-1f1f1","uc":"1f1f9-1f1f1","isCanonical": false},":flag_tk:":{"unicode":["1f1f9-1f1f0"],"fname":"1f1f9-1f1f0","uc":"1f1f9-1f1f0","isCanonical": true},":tk:":{"unicode":["1f1f9-1f1f0"],"fname":"1f1f9-1f1f0","uc":"1f1f9-1f1f0","isCanonical": false},":flag_tj:":{"unicode":["1f1f9-1f1ef"],"fname":"1f1f9-1f1ef","uc":"1f1f9-1f1ef","isCanonical": true},":tj:":{"unicode":["1f1f9-1f1ef"],"fname":"1f1f9-1f1ef","uc":"1f1f9-1f1ef","isCanonical": false},":flag_th:":{"unicode":["1f1f9-1f1ed"],"fname":"1f1f9-1f1ed","uc":"1f1f9-1f1ed","isCanonical": true},":th:":{"unicode":["1f1f9-1f1ed"],"fname":"1f1f9-1f1ed","uc":"1f1f9-1f1ed","isCanonical": false},":flag_tg:":{"unicode":["1f1f9-1f1ec"],"fname":"1f1f9-1f1ec","uc":"1f1f9-1f1ec","isCanonical": true},":tg:":{"unicode":["1f1f9-1f1ec"],"fname":"1f1f9-1f1ec","uc":"1f1f9-1f1ec","isCanonical": false},":flag_tf:":{"unicode":["1f1f9-1f1eb"],"fname":"1f1f9-1f1eb","uc":"1f1f9-1f1eb","isCanonical": true},":tf:":{"unicode":["1f1f9-1f1eb"],"fname":"1f1f9-1f1eb","uc":"1f1f9-1f1eb","isCanonical": false},":flag_td:":{"unicode":["1f1f9-1f1e9"],"fname":"1f1f9-1f1e9","uc":"1f1f9-1f1e9","isCanonical": true},":td:":{"unicode":["1f1f9-1f1e9"],"fname":"1f1f9-1f1e9","uc":"1f1f9-1f1e9","isCanonical": false},":flag_tc:":{"unicode":["1f1f9-1f1e8"],"fname":"1f1f9-1f1e8","uc":"1f1f9-1f1e8","isCanonical": true},":tc:":{"unicode":["1f1f9-1f1e8"],"fname":"1f1f9-1f1e8","uc":"1f1f9-1f1e8","isCanonical": false},":flag_ta:":{"unicode":["1f1f9-1f1e6"],"fname":"1f1f9-1f1e6","uc":"1f1f9-1f1e6","isCanonical": true},":ta:":{"unicode":["1f1f9-1f1e6"],"fname":"1f1f9-1f1e6","uc":"1f1f9-1f1e6","isCanonical": false},":flag_sz:":{"unicode":["1f1f8-1f1ff"],"fname":"1f1f8-1f1ff","uc":"1f1f8-1f1ff","isCanonical": true},":sz:":{"unicode":["1f1f8-1f1ff"],"fname":"1f1f8-1f1ff","uc":"1f1f8-1f1ff","isCanonical": false},":flag_sy:":{"unicode":["1f1f8-1f1fe"],"fname":"1f1f8-1f1fe","uc":"1f1f8-1f1fe","isCanonical": true},":sy:":{"unicode":["1f1f8-1f1fe"],"fname":"1f1f8-1f1fe","uc":"1f1f8-1f1fe","isCanonical": false},":flag_sx:":{"unicode":["1f1f8-1f1fd"],"fname":"1f1f8-1f1fd","uc":"1f1f8-1f1fd","isCanonical": true},":sx:":{"unicode":["1f1f8-1f1fd"],"fname":"1f1f8-1f1fd","uc":"1f1f8-1f1fd","isCanonical": false},":flag_sv:":{"unicode":["1f1f8-1f1fb"],"fname":"1f1f8-1f1fb","uc":"1f1f8-1f1fb","isCanonical": true},":sv:":{"unicode":["1f1f8-1f1fb"],"fname":"1f1f8-1f1fb","uc":"1f1f8-1f1fb","isCanonical": false},":flag_st:":{"unicode":["1f1f8-1f1f9"],"fname":"1f1f8-1f1f9","uc":"1f1f8-1f1f9","isCanonical": true},":st:":{"unicode":["1f1f8-1f1f9"],"fname":"1f1f8-1f1f9","uc":"1f1f8-1f1f9","isCanonical": false},":flag_ss:":{"unicode":["1f1f8-1f1f8"],"fname":"1f1f8-1f1f8","uc":"1f1f8-1f1f8","isCanonical": true},":ss:":{"unicode":["1f1f8-1f1f8"],"fname":"1f1f8-1f1f8","uc":"1f1f8-1f1f8","isCanonical": false},":flag_sr:":{"unicode":["1f1f8-1f1f7"],"fname":"1f1f8-1f1f7","uc":"1f1f8-1f1f7","isCanonical": true},":sr:":{"unicode":["1f1f8-1f1f7"],"fname":"1f1f8-1f1f7","uc":"1f1f8-1f1f7","isCanonical": false},":flag_so:":{"unicode":["1f1f8-1f1f4"],"fname":"1f1f8-1f1f4","uc":"1f1f8-1f1f4","isCanonical": true},":so:":{"unicode":["1f1f8-1f1f4"],"fname":"1f1f8-1f1f4","uc":"1f1f8-1f1f4","isCanonical": false},":flag_sn:":{"unicode":["1f1f8-1f1f3"],"fname":"1f1f8-1f1f3","uc":"1f1f8-1f1f3","isCanonical": true},":sn:":{"unicode":["1f1f8-1f1f3"],"fname":"1f1f8-1f1f3","uc":"1f1f8-1f1f3","isCanonical": false},":flag_sm:":{"unicode":["1f1f8-1f1f2"],"fname":"1f1f8-1f1f2","uc":"1f1f8-1f1f2","isCanonical": true},":sm:":{"unicode":["1f1f8-1f1f2"],"fname":"1f1f8-1f1f2","uc":"1f1f8-1f1f2","isCanonical": false},":flag_sl:":{"unicode":["1f1f8-1f1f1"],"fname":"1f1f8-1f1f1","uc":"1f1f8-1f1f1","isCanonical": true},":sl:":{"unicode":["1f1f8-1f1f1"],"fname":"1f1f8-1f1f1","uc":"1f1f8-1f1f1","isCanonical": false},":flag_sk:":{"unicode":["1f1f8-1f1f0"],"fname":"1f1f8-1f1f0","uc":"1f1f8-1f1f0","isCanonical": true},":sk:":{"unicode":["1f1f8-1f1f0"],"fname":"1f1f8-1f1f0","uc":"1f1f8-1f1f0","isCanonical": false},":flag_sj:":{"unicode":["1f1f8-1f1ef"],"fname":"1f1f8-1f1ef","uc":"1f1f8-1f1ef","isCanonical": true},":sj:":{"unicode":["1f1f8-1f1ef"],"fname":"1f1f8-1f1ef","uc":"1f1f8-1f1ef","isCanonical": false},":flag_si:":{"unicode":["1f1f8-1f1ee"],"fname":"1f1f8-1f1ee","uc":"1f1f8-1f1ee","isCanonical": true},":si:":{"unicode":["1f1f8-1f1ee"],"fname":"1f1f8-1f1ee","uc":"1f1f8-1f1ee","isCanonical": false},":flag_sh:":{"unicode":["1f1f8-1f1ed"],"fname":"1f1f8-1f1ed","uc":"1f1f8-1f1ed","isCanonical": true},":sh:":{"unicode":["1f1f8-1f1ed"],"fname":"1f1f8-1f1ed","uc":"1f1f8-1f1ed","isCanonical": false},":flag_sg:":{"unicode":["1f1f8-1f1ec"],"fname":"1f1f8-1f1ec","uc":"1f1f8-1f1ec","isCanonical": true},":sg:":{"unicode":["1f1f8-1f1ec"],"fname":"1f1f8-1f1ec","uc":"1f1f8-1f1ec","isCanonical": false},":flag_se:":{"unicode":["1f1f8-1f1ea"],"fname":"1f1f8-1f1ea","uc":"1f1f8-1f1ea","isCanonical": true},":se:":{"unicode":["1f1f8-1f1ea"],"fname":"1f1f8-1f1ea","uc":"1f1f8-1f1ea","isCanonical": false},":flag_sd:":{"unicode":["1f1f8-1f1e9"],"fname":"1f1f8-1f1e9","uc":"1f1f8-1f1e9","isCanonical": true},":sd:":{"unicode":["1f1f8-1f1e9"],"fname":"1f1f8-1f1e9","uc":"1f1f8-1f1e9","isCanonical": false},":flag_sc:":{"unicode":["1f1f8-1f1e8"],"fname":"1f1f8-1f1e8","uc":"1f1f8-1f1e8","isCanonical": true},":sc:":{"unicode":["1f1f8-1f1e8"],"fname":"1f1f8-1f1e8","uc":"1f1f8-1f1e8","isCanonical": false},":flag_sb:":{"unicode":["1f1f8-1f1e7"],"fname":"1f1f8-1f1e7","uc":"1f1f8-1f1e7","isCanonical": true},":sb:":{"unicode":["1f1f8-1f1e7"],"fname":"1f1f8-1f1e7","uc":"1f1f8-1f1e7","isCanonical": false},":flag_sa:":{"unicode":["1f1f8-1f1e6"],"fname":"1f1f8-1f1e6","uc":"1f1f8-1f1e6","isCanonical": true},":saudiarabia:":{"unicode":["1f1f8-1f1e6"],"fname":"1f1f8-1f1e6","uc":"1f1f8-1f1e6","isCanonical": false},":saudi:":{"unicode":["1f1f8-1f1e6"],"fname":"1f1f8-1f1e6","uc":"1f1f8-1f1e6","isCanonical": false},":flag_rw:":{"unicode":["1f1f7-1f1fc"],"fname":"1f1f7-1f1fc","uc":"1f1f7-1f1fc","isCanonical": true},":rw:":{"unicode":["1f1f7-1f1fc"],"fname":"1f1f7-1f1fc","uc":"1f1f7-1f1fc","isCanonical": false},":flag_ru:":{"unicode":["1f1f7-1f1fa"],"fname":"1f1f7-1f1fa","uc":"1f1f7-1f1fa","isCanonical": true},":ru:":{"unicode":["1f1f7-1f1fa"],"fname":"1f1f7-1f1fa","uc":"1f1f7-1f1fa","isCanonical": false},":flag_rs:":{"unicode":["1f1f7-1f1f8"],"fname":"1f1f7-1f1f8","uc":"1f1f7-1f1f8","isCanonical": true},":rs:":{"unicode":["1f1f7-1f1f8"],"fname":"1f1f7-1f1f8","uc":"1f1f7-1f1f8","isCanonical": false},":flag_ro:":{"unicode":["1f1f7-1f1f4"],"fname":"1f1f7-1f1f4","uc":"1f1f7-1f1f4","isCanonical": true},":ro:":{"unicode":["1f1f7-1f1f4"],"fname":"1f1f7-1f1f4","uc":"1f1f7-1f1f4","isCanonical": false},":flag_re:":{"unicode":["1f1f7-1f1ea"],"fname":"1f1f7-1f1ea","uc":"1f1f7-1f1ea","isCanonical": true},":re:":{"unicode":["1f1f7-1f1ea"],"fname":"1f1f7-1f1ea","uc":"1f1f7-1f1ea","isCanonical": false},":flag_qa:":{"unicode":["1f1f6-1f1e6"],"fname":"1f1f6-1f1e6","uc":"1f1f6-1f1e6","isCanonical": true},":qa:":{"unicode":["1f1f6-1f1e6"],"fname":"1f1f6-1f1e6","uc":"1f1f6-1f1e6","isCanonical": false},":flag_py:":{"unicode":["1f1f5-1f1fe"],"fname":"1f1f5-1f1fe","uc":"1f1f5-1f1fe","isCanonical": true},":py:":{"unicode":["1f1f5-1f1fe"],"fname":"1f1f5-1f1fe","uc":"1f1f5-1f1fe","isCanonical": false},":flag_pw:":{"unicode":["1f1f5-1f1fc"],"fname":"1f1f5-1f1fc","uc":"1f1f5-1f1fc","isCanonical": true},":pw:":{"unicode":["1f1f5-1f1fc"],"fname":"1f1f5-1f1fc","uc":"1f1f5-1f1fc","isCanonical": false},":flag_pt:":{"unicode":["1f1f5-1f1f9"],"fname":"1f1f5-1f1f9","uc":"1f1f5-1f1f9","isCanonical": true},":pt:":{"unicode":["1f1f5-1f1f9"],"fname":"1f1f5-1f1f9","uc":"1f1f5-1f1f9","isCanonical": false},":flag_ps:":{"unicode":["1f1f5-1f1f8"],"fname":"1f1f5-1f1f8","uc":"1f1f5-1f1f8","isCanonical": true},":ps:":{"unicode":["1f1f5-1f1f8"],"fname":"1f1f5-1f1f8","uc":"1f1f5-1f1f8","isCanonical": false},":flag_pr:":{"unicode":["1f1f5-1f1f7"],"fname":"1f1f5-1f1f7","uc":"1f1f5-1f1f7","isCanonical": true},":pr:":{"unicode":["1f1f5-1f1f7"],"fname":"1f1f5-1f1f7","uc":"1f1f5-1f1f7","isCanonical": false},":flag_pn:":{"unicode":["1f1f5-1f1f3"],"fname":"1f1f5-1f1f3","uc":"1f1f5-1f1f3","isCanonical": true},":pn:":{"unicode":["1f1f5-1f1f3"],"fname":"1f1f5-1f1f3","uc":"1f1f5-1f1f3","isCanonical": false},":flag_pm:":{"unicode":["1f1f5-1f1f2"],"fname":"1f1f5-1f1f2","uc":"1f1f5-1f1f2","isCanonical": true},":pm:":{"unicode":["1f1f5-1f1f2"],"fname":"1f1f5-1f1f2","uc":"1f1f5-1f1f2","isCanonical": false},":flag_pl:":{"unicode":["1f1f5-1f1f1"],"fname":"1f1f5-1f1f1","uc":"1f1f5-1f1f1","isCanonical": true},":pl:":{"unicode":["1f1f5-1f1f1"],"fname":"1f1f5-1f1f1","uc":"1f1f5-1f1f1","isCanonical": false},":flag_pk:":{"unicode":["1f1f5-1f1f0"],"fname":"1f1f5-1f1f0","uc":"1f1f5-1f1f0","isCanonical": true},":pk:":{"unicode":["1f1f5-1f1f0"],"fname":"1f1f5-1f1f0","uc":"1f1f5-1f1f0","isCanonical": false},":flag_ph:":{"unicode":["1f1f5-1f1ed"],"fname":"1f1f5-1f1ed","uc":"1f1f5-1f1ed","isCanonical": true},":ph:":{"unicode":["1f1f5-1f1ed"],"fname":"1f1f5-1f1ed","uc":"1f1f5-1f1ed","isCanonical": false},":flag_pg:":{"unicode":["1f1f5-1f1ec"],"fname":"1f1f5-1f1ec","uc":"1f1f5-1f1ec","isCanonical": true},":pg:":{"unicode":["1f1f5-1f1ec"],"fname":"1f1f5-1f1ec","uc":"1f1f5-1f1ec","isCanonical": false},":flag_pf:":{"unicode":["1f1f5-1f1eb"],"fname":"1f1f5-1f1eb","uc":"1f1f5-1f1eb","isCanonical": true},":pf:":{"unicode":["1f1f5-1f1eb"],"fname":"1f1f5-1f1eb","uc":"1f1f5-1f1eb","isCanonical": false},":flag_pe:":{"unicode":["1f1f5-1f1ea"],"fname":"1f1f5-1f1ea","uc":"1f1f5-1f1ea","isCanonical": true},":pe:":{"unicode":["1f1f5-1f1ea"],"fname":"1f1f5-1f1ea","uc":"1f1f5-1f1ea","isCanonical": false},":flag_pa:":{"unicode":["1f1f5-1f1e6"],"fname":"1f1f5-1f1e6","uc":"1f1f5-1f1e6","isCanonical": true},":pa:":{"unicode":["1f1f5-1f1e6"],"fname":"1f1f5-1f1e6","uc":"1f1f5-1f1e6","isCanonical": false},":flag_om:":{"unicode":["1f1f4-1f1f2"],"fname":"1f1f4-1f1f2","uc":"1f1f4-1f1f2","isCanonical": true},":om:":{"unicode":["1f1f4-1f1f2"],"fname":"1f1f4-1f1f2","uc":"1f1f4-1f1f2","isCanonical": false},":flag_nz:":{"unicode":["1f1f3-1f1ff"],"fname":"1f1f3-1f1ff","uc":"1f1f3-1f1ff","isCanonical": true},":nz:":{"unicode":["1f1f3-1f1ff"],"fname":"1f1f3-1f1ff","uc":"1f1f3-1f1ff","isCanonical": false},":flag_nu:":{"unicode":["1f1f3-1f1fa"],"fname":"1f1f3-1f1fa","uc":"1f1f3-1f1fa","isCanonical": true},":nu:":{"unicode":["1f1f3-1f1fa"],"fname":"1f1f3-1f1fa","uc":"1f1f3-1f1fa","isCanonical": false},":flag_nr:":{"unicode":["1f1f3-1f1f7"],"fname":"1f1f3-1f1f7","uc":"1f1f3-1f1f7","isCanonical": true},":nr:":{"unicode":["1f1f3-1f1f7"],"fname":"1f1f3-1f1f7","uc":"1f1f3-1f1f7","isCanonical": false},":flag_np:":{"unicode":["1f1f3-1f1f5"],"fname":"1f1f3-1f1f5","uc":"1f1f3-1f1f5","isCanonical": true},":np:":{"unicode":["1f1f3-1f1f5"],"fname":"1f1f3-1f1f5","uc":"1f1f3-1f1f5","isCanonical": false},":flag_no:":{"unicode":["1f1f3-1f1f4"],"fname":"1f1f3-1f1f4","uc":"1f1f3-1f1f4","isCanonical": true},":no:":{"unicode":["1f1f3-1f1f4"],"fname":"1f1f3-1f1f4","uc":"1f1f3-1f1f4","isCanonical": false},":flag_nl:":{"unicode":["1f1f3-1f1f1"],"fname":"1f1f3-1f1f1","uc":"1f1f3-1f1f1","isCanonical": true},":nl:":{"unicode":["1f1f3-1f1f1"],"fname":"1f1f3-1f1f1","uc":"1f1f3-1f1f1","isCanonical": false},":flag_ni:":{"unicode":["1f1f3-1f1ee"],"fname":"1f1f3-1f1ee","uc":"1f1f3-1f1ee","isCanonical": true},":ni:":{"unicode":["1f1f3-1f1ee"],"fname":"1f1f3-1f1ee","uc":"1f1f3-1f1ee","isCanonical": false},":flag_ng:":{"unicode":["1f1f3-1f1ec"],"fname":"1f1f3-1f1ec","uc":"1f1f3-1f1ec","isCanonical": true},":nigeria:":{"unicode":["1f1f3-1f1ec"],"fname":"1f1f3-1f1ec","uc":"1f1f3-1f1ec","isCanonical": false},":flag_nf:":{"unicode":["1f1f3-1f1eb"],"fname":"1f1f3-1f1eb","uc":"1f1f3-1f1eb","isCanonical": true},":nf:":{"unicode":["1f1f3-1f1eb"],"fname":"1f1f3-1f1eb","uc":"1f1f3-1f1eb","isCanonical": false},":flag_ne:":{"unicode":["1f1f3-1f1ea"],"fname":"1f1f3-1f1ea","uc":"1f1f3-1f1ea","isCanonical": true},":ne:":{"unicode":["1f1f3-1f1ea"],"fname":"1f1f3-1f1ea","uc":"1f1f3-1f1ea","isCanonical": false},":flag_nc:":{"unicode":["1f1f3-1f1e8"],"fname":"1f1f3-1f1e8","uc":"1f1f3-1f1e8","isCanonical": true},":nc:":{"unicode":["1f1f3-1f1e8"],"fname":"1f1f3-1f1e8","uc":"1f1f3-1f1e8","isCanonical": false},":flag_na:":{"unicode":["1f1f3-1f1e6"],"fname":"1f1f3-1f1e6","uc":"1f1f3-1f1e6","isCanonical": true},":na:":{"unicode":["1f1f3-1f1e6"],"fname":"1f1f3-1f1e6","uc":"1f1f3-1f1e6","isCanonical": false},":flag_mz:":{"unicode":["1f1f2-1f1ff"],"fname":"1f1f2-1f1ff","uc":"1f1f2-1f1ff","isCanonical": true},":mz:":{"unicode":["1f1f2-1f1ff"],"fname":"1f1f2-1f1ff","uc":"1f1f2-1f1ff","isCanonical": false},":flag_my:":{"unicode":["1f1f2-1f1fe"],"fname":"1f1f2-1f1fe","uc":"1f1f2-1f1fe","isCanonical": true},":my:":{"unicode":["1f1f2-1f1fe"],"fname":"1f1f2-1f1fe","uc":"1f1f2-1f1fe","isCanonical": false},":flag_mx:":{"unicode":["1f1f2-1f1fd"],"fname":"1f1f2-1f1fd","uc":"1f1f2-1f1fd","isCanonical": true},":mx:":{"unicode":["1f1f2-1f1fd"],"fname":"1f1f2-1f1fd","uc":"1f1f2-1f1fd","isCanonical": false},":flag_mw:":{"unicode":["1f1f2-1f1fc"],"fname":"1f1f2-1f1fc","uc":"1f1f2-1f1fc","isCanonical": true},":mw:":{"unicode":["1f1f2-1f1fc"],"fname":"1f1f2-1f1fc","uc":"1f1f2-1f1fc","isCanonical": false},":flag_mv:":{"unicode":["1f1f2-1f1fb"],"fname":"1f1f2-1f1fb","uc":"1f1f2-1f1fb","isCanonical": true},":mv:":{"unicode":["1f1f2-1f1fb"],"fname":"1f1f2-1f1fb","uc":"1f1f2-1f1fb","isCanonical": false},":flag_mu:":{"unicode":["1f1f2-1f1fa"],"fname":"1f1f2-1f1fa","uc":"1f1f2-1f1fa","isCanonical": true},":mu:":{"unicode":["1f1f2-1f1fa"],"fname":"1f1f2-1f1fa","uc":"1f1f2-1f1fa","isCanonical": false},":flag_mt:":{"unicode":["1f1f2-1f1f9"],"fname":"1f1f2-1f1f9","uc":"1f1f2-1f1f9","isCanonical": true},":mt:":{"unicode":["1f1f2-1f1f9"],"fname":"1f1f2-1f1f9","uc":"1f1f2-1f1f9","isCanonical": false},":flag_ms:":{"unicode":["1f1f2-1f1f8"],"fname":"1f1f2-1f1f8","uc":"1f1f2-1f1f8","isCanonical": true},":ms:":{"unicode":["1f1f2-1f1f8"],"fname":"1f1f2-1f1f8","uc":"1f1f2-1f1f8","isCanonical": false},":flag_mr:":{"unicode":["1f1f2-1f1f7"],"fname":"1f1f2-1f1f7","uc":"1f1f2-1f1f7","isCanonical": true},":mr:":{"unicode":["1f1f2-1f1f7"],"fname":"1f1f2-1f1f7","uc":"1f1f2-1f1f7","isCanonical": false},":flag_mq:":{"unicode":["1f1f2-1f1f6"],"fname":"1f1f2-1f1f6","uc":"1f1f2-1f1f6","isCanonical": true},":mq:":{"unicode":["1f1f2-1f1f6"],"fname":"1f1f2-1f1f6","uc":"1f1f2-1f1f6","isCanonical": false},":flag_mp:":{"unicode":["1f1f2-1f1f5"],"fname":"1f1f2-1f1f5","uc":"1f1f2-1f1f5","isCanonical": true},":mp:":{"unicode":["1f1f2-1f1f5"],"fname":"1f1f2-1f1f5","uc":"1f1f2-1f1f5","isCanonical": false},":flag_mo:":{"unicode":["1f1f2-1f1f4"],"fname":"1f1f2-1f1f4","uc":"1f1f2-1f1f4","isCanonical": true},":mo:":{"unicode":["1f1f2-1f1f4"],"fname":"1f1f2-1f1f4","uc":"1f1f2-1f1f4","isCanonical": false},":flag_mn:":{"unicode":["1f1f2-1f1f3"],"fname":"1f1f2-1f1f3","uc":"1f1f2-1f1f3","isCanonical": true},":mn:":{"unicode":["1f1f2-1f1f3"],"fname":"1f1f2-1f1f3","uc":"1f1f2-1f1f3","isCanonical": false},":flag_mm:":{"unicode":["1f1f2-1f1f2"],"fname":"1f1f2-1f1f2","uc":"1f1f2-1f1f2","isCanonical": true},":mm:":{"unicode":["1f1f2-1f1f2"],"fname":"1f1f2-1f1f2","uc":"1f1f2-1f1f2","isCanonical": false},":flag_ml:":{"unicode":["1f1f2-1f1f1"],"fname":"1f1f2-1f1f1","uc":"1f1f2-1f1f1","isCanonical": true},":ml:":{"unicode":["1f1f2-1f1f1"],"fname":"1f1f2-1f1f1","uc":"1f1f2-1f1f1","isCanonical": false},":flag_mk:":{"unicode":["1f1f2-1f1f0"],"fname":"1f1f2-1f1f0","uc":"1f1f2-1f1f0","isCanonical": true},":mk:":{"unicode":["1f1f2-1f1f0"],"fname":"1f1f2-1f1f0","uc":"1f1f2-1f1f0","isCanonical": false},":flag_mh:":{"unicode":["1f1f2-1f1ed"],"fname":"1f1f2-1f1ed","uc":"1f1f2-1f1ed","isCanonical": true},":mh:":{"unicode":["1f1f2-1f1ed"],"fname":"1f1f2-1f1ed","uc":"1f1f2-1f1ed","isCanonical": false},":flag_mg:":{"unicode":["1f1f2-1f1ec"],"fname":"1f1f2-1f1ec","uc":"1f1f2-1f1ec","isCanonical": true},":mg:":{"unicode":["1f1f2-1f1ec"],"fname":"1f1f2-1f1ec","uc":"1f1f2-1f1ec","isCanonical": false},":flag_mf:":{"unicode":["1f1f2-1f1eb"],"fname":"1f1f2-1f1eb","uc":"1f1f2-1f1eb","isCanonical": true},":mf:":{"unicode":["1f1f2-1f1eb"],"fname":"1f1f2-1f1eb","uc":"1f1f2-1f1eb","isCanonical": false},":flag_me:":{"unicode":["1f1f2-1f1ea"],"fname":"1f1f2-1f1ea","uc":"1f1f2-1f1ea","isCanonical": true},":me:":{"unicode":["1f1f2-1f1ea"],"fname":"1f1f2-1f1ea","uc":"1f1f2-1f1ea","isCanonical": false},":flag_md:":{"unicode":["1f1f2-1f1e9"],"fname":"1f1f2-1f1e9","uc":"1f1f2-1f1e9","isCanonical": true},":md:":{"unicode":["1f1f2-1f1e9"],"fname":"1f1f2-1f1e9","uc":"1f1f2-1f1e9","isCanonical": false},":flag_mc:":{"unicode":["1f1f2-1f1e8"],"fname":"1f1f2-1f1e8","uc":"1f1f2-1f1e8","isCanonical": true},":mc:":{"unicode":["1f1f2-1f1e8"],"fname":"1f1f2-1f1e8","uc":"1f1f2-1f1e8","isCanonical": false},":flag_ma:":{"unicode":["1f1f2-1f1e6"],"fname":"1f1f2-1f1e6","uc":"1f1f2-1f1e6","isCanonical": true},":ma:":{"unicode":["1f1f2-1f1e6"],"fname":"1f1f2-1f1e6","uc":"1f1f2-1f1e6","isCanonical": false},":flag_ly:":{"unicode":["1f1f1-1f1fe"],"fname":"1f1f1-1f1fe","uc":"1f1f1-1f1fe","isCanonical": true},":ly:":{"unicode":["1f1f1-1f1fe"],"fname":"1f1f1-1f1fe","uc":"1f1f1-1f1fe","isCanonical": false},":flag_lv:":{"unicode":["1f1f1-1f1fb"],"fname":"1f1f1-1f1fb","uc":"1f1f1-1f1fb","isCanonical": true},":lv:":{"unicode":["1f1f1-1f1fb"],"fname":"1f1f1-1f1fb","uc":"1f1f1-1f1fb","isCanonical": false},":flag_lu:":{"unicode":["1f1f1-1f1fa"],"fname":"1f1f1-1f1fa","uc":"1f1f1-1f1fa","isCanonical": true},":lu:":{"unicode":["1f1f1-1f1fa"],"fname":"1f1f1-1f1fa","uc":"1f1f1-1f1fa","isCanonical": false},":flag_lt:":{"unicode":["1f1f1-1f1f9"],"fname":"1f1f1-1f1f9","uc":"1f1f1-1f1f9","isCanonical": true},":lt:":{"unicode":["1f1f1-1f1f9"],"fname":"1f1f1-1f1f9","uc":"1f1f1-1f1f9","isCanonical": false},":flag_ls:":{"unicode":["1f1f1-1f1f8"],"fname":"1f1f1-1f1f8","uc":"1f1f1-1f1f8","isCanonical": true},":ls:":{"unicode":["1f1f1-1f1f8"],"fname":"1f1f1-1f1f8","uc":"1f1f1-1f1f8","isCanonical": false},":flag_lr:":{"unicode":["1f1f1-1f1f7"],"fname":"1f1f1-1f1f7","uc":"1f1f1-1f1f7","isCanonical": true},":lr:":{"unicode":["1f1f1-1f1f7"],"fname":"1f1f1-1f1f7","uc":"1f1f1-1f1f7","isCanonical": false},":flag_lk:":{"unicode":["1f1f1-1f1f0"],"fname":"1f1f1-1f1f0","uc":"1f1f1-1f1f0","isCanonical": true},":lk:":{"unicode":["1f1f1-1f1f0"],"fname":"1f1f1-1f1f0","uc":"1f1f1-1f1f0","isCanonical": false},":flag_li:":{"unicode":["1f1f1-1f1ee"],"fname":"1f1f1-1f1ee","uc":"1f1f1-1f1ee","isCanonical": true},":li:":{"unicode":["1f1f1-1f1ee"],"fname":"1f1f1-1f1ee","uc":"1f1f1-1f1ee","isCanonical": false},":flag_lc:":{"unicode":["1f1f1-1f1e8"],"fname":"1f1f1-1f1e8","uc":"1f1f1-1f1e8","isCanonical": true},":lc:":{"unicode":["1f1f1-1f1e8"],"fname":"1f1f1-1f1e8","uc":"1f1f1-1f1e8","isCanonical": false},":flag_lb:":{"unicode":["1f1f1-1f1e7"],"fname":"1f1f1-1f1e7","uc":"1f1f1-1f1e7","isCanonical": true},":lb:":{"unicode":["1f1f1-1f1e7"],"fname":"1f1f1-1f1e7","uc":"1f1f1-1f1e7","isCanonical": false},":flag_la:":{"unicode":["1f1f1-1f1e6"],"fname":"1f1f1-1f1e6","uc":"1f1f1-1f1e6","isCanonical": true},":la:":{"unicode":["1f1f1-1f1e6"],"fname":"1f1f1-1f1e6","uc":"1f1f1-1f1e6","isCanonical": false},":flag_kz:":{"unicode":["1f1f0-1f1ff"],"fname":"1f1f0-1f1ff","uc":"1f1f0-1f1ff","isCanonical": true},":kz:":{"unicode":["1f1f0-1f1ff"],"fname":"1f1f0-1f1ff","uc":"1f1f0-1f1ff","isCanonical": false},":flag_ky:":{"unicode":["1f1f0-1f1fe"],"fname":"1f1f0-1f1fe","uc":"1f1f0-1f1fe","isCanonical": true},":ky:":{"unicode":["1f1f0-1f1fe"],"fname":"1f1f0-1f1fe","uc":"1f1f0-1f1fe","isCanonical": false},":flag_kw:":{"unicode":["1f1f0-1f1fc"],"fname":"1f1f0-1f1fc","uc":"1f1f0-1f1fc","isCanonical": true},":kw:":{"unicode":["1f1f0-1f1fc"],"fname":"1f1f0-1f1fc","uc":"1f1f0-1f1fc","isCanonical": false},":flag_kr:":{"unicode":["1f1f0-1f1f7"],"fname":"1f1f0-1f1f7","uc":"1f1f0-1f1f7","isCanonical": true},":kr:":{"unicode":["1f1f0-1f1f7"],"fname":"1f1f0-1f1f7","uc":"1f1f0-1f1f7","isCanonical": false},":flag_kp:":{"unicode":["1f1f0-1f1f5"],"fname":"1f1f0-1f1f5","uc":"1f1f0-1f1f5","isCanonical": true},":kp:":{"unicode":["1f1f0-1f1f5"],"fname":"1f1f0-1f1f5","uc":"1f1f0-1f1f5","isCanonical": false},":flag_kn:":{"unicode":["1f1f0-1f1f3"],"fname":"1f1f0-1f1f3","uc":"1f1f0-1f1f3","isCanonical": true},":kn:":{"unicode":["1f1f0-1f1f3"],"fname":"1f1f0-1f1f3","uc":"1f1f0-1f1f3","isCanonical": false},":flag_km:":{"unicode":["1f1f0-1f1f2"],"fname":"1f1f0-1f1f2","uc":"1f1f0-1f1f2","isCanonical": true},":km:":{"unicode":["1f1f0-1f1f2"],"fname":"1f1f0-1f1f2","uc":"1f1f0-1f1f2","isCanonical": false},":flag_ki:":{"unicode":["1f1f0-1f1ee"],"fname":"1f1f0-1f1ee","uc":"1f1f0-1f1ee","isCanonical": true},":ki:":{"unicode":["1f1f0-1f1ee"],"fname":"1f1f0-1f1ee","uc":"1f1f0-1f1ee","isCanonical": false},":flag_kh:":{"unicode":["1f1f0-1f1ed"],"fname":"1f1f0-1f1ed","uc":"1f1f0-1f1ed","isCanonical": true},":kh:":{"unicode":["1f1f0-1f1ed"],"fname":"1f1f0-1f1ed","uc":"1f1f0-1f1ed","isCanonical": false},":flag_kg:":{"unicode":["1f1f0-1f1ec"],"fname":"1f1f0-1f1ec","uc":"1f1f0-1f1ec","isCanonical": true},":kg:":{"unicode":["1f1f0-1f1ec"],"fname":"1f1f0-1f1ec","uc":"1f1f0-1f1ec","isCanonical": false},":flag_ke:":{"unicode":["1f1f0-1f1ea"],"fname":"1f1f0-1f1ea","uc":"1f1f0-1f1ea","isCanonical": true},":ke:":{"unicode":["1f1f0-1f1ea"],"fname":"1f1f0-1f1ea","uc":"1f1f0-1f1ea","isCanonical": false},":flag_jp:":{"unicode":["1f1ef-1f1f5"],"fname":"1f1ef-1f1f5","uc":"1f1ef-1f1f5","isCanonical": true},":jp:":{"unicode":["1f1ef-1f1f5"],"fname":"1f1ef-1f1f5","uc":"1f1ef-1f1f5","isCanonical": false},":flag_jo:":{"unicode":["1f1ef-1f1f4"],"fname":"1f1ef-1f1f4","uc":"1f1ef-1f1f4","isCanonical": true},":jo:":{"unicode":["1f1ef-1f1f4"],"fname":"1f1ef-1f1f4","uc":"1f1ef-1f1f4","isCanonical": false},":flag_jm:":{"unicode":["1f1ef-1f1f2"],"fname":"1f1ef-1f1f2","uc":"1f1ef-1f1f2","isCanonical": true},":jm:":{"unicode":["1f1ef-1f1f2"],"fname":"1f1ef-1f1f2","uc":"1f1ef-1f1f2","isCanonical": false},":flag_je:":{"unicode":["1f1ef-1f1ea"],"fname":"1f1ef-1f1ea","uc":"1f1ef-1f1ea","isCanonical": true},":je:":{"unicode":["1f1ef-1f1ea"],"fname":"1f1ef-1f1ea","uc":"1f1ef-1f1ea","isCanonical": false},":flag_it:":{"unicode":["1f1ee-1f1f9"],"fname":"1f1ee-1f1f9","uc":"1f1ee-1f1f9","isCanonical": true},":it:":{"unicode":["1f1ee-1f1f9"],"fname":"1f1ee-1f1f9","uc":"1f1ee-1f1f9","isCanonical": false},":flag_is:":{"unicode":["1f1ee-1f1f8"],"fname":"1f1ee-1f1f8","uc":"1f1ee-1f1f8","isCanonical": true},":is:":{"unicode":["1f1ee-1f1f8"],"fname":"1f1ee-1f1f8","uc":"1f1ee-1f1f8","isCanonical": false},":flag_ir:":{"unicode":["1f1ee-1f1f7"],"fname":"1f1ee-1f1f7","uc":"1f1ee-1f1f7","isCanonical": true},":ir:":{"unicode":["1f1ee-1f1f7"],"fname":"1f1ee-1f1f7","uc":"1f1ee-1f1f7","isCanonical": false},":flag_iq:":{"unicode":["1f1ee-1f1f6"],"fname":"1f1ee-1f1f6","uc":"1f1ee-1f1f6","isCanonical": true},":iq:":{"unicode":["1f1ee-1f1f6"],"fname":"1f1ee-1f1f6","uc":"1f1ee-1f1f6","isCanonical": false},":flag_io:":{"unicode":["1f1ee-1f1f4"],"fname":"1f1ee-1f1f4","uc":"1f1ee-1f1f4","isCanonical": true},":io:":{"unicode":["1f1ee-1f1f4"],"fname":"1f1ee-1f1f4","uc":"1f1ee-1f1f4","isCanonical": false},":flag_in:":{"unicode":["1f1ee-1f1f3"],"fname":"1f1ee-1f1f3","uc":"1f1ee-1f1f3","isCanonical": true},":in:":{"unicode":["1f1ee-1f1f3"],"fname":"1f1ee-1f1f3","uc":"1f1ee-1f1f3","isCanonical": false},":flag_im:":{"unicode":["1f1ee-1f1f2"],"fname":"1f1ee-1f1f2","uc":"1f1ee-1f1f2","isCanonical": true},":im:":{"unicode":["1f1ee-1f1f2"],"fname":"1f1ee-1f1f2","uc":"1f1ee-1f1f2","isCanonical": false},":flag_il:":{"unicode":["1f1ee-1f1f1"],"fname":"1f1ee-1f1f1","uc":"1f1ee-1f1f1","isCanonical": true},":il:":{"unicode":["1f1ee-1f1f1"],"fname":"1f1ee-1f1f1","uc":"1f1ee-1f1f1","isCanonical": false},":flag_ie:":{"unicode":["1f1ee-1f1ea"],"fname":"1f1ee-1f1ea","uc":"1f1ee-1f1ea","isCanonical": true},":ie:":{"unicode":["1f1ee-1f1ea"],"fname":"1f1ee-1f1ea","uc":"1f1ee-1f1ea","isCanonical": false},":flag_id:":{"unicode":["1f1ee-1f1e9"],"fname":"1f1ee-1f1e9","uc":"1f1ee-1f1e9","isCanonical": true},":indonesia:":{"unicode":["1f1ee-1f1e9"],"fname":"1f1ee-1f1e9","uc":"1f1ee-1f1e9","isCanonical": false},":flag_ic:":{"unicode":["1f1ee-1f1e8"],"fname":"1f1ee-1f1e8","uc":"1f1ee-1f1e8","isCanonical": true},":ic:":{"unicode":["1f1ee-1f1e8"],"fname":"1f1ee-1f1e8","uc":"1f1ee-1f1e8","isCanonical": false},":flag_hu:":{"unicode":["1f1ed-1f1fa"],"fname":"1f1ed-1f1fa","uc":"1f1ed-1f1fa","isCanonical": true},":hu:":{"unicode":["1f1ed-1f1fa"],"fname":"1f1ed-1f1fa","uc":"1f1ed-1f1fa","isCanonical": false},":flag_ht:":{"unicode":["1f1ed-1f1f9"],"fname":"1f1ed-1f1f9","uc":"1f1ed-1f1f9","isCanonical": true},":ht:":{"unicode":["1f1ed-1f1f9"],"fname":"1f1ed-1f1f9","uc":"1f1ed-1f1f9","isCanonical": false},":flag_hr:":{"unicode":["1f1ed-1f1f7"],"fname":"1f1ed-1f1f7","uc":"1f1ed-1f1f7","isCanonical": true},":hr:":{"unicode":["1f1ed-1f1f7"],"fname":"1f1ed-1f1f7","uc":"1f1ed-1f1f7","isCanonical": false},":flag_hn:":{"unicode":["1f1ed-1f1f3"],"fname":"1f1ed-1f1f3","uc":"1f1ed-1f1f3","isCanonical": true},":hn:":{"unicode":["1f1ed-1f1f3"],"fname":"1f1ed-1f1f3","uc":"1f1ed-1f1f3","isCanonical": false},":flag_hm:":{"unicode":["1f1ed-1f1f2"],"fname":"1f1ed-1f1f2","uc":"1f1ed-1f1f2","isCanonical": true},":hm:":{"unicode":["1f1ed-1f1f2"],"fname":"1f1ed-1f1f2","uc":"1f1ed-1f1f2","isCanonical": false},":flag_hk:":{"unicode":["1f1ed-1f1f0"],"fname":"1f1ed-1f1f0","uc":"1f1ed-1f1f0","isCanonical": true},":hk:":{"unicode":["1f1ed-1f1f0"],"fname":"1f1ed-1f1f0","uc":"1f1ed-1f1f0","isCanonical": false},":flag_gy:":{"unicode":["1f1ec-1f1fe"],"fname":"1f1ec-1f1fe","uc":"1f1ec-1f1fe","isCanonical": true},":gy:":{"unicode":["1f1ec-1f1fe"],"fname":"1f1ec-1f1fe","uc":"1f1ec-1f1fe","isCanonical": false},":flag_gw:":{"unicode":["1f1ec-1f1fc"],"fname":"1f1ec-1f1fc","uc":"1f1ec-1f1fc","isCanonical": true},":gw:":{"unicode":["1f1ec-1f1fc"],"fname":"1f1ec-1f1fc","uc":"1f1ec-1f1fc","isCanonical": false},":flag_gu:":{"unicode":["1f1ec-1f1fa"],"fname":"1f1ec-1f1fa","uc":"1f1ec-1f1fa","isCanonical": true},":gu:":{"unicode":["1f1ec-1f1fa"],"fname":"1f1ec-1f1fa","uc":"1f1ec-1f1fa","isCanonical": false},":flag_gt:":{"unicode":["1f1ec-1f1f9"],"fname":"1f1ec-1f1f9","uc":"1f1ec-1f1f9","isCanonical": true},":gt:":{"unicode":["1f1ec-1f1f9"],"fname":"1f1ec-1f1f9","uc":"1f1ec-1f1f9","isCanonical": false},":flag_gs:":{"unicode":["1f1ec-1f1f8"],"fname":"1f1ec-1f1f8","uc":"1f1ec-1f1f8","isCanonical": true},":gs:":{"unicode":["1f1ec-1f1f8"],"fname":"1f1ec-1f1f8","uc":"1f1ec-1f1f8","isCanonical": false},":flag_gr:":{"unicode":["1f1ec-1f1f7"],"fname":"1f1ec-1f1f7","uc":"1f1ec-1f1f7","isCanonical": true},":gr:":{"unicode":["1f1ec-1f1f7"],"fname":"1f1ec-1f1f7","uc":"1f1ec-1f1f7","isCanonical": false},":flag_gq:":{"unicode":["1f1ec-1f1f6"],"fname":"1f1ec-1f1f6","uc":"1f1ec-1f1f6","isCanonical": true},":gq:":{"unicode":["1f1ec-1f1f6"],"fname":"1f1ec-1f1f6","uc":"1f1ec-1f1f6","isCanonical": false},":flag_gp:":{"unicode":["1f1ec-1f1f5"],"fname":"1f1ec-1f1f5","uc":"1f1ec-1f1f5","isCanonical": true},":gp:":{"unicode":["1f1ec-1f1f5"],"fname":"1f1ec-1f1f5","uc":"1f1ec-1f1f5","isCanonical": false},":flag_gn:":{"unicode":["1f1ec-1f1f3"],"fname":"1f1ec-1f1f3","uc":"1f1ec-1f1f3","isCanonical": true},":gn:":{"unicode":["1f1ec-1f1f3"],"fname":"1f1ec-1f1f3","uc":"1f1ec-1f1f3","isCanonical": false},":flag_gm:":{"unicode":["1f1ec-1f1f2"],"fname":"1f1ec-1f1f2","uc":"1f1ec-1f1f2","isCanonical": true},":gm:":{"unicode":["1f1ec-1f1f2"],"fname":"1f1ec-1f1f2","uc":"1f1ec-1f1f2","isCanonical": false},":flag_gl:":{"unicode":["1f1ec-1f1f1"],"fname":"1f1ec-1f1f1","uc":"1f1ec-1f1f1","isCanonical": true},":gl:":{"unicode":["1f1ec-1f1f1"],"fname":"1f1ec-1f1f1","uc":"1f1ec-1f1f1","isCanonical": false},":flag_gi:":{"unicode":["1f1ec-1f1ee"],"fname":"1f1ec-1f1ee","uc":"1f1ec-1f1ee","isCanonical": true},":gi:":{"unicode":["1f1ec-1f1ee"],"fname":"1f1ec-1f1ee","uc":"1f1ec-1f1ee","isCanonical": false},":flag_gh:":{"unicode":["1f1ec-1f1ed"],"fname":"1f1ec-1f1ed","uc":"1f1ec-1f1ed","isCanonical": true},":gh:":{"unicode":["1f1ec-1f1ed"],"fname":"1f1ec-1f1ed","uc":"1f1ec-1f1ed","isCanonical": false},":flag_gg:":{"unicode":["1f1ec-1f1ec"],"fname":"1f1ec-1f1ec","uc":"1f1ec-1f1ec","isCanonical": true},":gg:":{"unicode":["1f1ec-1f1ec"],"fname":"1f1ec-1f1ec","uc":"1f1ec-1f1ec","isCanonical": false},":flag_gf:":{"unicode":["1f1ec-1f1eb"],"fname":"1f1ec-1f1eb","uc":"1f1ec-1f1eb","isCanonical": true},":gf:":{"unicode":["1f1ec-1f1eb"],"fname":"1f1ec-1f1eb","uc":"1f1ec-1f1eb","isCanonical": false},":flag_ge:":{"unicode":["1f1ec-1f1ea"],"fname":"1f1ec-1f1ea","uc":"1f1ec-1f1ea","isCanonical": true},":ge:":{"unicode":["1f1ec-1f1ea"],"fname":"1f1ec-1f1ea","uc":"1f1ec-1f1ea","isCanonical": false},":flag_gd:":{"unicode":["1f1ec-1f1e9"],"fname":"1f1ec-1f1e9","uc":"1f1ec-1f1e9","isCanonical": true},":gd:":{"unicode":["1f1ec-1f1e9"],"fname":"1f1ec-1f1e9","uc":"1f1ec-1f1e9","isCanonical": false},":flag_gb:":{"unicode":["1f1ec-1f1e7"],"fname":"1f1ec-1f1e7","uc":"1f1ec-1f1e7","isCanonical": true},":gb:":{"unicode":["1f1ec-1f1e7"],"fname":"1f1ec-1f1e7","uc":"1f1ec-1f1e7","isCanonical": false},":flag_ga:":{"unicode":["1f1ec-1f1e6"],"fname":"1f1ec-1f1e6","uc":"1f1ec-1f1e6","isCanonical": true},":ga:":{"unicode":["1f1ec-1f1e6"],"fname":"1f1ec-1f1e6","uc":"1f1ec-1f1e6","isCanonical": false},":flag_fr:":{"unicode":["1f1eb-1f1f7"],"fname":"1f1eb-1f1f7","uc":"1f1eb-1f1f7","isCanonical": true},":fr:":{"unicode":["1f1eb-1f1f7"],"fname":"1f1eb-1f1f7","uc":"1f1eb-1f1f7","isCanonical": false},":flag_fo:":{"unicode":["1f1eb-1f1f4"],"fname":"1f1eb-1f1f4","uc":"1f1eb-1f1f4","isCanonical": true},":fo:":{"unicode":["1f1eb-1f1f4"],"fname":"1f1eb-1f1f4","uc":"1f1eb-1f1f4","isCanonical": false},":flag_fm:":{"unicode":["1f1eb-1f1f2"],"fname":"1f1eb-1f1f2","uc":"1f1eb-1f1f2","isCanonical": true},":fm:":{"unicode":["1f1eb-1f1f2"],"fname":"1f1eb-1f1f2","uc":"1f1eb-1f1f2","isCanonical": false},":flag_fk:":{"unicode":["1f1eb-1f1f0"],"fname":"1f1eb-1f1f0","uc":"1f1eb-1f1f0","isCanonical": true},":fk:":{"unicode":["1f1eb-1f1f0"],"fname":"1f1eb-1f1f0","uc":"1f1eb-1f1f0","isCanonical": false},":flag_fj:":{"unicode":["1f1eb-1f1ef"],"fname":"1f1eb-1f1ef","uc":"1f1eb-1f1ef","isCanonical": true},":fj:":{"unicode":["1f1eb-1f1ef"],"fname":"1f1eb-1f1ef","uc":"1f1eb-1f1ef","isCanonical": false},":flag_fi:":{"unicode":["1f1eb-1f1ee"],"fname":"1f1eb-1f1ee","uc":"1f1eb-1f1ee","isCanonical": true},":fi:":{"unicode":["1f1eb-1f1ee"],"fname":"1f1eb-1f1ee","uc":"1f1eb-1f1ee","isCanonical": false},":flag_eu:":{"unicode":["1f1ea-1f1fa"],"fname":"1f1ea-1f1fa","uc":"1f1ea-1f1fa","isCanonical": true},":eu:":{"unicode":["1f1ea-1f1fa"],"fname":"1f1ea-1f1fa","uc":"1f1ea-1f1fa","isCanonical": false},":flag_et:":{"unicode":["1f1ea-1f1f9"],"fname":"1f1ea-1f1f9","uc":"1f1ea-1f1f9","isCanonical": true},":et:":{"unicode":["1f1ea-1f1f9"],"fname":"1f1ea-1f1f9","uc":"1f1ea-1f1f9","isCanonical": false},":flag_es:":{"unicode":["1f1ea-1f1f8"],"fname":"1f1ea-1f1f8","uc":"1f1ea-1f1f8","isCanonical": true},":es:":{"unicode":["1f1ea-1f1f8"],"fname":"1f1ea-1f1f8","uc":"1f1ea-1f1f8","isCanonical": false},":flag_er:":{"unicode":["1f1ea-1f1f7"],"fname":"1f1ea-1f1f7","uc":"1f1ea-1f1f7","isCanonical": true},":er:":{"unicode":["1f1ea-1f1f7"],"fname":"1f1ea-1f1f7","uc":"1f1ea-1f1f7","isCanonical": false},":flag_eh:":{"unicode":["1f1ea-1f1ed"],"fname":"1f1ea-1f1ed","uc":"1f1ea-1f1ed","isCanonical": true},":eh:":{"unicode":["1f1ea-1f1ed"],"fname":"1f1ea-1f1ed","uc":"1f1ea-1f1ed","isCanonical": false},":flag_eg:":{"unicode":["1f1ea-1f1ec"],"fname":"1f1ea-1f1ec","uc":"1f1ea-1f1ec","isCanonical": true},":eg:":{"unicode":["1f1ea-1f1ec"],"fname":"1f1ea-1f1ec","uc":"1f1ea-1f1ec","isCanonical": false},":flag_ee:":{"unicode":["1f1ea-1f1ea"],"fname":"1f1ea-1f1ea","uc":"1f1ea-1f1ea","isCanonical": true},":ee:":{"unicode":["1f1ea-1f1ea"],"fname":"1f1ea-1f1ea","uc":"1f1ea-1f1ea","isCanonical": false},":flag_ec:":{"unicode":["1f1ea-1f1e8"],"fname":"1f1ea-1f1e8","uc":"1f1ea-1f1e8","isCanonical": true},":ec:":{"unicode":["1f1ea-1f1e8"],"fname":"1f1ea-1f1e8","uc":"1f1ea-1f1e8","isCanonical": false},":flag_ea:":{"unicode":["1f1ea-1f1e6"],"fname":"1f1ea-1f1e6","uc":"1f1ea-1f1e6","isCanonical": true},":ea:":{"unicode":["1f1ea-1f1e6"],"fname":"1f1ea-1f1e6","uc":"1f1ea-1f1e6","isCanonical": false},":flag_dz:":{"unicode":["1f1e9-1f1ff"],"fname":"1f1e9-1f1ff","uc":"1f1e9-1f1ff","isCanonical": true},":dz:":{"unicode":["1f1e9-1f1ff"],"fname":"1f1e9-1f1ff","uc":"1f1e9-1f1ff","isCanonical": false},":flag_do:":{"unicode":["1f1e9-1f1f4"],"fname":"1f1e9-1f1f4","uc":"1f1e9-1f1f4","isCanonical": true},":do:":{"unicode":["1f1e9-1f1f4"],"fname":"1f1e9-1f1f4","uc":"1f1e9-1f1f4","isCanonical": false},":flag_dm:":{"unicode":["1f1e9-1f1f2"],"fname":"1f1e9-1f1f2","uc":"1f1e9-1f1f2","isCanonical": true},":dm:":{"unicode":["1f1e9-1f1f2"],"fname":"1f1e9-1f1f2","uc":"1f1e9-1f1f2","isCanonical": false},":flag_dk:":{"unicode":["1f1e9-1f1f0"],"fname":"1f1e9-1f1f0","uc":"1f1e9-1f1f0","isCanonical": true},":dk:":{"unicode":["1f1e9-1f1f0"],"fname":"1f1e9-1f1f0","uc":"1f1e9-1f1f0","isCanonical": false},":flag_dj:":{"unicode":["1f1e9-1f1ef"],"fname":"1f1e9-1f1ef","uc":"1f1e9-1f1ef","isCanonical": true},":dj:":{"unicode":["1f1e9-1f1ef"],"fname":"1f1e9-1f1ef","uc":"1f1e9-1f1ef","isCanonical": false},":flag_dg:":{"unicode":["1f1e9-1f1ec"],"fname":"1f1e9-1f1ec","uc":"1f1e9-1f1ec","isCanonical": true},":dg:":{"unicode":["1f1e9-1f1ec"],"fname":"1f1e9-1f1ec","uc":"1f1e9-1f1ec","isCanonical": false},":flag_de:":{"unicode":["1f1e9-1f1ea"],"fname":"1f1e9-1f1ea","uc":"1f1e9-1f1ea","isCanonical": true},":de:":{"unicode":["1f1e9-1f1ea"],"fname":"1f1e9-1f1ea","uc":"1f1e9-1f1ea","isCanonical": false},":flag_cz:":{"unicode":["1f1e8-1f1ff"],"fname":"1f1e8-1f1ff","uc":"1f1e8-1f1ff","isCanonical": true},":cz:":{"unicode":["1f1e8-1f1ff"],"fname":"1f1e8-1f1ff","uc":"1f1e8-1f1ff","isCanonical": false},":flag_cy:":{"unicode":["1f1e8-1f1fe"],"fname":"1f1e8-1f1fe","uc":"1f1e8-1f1fe","isCanonical": true},":cy:":{"unicode":["1f1e8-1f1fe"],"fname":"1f1e8-1f1fe","uc":"1f1e8-1f1fe","isCanonical": false},":flag_cx:":{"unicode":["1f1e8-1f1fd"],"fname":"1f1e8-1f1fd","uc":"1f1e8-1f1fd","isCanonical": true},":cx:":{"unicode":["1f1e8-1f1fd"],"fname":"1f1e8-1f1fd","uc":"1f1e8-1f1fd","isCanonical": false},":flag_cw:":{"unicode":["1f1e8-1f1fc"],"fname":"1f1e8-1f1fc","uc":"1f1e8-1f1fc","isCanonical": true},":cw:":{"unicode":["1f1e8-1f1fc"],"fname":"1f1e8-1f1fc","uc":"1f1e8-1f1fc","isCanonical": false},":flag_cv:":{"unicode":["1f1e8-1f1fb"],"fname":"1f1e8-1f1fb","uc":"1f1e8-1f1fb","isCanonical": true},":cv:":{"unicode":["1f1e8-1f1fb"],"fname":"1f1e8-1f1fb","uc":"1f1e8-1f1fb","isCanonical": false},":flag_cu:":{"unicode":["1f1e8-1f1fa"],"fname":"1f1e8-1f1fa","uc":"1f1e8-1f1fa","isCanonical": true},":cu:":{"unicode":["1f1e8-1f1fa"],"fname":"1f1e8-1f1fa","uc":"1f1e8-1f1fa","isCanonical": false},":flag_cr:":{"unicode":["1f1e8-1f1f7"],"fname":"1f1e8-1f1f7","uc":"1f1e8-1f1f7","isCanonical": true},":cr:":{"unicode":["1f1e8-1f1f7"],"fname":"1f1e8-1f1f7","uc":"1f1e8-1f1f7","isCanonical": false},":flag_cp:":{"unicode":["1f1e8-1f1f5"],"fname":"1f1e8-1f1f5","uc":"1f1e8-1f1f5","isCanonical": true},":cp:":{"unicode":["1f1e8-1f1f5"],"fname":"1f1e8-1f1f5","uc":"1f1e8-1f1f5","isCanonical": false},":flag_co:":{"unicode":["1f1e8-1f1f4"],"fname":"1f1e8-1f1f4","uc":"1f1e8-1f1f4","isCanonical": true},":co:":{"unicode":["1f1e8-1f1f4"],"fname":"1f1e8-1f1f4","uc":"1f1e8-1f1f4","isCanonical": false},":flag_cn:":{"unicode":["1f1e8-1f1f3"],"fname":"1f1e8-1f1f3","uc":"1f1e8-1f1f3","isCanonical": true},":cn:":{"unicode":["1f1e8-1f1f3"],"fname":"1f1e8-1f1f3","uc":"1f1e8-1f1f3","isCanonical": false},":flag_cm:":{"unicode":["1f1e8-1f1f2"],"fname":"1f1e8-1f1f2","uc":"1f1e8-1f1f2","isCanonical": true},":cm:":{"unicode":["1f1e8-1f1f2"],"fname":"1f1e8-1f1f2","uc":"1f1e8-1f1f2","isCanonical": false},":flag_cl:":{"unicode":["1f1e8-1f1f1"],"fname":"1f1e8-1f1f1","uc":"1f1e8-1f1f1","isCanonical": true},":chile:":{"unicode":["1f1e8-1f1f1"],"fname":"1f1e8-1f1f1","uc":"1f1e8-1f1f1","isCanonical": false},":flag_ck:":{"unicode":["1f1e8-1f1f0"],"fname":"1f1e8-1f1f0","uc":"1f1e8-1f1f0","isCanonical": true},":ck:":{"unicode":["1f1e8-1f1f0"],"fname":"1f1e8-1f1f0","uc":"1f1e8-1f1f0","isCanonical": false},":flag_ci:":{"unicode":["1f1e8-1f1ee"],"fname":"1f1e8-1f1ee","uc":"1f1e8-1f1ee","isCanonical": true},":ci:":{"unicode":["1f1e8-1f1ee"],"fname":"1f1e8-1f1ee","uc":"1f1e8-1f1ee","isCanonical": false},":flag_ch:":{"unicode":["1f1e8-1f1ed"],"fname":"1f1e8-1f1ed","uc":"1f1e8-1f1ed","isCanonical": true},":ch:":{"unicode":["1f1e8-1f1ed"],"fname":"1f1e8-1f1ed","uc":"1f1e8-1f1ed","isCanonical": false},":flag_cg:":{"unicode":["1f1e8-1f1ec"],"fname":"1f1e8-1f1ec","uc":"1f1e8-1f1ec","isCanonical": true},":cg:":{"unicode":["1f1e8-1f1ec"],"fname":"1f1e8-1f1ec","uc":"1f1e8-1f1ec","isCanonical": false},":flag_cf:":{"unicode":["1f1e8-1f1eb"],"fname":"1f1e8-1f1eb","uc":"1f1e8-1f1eb","isCanonical": true},":cf:":{"unicode":["1f1e8-1f1eb"],"fname":"1f1e8-1f1eb","uc":"1f1e8-1f1eb","isCanonical": false},":flag_cd:":{"unicode":["1f1e8-1f1e9"],"fname":"1f1e8-1f1e9","uc":"1f1e8-1f1e9","isCanonical": true},":congo:":{"unicode":["1f1e8-1f1e9"],"fname":"1f1e8-1f1e9","uc":"1f1e8-1f1e9","isCanonical": false},":flag_cc:":{"unicode":["1f1e8-1f1e8"],"fname":"1f1e8-1f1e8","uc":"1f1e8-1f1e8","isCanonical": true},":cc:":{"unicode":["1f1e8-1f1e8"],"fname":"1f1e8-1f1e8","uc":"1f1e8-1f1e8","isCanonical": false},":flag_ca:":{"unicode":["1f1e8-1f1e6"],"fname":"1f1e8-1f1e6","uc":"1f1e8-1f1e6","isCanonical": true},":ca:":{"unicode":["1f1e8-1f1e6"],"fname":"1f1e8-1f1e6","uc":"1f1e8-1f1e6","isCanonical": false},":flag_bz:":{"unicode":["1f1e7-1f1ff"],"fname":"1f1e7-1f1ff","uc":"1f1e7-1f1ff","isCanonical": true},":bz:":{"unicode":["1f1e7-1f1ff"],"fname":"1f1e7-1f1ff","uc":"1f1e7-1f1ff","isCanonical": false},":flag_by:":{"unicode":["1f1e7-1f1fe"],"fname":"1f1e7-1f1fe","uc":"1f1e7-1f1fe","isCanonical": true},":by:":{"unicode":["1f1e7-1f1fe"],"fname":"1f1e7-1f1fe","uc":"1f1e7-1f1fe","isCanonical": false},":flag_bw:":{"unicode":["1f1e7-1f1fc"],"fname":"1f1e7-1f1fc","uc":"1f1e7-1f1fc","isCanonical": true},":bw:":{"unicode":["1f1e7-1f1fc"],"fname":"1f1e7-1f1fc","uc":"1f1e7-1f1fc","isCanonical": false},":flag_bv:":{"unicode":["1f1e7-1f1fb"],"fname":"1f1e7-1f1fb","uc":"1f1e7-1f1fb","isCanonical": true},":bv:":{"unicode":["1f1e7-1f1fb"],"fname":"1f1e7-1f1fb","uc":"1f1e7-1f1fb","isCanonical": false},":flag_bt:":{"unicode":["1f1e7-1f1f9"],"fname":"1f1e7-1f1f9","uc":"1f1e7-1f1f9","isCanonical": true},":bt:":{"unicode":["1f1e7-1f1f9"],"fname":"1f1e7-1f1f9","uc":"1f1e7-1f1f9","isCanonical": false},":flag_bs:":{"unicode":["1f1e7-1f1f8"],"fname":"1f1e7-1f1f8","uc":"1f1e7-1f1f8","isCanonical": true},":bs:":{"unicode":["1f1e7-1f1f8"],"fname":"1f1e7-1f1f8","uc":"1f1e7-1f1f8","isCanonical": false},":flag_br:":{"unicode":["1f1e7-1f1f7"],"fname":"1f1e7-1f1f7","uc":"1f1e7-1f1f7","isCanonical": true},":br:":{"unicode":["1f1e7-1f1f7"],"fname":"1f1e7-1f1f7","uc":"1f1e7-1f1f7","isCanonical": false},":flag_bq:":{"unicode":["1f1e7-1f1f6"],"fname":"1f1e7-1f1f6","uc":"1f1e7-1f1f6","isCanonical": true},":bq:":{"unicode":["1f1e7-1f1f6"],"fname":"1f1e7-1f1f6","uc":"1f1e7-1f1f6","isCanonical": false},":flag_bo:":{"unicode":["1f1e7-1f1f4"],"fname":"1f1e7-1f1f4","uc":"1f1e7-1f1f4","isCanonical": true},":bo:":{"unicode":["1f1e7-1f1f4"],"fname":"1f1e7-1f1f4","uc":"1f1e7-1f1f4","isCanonical": false},":flag_bn:":{"unicode":["1f1e7-1f1f3"],"fname":"1f1e7-1f1f3","uc":"1f1e7-1f1f3","isCanonical": true},":bn:":{"unicode":["1f1e7-1f1f3"],"fname":"1f1e7-1f1f3","uc":"1f1e7-1f1f3","isCanonical": false},":flag_bm:":{"unicode":["1f1e7-1f1f2"],"fname":"1f1e7-1f1f2","uc":"1f1e7-1f1f2","isCanonical": true},":bm:":{"unicode":["1f1e7-1f1f2"],"fname":"1f1e7-1f1f2","uc":"1f1e7-1f1f2","isCanonical": false},":flag_bl:":{"unicode":["1f1e7-1f1f1"],"fname":"1f1e7-1f1f1","uc":"1f1e7-1f1f1","isCanonical": true},":bl:":{"unicode":["1f1e7-1f1f1"],"fname":"1f1e7-1f1f1","uc":"1f1e7-1f1f1","isCanonical": false},":flag_bj:":{"unicode":["1f1e7-1f1ef"],"fname":"1f1e7-1f1ef","uc":"1f1e7-1f1ef","isCanonical": true},":bj:":{"unicode":["1f1e7-1f1ef"],"fname":"1f1e7-1f1ef","uc":"1f1e7-1f1ef","isCanonical": false},":flag_bi:":{"unicode":["1f1e7-1f1ee"],"fname":"1f1e7-1f1ee","uc":"1f1e7-1f1ee","isCanonical": true},":bi:":{"unicode":["1f1e7-1f1ee"],"fname":"1f1e7-1f1ee","uc":"1f1e7-1f1ee","isCanonical": false},":flag_bh:":{"unicode":["1f1e7-1f1ed"],"fname":"1f1e7-1f1ed","uc":"1f1e7-1f1ed","isCanonical": true},":bh:":{"unicode":["1f1e7-1f1ed"],"fname":"1f1e7-1f1ed","uc":"1f1e7-1f1ed","isCanonical": false},":flag_bg:":{"unicode":["1f1e7-1f1ec"],"fname":"1f1e7-1f1ec","uc":"1f1e7-1f1ec","isCanonical": true},":bg:":{"unicode":["1f1e7-1f1ec"],"fname":"1f1e7-1f1ec","uc":"1f1e7-1f1ec","isCanonical": false},":flag_bf:":{"unicode":["1f1e7-1f1eb"],"fname":"1f1e7-1f1eb","uc":"1f1e7-1f1eb","isCanonical": true},":bf:":{"unicode":["1f1e7-1f1eb"],"fname":"1f1e7-1f1eb","uc":"1f1e7-1f1eb","isCanonical": false},":flag_be:":{"unicode":["1f1e7-1f1ea"],"fname":"1f1e7-1f1ea","uc":"1f1e7-1f1ea","isCanonical": true},":be:":{"unicode":["1f1e7-1f1ea"],"fname":"1f1e7-1f1ea","uc":"1f1e7-1f1ea","isCanonical": false},":flag_bd:":{"unicode":["1f1e7-1f1e9"],"fname":"1f1e7-1f1e9","uc":"1f1e7-1f1e9","isCanonical": true},":bd:":{"unicode":["1f1e7-1f1e9"],"fname":"1f1e7-1f1e9","uc":"1f1e7-1f1e9","isCanonical": false},":flag_bb:":{"unicode":["1f1e7-1f1e7"],"fname":"1f1e7-1f1e7","uc":"1f1e7-1f1e7","isCanonical": true},":bb:":{"unicode":["1f1e7-1f1e7"],"fname":"1f1e7-1f1e7","uc":"1f1e7-1f1e7","isCanonical": false},":flag_ba:":{"unicode":["1f1e7-1f1e6"],"fname":"1f1e7-1f1e6","uc":"1f1e7-1f1e6","isCanonical": true},":ba:":{"unicode":["1f1e7-1f1e6"],"fname":"1f1e7-1f1e6","uc":"1f1e7-1f1e6","isCanonical": false},":flag_az:":{"unicode":["1f1e6-1f1ff"],"fname":"1f1e6-1f1ff","uc":"1f1e6-1f1ff","isCanonical": true},":az:":{"unicode":["1f1e6-1f1ff"],"fname":"1f1e6-1f1ff","uc":"1f1e6-1f1ff","isCanonical": false},":flag_ax:":{"unicode":["1f1e6-1f1fd"],"fname":"1f1e6-1f1fd","uc":"1f1e6-1f1fd","isCanonical": true},":ax:":{"unicode":["1f1e6-1f1fd"],"fname":"1f1e6-1f1fd","uc":"1f1e6-1f1fd","isCanonical": false},":flag_aw:":{"unicode":["1f1e6-1f1fc"],"fname":"1f1e6-1f1fc","uc":"1f1e6-1f1fc","isCanonical": true},":aw:":{"unicode":["1f1e6-1f1fc"],"fname":"1f1e6-1f1fc","uc":"1f1e6-1f1fc","isCanonical": false},":flag_au:":{"unicode":["1f1e6-1f1fa"],"fname":"1f1e6-1f1fa","uc":"1f1e6-1f1fa","isCanonical": true},":au:":{"unicode":["1f1e6-1f1fa"],"fname":"1f1e6-1f1fa","uc":"1f1e6-1f1fa","isCanonical": false},":flag_at:":{"unicode":["1f1e6-1f1f9"],"fname":"1f1e6-1f1f9","uc":"1f1e6-1f1f9","isCanonical": true},":at:":{"unicode":["1f1e6-1f1f9"],"fname":"1f1e6-1f1f9","uc":"1f1e6-1f1f9","isCanonical": false},":flag_as:":{"unicode":["1f1e6-1f1f8"],"fname":"1f1e6-1f1f8","uc":"1f1e6-1f1f8","isCanonical": true},":as:":{"unicode":["1f1e6-1f1f8"],"fname":"1f1e6-1f1f8","uc":"1f1e6-1f1f8","isCanonical": false},":flag_ar:":{"unicode":["1f1e6-1f1f7"],"fname":"1f1e6-1f1f7","uc":"1f1e6-1f1f7","isCanonical": true},":ar:":{"unicode":["1f1e6-1f1f7"],"fname":"1f1e6-1f1f7","uc":"1f1e6-1f1f7","isCanonical": false},":flag_aq:":{"unicode":["1f1e6-1f1f6"],"fname":"1f1e6-1f1f6","uc":"1f1e6-1f1f6","isCanonical": true},":aq:":{"unicode":["1f1e6-1f1f6"],"fname":"1f1e6-1f1f6","uc":"1f1e6-1f1f6","isCanonical": false},":flag_ao:":{"unicode":["1f1e6-1f1f4"],"fname":"1f1e6-1f1f4","uc":"1f1e6-1f1f4","isCanonical": true},":ao:":{"unicode":["1f1e6-1f1f4"],"fname":"1f1e6-1f1f4","uc":"1f1e6-1f1f4","isCanonical": false},":flag_am:":{"unicode":["1f1e6-1f1f2"],"fname":"1f1e6-1f1f2","uc":"1f1e6-1f1f2","isCanonical": true},":am:":{"unicode":["1f1e6-1f1f2"],"fname":"1f1e6-1f1f2","uc":"1f1e6-1f1f2","isCanonical": false},":flag_al:":{"unicode":["1f1e6-1f1f1"],"fname":"1f1e6-1f1f1","uc":"1f1e6-1f1f1","isCanonical": true},":al:":{"unicode":["1f1e6-1f1f1"],"fname":"1f1e6-1f1f1","uc":"1f1e6-1f1f1","isCanonical": false},":flag_ai:":{"unicode":["1f1e6-1f1ee"],"fname":"1f1e6-1f1ee","uc":"1f1e6-1f1ee","isCanonical": true},":ai:":{"unicode":["1f1e6-1f1ee"],"fname":"1f1e6-1f1ee","uc":"1f1e6-1f1ee","isCanonical": false},":flag_ag:":{"unicode":["1f1e6-1f1ec"],"fname":"1f1e6-1f1ec","uc":"1f1e6-1f1ec","isCanonical": true},":ag:":{"unicode":["1f1e6-1f1ec"],"fname":"1f1e6-1f1ec","uc":"1f1e6-1f1ec","isCanonical": false},":flag_af:":{"unicode":["1f1e6-1f1eb"],"fname":"1f1e6-1f1eb","uc":"1f1e6-1f1eb","isCanonical": true},":af:":{"unicode":["1f1e6-1f1eb"],"fname":"1f1e6-1f1eb","uc":"1f1e6-1f1eb","isCanonical": false},":flag_ae:":{"unicode":["1f1e6-1f1ea"],"fname":"1f1e6-1f1ea","uc":"1f1e6-1f1ea","isCanonical": true},":ae:":{"unicode":["1f1e6-1f1ea"],"fname":"1f1e6-1f1ea","uc":"1f1e6-1f1ea","isCanonical": false},":flag_ad:":{"unicode":["1f1e6-1f1e9"],"fname":"1f1e6-1f1e9","uc":"1f1e6-1f1e9","isCanonical": true},":ad:":{"unicode":["1f1e6-1f1e9"],"fname":"1f1e6-1f1e9","uc":"1f1e6-1f1e9","isCanonical": false},":flag_ac:":{"unicode":["1f1e6-1f1e8"],"fname":"1f1e6-1f1e8","uc":"1f1e6-1f1e8","isCanonical": true},":ac:":{"unicode":["1f1e6-1f1e8"],"fname":"1f1e6-1f1e8","uc":"1f1e6-1f1e8","isCanonical": false},":mahjong:":{"unicode":["1f004-fe0f","1f004"],"fname":"1f004","uc":"1f004","isCanonical": true},":parking:":{"unicode":["1f17f-fe0f","1f17f"],"fname":"1f17f","uc":"1f17f","isCanonical": true},":sa:":{"unicode":["1f202-fe0f","1f202"],"fname":"1f202","uc":"1f202","isCanonical": true},":u7121:":{"unicode":["1f21a-fe0f","1f21a"],"fname":"1f21a","uc":"1f21a","isCanonical": true},":u6307:":{"unicode":["1f22f-fe0f","1f22f"],"fname":"1f22f","uc":"1f22f","isCanonical": true},":u6708:":{"unicode":["1f237-fe0f","1f237"],"fname":"1f237","uc":"1f237","isCanonical": true},":film_frames:":{"unicode":["1f39e-fe0f","1f39e"],"fname":"1f39e","uc":"1f39e","isCanonical": true},":tickets:":{"unicode":["1f39f-fe0f","1f39f"],"fname":"1f39f","uc":"1f39f","isCanonical": true},":admission_tickets:":{"unicode":["1f39f-fe0f","1f39f"],"fname":"1f39f","uc":"1f39f","isCanonical": false},":lifter:":{"unicode":["1f3cb-fe0f","1f3cb"],"fname":"1f3cb","uc":"1f3cb","isCanonical": true},":weight_lifter:":{"unicode":["1f3cb-fe0f","1f3cb"],"fname":"1f3cb","uc":"1f3cb","isCanonical": false},":golfer:":{"unicode":["1f3cc-fe0f","1f3cc"],"fname":"1f3cc","uc":"1f3cc","isCanonical": true},":motorcycle:":{"unicode":["1f3cd-fe0f","1f3cd"],"fname":"1f3cd","uc":"1f3cd","isCanonical": true},":racing_motorcycle:":{"unicode":["1f3cd-fe0f","1f3cd"],"fname":"1f3cd","uc":"1f3cd","isCanonical": false},":race_car:":{"unicode":["1f3ce-fe0f","1f3ce"],"fname":"1f3ce","uc":"1f3ce","isCanonical": true},":racing_car:":{"unicode":["1f3ce-fe0f","1f3ce"],"fname":"1f3ce","uc":"1f3ce","isCanonical": false},":military_medal:":{"unicode":["1f396-fe0f","1f396"],"fname":"1f396","uc":"1f396","isCanonical": true},":reminder_ribbon:":{"unicode":["1f397-fe0f","1f397"],"fname":"1f397","uc":"1f397","isCanonical": true},":hot_pepper:":{"unicode":["1f336-fe0f","1f336"],"fname":"1f336","uc":"1f336","isCanonical": true},":cloud_rain:":{"unicode":["1f327-fe0f","1f327"],"fname":"1f327","uc":"1f327","isCanonical": true},":cloud_with_rain:":{"unicode":["1f327-fe0f","1f327"],"fname":"1f327","uc":"1f327","isCanonical": false},":cloud_snow:":{"unicode":["1f328-fe0f","1f328"],"fname":"1f328","uc":"1f328","isCanonical": true},":cloud_with_snow:":{"unicode":["1f328-fe0f","1f328"],"fname":"1f328","uc":"1f328","isCanonical": false},":cloud_lightning:":{"unicode":["1f329-fe0f","1f329"],"fname":"1f329","uc":"1f329","isCanonical": true},":cloud_with_lightning:":{"unicode":["1f329-fe0f","1f329"],"fname":"1f329","uc":"1f329","isCanonical": false},":cloud_tornado:":{"unicode":["1f32a-fe0f","1f32a"],"fname":"1f32a","uc":"1f32a","isCanonical": true},":cloud_with_tornado:":{"unicode":["1f32a-fe0f","1f32a"],"fname":"1f32a","uc":"1f32a","isCanonical": false},":fog:":{"unicode":["1f32b-fe0f","1f32b"],"fname":"1f32b","uc":"1f32b","isCanonical": true},":wind_blowing_face:":{"unicode":["1f32c-fe0f","1f32c"],"fname":"1f32c","uc":"1f32c","isCanonical": true},":chipmunk:":{"unicode":["1f43f-fe0f","1f43f"],"fname":"1f43f","uc":"1f43f","isCanonical": true},":spider:":{"unicode":["1f577-fe0f","1f577"],"fname":"1f577","uc":"1f577","isCanonical": true},":spider_web:":{"unicode":["1f578-fe0f","1f578"],"fname":"1f578","uc":"1f578","isCanonical": true},":thermometer:":{"unicode":["1f321-fe0f","1f321"],"fname":"1f321","uc":"1f321","isCanonical": true},":microphone2:":{"unicode":["1f399-fe0f","1f399"],"fname":"1f399","uc":"1f399","isCanonical": true},":studio_microphone:":{"unicode":["1f399-fe0f","1f399"],"fname":"1f399","uc":"1f399","isCanonical": false},":level_slider:":{"unicode":["1f39a-fe0f","1f39a"],"fname":"1f39a","uc":"1f39a","isCanonical": true},":control_knobs:":{"unicode":["1f39b-fe0f","1f39b"],"fname":"1f39b","uc":"1f39b","isCanonical": true},":flag_white:":{"unicode":["1f3f3-fe0f","1f3f3"],"fname":"1f3f3","uc":"1f3f3","isCanonical": true},":waving_white_flag:":{"unicode":["1f3f3-fe0f","1f3f3"],"fname":"1f3f3","uc":"1f3f3","isCanonical": false},":rosette:":{"unicode":["1f3f5-fe0f","1f3f5"],"fname":"1f3f5","uc":"1f3f5","isCanonical": true},":label:":{"unicode":["1f3f7-fe0f","1f3f7"],"fname":"1f3f7","uc":"1f3f7","isCanonical": true},":projector:":{"unicode":["1f4fd-fe0f","1f4fd"],"fname":"1f4fd","uc":"1f4fd","isCanonical": true},":film_projector:":{"unicode":["1f4fd-fe0f","1f4fd"],"fname":"1f4fd","uc":"1f4fd","isCanonical": false},":om_symbol:":{"unicode":["1f549-fe0f","1f549"],"fname":"1f549","uc":"1f549","isCanonical": true},":dove:":{"unicode":["1f54a-fe0f","1f54a"],"fname":"1f54a","uc":"1f54a","isCanonical": true},":dove_of_peace:":{"unicode":["1f54a-fe0f","1f54a"],"fname":"1f54a","uc":"1f54a","isCanonical": false},":candle:":{"unicode":["1f56f-fe0f","1f56f"],"fname":"1f56f","uc":"1f56f","isCanonical": true},":clock:":{"unicode":["1f570-fe0f","1f570"],"fname":"1f570","uc":"1f570","isCanonical": true},":mantlepiece_clock:":{"unicode":["1f570-fe0f","1f570"],"fname":"1f570","uc":"1f570","isCanonical": false},":hole:":{"unicode":["1f573-fe0f","1f573"],"fname":"1f573","uc":"1f573","isCanonical": true},":dark_sunglasses:":{"unicode":["1f576-fe0f","1f576"],"fname":"1f576","uc":"1f576","isCanonical": true},":joystick:":{"unicode":["1f579-fe0f","1f579"],"fname":"1f579","uc":"1f579","isCanonical": true},":paperclips:":{"unicode":["1f587-fe0f","1f587"],"fname":"1f587","uc":"1f587","isCanonical": true},":linked_paperclips:":{"unicode":["1f587-fe0f","1f587"],"fname":"1f587","uc":"1f587","isCanonical": false},":pen_ballpoint:":{"unicode":["1f58a-fe0f","1f58a"],"fname":"1f58a","uc":"1f58a","isCanonical": true},":lower_left_ballpoint_pen:":{"unicode":["1f58a-fe0f","1f58a"],"fname":"1f58a","uc":"1f58a","isCanonical": false},":pen_fountain:":{"unicode":["1f58b-fe0f","1f58b"],"fname":"1f58b","uc":"1f58b","isCanonical": true},":lower_left_fountain_pen:":{"unicode":["1f58b-fe0f","1f58b"],"fname":"1f58b","uc":"1f58b","isCanonical": false},":paintbrush:":{"unicode":["1f58c-fe0f","1f58c"],"fname":"1f58c","uc":"1f58c","isCanonical": true},":lower_left_paintbrush:":{"unicode":["1f58c-fe0f","1f58c"],"fname":"1f58c","uc":"1f58c","isCanonical": false},":crayon:":{"unicode":["1f58d-fe0f","1f58d"],"fname":"1f58d","uc":"1f58d","isCanonical": true},":lower_left_crayon:":{"unicode":["1f58d-fe0f","1f58d"],"fname":"1f58d","uc":"1f58d","isCanonical": false},":desktop:":{"unicode":["1f5a5-fe0f","1f5a5"],"fname":"1f5a5","uc":"1f5a5","isCanonical": true},":desktop_computer:":{"unicode":["1f5a5-fe0f","1f5a5"],"fname":"1f5a5","uc":"1f5a5","isCanonical": false},":printer:":{"unicode":["1f5a8-fe0f","1f5a8"],"fname":"1f5a8","uc":"1f5a8","isCanonical": true},":trackball:":{"unicode":["1f5b2-fe0f","1f5b2"],"fname":"1f5b2","uc":"1f5b2","isCanonical": true},":frame_photo:":{"unicode":["1f5bc-fe0f","1f5bc"],"fname":"1f5bc","uc":"1f5bc","isCanonical": true},":frame_with_picture:":{"unicode":["1f5bc-fe0f","1f5bc"],"fname":"1f5bc","uc":"1f5bc","isCanonical": false},":dividers:":{"unicode":["1f5c2-fe0f","1f5c2"],"fname":"1f5c2","uc":"1f5c2","isCanonical": true},":card_index_dividers:":{"unicode":["1f5c2-fe0f","1f5c2"],"fname":"1f5c2","uc":"1f5c2","isCanonical": false},":card_box:":{"unicode":["1f5c3-fe0f","1f5c3"],"fname":"1f5c3","uc":"1f5c3","isCanonical": true},":card_file_box:":{"unicode":["1f5c3-fe0f","1f5c3"],"fname":"1f5c3","uc":"1f5c3","isCanonical": false},":file_cabinet:":{"unicode":["1f5c4-fe0f","1f5c4"],"fname":"1f5c4","uc":"1f5c4","isCanonical": true},":wastebasket:":{"unicode":["1f5d1-fe0f","1f5d1"],"fname":"1f5d1","uc":"1f5d1","isCanonical": true},":notepad_spiral:":{"unicode":["1f5d2-fe0f","1f5d2"],"fname":"1f5d2","uc":"1f5d2","isCanonical": true},":spiral_note_pad:":{"unicode":["1f5d2-fe0f","1f5d2"],"fname":"1f5d2","uc":"1f5d2","isCanonical": false},":calendar_spiral:":{"unicode":["1f5d3-fe0f","1f5d3"],"fname":"1f5d3","uc":"1f5d3","isCanonical": true},":spiral_calendar_pad:":{"unicode":["1f5d3-fe0f","1f5d3"],"fname":"1f5d3","uc":"1f5d3","isCanonical": false},":compression:":{"unicode":["1f5dc-fe0f","1f5dc"],"fname":"1f5dc","uc":"1f5dc","isCanonical": true},":key2:":{"unicode":["1f5dd-fe0f","1f5dd"],"fname":"1f5dd","uc":"1f5dd","isCanonical": true},":old_key:":{"unicode":["1f5dd-fe0f","1f5dd"],"fname":"1f5dd","uc":"1f5dd","isCanonical": false},":newspaper2:":{"unicode":["1f5de-fe0f","1f5de"],"fname":"1f5de","uc":"1f5de","isCanonical": true},":rolled_up_newspaper:":{"unicode":["1f5de-fe0f","1f5de"],"fname":"1f5de","uc":"1f5de","isCanonical": false},":dagger:":{"unicode":["1f5e1-fe0f","1f5e1"],"fname":"1f5e1","uc":"1f5e1","isCanonical": true},":dagger_knife:":{"unicode":["1f5e1-fe0f","1f5e1"],"fname":"1f5e1","uc":"1f5e1","isCanonical": false},":speaking_head:":{"unicode":["1f5e3-fe0f","1f5e3"],"fname":"1f5e3","uc":"1f5e3","isCanonical": true},":speaking_head_in_silhouette:":{"unicode":["1f5e3-fe0f","1f5e3"],"fname":"1f5e3","uc":"1f5e3","isCanonical": false},":speech_left:":{"unicode":["1f5e8-fe0f","1f5e8"],"fname":"1f5e8","uc":"1f5e8","isCanonical": true},":left_speech_bubble:":{"unicode":["1f5e8-fe0f","1f5e8"],"fname":"1f5e8","uc":"1f5e8","isCanonical": false},":anger_right:":{"unicode":["1f5ef-fe0f","1f5ef"],"fname":"1f5ef","uc":"1f5ef","isCanonical": true},":right_anger_bubble:":{"unicode":["1f5ef-fe0f","1f5ef"],"fname":"1f5ef","uc":"1f5ef","isCanonical": false},":ballot_box:":{"unicode":["1f5f3-fe0f","1f5f3"],"fname":"1f5f3","uc":"1f5f3","isCanonical": true},":ballot_box_with_ballot:":{"unicode":["1f5f3-fe0f","1f5f3"],"fname":"1f5f3","uc":"1f5f3","isCanonical": false},":map:":{"unicode":["1f5fa-fe0f","1f5fa"],"fname":"1f5fa","uc":"1f5fa","isCanonical": true},":world_map:":{"unicode":["1f5fa-fe0f","1f5fa"],"fname":"1f5fa","uc":"1f5fa","isCanonical": false},":tools:":{"unicode":["1f6e0-fe0f","1f6e0"],"fname":"1f6e0","uc":"1f6e0","isCanonical": true},":hammer_and_wrench:":{"unicode":["1f6e0-fe0f","1f6e0"],"fname":"1f6e0","uc":"1f6e0","isCanonical": false},":shield:":{"unicode":["1f6e1-fe0f","1f6e1"],"fname":"1f6e1","uc":"1f6e1","isCanonical": true},":oil:":{"unicode":["1f6e2-fe0f","1f6e2"],"fname":"1f6e2","uc":"1f6e2","isCanonical": true},":oil_drum:":{"unicode":["1f6e2-fe0f","1f6e2"],"fname":"1f6e2","uc":"1f6e2","isCanonical": false},":satellite_orbital:":{"unicode":["1f6f0-fe0f","1f6f0"],"fname":"1f6f0","uc":"1f6f0","isCanonical": true},":fork_knife_plate:":{"unicode":["1f37d-fe0f","1f37d"],"fname":"1f37d","uc":"1f37d","isCanonical": true},":fork_and_knife_with_plate:":{"unicode":["1f37d-fe0f","1f37d"],"fname":"1f37d","uc":"1f37d","isCanonical": false},":eye:":{"unicode":["1f441-fe0f","1f441"],"fname":"1f441","uc":"1f441","isCanonical": true},":levitate:":{"unicode":["1f574-fe0f","1f574"],"fname":"1f574","uc":"1f574","isCanonical": true},":man_in_business_suit_levitating:":{"unicode":["1f574-fe0f","1f574"],"fname":"1f574","uc":"1f574","isCanonical": false},":spy:":{"unicode":["1f575-fe0f","1f575"],"fname":"1f575","uc":"1f575","isCanonical": true},":sleuth_or_spy:":{"unicode":["1f575-fe0f","1f575"],"fname":"1f575","uc":"1f575","isCanonical": false},":hand_splayed:":{"unicode":["1f590-fe0f","1f590"],"fname":"1f590","uc":"1f590","isCanonical": true},":raised_hand_with_fingers_splayed:":{"unicode":["1f590-fe0f","1f590"],"fname":"1f590","uc":"1f590","isCanonical": false},":mountain_snow:":{"unicode":["1f3d4-fe0f","1f3d4"],"fname":"1f3d4","uc":"1f3d4","isCanonical": true},":snow_capped_mountain:":{"unicode":["1f3d4-fe0f","1f3d4"],"fname":"1f3d4","uc":"1f3d4","isCanonical": false},":camping:":{"unicode":["1f3d5-fe0f","1f3d5"],"fname":"1f3d5","uc":"1f3d5","isCanonical": true},":beach:":{"unicode":["1f3d6-fe0f","1f3d6"],"fname":"1f3d6","uc":"1f3d6","isCanonical": true},":beach_with_umbrella:":{"unicode":["1f3d6-fe0f","1f3d6"],"fname":"1f3d6","uc":"1f3d6","isCanonical": false},":construction_site:":{"unicode":["1f3d7-fe0f","1f3d7"],"fname":"1f3d7","uc":"1f3d7","isCanonical": true},":building_construction:":{"unicode":["1f3d7-fe0f","1f3d7"],"fname":"1f3d7","uc":"1f3d7","isCanonical": false},":homes:":{"unicode":["1f3d8-fe0f","1f3d8"],"fname":"1f3d8","uc":"1f3d8","isCanonical": true},":house_buildings:":{"unicode":["1f3d8-fe0f","1f3d8"],"fname":"1f3d8","uc":"1f3d8","isCanonical": false},":cityscape:":{"unicode":["1f3d9-fe0f","1f3d9"],"fname":"1f3d9","uc":"1f3d9","isCanonical": true},":house_abandoned:":{"unicode":["1f3da-fe0f","1f3da"],"fname":"1f3da","uc":"1f3da","isCanonical": true},":derelict_house_building:":{"unicode":["1f3da-fe0f","1f3da"],"fname":"1f3da","uc":"1f3da","isCanonical": false},":classical_building:":{"unicode":["1f3db-fe0f","1f3db"],"fname":"1f3db","uc":"1f3db","isCanonical": true},":desert:":{"unicode":["1f3dc-fe0f","1f3dc"],"fname":"1f3dc","uc":"1f3dc","isCanonical": true},":island:":{"unicode":["1f3dd-fe0f","1f3dd"],"fname":"1f3dd","uc":"1f3dd","isCanonical": true},":desert_island:":{"unicode":["1f3dd-fe0f","1f3dd"],"fname":"1f3dd","uc":"1f3dd","isCanonical": false},":park:":{"unicode":["1f3de-fe0f","1f3de"],"fname":"1f3de","uc":"1f3de","isCanonical": true},":national_park:":{"unicode":["1f3de-fe0f","1f3de"],"fname":"1f3de","uc":"1f3de","isCanonical": false},":stadium:":{"unicode":["1f3df-fe0f","1f3df"],"fname":"1f3df","uc":"1f3df","isCanonical": true},":couch:":{"unicode":["1f6cb-fe0f","1f6cb"],"fname":"1f6cb","uc":"1f6cb","isCanonical": true},":couch_and_lamp:":{"unicode":["1f6cb-fe0f","1f6cb"],"fname":"1f6cb","uc":"1f6cb","isCanonical": false},":shopping_bags:":{"unicode":["1f6cd-fe0f","1f6cd"],"fname":"1f6cd","uc":"1f6cd","isCanonical": true},":bellhop:":{"unicode":["1f6ce-fe0f","1f6ce"],"fname":"1f6ce","uc":"1f6ce","isCanonical": true},":bellhop_bell:":{"unicode":["1f6ce-fe0f","1f6ce"],"fname":"1f6ce","uc":"1f6ce","isCanonical": false},":bed:":{"unicode":["1f6cf-fe0f","1f6cf"],"fname":"1f6cf","uc":"1f6cf","isCanonical": true},":motorway:":{"unicode":["1f6e3-fe0f","1f6e3"],"fname":"1f6e3","uc":"1f6e3","isCanonical": true},":railway_track:":{"unicode":["1f6e4-fe0f","1f6e4"],"fname":"1f6e4","uc":"1f6e4","isCanonical": true},":railroad_track:":{"unicode":["1f6e4-fe0f","1f6e4"],"fname":"1f6e4","uc":"1f6e4","isCanonical": false},":motorboat:":{"unicode":["1f6e5-fe0f","1f6e5"],"fname":"1f6e5","uc":"1f6e5","isCanonical": true},":airplane_small:":{"unicode":["1f6e9-fe0f","1f6e9"],"fname":"1f6e9","uc":"1f6e9","isCanonical": true},":small_airplane:":{"unicode":["1f6e9-fe0f","1f6e9"],"fname":"1f6e9","uc":"1f6e9","isCanonical": false},":cruise_ship:":{"unicode":["1f6f3-fe0f","1f6f3"],"fname":"1f6f3","uc":"1f6f3","isCanonical": true},":passenger_ship:":{"unicode":["1f6f3-fe0f","1f6f3"],"fname":"1f6f3","uc":"1f6f3","isCanonical": false},":white_sun_small_cloud:":{"unicode":["1f324-fe0f","1f324"],"fname":"1f324","uc":"1f324","isCanonical": true},":white_sun_with_small_cloud:":{"unicode":["1f324-fe0f","1f324"],"fname":"1f324","uc":"1f324","isCanonical": false},":white_sun_cloud:":{"unicode":["1f325-fe0f","1f325"],"fname":"1f325","uc":"1f325","isCanonical": true},":white_sun_behind_cloud:":{"unicode":["1f325-fe0f","1f325"],"fname":"1f325","uc":"1f325","isCanonical": false},":white_sun_rain_cloud:":{"unicode":["1f326-fe0f","1f326"],"fname":"1f326","uc":"1f326","isCanonical": true},":white_sun_behind_cloud_with_rain:":{"unicode":["1f326-fe0f","1f326"],"fname":"1f326","uc":"1f326","isCanonical": false},":mouse_three_button:":{"unicode":["1f5b1-fe0f","1f5b1"],"fname":"1f5b1","uc":"1f5b1","isCanonical": true},":three_button_mouse:":{"unicode":["1f5b1-fe0f","1f5b1"],"fname":"1f5b1","uc":"1f5b1","isCanonical": false},":point_up_tone1:":{"unicode":["261d-1f3fb"],"fname":"261d-1f3fb","uc":"261d-1f3fb","isCanonical": true},":point_up_tone2:":{"unicode":["261d-1f3fc"],"fname":"261d-1f3fc","uc":"261d-1f3fc","isCanonical": true},":point_up_tone3:":{"unicode":["261d-1f3fd"],"fname":"261d-1f3fd","uc":"261d-1f3fd","isCanonical": true},":point_up_tone4:":{"unicode":["261d-1f3fe"],"fname":"261d-1f3fe","uc":"261d-1f3fe","isCanonical": true},":point_up_tone5:":{"unicode":["261d-1f3ff"],"fname":"261d-1f3ff","uc":"261d-1f3ff","isCanonical": true},":v_tone1:":{"unicode":["270c-1f3fb"],"fname":"270c-1f3fb","uc":"270c-1f3fb","isCanonical": true},":v_tone2:":{"unicode":["270c-1f3fc"],"fname":"270c-1f3fc","uc":"270c-1f3fc","isCanonical": true},":v_tone3:":{"unicode":["270c-1f3fd"],"fname":"270c-1f3fd","uc":"270c-1f3fd","isCanonical": true},":v_tone4:":{"unicode":["270c-1f3fe"],"fname":"270c-1f3fe","uc":"270c-1f3fe","isCanonical": true},":v_tone5:":{"unicode":["270c-1f3ff"],"fname":"270c-1f3ff","uc":"270c-1f3ff","isCanonical": true},":fist_tone1:":{"unicode":["270a-1f3fb"],"fname":"270a-1f3fb","uc":"270a-1f3fb","isCanonical": true},":fist_tone2:":{"unicode":["270a-1f3fc"],"fname":"270a-1f3fc","uc":"270a-1f3fc","isCanonical": true},":fist_tone3:":{"unicode":["270a-1f3fd"],"fname":"270a-1f3fd","uc":"270a-1f3fd","isCanonical": true},":fist_tone4:":{"unicode":["270a-1f3fe"],"fname":"270a-1f3fe","uc":"270a-1f3fe","isCanonical": true},":fist_tone5:":{"unicode":["270a-1f3ff"],"fname":"270a-1f3ff","uc":"270a-1f3ff","isCanonical": true},":raised_hand_tone1:":{"unicode":["270b-1f3fb"],"fname":"270b-1f3fb","uc":"270b-1f3fb","isCanonical": true},":raised_hand_tone2:":{"unicode":["270b-1f3fc"],"fname":"270b-1f3fc","uc":"270b-1f3fc","isCanonical": true},":raised_hand_tone3:":{"unicode":["270b-1f3fd"],"fname":"270b-1f3fd","uc":"270b-1f3fd","isCanonical": true},":raised_hand_tone4:":{"unicode":["270b-1f3fe"],"fname":"270b-1f3fe","uc":"270b-1f3fe","isCanonical": true},":raised_hand_tone5:":{"unicode":["270b-1f3ff"],"fname":"270b-1f3ff","uc":"270b-1f3ff","isCanonical": true},":writing_hand_tone1:":{"unicode":["270d-1f3fb"],"fname":"270d-1f3fb","uc":"270d-1f3fb","isCanonical": true},":writing_hand_tone2:":{"unicode":["270d-1f3fc"],"fname":"270d-1f3fc","uc":"270d-1f3fc","isCanonical": true},":writing_hand_tone3:":{"unicode":["270d-1f3fd"],"fname":"270d-1f3fd","uc":"270d-1f3fd","isCanonical": true},":writing_hand_tone4:":{"unicode":["270d-1f3fe"],"fname":"270d-1f3fe","uc":"270d-1f3fe","isCanonical": true},":writing_hand_tone5:":{"unicode":["270d-1f3ff"],"fname":"270d-1f3ff","uc":"270d-1f3ff","isCanonical": true},":basketball_player_tone1:":{"unicode":["26f9-1f3fb"],"fname":"26f9-1f3fb","uc":"26f9-1f3fb","isCanonical": true},":person_with_ball_tone1:":{"unicode":["26f9-1f3fb"],"fname":"26f9-1f3fb","uc":"26f9-1f3fb","isCanonical": false},":basketball_player_tone2:":{"unicode":["26f9-1f3fc"],"fname":"26f9-1f3fc","uc":"26f9-1f3fc","isCanonical": true},":person_with_ball_tone2:":{"unicode":["26f9-1f3fc"],"fname":"26f9-1f3fc","uc":"26f9-1f3fc","isCanonical": false},":basketball_player_tone3:":{"unicode":["26f9-1f3fd"],"fname":"26f9-1f3fd","uc":"26f9-1f3fd","isCanonical": true},":person_with_ball_tone3:":{"unicode":["26f9-1f3fd"],"fname":"26f9-1f3fd","uc":"26f9-1f3fd","isCanonical": false},":basketball_player_tone4:":{"unicode":["26f9-1f3fe"],"fname":"26f9-1f3fe","uc":"26f9-1f3fe","isCanonical": true},":person_with_ball_tone4:":{"unicode":["26f9-1f3fe"],"fname":"26f9-1f3fe","uc":"26f9-1f3fe","isCanonical": false},":basketball_player_tone5:":{"unicode":["26f9-1f3ff"],"fname":"26f9-1f3ff","uc":"26f9-1f3ff","isCanonical": true},":person_with_ball_tone5:":{"unicode":["26f9-1f3ff"],"fname":"26f9-1f3ff","uc":"26f9-1f3ff","isCanonical": false},":copyright:":{"unicode":["00a9-fe0f","00a9"],"fname":"00a9","uc":"00a9","isCanonical": true},":registered:":{"unicode":["00ae-fe0f","00ae"],"fname":"00ae","uc":"00ae","isCanonical": true},":bangbang:":{"unicode":["203c-fe0f","203c"],"fname":"203c","uc":"203c","isCanonical": true},":interrobang:":{"unicode":["2049-fe0f","2049"],"fname":"2049","uc":"2049","isCanonical": true},":tm:":{"unicode":["2122-fe0f","2122"],"fname":"2122","uc":"2122","isCanonical": true},":information_source:":{"unicode":["2139-fe0f","2139"],"fname":"2139","uc":"2139","isCanonical": true},":left_right_arrow:":{"unicode":["2194-fe0f","2194"],"fname":"2194","uc":"2194","isCanonical": true},":arrow_up_down:":{"unicode":["2195-fe0f","2195"],"fname":"2195","uc":"2195","isCanonical": true},":arrow_upper_left:":{"unicode":["2196-fe0f","2196"],"fname":"2196","uc":"2196","isCanonical": true},":arrow_upper_right:":{"unicode":["2197-fe0f","2197"],"fname":"2197","uc":"2197","isCanonical": true},":arrow_lower_right:":{"unicode":["2198-fe0f","2198"],"fname":"2198","uc":"2198","isCanonical": true},":arrow_lower_left:":{"unicode":["2199-fe0f","2199"],"fname":"2199","uc":"2199","isCanonical": true},":leftwards_arrow_with_hook:":{"unicode":["21a9-fe0f","21a9"],"fname":"21a9","uc":"21a9","isCanonical": true},":arrow_right_hook:":{"unicode":["21aa-fe0f","21aa"],"fname":"21aa","uc":"21aa","isCanonical": true},":watch:":{"unicode":["231a-fe0f","231a"],"fname":"231a","uc":"231a","isCanonical": true},":hourglass:":{"unicode":["231b-fe0f","231b"],"fname":"231b","uc":"231b","isCanonical": true},":m:":{"unicode":["24c2-fe0f","24c2"],"fname":"24c2","uc":"24c2","isCanonical": true},":black_small_square:":{"unicode":["25aa-fe0f","25aa"],"fname":"25aa","uc":"25aa","isCanonical": true},":white_small_square:":{"unicode":["25ab-fe0f","25ab"],"fname":"25ab","uc":"25ab","isCanonical": true},":arrow_forward:":{"unicode":["25b6-fe0f","25b6"],"fname":"25b6","uc":"25b6","isCanonical": true},":arrow_backward:":{"unicode":["25c0-fe0f","25c0"],"fname":"25c0","uc":"25c0","isCanonical": true},":white_medium_square:":{"unicode":["25fb-fe0f","25fb"],"fname":"25fb","uc":"25fb","isCanonical": true},":black_medium_square:":{"unicode":["25fc-fe0f","25fc"],"fname":"25fc","uc":"25fc","isCanonical": true},":white_medium_small_square:":{"unicode":["25fd-fe0f","25fd"],"fname":"25fd","uc":"25fd","isCanonical": true},":black_medium_small_square:":{"unicode":["25fe-fe0f","25fe"],"fname":"25fe","uc":"25fe","isCanonical": true},":sunny:":{"unicode":["2600-fe0f","2600"],"fname":"2600","uc":"2600","isCanonical": true},":cloud:":{"unicode":["2601-fe0f","2601"],"fname":"2601","uc":"2601","isCanonical": true},":telephone:":{"unicode":["260e-fe0f","260e"],"fname":"260e","uc":"260e","isCanonical": true},":ballot_box_with_check:":{"unicode":["2611-fe0f","2611"],"fname":"2611","uc":"2611","isCanonical": true},":umbrella:":{"unicode":["2614-fe0f","2614"],"fname":"2614","uc":"2614","isCanonical": true},":coffee:":{"unicode":["2615-fe0f","2615"],"fname":"2615","uc":"2615","isCanonical": true},":point_up:":{"unicode":["261d-fe0f","261d"],"fname":"261d","uc":"261d","isCanonical": true},":relaxed:":{"unicode":["263a-fe0f","263a"],"fname":"263a","uc":"263a","isCanonical": true},":aries:":{"unicode":["2648-fe0f","2648"],"fname":"2648","uc":"2648","isCanonical": true},":taurus:":{"unicode":["2649-fe0f","2649"],"fname":"2649","uc":"2649","isCanonical": true},":gemini:":{"unicode":["264a-fe0f","264a"],"fname":"264a","uc":"264a","isCanonical": true},":cancer:":{"unicode":["264b-fe0f","264b"],"fname":"264b","uc":"264b","isCanonical": true},":leo:":{"unicode":["264c-fe0f","264c"],"fname":"264c","uc":"264c","isCanonical": true},":virgo:":{"unicode":["264d-fe0f","264d"],"fname":"264d","uc":"264d","isCanonical": true},":libra:":{"unicode":["264e-fe0f","264e"],"fname":"264e","uc":"264e","isCanonical": true},":scorpius:":{"unicode":["264f-fe0f","264f"],"fname":"264f","uc":"264f","isCanonical": true},":sagittarius:":{"unicode":["2650-fe0f","2650"],"fname":"2650","uc":"2650","isCanonical": true},":capricorn:":{"unicode":["2651-fe0f","2651"],"fname":"2651","uc":"2651","isCanonical": true},":aquarius:":{"unicode":["2652-fe0f","2652"],"fname":"2652","uc":"2652","isCanonical": true},":pisces:":{"unicode":["2653-fe0f","2653"],"fname":"2653","uc":"2653","isCanonical": true},":spades:":{"unicode":["2660-fe0f","2660"],"fname":"2660","uc":"2660","isCanonical": true},":clubs:":{"unicode":["2663-fe0f","2663"],"fname":"2663","uc":"2663","isCanonical": true},":hearts:":{"unicode":["2665-fe0f","2665"],"fname":"2665","uc":"2665","isCanonical": true},":diamonds:":{"unicode":["2666-fe0f","2666"],"fname":"2666","uc":"2666","isCanonical": true},":hotsprings:":{"unicode":["2668-fe0f","2668"],"fname":"2668","uc":"2668","isCanonical": true},":recycle:":{"unicode":["267b-fe0f","267b"],"fname":"267b","uc":"267b","isCanonical": true},":wheelchair:":{"unicode":["267f-fe0f","267f"],"fname":"267f","uc":"267f","isCanonical": true},":anchor:":{"unicode":["2693-fe0f","2693"],"fname":"2693","uc":"2693","isCanonical": true},":warning:":{"unicode":["26a0-fe0f","26a0"],"fname":"26a0","uc":"26a0","isCanonical": true},":zap:":{"unicode":["26a1-fe0f","26a1"],"fname":"26a1","uc":"26a1","isCanonical": true},":white_circle:":{"unicode":["26aa-fe0f","26aa"],"fname":"26aa","uc":"26aa","isCanonical": true},":black_circle:":{"unicode":["26ab-fe0f","26ab"],"fname":"26ab","uc":"26ab","isCanonical": true},":soccer:":{"unicode":["26bd-fe0f","26bd"],"fname":"26bd","uc":"26bd","isCanonical": true},":baseball:":{"unicode":["26be-fe0f","26be"],"fname":"26be","uc":"26be","isCanonical": true},":snowman:":{"unicode":["26c4-fe0f","26c4"],"fname":"26c4","uc":"26c4","isCanonical": true},":partly_sunny:":{"unicode":["26c5-fe0f","26c5"],"fname":"26c5","uc":"26c5","isCanonical": true},":no_entry:":{"unicode":["26d4-fe0f","26d4"],"fname":"26d4","uc":"26d4","isCanonical": true},":church:":{"unicode":["26ea-fe0f","26ea"],"fname":"26ea","uc":"26ea","isCanonical": true},":fountain:":{"unicode":["26f2-fe0f","26f2"],"fname":"26f2","uc":"26f2","isCanonical": true},":golf:":{"unicode":["26f3-fe0f","26f3"],"fname":"26f3","uc":"26f3","isCanonical": true},":sailboat:":{"unicode":["26f5-fe0f","26f5"],"fname":"26f5","uc":"26f5","isCanonical": true},":tent:":{"unicode":["26fa-fe0f","26fa"],"fname":"26fa","uc":"26fa","isCanonical": true},":fuelpump:":{"unicode":["26fd-fe0f","26fd"],"fname":"26fd","uc":"26fd","isCanonical": true},":scissors:":{"unicode":["2702-fe0f","2702"],"fname":"2702","uc":"2702","isCanonical": true},":airplane:":{"unicode":["2708-fe0f","2708"],"fname":"2708","uc":"2708","isCanonical": true},":envelope:":{"unicode":["2709-fe0f","2709"],"fname":"2709","uc":"2709","isCanonical": true},":v:":{"unicode":["270c-fe0f","270c"],"fname":"270c","uc":"270c","isCanonical": true},":pencil2:":{"unicode":["270f-fe0f","270f"],"fname":"270f","uc":"270f","isCanonical": true},":black_nib:":{"unicode":["2712-fe0f","2712"],"fname":"2712","uc":"2712","isCanonical": true},":heavy_check_mark:":{"unicode":["2714-fe0f","2714"],"fname":"2714","uc":"2714","isCanonical": true},":heavy_multiplication_x:":{"unicode":["2716-fe0f","2716"],"fname":"2716","uc":"2716","isCanonical": true},":eight_spoked_asterisk:":{"unicode":["2733-fe0f","2733"],"fname":"2733","uc":"2733","isCanonical": true},":eight_pointed_black_star:":{"unicode":["2734-fe0f","2734"],"fname":"2734","uc":"2734","isCanonical": true},":snowflake:":{"unicode":["2744-fe0f","2744"],"fname":"2744","uc":"2744","isCanonical": true},":sparkle:":{"unicode":["2747-fe0f","2747"],"fname":"2747","uc":"2747","isCanonical": true},":exclamation:":{"unicode":["2757-fe0f","2757"],"fname":"2757","uc":"2757","isCanonical": true},":heart:":{"unicode":["2764-fe0f","2764"],"fname":"2764","uc":"2764","isCanonical": true},":arrow_right:":{"unicode":["27a1-fe0f","27a1"],"fname":"27a1","uc":"27a1","isCanonical": true},":arrow_heading_up:":{"unicode":["2934-fe0f","2934"],"fname":"2934","uc":"2934","isCanonical": true},":arrow_heading_down:":{"unicode":["2935-fe0f","2935"],"fname":"2935","uc":"2935","isCanonical": true},":arrow_left:":{"unicode":["2b05-fe0f","2b05"],"fname":"2b05","uc":"2b05","isCanonical": true},":arrow_up:":{"unicode":["2b06-fe0f","2b06"],"fname":"2b06","uc":"2b06","isCanonical": true},":arrow_down:":{"unicode":["2b07-fe0f","2b07"],"fname":"2b07","uc":"2b07","isCanonical": true},":black_large_square:":{"unicode":["2b1b-fe0f","2b1b"],"fname":"2b1b","uc":"2b1b","isCanonical": true},":white_large_square:":{"unicode":["2b1c-fe0f","2b1c"],"fname":"2b1c","uc":"2b1c","isCanonical": true},":star:":{"unicode":["2b50-fe0f","2b50"],"fname":"2b50","uc":"2b50","isCanonical": true},":o:":{"unicode":["2b55-fe0f","2b55"],"fname":"2b55","uc":"2b55","isCanonical": true},":wavy_dash:":{"unicode":["3030-fe0f","3030"],"fname":"3030","uc":"3030","isCanonical": true},":part_alternation_mark:":{"unicode":["303d-fe0f","303d"],"fname":"303d","uc":"303d","isCanonical": true},":congratulations:":{"unicode":["3297-fe0f","3297"],"fname":"3297","uc":"3297","isCanonical": true},":secret:":{"unicode":["3299-fe0f","3299"],"fname":"3299","uc":"3299","isCanonical": true},":cross:":{"unicode":["271d-fe0f","271d"],"fname":"271d","uc":"271d","isCanonical": true},":latin_cross:":{"unicode":["271d-fe0f","271d"],"fname":"271d","uc":"271d","isCanonical": false},":keyboard:":{"unicode":["2328-fe0f","2328"],"fname":"2328","uc":"2328","isCanonical": true},":writing_hand:":{"unicode":["270d-fe0f","270d"],"fname":"270d","uc":"270d","isCanonical": true},":eject:":{"unicode":["23cf-fe0f","23cf"],"fname":"23cf","uc":"23cf","isCanonical": true},":eject_symbol:":{"unicode":["23cf-fe0f","23cf"],"fname":"23cf","uc":"23cf","isCanonical": false},":track_next:":{"unicode":["23ed-fe0f","23ed"],"fname":"23ed","uc":"23ed","isCanonical": true},":next_track:":{"unicode":["23ed-fe0f","23ed"],"fname":"23ed","uc":"23ed","isCanonical": false},":track_previous:":{"unicode":["23ee-fe0f","23ee"],"fname":"23ee","uc":"23ee","isCanonical": true},":previous_track:":{"unicode":["23ee-fe0f","23ee"],"fname":"23ee","uc":"23ee","isCanonical": false},":play_pause:":{"unicode":["23ef-fe0f","23ef"],"fname":"23ef","uc":"23ef","isCanonical": true},":stopwatch:":{"unicode":["23f1-fe0f","23f1"],"fname":"23f1","uc":"23f1","isCanonical": true},":timer:":{"unicode":["23f2-fe0f","23f2"],"fname":"23f2","uc":"23f2","isCanonical": true},":timer_clock:":{"unicode":["23f2-fe0f","23f2"],"fname":"23f2","uc":"23f2","isCanonical": false},":pause_button:":{"unicode":["23f8-fe0f","23f8"],"fname":"23f8","uc":"23f8","isCanonical": true},":double_vertical_bar:":{"unicode":["23f8-fe0f","23f8"],"fname":"23f8","uc":"23f8","isCanonical": false},":stop_button:":{"unicode":["23f9-fe0f","23f9"],"fname":"23f9","uc":"23f9","isCanonical": true},":record_button:":{"unicode":["23fa-fe0f","23fa"],"fname":"23fa","uc":"23fa","isCanonical": true},":umbrella2:":{"unicode":["2602-fe0f","2602"],"fname":"2602","uc":"2602","isCanonical": true},":snowman2:":{"unicode":["2603-fe0f","2603"],"fname":"2603","uc":"2603","isCanonical": true},":comet:":{"unicode":["2604-fe0f","2604"],"fname":"2604","uc":"2604","isCanonical": true},":shamrock:":{"unicode":["2618-fe0f","2618"],"fname":"2618","uc":"2618","isCanonical": true},":skull_crossbones:":{"unicode":["2620-fe0f","2620"],"fname":"2620","uc":"2620","isCanonical": true},":skull_and_crossbones:":{"unicode":["2620-fe0f","2620"],"fname":"2620","uc":"2620","isCanonical": false},":radioactive:":{"unicode":["2622-fe0f","2622"],"fname":"2622","uc":"2622","isCanonical": true},":radioactive_sign:":{"unicode":["2622-fe0f","2622"],"fname":"2622","uc":"2622","isCanonical": false},":biohazard:":{"unicode":["2623-fe0f","2623"],"fname":"2623","uc":"2623","isCanonical": true},":biohazard_sign:":{"unicode":["2623-fe0f","2623"],"fname":"2623","uc":"2623","isCanonical": false},":orthodox_cross:":{"unicode":["2626-fe0f","2626"],"fname":"2626","uc":"2626","isCanonical": true},":star_and_crescent:":{"unicode":["262a-fe0f","262a"],"fname":"262a","uc":"262a","isCanonical": true},":peace:":{"unicode":["262e-fe0f","262e"],"fname":"262e","uc":"262e","isCanonical": true},":peace_symbol:":{"unicode":["262e-fe0f","262e"],"fname":"262e","uc":"262e","isCanonical": false},":yin_yang:":{"unicode":["262f-fe0f","262f"],"fname":"262f","uc":"262f","isCanonical": true},":wheel_of_dharma:":{"unicode":["2638-fe0f","2638"],"fname":"2638","uc":"2638","isCanonical": true},":frowning2:":{"unicode":["2639-fe0f","2639"],"fname":"2639","uc":"2639","isCanonical": true},":white_frowning_face:":{"unicode":["2639-fe0f","2639"],"fname":"2639","uc":"2639","isCanonical": false},":hammer_pick:":{"unicode":["2692-fe0f","2692"],"fname":"2692","uc":"2692","isCanonical": true},":hammer_and_pick:":{"unicode":["2692-fe0f","2692"],"fname":"2692","uc":"2692","isCanonical": false},":crossed_swords:":{"unicode":["2694-fe0f","2694"],"fname":"2694","uc":"2694","isCanonical": true},":scales:":{"unicode":["2696-fe0f","2696"],"fname":"2696","uc":"2696","isCanonical": true},":alembic:":{"unicode":["2697-fe0f","2697"],"fname":"2697","uc":"2697","isCanonical": true},":gear:":{"unicode":["2699-fe0f","2699"],"fname":"2699","uc":"2699","isCanonical": true},":atom:":{"unicode":["269b-fe0f","269b"],"fname":"269b","uc":"269b","isCanonical": true},":atom_symbol:":{"unicode":["269b-fe0f","269b"],"fname":"269b","uc":"269b","isCanonical": false},":fleur-de-lis:":{"unicode":["269c-fe0f","269c"],"fname":"269c","uc":"269c","isCanonical": true},":coffin:":{"unicode":["26b0-fe0f","26b0"],"fname":"26b0","uc":"26b0","isCanonical": true},":urn:":{"unicode":["26b1-fe0f","26b1"],"fname":"26b1","uc":"26b1","isCanonical": true},":funeral_urn:":{"unicode":["26b1-fe0f","26b1"],"fname":"26b1","uc":"26b1","isCanonical": false},":thunder_cloud_rain:":{"unicode":["26c8-fe0f","26c8"],"fname":"26c8","uc":"26c8","isCanonical": true},":thunder_cloud_and_rain:":{"unicode":["26c8-fe0f","26c8"],"fname":"26c8","uc":"26c8","isCanonical": false},":pick:":{"unicode":["26cf-fe0f","26cf"],"fname":"26cf","uc":"26cf","isCanonical": true},":helmet_with_cross:":{"unicode":["26d1-fe0f","26d1"],"fname":"26d1","uc":"26d1","isCanonical": true},":helmet_with_white_cross:":{"unicode":["26d1-fe0f","26d1"],"fname":"26d1","uc":"26d1","isCanonical": false},":chains:":{"unicode":["26d3-fe0f","26d3"],"fname":"26d3","uc":"26d3","isCanonical": true},":shinto_shrine:":{"unicode":["26e9-fe0f","26e9"],"fname":"26e9","uc":"26e9","isCanonical": true},":mountain:":{"unicode":["26f0-fe0f","26f0"],"fname":"26f0","uc":"26f0","isCanonical": true},":beach_umbrella:":{"unicode":["26f1-fe0f","26f1"],"fname":"26f1","uc":"26f1","isCanonical": true},":umbrella_on_ground:":{"unicode":["26f1-fe0f","26f1"],"fname":"26f1","uc":"26f1","isCanonical": false},":ferry:":{"unicode":["26f4-fe0f","26f4"],"fname":"26f4","uc":"26f4","isCanonical": true},":skier:":{"unicode":["26f7-fe0f","26f7"],"fname":"26f7","uc":"26f7","isCanonical": true},":ice_skate:":{"unicode":["26f8-fe0f","26f8"],"fname":"26f8","uc":"26f8","isCanonical": true},":basketball_player:":{"unicode":["26f9-fe0f","26f9"],"fname":"26f9","uc":"26f9","isCanonical": true},":person_with_ball:":{"unicode":["26f9-fe0f","26f9"],"fname":"26f9","uc":"26f9","isCanonical": false},":star_of_david:":{"unicode":["2721-fe0f","2721"],"fname":"2721","uc":"2721","isCanonical": true},":heart_exclamation:":{"unicode":["2763-fe0f","2763"],"fname":"2763","uc":"2763","isCanonical": true},":heavy_heart_exclamation_mark_ornament:":{"unicode":["2763-fe0f","2763"],"fname":"2763","uc":"2763","isCanonical": false},":third_place:":{"unicode":["1f949"],"fname":"1f949","uc":"1f949","isCanonical": true},":third_place_medal:":{"unicode":["1f949"],"fname":"1f949","uc":"1f949","isCanonical": false},":second_place:":{"unicode":["1f948"],"fname":"1f948","uc":"1f948","isCanonical": true},":second_place_medal:":{"unicode":["1f948"],"fname":"1f948","uc":"1f948","isCanonical": false},":first_place:":{"unicode":["1f947"],"fname":"1f947","uc":"1f947","isCanonical": true},":first_place_medal:":{"unicode":["1f947"],"fname":"1f947","uc":"1f947","isCanonical": false},":fencer:":{"unicode":["1f93a"],"fname":"1f93a","uc":"1f93a","isCanonical": true},":fencing:":{"unicode":["1f93a"],"fname":"1f93a","uc":"1f93a","isCanonical": false},":goal:":{"unicode":["1f945"],"fname":"1f945","uc":"1f945","isCanonical": true},":goal_net:":{"unicode":["1f945"],"fname":"1f945","uc":"1f945","isCanonical": false},":handball:":{"unicode":["1f93e"],"fname":"1f93e","uc":"1f93e","isCanonical": true},":regional_indicator_z:":{"unicode":["1f1ff"],"fname":"1f1ff","uc":"1f1ff","isCanonical": true},":water_polo:":{"unicode":["1f93d"],"fname":"1f93d","uc":"1f93d","isCanonical": true},":martial_arts_uniform:":{"unicode":["1f94b"],"fname":"1f94b","uc":"1f94b","isCanonical": true},":karate_uniform:":{"unicode":["1f94b"],"fname":"1f94b","uc":"1f94b","isCanonical": false},":boxing_glove:":{"unicode":["1f94a"],"fname":"1f94a","uc":"1f94a","isCanonical": true},":boxing_gloves:":{"unicode":["1f94a"],"fname":"1f94a","uc":"1f94a","isCanonical": false},":wrestlers:":{"unicode":["1f93c"],"fname":"1f93c","uc":"1f93c","isCanonical": true},":wrestling:":{"unicode":["1f93c"],"fname":"1f93c","uc":"1f93c","isCanonical": false},":juggling:":{"unicode":["1f939"],"fname":"1f939","uc":"1f939","isCanonical": true},":juggler:":{"unicode":["1f939"],"fname":"1f939","uc":"1f939","isCanonical": false},":cartwheel:":{"unicode":["1f938"],"fname":"1f938","uc":"1f938","isCanonical": true},":person_doing_cartwheel:":{"unicode":["1f938"],"fname":"1f938","uc":"1f938","isCanonical": false},":canoe:":{"unicode":["1f6f6"],"fname":"1f6f6","uc":"1f6f6","isCanonical": true},":kayak:":{"unicode":["1f6f6"],"fname":"1f6f6","uc":"1f6f6","isCanonical": false},":motor_scooter:":{"unicode":["1f6f5"],"fname":"1f6f5","uc":"1f6f5","isCanonical": true},":motorbike:":{"unicode":["1f6f5"],"fname":"1f6f5","uc":"1f6f5","isCanonical": false},":scooter:":{"unicode":["1f6f4"],"fname":"1f6f4","uc":"1f6f4","isCanonical": true},":shopping_cart:":{"unicode":["1f6d2"],"fname":"1f6d2","uc":"1f6d2","isCanonical": true},":shopping_trolley:":{"unicode":["1f6d2"],"fname":"1f6d2","uc":"1f6d2","isCanonical": false},":black_joker:":{"unicode":["1f0cf"],"fname":"1f0cf","uc":"1f0cf","isCanonical": true},":a:":{"unicode":["1f170"],"fname":"1f170","uc":"1f170","isCanonical": true},":b:":{"unicode":["1f171"],"fname":"1f171","uc":"1f171","isCanonical": true},":o2:":{"unicode":["1f17e"],"fname":"1f17e","uc":"1f17e","isCanonical": true},":octagonal_sign:":{"unicode":["1f6d1"],"fname":"1f6d1","uc":"1f6d1","isCanonical": true},":stop_sign:":{"unicode":["1f6d1"],"fname":"1f6d1","uc":"1f6d1","isCanonical": false},":ab:":{"unicode":["1f18e"],"fname":"1f18e","uc":"1f18e","isCanonical": true},":cl:":{"unicode":["1f191"],"fname":"1f191","uc":"1f191","isCanonical": true},":regional_indicator_y:":{"unicode":["1f1fe"],"fname":"1f1fe","uc":"1f1fe","isCanonical": true},":cool:":{"unicode":["1f192"],"fname":"1f192","uc":"1f192","isCanonical": true},":free:":{"unicode":["1f193"],"fname":"1f193","uc":"1f193","isCanonical": true},":id:":{"unicode":["1f194"],"fname":"1f194","uc":"1f194","isCanonical": true},":new:":{"unicode":["1f195"],"fname":"1f195","uc":"1f195","isCanonical": true},":ng:":{"unicode":["1f196"],"fname":"1f196","uc":"1f196","isCanonical": true},":ok:":{"unicode":["1f197"],"fname":"1f197","uc":"1f197","isCanonical": true},":sos:":{"unicode":["1f198"],"fname":"1f198","uc":"1f198","isCanonical": true},":spoon:":{"unicode":["1f944"],"fname":"1f944","uc":"1f944","isCanonical": true},":up:":{"unicode":["1f199"],"fname":"1f199","uc":"1f199","isCanonical": true},":vs:":{"unicode":["1f19a"],"fname":"1f19a","uc":"1f19a","isCanonical": true},":champagne_glass:":{"unicode":["1f942"],"fname":"1f942","uc":"1f942","isCanonical": true},":clinking_glass:":{"unicode":["1f942"],"fname":"1f942","uc":"1f942","isCanonical": false},":tumbler_glass:":{"unicode":["1f943"],"fname":"1f943","uc":"1f943","isCanonical": true},":whisky:":{"unicode":["1f943"],"fname":"1f943","uc":"1f943","isCanonical": false},":koko:":{"unicode":["1f201"],"fname":"1f201","uc":"1f201","isCanonical": true},":stuffed_flatbread:":{"unicode":["1f959"],"fname":"1f959","uc":"1f959","isCanonical": true},":stuffed_pita:":{"unicode":["1f959"],"fname":"1f959","uc":"1f959","isCanonical": false},":u7981:":{"unicode":["1f232"],"fname":"1f232","uc":"1f232","isCanonical": true},":u7a7a:":{"unicode":["1f233"],"fname":"1f233","uc":"1f233","isCanonical": true},":u5408:":{"unicode":["1f234"],"fname":"1f234","uc":"1f234","isCanonical": true},":u6e80:":{"unicode":["1f235"],"fname":"1f235","uc":"1f235","isCanonical": true},":u6709:":{"unicode":["1f236"],"fname":"1f236","uc":"1f236","isCanonical": true},":shallow_pan_of_food:":{"unicode":["1f958"],"fname":"1f958","uc":"1f958","isCanonical": true},":paella:":{"unicode":["1f958"],"fname":"1f958","uc":"1f958","isCanonical": false},":u7533:":{"unicode":["1f238"],"fname":"1f238","uc":"1f238","isCanonical": true},":u5272:":{"unicode":["1f239"],"fname":"1f239","uc":"1f239","isCanonical": true},":salad:":{"unicode":["1f957"],"fname":"1f957","uc":"1f957","isCanonical": true},":green_salad:":{"unicode":["1f957"],"fname":"1f957","uc":"1f957","isCanonical": false},":u55b6:":{"unicode":["1f23a"],"fname":"1f23a","uc":"1f23a","isCanonical": true},":ideograph_advantage:":{"unicode":["1f250"],"fname":"1f250","uc":"1f250","isCanonical": true},":accept:":{"unicode":["1f251"],"fname":"1f251","uc":"1f251","isCanonical": true},":cyclone:":{"unicode":["1f300"],"fname":"1f300","uc":"1f300","isCanonical": true},":french_bread:":{"unicode":["1f956"],"fname":"1f956","uc":"1f956","isCanonical": true},":baguette_bread:":{"unicode":["1f956"],"fname":"1f956","uc":"1f956","isCanonical": false},":foggy:":{"unicode":["1f301"],"fname":"1f301","uc":"1f301","isCanonical": true},":closed_umbrella:":{"unicode":["1f302"],"fname":"1f302","uc":"1f302","isCanonical": true},":night_with_stars:":{"unicode":["1f303"],"fname":"1f303","uc":"1f303","isCanonical": true},":sunrise_over_mountains:":{"unicode":["1f304"],"fname":"1f304","uc":"1f304","isCanonical": true},":sunrise:":{"unicode":["1f305"],"fname":"1f305","uc":"1f305","isCanonical": true},":city_dusk:":{"unicode":["1f306"],"fname":"1f306","uc":"1f306","isCanonical": true},":carrot:":{"unicode":["1f955"],"fname":"1f955","uc":"1f955","isCanonical": true},":city_sunset:":{"unicode":["1f307"],"fname":"1f307","uc":"1f307","isCanonical": true},":city_sunrise:":{"unicode":["1f307"],"fname":"1f307","uc":"1f307","isCanonical": false},":rainbow:":{"unicode":["1f308"],"fname":"1f308","uc":"1f308","isCanonical": true},":potato:":{"unicode":["1f954"],"fname":"1f954","uc":"1f954","isCanonical": true},":bridge_at_night:":{"unicode":["1f309"],"fname":"1f309","uc":"1f309","isCanonical": true},":ocean:":{"unicode":["1f30a"],"fname":"1f30a","uc":"1f30a","isCanonical": true},":volcano:":{"unicode":["1f30b"],"fname":"1f30b","uc":"1f30b","isCanonical": true},":milky_way:":{"unicode":["1f30c"],"fname":"1f30c","uc":"1f30c","isCanonical": true},":earth_asia:":{"unicode":["1f30f"],"fname":"1f30f","uc":"1f30f","isCanonical": true},":new_moon:":{"unicode":["1f311"],"fname":"1f311","uc":"1f311","isCanonical": true},":bacon:":{"unicode":["1f953"],"fname":"1f953","uc":"1f953","isCanonical": true},":first_quarter_moon:":{"unicode":["1f313"],"fname":"1f313","uc":"1f313","isCanonical": true},":waxing_gibbous_moon:":{"unicode":["1f314"],"fname":"1f314","uc":"1f314","isCanonical": true},":full_moon:":{"unicode":["1f315"],"fname":"1f315","uc":"1f315","isCanonical": true},":crescent_moon:":{"unicode":["1f319"],"fname":"1f319","uc":"1f319","isCanonical": true},":first_quarter_moon_with_face:":{"unicode":["1f31b"],"fname":"1f31b","uc":"1f31b","isCanonical": true},":star2:":{"unicode":["1f31f"],"fname":"1f31f","uc":"1f31f","isCanonical": true},":cucumber:":{"unicode":["1f952"],"fname":"1f952","uc":"1f952","isCanonical": true},":stars:":{"unicode":["1f320"],"fname":"1f320","uc":"1f320","isCanonical": true},":chestnut:":{"unicode":["1f330"],"fname":"1f330","uc":"1f330","isCanonical": true},":avocado:":{"unicode":["1f951"],"fname":"1f951","uc":"1f951","isCanonical": true},":seedling:":{"unicode":["1f331"],"fname":"1f331","uc":"1f331","isCanonical": true},":palm_tree:":{"unicode":["1f334"],"fname":"1f334","uc":"1f334","isCanonical": true},":cactus:":{"unicode":["1f335"],"fname":"1f335","uc":"1f335","isCanonical": true},":tulip:":{"unicode":["1f337"],"fname":"1f337","uc":"1f337","isCanonical": true},":cherry_blossom:":{"unicode":["1f338"],"fname":"1f338","uc":"1f338","isCanonical": true},":rose:":{"unicode":["1f339"],"fname":"1f339","uc":"1f339","isCanonical": true},":hibiscus:":{"unicode":["1f33a"],"fname":"1f33a","uc":"1f33a","isCanonical": true},":sunflower:":{"unicode":["1f33b"],"fname":"1f33b","uc":"1f33b","isCanonical": true},":blossom:":{"unicode":["1f33c"],"fname":"1f33c","uc":"1f33c","isCanonical": true},":corn:":{"unicode":["1f33d"],"fname":"1f33d","uc":"1f33d","isCanonical": true},":croissant:":{"unicode":["1f950"],"fname":"1f950","uc":"1f950","isCanonical": true},":ear_of_rice:":{"unicode":["1f33e"],"fname":"1f33e","uc":"1f33e","isCanonical": true},":herb:":{"unicode":["1f33f"],"fname":"1f33f","uc":"1f33f","isCanonical": true},":four_leaf_clover:":{"unicode":["1f340"],"fname":"1f340","uc":"1f340","isCanonical": true},":maple_leaf:":{"unicode":["1f341"],"fname":"1f341","uc":"1f341","isCanonical": true},":fallen_leaf:":{"unicode":["1f342"],"fname":"1f342","uc":"1f342","isCanonical": true},":leaves:":{"unicode":["1f343"],"fname":"1f343","uc":"1f343","isCanonical": true},":mushroom:":{"unicode":["1f344"],"fname":"1f344","uc":"1f344","isCanonical": true},":tomato:":{"unicode":["1f345"],"fname":"1f345","uc":"1f345","isCanonical": true},":eggplant:":{"unicode":["1f346"],"fname":"1f346","uc":"1f346","isCanonical": true},":grapes:":{"unicode":["1f347"],"fname":"1f347","uc":"1f347","isCanonical": true},":melon:":{"unicode":["1f348"],"fname":"1f348","uc":"1f348","isCanonical": true},":watermelon:":{"unicode":["1f349"],"fname":"1f349","uc":"1f349","isCanonical": true},":tangerine:":{"unicode":["1f34a"],"fname":"1f34a","uc":"1f34a","isCanonical": true},":wilted_rose:":{"unicode":["1f940"],"fname":"1f940","uc":"1f940","isCanonical": true},":wilted_flower:":{"unicode":["1f940"],"fname":"1f940","uc":"1f940","isCanonical": false},":banana:":{"unicode":["1f34c"],"fname":"1f34c","uc":"1f34c","isCanonical": true},":pineapple:":{"unicode":["1f34d"],"fname":"1f34d","uc":"1f34d","isCanonical": true},":apple:":{"unicode":["1f34e"],"fname":"1f34e","uc":"1f34e","isCanonical": true},":green_apple:":{"unicode":["1f34f"],"fname":"1f34f","uc":"1f34f","isCanonical": true},":peach:":{"unicode":["1f351"],"fname":"1f351","uc":"1f351","isCanonical": true},":cherries:":{"unicode":["1f352"],"fname":"1f352","uc":"1f352","isCanonical": true},":strawberry:":{"unicode":["1f353"],"fname":"1f353","uc":"1f353","isCanonical": true},":rhino:":{"unicode":["1f98f"],"fname":"1f98f","uc":"1f98f","isCanonical": true},":rhinoceros:":{"unicode":["1f98f"],"fname":"1f98f","uc":"1f98f","isCanonical": false},":hamburger:":{"unicode":["1f354"],"fname":"1f354","uc":"1f354","isCanonical": true},":pizza:":{"unicode":["1f355"],"fname":"1f355","uc":"1f355","isCanonical": true},":meat_on_bone:":{"unicode":["1f356"],"fname":"1f356","uc":"1f356","isCanonical": true},":lizard:":{"unicode":["1f98e"],"fname":"1f98e","uc":"1f98e","isCanonical": true},":poultry_leg:":{"unicode":["1f357"],"fname":"1f357","uc":"1f357","isCanonical": true},":rice_cracker:":{"unicode":["1f358"],"fname":"1f358","uc":"1f358","isCanonical": true},":rice_ball:":{"unicode":["1f359"],"fname":"1f359","uc":"1f359","isCanonical": true},":gorilla:":{"unicode":["1f98d"],"fname":"1f98d","uc":"1f98d","isCanonical": true},":rice:":{"unicode":["1f35a"],"fname":"1f35a","uc":"1f35a","isCanonical": true},":curry:":{"unicode":["1f35b"],"fname":"1f35b","uc":"1f35b","isCanonical": true},":deer:":{"unicode":["1f98c"],"fname":"1f98c","uc":"1f98c","isCanonical": true},":ramen:":{"unicode":["1f35c"],"fname":"1f35c","uc":"1f35c","isCanonical": true},":spaghetti:":{"unicode":["1f35d"],"fname":"1f35d","uc":"1f35d","isCanonical": true},":bread:":{"unicode":["1f35e"],"fname":"1f35e","uc":"1f35e","isCanonical": true},":fries:":{"unicode":["1f35f"],"fname":"1f35f","uc":"1f35f","isCanonical": true},":butterfly:":{"unicode":["1f98b"],"fname":"1f98b","uc":"1f98b","isCanonical": true},":sweet_potato:":{"unicode":["1f360"],"fname":"1f360","uc":"1f360","isCanonical": true},":dango:":{"unicode":["1f361"],"fname":"1f361","uc":"1f361","isCanonical": true},":fox:":{"unicode":["1f98a"],"fname":"1f98a","uc":"1f98a","isCanonical": true},":fox_face:":{"unicode":["1f98a"],"fname":"1f98a","uc":"1f98a","isCanonical": false},":oden:":{"unicode":["1f362"],"fname":"1f362","uc":"1f362","isCanonical": true},":sushi:":{"unicode":["1f363"],"fname":"1f363","uc":"1f363","isCanonical": true},":owl:":{"unicode":["1f989"],"fname":"1f989","uc":"1f989","isCanonical": true},":fried_shrimp:":{"unicode":["1f364"],"fname":"1f364","uc":"1f364","isCanonical": true},":fish_cake:":{"unicode":["1f365"],"fname":"1f365","uc":"1f365","isCanonical": true},":shark:":{"unicode":["1f988"],"fname":"1f988","uc":"1f988","isCanonical": true},":icecream:":{"unicode":["1f366"],"fname":"1f366","uc":"1f366","isCanonical": true},":bat:":{"unicode":["1f987"],"fname":"1f987","uc":"1f987","isCanonical": true},":shaved_ice:":{"unicode":["1f367"],"fname":"1f367","uc":"1f367","isCanonical": true},":regional_indicator_x:":{"unicode":["1f1fd"],"fname":"1f1fd","uc":"1f1fd","isCanonical": true},":ice_cream:":{"unicode":["1f368"],"fname":"1f368","uc":"1f368","isCanonical": true},":duck:":{"unicode":["1f986"],"fname":"1f986","uc":"1f986","isCanonical": true},":doughnut:":{"unicode":["1f369"],"fname":"1f369","uc":"1f369","isCanonical": true},":eagle:":{"unicode":["1f985"],"fname":"1f985","uc":"1f985","isCanonical": true},":cookie:":{"unicode":["1f36a"],"fname":"1f36a","uc":"1f36a","isCanonical": true},":black_heart:":{"unicode":["1f5a4"],"fname":"1f5a4","uc":"1f5a4","isCanonical": true},":chocolate_bar:":{"unicode":["1f36b"],"fname":"1f36b","uc":"1f36b","isCanonical": true},":candy:":{"unicode":["1f36c"],"fname":"1f36c","uc":"1f36c","isCanonical": true},":lollipop:":{"unicode":["1f36d"],"fname":"1f36d","uc":"1f36d","isCanonical": true},":custard:":{"unicode":["1f36e"],"fname":"1f36e","uc":"1f36e","isCanonical": true},":pudding:":{"unicode":["1f36e"],"fname":"1f36e","uc":"1f36e","isCanonical": false},":flan:":{"unicode":["1f36e"],"fname":"1f36e","uc":"1f36e","isCanonical": false},":honey_pot:":{"unicode":["1f36f"],"fname":"1f36f","uc":"1f36f","isCanonical": true},":fingers_crossed:":{"unicode":["1f91e"],"fname":"1f91e","uc":"1f91e","isCanonical": true},":hand_with_index_and_middle_finger_crossed:":{"unicode":["1f91e"],"fname":"1f91e","uc":"1f91e","isCanonical": false},":cake:":{"unicode":["1f370"],"fname":"1f370","uc":"1f370","isCanonical": true},":bento:":{"unicode":["1f371"],"fname":"1f371","uc":"1f371","isCanonical": true},":stew:":{"unicode":["1f372"],"fname":"1f372","uc":"1f372","isCanonical": true},":handshake:":{"unicode":["1f91d"],"fname":"1f91d","uc":"1f91d","isCanonical": true},":shaking_hands:":{"unicode":["1f91d"],"fname":"1f91d","uc":"1f91d","isCanonical": false},":cooking:":{"unicode":["1f373"],"fname":"1f373","uc":"1f373","isCanonical": true},":fork_and_knife:":{"unicode":["1f374"],"fname":"1f374","uc":"1f374","isCanonical": true},":tea:":{"unicode":["1f375"],"fname":"1f375","uc":"1f375","isCanonical": true},":sake:":{"unicode":["1f376"],"fname":"1f376","uc":"1f376","isCanonical": true},":wine_glass:":{"unicode":["1f377"],"fname":"1f377","uc":"1f377","isCanonical": true},":cocktail:":{"unicode":["1f378"],"fname":"1f378","uc":"1f378","isCanonical": true},":tropical_drink:":{"unicode":["1f379"],"fname":"1f379","uc":"1f379","isCanonical": true},":beer:":{"unicode":["1f37a"],"fname":"1f37a","uc":"1f37a","isCanonical": true},":beers:":{"unicode":["1f37b"],"fname":"1f37b","uc":"1f37b","isCanonical": true},":ribbon:":{"unicode":["1f380"],"fname":"1f380","uc":"1f380","isCanonical": true},":gift:":{"unicode":["1f381"],"fname":"1f381","uc":"1f381","isCanonical": true},":birthday:":{"unicode":["1f382"],"fname":"1f382","uc":"1f382","isCanonical": true},":jack_o_lantern:":{"unicode":["1f383"],"fname":"1f383","uc":"1f383","isCanonical": true},":left_facing_fist:":{"unicode":["1f91b"],"fname":"1f91b","uc":"1f91b","isCanonical": true},":left_fist:":{"unicode":["1f91b"],"fname":"1f91b","uc":"1f91b","isCanonical": false},":right_facing_fist:":{"unicode":["1f91c"],"fname":"1f91c","uc":"1f91c","isCanonical": true},":right_fist:":{"unicode":["1f91c"],"fname":"1f91c","uc":"1f91c","isCanonical": false},":christmas_tree:":{"unicode":["1f384"],"fname":"1f384","uc":"1f384","isCanonical": true},":santa:":{"unicode":["1f385"],"fname":"1f385","uc":"1f385","isCanonical": true},":fireworks:":{"unicode":["1f386"],"fname":"1f386","uc":"1f386","isCanonical": true},":raised_back_of_hand:":{"unicode":["1f91a"],"fname":"1f91a","uc":"1f91a","isCanonical": true},":back_of_hand:":{"unicode":["1f91a"],"fname":"1f91a","uc":"1f91a","isCanonical": false},":sparkler:":{"unicode":["1f387"],"fname":"1f387","uc":"1f387","isCanonical": true},":balloon:":{"unicode":["1f388"],"fname":"1f388","uc":"1f388","isCanonical": true},":tada:":{"unicode":["1f389"],"fname":"1f389","uc":"1f389","isCanonical": true},":confetti_ball:":{"unicode":["1f38a"],"fname":"1f38a","uc":"1f38a","isCanonical": true},":tanabata_tree:":{"unicode":["1f38b"],"fname":"1f38b","uc":"1f38b","isCanonical": true},":crossed_flags:":{"unicode":["1f38c"],"fname":"1f38c","uc":"1f38c","isCanonical": true},":call_me:":{"unicode":["1f919"],"fname":"1f919","uc":"1f919","isCanonical": true},":call_me_hand:":{"unicode":["1f919"],"fname":"1f919","uc":"1f919","isCanonical": false},":bamboo:":{"unicode":["1f38d"],"fname":"1f38d","uc":"1f38d","isCanonical": true},":man_dancing:":{"unicode":["1f57a"],"fname":"1f57a","uc":"1f57a","isCanonical": true},":male_dancer:":{"unicode":["1f57a"],"fname":"1f57a","uc":"1f57a","isCanonical": false},":dolls:":{"unicode":["1f38e"],"fname":"1f38e","uc":"1f38e","isCanonical": true},":selfie:":{"unicode":["1f933"],"fname":"1f933","uc":"1f933","isCanonical": true},":flags:":{"unicode":["1f38f"],"fname":"1f38f","uc":"1f38f","isCanonical": true},":pregnant_woman:":{"unicode":["1f930"],"fname":"1f930","uc":"1f930","isCanonical": true},":expecting_woman:":{"unicode":["1f930"],"fname":"1f930","uc":"1f930","isCanonical": false},":wind_chime:":{"unicode":["1f390"],"fname":"1f390","uc":"1f390","isCanonical": true},":face_palm:":{"unicode":["1f926"],"fname":"1f926","uc":"1f926","isCanonical": true},":facepalm:":{"unicode":["1f926"],"fname":"1f926","uc":"1f926","isCanonical": false},":shrug:":{"unicode":["1f937"],"fname":"1f937","uc":"1f937","isCanonical": true},":rice_scene:":{"unicode":["1f391"],"fname":"1f391","uc":"1f391","isCanonical": true},":school_satchel:":{"unicode":["1f392"],"fname":"1f392","uc":"1f392","isCanonical": true},":mortar_board:":{"unicode":["1f393"],"fname":"1f393","uc":"1f393","isCanonical": true},":carousel_horse:":{"unicode":["1f3a0"],"fname":"1f3a0","uc":"1f3a0","isCanonical": true},":ferris_wheel:":{"unicode":["1f3a1"],"fname":"1f3a1","uc":"1f3a1","isCanonical": true},":roller_coaster:":{"unicode":["1f3a2"],"fname":"1f3a2","uc":"1f3a2","isCanonical": true},":fishing_pole_and_fish:":{"unicode":["1f3a3"],"fname":"1f3a3","uc":"1f3a3","isCanonical": true},":microphone:":{"unicode":["1f3a4"],"fname":"1f3a4","uc":"1f3a4","isCanonical": true},":movie_camera:":{"unicode":["1f3a5"],"fname":"1f3a5","uc":"1f3a5","isCanonical": true},":cinema:":{"unicode":["1f3a6"],"fname":"1f3a6","uc":"1f3a6","isCanonical": true},":headphones:":{"unicode":["1f3a7"],"fname":"1f3a7","uc":"1f3a7","isCanonical": true},":mrs_claus:":{"unicode":["1f936"],"fname":"1f936","uc":"1f936","isCanonical": true},":mother_christmas:":{"unicode":["1f936"],"fname":"1f936","uc":"1f936","isCanonical": false},":art:":{"unicode":["1f3a8"],"fname":"1f3a8","uc":"1f3a8","isCanonical": true},":man_in_tuxedo:":{"unicode":["1f935"],"fname":"1f935","uc":"1f935","isCanonical": true},":tophat:":{"unicode":["1f3a9"],"fname":"1f3a9","uc":"1f3a9","isCanonical": true},":circus_tent:":{"unicode":["1f3aa"],"fname":"1f3aa","uc":"1f3aa","isCanonical": true},":prince:":{"unicode":["1f934"],"fname":"1f934","uc":"1f934","isCanonical": true},":ticket:":{"unicode":["1f3ab"],"fname":"1f3ab","uc":"1f3ab","isCanonical": true},":clapper:":{"unicode":["1f3ac"],"fname":"1f3ac","uc":"1f3ac","isCanonical": true},":performing_arts:":{"unicode":["1f3ad"],"fname":"1f3ad","uc":"1f3ad","isCanonical": true},":sneezing_face:":{"unicode":["1f927"],"fname":"1f927","uc":"1f927","isCanonical": true},":sneeze:":{"unicode":["1f927"],"fname":"1f927","uc":"1f927","isCanonical": false},":video_game:":{"unicode":["1f3ae"],"fname":"1f3ae","uc":"1f3ae","isCanonical": true},":dart:":{"unicode":["1f3af"],"fname":"1f3af","uc":"1f3af","isCanonical": true},":slot_machine:":{"unicode":["1f3b0"],"fname":"1f3b0","uc":"1f3b0","isCanonical": true},":8ball:":{"unicode":["1f3b1"],"fname":"1f3b1","uc":"1f3b1","isCanonical": true},":game_die:":{"unicode":["1f3b2"],"fname":"1f3b2","uc":"1f3b2","isCanonical": true},":bowling:":{"unicode":["1f3b3"],"fname":"1f3b3","uc":"1f3b3","isCanonical": true},":flower_playing_cards:":{"unicode":["1f3b4"],"fname":"1f3b4","uc":"1f3b4","isCanonical": true},":lying_face:":{"unicode":["1f925"],"fname":"1f925","uc":"1f925","isCanonical": true},":liar:":{"unicode":["1f925"],"fname":"1f925","uc":"1f925","isCanonical": false},":musical_note:":{"unicode":["1f3b5"],"fname":"1f3b5","uc":"1f3b5","isCanonical": true},":notes:":{"unicode":["1f3b6"],"fname":"1f3b6","uc":"1f3b6","isCanonical": true},":saxophone:":{"unicode":["1f3b7"],"fname":"1f3b7","uc":"1f3b7","isCanonical": true},":drooling_face:":{"unicode":["1f924"],"fname":"1f924","uc":"1f924","isCanonical": true},":drool:":{"unicode":["1f924"],"fname":"1f924","uc":"1f924","isCanonical": false},":guitar:":{"unicode":["1f3b8"],"fname":"1f3b8","uc":"1f3b8","isCanonical": true},":musical_keyboard:":{"unicode":["1f3b9"],"fname":"1f3b9","uc":"1f3b9","isCanonical": true},":trumpet:":{"unicode":["1f3ba"],"fname":"1f3ba","uc":"1f3ba","isCanonical": true},":rofl:":{"unicode":["1f923"],"fname":"1f923","uc":"1f923","isCanonical": true},":rolling_on_the_floor_laughing:":{"unicode":["1f923"],"fname":"1f923","uc":"1f923","isCanonical": false},":violin:":{"unicode":["1f3bb"],"fname":"1f3bb","uc":"1f3bb","isCanonical": true},":musical_score:":{"unicode":["1f3bc"],"fname":"1f3bc","uc":"1f3bc","isCanonical": true},":running_shirt_with_sash:":{"unicode":["1f3bd"],"fname":"1f3bd","uc":"1f3bd","isCanonical": true},":nauseated_face:":{"unicode":["1f922"],"fname":"1f922","uc":"1f922","isCanonical": true},":sick:":{"unicode":["1f922"],"fname":"1f922","uc":"1f922","isCanonical": false},":tennis:":{"unicode":["1f3be"],"fname":"1f3be","uc":"1f3be","isCanonical": true},":ski:":{"unicode":["1f3bf"],"fname":"1f3bf","uc":"1f3bf","isCanonical": true},":basketball:":{"unicode":["1f3c0"],"fname":"1f3c0","uc":"1f3c0","isCanonical": true},":checkered_flag:":{"unicode":["1f3c1"],"fname":"1f3c1","uc":"1f3c1","isCanonical": true},":clown:":{"unicode":["1f921"],"fname":"1f921","uc":"1f921","isCanonical": true},":clown_face:":{"unicode":["1f921"],"fname":"1f921","uc":"1f921","isCanonical": false},":snowboarder:":{"unicode":["1f3c2"],"fname":"1f3c2","uc":"1f3c2","isCanonical": true},":runner:":{"unicode":["1f3c3"],"fname":"1f3c3","uc":"1f3c3","isCanonical": true},":surfer:":{"unicode":["1f3c4"],"fname":"1f3c4","uc":"1f3c4","isCanonical": true},":trophy:":{"unicode":["1f3c6"],"fname":"1f3c6","uc":"1f3c6","isCanonical": true},":football:":{"unicode":["1f3c8"],"fname":"1f3c8","uc":"1f3c8","isCanonical": true},":swimmer:":{"unicode":["1f3ca"],"fname":"1f3ca","uc":"1f3ca","isCanonical": true},":house:":{"unicode":["1f3e0"],"fname":"1f3e0","uc":"1f3e0","isCanonical": true},":house_with_garden:":{"unicode":["1f3e1"],"fname":"1f3e1","uc":"1f3e1","isCanonical": true},":office:":{"unicode":["1f3e2"],"fname":"1f3e2","uc":"1f3e2","isCanonical": true},":post_office:":{"unicode":["1f3e3"],"fname":"1f3e3","uc":"1f3e3","isCanonical": true},":hospital:":{"unicode":["1f3e5"],"fname":"1f3e5","uc":"1f3e5","isCanonical": true},":bank:":{"unicode":["1f3e6"],"fname":"1f3e6","uc":"1f3e6","isCanonical": true},":atm:":{"unicode":["1f3e7"],"fname":"1f3e7","uc":"1f3e7","isCanonical": true},":hotel:":{"unicode":["1f3e8"],"fname":"1f3e8","uc":"1f3e8","isCanonical": true},":love_hotel:":{"unicode":["1f3e9"],"fname":"1f3e9","uc":"1f3e9","isCanonical": true},":convenience_store:":{"unicode":["1f3ea"],"fname":"1f3ea","uc":"1f3ea","isCanonical": true},":school:":{"unicode":["1f3eb"],"fname":"1f3eb","uc":"1f3eb","isCanonical": true},":department_store:":{"unicode":["1f3ec"],"fname":"1f3ec","uc":"1f3ec","isCanonical": true},":cowboy:":{"unicode":["1f920"],"fname":"1f920","uc":"1f920","isCanonical": true},":face_with_cowboy_hat:":{"unicode":["1f920"],"fname":"1f920","uc":"1f920","isCanonical": false},":factory:":{"unicode":["1f3ed"],"fname":"1f3ed","uc":"1f3ed","isCanonical": true},":izakaya_lantern:":{"unicode":["1f3ee"],"fname":"1f3ee","uc":"1f3ee","isCanonical": true},":japanese_castle:":{"unicode":["1f3ef"],"fname":"1f3ef","uc":"1f3ef","isCanonical": true},":european_castle:":{"unicode":["1f3f0"],"fname":"1f3f0","uc":"1f3f0","isCanonical": true},":snail:":{"unicode":["1f40c"],"fname":"1f40c","uc":"1f40c","isCanonical": true},":snake:":{"unicode":["1f40d"],"fname":"1f40d","uc":"1f40d","isCanonical": true},":racehorse:":{"unicode":["1f40e"],"fname":"1f40e","uc":"1f40e","isCanonical": true},":sheep:":{"unicode":["1f411"],"fname":"1f411","uc":"1f411","isCanonical": true},":monkey:":{"unicode":["1f412"],"fname":"1f412","uc":"1f412","isCanonical": true},":chicken:":{"unicode":["1f414"],"fname":"1f414","uc":"1f414","isCanonical": true},":boar:":{"unicode":["1f417"],"fname":"1f417","uc":"1f417","isCanonical": true},":elephant:":{"unicode":["1f418"],"fname":"1f418","uc":"1f418","isCanonical": true},":octopus:":{"unicode":["1f419"],"fname":"1f419","uc":"1f419","isCanonical": true},":shell:":{"unicode":["1f41a"],"fname":"1f41a","uc":"1f41a","isCanonical": true},":bug:":{"unicode":["1f41b"],"fname":"1f41b","uc":"1f41b","isCanonical": true},":ant:":{"unicode":["1f41c"],"fname":"1f41c","uc":"1f41c","isCanonical": true},":bee:":{"unicode":["1f41d"],"fname":"1f41d","uc":"1f41d","isCanonical": true},":beetle:":{"unicode":["1f41e"],"fname":"1f41e","uc":"1f41e","isCanonical": true},":fish:":{"unicode":["1f41f"],"fname":"1f41f","uc":"1f41f","isCanonical": true},":tropical_fish:":{"unicode":["1f420"],"fname":"1f420","uc":"1f420","isCanonical": true},":blowfish:":{"unicode":["1f421"],"fname":"1f421","uc":"1f421","isCanonical": true},":turtle:":{"unicode":["1f422"],"fname":"1f422","uc":"1f422","isCanonical": true},":hatching_chick:":{"unicode":["1f423"],"fname":"1f423","uc":"1f423","isCanonical": true},":baby_chick:":{"unicode":["1f424"],"fname":"1f424","uc":"1f424","isCanonical": true},":hatched_chick:":{"unicode":["1f425"],"fname":"1f425","uc":"1f425","isCanonical": true},":bird:":{"unicode":["1f426"],"fname":"1f426","uc":"1f426","isCanonical": true},":penguin:":{"unicode":["1f427"],"fname":"1f427","uc":"1f427","isCanonical": true},":koala:":{"unicode":["1f428"],"fname":"1f428","uc":"1f428","isCanonical": true},":poodle:":{"unicode":["1f429"],"fname":"1f429","uc":"1f429","isCanonical": true},":camel:":{"unicode":["1f42b"],"fname":"1f42b","uc":"1f42b","isCanonical": true},":dolphin:":{"unicode":["1f42c"],"fname":"1f42c","uc":"1f42c","isCanonical": true},":mouse:":{"unicode":["1f42d"],"fname":"1f42d","uc":"1f42d","isCanonical": true},":cow:":{"unicode":["1f42e"],"fname":"1f42e","uc":"1f42e","isCanonical": true},":tiger:":{"unicode":["1f42f"],"fname":"1f42f","uc":"1f42f","isCanonical": true},":rabbit:":{"unicode":["1f430"],"fname":"1f430","uc":"1f430","isCanonical": true},":cat:":{"unicode":["1f431"],"fname":"1f431","uc":"1f431","isCanonical": true},":dragon_face:":{"unicode":["1f432"],"fname":"1f432","uc":"1f432","isCanonical": true},":whale:":{"unicode":["1f433"],"fname":"1f433","uc":"1f433","isCanonical": true},":horse:":{"unicode":["1f434"],"fname":"1f434","uc":"1f434","isCanonical": true},":monkey_face:":{"unicode":["1f435"],"fname":"1f435","uc":"1f435","isCanonical": true},":dog:":{"unicode":["1f436"],"fname":"1f436","uc":"1f436","isCanonical": true},":pig:":{"unicode":["1f437"],"fname":"1f437","uc":"1f437","isCanonical": true},":frog:":{"unicode":["1f438"],"fname":"1f438","uc":"1f438","isCanonical": true},":hamster:":{"unicode":["1f439"],"fname":"1f439","uc":"1f439","isCanonical": true},":wolf:":{"unicode":["1f43a"],"fname":"1f43a","uc":"1f43a","isCanonical": true},":bear:":{"unicode":["1f43b"],"fname":"1f43b","uc":"1f43b","isCanonical": true},":panda_face:":{"unicode":["1f43c"],"fname":"1f43c","uc":"1f43c","isCanonical": true},":pig_nose:":{"unicode":["1f43d"],"fname":"1f43d","uc":"1f43d","isCanonical": true},":feet:":{"unicode":["1f43e"],"fname":"1f43e","uc":"1f43e","isCanonical": true},":paw_prints:":{"unicode":["1f43e"],"fname":"1f43e","uc":"1f43e","isCanonical": false},":eyes:":{"unicode":["1f440"],"fname":"1f440","uc":"1f440","isCanonical": true},":ear:":{"unicode":["1f442"],"fname":"1f442","uc":"1f442","isCanonical": true},":nose:":{"unicode":["1f443"],"fname":"1f443","uc":"1f443","isCanonical": true},":lips:":{"unicode":["1f444"],"fname":"1f444","uc":"1f444","isCanonical": true},":tongue:":{"unicode":["1f445"],"fname":"1f445","uc":"1f445","isCanonical": true},":point_up_2:":{"unicode":["1f446"],"fname":"1f446","uc":"1f446","isCanonical": true},":point_down:":{"unicode":["1f447"],"fname":"1f447","uc":"1f447","isCanonical": true},":point_left:":{"unicode":["1f448"],"fname":"1f448","uc":"1f448","isCanonical": true},":point_right:":{"unicode":["1f449"],"fname":"1f449","uc":"1f449","isCanonical": true},":punch:":{"unicode":["1f44a"],"fname":"1f44a","uc":"1f44a","isCanonical": true},":wave:":{"unicode":["1f44b"],"fname":"1f44b","uc":"1f44b","isCanonical": true},":ok_hand:":{"unicode":["1f44c"],"fname":"1f44c","uc":"1f44c","isCanonical": true},":thumbsup:":{"unicode":["1f44d"],"fname":"1f44d","uc":"1f44d","isCanonical": true},":+1:":{"unicode":["1f44d"],"fname":"1f44d","uc":"1f44d","isCanonical": false},":thumbup:":{"unicode":["1f44d"],"fname":"1f44d","uc":"1f44d","isCanonical": false},":thumbsdown:":{"unicode":["1f44e"],"fname":"1f44e","uc":"1f44e","isCanonical": true},":-1:":{"unicode":["1f44e"],"fname":"1f44e","uc":"1f44e","isCanonical": false},":thumbdown:":{"unicode":["1f44e"],"fname":"1f44e","uc":"1f44e","isCanonical": false},":clap:":{"unicode":["1f44f"],"fname":"1f44f","uc":"1f44f","isCanonical": true},":open_hands:":{"unicode":["1f450"],"fname":"1f450","uc":"1f450","isCanonical": true},":crown:":{"unicode":["1f451"],"fname":"1f451","uc":"1f451","isCanonical": true},":womans_hat:":{"unicode":["1f452"],"fname":"1f452","uc":"1f452","isCanonical": true},":eyeglasses:":{"unicode":["1f453"],"fname":"1f453","uc":"1f453","isCanonical": true},":necktie:":{"unicode":["1f454"],"fname":"1f454","uc":"1f454","isCanonical": true},":shirt:":{"unicode":["1f455"],"fname":"1f455","uc":"1f455","isCanonical": true},":jeans:":{"unicode":["1f456"],"fname":"1f456","uc":"1f456","isCanonical": true},":dress:":{"unicode":["1f457"],"fname":"1f457","uc":"1f457","isCanonical": true},":kimono:":{"unicode":["1f458"],"fname":"1f458","uc":"1f458","isCanonical": true},":bikini:":{"unicode":["1f459"],"fname":"1f459","uc":"1f459","isCanonical": true},":womans_clothes:":{"unicode":["1f45a"],"fname":"1f45a","uc":"1f45a","isCanonical": true},":purse:":{"unicode":["1f45b"],"fname":"1f45b","uc":"1f45b","isCanonical": true},":handbag:":{"unicode":["1f45c"],"fname":"1f45c","uc":"1f45c","isCanonical": true},":pouch:":{"unicode":["1f45d"],"fname":"1f45d","uc":"1f45d","isCanonical": true},":mans_shoe:":{"unicode":["1f45e"],"fname":"1f45e","uc":"1f45e","isCanonical": true},":athletic_shoe:":{"unicode":["1f45f"],"fname":"1f45f","uc":"1f45f","isCanonical": true},":high_heel:":{"unicode":["1f460"],"fname":"1f460","uc":"1f460","isCanonical": true},":sandal:":{"unicode":["1f461"],"fname":"1f461","uc":"1f461","isCanonical": true},":boot:":{"unicode":["1f462"],"fname":"1f462","uc":"1f462","isCanonical": true},":footprints:":{"unicode":["1f463"],"fname":"1f463","uc":"1f463","isCanonical": true},":bust_in_silhouette:":{"unicode":["1f464"],"fname":"1f464","uc":"1f464","isCanonical": true},":boy:":{"unicode":["1f466"],"fname":"1f466","uc":"1f466","isCanonical": true},":girl:":{"unicode":["1f467"],"fname":"1f467","uc":"1f467","isCanonical": true},":man:":{"unicode":["1f468"],"fname":"1f468","uc":"1f468","isCanonical": true},":woman:":{"unicode":["1f469"],"fname":"1f469","uc":"1f469","isCanonical": true},":family:":{"unicode":["1f46a"],"fname":"1f46a","uc":"1f46a","isCanonical": true},":couple:":{"unicode":["1f46b"],"fname":"1f46b","uc":"1f46b","isCanonical": true},":cop:":{"unicode":["1f46e"],"fname":"1f46e","uc":"1f46e","isCanonical": true},":dancers:":{"unicode":["1f46f"],"fname":"1f46f","uc":"1f46f","isCanonical": true},":bride_with_veil:":{"unicode":["1f470"],"fname":"1f470","uc":"1f470","isCanonical": true},":person_with_blond_hair:":{"unicode":["1f471"],"fname":"1f471","uc":"1f471","isCanonical": true},":man_with_gua_pi_mao:":{"unicode":["1f472"],"fname":"1f472","uc":"1f472","isCanonical": true},":man_with_turban:":{"unicode":["1f473"],"fname":"1f473","uc":"1f473","isCanonical": true},":older_man:":{"unicode":["1f474"],"fname":"1f474","uc":"1f474","isCanonical": true},":older_woman:":{"unicode":["1f475"],"fname":"1f475","uc":"1f475","isCanonical": true},":grandma:":{"unicode":["1f475"],"fname":"1f475","uc":"1f475","isCanonical": false},":baby:":{"unicode":["1f476"],"fname":"1f476","uc":"1f476","isCanonical": true},":construction_worker:":{"unicode":["1f477"],"fname":"1f477","uc":"1f477","isCanonical": true},":princess:":{"unicode":["1f478"],"fname":"1f478","uc":"1f478","isCanonical": true},":japanese_ogre:":{"unicode":["1f479"],"fname":"1f479","uc":"1f479","isCanonical": true},":japanese_goblin:":{"unicode":["1f47a"],"fname":"1f47a","uc":"1f47a","isCanonical": true},":ghost:":{"unicode":["1f47b"],"fname":"1f47b","uc":"1f47b","isCanonical": true},":angel:":{"unicode":["1f47c"],"fname":"1f47c","uc":"1f47c","isCanonical": true},":alien:":{"unicode":["1f47d"],"fname":"1f47d","uc":"1f47d","isCanonical": true},":space_invader:":{"unicode":["1f47e"],"fname":"1f47e","uc":"1f47e","isCanonical": true},":imp:":{"unicode":["1f47f"],"fname":"1f47f","uc":"1f47f","isCanonical": true},":skull:":{"unicode":["1f480"],"fname":"1f480","uc":"1f480","isCanonical": true},":skeleton:":{"unicode":["1f480"],"fname":"1f480","uc":"1f480","isCanonical": false},":card_index:":{"unicode":["1f4c7"],"fname":"1f4c7","uc":"1f4c7","isCanonical": true},":information_desk_person:":{"unicode":["1f481"],"fname":"1f481","uc":"1f481","isCanonical": true},":guardsman:":{"unicode":["1f482"],"fname":"1f482","uc":"1f482","isCanonical": true},":dancer:":{"unicode":["1f483"],"fname":"1f483","uc":"1f483","isCanonical": true},":lipstick:":{"unicode":["1f484"],"fname":"1f484","uc":"1f484","isCanonical": true},":nail_care:":{"unicode":["1f485"],"fname":"1f485","uc":"1f485","isCanonical": true},":ledger:":{"unicode":["1f4d2"],"fname":"1f4d2","uc":"1f4d2","isCanonical": true},":massage:":{"unicode":["1f486"],"fname":"1f486","uc":"1f486","isCanonical": true},":notebook:":{"unicode":["1f4d3"],"fname":"1f4d3","uc":"1f4d3","isCanonical": true},":haircut:":{"unicode":["1f487"],"fname":"1f487","uc":"1f487","isCanonical": true},":notebook_with_decorative_cover:":{"unicode":["1f4d4"],"fname":"1f4d4","uc":"1f4d4","isCanonical": true},":barber:":{"unicode":["1f488"],"fname":"1f488","uc":"1f488","isCanonical": true},":closed_book:":{"unicode":["1f4d5"],"fname":"1f4d5","uc":"1f4d5","isCanonical": true},":syringe:":{"unicode":["1f489"],"fname":"1f489","uc":"1f489","isCanonical": true},":book:":{"unicode":["1f4d6"],"fname":"1f4d6","uc":"1f4d6","isCanonical": true},":pill:":{"unicode":["1f48a"],"fname":"1f48a","uc":"1f48a","isCanonical": true},":green_book:":{"unicode":["1f4d7"],"fname":"1f4d7","uc":"1f4d7","isCanonical": true},":kiss:":{"unicode":["1f48b"],"fname":"1f48b","uc":"1f48b","isCanonical": true},":blue_book:":{"unicode":["1f4d8"],"fname":"1f4d8","uc":"1f4d8","isCanonical": true},":love_letter:":{"unicode":["1f48c"],"fname":"1f48c","uc":"1f48c","isCanonical": true},":orange_book:":{"unicode":["1f4d9"],"fname":"1f4d9","uc":"1f4d9","isCanonical": true},":ring:":{"unicode":["1f48d"],"fname":"1f48d","uc":"1f48d","isCanonical": true},":books:":{"unicode":["1f4da"],"fname":"1f4da","uc":"1f4da","isCanonical": true},":gem:":{"unicode":["1f48e"],"fname":"1f48e","uc":"1f48e","isCanonical": true},":name_badge:":{"unicode":["1f4db"],"fname":"1f4db","uc":"1f4db","isCanonical": true},":couplekiss:":{"unicode":["1f48f"],"fname":"1f48f","uc":"1f48f","isCanonical": true},":scroll:":{"unicode":["1f4dc"],"fname":"1f4dc","uc":"1f4dc","isCanonical": true},":bouquet:":{"unicode":["1f490"],"fname":"1f490","uc":"1f490","isCanonical": true},":pencil:":{"unicode":["1f4dd"],"fname":"1f4dd","uc":"1f4dd","isCanonical": true},":couple_with_heart:":{"unicode":["1f491"],"fname":"1f491","uc":"1f491","isCanonical": true},":telephone_receiver:":{"unicode":["1f4de"],"fname":"1f4de","uc":"1f4de","isCanonical": true},":wedding:":{"unicode":["1f492"],"fname":"1f492","uc":"1f492","isCanonical": true},":pager:":{"unicode":["1f4df"],"fname":"1f4df","uc":"1f4df","isCanonical": true},":fax:":{"unicode":["1f4e0"],"fname":"1f4e0","uc":"1f4e0","isCanonical": true},":heartbeat:":{"unicode":["1f493"],"fname":"1f493","uc":"1f493","isCanonical": true},":satellite:":{"unicode":["1f4e1"],"fname":"1f4e1","uc":"1f4e1","isCanonical": true},":loudspeaker:":{"unicode":["1f4e2"],"fname":"1f4e2","uc":"1f4e2","isCanonical": true},":broken_heart:":{"unicode":["1f494"],"fname":"1f494","uc":"1f494","isCanonical": true},":mega:":{"unicode":["1f4e3"],"fname":"1f4e3","uc":"1f4e3","isCanonical": true},":outbox_tray:":{"unicode":["1f4e4"],"fname":"1f4e4","uc":"1f4e4","isCanonical": true},":two_hearts:":{"unicode":["1f495"],"fname":"1f495","uc":"1f495","isCanonical": true},":inbox_tray:":{"unicode":["1f4e5"],"fname":"1f4e5","uc":"1f4e5","isCanonical": true},":package:":{"unicode":["1f4e6"],"fname":"1f4e6","uc":"1f4e6","isCanonical": true},":sparkling_heart:":{"unicode":["1f496"],"fname":"1f496","uc":"1f496","isCanonical": true},":e-mail:":{"unicode":["1f4e7"],"fname":"1f4e7","uc":"1f4e7","isCanonical": true},":email:":{"unicode":["1f4e7"],"fname":"1f4e7","uc":"1f4e7","isCanonical": false},":incoming_envelope:":{"unicode":["1f4e8"],"fname":"1f4e8","uc":"1f4e8","isCanonical": true},":heartpulse:":{"unicode":["1f497"],"fname":"1f497","uc":"1f497","isCanonical": true},":envelope_with_arrow:":{"unicode":["1f4e9"],"fname":"1f4e9","uc":"1f4e9","isCanonical": true},":mailbox_closed:":{"unicode":["1f4ea"],"fname":"1f4ea","uc":"1f4ea","isCanonical": true},":cupid:":{"unicode":["1f498"],"fname":"1f498","uc":"1f498","isCanonical": true},":mailbox:":{"unicode":["1f4eb"],"fname":"1f4eb","uc":"1f4eb","isCanonical": true},":postbox:":{"unicode":["1f4ee"],"fname":"1f4ee","uc":"1f4ee","isCanonical": true},":blue_heart:":{"unicode":["1f499"],"fname":"1f499","uc":"1f499","isCanonical": true},":newspaper:":{"unicode":["1f4f0"],"fname":"1f4f0","uc":"1f4f0","isCanonical": true},":iphone:":{"unicode":["1f4f1"],"fname":"1f4f1","uc":"1f4f1","isCanonical": true},":green_heart:":{"unicode":["1f49a"],"fname":"1f49a","uc":"1f49a","isCanonical": true},":calling:":{"unicode":["1f4f2"],"fname":"1f4f2","uc":"1f4f2","isCanonical": true},":vibration_mode:":{"unicode":["1f4f3"],"fname":"1f4f3","uc":"1f4f3","isCanonical": true},":yellow_heart:":{"unicode":["1f49b"],"fname":"1f49b","uc":"1f49b","isCanonical": true},":mobile_phone_off:":{"unicode":["1f4f4"],"fname":"1f4f4","uc":"1f4f4","isCanonical": true},":signal_strength:":{"unicode":["1f4f6"],"fname":"1f4f6","uc":"1f4f6","isCanonical": true},":purple_heart:":{"unicode":["1f49c"],"fname":"1f49c","uc":"1f49c","isCanonical": true},":camera:":{"unicode":["1f4f7"],"fname":"1f4f7","uc":"1f4f7","isCanonical": true},":video_camera:":{"unicode":["1f4f9"],"fname":"1f4f9","uc":"1f4f9","isCanonical": true},":gift_heart:":{"unicode":["1f49d"],"fname":"1f49d","uc":"1f49d","isCanonical": true},":tv:":{"unicode":["1f4fa"],"fname":"1f4fa","uc":"1f4fa","isCanonical": true},":radio:":{"unicode":["1f4fb"],"fname":"1f4fb","uc":"1f4fb","isCanonical": true},":revolving_hearts:":{"unicode":["1f49e"],"fname":"1f49e","uc":"1f49e","isCanonical": true},":vhs:":{"unicode":["1f4fc"],"fname":"1f4fc","uc":"1f4fc","isCanonical": true},":arrows_clockwise:":{"unicode":["1f503"],"fname":"1f503","uc":"1f503","isCanonical": true},":heart_decoration:":{"unicode":["1f49f"],"fname":"1f49f","uc":"1f49f","isCanonical": true},":loud_sound:":{"unicode":["1f50a"],"fname":"1f50a","uc":"1f50a","isCanonical": true},":battery:":{"unicode":["1f50b"],"fname":"1f50b","uc":"1f50b","isCanonical": true},":diamond_shape_with_a_dot_inside:":{"unicode":["1f4a0"],"fname":"1f4a0","uc":"1f4a0","isCanonical": true},":electric_plug:":{"unicode":["1f50c"],"fname":"1f50c","uc":"1f50c","isCanonical": true},":mag:":{"unicode":["1f50d"],"fname":"1f50d","uc":"1f50d","isCanonical": true},":bulb:":{"unicode":["1f4a1"],"fname":"1f4a1","uc":"1f4a1","isCanonical": true},":mag_right:":{"unicode":["1f50e"],"fname":"1f50e","uc":"1f50e","isCanonical": true},":lock_with_ink_pen:":{"unicode":["1f50f"],"fname":"1f50f","uc":"1f50f","isCanonical": true},":anger:":{"unicode":["1f4a2"],"fname":"1f4a2","uc":"1f4a2","isCanonical": true},":closed_lock_with_key:":{"unicode":["1f510"],"fname":"1f510","uc":"1f510","isCanonical": true},":key:":{"unicode":["1f511"],"fname":"1f511","uc":"1f511","isCanonical": true},":bomb:":{"unicode":["1f4a3"],"fname":"1f4a3","uc":"1f4a3","isCanonical": true},":lock:":{"unicode":["1f512"],"fname":"1f512","uc":"1f512","isCanonical": true},":unlock:":{"unicode":["1f513"],"fname":"1f513","uc":"1f513","isCanonical": true},":zzz:":{"unicode":["1f4a4"],"fname":"1f4a4","uc":"1f4a4","isCanonical": true},":bell:":{"unicode":["1f514"],"fname":"1f514","uc":"1f514","isCanonical": true},":bookmark:":{"unicode":["1f516"],"fname":"1f516","uc":"1f516","isCanonical": true},":boom:":{"unicode":["1f4a5"],"fname":"1f4a5","uc":"1f4a5","isCanonical": true},":link:":{"unicode":["1f517"],"fname":"1f517","uc":"1f517","isCanonical": true},":radio_button:":{"unicode":["1f518"],"fname":"1f518","uc":"1f518","isCanonical": true},":sweat_drops:":{"unicode":["1f4a6"],"fname":"1f4a6","uc":"1f4a6","isCanonical": true},":back:":{"unicode":["1f519"],"fname":"1f519","uc":"1f519","isCanonical": true},":end:":{"unicode":["1f51a"],"fname":"1f51a","uc":"1f51a","isCanonical": true},":droplet:":{"unicode":["1f4a7"],"fname":"1f4a7","uc":"1f4a7","isCanonical": true},":on:":{"unicode":["1f51b"],"fname":"1f51b","uc":"1f51b","isCanonical": true},":soon:":{"unicode":["1f51c"],"fname":"1f51c","uc":"1f51c","isCanonical": true},":dash:":{"unicode":["1f4a8"],"fname":"1f4a8","uc":"1f4a8","isCanonical": true},":top:":{"unicode":["1f51d"],"fname":"1f51d","uc":"1f51d","isCanonical": true},":underage:":{"unicode":["1f51e"],"fname":"1f51e","uc":"1f51e","isCanonical": true},":poop:":{"unicode":["1f4a9"],"fname":"1f4a9","uc":"1f4a9","isCanonical": true},":shit:":{"unicode":["1f4a9"],"fname":"1f4a9","uc":"1f4a9","isCanonical": false},":hankey:":{"unicode":["1f4a9"],"fname":"1f4a9","uc":"1f4a9","isCanonical": false},":poo:":{"unicode":["1f4a9"],"fname":"1f4a9","uc":"1f4a9","isCanonical": false},":keycap_ten:":{"unicode":["1f51f"],"fname":"1f51f","uc":"1f51f","isCanonical": true},":muscle:":{"unicode":["1f4aa"],"fname":"1f4aa","uc":"1f4aa","isCanonical": true},":capital_abcd:":{"unicode":["1f520"],"fname":"1f520","uc":"1f520","isCanonical": true},":abcd:":{"unicode":["1f521"],"fname":"1f521","uc":"1f521","isCanonical": true},":dizzy:":{"unicode":["1f4ab"],"fname":"1f4ab","uc":"1f4ab","isCanonical": true},":1234:":{"unicode":["1f522"],"fname":"1f522","uc":"1f522","isCanonical": true},":symbols:":{"unicode":["1f523"],"fname":"1f523","uc":"1f523","isCanonical": true},":speech_balloon:":{"unicode":["1f4ac"],"fname":"1f4ac","uc":"1f4ac","isCanonical": true},":abc:":{"unicode":["1f524"],"fname":"1f524","uc":"1f524","isCanonical": true},":fire:":{"unicode":["1f525"],"fname":"1f525","uc":"1f525","isCanonical": true},":flame:":{"unicode":["1f525"],"fname":"1f525","uc":"1f525","isCanonical": false},":white_flower:":{"unicode":["1f4ae"],"fname":"1f4ae","uc":"1f4ae","isCanonical": true},":flashlight:":{"unicode":["1f526"],"fname":"1f526","uc":"1f526","isCanonical": true},":wrench:":{"unicode":["1f527"],"fname":"1f527","uc":"1f527","isCanonical": true},":100:":{"unicode":["1f4af"],"fname":"1f4af","uc":"1f4af","isCanonical": true},":hammer:":{"unicode":["1f528"],"fname":"1f528","uc":"1f528","isCanonical": true},":nut_and_bolt:":{"unicode":["1f529"],"fname":"1f529","uc":"1f529","isCanonical": true},":moneybag:":{"unicode":["1f4b0"],"fname":"1f4b0","uc":"1f4b0","isCanonical": true},":knife:":{"unicode":["1f52a"],"fname":"1f52a","uc":"1f52a","isCanonical": true},":gun:":{"unicode":["1f52b"],"fname":"1f52b","uc":"1f52b","isCanonical": true},":currency_exchange:":{"unicode":["1f4b1"],"fname":"1f4b1","uc":"1f4b1","isCanonical": true},":crystal_ball:":{"unicode":["1f52e"],"fname":"1f52e","uc":"1f52e","isCanonical": true},":heavy_dollar_sign:":{"unicode":["1f4b2"],"fname":"1f4b2","uc":"1f4b2","isCanonical": true},":six_pointed_star:":{"unicode":["1f52f"],"fname":"1f52f","uc":"1f52f","isCanonical": true},":credit_card:":{"unicode":["1f4b3"],"fname":"1f4b3","uc":"1f4b3","isCanonical": true},":beginner:":{"unicode":["1f530"],"fname":"1f530","uc":"1f530","isCanonical": true},":trident:":{"unicode":["1f531"],"fname":"1f531","uc":"1f531","isCanonical": true},":yen:":{"unicode":["1f4b4"],"fname":"1f4b4","uc":"1f4b4","isCanonical": true},":black_square_button:":{"unicode":["1f532"],"fname":"1f532","uc":"1f532","isCanonical": true},":white_square_button:":{"unicode":["1f533"],"fname":"1f533","uc":"1f533","isCanonical": true},":dollar:":{"unicode":["1f4b5"],"fname":"1f4b5","uc":"1f4b5","isCanonical": true},":red_circle:":{"unicode":["1f534"],"fname":"1f534","uc":"1f534","isCanonical": true},":blue_circle:":{"unicode":["1f535"],"fname":"1f535","uc":"1f535","isCanonical": true},":money_with_wings:":{"unicode":["1f4b8"],"fname":"1f4b8","uc":"1f4b8","isCanonical": true},":large_orange_diamond:":{"unicode":["1f536"],"fname":"1f536","uc":"1f536","isCanonical": true},":large_blue_diamond:":{"unicode":["1f537"],"fname":"1f537","uc":"1f537","isCanonical": true},":chart:":{"unicode":["1f4b9"],"fname":"1f4b9","uc":"1f4b9","isCanonical": true},":small_orange_diamond:":{"unicode":["1f538"],"fname":"1f538","uc":"1f538","isCanonical": true},":small_blue_diamond:":{"unicode":["1f539"],"fname":"1f539","uc":"1f539","isCanonical": true},":seat:":{"unicode":["1f4ba"],"fname":"1f4ba","uc":"1f4ba","isCanonical": true},":small_red_triangle:":{"unicode":["1f53a"],"fname":"1f53a","uc":"1f53a","isCanonical": true},":small_red_triangle_down:":{"unicode":["1f53b"],"fname":"1f53b","uc":"1f53b","isCanonical": true},":computer:":{"unicode":["1f4bb"],"fname":"1f4bb","uc":"1f4bb","isCanonical": true},":arrow_up_small:":{"unicode":["1f53c"],"fname":"1f53c","uc":"1f53c","isCanonical": true},":briefcase:":{"unicode":["1f4bc"],"fname":"1f4bc","uc":"1f4bc","isCanonical": true},":arrow_down_small:":{"unicode":["1f53d"],"fname":"1f53d","uc":"1f53d","isCanonical": true},":clock1:":{"unicode":["1f550"],"fname":"1f550","uc":"1f550","isCanonical": true},":minidisc:":{"unicode":["1f4bd"],"fname":"1f4bd","uc":"1f4bd","isCanonical": true},":clock2:":{"unicode":["1f551"],"fname":"1f551","uc":"1f551","isCanonical": true},":floppy_disk:":{"unicode":["1f4be"],"fname":"1f4be","uc":"1f4be","isCanonical": true},":clock3:":{"unicode":["1f552"],"fname":"1f552","uc":"1f552","isCanonical": true},":cd:":{"unicode":["1f4bf"],"fname":"1f4bf","uc":"1f4bf","isCanonical": true},":clock4:":{"unicode":["1f553"],"fname":"1f553","uc":"1f553","isCanonical": true},":dvd:":{"unicode":["1f4c0"],"fname":"1f4c0","uc":"1f4c0","isCanonical": true},":clock5:":{"unicode":["1f554"],"fname":"1f554","uc":"1f554","isCanonical": true},":clock6:":{"unicode":["1f555"],"fname":"1f555","uc":"1f555","isCanonical": true},":file_folder:":{"unicode":["1f4c1"],"fname":"1f4c1","uc":"1f4c1","isCanonical": true},":clock7:":{"unicode":["1f556"],"fname":"1f556","uc":"1f556","isCanonical": true},":clock8:":{"unicode":["1f557"],"fname":"1f557","uc":"1f557","isCanonical": true},":open_file_folder:":{"unicode":["1f4c2"],"fname":"1f4c2","uc":"1f4c2","isCanonical": true},":clock9:":{"unicode":["1f558"],"fname":"1f558","uc":"1f558","isCanonical": true},":clock10:":{"unicode":["1f559"],"fname":"1f559","uc":"1f559","isCanonical": true},":page_with_curl:":{"unicode":["1f4c3"],"fname":"1f4c3","uc":"1f4c3","isCanonical": true},":clock11:":{"unicode":["1f55a"],"fname":"1f55a","uc":"1f55a","isCanonical": true},":clock12:":{"unicode":["1f55b"],"fname":"1f55b","uc":"1f55b","isCanonical": true},":page_facing_up:":{"unicode":["1f4c4"],"fname":"1f4c4","uc":"1f4c4","isCanonical": true},":mount_fuji:":{"unicode":["1f5fb"],"fname":"1f5fb","uc":"1f5fb","isCanonical": true},":tokyo_tower:":{"unicode":["1f5fc"],"fname":"1f5fc","uc":"1f5fc","isCanonical": true},":date:":{"unicode":["1f4c5"],"fname":"1f4c5","uc":"1f4c5","isCanonical": true},":statue_of_liberty:":{"unicode":["1f5fd"],"fname":"1f5fd","uc":"1f5fd","isCanonical": true},":japan:":{"unicode":["1f5fe"],"fname":"1f5fe","uc":"1f5fe","isCanonical": true},":calendar:":{"unicode":["1f4c6"],"fname":"1f4c6","uc":"1f4c6","isCanonical": true},":moyai:":{"unicode":["1f5ff"],"fname":"1f5ff","uc":"1f5ff","isCanonical": true},":grin:":{"unicode":["1f601"],"fname":"1f601","uc":"1f601","isCanonical": true},":joy:":{"unicode":["1f602"],"fname":"1f602","uc":"1f602","isCanonical": true},":smiley:":{"unicode":["1f603"],"fname":"1f603","uc":"1f603","isCanonical": true},":chart_with_upwards_trend:":{"unicode":["1f4c8"],"fname":"1f4c8","uc":"1f4c8","isCanonical": true},":smile:":{"unicode":["1f604"],"fname":"1f604","uc":"1f604","isCanonical": true},":sweat_smile:":{"unicode":["1f605"],"fname":"1f605","uc":"1f605","isCanonical": true},":chart_with_downwards_trend:":{"unicode":["1f4c9"],"fname":"1f4c9","uc":"1f4c9","isCanonical": true},":laughing:":{"unicode":["1f606"],"fname":"1f606","uc":"1f606","isCanonical": true},":satisfied:":{"unicode":["1f606"],"fname":"1f606","uc":"1f606","isCanonical": false},":wink:":{"unicode":["1f609"],"fname":"1f609","uc":"1f609","isCanonical": true},":bar_chart:":{"unicode":["1f4ca"],"fname":"1f4ca","uc":"1f4ca","isCanonical": true},":blush:":{"unicode":["1f60a"],"fname":"1f60a","uc":"1f60a","isCanonical": true},":yum:":{"unicode":["1f60b"],"fname":"1f60b","uc":"1f60b","isCanonical": true},":clipboard:":{"unicode":["1f4cb"],"fname":"1f4cb","uc":"1f4cb","isCanonical": true},":relieved:":{"unicode":["1f60c"],"fname":"1f60c","uc":"1f60c","isCanonical": true},":heart_eyes:":{"unicode":["1f60d"],"fname":"1f60d","uc":"1f60d","isCanonical": true},":pushpin:":{"unicode":["1f4cc"],"fname":"1f4cc","uc":"1f4cc","isCanonical": true},":smirk:":{"unicode":["1f60f"],"fname":"1f60f","uc":"1f60f","isCanonical": true},":unamused:":{"unicode":["1f612"],"fname":"1f612","uc":"1f612","isCanonical": true},":round_pushpin:":{"unicode":["1f4cd"],"fname":"1f4cd","uc":"1f4cd","isCanonical": true},":sweat:":{"unicode":["1f613"],"fname":"1f613","uc":"1f613","isCanonical": true},":pensive:":{"unicode":["1f614"],"fname":"1f614","uc":"1f614","isCanonical": true},":paperclip:":{"unicode":["1f4ce"],"fname":"1f4ce","uc":"1f4ce","isCanonical": true},":confounded:":{"unicode":["1f616"],"fname":"1f616","uc":"1f616","isCanonical": true},":kissing_heart:":{"unicode":["1f618"],"fname":"1f618","uc":"1f618","isCanonical": true},":straight_ruler:":{"unicode":["1f4cf"],"fname":"1f4cf","uc":"1f4cf","isCanonical": true},":kissing_closed_eyes:":{"unicode":["1f61a"],"fname":"1f61a","uc":"1f61a","isCanonical": true},":stuck_out_tongue_winking_eye:":{"unicode":["1f61c"],"fname":"1f61c","uc":"1f61c","isCanonical": true},":triangular_ruler:":{"unicode":["1f4d0"],"fname":"1f4d0","uc":"1f4d0","isCanonical": true},":stuck_out_tongue_closed_eyes:":{"unicode":["1f61d"],"fname":"1f61d","uc":"1f61d","isCanonical": true},":disappointed:":{"unicode":["1f61e"],"fname":"1f61e","uc":"1f61e","isCanonical": true},":bookmark_tabs:":{"unicode":["1f4d1"],"fname":"1f4d1","uc":"1f4d1","isCanonical": true},":angry:":{"unicode":["1f620"],"fname":"1f620","uc":"1f620","isCanonical": true},":rage:":{"unicode":["1f621"],"fname":"1f621","uc":"1f621","isCanonical": true},":cry:":{"unicode":["1f622"],"fname":"1f622","uc":"1f622","isCanonical": true},":persevere:":{"unicode":["1f623"],"fname":"1f623","uc":"1f623","isCanonical": true},":triumph:":{"unicode":["1f624"],"fname":"1f624","uc":"1f624","isCanonical": true},":disappointed_relieved:":{"unicode":["1f625"],"fname":"1f625","uc":"1f625","isCanonical": true},":fearful:":{"unicode":["1f628"],"fname":"1f628","uc":"1f628","isCanonical": true},":weary:":{"unicode":["1f629"],"fname":"1f629","uc":"1f629","isCanonical": true},":sleepy:":{"unicode":["1f62a"],"fname":"1f62a","uc":"1f62a","isCanonical": true},":tired_face:":{"unicode":["1f62b"],"fname":"1f62b","uc":"1f62b","isCanonical": true},":sob:":{"unicode":["1f62d"],"fname":"1f62d","uc":"1f62d","isCanonical": true},":cold_sweat:":{"unicode":["1f630"],"fname":"1f630","uc":"1f630","isCanonical": true},":scream:":{"unicode":["1f631"],"fname":"1f631","uc":"1f631","isCanonical": true},":astonished:":{"unicode":["1f632"],"fname":"1f632","uc":"1f632","isCanonical": true},":flushed:":{"unicode":["1f633"],"fname":"1f633","uc":"1f633","isCanonical": true},":dizzy_face:":{"unicode":["1f635"],"fname":"1f635","uc":"1f635","isCanonical": true},":mask:":{"unicode":["1f637"],"fname":"1f637","uc":"1f637","isCanonical": true},":smile_cat:":{"unicode":["1f638"],"fname":"1f638","uc":"1f638","isCanonical": true},":joy_cat:":{"unicode":["1f639"],"fname":"1f639","uc":"1f639","isCanonical": true},":smiley_cat:":{"unicode":["1f63a"],"fname":"1f63a","uc":"1f63a","isCanonical": true},":heart_eyes_cat:":{"unicode":["1f63b"],"fname":"1f63b","uc":"1f63b","isCanonical": true},":smirk_cat:":{"unicode":["1f63c"],"fname":"1f63c","uc":"1f63c","isCanonical": true},":kissing_cat:":{"unicode":["1f63d"],"fname":"1f63d","uc":"1f63d","isCanonical": true},":pouting_cat:":{"unicode":["1f63e"],"fname":"1f63e","uc":"1f63e","isCanonical": true},":crying_cat_face:":{"unicode":["1f63f"],"fname":"1f63f","uc":"1f63f","isCanonical": true},":scream_cat:":{"unicode":["1f640"],"fname":"1f640","uc":"1f640","isCanonical": true},":no_good:":{"unicode":["1f645"],"fname":"1f645","uc":"1f645","isCanonical": true},":ok_woman:":{"unicode":["1f646"],"fname":"1f646","uc":"1f646","isCanonical": true},":bow:":{"unicode":["1f647"],"fname":"1f647","uc":"1f647","isCanonical": true},":see_no_evil:":{"unicode":["1f648"],"fname":"1f648","uc":"1f648","isCanonical": true},":hear_no_evil:":{"unicode":["1f649"],"fname":"1f649","uc":"1f649","isCanonical": true},":speak_no_evil:":{"unicode":["1f64a"],"fname":"1f64a","uc":"1f64a","isCanonical": true},":raising_hand:":{"unicode":["1f64b"],"fname":"1f64b","uc":"1f64b","isCanonical": true},":raised_hands:":{"unicode":["1f64c"],"fname":"1f64c","uc":"1f64c","isCanonical": true},":person_frowning:":{"unicode":["1f64d"],"fname":"1f64d","uc":"1f64d","isCanonical": true},":person_with_pouting_face:":{"unicode":["1f64e"],"fname":"1f64e","uc":"1f64e","isCanonical": true},":pray:":{"unicode":["1f64f"],"fname":"1f64f","uc":"1f64f","isCanonical": true},":rocket:":{"unicode":["1f680"],"fname":"1f680","uc":"1f680","isCanonical": true},":railway_car:":{"unicode":["1f683"],"fname":"1f683","uc":"1f683","isCanonical": true},":bullettrain_side:":{"unicode":["1f684"],"fname":"1f684","uc":"1f684","isCanonical": true},":bullettrain_front:":{"unicode":["1f685"],"fname":"1f685","uc":"1f685","isCanonical": true},":metro:":{"unicode":["1f687"],"fname":"1f687","uc":"1f687","isCanonical": true},":station:":{"unicode":["1f689"],"fname":"1f689","uc":"1f689","isCanonical": true},":bus:":{"unicode":["1f68c"],"fname":"1f68c","uc":"1f68c","isCanonical": true},":busstop:":{"unicode":["1f68f"],"fname":"1f68f","uc":"1f68f","isCanonical": true},":ambulance:":{"unicode":["1f691"],"fname":"1f691","uc":"1f691","isCanonical": true},":fire_engine:":{"unicode":["1f692"],"fname":"1f692","uc":"1f692","isCanonical": true},":police_car:":{"unicode":["1f693"],"fname":"1f693","uc":"1f693","isCanonical": true},":taxi:":{"unicode":["1f695"],"fname":"1f695","uc":"1f695","isCanonical": true},":red_car:":{"unicode":["1f697"],"fname":"1f697","uc":"1f697","isCanonical": true},":blue_car:":{"unicode":["1f699"],"fname":"1f699","uc":"1f699","isCanonical": true},":truck:":{"unicode":["1f69a"],"fname":"1f69a","uc":"1f69a","isCanonical": true},":ship:":{"unicode":["1f6a2"],"fname":"1f6a2","uc":"1f6a2","isCanonical": true},":speedboat:":{"unicode":["1f6a4"],"fname":"1f6a4","uc":"1f6a4","isCanonical": true},":traffic_light:":{"unicode":["1f6a5"],"fname":"1f6a5","uc":"1f6a5","isCanonical": true},":construction:":{"unicode":["1f6a7"],"fname":"1f6a7","uc":"1f6a7","isCanonical": true},":rotating_light:":{"unicode":["1f6a8"],"fname":"1f6a8","uc":"1f6a8","isCanonical": true},":triangular_flag_on_post:":{"unicode":["1f6a9"],"fname":"1f6a9","uc":"1f6a9","isCanonical": true},":door:":{"unicode":["1f6aa"],"fname":"1f6aa","uc":"1f6aa","isCanonical": true},":no_entry_sign:":{"unicode":["1f6ab"],"fname":"1f6ab","uc":"1f6ab","isCanonical": true},":smoking:":{"unicode":["1f6ac"],"fname":"1f6ac","uc":"1f6ac","isCanonical": true},":no_smoking:":{"unicode":["1f6ad"],"fname":"1f6ad","uc":"1f6ad","isCanonical": true},":bike:":{"unicode":["1f6b2"],"fname":"1f6b2","uc":"1f6b2","isCanonical": true},":walking:":{"unicode":["1f6b6"],"fname":"1f6b6","uc":"1f6b6","isCanonical": true},":mens:":{"unicode":["1f6b9"],"fname":"1f6b9","uc":"1f6b9","isCanonical": true},":womens:":{"unicode":["1f6ba"],"fname":"1f6ba","uc":"1f6ba","isCanonical": true},":restroom:":{"unicode":["1f6bb"],"fname":"1f6bb","uc":"1f6bb","isCanonical": true},":baby_symbol:":{"unicode":["1f6bc"],"fname":"1f6bc","uc":"1f6bc","isCanonical": true},":toilet:":{"unicode":["1f6bd"],"fname":"1f6bd","uc":"1f6bd","isCanonical": true},":wc:":{"unicode":["1f6be"],"fname":"1f6be","uc":"1f6be","isCanonical": true},":bath:":{"unicode":["1f6c0"],"fname":"1f6c0","uc":"1f6c0","isCanonical": true},":metal:":{"unicode":["1f918"],"fname":"1f918","uc":"1f918","isCanonical": true},":sign_of_the_horns:":{"unicode":["1f918"],"fname":"1f918","uc":"1f918","isCanonical": false},":grinning:":{"unicode":["1f600"],"fname":"1f600","uc":"1f600","isCanonical": true},":innocent:":{"unicode":["1f607"],"fname":"1f607","uc":"1f607","isCanonical": true},":smiling_imp:":{"unicode":["1f608"],"fname":"1f608","uc":"1f608","isCanonical": true},":sunglasses:":{"unicode":["1f60e"],"fname":"1f60e","uc":"1f60e","isCanonical": true},":neutral_face:":{"unicode":["1f610"],"fname":"1f610","uc":"1f610","isCanonical": true},":expressionless:":{"unicode":["1f611"],"fname":"1f611","uc":"1f611","isCanonical": true},":confused:":{"unicode":["1f615"],"fname":"1f615","uc":"1f615","isCanonical": true},":kissing:":{"unicode":["1f617"],"fname":"1f617","uc":"1f617","isCanonical": true},":kissing_smiling_eyes:":{"unicode":["1f619"],"fname":"1f619","uc":"1f619","isCanonical": true},":stuck_out_tongue:":{"unicode":["1f61b"],"fname":"1f61b","uc":"1f61b","isCanonical": true},":worried:":{"unicode":["1f61f"],"fname":"1f61f","uc":"1f61f","isCanonical": true},":frowning:":{"unicode":["1f626"],"fname":"1f626","uc":"1f626","isCanonical": true},":anguished:":{"unicode":["1f627"],"fname":"1f627","uc":"1f627","isCanonical": true},":grimacing:":{"unicode":["1f62c"],"fname":"1f62c","uc":"1f62c","isCanonical": true},":open_mouth:":{"unicode":["1f62e"],"fname":"1f62e","uc":"1f62e","isCanonical": true},":hushed:":{"unicode":["1f62f"],"fname":"1f62f","uc":"1f62f","isCanonical": true},":sleeping:":{"unicode":["1f634"],"fname":"1f634","uc":"1f634","isCanonical": true},":no_mouth:":{"unicode":["1f636"],"fname":"1f636","uc":"1f636","isCanonical": true},":helicopter:":{"unicode":["1f681"],"fname":"1f681","uc":"1f681","isCanonical": true},":steam_locomotive:":{"unicode":["1f682"],"fname":"1f682","uc":"1f682","isCanonical": true},":train2:":{"unicode":["1f686"],"fname":"1f686","uc":"1f686","isCanonical": true},":light_rail:":{"unicode":["1f688"],"fname":"1f688","uc":"1f688","isCanonical": true},":tram:":{"unicode":["1f68a"],"fname":"1f68a","uc":"1f68a","isCanonical": true},":oncoming_bus:":{"unicode":["1f68d"],"fname":"1f68d","uc":"1f68d","isCanonical": true},":trolleybus:":{"unicode":["1f68e"],"fname":"1f68e","uc":"1f68e","isCanonical": true},":minibus:":{"unicode":["1f690"],"fname":"1f690","uc":"1f690","isCanonical": true},":oncoming_police_car:":{"unicode":["1f694"],"fname":"1f694","uc":"1f694","isCanonical": true},":oncoming_taxi:":{"unicode":["1f696"],"fname":"1f696","uc":"1f696","isCanonical": true},":oncoming_automobile:":{"unicode":["1f698"],"fname":"1f698","uc":"1f698","isCanonical": true},":articulated_lorry:":{"unicode":["1f69b"],"fname":"1f69b","uc":"1f69b","isCanonical": true},":tractor:":{"unicode":["1f69c"],"fname":"1f69c","uc":"1f69c","isCanonical": true},":monorail:":{"unicode":["1f69d"],"fname":"1f69d","uc":"1f69d","isCanonical": true},":mountain_railway:":{"unicode":["1f69e"],"fname":"1f69e","uc":"1f69e","isCanonical": true},":suspension_railway:":{"unicode":["1f69f"],"fname":"1f69f","uc":"1f69f","isCanonical": true},":mountain_cableway:":{"unicode":["1f6a0"],"fname":"1f6a0","uc":"1f6a0","isCanonical": true},":aerial_tramway:":{"unicode":["1f6a1"],"fname":"1f6a1","uc":"1f6a1","isCanonical": true},":rowboat:":{"unicode":["1f6a3"],"fname":"1f6a3","uc":"1f6a3","isCanonical": true},":vertical_traffic_light:":{"unicode":["1f6a6"],"fname":"1f6a6","uc":"1f6a6","isCanonical": true},":put_litter_in_its_place:":{"unicode":["1f6ae"],"fname":"1f6ae","uc":"1f6ae","isCanonical": true},":do_not_litter:":{"unicode":["1f6af"],"fname":"1f6af","uc":"1f6af","isCanonical": true},":potable_water:":{"unicode":["1f6b0"],"fname":"1f6b0","uc":"1f6b0","isCanonical": true},":non-potable_water:":{"unicode":["1f6b1"],"fname":"1f6b1","uc":"1f6b1","isCanonical": true},":no_bicycles:":{"unicode":["1f6b3"],"fname":"1f6b3","uc":"1f6b3","isCanonical": true},":bicyclist:":{"unicode":["1f6b4"],"fname":"1f6b4","uc":"1f6b4","isCanonical": true},":mountain_bicyclist:":{"unicode":["1f6b5"],"fname":"1f6b5","uc":"1f6b5","isCanonical": true},":no_pedestrians:":{"unicode":["1f6b7"],"fname":"1f6b7","uc":"1f6b7","isCanonical": true},":children_crossing:":{"unicode":["1f6b8"],"fname":"1f6b8","uc":"1f6b8","isCanonical": true},":shower:":{"unicode":["1f6bf"],"fname":"1f6bf","uc":"1f6bf","isCanonical": true},":bathtub:":{"unicode":["1f6c1"],"fname":"1f6c1","uc":"1f6c1","isCanonical": true},":passport_control:":{"unicode":["1f6c2"],"fname":"1f6c2","uc":"1f6c2","isCanonical": true},":customs:":{"unicode":["1f6c3"],"fname":"1f6c3","uc":"1f6c3","isCanonical": true},":baggage_claim:":{"unicode":["1f6c4"],"fname":"1f6c4","uc":"1f6c4","isCanonical": true},":left_luggage:":{"unicode":["1f6c5"],"fname":"1f6c5","uc":"1f6c5","isCanonical": true},":earth_africa:":{"unicode":["1f30d"],"fname":"1f30d","uc":"1f30d","isCanonical": true},":earth_americas:":{"unicode":["1f30e"],"fname":"1f30e","uc":"1f30e","isCanonical": true},":globe_with_meridians:":{"unicode":["1f310"],"fname":"1f310","uc":"1f310","isCanonical": true},":waxing_crescent_moon:":{"unicode":["1f312"],"fname":"1f312","uc":"1f312","isCanonical": true},":waning_gibbous_moon:":{"unicode":["1f316"],"fname":"1f316","uc":"1f316","isCanonical": true},":last_quarter_moon:":{"unicode":["1f317"],"fname":"1f317","uc":"1f317","isCanonical": true},":waning_crescent_moon:":{"unicode":["1f318"],"fname":"1f318","uc":"1f318","isCanonical": true},":new_moon_with_face:":{"unicode":["1f31a"],"fname":"1f31a","uc":"1f31a","isCanonical": true},":last_quarter_moon_with_face:":{"unicode":["1f31c"],"fname":"1f31c","uc":"1f31c","isCanonical": true},":full_moon_with_face:":{"unicode":["1f31d"],"fname":"1f31d","uc":"1f31d","isCanonical": true},":sun_with_face:":{"unicode":["1f31e"],"fname":"1f31e","uc":"1f31e","isCanonical": true},":evergreen_tree:":{"unicode":["1f332"],"fname":"1f332","uc":"1f332","isCanonical": true},":deciduous_tree:":{"unicode":["1f333"],"fname":"1f333","uc":"1f333","isCanonical": true},":lemon:":{"unicode":["1f34b"],"fname":"1f34b","uc":"1f34b","isCanonical": true},":pear:":{"unicode":["1f350"],"fname":"1f350","uc":"1f350","isCanonical": true},":baby_bottle:":{"unicode":["1f37c"],"fname":"1f37c","uc":"1f37c","isCanonical": true},":horse_racing:":{"unicode":["1f3c7"],"fname":"1f3c7","uc":"1f3c7","isCanonical": true},":rugby_football:":{"unicode":["1f3c9"],"fname":"1f3c9","uc":"1f3c9","isCanonical": true},":european_post_office:":{"unicode":["1f3e4"],"fname":"1f3e4","uc":"1f3e4","isCanonical": true},":rat:":{"unicode":["1f400"],"fname":"1f400","uc":"1f400","isCanonical": true},":mouse2:":{"unicode":["1f401"],"fname":"1f401","uc":"1f401","isCanonical": true},":ox:":{"unicode":["1f402"],"fname":"1f402","uc":"1f402","isCanonical": true},":water_buffalo:":{"unicode":["1f403"],"fname":"1f403","uc":"1f403","isCanonical": true},":cow2:":{"unicode":["1f404"],"fname":"1f404","uc":"1f404","isCanonical": true},":tiger2:":{"unicode":["1f405"],"fname":"1f405","uc":"1f405","isCanonical": true},":leopard:":{"unicode":["1f406"],"fname":"1f406","uc":"1f406","isCanonical": true},":rabbit2:":{"unicode":["1f407"],"fname":"1f407","uc":"1f407","isCanonical": true},":cat2:":{"unicode":["1f408"],"fname":"1f408","uc":"1f408","isCanonical": true},":dragon:":{"unicode":["1f409"],"fname":"1f409","uc":"1f409","isCanonical": true},":crocodile:":{"unicode":["1f40a"],"fname":"1f40a","uc":"1f40a","isCanonical": true},":whale2:":{"unicode":["1f40b"],"fname":"1f40b","uc":"1f40b","isCanonical": true},":ram:":{"unicode":["1f40f"],"fname":"1f40f","uc":"1f40f","isCanonical": true},":goat:":{"unicode":["1f410"],"fname":"1f410","uc":"1f410","isCanonical": true},":rooster:":{"unicode":["1f413"],"fname":"1f413","uc":"1f413","isCanonical": true},":dog2:":{"unicode":["1f415"],"fname":"1f415","uc":"1f415","isCanonical": true},":pig2:":{"unicode":["1f416"],"fname":"1f416","uc":"1f416","isCanonical": true},":dromedary_camel:":{"unicode":["1f42a"],"fname":"1f42a","uc":"1f42a","isCanonical": true},":busts_in_silhouette:":{"unicode":["1f465"],"fname":"1f465","uc":"1f465","isCanonical": true},":two_men_holding_hands:":{"unicode":["1f46c"],"fname":"1f46c","uc":"1f46c","isCanonical": true},":two_women_holding_hands:":{"unicode":["1f46d"],"fname":"1f46d","uc":"1f46d","isCanonical": true},":thought_balloon:":{"unicode":["1f4ad"],"fname":"1f4ad","uc":"1f4ad","isCanonical": true},":euro:":{"unicode":["1f4b6"],"fname":"1f4b6","uc":"1f4b6","isCanonical": true},":pound:":{"unicode":["1f4b7"],"fname":"1f4b7","uc":"1f4b7","isCanonical": true},":mailbox_with_mail:":{"unicode":["1f4ec"],"fname":"1f4ec","uc":"1f4ec","isCanonical": true},":mailbox_with_no_mail:":{"unicode":["1f4ed"],"fname":"1f4ed","uc":"1f4ed","isCanonical": true},":postal_horn:":{"unicode":["1f4ef"],"fname":"1f4ef","uc":"1f4ef","isCanonical": true},":no_mobile_phones:":{"unicode":["1f4f5"],"fname":"1f4f5","uc":"1f4f5","isCanonical": true},":twisted_rightwards_arrows:":{"unicode":["1f500"],"fname":"1f500","uc":"1f500","isCanonical": true},":repeat:":{"unicode":["1f501"],"fname":"1f501","uc":"1f501","isCanonical": true},":repeat_one:":{"unicode":["1f502"],"fname":"1f502","uc":"1f502","isCanonical": true},":arrows_counterclockwise:":{"unicode":["1f504"],"fname":"1f504","uc":"1f504","isCanonical": true},":low_brightness:":{"unicode":["1f505"],"fname":"1f505","uc":"1f505","isCanonical": true},":high_brightness:":{"unicode":["1f506"],"fname":"1f506","uc":"1f506","isCanonical": true},":mute:":{"unicode":["1f507"],"fname":"1f507","uc":"1f507","isCanonical": true},":sound:":{"unicode":["1f509"],"fname":"1f509","uc":"1f509","isCanonical": true},":no_bell:":{"unicode":["1f515"],"fname":"1f515","uc":"1f515","isCanonical": true},":microscope:":{"unicode":["1f52c"],"fname":"1f52c","uc":"1f52c","isCanonical": true},":telescope:":{"unicode":["1f52d"],"fname":"1f52d","uc":"1f52d","isCanonical": true},":clock130:":{"unicode":["1f55c"],"fname":"1f55c","uc":"1f55c","isCanonical": true},":clock230:":{"unicode":["1f55d"],"fname":"1f55d","uc":"1f55d","isCanonical": true},":clock330:":{"unicode":["1f55e"],"fname":"1f55e","uc":"1f55e","isCanonical": true},":clock430:":{"unicode":["1f55f"],"fname":"1f55f","uc":"1f55f","isCanonical": true},":clock530:":{"unicode":["1f560"],"fname":"1f560","uc":"1f560","isCanonical": true},":clock630:":{"unicode":["1f561"],"fname":"1f561","uc":"1f561","isCanonical": true},":clock730:":{"unicode":["1f562"],"fname":"1f562","uc":"1f562","isCanonical": true},":clock830:":{"unicode":["1f563"],"fname":"1f563","uc":"1f563","isCanonical": true},":clock930:":{"unicode":["1f564"],"fname":"1f564","uc":"1f564","isCanonical": true},":clock1030:":{"unicode":["1f565"],"fname":"1f565","uc":"1f565","isCanonical": true},":clock1130:":{"unicode":["1f566"],"fname":"1f566","uc":"1f566","isCanonical": true},":clock1230:":{"unicode":["1f567"],"fname":"1f567","uc":"1f567","isCanonical": true},":speaker:":{"unicode":["1f508"],"fname":"1f508","uc":"1f508","isCanonical": true},":train:":{"unicode":["1f68b"],"fname":"1f68b","uc":"1f68b","isCanonical": true},":medal:":{"unicode":["1f3c5"],"fname":"1f3c5","uc":"1f3c5","isCanonical": true},":sports_medal:":{"unicode":["1f3c5"],"fname":"1f3c5","uc":"1f3c5","isCanonical": false},":flag_black:":{"unicode":["1f3f4"],"fname":"1f3f4","uc":"1f3f4","isCanonical": true},":waving_black_flag:":{"unicode":["1f3f4"],"fname":"1f3f4","uc":"1f3f4","isCanonical": false},":camera_with_flash:":{"unicode":["1f4f8"],"fname":"1f4f8","uc":"1f4f8","isCanonical": true},":sleeping_accommodation:":{"unicode":["1f6cc"],"fname":"1f6cc","uc":"1f6cc","isCanonical": true},":middle_finger:":{"unicode":["1f595"],"fname":"1f595","uc":"1f595","isCanonical": true},":reversed_hand_with_middle_finger_extended:":{"unicode":["1f595"],"fname":"1f595","uc":"1f595","isCanonical": false},":vulcan:":{"unicode":["1f596"],"fname":"1f596","uc":"1f596","isCanonical": true},":raised_hand_with_part_between_middle_and_ring_fingers:":{"unicode":["1f596"],"fname":"1f596","uc":"1f596","isCanonical": false},":slight_frown:":{"unicode":["1f641"],"fname":"1f641","uc":"1f641","isCanonical": true},":slightly_frowning_face:":{"unicode":["1f641"],"fname":"1f641","uc":"1f641","isCanonical": false},":slight_smile:":{"unicode":["1f642"],"fname":"1f642","uc":"1f642","isCanonical": true},":slightly_smiling_face:":{"unicode":["1f642"],"fname":"1f642","uc":"1f642","isCanonical": false},":airplane_departure:":{"unicode":["1f6eb"],"fname":"1f6eb","uc":"1f6eb","isCanonical": true},":airplane_arriving:":{"unicode":["1f6ec"],"fname":"1f6ec","uc":"1f6ec","isCanonical": true},":tone1:":{"unicode":["1f3fb"],"fname":"1f3fb","uc":"1f3fb","isCanonical": true},":tone2:":{"unicode":["1f3fc"],"fname":"1f3fc","uc":"1f3fc","isCanonical": true},":tone3:":{"unicode":["1f3fd"],"fname":"1f3fd","uc":"1f3fd","isCanonical": true},":tone4:":{"unicode":["1f3fe"],"fname":"1f3fe","uc":"1f3fe","isCanonical": true},":tone5:":{"unicode":["1f3ff"],"fname":"1f3ff","uc":"1f3ff","isCanonical": true},":upside_down:":{"unicode":["1f643"],"fname":"1f643","uc":"1f643","isCanonical": true},":upside_down_face:":{"unicode":["1f643"],"fname":"1f643","uc":"1f643","isCanonical": false},":money_mouth:":{"unicode":["1f911"],"fname":"1f911","uc":"1f911","isCanonical": true},":money_mouth_face:":{"unicode":["1f911"],"fname":"1f911","uc":"1f911","isCanonical": false},":nerd:":{"unicode":["1f913"],"fname":"1f913","uc":"1f913","isCanonical": true},":nerd_face:":{"unicode":["1f913"],"fname":"1f913","uc":"1f913","isCanonical": false},":hugging:":{"unicode":["1f917"],"fname":"1f917","uc":"1f917","isCanonical": true},":hugging_face:":{"unicode":["1f917"],"fname":"1f917","uc":"1f917","isCanonical": false},":rolling_eyes:":{"unicode":["1f644"],"fname":"1f644","uc":"1f644","isCanonical": true},":face_with_rolling_eyes:":{"unicode":["1f644"],"fname":"1f644","uc":"1f644","isCanonical": false},":thinking:":{"unicode":["1f914"],"fname":"1f914","uc":"1f914","isCanonical": true},":thinking_face:":{"unicode":["1f914"],"fname":"1f914","uc":"1f914","isCanonical": false},":zipper_mouth:":{"unicode":["1f910"],"fname":"1f910","uc":"1f910","isCanonical": true},":zipper_mouth_face:":{"unicode":["1f910"],"fname":"1f910","uc":"1f910","isCanonical": false},":thermometer_face:":{"unicode":["1f912"],"fname":"1f912","uc":"1f912","isCanonical": true},":face_with_thermometer:":{"unicode":["1f912"],"fname":"1f912","uc":"1f912","isCanonical": false},":head_bandage:":{"unicode":["1f915"],"fname":"1f915","uc":"1f915","isCanonical": true},":face_with_head_bandage:":{"unicode":["1f915"],"fname":"1f915","uc":"1f915","isCanonical": false},":robot:":{"unicode":["1f916"],"fname":"1f916","uc":"1f916","isCanonical": true},":robot_face:":{"unicode":["1f916"],"fname":"1f916","uc":"1f916","isCanonical": false},":lion_face:":{"unicode":["1f981"],"fname":"1f981","uc":"1f981","isCanonical": true},":lion:":{"unicode":["1f981"],"fname":"1f981","uc":"1f981","isCanonical": false},":unicorn:":{"unicode":["1f984"],"fname":"1f984","uc":"1f984","isCanonical": true},":unicorn_face:":{"unicode":["1f984"],"fname":"1f984","uc":"1f984","isCanonical": false},":scorpion:":{"unicode":["1f982"],"fname":"1f982","uc":"1f982","isCanonical": true},":crab:":{"unicode":["1f980"],"fname":"1f980","uc":"1f980","isCanonical": true},":turkey:":{"unicode":["1f983"],"fname":"1f983","uc":"1f983","isCanonical": true},":cheese:":{"unicode":["1f9c0"],"fname":"1f9c0","uc":"1f9c0","isCanonical": true},":cheese_wedge:":{"unicode":["1f9c0"],"fname":"1f9c0","uc":"1f9c0","isCanonical": false},":hotdog:":{"unicode":["1f32d"],"fname":"1f32d","uc":"1f32d","isCanonical": true},":hot_dog:":{"unicode":["1f32d"],"fname":"1f32d","uc":"1f32d","isCanonical": false},":taco:":{"unicode":["1f32e"],"fname":"1f32e","uc":"1f32e","isCanonical": true},":burrito:":{"unicode":["1f32f"],"fname":"1f32f","uc":"1f32f","isCanonical": true},":popcorn:":{"unicode":["1f37f"],"fname":"1f37f","uc":"1f37f","isCanonical": true},":champagne:":{"unicode":["1f37e"],"fname":"1f37e","uc":"1f37e","isCanonical": true},":bottle_with_popping_cork:":{"unicode":["1f37e"],"fname":"1f37e","uc":"1f37e","isCanonical": false},":bow_and_arrow:":{"unicode":["1f3f9"],"fname":"1f3f9","uc":"1f3f9","isCanonical": true},":archery:":{"unicode":["1f3f9"],"fname":"1f3f9","uc":"1f3f9","isCanonical": false},":amphora:":{"unicode":["1f3fa"],"fname":"1f3fa","uc":"1f3fa","isCanonical": true},":place_of_worship:":{"unicode":["1f6d0"],"fname":"1f6d0","uc":"1f6d0","isCanonical": true},":worship_symbol:":{"unicode":["1f6d0"],"fname":"1f6d0","uc":"1f6d0","isCanonical": false},":kaaba:":{"unicode":["1f54b"],"fname":"1f54b","uc":"1f54b","isCanonical": true},":mosque:":{"unicode":["1f54c"],"fname":"1f54c","uc":"1f54c","isCanonical": true},":synagogue:":{"unicode":["1f54d"],"fname":"1f54d","uc":"1f54d","isCanonical": true},":menorah:":{"unicode":["1f54e"],"fname":"1f54e","uc":"1f54e","isCanonical": true},":prayer_beads:":{"unicode":["1f4ff"],"fname":"1f4ff","uc":"1f4ff","isCanonical": true},":cricket:":{"unicode":["1f3cf"],"fname":"1f3cf","uc":"1f3cf","isCanonical": true},":cricket_bat_ball:":{"unicode":["1f3cf"],"fname":"1f3cf","uc":"1f3cf","isCanonical": false},":volleyball:":{"unicode":["1f3d0"],"fname":"1f3d0","uc":"1f3d0","isCanonical": true},":field_hockey:":{"unicode":["1f3d1"],"fname":"1f3d1","uc":"1f3d1","isCanonical": true},":hockey:":{"unicode":["1f3d2"],"fname":"1f3d2","uc":"1f3d2","isCanonical": true},":ping_pong:":{"unicode":["1f3d3"],"fname":"1f3d3","uc":"1f3d3","isCanonical": true},":table_tennis:":{"unicode":["1f3d3"],"fname":"1f3d3","uc":"1f3d3","isCanonical": false},":badminton:":{"unicode":["1f3f8"],"fname":"1f3f8","uc":"1f3f8","isCanonical": true},":drum:":{"unicode":["1f941"],"fname":"1f941","uc":"1f941","isCanonical": true},":drum_with_drumsticks:":{"unicode":["1f941"],"fname":"1f941","uc":"1f941","isCanonical": false},":shrimp:":{"unicode":["1f990"],"fname":"1f990","uc":"1f990","isCanonical": true},":squid:":{"unicode":["1f991"],"fname":"1f991","uc":"1f991","isCanonical": true},":egg:":{"unicode":["1f95a"],"fname":"1f95a","uc":"1f95a","isCanonical": true},":milk:":{"unicode":["1f95b"],"fname":"1f95b","uc":"1f95b","isCanonical": true},":glass_of_milk:":{"unicode":["1f95b"],"fname":"1f95b","uc":"1f95b","isCanonical": false},":peanuts:":{"unicode":["1f95c"],"fname":"1f95c","uc":"1f95c","isCanonical": true},":shelled_peanut:":{"unicode":["1f95c"],"fname":"1f95c","uc":"1f95c","isCanonical": false},":kiwi:":{"unicode":["1f95d"],"fname":"1f95d","uc":"1f95d","isCanonical": true},":kiwifruit:":{"unicode":["1f95d"],"fname":"1f95d","uc":"1f95d","isCanonical": false},":pancakes:":{"unicode":["1f95e"],"fname":"1f95e","uc":"1f95e","isCanonical": true},":regional_indicator_w:":{"unicode":["1f1fc"],"fname":"1f1fc","uc":"1f1fc","isCanonical": true},":regional_indicator_v:":{"unicode":["1f1fb"],"fname":"1f1fb","uc":"1f1fb","isCanonical": true},":regional_indicator_u:":{"unicode":["1f1fa"],"fname":"1f1fa","uc":"1f1fa","isCanonical": true},":regional_indicator_t:":{"unicode":["1f1f9"],"fname":"1f1f9","uc":"1f1f9","isCanonical": true},":regional_indicator_s:":{"unicode":["1f1f8"],"fname":"1f1f8","uc":"1f1f8","isCanonical": true},":regional_indicator_r:":{"unicode":["1f1f7"],"fname":"1f1f7","uc":"1f1f7","isCanonical": true},":regional_indicator_q:":{"unicode":["1f1f6"],"fname":"1f1f6","uc":"1f1f6","isCanonical": true},":regional_indicator_p:":{"unicode":["1f1f5"],"fname":"1f1f5","uc":"1f1f5","isCanonical": true},":regional_indicator_o:":{"unicode":["1f1f4"],"fname":"1f1f4","uc":"1f1f4","isCanonical": true},":regional_indicator_n:":{"unicode":["1f1f3"],"fname":"1f1f3","uc":"1f1f3","isCanonical": true},":regional_indicator_m:":{"unicode":["1f1f2"],"fname":"1f1f2","uc":"1f1f2","isCanonical": true},":regional_indicator_l:":{"unicode":["1f1f1"],"fname":"1f1f1","uc":"1f1f1","isCanonical": true},":regional_indicator_k:":{"unicode":["1f1f0"],"fname":"1f1f0","uc":"1f1f0","isCanonical": true},":regional_indicator_j:":{"unicode":["1f1ef"],"fname":"1f1ef","uc":"1f1ef","isCanonical": true},":regional_indicator_i:":{"unicode":["1f1ee"],"fname":"1f1ee","uc":"1f1ee","isCanonical": true},":regional_indicator_h:":{"unicode":["1f1ed"],"fname":"1f1ed","uc":"1f1ed","isCanonical": true},":regional_indicator_g:":{"unicode":["1f1ec"],"fname":"1f1ec","uc":"1f1ec","isCanonical": true},":regional_indicator_f:":{"unicode":["1f1eb"],"fname":"1f1eb","uc":"1f1eb","isCanonical": true},":regional_indicator_e:":{"unicode":["1f1ea"],"fname":"1f1ea","uc":"1f1ea","isCanonical": true},":regional_indicator_d:":{"unicode":["1f1e9"],"fname":"1f1e9","uc":"1f1e9","isCanonical": true},":regional_indicator_c:":{"unicode":["1f1e8"],"fname":"1f1e8","uc":"1f1e8","isCanonical": true},":regional_indicator_b:":{"unicode":["1f1e7"],"fname":"1f1e7","uc":"1f1e7","isCanonical": true},":regional_indicator_a:":{"unicode":["1f1e6"],"fname":"1f1e6","uc":"1f1e6","isCanonical": true},":fast_forward:":{"unicode":["23e9"],"fname":"23e9","uc":"23e9","isCanonical": true},":rewind:":{"unicode":["23ea"],"fname":"23ea","uc":"23ea","isCanonical": true},":arrow_double_up:":{"unicode":["23eb"],"fname":"23eb","uc":"23eb","isCanonical": true},":arrow_double_down:":{"unicode":["23ec"],"fname":"23ec","uc":"23ec","isCanonical": true},":alarm_clock:":{"unicode":["23f0"],"fname":"23f0","uc":"23f0","isCanonical": true},":hourglass_flowing_sand:":{"unicode":["23f3"],"fname":"23f3","uc":"23f3","isCanonical": true},":ophiuchus:":{"unicode":["26ce"],"fname":"26ce","uc":"26ce","isCanonical": true},":white_check_mark:":{"unicode":["2705"],"fname":"2705","uc":"2705","isCanonical": true},":fist:":{"unicode":["270a"],"fname":"270a","uc":"270a","isCanonical": true},":raised_hand:":{"unicode":["270b"],"fname":"270b","uc":"270b","isCanonical": true},":sparkles:":{"unicode":["2728"],"fname":"2728","uc":"2728","isCanonical": true},":x:":{"unicode":["274c"],"fname":"274c","uc":"274c","isCanonical": true},":negative_squared_cross_mark:":{"unicode":["274e"],"fname":"274e","uc":"274e","isCanonical": true},":question:":{"unicode":["2753"],"fname":"2753","uc":"2753","isCanonical": true},":grey_question:":{"unicode":["2754"],"fname":"2754","uc":"2754","isCanonical": true},":grey_exclamation:":{"unicode":["2755"],"fname":"2755","uc":"2755","isCanonical": true},":heavy_plus_sign:":{"unicode":["2795"],"fname":"2795","uc":"2795","isCanonical": true},":heavy_minus_sign:":{"unicode":["2796"],"fname":"2796","uc":"2796","isCanonical": true},":heavy_division_sign:":{"unicode":["2797"],"fname":"2797","uc":"2797","isCanonical": true},":curly_loop:":{"unicode":["27b0"],"fname":"27b0","uc":"27b0","isCanonical": true},":loop:":{"unicode":["27bf"],"fname":"27bf","uc":"27bf","isCanonical": true}};
    // ns.shortnames = Object.keys(ns.emojioneList).map(function(emoji) {
    //     return emoji.replace(/[+]/g, "\\$&");
    // }).join('|');
    var tmpShortNames = [],
        emoji;
    for (emoji in ns.emojioneList) {
        if (!ns.emojioneList.hasOwnProperty(emoji)) continue;
        tmpShortNames.push(emoji.replace(/[+]/g, "\\$&"));
    }
    ns.shortnames = tmpShortNames.join('|');
    ns.asciiList = {
        '<3':'2764',
        '</3':'1f494',
        ':\')':'1f602',
        ':\'-)':'1f602',
        ':D':'1f603',
        ':-D':'1f603',
        '=D':'1f603',
        ':)':'1f642',
        ':-)':'1f642',
        '=]':'1f642',
        '=)':'1f642',
        ':]':'1f642',
        '\':)':'1f605',
        '\':-)':'1f605',
        '\'=)':'1f605',
        '\':D':'1f605',
        '\':-D':'1f605',
        '\'=D':'1f605',
        '>:)':'1f606',
        '>;)':'1f606',
        '>:-)':'1f606',
        '>=)':'1f606',
        ';)':'1f609',
        ';-)':'1f609',
        '*-)':'1f609',
        '*)':'1f609',
        ';-]':'1f609',
        ';]':'1f609',
        ';D':'1f609',
        ';^)':'1f609',
        '\':(':'1f613',
        '\':-(':'1f613',
        '\'=(':'1f613',
        ':*':'1f618',
        ':-*':'1f618',
        '=*':'1f618',
        ':^*':'1f618',
        '>:P':'1f61c',
        'X-P':'1f61c',
        'x-p':'1f61c',
        '>:[':'1f61e',
        ':-(':'1f61e',
        ':(':'1f61e',
        ':-[':'1f61e',
        ':[':'1f61e',
        '=(':'1f61e',
        '>:(':'1f620',
        '>:-(':'1f620',
        ':@':'1f620',
        ':\'(':'1f622',
        ':\'-(':'1f622',
        ';(':'1f622',
        ';-(':'1f622',
        '>.<':'1f623',
        'D:':'1f628',
        ':$':'1f633',
        '=$':'1f633',
        '#-)':'1f635',
        '#)':'1f635',
        '%-)':'1f635',
        '%)':'1f635',
        'X)':'1f635',
        'X-)':'1f635',
        '*\\0/*':'1f646',
        '\\0/':'1f646',
        '*\\O/*':'1f646',
        '\\O/':'1f646',
        'O:-)':'1f607',
        '0:-3':'1f607',
        '0:3':'1f607',
        '0:-)':'1f607',
        '0:)':'1f607',
        '0;^)':'1f607',
        'O:)':'1f607',
        'O;-)':'1f607',
        'O=)':'1f607',
        '0;-)':'1f607',
        'O:-3':'1f607',
        'O:3':'1f607',
        'B-)':'1f60e',
        'B)':'1f60e',
        '8)':'1f60e',
        '8-)':'1f60e',
        'B-D':'1f60e',
        '8-D':'1f60e',
        '-_-':'1f611',
        '-__-':'1f611',
        '-___-':'1f611',
        '>:\\':'1f615',
        '>:/':'1f615',
        ':-/':'1f615',
        ':-.':'1f615',
        ':/':'1f615',
        ':\\':'1f615',
        '=/':'1f615',
        '=\\':'1f615',
        ':L':'1f615',
        '=L':'1f615',
        ':P':'1f61b',
        ':-P':'1f61b',
        '=P':'1f61b',
        ':-p':'1f61b',
        ':p':'1f61b',
        '=p':'1f61b',
        ':-Þ':'1f61b',
        ':Þ':'1f61b',
        ':þ':'1f61b',
        ':-þ':'1f61b',
        ':-b':'1f61b',
        ':b':'1f61b',
        'd:':'1f61b',
        ':-O':'1f62e',
        ':O':'1f62e',
        ':-o':'1f62e',
        ':o':'1f62e',
        'O_O':'1f62e',
        '>:O':'1f62e',
        ':-X':'1f636',
        ':X':'1f636',
        ':-#':'1f636',
        ':#':'1f636',
        '=X':'1f636',
        '=x':'1f636',
        ':x':'1f636',
        ':-x':'1f636',
        '=#':'1f636'
    };
    ns.asciiRegexp = '(\\<3|&lt;3|\\<\\/3|&lt;\\/3|\\:\'\\)|\\:\'\\-\\)|\\:D|\\:\\-D|\\=D|\\:\\)|\\:\\-\\)|\\=\\]|\\=\\)|\\:\\]|\'\\:\\)|\'\\:\\-\\)|\'\\=\\)|\'\\:D|\'\\:\\-D|\'\\=D|\\>\\:\\)|&gt;\\:\\)|\\>;\\)|&gt;;\\)|\\>\\:\\-\\)|&gt;\\:\\-\\)|\\>\\=\\)|&gt;\\=\\)|;\\)|;\\-\\)|\\*\\-\\)|\\*\\)|;\\-\\]|;\\]|;D|;\\^\\)|\'\\:\\(|\'\\:\\-\\(|\'\\=\\(|\\:\\*|\\:\\-\\*|\\=\\*|\\:\\^\\*|\\>\\:P|&gt;\\:P|X\\-P|x\\-p|\\>\\:\\[|&gt;\\:\\[|\\:\\-\\(|\\:\\(|\\:\\-\\[|\\:\\[|\\=\\(|\\>\\:\\(|&gt;\\:\\(|\\>\\:\\-\\(|&gt;\\:\\-\\(|\\:@|\\:\'\\(|\\:\'\\-\\(|;\\(|;\\-\\(|\\>\\.\\<|&gt;\\.&lt;|D\\:|\\:\\$|\\=\\$|#\\-\\)|#\\)|%\\-\\)|%\\)|X\\)|X\\-\\)|\\*\\\\0\\/\\*|\\\\0\\/|\\*\\\\O\\/\\*|\\\\O\\/|O\\:\\-\\)|0\\:\\-3|0\\:3|0\\:\\-\\)|0\\:\\)|0;\\^\\)|O\\:\\-\\)|O\\:\\)|O;\\-\\)|O\\=\\)|0;\\-\\)|O\\:\\-3|O\\:3|B\\-\\)|B\\)|8\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\-__\\-|\\-___\\-|\\>\\:\\\\|&gt;\\:\\\\|\\>\\:\\/|&gt;\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\:\\-P|\\=P|\\:\\-p|\\:p|\\=p|\\:\\-Þ|\\:\\-&THORN;|\\:Þ|\\:&THORN;|\\:þ|\\:&thorn;|\\:\\-þ|\\:\\-&thorn;|\\:\\-b|\\:b|d\\:|\\:\\-O|\\:O|\\:\\-o|\\:o|O_O|\\>\\:O|&gt;\\:O|\\:\\-X|\\:X|\\:\\-#|\\:#|\\=X|\\=x|\\:x|\\:\\-x|\\=#)';
    // javascript escapes here must be ordered from largest length to shortest
    ns.unicodeRegexp = '(\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC8B\\u200D\\uD83D\\uDC69|\\uD83D\\uDC68\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC8B\\u200D\\uD83D\\uDC68|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC66\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC69|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC66|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC66\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC66\\uD83D\\uDC66|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC67\\uD83D\\uDC67|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC66|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC67\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC67|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC67\\uD83D\\uDC67|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC66\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\u2764\\uFE0F\\u200D\\uD83D\\uDC68|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC66|\\uD83D\\uDC69\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC66|\\uD83D\\uDC68\\u200D\\uD83D\\uDC68\\u200D\\uD83D\\uDC67|\\uD83D\\uDC68\\u200D\\uD83D\\uDC69\\u200D\\uD83D\\uDC67|\\uD83D\\uDC69\\u2764\\uD83D\\uDC8B\\uD83D\\uDC69|\\uD83D\\uDC68\\u2764\\uD83D\\uDC8B\\uD83D\\uDC68|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC67|\\uD83D\\uDC68\\uD83D\\uDC68\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC66|\\uD83D\\uDC69\\uD83D\\uDC69\\uD83D\\uDC67|\\uD83C\\uDFF3\\uFE0F\\u200D\\uD83C\\uDF08|\\uD83D\\uDC68\\uD83D\\uDC69\\uD83D\\uDC67|\\uD83D\\uDC68\\u2764\\uD83D\\uDC68|\\uD83D\\uDC41\\u200D\\uD83D\\uDDE8|\\uD83D\\uDC69\\u2764\\uD83D\\uDC69|\\uD83D\\uDC41\\uD83D\\uDDE8|\\uD83C\\uDDE6\\uD83C\\uDDE8|\\uD83C\\uDDE6\\uD83C\\uDDE9|\\uD83C\\uDDE6\\uD83C\\uDDEA|\\uD83C\\uDDE6\\uD83C\\uDDEB|\\uD83C\\uDDE6\\uD83C\\uDDEC|\\uD83C\\uDDE6\\uD83C\\uDDEE|\\uD83C\\uDDE6\\uD83C\\uDDF1|\\uD83C\\uDDE6\\uD83C\\uDDF2|\\uD83C\\uDDE6\\uD83C\\uDDF4|\\uD83C\\uDDE6\\uD83C\\uDDF6|\\uD83C\\uDDE6\\uD83C\\uDDF7|\\uD83C\\uDDE6\\uD83C\\uDDF8|\\uD83E\\uDD3E\\uD83C\\uDFFF|\\uD83E\\uDD3E\\uD83C\\uDFFE|\\uD83E\\uDD3E\\uD83C\\uDFFD|\\uD83E\\uDD3E\\uD83C\\uDFFC|\\uD83E\\uDD3E\\uD83C\\uDFFB|\\uD83E\\uDD3D\\uD83C\\uDFFF|\\uD83E\\uDD3D\\uD83C\\uDFFE|\\uD83E\\uDD3D\\uD83C\\uDFFD|\\uD83E\\uDD3D\\uD83C\\uDFFC|\\uD83E\\uDD3D\\uD83C\\uDFFB|\\uD83E\\uDD3C\\uD83C\\uDFFF|\\uD83E\\uDD3C\\uD83C\\uDFFE|\\uD83E\\uDD3C\\uD83C\\uDFFD|\\uD83E\\uDD3C\\uD83C\\uDFFC|\\uD83E\\uDD3C\\uD83C\\uDFFB|\\uD83E\\uDD39\\uD83C\\uDFFF|\\uD83E\\uDD39\\uD83C\\uDFFE|\\uD83E\\uDD39\\uD83C\\uDFFD|\\uD83E\\uDD39\\uD83C\\uDFFC|\\uD83E\\uDD39\\uD83C\\uDFFB|\\uD83E\\uDD38\\uD83C\\uDFFF|\\uD83E\\uDD38\\uD83C\\uDFFE|\\uD83E\\uDD38\\uD83C\\uDFFD|\\uD83E\\uDD38\\uD83C\\uDFFC|\\uD83E\\uDD38\\uD83C\\uDFFB|\\uD83E\\uDD37\\uD83C\\uDFFF|\\uD83E\\uDD37\\uD83C\\uDFFE|\\uD83E\\uDD37\\uD83C\\uDFFD|\\uD83E\\uDD37\\uD83C\\uDFFC|\\uD83E\\uDD37\\uD83C\\uDFFB|\\uD83E\\uDD36\\uD83C\\uDFFF|\\uD83E\\uDD36\\uD83C\\uDFFE|\\uD83E\\uDD36\\uD83C\\uDFFD|\\uD83E\\uDD36\\uD83C\\uDFFC|\\uD83E\\uDD36\\uD83C\\uDFFB|\\uD83E\\uDD35\\uD83C\\uDFFF|\\uD83E\\uDD35\\uD83C\\uDFFE|\\uD83E\\uDD35\\uD83C\\uDFFD|\\uD83E\\uDD35\\uD83C\\uDFFC|\\uD83E\\uDD35\\uD83C\\uDFFB|\\uD83E\\uDD34\\uD83C\\uDFFF|\\uD83E\\uDD34\\uD83C\\uDFFE|\\uD83E\\uDD34\\uD83C\\uDFFD|\\uD83E\\uDD34\\uD83C\\uDFFC|\\uD83E\\uDD34\\uD83C\\uDFFB|\\uD83E\\uDD33\\uD83C\\uDFFF|\\uD83E\\uDD33\\uD83C\\uDFFE|\\uD83E\\uDD33\\uD83C\\uDFFD|\\uD83E\\uDD33\\uD83C\\uDFFC|\\uD83E\\uDD33\\uD83C\\uDFFB|\\uD83E\\uDD30\\uD83C\\uDFFF|\\uD83E\\uDD30\\uD83C\\uDFFE|\\uD83E\\uDD30\\uD83C\\uDFFD|\\uD83E\\uDD30\\uD83C\\uDFFC|\\uD83E\\uDD30\\uD83C\\uDFFB|\\uD83E\\uDD26\\uD83C\\uDFFF|\\uD83E\\uDD26\\uD83C\\uDFFE|\\uD83E\\uDD26\\uD83C\\uDFFD|\\uD83E\\uDD26\\uD83C\\uDFFC|\\uD83E\\uDD26\\uD83C\\uDFFB|\\uD83E\\uDD1E\\uD83C\\uDFFF|\\uD83E\\uDD1E\\uD83C\\uDFFE|\\uD83E\\uDD1E\\uD83C\\uDFFD|\\uD83E\\uDD1E\\uD83C\\uDFFC|\\uD83E\\uDD1E\\uD83C\\uDFFB|\\uD83E\\uDD1D\\uD83C\\uDFFF|\\uD83E\\uDD1D\\uD83C\\uDFFE|\\uD83E\\uDD1D\\uD83C\\uDFFD|\\uD83E\\uDD1D\\uD83C\\uDFFC|\\uD83E\\uDD1D\\uD83C\\uDFFB|\\uD83E\\uDD1C\\uD83C\\uDFFF|\\uD83E\\uDD1C\\uD83C\\uDFFE|\\uD83E\\uDD1C\\uD83C\\uDFFD|\\uD83E\\uDD1C\\uD83C\\uDFFC|\\uD83E\\uDD1C\\uD83C\\uDFFB|\\uD83E\\uDD1B\\uD83C\\uDFFF|\\uD83E\\uDD1B\\uD83C\\uDFFE|\\uD83E\\uDD1B\\uD83C\\uDFFD|\\uD83E\\uDD1B\\uD83C\\uDFFC|\\uD83E\\uDD1B\\uD83C\\uDFFB|\\uD83E\\uDD1A\\uD83C\\uDFFF|\\uD83E\\uDD1A\\uD83C\\uDFFE|\\uD83E\\uDD1A\\uD83C\\uDFFD|\\uD83E\\uDD1A\\uD83C\\uDFFC|\\uD83E\\uDD1A\\uD83C\\uDFFB|\\uD83E\\uDD19\\uD83C\\uDFFF|\\uD83E\\uDD19\\uD83C\\uDFFE|\\uD83E\\uDD19\\uD83C\\uDFFD|\\uD83E\\uDD19\\uD83C\\uDFFC|\\uD83E\\uDD19\\uD83C\\uDFFB|\\uD83E\\uDD18\\uD83C\\uDFFF|\\uD83E\\uDD18\\uD83C\\uDFFE|\\uD83E\\uDD18\\uD83C\\uDFFD|\\uD83E\\uDD18\\uD83C\\uDFFC|\\uD83E\\uDD18\\uD83C\\uDFFB|\\uD83D\\uDEC0\\uD83C\\uDFFF|\\uD83D\\uDEC0\\uD83C\\uDFFE|\\uD83D\\uDEC0\\uD83C\\uDFFD|\\uD83D\\uDEC0\\uD83C\\uDFFC|\\uD83D\\uDEC0\\uD83C\\uDFFB|\\uD83D\\uDEB6\\uD83C\\uDFFF|\\uD83D\\uDEB6\\uD83C\\uDFFE|\\uD83D\\uDEB6\\uD83C\\uDFFD|\\uD83D\\uDEB6\\uD83C\\uDFFC|\\uD83D\\uDEB6\\uD83C\\uDFFB|\\uD83D\\uDEB5\\uD83C\\uDFFF|\\uD83D\\uDEB5\\uD83C\\uDFFE|\\uD83D\\uDEB5\\uD83C\\uDFFD|\\uD83D\\uDEB5\\uD83C\\uDFFC|\\uD83D\\uDEB5\\uD83C\\uDFFB|\\uD83D\\uDEB4\\uD83C\\uDFFF|\\uD83D\\uDEB4\\uD83C\\uDFFE|\\uD83D\\uDEB4\\uD83C\\uDFFD|\\uD83D\\uDEB4\\uD83C\\uDFFC|\\uD83D\\uDEB4\\uD83C\\uDFFB|\\uD83D\\uDEA3\\uD83C\\uDFFF|\\uD83D\\uDEA3\\uD83C\\uDFFE|\\uD83D\\uDEA3\\uD83C\\uDFFD|\\uD83D\\uDEA3\\uD83C\\uDFFC|\\uD83D\\uDEA3\\uD83C\\uDFFB|\\uD83D\\uDE4F\\uD83C\\uDFFF|\\uD83D\\uDE4F\\uD83C\\uDFFE|\\uD83D\\uDE4F\\uD83C\\uDFFD|\\uD83D\\uDE4F\\uD83C\\uDFFC|\\uD83D\\uDE4F\\uD83C\\uDFFB|\\uD83D\\uDE4E\\uD83C\\uDFFF|\\uD83D\\uDE4E\\uD83C\\uDFFE|\\uD83D\\uDE4E\\uD83C\\uDFFD|\\uD83D\\uDE4E\\uD83C\\uDFFC|\\uD83D\\uDE4E\\uD83C\\uDFFB|\\uD83D\\uDE4D\\uD83C\\uDFFF|\\uD83D\\uDE4D\\uD83C\\uDFFE|\\uD83D\\uDE4D\\uD83C\\uDFFD|\\uD83D\\uDE4D\\uD83C\\uDFFC|\\uD83D\\uDE4D\\uD83C\\uDFFB|\\uD83D\\uDE4C\\uD83C\\uDFFF|\\uD83D\\uDE4C\\uD83C\\uDFFE|\\uD83D\\uDE4C\\uD83C\\uDFFD|\\uD83D\\uDE4C\\uD83C\\uDFFC|\\uD83D\\uDE4C\\uD83C\\uDFFB|\\uD83D\\uDE4B\\uD83C\\uDFFF|\\uD83D\\uDE4B\\uD83C\\uDFFE|\\uD83D\\uDE4B\\uD83C\\uDFFD|\\uD83D\\uDE4B\\uD83C\\uDFFC|\\uD83D\\uDE4B\\uD83C\\uDFFB|\\uD83D\\uDE47\\uD83C\\uDFFF|\\uD83D\\uDE47\\uD83C\\uDFFE|\\uD83D\\uDE47\\uD83C\\uDFFD|\\uD83D\\uDE47\\uD83C\\uDFFC|\\uD83D\\uDE47\\uD83C\\uDFFB|\\uD83D\\uDE46\\uD83C\\uDFFF|\\uD83D\\uDE46\\uD83C\\uDFFE|\\uD83D\\uDE46\\uD83C\\uDFFD|\\uD83D\\uDE46\\uD83C\\uDFFC|\\uD83D\\uDE46\\uD83C\\uDFFB|\\uD83D\\uDE45\\uD83C\\uDFFF|\\uD83D\\uDE45\\uD83C\\uDFFE|\\uD83D\\uDE45\\uD83C\\uDFFD|\\uD83D\\uDE45\\uD83C\\uDFFC|\\uD83D\\uDE45\\uD83C\\uDFFB|\\uD83D\\uDD96\\uD83C\\uDFFF|\\uD83D\\uDD96\\uD83C\\uDFFE|\\uD83D\\uDD96\\uD83C\\uDFFD|\\uD83D\\uDD96\\uD83C\\uDFFC|\\uD83D\\uDD96\\uD83C\\uDFFB|\\uD83D\\uDD95\\uD83C\\uDFFF|\\uD83D\\uDD95\\uD83C\\uDFFE|\\uD83D\\uDD95\\uD83C\\uDFFD|\\uD83D\\uDD95\\uD83C\\uDFFC|\\uD83D\\uDD95\\uD83C\\uDFFB|\\uD83D\\uDD90\\uD83C\\uDFFF|\\uD83D\\uDD90\\uD83C\\uDFFE|\\uD83D\\uDD90\\uD83C\\uDFFD|\\uD83D\\uDD90\\uD83C\\uDFFC|\\uD83D\\uDD90\\uD83C\\uDFFB|\\uD83D\\uDD7A\\uD83C\\uDFFF|\\uD83D\\uDD7A\\uD83C\\uDFFE|\\uD83D\\uDD7A\\uD83C\\uDFFD|\\uD83D\\uDD7A\\uD83C\\uDFFC|\\uD83D\\uDD7A\\uD83C\\uDFFB|\\uD83D\\uDD75\\uD83C\\uDFFF|\\uD83D\\uDD75\\uD83C\\uDFFE|\\uD83D\\uDD75\\uD83C\\uDFFD|\\uD83D\\uDD75\\uD83C\\uDFFC|\\uD83D\\uDD75\\uD83C\\uDFFB|\\uD83D\\uDCAA\\uD83C\\uDFFF|\\uD83D\\uDCAA\\uD83C\\uDFFE|\\uD83D\\uDCAA\\uD83C\\uDFFD|\\uD83D\\uDCAA\\uD83C\\uDFFC|\\uD83D\\uDCAA\\uD83C\\uDFFB|\\uD83D\\uDC87\\uD83C\\uDFFF|\\uD83D\\uDC87\\uD83C\\uDFFE|\\uD83D\\uDC87\\uD83C\\uDFFD|\\uD83D\\uDC87\\uD83C\\uDFFC|\\uD83D\\uDC87\\uD83C\\uDFFB|\\uD83D\\uDC86\\uD83C\\uDFFF|\\uD83D\\uDC86\\uD83C\\uDFFE|\\uD83D\\uDC86\\uD83C\\uDFFD|\\uD83D\\uDC86\\uD83C\\uDFFC|\\uD83D\\uDC86\\uD83C\\uDFFB|\\uD83D\\uDC85\\uD83C\\uDFFF|\\uD83D\\uDC85\\uD83C\\uDFFE|\\uD83D\\uDC85\\uD83C\\uDFFD|\\uD83D\\uDC85\\uD83C\\uDFFC|\\uD83D\\uDC85\\uD83C\\uDFFB|\\uD83D\\uDC83\\uD83C\\uDFFF|\\uD83D\\uDC83\\uD83C\\uDFFE|\\uD83D\\uDC83\\uD83C\\uDFFD|\\uD83D\\uDC83\\uD83C\\uDFFC|\\uD83D\\uDC83\\uD83C\\uDFFB|\\uD83D\\uDC82\\uD83C\\uDFFF|\\uD83D\\uDC82\\uD83C\\uDFFE|\\uD83D\\uDC82\\uD83C\\uDFFD|\\uD83D\\uDC82\\uD83C\\uDFFC|\\uD83D\\uDC82\\uD83C\\uDFFB|\\uD83D\\uDC81\\uD83C\\uDFFF|\\uD83D\\uDC81\\uD83C\\uDFFE|\\uD83D\\uDC81\\uD83C\\uDFFD|\\uD83D\\uDC81\\uD83C\\uDFFC|\\uD83D\\uDC81\\uD83C\\uDFFB|\\uD83D\\uDC7C\\uD83C\\uDFFF|\\uD83D\\uDC7C\\uD83C\\uDFFE|\\uD83D\\uDC7C\\uD83C\\uDFFD|\\uD83D\\uDC7C\\uD83C\\uDFFC|\\uD83D\\uDC7C\\uD83C\\uDFFB|\\uD83D\\uDC78\\uD83C\\uDFFF|\\uD83D\\uDC78\\uD83C\\uDFFE|\\uD83D\\uDC78\\uD83C\\uDFFD|\\uD83D\\uDC78\\uD83C\\uDFFC|\\uD83D\\uDC78\\uD83C\\uDFFB|\\uD83D\\uDC77\\uD83C\\uDFFF|\\uD83D\\uDC77\\uD83C\\uDFFE|\\uD83D\\uDC77\\uD83C\\uDFFD|\\uD83D\\uDC77\\uD83C\\uDFFC|\\uD83D\\uDC77\\uD83C\\uDFFB|\\uD83D\\uDC76\\uD83C\\uDFFF|\\uD83D\\uDC76\\uD83C\\uDFFE|\\uD83D\\uDC76\\uD83C\\uDFFD|\\uD83D\\uDC76\\uD83C\\uDFFC|\\uD83D\\uDC76\\uD83C\\uDFFB|\\uD83D\\uDC75\\uD83C\\uDFFF|\\uD83D\\uDC75\\uD83C\\uDFFE|\\uD83D\\uDC75\\uD83C\\uDFFD|\\uD83D\\uDC75\\uD83C\\uDFFC|\\uD83D\\uDC75\\uD83C\\uDFFB|\\uD83D\\uDC74\\uD83C\\uDFFF|\\uD83D\\uDC74\\uD83C\\uDFFE|\\uD83D\\uDC74\\uD83C\\uDFFD|\\uD83D\\uDC74\\uD83C\\uDFFC|\\uD83D\\uDC74\\uD83C\\uDFFB|\\uD83D\\uDC73\\uD83C\\uDFFF|\\uD83D\\uDC73\\uD83C\\uDFFE|\\uD83D\\uDC73\\uD83C\\uDFFD|\\uD83D\\uDC73\\uD83C\\uDFFC|\\uD83D\\uDC73\\uD83C\\uDFFB|\\uD83D\\uDC72\\uD83C\\uDFFF|\\uD83D\\uDC72\\uD83C\\uDFFE|\\uD83D\\uDC72\\uD83C\\uDFFD|\\uD83D\\uDC72\\uD83C\\uDFFC|\\uD83D\\uDC72\\uD83C\\uDFFB|\\uD83D\\uDC71\\uD83C\\uDFFF|\\uD83D\\uDC71\\uD83C\\uDFFE|\\uD83D\\uDC71\\uD83C\\uDFFD|\\uD83D\\uDC71\\uD83C\\uDFFC|\\uD83D\\uDC71\\uD83C\\uDFFB|\\uD83D\\uDC70\\uD83C\\uDFFF|\\uD83D\\uDC70\\uD83C\\uDFFE|\\uD83D\\uDC70\\uD83C\\uDFFD|\\uD83D\\uDC70\\uD83C\\uDFFC|\\uD83D\\uDC70\\uD83C\\uDFFB|\\uD83D\\uDC6E\\uD83C\\uDFFF|\\uD83D\\uDC6E\\uD83C\\uDFFE|\\uD83D\\uDC6E\\uD83C\\uDFFD|\\uD83D\\uDC6E\\uD83C\\uDFFC|\\uD83D\\uDC6E\\uD83C\\uDFFB|\\uD83D\\uDC69\\uD83C\\uDFFF|\\uD83D\\uDC69\\uD83C\\uDFFE|\\uD83D\\uDC69\\uD83C\\uDFFD|\\uD83D\\uDC69\\uD83C\\uDFFC|\\uD83D\\uDC69\\uD83C\\uDFFB|\\uD83D\\uDC68\\uD83C\\uDFFF|\\uD83D\\uDC68\\uD83C\\uDFFE|\\uD83D\\uDC68\\uD83C\\uDFFD|\\uD83D\\uDC68\\uD83C\\uDFFC|\\uD83D\\uDC68\\uD83C\\uDFFB|\\uD83D\\uDC67\\uD83C\\uDFFF|\\uD83D\\uDC67\\uD83C\\uDFFE|\\uD83D\\uDC67\\uD83C\\uDFFD|\\uD83D\\uDC67\\uD83C\\uDFFC|\\uD83D\\uDC67\\uD83C\\uDFFB|\\uD83D\\uDC66\\uD83C\\uDFFF|\\uD83D\\uDC66\\uD83C\\uDFFE|\\uD83D\\uDC66\\uD83C\\uDFFD|\\uD83D\\uDC66\\uD83C\\uDFFC|\\uD83D\\uDC66\\uD83C\\uDFFB|\\uD83D\\uDC50\\uD83C\\uDFFF|\\uD83D\\uDC50\\uD83C\\uDFFE|\\uD83D\\uDC50\\uD83C\\uDFFD|\\uD83D\\uDC50\\uD83C\\uDFFC|\\uD83D\\uDC50\\uD83C\\uDFFB|\\uD83D\\uDC4F\\uD83C\\uDFFF|\\uD83D\\uDC4F\\uD83C\\uDFFE|\\uD83D\\uDC4F\\uD83C\\uDFFD|\\uD83D\\uDC4F\\uD83C\\uDFFC|\\uD83D\\uDC4F\\uD83C\\uDFFB|\\uD83D\\uDC4E\\uD83C\\uDFFF|\\uD83D\\uDC4E\\uD83C\\uDFFE|\\uD83D\\uDC4E\\uD83C\\uDFFD|\\uD83D\\uDC4E\\uD83C\\uDFFC|\\uD83D\\uDC4E\\uD83C\\uDFFB|\\uD83D\\uDC4D\\uD83C\\uDFFF|\\uD83D\\uDC4D\\uD83C\\uDFFE|\\uD83D\\uDC4D\\uD83C\\uDFFD|\\uD83D\\uDC4D\\uD83C\\uDFFC|\\uD83D\\uDC4D\\uD83C\\uDFFB|\\uD83D\\uDC4C\\uD83C\\uDFFF|\\uD83D\\uDC4C\\uD83C\\uDFFE|\\uD83D\\uDC4C\\uD83C\\uDFFD|\\uD83D\\uDC4C\\uD83C\\uDFFC|\\uD83D\\uDC4C\\uD83C\\uDFFB|\\uD83D\\uDC4B\\uD83C\\uDFFF|\\uD83D\\uDC4B\\uD83C\\uDFFE|\\uD83D\\uDC4B\\uD83C\\uDFFD|\\uD83D\\uDC4B\\uD83C\\uDFFC|\\uD83D\\uDC4B\\uD83C\\uDFFB|\\uD83D\\uDC4A\\uD83C\\uDFFF|\\uD83D\\uDC4A\\uD83C\\uDFFE|\\uD83D\\uDC4A\\uD83C\\uDFFD|\\uD83D\\uDC4A\\uD83C\\uDFFC|\\uD83D\\uDC4A\\uD83C\\uDFFB|\\uD83D\\uDC49\\uD83C\\uDFFF|\\uD83D\\uDC49\\uD83C\\uDFFE|\\uD83D\\uDC49\\uD83C\\uDFFD|\\uD83D\\uDC49\\uD83C\\uDFFC|\\uD83D\\uDC49\\uD83C\\uDFFB|\\uD83D\\uDC48\\uD83C\\uDFFF|\\uD83D\\uDC48\\uD83C\\uDFFE|\\uD83D\\uDC48\\uD83C\\uDFFD|\\uD83D\\uDC48\\uD83C\\uDFFC|\\uD83D\\uDC48\\uD83C\\uDFFB|\\uD83D\\uDC47\\uD83C\\uDFFF|\\uD83D\\uDC47\\uD83C\\uDFFE|\\uD83D\\uDC47\\uD83C\\uDFFD|\\uD83D\\uDC47\\uD83C\\uDFFC|\\uD83D\\uDC47\\uD83C\\uDFFB|\\uD83D\\uDC46\\uD83C\\uDFFF|\\uD83D\\uDC46\\uD83C\\uDFFE|\\uD83D\\uDC46\\uD83C\\uDFFD|\\uD83D\\uDC46\\uD83C\\uDFFC|\\uD83D\\uDC46\\uD83C\\uDFFB|\\uD83D\\uDC43\\uD83C\\uDFFF|\\uD83D\\uDC43\\uD83C\\uDFFE|\\uD83D\\uDC43\\uD83C\\uDFFD|\\uD83D\\uDC43\\uD83C\\uDFFC|\\uD83D\\uDC43\\uD83C\\uDFFB|\\uD83D\\uDC42\\uD83C\\uDFFF|\\uD83D\\uDC42\\uD83C\\uDFFE|\\uD83D\\uDC42\\uD83C\\uDFFD|\\uD83D\\uDC42\\uD83C\\uDFFC|\\uD83D\\uDC42\\uD83C\\uDFFB|\\uD83C\\uDFCB\\uD83C\\uDFFF|\\uD83C\\uDFCB\\uD83C\\uDFFE|\\uD83C\\uDFF3\\uD83C\\uDF08|\\uD83C\\uDFCB\\uD83C\\uDFFC|\\uD83C\\uDFCB\\uD83C\\uDFFB|\\uD83C\\uDFCA\\uD83C\\uDFFF|\\uD83C\\uDFCA\\uD83C\\uDFFE|\\uD83C\\uDFCA\\uD83C\\uDFFD|\\uD83C\\uDFCA\\uD83C\\uDFFC|\\uD83C\\uDFCA\\uD83C\\uDFFB|\\uD83C\\uDFC7\\uD83C\\uDFFF|\\uD83C\\uDFC7\\uD83C\\uDFFE|\\uD83C\\uDFC7\\uD83C\\uDFFD|\\uD83C\\uDFC7\\uD83C\\uDFFC|\\uD83C\\uDFC7\\uD83C\\uDFFB|\\uD83C\\uDFC4\\uD83C\\uDFFF|\\uD83C\\uDFCB\\uD83C\\uDFFD|\\uD83C\\uDFC4\\uD83C\\uDFFD|\\uD83C\\uDFC4\\uD83C\\uDFFC|\\uD83C\\uDFC4\\uD83C\\uDFFB|\\uD83C\\uDFC3\\uD83C\\uDFFF|\\uD83C\\uDFC3\\uD83C\\uDFFE|\\uD83C\\uDFC3\\uD83C\\uDFFD|\\uD83C\\uDFC3\\uD83C\\uDFFC|\\uD83C\\uDFC3\\uD83C\\uDFFB|\\uD83C\\uDF85\\uD83C\\uDFFF|\\uD83C\\uDF85\\uD83C\\uDFFE|\\uD83C\\uDF85\\uD83C\\uDFFD|\\uD83C\\uDF85\\uD83C\\uDFFC|\\uD83C\\uDF85\\uD83C\\uDFFB|\\uD83C\\uDDFF\\uD83C\\uDDFC|\\uD83C\\uDDFF\\uD83C\\uDDF2|\\uD83C\\uDDFF\\uD83C\\uDDE6|\\uD83C\\uDDFE\\uD83C\\uDDF9|\\uD83C\\uDDFE\\uD83C\\uDDEA|\\uD83C\\uDDFD\\uD83C\\uDDF0|\\uD83C\\uDDFC\\uD83C\\uDDF8|\\uD83C\\uDDFC\\uD83C\\uDDEB|\\uD83C\\uDDFB\\uD83C\\uDDFA|\\uD83C\\uDDFB\\uD83C\\uDDF3|\\uD83C\\uDDFB\\uD83C\\uDDEE|\\uD83C\\uDDFB\\uD83C\\uDDEC|\\uD83C\\uDDFB\\uD83C\\uDDEA|\\uD83C\\uDDFB\\uD83C\\uDDE8|\\uD83C\\uDDFB\\uD83C\\uDDE6|\\uD83C\\uDDFA\\uD83C\\uDDFF|\\uD83C\\uDDFA\\uD83C\\uDDFE|\\uD83C\\uDDFA\\uD83C\\uDDF8|\\uD83C\\uDDFA\\uD83C\\uDDF2|\\uD83C\\uDDFA\\uD83C\\uDDEC|\\uD83C\\uDDFA\\uD83C\\uDDE6|\\uD83C\\uDDF9\\uD83C\\uDDFF|\\uD83C\\uDDF9\\uD83C\\uDDFC|\\uD83C\\uDDF9\\uD83C\\uDDFB|\\uD83C\\uDDF9\\uD83C\\uDDF9|\\uD83C\\uDDF9\\uD83C\\uDDF7|\\uD83C\\uDDF9\\uD83C\\uDDF4|\\uD83C\\uDDF9\\uD83C\\uDDF3|\\uD83C\\uDDF9\\uD83C\\uDDF2|\\uD83C\\uDDF9\\uD83C\\uDDF1|\\uD83C\\uDDF9\\uD83C\\uDDF0|\\uD83C\\uDDF9\\uD83C\\uDDEF|\\uD83C\\uDDF9\\uD83C\\uDDED|\\uD83C\\uDDF9\\uD83C\\uDDEC|\\uD83C\\uDDF9\\uD83C\\uDDEB|\\uD83C\\uDDF9\\uD83C\\uDDE9|\\uD83C\\uDDF9\\uD83C\\uDDE8|\\uD83C\\uDDF9\\uD83C\\uDDE6|\\uD83C\\uDDF8\\uD83C\\uDDFF|\\uD83C\\uDDF8\\uD83C\\uDDFE|\\uD83C\\uDDF8\\uD83C\\uDDFD|\\uD83C\\uDDF8\\uD83C\\uDDFB|\\uD83C\\uDDF8\\uD83C\\uDDF9|\\uD83C\\uDDF8\\uD83C\\uDDF8|\\uD83C\\uDDF8\\uD83C\\uDDF7|\\uD83C\\uDDF8\\uD83C\\uDDF4|\\uD83C\\uDDF8\\uD83C\\uDDF3|\\uD83C\\uDDF8\\uD83C\\uDDF2|\\uD83C\\uDDF8\\uD83C\\uDDF1|\\uD83C\\uDDF8\\uD83C\\uDDF0|\\uD83C\\uDDF8\\uD83C\\uDDEF|\\uD83C\\uDDF8\\uD83C\\uDDEE|\\uD83C\\uDDF8\\uD83C\\uDDED|\\uD83C\\uDDF8\\uD83C\\uDDEC|\\uD83C\\uDDF8\\uD83C\\uDDEA|\\uD83C\\uDDF8\\uD83C\\uDDE9|\\uD83C\\uDDF8\\uD83C\\uDDE8|\\uD83C\\uDDF8\\uD83C\\uDDE7|\\uD83C\\uDDF8\\uD83C\\uDDE6|\\uD83C\\uDDF7\\uD83C\\uDDFC|\\uD83C\\uDDF7\\uD83C\\uDDFA|\\uD83C\\uDDF7\\uD83C\\uDDF8|\\uD83C\\uDDF7\\uD83C\\uDDF4|\\uD83C\\uDDF7\\uD83C\\uDDEA|\\uD83C\\uDDF6\\uD83C\\uDDE6|\\uD83C\\uDDF5\\uD83C\\uDDFE|\\uD83C\\uDDF5\\uD83C\\uDDFC|\\uD83C\\uDDF5\\uD83C\\uDDF9|\\uD83C\\uDDF5\\uD83C\\uDDF8|\\uD83C\\uDDF5\\uD83C\\uDDF7|\\uD83C\\uDDF5\\uD83C\\uDDF3|\\uD83C\\uDDF5\\uD83C\\uDDF2|\\uD83C\\uDDF5\\uD83C\\uDDF1|\\uD83C\\uDDF5\\uD83C\\uDDF0|\\uD83C\\uDDF5\\uD83C\\uDDED|\\uD83C\\uDDF5\\uD83C\\uDDEC|\\uD83C\\uDDF5\\uD83C\\uDDEB|\\uD83C\\uDDF5\\uD83C\\uDDEA|\\uD83C\\uDDF5\\uD83C\\uDDE6|\\uD83C\\uDDF4\\uD83C\\uDDF2|\\uD83C\\uDDF3\\uD83C\\uDDFF|\\uD83C\\uDDF3\\uD83C\\uDDFA|\\uD83C\\uDDF3\\uD83C\\uDDF7|\\uD83C\\uDDF3\\uD83C\\uDDF5|\\uD83C\\uDDF3\\uD83C\\uDDF4|\\uD83C\\uDDF3\\uD83C\\uDDF1|\\uD83C\\uDDF3\\uD83C\\uDDEE|\\uD83C\\uDDF3\\uD83C\\uDDEC|\\uD83C\\uDDF3\\uD83C\\uDDEB|\\uD83C\\uDDF3\\uD83C\\uDDEA|\\uD83C\\uDDF3\\uD83C\\uDDE8|\\uD83C\\uDDF3\\uD83C\\uDDE6|\\uD83C\\uDDF2\\uD83C\\uDDFF|\\uD83C\\uDDF2\\uD83C\\uDDFE|\\uD83C\\uDDF2\\uD83C\\uDDFD|\\uD83C\\uDDF2\\uD83C\\uDDFC|\\uD83C\\uDDF2\\uD83C\\uDDFB|\\uD83C\\uDDF2\\uD83C\\uDDFA|\\uD83C\\uDDF2\\uD83C\\uDDF9|\\uD83C\\uDDF2\\uD83C\\uDDF8|\\uD83C\\uDDF2\\uD83C\\uDDF7|\\uD83C\\uDDF2\\uD83C\\uDDF6|\\uD83C\\uDDF2\\uD83C\\uDDF5|\\uD83C\\uDDF2\\uD83C\\uDDF4|\\uD83C\\uDDF2\\uD83C\\uDDF3|\\uD83C\\uDDF2\\uD83C\\uDDF2|\\uD83C\\uDDF2\\uD83C\\uDDF1|\\uD83C\\uDDF2\\uD83C\\uDDF0|\\uD83C\\uDDF2\\uD83C\\uDDED|\\uD83C\\uDDF2\\uD83C\\uDDEC|\\uD83C\\uDDF2\\uD83C\\uDDEB|\\uD83C\\uDDF2\\uD83C\\uDDEA|\\uD83C\\uDDF2\\uD83C\\uDDE9|\\uD83C\\uDDF2\\uD83C\\uDDE8|\\uD83C\\uDDF2\\uD83C\\uDDE6|\\uD83C\\uDDF1\\uD83C\\uDDFE|\\uD83C\\uDDF1\\uD83C\\uDDFB|\\uD83C\\uDDF1\\uD83C\\uDDFA|\\uD83C\\uDDF1\\uD83C\\uDDF9|\\uD83C\\uDDF1\\uD83C\\uDDF8|\\uD83C\\uDDF1\\uD83C\\uDDF7|\\uD83C\\uDDF1\\uD83C\\uDDF0|\\uD83C\\uDDF1\\uD83C\\uDDEE|\\uD83C\\uDDF1\\uD83C\\uDDE8|\\uD83C\\uDDF1\\uD83C\\uDDE7|\\uD83C\\uDDF1\\uD83C\\uDDE6|\\uD83C\\uDDF0\\uD83C\\uDDFF|\\uD83C\\uDDF0\\uD83C\\uDDFE|\\uD83C\\uDDF0\\uD83C\\uDDFC|\\uD83C\\uDDF0\\uD83C\\uDDF7|\\uD83C\\uDDF0\\uD83C\\uDDF5|\\uD83C\\uDDF0\\uD83C\\uDDF3|\\uD83C\\uDDF0\\uD83C\\uDDF2|\\uD83C\\uDDF0\\uD83C\\uDDEE|\\uD83C\\uDDF0\\uD83C\\uDDED|\\uD83C\\uDDF0\\uD83C\\uDDEC|\\uD83C\\uDDF0\\uD83C\\uDDEA|\\uD83C\\uDDEF\\uD83C\\uDDF5|\\uD83C\\uDDEF\\uD83C\\uDDF4|\\uD83C\\uDDEF\\uD83C\\uDDF2|\\uD83C\\uDDEF\\uD83C\\uDDEA|\\uD83C\\uDDEE\\uD83C\\uDDF9|\\uD83C\\uDDEE\\uD83C\\uDDF8|\\uD83C\\uDDEE\\uD83C\\uDDF7|\\uD83C\\uDDEE\\uD83C\\uDDF6|\\uD83C\\uDDEE\\uD83C\\uDDF4|\\uD83C\\uDDEE\\uD83C\\uDDF3|\\uD83C\\uDDEE\\uD83C\\uDDF2|\\uD83C\\uDDEE\\uD83C\\uDDF1|\\uD83C\\uDDEE\\uD83C\\uDDEA|\\uD83C\\uDDEE\\uD83C\\uDDE9|\\uD83C\\uDDEE\\uD83C\\uDDE8|\\uD83C\\uDDED\\uD83C\\uDDFA|\\uD83C\\uDDED\\uD83C\\uDDF9|\\uD83C\\uDDED\\uD83C\\uDDF7|\\uD83C\\uDDED\\uD83C\\uDDF3|\\uD83C\\uDDED\\uD83C\\uDDF2|\\uD83C\\uDDED\\uD83C\\uDDF0|\\uD83C\\uDDEC\\uD83C\\uDDFE|\\uD83C\\uDDEC\\uD83C\\uDDFC|\\uD83C\\uDDEC\\uD83C\\uDDFA|\\uD83C\\uDDEC\\uD83C\\uDDF9|\\uD83C\\uDDEC\\uD83C\\uDDF8|\\uD83C\\uDDEC\\uD83C\\uDDF7|\\uD83C\\uDDEC\\uD83C\\uDDF6|\\uD83C\\uDDEC\\uD83C\\uDDF5|\\uD83C\\uDDEC\\uD83C\\uDDF3|\\uD83C\\uDDEC\\uD83C\\uDDF2|\\uD83C\\uDDEC\\uD83C\\uDDF1|\\uD83C\\uDDEC\\uD83C\\uDDEE|\\uD83C\\uDDEC\\uD83C\\uDDED|\\uD83C\\uDDEC\\uD83C\\uDDEC|\\uD83C\\uDDEC\\uD83C\\uDDEB|\\uD83C\\uDDEC\\uD83C\\uDDEA|\\uD83C\\uDDEC\\uD83C\\uDDE9|\\uD83C\\uDDEC\\uD83C\\uDDE7|\\uD83C\\uDDEC\\uD83C\\uDDE6|\\uD83C\\uDDEB\\uD83C\\uDDF7|\\uD83C\\uDDEB\\uD83C\\uDDF4|\\uD83C\\uDDEB\\uD83C\\uDDF2|\\uD83C\\uDDEB\\uD83C\\uDDF0|\\uD83C\\uDDEB\\uD83C\\uDDEF|\\uD83C\\uDDEB\\uD83C\\uDDEE|\\uD83C\\uDDEA\\uD83C\\uDDFA|\\uD83C\\uDDEA\\uD83C\\uDDF9|\\uD83C\\uDDEA\\uD83C\\uDDF8|\\uD83C\\uDDEA\\uD83C\\uDDF7|\\uD83C\\uDDEA\\uD83C\\uDDED|\\uD83C\\uDDEA\\uD83C\\uDDEC|\\uD83C\\uDDEA\\uD83C\\uDDEA|\\uD83C\\uDDEA\\uD83C\\uDDE8|\\uD83C\\uDDEA\\uD83C\\uDDE6|\\uD83C\\uDDE9\\uD83C\\uDDFF|\\uD83C\\uDDE9\\uD83C\\uDDF4|\\uD83C\\uDDE9\\uD83C\\uDDF2|\\uD83C\\uDDE9\\uD83C\\uDDF0|\\uD83C\\uDDE9\\uD83C\\uDDEF|\\uD83C\\uDDE9\\uD83C\\uDDEC|\\uD83C\\uDDE9\\uD83C\\uDDEA|\\uD83C\\uDDE8\\uD83C\\uDDFF|\\uD83C\\uDDE8\\uD83C\\uDDFE|\\uD83C\\uDDE8\\uD83C\\uDDFD|\\uD83C\\uDDE8\\uD83C\\uDDFC|\\uD83C\\uDDE8\\uD83C\\uDDFB|\\uD83C\\uDDE8\\uD83C\\uDDFA|\\uD83C\\uDDE8\\uD83C\\uDDF7|\\uD83C\\uDDE8\\uD83C\\uDDF5|\\uD83C\\uDDE8\\uD83C\\uDDF4|\\uD83C\\uDDE8\\uD83C\\uDDF3|\\uD83C\\uDDE8\\uD83C\\uDDF2|\\uD83C\\uDDE8\\uD83C\\uDDF1|\\uD83C\\uDDE8\\uD83C\\uDDF0|\\uD83C\\uDDE8\\uD83C\\uDDEE|\\uD83C\\uDDE8\\uD83C\\uDDED|\\uD83C\\uDDE8\\uD83C\\uDDEC|\\uD83C\\uDDE8\\uD83C\\uDDEB|\\uD83C\\uDDE8\\uD83C\\uDDE9|\\uD83C\\uDDE8\\uD83C\\uDDE8|\\uD83C\\uDDE8\\uD83C\\uDDE6|\\uD83C\\uDDE7\\uD83C\\uDDFF|\\uD83C\\uDDE7\\uD83C\\uDDFE|\\uD83C\\uDDE7\\uD83C\\uDDFC|\\uD83C\\uDDE7\\uD83C\\uDDFB|\\uD83C\\uDDE7\\uD83C\\uDDF9|\\uD83C\\uDDE7\\uD83C\\uDDF8|\\uD83C\\uDDE7\\uD83C\\uDDF7|\\uD83C\\uDDE7\\uD83C\\uDDF6|\\uD83C\\uDDE7\\uD83C\\uDDF4|\\uD83C\\uDDE7\\uD83C\\uDDF3|\\uD83C\\uDDE7\\uD83C\\uDDF2|\\uD83C\\uDDE7\\uD83C\\uDDF1|\\uD83C\\uDDE7\\uD83C\\uDDEF|\\uD83C\\uDDE7\\uD83C\\uDDEE|\\uD83C\\uDDE7\\uD83C\\uDDED|\\uD83C\\uDDE7\\uD83C\\uDDEC|\\uD83C\\uDDE7\\uD83C\\uDDEB|\\uD83C\\uDDE7\\uD83C\\uDDEA|\\uD83C\\uDDE7\\uD83C\\uDDE9|\\uD83C\\uDDE7\\uD83C\\uDDE7|\\uD83C\\uDDE7\\uD83C\\uDDE6|\\uD83C\\uDDE6\\uD83C\\uDDFF|\\uD83C\\uDDE6\\uD83C\\uDDFD|\\uD83C\\uDDE6\\uD83C\\uDDFC|\\uD83C\\uDDE6\\uD83C\\uDDFA|\\uD83C\\uDDE6\\uD83C\\uDDF9|\\uD83C\\uDFC4\\uD83C\\uDFFE|\\uD83D\\uDDE3\\uFE0F|\\u26F9\\uD83C\\uDFFF|\\u26F9\\uD83C\\uDFFE|\\u26F9\\uD83C\\uDFFD|\\u26F9\\uD83C\\uDFFC|\\u26F9\\uD83C\\uDFFB|\\u270D\\uD83C\\uDFFF|\\u270D\\uD83C\\uDFFE|\\u270D\\uD83C\\uDFFD|\\u270D\\uD83C\\uDFFC|\\u270D\\uD83C\\uDFFB|\\uD83C\\uDC04\\uFE0F|\\uD83C\\uDD7F\\uFE0F|\\uD83C\\uDE02\\uFE0F|\\uD83C\\uDE1A\\uFE0F|\\uD83C\\uDE2F\\uFE0F|\\uD83C\\uDE37\\uFE0F|\\uD83C\\uDF9E\\uFE0F|\\uD83C\\uDF9F\\uFE0F|\\uD83C\\uDFCB\\uFE0F|\\uD83C\\uDFCC\\uFE0F|\\uD83C\\uDFCD\\uFE0F|\\uD83C\\uDFCE\\uFE0F|\\uD83C\\uDF96\\uFE0F|\\uD83C\\uDF97\\uFE0F|\\uD83C\\uDF36\\uFE0F|\\uD83C\\uDF27\\uFE0F|\\uD83C\\uDF28\\uFE0F|\\uD83C\\uDF29\\uFE0F|\\uD83C\\uDF2A\\uFE0F|\\uD83C\\uDF2B\\uFE0F|\\uD83C\\uDF2C\\uFE0F|\\uD83D\\uDC3F\\uFE0F|\\uD83D\\uDD77\\uFE0F|\\uD83D\\uDD78\\uFE0F|\\uD83C\\uDF21\\uFE0F|\\uD83C\\uDF99\\uFE0F|\\uD83C\\uDF9A\\uFE0F|\\uD83C\\uDF9B\\uFE0F|\\uD83C\\uDFF3\\uFE0F|\\uD83C\\uDFF5\\uFE0F|\\uD83C\\uDFF7\\uFE0F|\\uD83D\\uDCFD\\uFE0F|\\uD83D\\uDD49\\uFE0F|\\uD83D\\uDD4A\\uFE0F|\\uD83D\\uDD6F\\uFE0F|\\uD83D\\uDD70\\uFE0F|\\uD83D\\uDD73\\uFE0F|\\uD83D\\uDD76\\uFE0F|\\uD83D\\uDD79\\uFE0F|\\uD83D\\uDD87\\uFE0F|\\uD83D\\uDD8A\\uFE0F|\\uD83D\\uDD8B\\uFE0F|\\uD83D\\uDD8C\\uFE0F|\\uD83D\\uDD8D\\uFE0F|\\uD83D\\uDDA5\\uFE0F|\\uD83D\\uDDA8\\uFE0F|\\uD83D\\uDDB2\\uFE0F|\\uD83D\\uDDBC\\uFE0F|\\uD83D\\uDDC2\\uFE0F|\\uD83D\\uDDC3\\uFE0F|\\uD83D\\uDDC4\\uFE0F|\\uD83D\\uDDD1\\uFE0F|\\uD83D\\uDDD2\\uFE0F|\\uD83D\\uDDD3\\uFE0F|\\uD83D\\uDDDC\\uFE0F|\\uD83D\\uDDDD\\uFE0F|\\uD83D\\uDDDE\\uFE0F|\\uD83D\\uDDE1\\uFE0F|\\u270B\\uD83C\\uDFFF|\\uD83D\\uDDE8\\uFE0F|\\uD83D\\uDDEF\\uFE0F|\\uD83D\\uDDF3\\uFE0F|\\uD83D\\uDDFA\\uFE0F|\\uD83D\\uDEE0\\uFE0F|\\uD83D\\uDEE1\\uFE0F|\\uD83D\\uDEE2\\uFE0F|\\uD83D\\uDEF0\\uFE0F|\\uD83C\\uDF7D\\uFE0F|\\uD83D\\uDC41\\uFE0F|\\uD83D\\uDD74\\uFE0F|\\uD83D\\uDD75\\uFE0F|\\uD83D\\uDD90\\uFE0F|\\uD83C\\uDFD4\\uFE0F|\\uD83C\\uDFD5\\uFE0F|\\uD83C\\uDFD6\\uFE0F|\\uD83C\\uDFD7\\uFE0F|\\uD83C\\uDFD8\\uFE0F|\\uD83C\\uDFD9\\uFE0F|\\uD83C\\uDFDA\\uFE0F|\\uD83C\\uDFDB\\uFE0F|\\uD83C\\uDFDC\\uFE0F|\\uD83C\\uDFDD\\uFE0F|\\uD83C\\uDFDE\\uFE0F|\\uD83C\\uDFDF\\uFE0F|\\uD83D\\uDECB\\uFE0F|\\uD83D\\uDECD\\uFE0F|\\uD83D\\uDECE\\uFE0F|\\uD83D\\uDECF\\uFE0F|\\uD83D\\uDEE3\\uFE0F|\\uD83D\\uDEE4\\uFE0F|\\uD83D\\uDEE5\\uFE0F|\\uD83D\\uDEE9\\uFE0F|\\uD83D\\uDEF3\\uFE0F|\\uD83C\\uDF24\\uFE0F|\\uD83C\\uDF25\\uFE0F|\\uD83C\\uDF26\\uFE0F|\\uD83D\\uDDB1\\uFE0F|\\u261D\\uD83C\\uDFFB|\\u261D\\uD83C\\uDFFC|\\u261D\\uD83C\\uDFFD|\\u261D\\uD83C\\uDFFE|\\u261D\\uD83C\\uDFFF|\\u270C\\uD83C\\uDFFB|\\u270C\\uD83C\\uDFFC|\\u270C\\uD83C\\uDFFD|\\u270C\\uD83C\\uDFFE|\\u270C\\uD83C\\uDFFF|\\u270A\\uD83C\\uDFFB|\\u270A\\uD83C\\uDFFC|\\u270A\\uD83C\\uDFFD|\\u270A\\uD83C\\uDFFE|\\u270A\\uD83C\\uDFFF|\\u270B\\uD83C\\uDFFB|\\u270B\\uD83C\\uDFFC|\\u270B\\uD83C\\uDFFD|\\u270B\\uD83C\\uDFFE|\\4\\uFE0F\\u20E3|\\9\\uFE0F\\u20E3|\\0\\uFE0F\\u20E3|\\1\\uFE0F\\u20E3|\\2\\uFE0F\\u20E3|\\3\\uFE0F\\u20E3|\\#\\uFE0F\\u20E3|\\5\\uFE0F\\u20E3|\\6\\uFE0F\\u20E3|\\7\\uFE0F\\u20E3|\\8\\uFE0F\\u20E3|\\*\\uFE0F\\u20E3|\\uD83D\\uDDE1|\\uD83D\\uDD77|\\uD83D\\uDDE3|\\uD83D\\uDEE4|\\uD83D\\uDDE8|\\uD83D\\uDD78|\\uD83D\\uDDEF|\\uD83C\\uDE37|\\uD83D\\uDDF3|\\uD83C\\uDF21|\\uD83D\\uDDFA|\\uD83D\\uDDB1|\\uD83D\\uDEE0|\\uD83C\\uDF99|\\uD83D\\uDEE1|\\uD83C\\uDF9E|\\uD83D\\uDEE2|\\uD83C\\uDF9A|\\uD83D\\uDEF0|\\uD83D\\uDEE3|\\uD83C\\uDF7D|\\uD83C\\uDF9B|\\uD83D\\uDC41|\\uD83C\\uDF9F|\\uD83D\\uDD74|\\uD83C\\uDFF3|\\uD83D\\uDD75|\\uD83D\\uDEF3|\\uD83D\\uDD90|\\uD83C\\uDFF5|\\uD83C\\uDFD4|\\uD83C\\uDFCB|\\uD83C\\uDFD5|\\uD83C\\uDFF7|\\uD83C\\uDFD6|\\uD83D\\uDECF|\\uD83C\\uDFD7|\\uD83D\\uDCFD|\\uD83C\\uDFD8|\\uD83C\\uDFCC|\\uD83C\\uDFD9|\\uD83D\\uDD49|\\uD83C\\uDFDA|\\uD83C\\uDF25|\\uD83C\\uDFDB|\\uD83D\\uDD4A|\\uD83C\\uDFDC|\\uD83C\\uDFCD|\\uD83C\\uDFDD|\\uD83D\\uDD6F|\\uD83C\\uDFDE|\\uD83D\\uDECE|\\uD83C\\uDFDF|\\uD83D\\uDD70|\\uD83D\\uDECB|\\uD83C\\uDFCE|\\uD83D\\uDECD|\\uD83D\\uDD73|\\uD83D\\uDECE|\\uD83D\\uDEE9|\\uD83D\\uDECF|\\uD83D\\uDD76|\\uD83D\\uDEE3|\\uD83C\\uDF96|\\uD83D\\uDEE4|\\uD83D\\uDD79|\\uD83D\\uDEE5|\\uD83D\\uDECD|\\uD83D\\uDEE9|\\uD83D\\uDD87|\\uD83D\\uDEF3|\\uD83C\\uDF97|\\uD83C\\uDF24|\\uD83D\\uDD8A|\\uD83C\\uDF25|\\uD83C\\uDC04|\\uD83C\\uDF26|\\uD83D\\uDD8B|\\uD83D\\uDDB1|\\uD83C\\uDF36|\\uD83D\\uDD8C|\\uD83C\\uDF26|\\uD83D\\uDD8D|\\uD83C\\uDF27|\\uD83D\\uDDA5|\\uD83C\\uDD7F|\\uD83D\\uDDA8|\\uD83C\\uDF28|\\uD83D\\uDDB2|\\uD83D\\uDECB|\\uD83D\\uDDBC|\\uD83C\\uDF29|\\uD83D\\uDDC2|\\uD83C\\uDE02|\\uD83D\\uDDC3|\\uD83C\\uDF2A|\\uD83D\\uDDC4|\\uD83D\\uDEE5|\\uD83D\\uDDD1|\\uD83C\\uDF2B|\\uD83D\\uDDD2|\\uD83C\\uDE1A|\\uD83D\\uDDD3|\\uD83C\\uDF2C|\\uD83D\\uDDDC|\\uD83C\\uDF24|\\uD83D\\uDDDD|\\uD83D\\uDC3F|\\uD83D\\uDDDE|\\u00A9\\uFE0F|\\uD83C\\uDFDF|\\u00AE\\uFE0F|\\uD83C\\uDFDE|\\u203C\\uFE0F|\\uD83C\\uDFDD|\\u2049\\uFE0F|\\uD83C\\uDFDC|\\u2122\\uFE0F|\\uD83C\\uDFDB|\\u2139\\uFE0F|\\uD83C\\uDFDA|\\u2194\\uFE0F|\\uD83C\\uDFD9|\\u2195\\uFE0F|\\uD83C\\uDFD8|\\u2196\\uFE0F|\\uD83C\\uDFD7|\\u2197\\uFE0F|\\uD83C\\uDFD6|\\u2198\\uFE0F|\\uD83C\\uDFD5|\\u2199\\uFE0F|\\uD83C\\uDFD4|\\u21A9\\uFE0F|\\uD83D\\uDD90|\\u21AA\\uFE0F|\\uD83D\\uDD75|\\u231A\\uFE0F|\\uD83D\\uDD74|\\u231B\\uFE0F|\\uD83D\\uDC41|\\u24C2\\uFE0F|\\uD83C\\uDF7D|\\u25AA\\uFE0F|\\uD83D\\uDEF0|\\u25AB\\uFE0F|\\uD83D\\uDEE2|\\u25B6\\uFE0F|\\uD83D\\uDEE1|\\u25C0\\uFE0F|\\uD83D\\uDEE0|\\u25FB\\uFE0F|\\uD83D\\uDDFA|\\u25FC\\uFE0F|\\uD83D\\uDDF3|\\u25FD\\uFE0F|\\uD83D\\uDDEF|\\u25FE\\uFE0F|\\uD83D\\uDDE8|\\u2600\\uFE0F|\\uD83D\\uDDE3|\\u2601\\uFE0F|\\uD83D\\uDDE1|\\u260E\\uFE0F|\\uD83D\\uDDDE|\\u2611\\uFE0F|\\uD83D\\uDDDD|\\u2614\\uFE0F|\\uD83D\\uDDDC|\\u2615\\uFE0F|\\uD83D\\uDDD3|\\u261D\\uFE0F|\\uD83D\\uDDD2|\\u263A\\uFE0F|\\uD83D\\uDDD1|\\u2648\\uFE0F|\\uD83D\\uDDC4|\\u2649\\uFE0F|\\uD83D\\uDDC3|\\u264A\\uFE0F|\\uD83D\\uDDC2|\\u264B\\uFE0F|\\uD83D\\uDDBC|\\u264C\\uFE0F|\\uD83D\\uDDB2|\\u264D\\uFE0F|\\uD83D\\uDDA8|\\u264E\\uFE0F|\\uD83D\\uDDA5|\\u264F\\uFE0F|\\uD83D\\uDD8D|\\u2650\\uFE0F|\\uD83D\\uDD8C|\\u2651\\uFE0F|\\uD83D\\uDD8B|\\u2652\\uFE0F|\\uD83D\\uDD8A|\\u2653\\uFE0F|\\uD83D\\uDD87|\\u2660\\uFE0F|\\uD83D\\uDD79|\\u2663\\uFE0F|\\uD83D\\uDD76|\\u2665\\uFE0F|\\uD83D\\uDD73|\\u2666\\uFE0F|\\uD83D\\uDD70|\\u2668\\uFE0F|\\uD83D\\uDD6F|\\u267B\\uFE0F|\\uD83D\\uDD4A|\\u267F\\uFE0F|\\uD83D\\uDD49|\\u2693\\uFE0F|\\uD83D\\uDCFD|\\u26A0\\uFE0F|\\uD83C\\uDFF7|\\u26A1\\uFE0F|\\uD83C\\uDFF5|\\u26AA\\uFE0F|\\uD83C\\uDFF3|\\u26AB\\uFE0F|\\uD83C\\uDF9B|\\u26BD\\uFE0F|\\uD83C\\uDF9A|\\u26BE\\uFE0F|\\uD83C\\uDF99|\\u26C4\\uFE0F|\\uD83C\\uDF21|\\u26C5\\uFE0F|\\uD83D\\uDD78|\\u26D4\\uFE0F|\\uD83D\\uDD77|\\u26EA\\uFE0F|\\uD83D\\uDC3F|\\uD83C\\uDE2F|\\uD83C\\uDF2C|\\u26F3\\uFE0F|\\uD83C\\uDF2B|\\u26F5\\uFE0F|\\uD83C\\uDF2A|\\u26FA\\uFE0F|\\uD83C\\uDF29|\\u26FD\\uFE0F|\\uD83C\\uDF28|\\u2702\\uFE0F|\\uD83C\\uDF27|\\u2708\\uFE0F|\\uD83C\\uDF36|\\u2709\\uFE0F|\\uD83C\\uDF97|\\u270C\\uFE0F|\\uD83C\\uDF96|\\u270F\\uFE0F|\\uD83C\\uDFCE|\\u2712\\uFE0F|\\uD83C\\uDFCD|\\u2714\\uFE0F|\\uD83C\\uDFCC|\\u2716\\uFE0F|\\uD83C\\uDFCB|\\u2733\\uFE0F|\\uD83C\\uDF9F|\\u2734\\uFE0F|\\uD83C\\uDF9E|\\u2744\\uFE0F|\\uD83C\\uDE37|\\u2747\\uFE0F|\\uD83C\\uDE2F|\\u2757\\uFE0F|\\uD83C\\uDE1A|\\u2764\\uFE0F|\\uD83C\\uDE02|\\u27A1\\uFE0F|\\uD83C\\uDD7F|\\u2934\\uFE0F|\\uD83C\\uDC04|\\u2935\\uFE0F|\\uD83C\\uDDE6|\\u2B05\\uFE0F|\\uD83C\\uDDE7|\\u2B06\\uFE0F|\\uD83C\\uDDE8|\\u2B07\\uFE0F|\\uD83C\\uDDE9|\\u2B1B\\uFE0F|\\uD83C\\uDDEA|\\u2B1C\\uFE0F|\\uD83C\\uDDEB|\\u2B50\\uFE0F|\\uD83C\\uDDEC|\\u2B55\\uFE0F|\\uD83C\\uDDED|\\u3030\\uFE0F|\\uD83C\\uDDEE|\\u303D\\uFE0F|\\uD83C\\uDDEF|\\u3297\\uFE0F|\\uD83C\\uDDF0|\\u3299\\uFE0F|\\uD83C\\uDDF1|\\u271D\\uFE0F|\\uD83C\\uDDF2|\\u2328\\uFE0F|\\uD83C\\uDDF3|\\u270D\\uFE0F|\\uD83C\\uDDF4|\\u23CF\\uFE0F|\\uD83C\\uDDF5|\\u23ED\\uFE0F|\\uD83C\\uDDF6|\\u23EE\\uFE0F|\\uD83C\\uDDF7|\\u23EF\\uFE0F|\\uD83C\\uDDF8|\\u23F1\\uFE0F|\\uD83C\\uDDF9|\\u23F2\\uFE0F|\\uD83C\\uDDFA|\\u23F8\\uFE0F|\\uD83C\\uDDFB|\\u23F9\\uFE0F|\\uD83C\\uDDFC|\\u23FA\\uFE0F|\\uD83E\\uDD5E|\\u2602\\uFE0F|\\uD83E\\uDD5D|\\u2603\\uFE0F|\\uD83E\\uDD5C|\\u2604\\uFE0F|\\uD83E\\uDD5B|\\u2618\\uFE0F|\\uD83E\\uDD5A|\\u2620\\uFE0F|\\uD83E\\uDD91|\\u2622\\uFE0F|\\uD83E\\uDD90|\\u2623\\uFE0F|\\uD83E\\uDD41|\\u2626\\uFE0F|\\uD83C\\uDFF8|\\u262A\\uFE0F|\\uD83C\\uDFD3|\\u262E\\uFE0F|\\uD83C\\uDFD2|\\u262F\\uFE0F|\\uD83C\\uDFD1|\\u2638\\uFE0F|\\uD83C\\uDFD0|\\u2639\\uFE0F|\\uD83C\\uDFCF|\\u2692\\uFE0F|\\uD83D\\uDCFF|\\u2694\\uFE0F|\\uD83D\\uDD4E|\\u2696\\uFE0F|\\uD83D\\uDD4D|\\u2697\\uFE0F|\\uD83D\\uDD4C|\\u2699\\uFE0F|\\uD83D\\uDD4B|\\u269B\\uFE0F|\\uD83D\\uDED0|\\u269C\\uFE0F|\\uD83C\\uDFFA|\\u26B0\\uFE0F|\\uD83C\\uDFF9|\\u26B1\\uFE0F|\\uD83C\\uDF7E|\\u26C8\\uFE0F|\\uD83C\\uDF7F|\\u26CF\\uFE0F|\\uD83C\\uDF2F|\\u26D1\\uFE0F|\\uD83C\\uDF2E|\\u26D3\\uFE0F|\\uD83C\\uDF2D|\\u26E9\\uFE0F|\\uD83E\\uDDC0|\\u26F0\\uFE0F|\\uD83E\\uDD83|\\u26F1\\uFE0F|\\uD83E\\uDD80|\\u26F4\\uFE0F|\\uD83E\\uDD82|\\u26F7\\uFE0F|\\uD83E\\uDD84|\\u26F8\\uFE0F|\\uD83E\\uDD81|\\u26F9\\uFE0F|\\uD83E\\uDD16|\\u2721\\uFE0F|\\uD83E\\uDD15|\\u2763\\uFE0F|\\uD83E\\uDD12|\\uD83E\\uDD49|\\uD83E\\uDD48|\\uD83E\\uDD47|\\uD83E\\uDD3A|\\uD83E\\uDD45|\\uD83E\\uDD3E|\\uD83C\\uDDFF|\\uD83E\\uDD3D|\\uD83E\\uDD4B|\\uD83E\\uDD4A|\\uD83E\\uDD3C|\\uD83E\\uDD39|\\uD83E\\uDD38|\\uD83D\\uDEF6|\\uD83D\\uDEF5|\\uD83D\\uDEF4|\\uD83D\\uDED2|\\uD83C\\uDCCF|\\uD83C\\uDD70|\\uD83C\\uDD71|\\uD83C\\uDD7E|\\uD83D\\uDED1|\\uD83C\\uDD8E|\\uD83C\\uDD91|\\uD83C\\uDDFE|\\uD83C\\uDD92|\\uD83C\\uDD93|\\uD83C\\uDD94|\\uD83C\\uDD95|\\uD83C\\uDD96|\\uD83C\\uDD97|\\uD83C\\uDD98|\\uD83E\\uDD44|\\uD83C\\uDD99|\\uD83C\\uDD9A|\\uD83E\\uDD42|\\uD83E\\uDD43|\\uD83C\\uDE01|\\uD83E\\uDD59|\\uD83C\\uDE32|\\uD83C\\uDE33|\\uD83C\\uDE34|\\uD83C\\uDE35|\\uD83C\\uDE36|\\uD83E\\uDD58|\\uD83C\\uDE38|\\uD83C\\uDE39|\\uD83E\\uDD57|\\uD83C\\uDE3A|\\uD83C\\uDE50|\\uD83C\\uDE51|\\uD83C\\uDF00|\\uD83E\\uDD56|\\uD83C\\uDF01|\\uD83C\\uDF02|\\uD83C\\uDF03|\\uD83C\\uDF04|\\uD83C\\uDF05|\\uD83C\\uDF06|\\uD83E\\uDD55|\\uD83C\\uDF07|\\uD83C\\uDF08|\\uD83E\\uDD54|\\uD83C\\uDF09|\\uD83C\\uDF0A|\\uD83C\\uDF0B|\\uD83C\\uDF0C|\\uD83C\\uDF0F|\\uD83C\\uDF11|\\uD83E\\uDD53|\\uD83C\\uDF13|\\uD83C\\uDF14|\\uD83C\\uDF15|\\uD83C\\uDF19|\\uD83C\\uDF1B|\\uD83C\\uDF1F|\\uD83E\\uDD52|\\uD83C\\uDF20|\\uD83C\\uDF30|\\uD83E\\uDD51|\\uD83C\\uDF31|\\uD83C\\uDF34|\\uD83C\\uDF35|\\uD83C\\uDF37|\\uD83C\\uDF38|\\uD83C\\uDF39|\\uD83C\\uDF3A|\\uD83C\\uDF3B|\\uD83C\\uDF3C|\\uD83C\\uDF3D|\\uD83E\\uDD50|\\uD83C\\uDF3E|\\uD83C\\uDF3F|\\uD83C\\uDF40|\\uD83C\\uDF41|\\uD83C\\uDF42|\\uD83C\\uDF43|\\uD83C\\uDF44|\\uD83C\\uDF45|\\uD83C\\uDF46|\\uD83C\\uDF47|\\uD83C\\uDF48|\\uD83C\\uDF49|\\uD83C\\uDF4A|\\uD83E\\uDD40|\\uD83C\\uDF4C|\\uD83C\\uDF4D|\\uD83C\\uDF4E|\\uD83C\\uDF4F|\\uD83C\\uDF51|\\uD83C\\uDF52|\\uD83C\\uDF53|\\uD83E\\uDD8F|\\uD83C\\uDF54|\\uD83C\\uDF55|\\uD83C\\uDF56|\\uD83E\\uDD8E|\\uD83C\\uDF57|\\uD83C\\uDF58|\\uD83C\\uDF59|\\uD83E\\uDD8D|\\uD83C\\uDF5A|\\uD83C\\uDF5B|\\uD83E\\uDD8C|\\uD83C\\uDF5C|\\uD83C\\uDF5D|\\uD83C\\uDF5E|\\uD83C\\uDF5F|\\uD83E\\uDD8B|\\uD83C\\uDF60|\\uD83C\\uDF61|\\uD83E\\uDD8A|\\uD83C\\uDF62|\\uD83C\\uDF63|\\uD83E\\uDD89|\\uD83C\\uDF64|\\uD83C\\uDF65|\\uD83E\\uDD88|\\uD83C\\uDF66|\\uD83E\\uDD87|\\uD83C\\uDF67|\\uD83C\\uDDFD|\\uD83C\\uDF68|\\uD83E\\uDD86|\\uD83C\\uDF69|\\uD83E\\uDD85|\\uD83C\\uDF6A|\\uD83D\\uDDA4|\\uD83C\\uDF6B|\\uD83C\\uDF6C|\\uD83C\\uDF6D|\\uD83C\\uDF6E|\\uD83C\\uDF6F|\\uD83E\\uDD1E|\\uD83C\\uDF70|\\uD83C\\uDF71|\\uD83C\\uDF72|\\uD83E\\uDD1D|\\uD83C\\uDF73|\\uD83C\\uDF74|\\uD83C\\uDF75|\\uD83C\\uDF76|\\uD83C\\uDF77|\\uD83C\\uDF78|\\uD83C\\uDF79|\\uD83C\\uDF7A|\\uD83C\\uDF7B|\\uD83C\\uDF80|\\uD83C\\uDF81|\\uD83C\\uDF82|\\uD83C\\uDF83|\\uD83E\\uDD1B|\\uD83E\\uDD1C|\\uD83C\\uDF84|\\uD83C\\uDF85|\\uD83C\\uDF86|\\uD83E\\uDD1A|\\uD83C\\uDF87|\\uD83C\\uDF88|\\uD83C\\uDF89|\\uD83C\\uDF8A|\\uD83C\\uDF8B|\\uD83C\\uDF8C|\\uD83E\\uDD19|\\uD83C\\uDF8D|\\uD83D\\uDD7A|\\uD83C\\uDF8E|\\uD83E\\uDD33|\\uD83C\\uDF8F|\\uD83E\\uDD30|\\uD83C\\uDF90|\\uD83E\\uDD26|\\uD83E\\uDD37|\\uD83C\\uDF91|\\uD83C\\uDF92|\\uD83C\\uDF93|\\uD83C\\uDFA0|\\uD83C\\uDFA1|\\uD83C\\uDFA2|\\uD83C\\uDFA3|\\uD83C\\uDFA4|\\uD83C\\uDFA5|\\uD83C\\uDFA6|\\uD83C\\uDFA7|\\uD83E\\uDD36|\\uD83C\\uDFA8|\\uD83E\\uDD35|\\uD83C\\uDFA9|\\uD83C\\uDFAA|\\uD83E\\uDD34|\\uD83C\\uDFAB|\\uD83C\\uDFAC|\\uD83C\\uDFAD|\\uD83E\\uDD27|\\uD83C\\uDFAE|\\uD83C\\uDFAF|\\uD83C\\uDFB0|\\uD83C\\uDFB1|\\uD83C\\uDFB2|\\uD83C\\uDFB3|\\uD83C\\uDFB4|\\uD83E\\uDD25|\\uD83C\\uDFB5|\\uD83C\\uDFB6|\\uD83C\\uDFB7|\\uD83E\\uDD24|\\uD83C\\uDFB8|\\uD83C\\uDFB9|\\uD83C\\uDFBA|\\uD83E\\uDD23|\\uD83C\\uDFBB|\\uD83C\\uDFBC|\\uD83C\\uDFBD|\\uD83E\\uDD22|\\uD83C\\uDFBE|\\uD83C\\uDFBF|\\uD83C\\uDFC0|\\uD83C\\uDFC1|\\uD83E\\uDD21|\\uD83C\\uDFC2|\\uD83C\\uDFC3|\\uD83C\\uDFC4|\\uD83C\\uDFC6|\\uD83C\\uDFC8|\\uD83C\\uDFCA|\\uD83C\\uDFE0|\\uD83C\\uDFE1|\\uD83C\\uDFE2|\\uD83C\\uDFE3|\\uD83C\\uDFE5|\\uD83C\\uDFE6|\\uD83C\\uDFE7|\\uD83C\\uDFE8|\\uD83C\\uDFE9|\\uD83C\\uDFEA|\\uD83C\\uDFEB|\\uD83C\\uDFEC|\\uD83E\\uDD20|\\uD83C\\uDFED|\\uD83C\\uDFEE|\\uD83C\\uDFEF|\\uD83C\\uDFF0|\\uD83D\\uDC0C|\\uD83D\\uDC0D|\\uD83D\\uDC0E|\\uD83D\\uDC11|\\uD83D\\uDC12|\\uD83D\\uDC14|\\uD83D\\uDC17|\\uD83D\\uDC18|\\uD83D\\uDC19|\\uD83D\\uDC1A|\\uD83D\\uDC1B|\\uD83D\\uDC1C|\\uD83D\\uDC1D|\\uD83D\\uDC1E|\\uD83D\\uDC1F|\\uD83D\\uDC20|\\uD83D\\uDC21|\\uD83D\\uDC22|\\uD83D\\uDC23|\\uD83D\\uDC24|\\uD83D\\uDC25|\\uD83D\\uDC26|\\uD83D\\uDC27|\\uD83D\\uDC28|\\uD83D\\uDC29|\\uD83D\\uDC2B|\\uD83D\\uDC2C|\\uD83D\\uDC2D|\\uD83D\\uDC2E|\\uD83D\\uDC2F|\\uD83D\\uDC30|\\uD83D\\uDC31|\\uD83D\\uDC32|\\uD83D\\uDC33|\\uD83D\\uDC34|\\uD83D\\uDC35|\\uD83D\\uDC36|\\uD83D\\uDC37|\\uD83D\\uDC38|\\uD83D\\uDC39|\\uD83D\\uDC3A|\\uD83D\\uDC3B|\\uD83D\\uDC3C|\\uD83D\\uDC3D|\\uD83D\\uDC3E|\\uD83D\\uDC40|\\uD83D\\uDC42|\\uD83D\\uDC43|\\uD83D\\uDC44|\\uD83D\\uDC45|\\uD83D\\uDC46|\\uD83D\\uDC47|\\uD83D\\uDC48|\\uD83D\\uDC49|\\uD83D\\uDC4A|\\uD83D\\uDC4B|\\uD83D\\uDC4C|\\uD83D\\uDC4D|\\uD83D\\uDC4E|\\uD83D\\uDC4F|\\uD83D\\uDC50|\\uD83D\\uDC51|\\uD83D\\uDC52|\\uD83D\\uDC53|\\uD83D\\uDC54|\\uD83D\\uDC55|\\uD83D\\uDC56|\\uD83D\\uDC57|\\uD83D\\uDC58|\\uD83D\\uDC59|\\uD83D\\uDC5A|\\uD83D\\uDC5B|\\uD83D\\uDC5C|\\uD83D\\uDC5D|\\uD83D\\uDC5E|\\uD83D\\uDC5F|\\uD83D\\uDC60|\\uD83D\\uDC61|\\uD83D\\uDC62|\\uD83D\\uDC63|\\uD83D\\uDC64|\\uD83D\\uDC66|\\uD83D\\uDC67|\\uD83D\\uDC68|\\uD83D\\uDC69|\\uD83D\\uDC6A|\\uD83D\\uDC6B|\\uD83D\\uDC6E|\\uD83D\\uDC6F|\\uD83D\\uDC70|\\uD83D\\uDC71|\\uD83D\\uDC72|\\uD83D\\uDC73|\\uD83D\\uDC74|\\uD83D\\uDC75|\\uD83D\\uDC76|\\uD83D\\uDC77|\\uD83D\\uDC78|\\uD83D\\uDC79|\\uD83D\\uDC7A|\\uD83D\\uDC7B|\\uD83D\\uDC7C|\\uD83D\\uDC7D|\\uD83D\\uDC7E|\\uD83D\\uDC7F|\\uD83D\\uDC80|\\uD83D\\uDCC7|\\uD83D\\uDC81|\\uD83D\\uDC82|\\uD83D\\uDC83|\\uD83D\\uDC84|\\uD83D\\uDC85|\\uD83D\\uDCD2|\\uD83D\\uDC86|\\uD83D\\uDCD3|\\uD83D\\uDC87|\\uD83D\\uDCD4|\\uD83D\\uDC88|\\uD83D\\uDCD5|\\uD83D\\uDC89|\\uD83D\\uDCD6|\\uD83D\\uDC8A|\\uD83D\\uDCD7|\\uD83D\\uDC8B|\\uD83D\\uDCD8|\\uD83D\\uDC8C|\\uD83D\\uDCD9|\\uD83D\\uDC8D|\\uD83D\\uDCDA|\\uD83D\\uDC8E|\\uD83D\\uDCDB|\\uD83D\\uDC8F|\\uD83D\\uDCDC|\\uD83D\\uDC90|\\uD83D\\uDCDD|\\uD83D\\uDC91|\\uD83D\\uDCDE|\\uD83D\\uDC92|\\uD83D\\uDCDF|\\uD83D\\uDCE0|\\uD83D\\uDC93|\\uD83D\\uDCE1|\\uD83D\\uDCE2|\\uD83D\\uDC94|\\uD83D\\uDCE3|\\uD83D\\uDCE4|\\uD83D\\uDC95|\\uD83D\\uDCE5|\\uD83D\\uDCE6|\\uD83D\\uDC96|\\uD83D\\uDCE7|\\uD83D\\uDCE8|\\uD83D\\uDC97|\\uD83D\\uDCE9|\\uD83D\\uDCEA|\\uD83D\\uDC98|\\uD83D\\uDCEB|\\uD83D\\uDCEE|\\uD83D\\uDC99|\\uD83D\\uDCF0|\\uD83D\\uDCF1|\\uD83D\\uDC9A|\\uD83D\\uDCF2|\\uD83D\\uDCF3|\\uD83D\\uDC9B|\\uD83D\\uDCF4|\\uD83D\\uDCF6|\\uD83D\\uDC9C|\\uD83D\\uDCF7|\\uD83D\\uDCF9|\\uD83D\\uDC9D|\\uD83D\\uDCFA|\\uD83D\\uDCFB|\\uD83D\\uDC9E|\\uD83D\\uDCFC|\\uD83D\\uDD03|\\uD83D\\uDC9F|\\uD83D\\uDD0A|\\uD83D\\uDD0B|\\uD83D\\uDCA0|\\uD83D\\uDD0C|\\uD83D\\uDD0D|\\uD83D\\uDCA1|\\uD83D\\uDD0E|\\uD83D\\uDD0F|\\uD83D\\uDCA2|\\uD83D\\uDD10|\\uD83D\\uDD11|\\uD83D\\uDCA3|\\uD83D\\uDD12|\\uD83D\\uDD13|\\uD83D\\uDCA4|\\uD83D\\uDD14|\\uD83D\\uDD16|\\uD83D\\uDCA5|\\uD83D\\uDD17|\\uD83D\\uDD18|\\uD83D\\uDCA6|\\uD83D\\uDD19|\\uD83D\\uDD1A|\\uD83D\\uDCA7|\\uD83D\\uDD1B|\\uD83D\\uDD1C|\\uD83D\\uDCA8|\\uD83D\\uDD1D|\\uD83D\\uDD1E|\\uD83D\\uDCA9|\\uD83D\\uDD1F|\\uD83D\\uDCAA|\\uD83D\\uDD20|\\uD83D\\uDD21|\\uD83D\\uDCAB|\\uD83D\\uDD22|\\uD83D\\uDD23|\\uD83D\\uDCAC|\\uD83D\\uDD24|\\uD83D\\uDD25|\\uD83D\\uDCAE|\\uD83D\\uDD26|\\uD83D\\uDD27|\\uD83D\\uDCAF|\\uD83D\\uDD28|\\uD83D\\uDD29|\\uD83D\\uDCB0|\\uD83D\\uDD2A|\\uD83D\\uDD2B|\\uD83D\\uDCB1|\\uD83D\\uDD2E|\\uD83D\\uDCB2|\\uD83D\\uDD2F|\\uD83D\\uDCB3|\\uD83D\\uDD30|\\uD83D\\uDD31|\\uD83D\\uDCB4|\\uD83D\\uDD32|\\uD83D\\uDD33|\\uD83D\\uDCB5|\\uD83D\\uDD34|\\uD83D\\uDD35|\\uD83D\\uDCB8|\\uD83D\\uDD36|\\uD83D\\uDD37|\\uD83D\\uDCB9|\\uD83D\\uDD38|\\uD83D\\uDD39|\\uD83D\\uDCBA|\\uD83D\\uDD3A|\\uD83D\\uDD3B|\\uD83D\\uDCBB|\\uD83D\\uDD3C|\\uD83D\\uDCBC|\\uD83D\\uDD3D|\\uD83D\\uDD50|\\uD83D\\uDCBD|\\uD83D\\uDD51|\\uD83D\\uDCBE|\\uD83D\\uDD52|\\uD83D\\uDCBF|\\uD83D\\uDD53|\\uD83D\\uDCC0|\\uD83D\\uDD54|\\uD83D\\uDD55|\\uD83D\\uDCC1|\\uD83D\\uDD56|\\uD83D\\uDD57|\\uD83D\\uDCC2|\\uD83D\\uDD58|\\uD83D\\uDD59|\\uD83D\\uDCC3|\\uD83D\\uDD5A|\\uD83D\\uDD5B|\\uD83D\\uDCC4|\\uD83D\\uDDFB|\\uD83D\\uDDFC|\\uD83D\\uDCC5|\\uD83D\\uDDFD|\\uD83D\\uDDFE|\\uD83D\\uDCC6|\\uD83D\\uDDFF|\\uD83D\\uDE01|\\uD83D\\uDE02|\\uD83D\\uDE03|\\uD83D\\uDCC8|\\uD83D\\uDE04|\\uD83D\\uDE05|\\uD83D\\uDCC9|\\uD83D\\uDE06|\\uD83D\\uDE09|\\uD83D\\uDCCA|\\uD83D\\uDE0A|\\uD83D\\uDE0B|\\uD83D\\uDCCB|\\uD83D\\uDE0C|\\uD83D\\uDE0D|\\uD83D\\uDCCC|\\uD83D\\uDE0F|\\uD83D\\uDE12|\\uD83D\\uDCCD|\\uD83D\\uDE13|\\uD83D\\uDE14|\\uD83D\\uDCCE|\\uD83D\\uDE16|\\uD83D\\uDE18|\\uD83D\\uDCCF|\\uD83D\\uDE1A|\\uD83D\\uDE1C|\\uD83D\\uDCD0|\\uD83D\\uDE1D|\\uD83D\\uDE1E|\\uD83D\\uDCD1|\\uD83D\\uDE20|\\uD83D\\uDE21|\\uD83D\\uDE22|\\uD83D\\uDE23|\\uD83D\\uDE24|\\uD83D\\uDE25|\\uD83D\\uDE28|\\uD83D\\uDE29|\\uD83D\\uDE2A|\\uD83D\\uDE2B|\\uD83D\\uDE2D|\\uD83D\\uDE30|\\uD83D\\uDE31|\\uD83D\\uDE32|\\uD83D\\uDE33|\\uD83D\\uDE35|\\uD83D\\uDE37|\\uD83D\\uDE38|\\uD83D\\uDE39|\\uD83D\\uDE3A|\\uD83D\\uDE3B|\\uD83D\\uDE3C|\\uD83D\\uDE3D|\\uD83D\\uDE3E|\\uD83D\\uDE3F|\\uD83D\\uDE40|\\uD83D\\uDE45|\\uD83D\\uDE46|\\uD83D\\uDE47|\\uD83D\\uDE48|\\uD83D\\uDE49|\\uD83D\\uDE4A|\\uD83D\\uDE4B|\\uD83D\\uDE4C|\\uD83D\\uDE4D|\\uD83D\\uDE4E|\\uD83D\\uDE4F|\\uD83D\\uDE80|\\uD83D\\uDE83|\\uD83D\\uDE84|\\uD83D\\uDE85|\\uD83D\\uDE87|\\uD83D\\uDE89|\\uD83D\\uDE8C|\\uD83D\\uDE8F|\\uD83D\\uDE91|\\uD83D\\uDE92|\\uD83D\\uDE93|\\uD83D\\uDE95|\\uD83D\\uDE97|\\uD83D\\uDE99|\\uD83D\\uDE9A|\\uD83D\\uDEA2|\\uD83D\\uDEA4|\\uD83D\\uDEA5|\\uD83D\\uDEA7|\\uD83D\\uDEA8|\\uD83D\\uDEA9|\\uD83D\\uDEAA|\\uD83D\\uDEAB|\\uD83D\\uDEAC|\\uD83D\\uDEAD|\\uD83D\\uDEB2|\\uD83D\\uDEB6|\\uD83D\\uDEB9|\\uD83D\\uDEBA|\\uD83D\\uDEBB|\\uD83D\\uDEBC|\\uD83D\\uDEBD|\\uD83D\\uDEBE|\\uD83D\\uDEC0|\\uD83E\\uDD18|\\uD83D\\uDE00|\\uD83D\\uDE07|\\uD83D\\uDE08|\\uD83D\\uDE0E|\\uD83D\\uDE10|\\uD83D\\uDE11|\\uD83D\\uDE15|\\uD83D\\uDE17|\\uD83D\\uDE19|\\uD83D\\uDE1B|\\uD83D\\uDE1F|\\uD83D\\uDE26|\\uD83D\\uDE27|\\uD83D\\uDE2C|\\uD83D\\uDE2E|\\uD83D\\uDE2F|\\uD83D\\uDE34|\\uD83D\\uDE36|\\uD83D\\uDE81|\\uD83D\\uDE82|\\uD83D\\uDE86|\\uD83D\\uDE88|\\uD83D\\uDE8A|\\uD83D\\uDE8D|\\uD83D\\uDE8E|\\uD83D\\uDE90|\\uD83D\\uDE94|\\uD83D\\uDE96|\\uD83D\\uDE98|\\uD83D\\uDE9B|\\uD83D\\uDE9C|\\uD83D\\uDE9D|\\uD83D\\uDE9E|\\uD83D\\uDE9F|\\uD83D\\uDEA0|\\uD83D\\uDEA1|\\uD83D\\uDEA3|\\uD83D\\uDEA6|\\uD83D\\uDEAE|\\uD83D\\uDEAF|\\uD83D\\uDEB0|\\uD83D\\uDEB1|\\uD83D\\uDEB3|\\uD83D\\uDEB4|\\uD83D\\uDEB5|\\uD83D\\uDEB7|\\uD83D\\uDEB8|\\uD83D\\uDEBF|\\uD83D\\uDEC1|\\uD83D\\uDEC2|\\uD83D\\uDEC3|\\uD83D\\uDEC4|\\uD83D\\uDEC5|\\uD83C\\uDF0D|\\uD83C\\uDF0E|\\uD83C\\uDF10|\\uD83C\\uDF12|\\uD83C\\uDF16|\\uD83C\\uDF17|\\uD83C\\uDF18|\\uD83C\\uDF1A|\\uD83C\\uDF1C|\\uD83C\\uDF1D|\\uD83C\\uDF1E|\\uD83C\\uDF32|\\uD83C\\uDF33|\\uD83C\\uDF4B|\\uD83C\\uDF50|\\uD83C\\uDF7C|\\uD83C\\uDFC7|\\uD83C\\uDFC9|\\uD83C\\uDFE4|\\uD83D\\uDC00|\\uD83D\\uDC01|\\uD83D\\uDC02|\\uD83D\\uDC03|\\uD83D\\uDC04|\\uD83D\\uDC05|\\uD83D\\uDC06|\\uD83D\\uDC07|\\uD83D\\uDC08|\\uD83D\\uDC09|\\uD83D\\uDC0A|\\uD83D\\uDC0B|\\uD83D\\uDC0F|\\uD83D\\uDC10|\\uD83D\\uDC13|\\uD83D\\uDC15|\\uD83D\\uDC16|\\uD83D\\uDC2A|\\uD83D\\uDC65|\\uD83D\\uDC6C|\\uD83D\\uDC6D|\\uD83D\\uDCAD|\\uD83D\\uDCB6|\\uD83D\\uDCB7|\\uD83D\\uDCEC|\\uD83D\\uDCED|\\uD83D\\uDCEF|\\uD83D\\uDCF5|\\uD83D\\uDD00|\\uD83D\\uDD01|\\uD83D\\uDD02|\\uD83D\\uDD04|\\uD83D\\uDD05|\\uD83D\\uDD06|\\uD83D\\uDD07|\\uD83D\\uDD09|\\uD83D\\uDD15|\\uD83D\\uDD2C|\\uD83D\\uDD2D|\\uD83D\\uDD5C|\\uD83D\\uDD5D|\\uD83D\\uDD5E|\\uD83D\\uDD5F|\\uD83D\\uDD60|\\uD83D\\uDD61|\\uD83D\\uDD62|\\uD83D\\uDD63|\\uD83D\\uDD64|\\uD83D\\uDD65|\\uD83D\\uDD66|\\uD83D\\uDD67|\\uD83D\\uDD08|\\uD83D\\uDE8B|\\uD83C\\uDFC5|\\uD83C\\uDFF4|\\uD83D\\uDCF8|\\uD83D\\uDECC|\\uD83D\\uDD95|\\uD83D\\uDD96|\\uD83D\\uDE41|\\uD83D\\uDE42|\\uD83D\\uDEEB|\\uD83D\\uDEEC|\\uD83C\\uDFFB|\\uD83C\\uDFFC|\\uD83C\\uDFFD|\\uD83C\\uDFFE|\\uD83C\\uDFFF|\\uD83D\\uDE43|\\uD83E\\uDD11|\\uD83E\\uDD13|\\uD83E\\uDD17|\\uD83D\\uDE44|\\uD83E\\uDD14|\\uD83E\\uDD10|\\u26F2\\uFE0F|\\#\\u20E3|\\9\\u20E3|\\8\\u20E3|\\7\\u20E3|\\6\\u20E3|\\*\\u20E3|\\4\\u20E3|\\3\\u20E3|\\2\\u20E3|\\1\\u20E3|\\0\\u20E3|\\5\\u20E3|\\u26B1|\\u26B0|\\u269C|\\u269B|\\u2699|\\u2697|\\u2696|\\u2694|\\u2692|\\u2639|\\u2638|\\u262F|\\u262E|\\u262A|\\u2626|\\u2623|\\u2622|\\u2620|\\u2618|\\u2604|\\u2603|\\u2602|\\u23FA|\\u23F9|\\u23F8|\\u23F2|\\u23F1|\\u23EF|\\u23EE|\\u23ED|\\u23CF|\\u270D|\\u2328|\\u271D|\\u3299|\\u3297|\\u303D|\\u3030|\\u2B55|\\u2B50|\\u2B1C|\\u2B1B|\\u2B07|\\u2B06|\\u2B05|\\u2935|\\u23E9|\\u23EA|\\u23EB|\\u23EC|\\u23F0|\\u23F3|\\u26CE|\\u2705|\\u270A|\\u270B|\\u2728|\\u274C|\\u274E|\\u2753|\\u2754|\\u2755|\\u2795|\\u2796|\\u2797|\\u27B0|\\u27BF|\\u00A9|\\u00AE|\\u203C|\\u2049|\\u2122|\\u2139|\\u2194|\\u2195|\\u2196|\\u2197|\\u2198|\\u2199|\\u21A9|\\u21AA|\\u231A|\\u231B|\\u24C2|\\u25AA|\\u25AB|\\u25B6|\\u25C0|\\u25FB|\\u25FC|\\u25FD|\\u25FE|\\u2600|\\u2601|\\u260E|\\u2611|\\u2614|\\u2615|\\u261D|\\u263A|\\u2648|\\u2649|\\u264A|\\u264B|\\u264C|\\u264D|\\u264E|\\u264F|\\u2650|\\u2651|\\u2652|\\u2653|\\u2660|\\u2663|\\u2665|\\u2666|\\u2668|\\u267B|\\u267F|\\u2693|\\u26A0|\\u26A1|\\u26AA|\\u26AB|\\u26BD|\\u26BE|\\u26C4|\\u26C5|\\u26D4|\\u26EA|\\u26F2|\\u26F3|\\u26F5|\\u26FA|\\u26FD|\\u2702|\\u2708|\\u2709|\\u270C|\\u270F|\\u2712|\\u2714|\\u2716|\\u2733|\\u2734|\\u2744|\\u2747|\\u2721|\\u2764|\\u27A1|\\u2934|\\u2935|\\u2B05|\\u2B06|\\u2B07|\\u2B1B|\\u2B1C|\\u2B50|\\u2B55|\\u3030|\\u303D|\\u3297|\\u3299|\\u2934|\\u27A1|\\u2764|\\u2757|\\u2747|\\u2744|\\u2734|\\u2733|\\u2716|\\u2714|\\u2712|\\u270F|\\u270C|\\u2709|\\u2708|\\u2702|\\u26FD|\\u26FA|\\u26F5|\\u26F3|\\u26F2|\\u26EA|\\u26D4|\\u26C5|\\u26C4|\\u26BE|\\u26BD|\\u26AB|\\u26AA|\\u26A1|\\u26A0|\\u2693|\\u271D|\\u267F|\\u267B|\\u2668|\\u2666|\\u2665|\\u2663|\\u2660|\\u2653|\\u2652|\\u2651|\\u2650|\\u264F|\\u264E|\\u264D|\\u2328|\\u264C|\\u264B|\\u264A|\\u2649|\\u2648|\\u263A|\\u261D|\\u2615|\\u2614|\\u2611|\\u260E|\\u2601|\\u2600|\\u25FE|\\u25FD|\\u25FC|\\u25FB|\\u25C0|\\u25B6|\\u25AB|\\u25AA|\\u24C2|\\u231B|\\u231A|\\u21AA|\\u270D|\\u21A9|\\u2199|\\u2198|\\u2197|\\u2196|\\u2195|\\u2194|\\u2139|\\u2122|\\u2049|\\u203C|\\u00AE|\\u00A9|\\u2763|\\u26F9|\\u26F8|\\u26F7|\\u26F4|\\u26F1|\\u26F0|\\u26E9|\\u26D3|\\u23CF|\\u23ED|\\u23EE|\\u23EF|\\u23F1|\\u23F2|\\u23F8|\\u23F9|\\u23FA|\\u2602|\\u2603|\\u2604|\\u2618|\\u2620|\\u2622|\\u2623|\\u2626|\\u262A|\\u262E|\\u262F|\\u2638|\\u2639|\\u2692|\\u2694|\\u2696|\\u2697|\\u2699|\\u269B|\\u269C|\\u26B0|\\u26B1|\\u26C8|\\u26CF|\\u26D1|\\u26D3|\\u26E9|\\u26F0|\\u26F1|\\u26F4|\\u26F7|\\u26F8|\\u26F9|\\u2721|\\u2763|\\u26D1|\\u26CF|\\u26C8|\\u2757)';
    ns.jsEscapeMap = {"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","\uD83D\uDC69\u2764\uD83D\uDC8B\uD83D\uDC69":"1f469-2764-1f48b-1f469","\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","\uD83D\uDC68\u2764\uD83D\uDC8B\uD83D\uDC68":"1f468-2764-1f48b-1f468","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-200d-1f468-200d-1f466-200d-1f466","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC66\uD83D\uDC66":"1f468-1f468-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-200d-1f468-200d-1f467-200d-1f466","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC67\uD83D\uDC66":"1f468-1f468-1f467-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-200d-1f468-200d-1f467-200d-1f467","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC67\uD83D\uDC67":"1f468-1f468-1f467-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-200d-1f469-200d-1f466-200d-1f466","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC66\uD83D\uDC66":"1f468-1f469-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-200d-1f469-200d-1f467-200d-1f466","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC67\uD83D\uDC66":"1f468-1f469-1f467-1f466","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-200d-1f469-200d-1f467-200d-1f467","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC67\uD83D\uDC67":"1f468-1f469-1f467-1f467","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f469-200d-1f469-200d-1f466-200d-1f466","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC66\uD83D\uDC66":"1f469-1f469-1f466-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f469-200d-1f469-200d-1f467-200d-1f466","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC67\uD83D\uDC66":"1f469-1f469-1f467-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f469-200d-1f469-200d-1f467-200d-1f467","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC67\uD83D\uDC67":"1f469-1f469-1f467-1f467","\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69":"1f469-200d-2764-fe0f-200d-1f469","\uD83D\uDC69\u2764\uD83D\uDC69":"1f469-2764-1f469","\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68":"1f468-200d-2764-fe0f-200d-1f468","\uD83D\uDC68\u2764\uD83D\uDC68":"1f468-2764-1f468","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66":"1f468-200d-1f468-200d-1f466","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC66":"1f468-1f468-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67":"1f468-200d-1f468-200d-1f467","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC67":"1f468-1f468-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67":"1f468-200d-1f469-200d-1f467","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC67":"1f468-1f469-1f467","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66":"1f469-200d-1f469-200d-1f466","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC66":"1f469-1f469-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67":"1f469-200d-1f469-200d-1f467","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC67":"1f469-1f469-1f467","\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08":"1f3f3-fe0f-200d-1f308","\uD83C\uDFF3\uD83C\uDF08":"1f3f3-1f308","\uD83D\uDC41\u200D\uD83D\uDDE8":"1f441-200d-1f5e8","\uD83D\uDC41\uD83D\uDDE8":"1f441-1f5e8","#\uFE0F\u20E3":"0023-fe0f-20e3","#\u20E3":"0023-20e3","0\uFE0F\u20E3":"0030-fe0f-20e3","0\u20E3":"0030-20e3","1\uFE0F\u20E3":"0031-fe0f-20e3","1\u20E3":"0031-20e3","2\uFE0F\u20E3":"0032-fe0f-20e3","2\u20E3":"0032-20e3","3\uFE0F\u20E3":"0033-fe0f-20e3","3\u20E3":"0033-20e3","4\uFE0F\u20E3":"0034-fe0f-20e3","4\u20E3":"0034-20e3","5\uFE0F\u20E3":"0035-fe0f-20e3","5\u20E3":"0035-20e3","6\uFE0F\u20E3":"0036-fe0f-20e3","6\u20E3":"0036-20e3","7\uFE0F\u20E3":"0037-fe0f-20e3","7\u20E3":"0037-20e3","8\uFE0F\u20E3":"0038-fe0f-20e3","8\u20E3":"0038-20e3","9\uFE0F\u20E3":"0039-fe0f-20e3","9\u20E3":"0039-20e3","*\uFE0F\u20E3":"002a-fe0f-20e3","*\u20E3":"002a-20e3","\uD83E\uDD3E\uD83C\uDFFF":"1f93e-1f3ff","\uD83E\uDD3E\uD83C\uDFFE":"1f93e-1f3fe","\uD83E\uDD3E\uD83C\uDFFD":"1f93e-1f3fd","\uD83E\uDD3E\uD83C\uDFFC":"1f93e-1f3fc","\uD83E\uDD3E\uD83C\uDFFB":"1f93e-1f3fb","\uD83E\uDD3D\uD83C\uDFFF":"1f93d-1f3ff","\uD83E\uDD3D\uD83C\uDFFE":"1f93d-1f3fe","\uD83E\uDD3D\uD83C\uDFFD":"1f93d-1f3fd","\uD83E\uDD3D\uD83C\uDFFC":"1f93d-1f3fc","\uD83E\uDD3D\uD83C\uDFFB":"1f93d-1f3fb","\uD83E\uDD3C\uD83C\uDFFF":"1f93c-1f3ff","\uD83E\uDD3C\uD83C\uDFFE":"1f93c-1f3fe","\uD83E\uDD3C\uD83C\uDFFD":"1f93c-1f3fd","\uD83E\uDD3C\uD83C\uDFFC":"1f93c-1f3fc","\uD83E\uDD3C\uD83C\uDFFB":"1f93c-1f3fb","\uD83E\uDD39\uD83C\uDFFF":"1f939-1f3ff","\uD83E\uDD39\uD83C\uDFFE":"1f939-1f3fe","\uD83E\uDD39\uD83C\uDFFD":"1f939-1f3fd","\uD83E\uDD39\uD83C\uDFFC":"1f939-1f3fc","\uD83E\uDD39\uD83C\uDFFB":"1f939-1f3fb","\uD83E\uDD38\uD83C\uDFFF":"1f938-1f3ff","\uD83E\uDD38\uD83C\uDFFE":"1f938-1f3fe","\uD83E\uDD38\uD83C\uDFFD":"1f938-1f3fd","\uD83E\uDD38\uD83C\uDFFC":"1f938-1f3fc","\uD83E\uDD38\uD83C\uDFFB":"1f938-1f3fb","\uD83E\uDD37\uD83C\uDFFF":"1f937-1f3ff","\uD83E\uDD37\uD83C\uDFFE":"1f937-1f3fe","\uD83E\uDD37\uD83C\uDFFD":"1f937-1f3fd","\uD83E\uDD37\uD83C\uDFFC":"1f937-1f3fc","\uD83E\uDD37\uD83C\uDFFB":"1f937-1f3fb","\uD83E\uDD36\uD83C\uDFFF":"1f936-1f3ff","\uD83E\uDD36\uD83C\uDFFE":"1f936-1f3fe","\uD83E\uDD36\uD83C\uDFFD":"1f936-1f3fd","\uD83E\uDD36\uD83C\uDFFC":"1f936-1f3fc","\uD83E\uDD36\uD83C\uDFFB":"1f936-1f3fb","\uD83E\uDD35\uD83C\uDFFF":"1f935-1f3ff","\uD83E\uDD35\uD83C\uDFFE":"1f935-1f3fe","\uD83E\uDD35\uD83C\uDFFD":"1f935-1f3fd","\uD83E\uDD35\uD83C\uDFFC":"1f935-1f3fc","\uD83E\uDD35\uD83C\uDFFB":"1f935-1f3fb","\uD83E\uDD34\uD83C\uDFFF":"1f934-1f3ff","\uD83E\uDD34\uD83C\uDFFE":"1f934-1f3fe","\uD83E\uDD34\uD83C\uDFFD":"1f934-1f3fd","\uD83E\uDD34\uD83C\uDFFC":"1f934-1f3fc","\uD83E\uDD34\uD83C\uDFFB":"1f934-1f3fb","\uD83E\uDD33\uD83C\uDFFF":"1f933-1f3ff","\uD83E\uDD33\uD83C\uDFFE":"1f933-1f3fe","\uD83E\uDD33\uD83C\uDFFD":"1f933-1f3fd","\uD83E\uDD33\uD83C\uDFFC":"1f933-1f3fc","\uD83E\uDD33\uD83C\uDFFB":"1f933-1f3fb","\uD83E\uDD30\uD83C\uDFFF":"1f930-1f3ff","\uD83E\uDD30\uD83C\uDFFE":"1f930-1f3fe","\uD83E\uDD30\uD83C\uDFFD":"1f930-1f3fd","\uD83E\uDD30\uD83C\uDFFC":"1f930-1f3fc","\uD83E\uDD30\uD83C\uDFFB":"1f930-1f3fb","\uD83E\uDD26\uD83C\uDFFF":"1f926-1f3ff","\uD83E\uDD26\uD83C\uDFFE":"1f926-1f3fe","\uD83E\uDD26\uD83C\uDFFD":"1f926-1f3fd","\uD83E\uDD26\uD83C\uDFFC":"1f926-1f3fc","\uD83E\uDD26\uD83C\uDFFB":"1f926-1f3fb","\uD83E\uDD1E\uD83C\uDFFF":"1f91e-1f3ff","\uD83E\uDD1E\uD83C\uDFFE":"1f91e-1f3fe","\uD83E\uDD1E\uD83C\uDFFD":"1f91e-1f3fd","\uD83E\uDD1E\uD83C\uDFFC":"1f91e-1f3fc","\uD83E\uDD1E\uD83C\uDFFB":"1f91e-1f3fb","\uD83E\uDD1D\uD83C\uDFFF":"1f91d-1f3ff","\uD83E\uDD1D\uD83C\uDFFE":"1f91d-1f3fe","\uD83E\uDD1D\uD83C\uDFFD":"1f91d-1f3fd","\uD83E\uDD1D\uD83C\uDFFC":"1f91d-1f3fc","\uD83E\uDD1D\uD83C\uDFFB":"1f91d-1f3fb","\uD83E\uDD1C\uD83C\uDFFF":"1f91c-1f3ff","\uD83E\uDD1C\uD83C\uDFFE":"1f91c-1f3fe","\uD83E\uDD1C\uD83C\uDFFD":"1f91c-1f3fd","\uD83E\uDD1C\uD83C\uDFFC":"1f91c-1f3fc","\uD83E\uDD1C\uD83C\uDFFB":"1f91c-1f3fb","\uD83E\uDD1B\uD83C\uDFFF":"1f91b-1f3ff","\uD83E\uDD1B\uD83C\uDFFE":"1f91b-1f3fe","\uD83E\uDD1B\uD83C\uDFFD":"1f91b-1f3fd","\uD83E\uDD1B\uD83C\uDFFC":"1f91b-1f3fc","\uD83E\uDD1B\uD83C\uDFFB":"1f91b-1f3fb","\uD83E\uDD1A\uD83C\uDFFF":"1f91a-1f3ff","\uD83E\uDD1A\uD83C\uDFFE":"1f91a-1f3fe","\uD83E\uDD1A\uD83C\uDFFD":"1f91a-1f3fd","\uD83E\uDD1A\uD83C\uDFFC":"1f91a-1f3fc","\uD83E\uDD1A\uD83C\uDFFB":"1f91a-1f3fb","\uD83E\uDD19\uD83C\uDFFF":"1f919-1f3ff","\uD83E\uDD19\uD83C\uDFFE":"1f919-1f3fe","\uD83E\uDD19\uD83C\uDFFD":"1f919-1f3fd","\uD83E\uDD19\uD83C\uDFFC":"1f919-1f3fc","\uD83E\uDD19\uD83C\uDFFB":"1f919-1f3fb","\uD83E\uDD18\uD83C\uDFFF":"1f918-1f3ff","\uD83E\uDD18\uD83C\uDFFE":"1f918-1f3fe","\uD83E\uDD18\uD83C\uDFFD":"1f918-1f3fd","\uD83E\uDD18\uD83C\uDFFC":"1f918-1f3fc","\uD83E\uDD18\uD83C\uDFFB":"1f918-1f3fb","\uD83D\uDEC0\uD83C\uDFFF":"1f6c0-1f3ff","\uD83D\uDEC0\uD83C\uDFFE":"1f6c0-1f3fe","\uD83D\uDEC0\uD83C\uDFFD":"1f6c0-1f3fd","\uD83D\uDEC0\uD83C\uDFFC":"1f6c0-1f3fc","\uD83D\uDEC0\uD83C\uDFFB":"1f6c0-1f3fb","\uD83D\uDEB6\uD83C\uDFFF":"1f6b6-1f3ff","\uD83D\uDEB6\uD83C\uDFFE":"1f6b6-1f3fe","\uD83D\uDEB6\uD83C\uDFFD":"1f6b6-1f3fd","\uD83D\uDEB6\uD83C\uDFFC":"1f6b6-1f3fc","\uD83D\uDEB6\uD83C\uDFFB":"1f6b6-1f3fb","\uD83D\uDEB5\uD83C\uDFFF":"1f6b5-1f3ff","\uD83D\uDEB5\uD83C\uDFFE":"1f6b5-1f3fe","\uD83D\uDEB5\uD83C\uDFFD":"1f6b5-1f3fd","\uD83D\uDEB5\uD83C\uDFFC":"1f6b5-1f3fc","\uD83D\uDEB5\uD83C\uDFFB":"1f6b5-1f3fb","\uD83D\uDEB4\uD83C\uDFFF":"1f6b4-1f3ff","\uD83D\uDEB4\uD83C\uDFFE":"1f6b4-1f3fe","\uD83D\uDEB4\uD83C\uDFFD":"1f6b4-1f3fd","\uD83D\uDEB4\uD83C\uDFFC":"1f6b4-1f3fc","\uD83D\uDEB4\uD83C\uDFFB":"1f6b4-1f3fb","\uD83D\uDEA3\uD83C\uDFFF":"1f6a3-1f3ff","\uD83D\uDEA3\uD83C\uDFFE":"1f6a3-1f3fe","\uD83D\uDEA3\uD83C\uDFFD":"1f6a3-1f3fd","\uD83D\uDEA3\uD83C\uDFFC":"1f6a3-1f3fc","\uD83D\uDEA3\uD83C\uDFFB":"1f6a3-1f3fb","\uD83D\uDE4F\uD83C\uDFFF":"1f64f-1f3ff","\uD83D\uDE4F\uD83C\uDFFE":"1f64f-1f3fe","\uD83D\uDE4F\uD83C\uDFFD":"1f64f-1f3fd","\uD83D\uDE4F\uD83C\uDFFC":"1f64f-1f3fc","\uD83D\uDE4F\uD83C\uDFFB":"1f64f-1f3fb","\uD83D\uDE4E\uD83C\uDFFF":"1f64e-1f3ff","\uD83D\uDE4E\uD83C\uDFFE":"1f64e-1f3fe","\uD83D\uDE4E\uD83C\uDFFD":"1f64e-1f3fd","\uD83D\uDE4E\uD83C\uDFFC":"1f64e-1f3fc","\uD83D\uDE4E\uD83C\uDFFB":"1f64e-1f3fb","\uD83D\uDE4D\uD83C\uDFFF":"1f64d-1f3ff","\uD83D\uDE4D\uD83C\uDFFE":"1f64d-1f3fe","\uD83D\uDE4D\uD83C\uDFFD":"1f64d-1f3fd","\uD83D\uDE4D\uD83C\uDFFC":"1f64d-1f3fc","\uD83D\uDE4D\uD83C\uDFFB":"1f64d-1f3fb","\uD83D\uDE4C\uD83C\uDFFF":"1f64c-1f3ff","\uD83D\uDE4C\uD83C\uDFFE":"1f64c-1f3fe","\uD83D\uDE4C\uD83C\uDFFD":"1f64c-1f3fd","\uD83D\uDE4C\uD83C\uDFFC":"1f64c-1f3fc","\uD83D\uDE4C\uD83C\uDFFB":"1f64c-1f3fb","\uD83D\uDE4B\uD83C\uDFFF":"1f64b-1f3ff","\uD83D\uDE4B\uD83C\uDFFE":"1f64b-1f3fe","\uD83D\uDE4B\uD83C\uDFFD":"1f64b-1f3fd","\uD83D\uDE4B\uD83C\uDFFC":"1f64b-1f3fc","\uD83D\uDE4B\uD83C\uDFFB":"1f64b-1f3fb","\uD83D\uDE47\uD83C\uDFFF":"1f647-1f3ff","\uD83D\uDE47\uD83C\uDFFE":"1f647-1f3fe","\uD83D\uDE47\uD83C\uDFFD":"1f647-1f3fd","\uD83D\uDE47\uD83C\uDFFC":"1f647-1f3fc","\uD83D\uDE47\uD83C\uDFFB":"1f647-1f3fb","\uD83D\uDE46\uD83C\uDFFF":"1f646-1f3ff","\uD83D\uDE46\uD83C\uDFFE":"1f646-1f3fe","\uD83D\uDE46\uD83C\uDFFD":"1f646-1f3fd","\uD83D\uDE46\uD83C\uDFFC":"1f646-1f3fc","\uD83D\uDE46\uD83C\uDFFB":"1f646-1f3fb","\uD83D\uDE45\uD83C\uDFFF":"1f645-1f3ff","\uD83D\uDE45\uD83C\uDFFE":"1f645-1f3fe","\uD83D\uDE45\uD83C\uDFFD":"1f645-1f3fd","\uD83D\uDE45\uD83C\uDFFC":"1f645-1f3fc","\uD83D\uDE45\uD83C\uDFFB":"1f645-1f3fb","\uD83D\uDD96\uD83C\uDFFF":"1f596-1f3ff","\uD83D\uDD96\uD83C\uDFFE":"1f596-1f3fe","\uD83D\uDD96\uD83C\uDFFD":"1f596-1f3fd","\uD83D\uDD96\uD83C\uDFFC":"1f596-1f3fc","\uD83D\uDD96\uD83C\uDFFB":"1f596-1f3fb","\uD83D\uDD95\uD83C\uDFFF":"1f595-1f3ff","\uD83D\uDD95\uD83C\uDFFE":"1f595-1f3fe","\uD83D\uDD95\uD83C\uDFFD":"1f595-1f3fd","\uD83D\uDD95\uD83C\uDFFC":"1f595-1f3fc","\uD83D\uDD95\uD83C\uDFFB":"1f595-1f3fb","\uD83D\uDD90\uD83C\uDFFF":"1f590-1f3ff","\uD83D\uDD90\uD83C\uDFFE":"1f590-1f3fe","\uD83D\uDD90\uD83C\uDFFD":"1f590-1f3fd","\uD83D\uDD90\uD83C\uDFFC":"1f590-1f3fc","\uD83D\uDD90\uD83C\uDFFB":"1f590-1f3fb","\uD83D\uDD7A\uD83C\uDFFF":"1f57a-1f3ff","\uD83D\uDD7A\uD83C\uDFFE":"1f57a-1f3fe","\uD83D\uDD7A\uD83C\uDFFD":"1f57a-1f3fd","\uD83D\uDD7A\uD83C\uDFFC":"1f57a-1f3fc","\uD83D\uDD7A\uD83C\uDFFB":"1f57a-1f3fb","\uD83D\uDD75\uD83C\uDFFF":"1f575-1f3ff","\uD83D\uDD75\uD83C\uDFFE":"1f575-1f3fe","\uD83D\uDD75\uD83C\uDFFD":"1f575-1f3fd","\uD83D\uDD75\uD83C\uDFFC":"1f575-1f3fc","\uD83D\uDD75\uD83C\uDFFB":"1f575-1f3fb","\uD83D\uDCAA\uD83C\uDFFF":"1f4aa-1f3ff","\uD83D\uDCAA\uD83C\uDFFE":"1f4aa-1f3fe","\uD83D\uDCAA\uD83C\uDFFD":"1f4aa-1f3fd","\uD83D\uDCAA\uD83C\uDFFC":"1f4aa-1f3fc","\uD83D\uDCAA\uD83C\uDFFB":"1f4aa-1f3fb","\uD83D\uDC87\uD83C\uDFFF":"1f487-1f3ff","\uD83D\uDC87\uD83C\uDFFE":"1f487-1f3fe","\uD83D\uDC87\uD83C\uDFFD":"1f487-1f3fd","\uD83D\uDC87\uD83C\uDFFC":"1f487-1f3fc","\uD83D\uDC87\uD83C\uDFFB":"1f487-1f3fb","\uD83D\uDC86\uD83C\uDFFF":"1f486-1f3ff","\uD83D\uDC86\uD83C\uDFFE":"1f486-1f3fe","\uD83D\uDC86\uD83C\uDFFD":"1f486-1f3fd","\uD83D\uDC86\uD83C\uDFFC":"1f486-1f3fc","\uD83D\uDC86\uD83C\uDFFB":"1f486-1f3fb","\uD83D\uDC85\uD83C\uDFFF":"1f485-1f3ff","\uD83D\uDC85\uD83C\uDFFE":"1f485-1f3fe","\uD83D\uDC85\uD83C\uDFFD":"1f485-1f3fd","\uD83D\uDC85\uD83C\uDFFC":"1f485-1f3fc","\uD83D\uDC85\uD83C\uDFFB":"1f485-1f3fb","\uD83D\uDC83\uD83C\uDFFF":"1f483-1f3ff","\uD83D\uDC83\uD83C\uDFFE":"1f483-1f3fe","\uD83D\uDC83\uD83C\uDFFD":"1f483-1f3fd","\uD83D\uDC83\uD83C\uDFFC":"1f483-1f3fc","\uD83D\uDC83\uD83C\uDFFB":"1f483-1f3fb","\uD83D\uDC82\uD83C\uDFFF":"1f482-1f3ff","\uD83D\uDC82\uD83C\uDFFE":"1f482-1f3fe","\uD83D\uDC82\uD83C\uDFFD":"1f482-1f3fd","\uD83D\uDC82\uD83C\uDFFC":"1f482-1f3fc","\uD83D\uDC82\uD83C\uDFFB":"1f482-1f3fb","\uD83D\uDC81\uD83C\uDFFF":"1f481-1f3ff","\uD83D\uDC81\uD83C\uDFFE":"1f481-1f3fe","\uD83D\uDC81\uD83C\uDFFD":"1f481-1f3fd","\uD83D\uDC81\uD83C\uDFFC":"1f481-1f3fc","\uD83D\uDC81\uD83C\uDFFB":"1f481-1f3fb","\uD83D\uDC7C\uD83C\uDFFF":"1f47c-1f3ff","\uD83D\uDC7C\uD83C\uDFFE":"1f47c-1f3fe","\uD83D\uDC7C\uD83C\uDFFD":"1f47c-1f3fd","\uD83D\uDC7C\uD83C\uDFFC":"1f47c-1f3fc","\uD83D\uDC7C\uD83C\uDFFB":"1f47c-1f3fb","\uD83D\uDC78\uD83C\uDFFF":"1f478-1f3ff","\uD83D\uDC78\uD83C\uDFFE":"1f478-1f3fe","\uD83D\uDC78\uD83C\uDFFD":"1f478-1f3fd","\uD83D\uDC78\uD83C\uDFFC":"1f478-1f3fc","\uD83D\uDC78\uD83C\uDFFB":"1f478-1f3fb","\uD83D\uDC77\uD83C\uDFFF":"1f477-1f3ff","\uD83D\uDC77\uD83C\uDFFE":"1f477-1f3fe","\uD83D\uDC77\uD83C\uDFFD":"1f477-1f3fd","\uD83D\uDC77\uD83C\uDFFC":"1f477-1f3fc","\uD83D\uDC77\uD83C\uDFFB":"1f477-1f3fb","\uD83D\uDC76\uD83C\uDFFF":"1f476-1f3ff","\uD83D\uDC76\uD83C\uDFFE":"1f476-1f3fe","\uD83D\uDC76\uD83C\uDFFD":"1f476-1f3fd","\uD83D\uDC76\uD83C\uDFFC":"1f476-1f3fc","\uD83D\uDC76\uD83C\uDFFB":"1f476-1f3fb","\uD83D\uDC75\uD83C\uDFFF":"1f475-1f3ff","\uD83D\uDC75\uD83C\uDFFE":"1f475-1f3fe","\uD83D\uDC75\uD83C\uDFFD":"1f475-1f3fd","\uD83D\uDC75\uD83C\uDFFC":"1f475-1f3fc","\uD83D\uDC75\uD83C\uDFFB":"1f475-1f3fb","\uD83D\uDC74\uD83C\uDFFF":"1f474-1f3ff","\uD83D\uDC74\uD83C\uDFFE":"1f474-1f3fe","\uD83D\uDC74\uD83C\uDFFD":"1f474-1f3fd","\uD83D\uDC74\uD83C\uDFFC":"1f474-1f3fc","\uD83D\uDC74\uD83C\uDFFB":"1f474-1f3fb","\uD83D\uDC73\uD83C\uDFFF":"1f473-1f3ff","\uD83D\uDC73\uD83C\uDFFE":"1f473-1f3fe","\uD83D\uDC73\uD83C\uDFFD":"1f473-1f3fd","\uD83D\uDC73\uD83C\uDFFC":"1f473-1f3fc","\uD83D\uDC73\uD83C\uDFFB":"1f473-1f3fb","\uD83D\uDC72\uD83C\uDFFF":"1f472-1f3ff","\uD83D\uDC72\uD83C\uDFFE":"1f472-1f3fe","\uD83D\uDC72\uD83C\uDFFD":"1f472-1f3fd","\uD83D\uDC72\uD83C\uDFFC":"1f472-1f3fc","\uD83D\uDC72\uD83C\uDFFB":"1f472-1f3fb","\uD83D\uDC71\uD83C\uDFFF":"1f471-1f3ff","\uD83D\uDC71\uD83C\uDFFE":"1f471-1f3fe","\uD83D\uDC71\uD83C\uDFFD":"1f471-1f3fd","\uD83D\uDC71\uD83C\uDFFC":"1f471-1f3fc","\uD83D\uDC71\uD83C\uDFFB":"1f471-1f3fb","\uD83D\uDC70\uD83C\uDFFF":"1f470-1f3ff","\uD83D\uDC70\uD83C\uDFFE":"1f470-1f3fe","\uD83D\uDC70\uD83C\uDFFD":"1f470-1f3fd","\uD83D\uDC70\uD83C\uDFFC":"1f470-1f3fc","\uD83D\uDC70\uD83C\uDFFB":"1f470-1f3fb","\uD83D\uDC6E\uD83C\uDFFF":"1f46e-1f3ff","\uD83D\uDC6E\uD83C\uDFFE":"1f46e-1f3fe","\uD83D\uDC6E\uD83C\uDFFD":"1f46e-1f3fd","\uD83D\uDC6E\uD83C\uDFFC":"1f46e-1f3fc","\uD83D\uDC6E\uD83C\uDFFB":"1f46e-1f3fb","\uD83D\uDC69\uD83C\uDFFF":"1f469-1f3ff","\uD83D\uDC69\uD83C\uDFFE":"1f469-1f3fe","\uD83D\uDC69\uD83C\uDFFD":"1f469-1f3fd","\uD83D\uDC69\uD83C\uDFFC":"1f469-1f3fc","\uD83D\uDC69\uD83C\uDFFB":"1f469-1f3fb","\uD83D\uDC68\uD83C\uDFFF":"1f468-1f3ff","\uD83D\uDC68\uD83C\uDFFE":"1f468-1f3fe","\uD83D\uDC68\uD83C\uDFFD":"1f468-1f3fd","\uD83D\uDC68\uD83C\uDFFC":"1f468-1f3fc","\uD83D\uDC68\uD83C\uDFFB":"1f468-1f3fb","\uD83D\uDC67\uD83C\uDFFF":"1f467-1f3ff","\uD83D\uDC67\uD83C\uDFFE":"1f467-1f3fe","\uD83D\uDC67\uD83C\uDFFD":"1f467-1f3fd","\uD83D\uDC67\uD83C\uDFFC":"1f467-1f3fc","\uD83D\uDC67\uD83C\uDFFB":"1f467-1f3fb","\uD83D\uDC66\uD83C\uDFFF":"1f466-1f3ff","\uD83D\uDC66\uD83C\uDFFE":"1f466-1f3fe","\uD83D\uDC66\uD83C\uDFFD":"1f466-1f3fd","\uD83D\uDC66\uD83C\uDFFC":"1f466-1f3fc","\uD83D\uDC66\uD83C\uDFFB":"1f466-1f3fb","\uD83D\uDC50\uD83C\uDFFF":"1f450-1f3ff","\uD83D\uDC50\uD83C\uDFFE":"1f450-1f3fe","\uD83D\uDC50\uD83C\uDFFD":"1f450-1f3fd","\uD83D\uDC50\uD83C\uDFFC":"1f450-1f3fc","\uD83D\uDC50\uD83C\uDFFB":"1f450-1f3fb","\uD83D\uDC4F\uD83C\uDFFF":"1f44f-1f3ff","\uD83D\uDC4F\uD83C\uDFFE":"1f44f-1f3fe","\uD83D\uDC4F\uD83C\uDFFD":"1f44f-1f3fd","\uD83D\uDC4F\uD83C\uDFFC":"1f44f-1f3fc","\uD83D\uDC4F\uD83C\uDFFB":"1f44f-1f3fb","\uD83D\uDC4E\uD83C\uDFFF":"1f44e-1f3ff","\uD83D\uDC4E\uD83C\uDFFE":"1f44e-1f3fe","\uD83D\uDC4E\uD83C\uDFFD":"1f44e-1f3fd","\uD83D\uDC4E\uD83C\uDFFC":"1f44e-1f3fc","\uD83D\uDC4E\uD83C\uDFFB":"1f44e-1f3fb","\uD83D\uDC4D\uD83C\uDFFF":"1f44d-1f3ff","\uD83D\uDC4D\uD83C\uDFFE":"1f44d-1f3fe","\uD83D\uDC4D\uD83C\uDFFD":"1f44d-1f3fd","\uD83D\uDC4D\uD83C\uDFFC":"1f44d-1f3fc","\uD83D\uDC4D\uD83C\uDFFB":"1f44d-1f3fb","\uD83D\uDC4C\uD83C\uDFFF":"1f44c-1f3ff","\uD83D\uDC4C\uD83C\uDFFE":"1f44c-1f3fe","\uD83D\uDC4C\uD83C\uDFFD":"1f44c-1f3fd","\uD83D\uDC4C\uD83C\uDFFC":"1f44c-1f3fc","\uD83D\uDC4C\uD83C\uDFFB":"1f44c-1f3fb","\uD83D\uDC4B\uD83C\uDFFF":"1f44b-1f3ff","\uD83D\uDC4B\uD83C\uDFFE":"1f44b-1f3fe","\uD83D\uDC4B\uD83C\uDFFD":"1f44b-1f3fd","\uD83D\uDC4B\uD83C\uDFFC":"1f44b-1f3fc","\uD83D\uDC4B\uD83C\uDFFB":"1f44b-1f3fb","\uD83D\uDC4A\uD83C\uDFFF":"1f44a-1f3ff","\uD83D\uDC4A\uD83C\uDFFE":"1f44a-1f3fe","\uD83D\uDC4A\uD83C\uDFFD":"1f44a-1f3fd","\uD83D\uDC4A\uD83C\uDFFC":"1f44a-1f3fc","\uD83D\uDC4A\uD83C\uDFFB":"1f44a-1f3fb","\uD83D\uDC49\uD83C\uDFFF":"1f449-1f3ff","\uD83D\uDC49\uD83C\uDFFE":"1f449-1f3fe","\uD83D\uDC49\uD83C\uDFFD":"1f449-1f3fd","\uD83D\uDC49\uD83C\uDFFC":"1f449-1f3fc","\uD83D\uDC49\uD83C\uDFFB":"1f449-1f3fb","\uD83D\uDC48\uD83C\uDFFF":"1f448-1f3ff","\uD83D\uDC48\uD83C\uDFFE":"1f448-1f3fe","\uD83D\uDC48\uD83C\uDFFD":"1f448-1f3fd","\uD83D\uDC48\uD83C\uDFFC":"1f448-1f3fc","\uD83D\uDC48\uD83C\uDFFB":"1f448-1f3fb","\uD83D\uDC47\uD83C\uDFFF":"1f447-1f3ff","\uD83D\uDC47\uD83C\uDFFE":"1f447-1f3fe","\uD83D\uDC47\uD83C\uDFFD":"1f447-1f3fd","\uD83D\uDC47\uD83C\uDFFC":"1f447-1f3fc","\uD83D\uDC47\uD83C\uDFFB":"1f447-1f3fb","\uD83D\uDC46\uD83C\uDFFF":"1f446-1f3ff","\uD83D\uDC46\uD83C\uDFFE":"1f446-1f3fe","\uD83D\uDC46\uD83C\uDFFD":"1f446-1f3fd","\uD83D\uDC46\uD83C\uDFFC":"1f446-1f3fc","\uD83D\uDC46\uD83C\uDFFB":"1f446-1f3fb","\uD83D\uDC43\uD83C\uDFFF":"1f443-1f3ff","\uD83D\uDC43\uD83C\uDFFE":"1f443-1f3fe","\uD83D\uDC43\uD83C\uDFFD":"1f443-1f3fd","\uD83D\uDC43\uD83C\uDFFC":"1f443-1f3fc","\uD83D\uDC43\uD83C\uDFFB":"1f443-1f3fb","\uD83D\uDC42\uD83C\uDFFF":"1f442-1f3ff","\uD83D\uDC42\uD83C\uDFFE":"1f442-1f3fe","\uD83D\uDC42\uD83C\uDFFD":"1f442-1f3fd","\uD83D\uDC42\uD83C\uDFFC":"1f442-1f3fc","\uD83D\uDC42\uD83C\uDFFB":"1f442-1f3fb","\uD83C\uDFCB\uD83C\uDFFF":"1f3cb-1f3ff","\uD83C\uDFCB\uD83C\uDFFE":"1f3cb-1f3fe","\uD83C\uDFCB\uD83C\uDFFD":"1f3cb-1f3fd","\uD83C\uDFCB\uD83C\uDFFC":"1f3cb-1f3fc","\uD83C\uDFCB\uD83C\uDFFB":"1f3cb-1f3fb","\uD83C\uDFCA\uD83C\uDFFF":"1f3ca-1f3ff","\uD83C\uDFCA\uD83C\uDFFE":"1f3ca-1f3fe","\uD83C\uDFCA\uD83C\uDFFD":"1f3ca-1f3fd","\uD83C\uDFCA\uD83C\uDFFC":"1f3ca-1f3fc","\uD83C\uDFCA\uD83C\uDFFB":"1f3ca-1f3fb","\uD83C\uDFC7\uD83C\uDFFF":"1f3c7-1f3ff","\uD83C\uDFC7\uD83C\uDFFE":"1f3c7-1f3fe","\uD83C\uDFC7\uD83C\uDFFD":"1f3c7-1f3fd","\uD83C\uDFC7\uD83C\uDFFC":"1f3c7-1f3fc","\uD83C\uDFC7\uD83C\uDFFB":"1f3c7-1f3fb","\uD83C\uDFC4\uD83C\uDFFF":"1f3c4-1f3ff","\uD83C\uDFC4\uD83C\uDFFE":"1f3c4-1f3fe","\uD83C\uDFC4\uD83C\uDFFD":"1f3c4-1f3fd","\uD83C\uDFC4\uD83C\uDFFC":"1f3c4-1f3fc","\uD83C\uDFC4\uD83C\uDFFB":"1f3c4-1f3fb","\uD83C\uDFC3\uD83C\uDFFF":"1f3c3-1f3ff","\uD83C\uDFC3\uD83C\uDFFE":"1f3c3-1f3fe","\uD83C\uDFC3\uD83C\uDFFD":"1f3c3-1f3fd","\uD83C\uDFC3\uD83C\uDFFC":"1f3c3-1f3fc","\uD83C\uDFC3\uD83C\uDFFB":"1f3c3-1f3fb","\uD83C\uDF85\uD83C\uDFFF":"1f385-1f3ff","\uD83C\uDF85\uD83C\uDFFE":"1f385-1f3fe","\uD83C\uDF85\uD83C\uDFFD":"1f385-1f3fd","\uD83C\uDF85\uD83C\uDFFC":"1f385-1f3fc","\uD83C\uDF85\uD83C\uDFFB":"1f385-1f3fb","\uD83C\uDDFF\uD83C\uDDFC":"1f1ff-1f1fc","\uD83C\uDDFF\uD83C\uDDF2":"1f1ff-1f1f2","\uD83C\uDDFF\uD83C\uDDE6":"1f1ff-1f1e6","\uD83C\uDDFE\uD83C\uDDF9":"1f1fe-1f1f9","\uD83C\uDDFE\uD83C\uDDEA":"1f1fe-1f1ea","\uD83C\uDDFD\uD83C\uDDF0":"1f1fd-1f1f0","\uD83C\uDDFC\uD83C\uDDF8":"1f1fc-1f1f8","\uD83C\uDDFC\uD83C\uDDEB":"1f1fc-1f1eb","\uD83C\uDDFB\uD83C\uDDFA":"1f1fb-1f1fa","\uD83C\uDDFB\uD83C\uDDF3":"1f1fb-1f1f3","\uD83C\uDDFB\uD83C\uDDEE":"1f1fb-1f1ee","\uD83C\uDDFB\uD83C\uDDEC":"1f1fb-1f1ec","\uD83C\uDDFB\uD83C\uDDEA":"1f1fb-1f1ea","\uD83C\uDDFB\uD83C\uDDE8":"1f1fb-1f1e8","\uD83C\uDDFB\uD83C\uDDE6":"1f1fb-1f1e6","\uD83C\uDDFA\uD83C\uDDFF":"1f1fa-1f1ff","\uD83C\uDDFA\uD83C\uDDFE":"1f1fa-1f1fe","\uD83C\uDDFA\uD83C\uDDF8":"1f1fa-1f1f8","\uD83C\uDDFA\uD83C\uDDF2":"1f1fa-1f1f2","\uD83C\uDDFA\uD83C\uDDEC":"1f1fa-1f1ec","\uD83C\uDDFA\uD83C\uDDE6":"1f1fa-1f1e6","\uD83C\uDDF9\uD83C\uDDFF":"1f1f9-1f1ff","\uD83C\uDDF9\uD83C\uDDFC":"1f1f9-1f1fc","\uD83C\uDDF9\uD83C\uDDFB":"1f1f9-1f1fb","\uD83C\uDDF9\uD83C\uDDF9":"1f1f9-1f1f9","\uD83C\uDDF9\uD83C\uDDF7":"1f1f9-1f1f7","\uD83C\uDDF9\uD83C\uDDF4":"1f1f9-1f1f4","\uD83C\uDDF9\uD83C\uDDF3":"1f1f9-1f1f3","\uD83C\uDDF9\uD83C\uDDF2":"1f1f9-1f1f2","\uD83C\uDDF9\uD83C\uDDF1":"1f1f9-1f1f1","\uD83C\uDDF9\uD83C\uDDF0":"1f1f9-1f1f0","\uD83C\uDDF9\uD83C\uDDEF":"1f1f9-1f1ef","\uD83C\uDDF9\uD83C\uDDED":"1f1f9-1f1ed","\uD83C\uDDF9\uD83C\uDDEC":"1f1f9-1f1ec","\uD83C\uDDF9\uD83C\uDDEB":"1f1f9-1f1eb","\uD83C\uDDF9\uD83C\uDDE9":"1f1f9-1f1e9","\uD83C\uDDF9\uD83C\uDDE8":"1f1f9-1f1e8","\uD83C\uDDF9\uD83C\uDDE6":"1f1f9-1f1e6","\uD83C\uDDF8\uD83C\uDDFF":"1f1f8-1f1ff","\uD83C\uDDF8\uD83C\uDDFE":"1f1f8-1f1fe","\uD83C\uDDF8\uD83C\uDDFD":"1f1f8-1f1fd","\uD83C\uDDF8\uD83C\uDDFB":"1f1f8-1f1fb","\uD83C\uDDF8\uD83C\uDDF9":"1f1f8-1f1f9","\uD83C\uDDF8\uD83C\uDDF8":"1f1f8-1f1f8","\uD83C\uDDF8\uD83C\uDDF7":"1f1f8-1f1f7","\uD83C\uDDF8\uD83C\uDDF4":"1f1f8-1f1f4","\uD83C\uDDF8\uD83C\uDDF3":"1f1f8-1f1f3","\uD83C\uDDF8\uD83C\uDDF2":"1f1f8-1f1f2","\uD83C\uDDF8\uD83C\uDDF1":"1f1f8-1f1f1","\uD83C\uDDF8\uD83C\uDDF0":"1f1f8-1f1f0","\uD83C\uDDF8\uD83C\uDDEF":"1f1f8-1f1ef","\uD83C\uDDF8\uD83C\uDDEE":"1f1f8-1f1ee","\uD83C\uDDF8\uD83C\uDDED":"1f1f8-1f1ed","\uD83C\uDDF8\uD83C\uDDEC":"1f1f8-1f1ec","\uD83C\uDDF8\uD83C\uDDEA":"1f1f8-1f1ea","\uD83C\uDDF8\uD83C\uDDE9":"1f1f8-1f1e9","\uD83C\uDDF8\uD83C\uDDE8":"1f1f8-1f1e8","\uD83C\uDDF8\uD83C\uDDE7":"1f1f8-1f1e7","\uD83C\uDDF8\uD83C\uDDE6":"1f1f8-1f1e6","\uD83C\uDDF7\uD83C\uDDFC":"1f1f7-1f1fc","\uD83C\uDDF7\uD83C\uDDFA":"1f1f7-1f1fa","\uD83C\uDDF7\uD83C\uDDF8":"1f1f7-1f1f8","\uD83C\uDDF7\uD83C\uDDF4":"1f1f7-1f1f4","\uD83C\uDDF7\uD83C\uDDEA":"1f1f7-1f1ea","\uD83C\uDDF6\uD83C\uDDE6":"1f1f6-1f1e6","\uD83C\uDDF5\uD83C\uDDFE":"1f1f5-1f1fe","\uD83C\uDDF5\uD83C\uDDFC":"1f1f5-1f1fc","\uD83C\uDDF5\uD83C\uDDF9":"1f1f5-1f1f9","\uD83C\uDDF5\uD83C\uDDF8":"1f1f5-1f1f8","\uD83C\uDDF5\uD83C\uDDF7":"1f1f5-1f1f7","\uD83C\uDDF5\uD83C\uDDF3":"1f1f5-1f1f3","\uD83C\uDDF5\uD83C\uDDF2":"1f1f5-1f1f2","\uD83C\uDDF5\uD83C\uDDF1":"1f1f5-1f1f1","\uD83C\uDDF5\uD83C\uDDF0":"1f1f5-1f1f0","\uD83C\uDDF5\uD83C\uDDED":"1f1f5-1f1ed","\uD83C\uDDF5\uD83C\uDDEC":"1f1f5-1f1ec","\uD83C\uDDF5\uD83C\uDDEB":"1f1f5-1f1eb","\uD83C\uDDF5\uD83C\uDDEA":"1f1f5-1f1ea","\uD83C\uDDF5\uD83C\uDDE6":"1f1f5-1f1e6","\uD83C\uDDF4\uD83C\uDDF2":"1f1f4-1f1f2","\uD83C\uDDF3\uD83C\uDDFF":"1f1f3-1f1ff","\uD83C\uDDF3\uD83C\uDDFA":"1f1f3-1f1fa","\uD83C\uDDF3\uD83C\uDDF7":"1f1f3-1f1f7","\uD83C\uDDF3\uD83C\uDDF5":"1f1f3-1f1f5","\uD83C\uDDF3\uD83C\uDDF4":"1f1f3-1f1f4","\uD83C\uDDF3\uD83C\uDDF1":"1f1f3-1f1f1","\uD83C\uDDF3\uD83C\uDDEE":"1f1f3-1f1ee","\uD83C\uDDF3\uD83C\uDDEC":"1f1f3-1f1ec","\uD83C\uDDF3\uD83C\uDDEB":"1f1f3-1f1eb","\uD83C\uDDF3\uD83C\uDDEA":"1f1f3-1f1ea","\uD83C\uDDF3\uD83C\uDDE8":"1f1f3-1f1e8","\uD83C\uDDF3\uD83C\uDDE6":"1f1f3-1f1e6","\uD83C\uDDF2\uD83C\uDDFF":"1f1f2-1f1ff","\uD83C\uDDF2\uD83C\uDDFE":"1f1f2-1f1fe","\uD83C\uDDF2\uD83C\uDDFD":"1f1f2-1f1fd","\uD83C\uDDF2\uD83C\uDDFC":"1f1f2-1f1fc","\uD83C\uDDF2\uD83C\uDDFB":"1f1f2-1f1fb","\uD83C\uDDF2\uD83C\uDDFA":"1f1f2-1f1fa","\uD83C\uDDF2\uD83C\uDDF9":"1f1f2-1f1f9","\uD83C\uDDF2\uD83C\uDDF8":"1f1f2-1f1f8","\uD83C\uDDF2\uD83C\uDDF7":"1f1f2-1f1f7","\uD83C\uDDF2\uD83C\uDDF6":"1f1f2-1f1f6","\uD83C\uDDF2\uD83C\uDDF5":"1f1f2-1f1f5","\uD83C\uDDF2\uD83C\uDDF4":"1f1f2-1f1f4","\uD83C\uDDF2\uD83C\uDDF3":"1f1f2-1f1f3","\uD83C\uDDF2\uD83C\uDDF2":"1f1f2-1f1f2","\uD83C\uDDF2\uD83C\uDDF1":"1f1f2-1f1f1","\uD83C\uDDF2\uD83C\uDDF0":"1f1f2-1f1f0","\uD83C\uDDF2\uD83C\uDDED":"1f1f2-1f1ed","\uD83C\uDDF2\uD83C\uDDEC":"1f1f2-1f1ec","\uD83C\uDDF2\uD83C\uDDEB":"1f1f2-1f1eb","\uD83C\uDDF2\uD83C\uDDEA":"1f1f2-1f1ea","\uD83C\uDDF2\uD83C\uDDE9":"1f1f2-1f1e9","\uD83C\uDDF2\uD83C\uDDE8":"1f1f2-1f1e8","\uD83C\uDDF2\uD83C\uDDE6":"1f1f2-1f1e6","\uD83C\uDDF1\uD83C\uDDFE":"1f1f1-1f1fe","\uD83C\uDDF1\uD83C\uDDFB":"1f1f1-1f1fb","\uD83C\uDDF1\uD83C\uDDFA":"1f1f1-1f1fa","\uD83C\uDDF1\uD83C\uDDF9":"1f1f1-1f1f9","\uD83C\uDDF1\uD83C\uDDF8":"1f1f1-1f1f8","\uD83C\uDDF1\uD83C\uDDF7":"1f1f1-1f1f7","\uD83C\uDDF1\uD83C\uDDF0":"1f1f1-1f1f0","\uD83C\uDDF1\uD83C\uDDEE":"1f1f1-1f1ee","\uD83C\uDDF1\uD83C\uDDE8":"1f1f1-1f1e8","\uD83C\uDDF1\uD83C\uDDE7":"1f1f1-1f1e7","\uD83C\uDDF1\uD83C\uDDE6":"1f1f1-1f1e6","\uD83C\uDDF0\uD83C\uDDFF":"1f1f0-1f1ff","\uD83C\uDDF0\uD83C\uDDFE":"1f1f0-1f1fe","\uD83C\uDDF0\uD83C\uDDFC":"1f1f0-1f1fc","\uD83C\uDDF0\uD83C\uDDF7":"1f1f0-1f1f7","\uD83C\uDDF0\uD83C\uDDF5":"1f1f0-1f1f5","\uD83C\uDDF0\uD83C\uDDF3":"1f1f0-1f1f3","\uD83C\uDDF0\uD83C\uDDF2":"1f1f0-1f1f2","\uD83C\uDDF0\uD83C\uDDEE":"1f1f0-1f1ee","\uD83C\uDDF0\uD83C\uDDED":"1f1f0-1f1ed","\uD83C\uDDF0\uD83C\uDDEC":"1f1f0-1f1ec","\uD83C\uDDF0\uD83C\uDDEA":"1f1f0-1f1ea","\uD83C\uDDEF\uD83C\uDDF5":"1f1ef-1f1f5","\uD83C\uDDEF\uD83C\uDDF4":"1f1ef-1f1f4","\uD83C\uDDEF\uD83C\uDDF2":"1f1ef-1f1f2","\uD83C\uDDEF\uD83C\uDDEA":"1f1ef-1f1ea","\uD83C\uDDEE\uD83C\uDDF9":"1f1ee-1f1f9","\uD83C\uDDEE\uD83C\uDDF8":"1f1ee-1f1f8","\uD83C\uDDEE\uD83C\uDDF7":"1f1ee-1f1f7","\uD83C\uDDEE\uD83C\uDDF6":"1f1ee-1f1f6","\uD83C\uDDEE\uD83C\uDDF4":"1f1ee-1f1f4","\uD83C\uDDEE\uD83C\uDDF3":"1f1ee-1f1f3","\uD83C\uDDEE\uD83C\uDDF2":"1f1ee-1f1f2","\uD83C\uDDEE\uD83C\uDDF1":"1f1ee-1f1f1","\uD83C\uDDEE\uD83C\uDDEA":"1f1ee-1f1ea","\uD83C\uDDEE\uD83C\uDDE9":"1f1ee-1f1e9","\uD83C\uDDEE\uD83C\uDDE8":"1f1ee-1f1e8","\uD83C\uDDED\uD83C\uDDFA":"1f1ed-1f1fa","\uD83C\uDDED\uD83C\uDDF9":"1f1ed-1f1f9","\uD83C\uDDED\uD83C\uDDF7":"1f1ed-1f1f7","\uD83C\uDDED\uD83C\uDDF3":"1f1ed-1f1f3","\uD83C\uDDED\uD83C\uDDF2":"1f1ed-1f1f2","\uD83C\uDDED\uD83C\uDDF0":"1f1ed-1f1f0","\uD83C\uDDEC\uD83C\uDDFE":"1f1ec-1f1fe","\uD83C\uDDEC\uD83C\uDDFC":"1f1ec-1f1fc","\uD83C\uDDEC\uD83C\uDDFA":"1f1ec-1f1fa","\uD83C\uDDEC\uD83C\uDDF9":"1f1ec-1f1f9","\uD83C\uDDEC\uD83C\uDDF8":"1f1ec-1f1f8","\uD83C\uDDEC\uD83C\uDDF7":"1f1ec-1f1f7","\uD83C\uDDEC\uD83C\uDDF6":"1f1ec-1f1f6","\uD83C\uDDEC\uD83C\uDDF5":"1f1ec-1f1f5","\uD83C\uDDEC\uD83C\uDDF3":"1f1ec-1f1f3","\uD83C\uDDEC\uD83C\uDDF2":"1f1ec-1f1f2","\uD83C\uDDEC\uD83C\uDDF1":"1f1ec-1f1f1","\uD83C\uDDEC\uD83C\uDDEE":"1f1ec-1f1ee","\uD83C\uDDEC\uD83C\uDDED":"1f1ec-1f1ed","\uD83C\uDDEC\uD83C\uDDEC":"1f1ec-1f1ec","\uD83C\uDDEC\uD83C\uDDEB":"1f1ec-1f1eb","\uD83C\uDDEC\uD83C\uDDEA":"1f1ec-1f1ea","\uD83C\uDDEC\uD83C\uDDE9":"1f1ec-1f1e9","\uD83C\uDDEC\uD83C\uDDE7":"1f1ec-1f1e7","\uD83C\uDDEC\uD83C\uDDE6":"1f1ec-1f1e6","\uD83C\uDDEB\uD83C\uDDF7":"1f1eb-1f1f7","\uD83C\uDDEB\uD83C\uDDF4":"1f1eb-1f1f4","\uD83C\uDDEB\uD83C\uDDF2":"1f1eb-1f1f2","\uD83C\uDDEB\uD83C\uDDF0":"1f1eb-1f1f0","\uD83C\uDDEB\uD83C\uDDEF":"1f1eb-1f1ef","\uD83C\uDDEB\uD83C\uDDEE":"1f1eb-1f1ee","\uD83C\uDDEA\uD83C\uDDFA":"1f1ea-1f1fa","\uD83C\uDDEA\uD83C\uDDF9":"1f1ea-1f1f9","\uD83C\uDDEA\uD83C\uDDF8":"1f1ea-1f1f8","\uD83C\uDDEA\uD83C\uDDF7":"1f1ea-1f1f7","\uD83C\uDDEA\uD83C\uDDED":"1f1ea-1f1ed","\uD83C\uDDEA\uD83C\uDDEC":"1f1ea-1f1ec","\uD83C\uDDEA\uD83C\uDDEA":"1f1ea-1f1ea","\uD83C\uDDEA\uD83C\uDDE8":"1f1ea-1f1e8","\uD83C\uDDEA\uD83C\uDDE6":"1f1ea-1f1e6","\uD83C\uDDE9\uD83C\uDDFF":"1f1e9-1f1ff","\uD83C\uDDE9\uD83C\uDDF4":"1f1e9-1f1f4","\uD83C\uDDE9\uD83C\uDDF2":"1f1e9-1f1f2","\uD83C\uDDE9\uD83C\uDDF0":"1f1e9-1f1f0","\uD83C\uDDE9\uD83C\uDDEF":"1f1e9-1f1ef","\uD83C\uDDE9\uD83C\uDDEC":"1f1e9-1f1ec","\uD83C\uDDE9\uD83C\uDDEA":"1f1e9-1f1ea","\uD83C\uDDE8\uD83C\uDDFF":"1f1e8-1f1ff","\uD83C\uDDE8\uD83C\uDDFE":"1f1e8-1f1fe","\uD83C\uDDE8\uD83C\uDDFD":"1f1e8-1f1fd","\uD83C\uDDE8\uD83C\uDDFC":"1f1e8-1f1fc","\uD83C\uDDE8\uD83C\uDDFB":"1f1e8-1f1fb","\uD83C\uDDE8\uD83C\uDDFA":"1f1e8-1f1fa","\uD83C\uDDE8\uD83C\uDDF7":"1f1e8-1f1f7","\uD83C\uDDE8\uD83C\uDDF5":"1f1e8-1f1f5","\uD83C\uDDE8\uD83C\uDDF4":"1f1e8-1f1f4","\uD83C\uDDE8\uD83C\uDDF3":"1f1e8-1f1f3","\uD83C\uDDE8\uD83C\uDDF2":"1f1e8-1f1f2","\uD83C\uDDE8\uD83C\uDDF1":"1f1e8-1f1f1","\uD83C\uDDE8\uD83C\uDDF0":"1f1e8-1f1f0","\uD83C\uDDE8\uD83C\uDDEE":"1f1e8-1f1ee","\uD83C\uDDE8\uD83C\uDDED":"1f1e8-1f1ed","\uD83C\uDDE8\uD83C\uDDEC":"1f1e8-1f1ec","\uD83C\uDDE8\uD83C\uDDEB":"1f1e8-1f1eb","\uD83C\uDDE8\uD83C\uDDE9":"1f1e8-1f1e9","\uD83C\uDDE8\uD83C\uDDE8":"1f1e8-1f1e8","\uD83C\uDDE8\uD83C\uDDE6":"1f1e8-1f1e6","\uD83C\uDDE7\uD83C\uDDFF":"1f1e7-1f1ff","\uD83C\uDDE7\uD83C\uDDFE":"1f1e7-1f1fe","\uD83C\uDDE7\uD83C\uDDFC":"1f1e7-1f1fc","\uD83C\uDDE7\uD83C\uDDFB":"1f1e7-1f1fb","\uD83C\uDDE7\uD83C\uDDF9":"1f1e7-1f1f9","\uD83C\uDDE7\uD83C\uDDF8":"1f1e7-1f1f8","\uD83C\uDDE7\uD83C\uDDF7":"1f1e7-1f1f7","\uD83C\uDDE7\uD83C\uDDF6":"1f1e7-1f1f6","\uD83C\uDDE7\uD83C\uDDF4":"1f1e7-1f1f4","\uD83C\uDDE7\uD83C\uDDF3":"1f1e7-1f1f3","\uD83C\uDDE7\uD83C\uDDF2":"1f1e7-1f1f2","\uD83C\uDDE7\uD83C\uDDF1":"1f1e7-1f1f1","\uD83C\uDDE7\uD83C\uDDEF":"1f1e7-1f1ef","\uD83C\uDDE7\uD83C\uDDEE":"1f1e7-1f1ee","\uD83C\uDDE7\uD83C\uDDED":"1f1e7-1f1ed","\uD83C\uDDE7\uD83C\uDDEC":"1f1e7-1f1ec","\uD83C\uDDE7\uD83C\uDDEB":"1f1e7-1f1eb","\uD83C\uDDE7\uD83C\uDDEA":"1f1e7-1f1ea","\uD83C\uDDE7\uD83C\uDDE9":"1f1e7-1f1e9","\uD83C\uDDE7\uD83C\uDDE7":"1f1e7-1f1e7","\uD83C\uDDE7\uD83C\uDDE6":"1f1e7-1f1e6","\uD83C\uDDE6\uD83C\uDDFF":"1f1e6-1f1ff","\uD83C\uDDE6\uD83C\uDDFD":"1f1e6-1f1fd","\uD83C\uDDE6\uD83C\uDDFC":"1f1e6-1f1fc","\uD83C\uDDE6\uD83C\uDDFA":"1f1e6-1f1fa","\uD83C\uDDE6\uD83C\uDDF9":"1f1e6-1f1f9","\uD83C\uDDE6\uD83C\uDDF8":"1f1e6-1f1f8","\uD83C\uDDE6\uD83C\uDDF7":"1f1e6-1f1f7","\uD83C\uDDE6\uD83C\uDDF6":"1f1e6-1f1f6","\uD83C\uDDE6\uD83C\uDDF4":"1f1e6-1f1f4","\uD83C\uDDE6\uD83C\uDDF2":"1f1e6-1f1f2","\uD83C\uDDE6\uD83C\uDDF1":"1f1e6-1f1f1","\uD83C\uDDE6\uD83C\uDDEE":"1f1e6-1f1ee","\uD83C\uDDE6\uD83C\uDDEC":"1f1e6-1f1ec","\uD83C\uDDE6\uD83C\uDDEB":"1f1e6-1f1eb","\uD83C\uDDE6\uD83C\uDDEA":"1f1e6-1f1ea","\uD83C\uDDE6\uD83C\uDDE9":"1f1e6-1f1e9","\uD83C\uDDE6\uD83C\uDDE8":"1f1e6-1f1e8","\uD83C\uDC04\uFE0F":"1f004-fe0f","\uD83C\uDC04":"1f004","\uD83C\uDD7F\uFE0F":"1f17f-fe0f","\uD83C\uDD7F":"1f17f","\uD83C\uDE02\uFE0F":"1f202-fe0f","\uD83C\uDE02":"1f202","\uD83C\uDE1A\uFE0F":"1f21a-fe0f","\uD83C\uDE1A":"1f21a","\uD83C\uDE2F\uFE0F":"1f22f-fe0f","\uD83C\uDE2F":"1f22f","\uD83C\uDE37\uFE0F":"1f237-fe0f","\uD83C\uDE37":"1f237","\uD83C\uDF9E\uFE0F":"1f39e-fe0f","\uD83C\uDF9E":"1f39e","\uD83C\uDF9F\uFE0F":"1f39f-fe0f","\uD83C\uDF9F":"1f39f","\uD83C\uDFCB\uFE0F":"1f3cb-fe0f","\uD83C\uDFCB":"1f3cb","\uD83C\uDFCC\uFE0F":"1f3cc-fe0f","\uD83C\uDFCC":"1f3cc","\uD83C\uDFCD\uFE0F":"1f3cd-fe0f","\uD83C\uDFCD":"1f3cd","\uD83C\uDFCE\uFE0F":"1f3ce-fe0f","\uD83C\uDFCE":"1f3ce","\uD83C\uDF96\uFE0F":"1f396-fe0f","\uD83C\uDF96":"1f396","\uD83C\uDF97\uFE0F":"1f397-fe0f","\uD83C\uDF97":"1f397","\uD83C\uDF36\uFE0F":"1f336-fe0f","\uD83C\uDF36":"1f336","\uD83C\uDF27\uFE0F":"1f327-fe0f","\uD83C\uDF27":"1f327","\uD83C\uDF28\uFE0F":"1f328-fe0f","\uD83C\uDF28":"1f328","\uD83C\uDF29\uFE0F":"1f329-fe0f","\uD83C\uDF29":"1f329","\uD83C\uDF2A\uFE0F":"1f32a-fe0f","\uD83C\uDF2A":"1f32a","\uD83C\uDF2B\uFE0F":"1f32b-fe0f","\uD83C\uDF2B":"1f32b","\uD83C\uDF2C\uFE0F":"1f32c-fe0f","\uD83C\uDF2C":"1f32c","\uD83D\uDC3F\uFE0F":"1f43f-fe0f","\uD83D\uDC3F":"1f43f","\uD83D\uDD77\uFE0F":"1f577-fe0f","\uD83D\uDD77":"1f577","\uD83D\uDD78\uFE0F":"1f578-fe0f","\uD83D\uDD78":"1f578","\uD83C\uDF21\uFE0F":"1f321-fe0f","\uD83C\uDF21":"1f321","\uD83C\uDF99\uFE0F":"1f399-fe0f","\uD83C\uDF99":"1f399","\uD83C\uDF9A\uFE0F":"1f39a-fe0f","\uD83C\uDF9A":"1f39a","\uD83C\uDF9B\uFE0F":"1f39b-fe0f","\uD83C\uDF9B":"1f39b","\uD83C\uDFF3\uFE0F":"1f3f3-fe0f","\uD83C\uDFF3":"1f3f3","\uD83C\uDFF5\uFE0F":"1f3f5-fe0f","\uD83C\uDFF5":"1f3f5","\uD83C\uDFF7\uFE0F":"1f3f7-fe0f","\uD83C\uDFF7":"1f3f7","\uD83D\uDCFD\uFE0F":"1f4fd-fe0f","\uD83D\uDCFD":"1f4fd","\uD83D\uDD49\uFE0F":"1f549-fe0f","\uD83D\uDD49":"1f549","\uD83D\uDD4A\uFE0F":"1f54a-fe0f","\uD83D\uDD4A":"1f54a","\uD83D\uDD6F\uFE0F":"1f56f-fe0f","\uD83D\uDD6F":"1f56f","\uD83D\uDD70\uFE0F":"1f570-fe0f","\uD83D\uDD70":"1f570","\uD83D\uDD73\uFE0F":"1f573-fe0f","\uD83D\uDD73":"1f573","\uD83D\uDD76\uFE0F":"1f576-fe0f","\uD83D\uDD76":"1f576","\uD83D\uDD79\uFE0F":"1f579-fe0f","\uD83D\uDD79":"1f579","\uD83D\uDD87\uFE0F":"1f587-fe0f","\uD83D\uDD87":"1f587","\uD83D\uDD8A\uFE0F":"1f58a-fe0f","\uD83D\uDD8A":"1f58a","\uD83D\uDD8B\uFE0F":"1f58b-fe0f","\uD83D\uDD8B":"1f58b","\uD83D\uDD8C\uFE0F":"1f58c-fe0f","\uD83D\uDD8C":"1f58c","\uD83D\uDD8D\uFE0F":"1f58d-fe0f","\uD83D\uDD8D":"1f58d","\uD83D\uDDA5\uFE0F":"1f5a5-fe0f","\uD83D\uDDA5":"1f5a5","\uD83D\uDDA8\uFE0F":"1f5a8-fe0f","\uD83D\uDDA8":"1f5a8","\uD83D\uDDB2\uFE0F":"1f5b2-fe0f","\uD83D\uDDB2":"1f5b2","\uD83D\uDDBC\uFE0F":"1f5bc-fe0f","\uD83D\uDDBC":"1f5bc","\uD83D\uDDC2\uFE0F":"1f5c2-fe0f","\uD83D\uDDC2":"1f5c2","\uD83D\uDDC3\uFE0F":"1f5c3-fe0f","\uD83D\uDDC3":"1f5c3","\uD83D\uDDC4\uFE0F":"1f5c4-fe0f","\uD83D\uDDC4":"1f5c4","\uD83D\uDDD1\uFE0F":"1f5d1-fe0f","\uD83D\uDDD1":"1f5d1","\uD83D\uDDD2\uFE0F":"1f5d2-fe0f","\uD83D\uDDD2":"1f5d2","\uD83D\uDDD3\uFE0F":"1f5d3-fe0f","\uD83D\uDDD3":"1f5d3","\uD83D\uDDDC\uFE0F":"1f5dc-fe0f","\uD83D\uDDDC":"1f5dc","\uD83D\uDDDD\uFE0F":"1f5dd-fe0f","\uD83D\uDDDD":"1f5dd","\uD83D\uDDDE\uFE0F":"1f5de-fe0f","\uD83D\uDDDE":"1f5de","\uD83D\uDDE1\uFE0F":"1f5e1-fe0f","\uD83D\uDDE1":"1f5e1","\uD83D\uDDE3\uFE0F":"1f5e3-fe0f","\uD83D\uDDE3":"1f5e3","\uD83D\uDDE8\uFE0F":"1f5e8-fe0f","\uD83D\uDDE8":"1f5e8","\uD83D\uDDEF\uFE0F":"1f5ef-fe0f","\uD83D\uDDEF":"1f5ef","\uD83D\uDDF3\uFE0F":"1f5f3-fe0f","\uD83D\uDDF3":"1f5f3","\uD83D\uDDFA\uFE0F":"1f5fa-fe0f","\uD83D\uDDFA":"1f5fa","\uD83D\uDEE0\uFE0F":"1f6e0-fe0f","\uD83D\uDEE0":"1f6e0","\uD83D\uDEE1\uFE0F":"1f6e1-fe0f","\uD83D\uDEE1":"1f6e1","\uD83D\uDEE2\uFE0F":"1f6e2-fe0f","\uD83D\uDEE2":"1f6e2","\uD83D\uDEF0\uFE0F":"1f6f0-fe0f","\uD83D\uDEF0":"1f6f0","\uD83C\uDF7D\uFE0F":"1f37d-fe0f","\uD83C\uDF7D":"1f37d","\uD83D\uDC41\uFE0F":"1f441-fe0f","\uD83D\uDC41":"1f441","\uD83D\uDD74\uFE0F":"1f574-fe0f","\uD83D\uDD74":"1f574","\uD83D\uDD75\uFE0F":"1f575-fe0f","\uD83D\uDD75":"1f575","\uD83D\uDD90\uFE0F":"1f590-fe0f","\uD83D\uDD90":"1f590","\uD83C\uDFD4\uFE0F":"1f3d4-fe0f","\uD83C\uDFD4":"1f3d4","\uD83C\uDFD5\uFE0F":"1f3d5-fe0f","\uD83C\uDFD5":"1f3d5","\uD83C\uDFD6\uFE0F":"1f3d6-fe0f","\uD83C\uDFD6":"1f3d6","\uD83C\uDFD7\uFE0F":"1f3d7-fe0f","\uD83C\uDFD7":"1f3d7","\uD83C\uDFD8\uFE0F":"1f3d8-fe0f","\uD83C\uDFD8":"1f3d8","\uD83C\uDFD9\uFE0F":"1f3d9-fe0f","\uD83C\uDFD9":"1f3d9","\uD83C\uDFDA\uFE0F":"1f3da-fe0f","\uD83C\uDFDA":"1f3da","\uD83C\uDFDB\uFE0F":"1f3db-fe0f","\uD83C\uDFDB":"1f3db","\uD83C\uDFDC\uFE0F":"1f3dc-fe0f","\uD83C\uDFDC":"1f3dc","\uD83C\uDFDD\uFE0F":"1f3dd-fe0f","\uD83C\uDFDD":"1f3dd","\uD83C\uDFDE\uFE0F":"1f3de-fe0f","\uD83C\uDFDE":"1f3de","\uD83C\uDFDF\uFE0F":"1f3df-fe0f","\uD83C\uDFDF":"1f3df","\uD83D\uDECB\uFE0F":"1f6cb-fe0f","\uD83D\uDECB":"1f6cb","\uD83D\uDECD\uFE0F":"1f6cd-fe0f","\uD83D\uDECD":"1f6cd","\uD83D\uDECE\uFE0F":"1f6ce-fe0f","\uD83D\uDECE":"1f6ce","\uD83D\uDECF\uFE0F":"1f6cf-fe0f","\uD83D\uDECF":"1f6cf","\uD83D\uDEE3\uFE0F":"1f6e3-fe0f","\uD83D\uDEE3":"1f6e3","\uD83D\uDEE4\uFE0F":"1f6e4-fe0f","\uD83D\uDEE4":"1f6e4","\uD83D\uDEE5\uFE0F":"1f6e5-fe0f","\uD83D\uDEE5":"1f6e5","\uD83D\uDEE9\uFE0F":"1f6e9-fe0f","\uD83D\uDEE9":"1f6e9","\uD83D\uDEF3\uFE0F":"1f6f3-fe0f","\uD83D\uDEF3":"1f6f3","\uD83C\uDF24\uFE0F":"1f324-fe0f","\uD83C\uDF24":"1f324","\uD83C\uDF25\uFE0F":"1f325-fe0f","\uD83C\uDF25":"1f325","\uD83C\uDF26\uFE0F":"1f326-fe0f","\uD83C\uDF26":"1f326","\uD83D\uDDB1\uFE0F":"1f5b1-fe0f","\uD83D\uDDB1":"1f5b1","\u261D\uD83C\uDFFB":"261d-1f3fb","\u261D\uD83C\uDFFC":"261d-1f3fc","\u261D\uD83C\uDFFD":"261d-1f3fd","\u261D\uD83C\uDFFE":"261d-1f3fe","\u261D\uD83C\uDFFF":"261d-1f3ff","\u270C\uD83C\uDFFB":"270c-1f3fb","\u270C\uD83C\uDFFC":"270c-1f3fc","\u270C\uD83C\uDFFD":"270c-1f3fd","\u270C\uD83C\uDFFE":"270c-1f3fe","\u270C\uD83C\uDFFF":"270c-1f3ff","\u270A\uD83C\uDFFB":"270a-1f3fb","\u270A\uD83C\uDFFC":"270a-1f3fc","\u270A\uD83C\uDFFD":"270a-1f3fd","\u270A\uD83C\uDFFE":"270a-1f3fe","\u270A\uD83C\uDFFF":"270a-1f3ff","\u270B\uD83C\uDFFB":"270b-1f3fb","\u270B\uD83C\uDFFC":"270b-1f3fc","\u270B\uD83C\uDFFD":"270b-1f3fd","\u270B\uD83C\uDFFE":"270b-1f3fe","\u270B\uD83C\uDFFF":"270b-1f3ff","\u270D\uD83C\uDFFB":"270d-1f3fb","\u270D\uD83C\uDFFC":"270d-1f3fc","\u270D\uD83C\uDFFD":"270d-1f3fd","\u270D\uD83C\uDFFE":"270d-1f3fe","\u270D\uD83C\uDFFF":"270d-1f3ff","\u26F9\uD83C\uDFFB":"26f9-1f3fb","\u26F9\uD83C\uDFFC":"26f9-1f3fc","\u26F9\uD83C\uDFFD":"26f9-1f3fd","\u26F9\uD83C\uDFFE":"26f9-1f3fe","\u26F9\uD83C\uDFFF":"26f9-1f3ff","\u00A9\uFE0F":"00a9-fe0f","\u00A9":"00a9","\u00AE\uFE0F":"00ae-fe0f","\u00AE":"00ae","\u203C\uFE0F":"203c-fe0f","\u203C":"203c","\u2049\uFE0F":"2049-fe0f","\u2049":"2049","\u2122\uFE0F":"2122-fe0f","\u2122":"2122","\u2139\uFE0F":"2139-fe0f","\u2139":"2139","\u2194\uFE0F":"2194-fe0f","\u2194":"2194","\u2195\uFE0F":"2195-fe0f","\u2195":"2195","\u2196\uFE0F":"2196-fe0f","\u2196":"2196","\u2197\uFE0F":"2197-fe0f","\u2197":"2197","\u2198\uFE0F":"2198-fe0f","\u2198":"2198","\u2199\uFE0F":"2199-fe0f","\u2199":"2199","\u21A9\uFE0F":"21a9-fe0f","\u21A9":"21a9","\u21AA\uFE0F":"21aa-fe0f","\u21AA":"21aa","\u231A\uFE0F":"231a-fe0f","\u231A":"231a","\u231B\uFE0F":"231b-fe0f","\u231B":"231b","\u24C2\uFE0F":"24c2-fe0f","\u24C2":"24c2","\u25AA\uFE0F":"25aa-fe0f","\u25AA":"25aa","\u25AB\uFE0F":"25ab-fe0f","\u25AB":"25ab","\u25B6\uFE0F":"25b6-fe0f","\u25B6":"25b6","\u25C0\uFE0F":"25c0-fe0f","\u25C0":"25c0","\u25FB\uFE0F":"25fb-fe0f","\u25FB":"25fb","\u25FC\uFE0F":"25fc-fe0f","\u25FC":"25fc","\u25FD\uFE0F":"25fd-fe0f","\u25FD":"25fd","\u25FE\uFE0F":"25fe-fe0f","\u25FE":"25fe","\u2600\uFE0F":"2600-fe0f","\u2600":"2600","\u2601\uFE0F":"2601-fe0f","\u2601":"2601","\u260E\uFE0F":"260e-fe0f","\u260E":"260e","\u2611\uFE0F":"2611-fe0f","\u2611":"2611","\u2614\uFE0F":"2614-fe0f","\u2614":"2614","\u2615\uFE0F":"2615-fe0f","\u2615":"2615","\u261D\uFE0F":"261d-fe0f","\u261D":"261d","\u263A\uFE0F":"263a-fe0f","\u263A":"263a","\u2648\uFE0F":"2648-fe0f","\u2648":"2648","\u2649\uFE0F":"2649-fe0f","\u2649":"2649","\u264A\uFE0F":"264a-fe0f","\u264A":"264a","\u264B\uFE0F":"264b-fe0f","\u264B":"264b","\u264C\uFE0F":"264c-fe0f","\u264C":"264c","\u264D\uFE0F":"264d-fe0f","\u264D":"264d","\u264E\uFE0F":"264e-fe0f","\u264E":"264e","\u264F\uFE0F":"264f-fe0f","\u264F":"264f","\u2650\uFE0F":"2650-fe0f","\u2650":"2650","\u2651\uFE0F":"2651-fe0f","\u2651":"2651","\u2652\uFE0F":"2652-fe0f","\u2652":"2652","\u2653\uFE0F":"2653-fe0f","\u2653":"2653","\u2660\uFE0F":"2660-fe0f","\u2660":"2660","\u2663\uFE0F":"2663-fe0f","\u2663":"2663","\u2665\uFE0F":"2665-fe0f","\u2665":"2665","\u2666\uFE0F":"2666-fe0f","\u2666":"2666","\u2668\uFE0F":"2668-fe0f","\u2668":"2668","\u267B\uFE0F":"267b-fe0f","\u267B":"267b","\u267F\uFE0F":"267f-fe0f","\u267F":"267f","\u2693\uFE0F":"2693-fe0f","\u2693":"2693","\u26A0\uFE0F":"26a0-fe0f","\u26A0":"26a0","\u26A1\uFE0F":"26a1-fe0f","\u26A1":"26a1","\u26AA\uFE0F":"26aa-fe0f","\u26AA":"26aa","\u26AB\uFE0F":"26ab-fe0f","\u26AB":"26ab","\u26BD\uFE0F":"26bd-fe0f","\u26BD":"26bd","\u26BE\uFE0F":"26be-fe0f","\u26BE":"26be","\u26C4\uFE0F":"26c4-fe0f","\u26C4":"26c4","\u26C5\uFE0F":"26c5-fe0f","\u26C5":"26c5","\u26D4\uFE0F":"26d4-fe0f","\u26D4":"26d4","\u26EA\uFE0F":"26ea-fe0f","\u26EA":"26ea","\u26F2\uFE0F":"26f2-fe0f","\u26F2":"26f2","\u26F3\uFE0F":"26f3-fe0f","\u26F3":"26f3","\u26F5\uFE0F":"26f5-fe0f","\u26F5":"26f5","\u26FA\uFE0F":"26fa-fe0f","\u26FA":"26fa","\u26FD\uFE0F":"26fd-fe0f","\u26FD":"26fd","\u2702\uFE0F":"2702-fe0f","\u2702":"2702","\u2708\uFE0F":"2708-fe0f","\u2708":"2708","\u2709\uFE0F":"2709-fe0f","\u2709":"2709","\u270C\uFE0F":"270c-fe0f","\u270C":"270c","\u270F\uFE0F":"270f-fe0f","\u270F":"270f","\u2712\uFE0F":"2712-fe0f","\u2712":"2712","\u2714\uFE0F":"2714-fe0f","\u2714":"2714","\u2716\uFE0F":"2716-fe0f","\u2716":"2716","\u2733\uFE0F":"2733-fe0f","\u2733":"2733","\u2734\uFE0F":"2734-fe0f","\u2734":"2734","\u2744\uFE0F":"2744-fe0f","\u2744":"2744","\u2747\uFE0F":"2747-fe0f","\u2747":"2747","\u2757\uFE0F":"2757-fe0f","\u2757":"2757","\u2764\uFE0F":"2764-fe0f","\u2764":"2764","\u27A1\uFE0F":"27a1-fe0f","\u27A1":"27a1","\u2934\uFE0F":"2934-fe0f","\u2934":"2934","\u2935\uFE0F":"2935-fe0f","\u2935":"2935","\u2B05\uFE0F":"2b05-fe0f","\u2B05":"2b05","\u2B06\uFE0F":"2b06-fe0f","\u2B06":"2b06","\u2B07\uFE0F":"2b07-fe0f","\u2B07":"2b07","\u2B1B\uFE0F":"2b1b-fe0f","\u2B1B":"2b1b","\u2B1C\uFE0F":"2b1c-fe0f","\u2B1C":"2b1c","\u2B50\uFE0F":"2b50-fe0f","\u2B50":"2b50","\u2B55\uFE0F":"2b55-fe0f","\u2B55":"2b55","\u3030\uFE0F":"3030-fe0f","\u3030":"3030","\u303D\uFE0F":"303d-fe0f","\u303D":"303d","\u3297\uFE0F":"3297-fe0f","\u3297":"3297","\u3299\uFE0F":"3299-fe0f","\u3299":"3299","\u271D\uFE0F":"271d-fe0f","\u271D":"271d","\u2328\uFE0F":"2328-fe0f","\u2328":"2328","\u270D\uFE0F":"270d-fe0f","\u270D":"270d","\u23CF\uFE0F":"23cf-fe0f","\u23CF":"23cf","\u23ED\uFE0F":"23ed-fe0f","\u23ED":"23ed","\u23EE\uFE0F":"23ee-fe0f","\u23EE":"23ee","\u23EF\uFE0F":"23ef-fe0f","\u23EF":"23ef","\u23F1\uFE0F":"23f1-fe0f","\u23F1":"23f1","\u23F2\uFE0F":"23f2-fe0f","\u23F2":"23f2","\u23F8\uFE0F":"23f8-fe0f","\u23F8":"23f8","\u23F9\uFE0F":"23f9-fe0f","\u23F9":"23f9","\u23FA\uFE0F":"23fa-fe0f","\u23FA":"23fa","\u2602\uFE0F":"2602-fe0f","\u2602":"2602","\u2603\uFE0F":"2603-fe0f","\u2603":"2603","\u2604\uFE0F":"2604-fe0f","\u2604":"2604","\u2618\uFE0F":"2618-fe0f","\u2618":"2618","\u2620\uFE0F":"2620-fe0f","\u2620":"2620","\u2622\uFE0F":"2622-fe0f","\u2622":"2622","\u2623\uFE0F":"2623-fe0f","\u2623":"2623","\u2626\uFE0F":"2626-fe0f","\u2626":"2626","\u262A\uFE0F":"262a-fe0f","\u262A":"262a","\u262E\uFE0F":"262e-fe0f","\u262E":"262e","\u262F\uFE0F":"262f-fe0f","\u262F":"262f","\u2638\uFE0F":"2638-fe0f","\u2638":"2638","\u2639\uFE0F":"2639-fe0f","\u2639":"2639","\u2692\uFE0F":"2692-fe0f","\u2692":"2692","\u2694\uFE0F":"2694-fe0f","\u2694":"2694","\u2696\uFE0F":"2696-fe0f","\u2696":"2696","\u2697\uFE0F":"2697-fe0f","\u2697":"2697","\u2699\uFE0F":"2699-fe0f","\u2699":"2699","\u269B\uFE0F":"269b-fe0f","\u269B":"269b","\u269C\uFE0F":"269c-fe0f","\u269C":"269c","\u26B0\uFE0F":"26b0-fe0f","\u26B0":"26b0","\u26B1\uFE0F":"26b1-fe0f","\u26B1":"26b1","\u26C8\uFE0F":"26c8-fe0f","\u26C8":"26c8","\u26CF\uFE0F":"26cf-fe0f","\u26CF":"26cf","\u26D1\uFE0F":"26d1-fe0f","\u26D1":"26d1","\u26D3\uFE0F":"26d3-fe0f","\u26D3":"26d3","\u26E9\uFE0F":"26e9-fe0f","\u26E9":"26e9","\u26F0\uFE0F":"26f0-fe0f","\u26F0":"26f0","\u26F1\uFE0F":"26f1-fe0f","\u26F1":"26f1","\u26F4\uFE0F":"26f4-fe0f","\u26F4":"26f4","\u26F7\uFE0F":"26f7-fe0f","\u26F7":"26f7","\u26F8\uFE0F":"26f8-fe0f","\u26F8":"26f8","\u26F9\uFE0F":"26f9-fe0f","\u26F9":"26f9","\u2721\uFE0F":"2721-fe0f","\u2721":"2721","\u2763\uFE0F":"2763-fe0f","\u2763":"2763","\uD83E\uDD49":"1f949","\uD83E\uDD48":"1f948","\uD83E\uDD47":"1f947","\uD83E\uDD3A":"1f93a","\uD83E\uDD45":"1f945","\uD83E\uDD3E":"1f93e","\uD83C\uDDFF":"1f1ff","\uD83E\uDD3D":"1f93d","\uD83E\uDD4B":"1f94b","\uD83E\uDD4A":"1f94a","\uD83E\uDD3C":"1f93c","\uD83E\uDD39":"1f939","\uD83E\uDD38":"1f938","\uD83D\uDEF6":"1f6f6","\uD83D\uDEF5":"1f6f5","\uD83D\uDEF4":"1f6f4","\uD83D\uDED2":"1f6d2","\uD83C\uDCCF":"1f0cf","\uD83C\uDD70":"1f170","\uD83C\uDD71":"1f171","\uD83C\uDD7E":"1f17e","\uD83D\uDED1":"1f6d1","\uD83C\uDD8E":"1f18e","\uD83C\uDD91":"1f191","\uD83C\uDDFE":"1f1fe","\uD83C\uDD92":"1f192","\uD83C\uDD93":"1f193","\uD83C\uDD94":"1f194","\uD83C\uDD95":"1f195","\uD83C\uDD96":"1f196","\uD83C\uDD97":"1f197","\uD83C\uDD98":"1f198","\uD83E\uDD44":"1f944","\uD83C\uDD99":"1f199","\uD83C\uDD9A":"1f19a","\uD83E\uDD42":"1f942","\uD83E\uDD43":"1f943","\uD83C\uDE01":"1f201","\uD83E\uDD59":"1f959","\uD83C\uDE32":"1f232","\uD83C\uDE33":"1f233","\uD83C\uDE34":"1f234","\uD83C\uDE35":"1f235","\uD83C\uDE36":"1f236","\uD83E\uDD58":"1f958","\uD83C\uDE38":"1f238","\uD83C\uDE39":"1f239","\uD83E\uDD57":"1f957","\uD83C\uDE3A":"1f23a","\uD83C\uDE50":"1f250","\uD83C\uDE51":"1f251","\uD83C\uDF00":"1f300","\uD83E\uDD56":"1f956","\uD83C\uDF01":"1f301","\uD83C\uDF02":"1f302","\uD83C\uDF03":"1f303","\uD83C\uDF04":"1f304","\uD83C\uDF05":"1f305","\uD83C\uDF06":"1f306","\uD83E\uDD55":"1f955","\uD83C\uDF07":"1f307","\uD83C\uDF08":"1f308","\uD83E\uDD54":"1f954","\uD83C\uDF09":"1f309","\uD83C\uDF0A":"1f30a","\uD83C\uDF0B":"1f30b","\uD83C\uDF0C":"1f30c","\uD83C\uDF0F":"1f30f","\uD83C\uDF11":"1f311","\uD83E\uDD53":"1f953","\uD83C\uDF13":"1f313","\uD83C\uDF14":"1f314","\uD83C\uDF15":"1f315","\uD83C\uDF19":"1f319","\uD83C\uDF1B":"1f31b","\uD83C\uDF1F":"1f31f","\uD83E\uDD52":"1f952","\uD83C\uDF20":"1f320","\uD83C\uDF30":"1f330","\uD83E\uDD51":"1f951","\uD83C\uDF31":"1f331","\uD83C\uDF34":"1f334","\uD83C\uDF35":"1f335","\uD83C\uDF37":"1f337","\uD83C\uDF38":"1f338","\uD83C\uDF39":"1f339","\uD83C\uDF3A":"1f33a","\uD83C\uDF3B":"1f33b","\uD83C\uDF3C":"1f33c","\uD83C\uDF3D":"1f33d","\uD83E\uDD50":"1f950","\uD83C\uDF3E":"1f33e","\uD83C\uDF3F":"1f33f","\uD83C\uDF40":"1f340","\uD83C\uDF41":"1f341","\uD83C\uDF42":"1f342","\uD83C\uDF43":"1f343","\uD83C\uDF44":"1f344","\uD83C\uDF45":"1f345","\uD83C\uDF46":"1f346","\uD83C\uDF47":"1f347","\uD83C\uDF48":"1f348","\uD83C\uDF49":"1f349","\uD83C\uDF4A":"1f34a","\uD83E\uDD40":"1f940","\uD83C\uDF4C":"1f34c","\uD83C\uDF4D":"1f34d","\uD83C\uDF4E":"1f34e","\uD83C\uDF4F":"1f34f","\uD83C\uDF51":"1f351","\uD83C\uDF52":"1f352","\uD83C\uDF53":"1f353","\uD83E\uDD8F":"1f98f","\uD83C\uDF54":"1f354","\uD83C\uDF55":"1f355","\uD83C\uDF56":"1f356","\uD83E\uDD8E":"1f98e","\uD83C\uDF57":"1f357","\uD83C\uDF58":"1f358","\uD83C\uDF59":"1f359","\uD83E\uDD8D":"1f98d","\uD83C\uDF5A":"1f35a","\uD83C\uDF5B":"1f35b","\uD83E\uDD8C":"1f98c","\uD83C\uDF5C":"1f35c","\uD83C\uDF5D":"1f35d","\uD83C\uDF5E":"1f35e","\uD83C\uDF5F":"1f35f","\uD83E\uDD8B":"1f98b","\uD83C\uDF60":"1f360","\uD83C\uDF61":"1f361","\uD83E\uDD8A":"1f98a","\uD83C\uDF62":"1f362","\uD83C\uDF63":"1f363","\uD83E\uDD89":"1f989","\uD83C\uDF64":"1f364","\uD83C\uDF65":"1f365","\uD83E\uDD88":"1f988","\uD83C\uDF66":"1f366","\uD83E\uDD87":"1f987","\uD83C\uDF67":"1f367","\uD83C\uDDFD":"1f1fd","\uD83C\uDF68":"1f368","\uD83E\uDD86":"1f986","\uD83C\uDF69":"1f369","\uD83E\uDD85":"1f985","\uD83C\uDF6A":"1f36a","\uD83D\uDDA4":"1f5a4","\uD83C\uDF6B":"1f36b","\uD83C\uDF6C":"1f36c","\uD83C\uDF6D":"1f36d","\uD83C\uDF6E":"1f36e","\uD83C\uDF6F":"1f36f","\uD83E\uDD1E":"1f91e","\uD83C\uDF70":"1f370","\uD83C\uDF71":"1f371","\uD83C\uDF72":"1f372","\uD83E\uDD1D":"1f91d","\uD83C\uDF73":"1f373","\uD83C\uDF74":"1f374","\uD83C\uDF75":"1f375","\uD83C\uDF76":"1f376","\uD83C\uDF77":"1f377","\uD83C\uDF78":"1f378","\uD83C\uDF79":"1f379","\uD83C\uDF7A":"1f37a","\uD83C\uDF7B":"1f37b","\uD83C\uDF80":"1f380","\uD83C\uDF81":"1f381","\uD83C\uDF82":"1f382","\uD83C\uDF83":"1f383","\uD83E\uDD1B":"1f91b","\uD83E\uDD1C":"1f91c","\uD83C\uDF84":"1f384","\uD83C\uDF85":"1f385","\uD83C\uDF86":"1f386","\uD83E\uDD1A":"1f91a","\uD83C\uDF87":"1f387","\uD83C\uDF88":"1f388","\uD83C\uDF89":"1f389","\uD83C\uDF8A":"1f38a","\uD83C\uDF8B":"1f38b","\uD83C\uDF8C":"1f38c","\uD83E\uDD19":"1f919","\uD83C\uDF8D":"1f38d","\uD83D\uDD7A":"1f57a","\uD83C\uDF8E":"1f38e","\uD83E\uDD33":"1f933","\uD83C\uDF8F":"1f38f","\uD83E\uDD30":"1f930","\uD83C\uDF90":"1f390","\uD83E\uDD26":"1f926","\uD83E\uDD37":"1f937","\uD83C\uDF91":"1f391","\uD83C\uDF92":"1f392","\uD83C\uDF93":"1f393","\uD83C\uDFA0":"1f3a0","\uD83C\uDFA1":"1f3a1","\uD83C\uDFA2":"1f3a2","\uD83C\uDFA3":"1f3a3","\uD83C\uDFA4":"1f3a4","\uD83C\uDFA5":"1f3a5","\uD83C\uDFA6":"1f3a6","\uD83C\uDFA7":"1f3a7","\uD83E\uDD36":"1f936","\uD83C\uDFA8":"1f3a8","\uD83E\uDD35":"1f935","\uD83C\uDFA9":"1f3a9","\uD83C\uDFAA":"1f3aa","\uD83E\uDD34":"1f934","\uD83C\uDFAB":"1f3ab","\uD83C\uDFAC":"1f3ac","\uD83C\uDFAD":"1f3ad","\uD83E\uDD27":"1f927","\uD83C\uDFAE":"1f3ae","\uD83C\uDFAF":"1f3af","\uD83C\uDFB0":"1f3b0","\uD83C\uDFB1":"1f3b1","\uD83C\uDFB2":"1f3b2","\uD83C\uDFB3":"1f3b3","\uD83C\uDFB4":"1f3b4","\uD83E\uDD25":"1f925","\uD83C\uDFB5":"1f3b5","\uD83C\uDFB6":"1f3b6","\uD83C\uDFB7":"1f3b7","\uD83E\uDD24":"1f924","\uD83C\uDFB8":"1f3b8","\uD83C\uDFB9":"1f3b9","\uD83C\uDFBA":"1f3ba","\uD83E\uDD23":"1f923","\uD83C\uDFBB":"1f3bb","\uD83C\uDFBC":"1f3bc","\uD83C\uDFBD":"1f3bd","\uD83E\uDD22":"1f922","\uD83C\uDFBE":"1f3be","\uD83C\uDFBF":"1f3bf","\uD83C\uDFC0":"1f3c0","\uD83C\uDFC1":"1f3c1","\uD83E\uDD21":"1f921","\uD83C\uDFC2":"1f3c2","\uD83C\uDFC3":"1f3c3","\uD83C\uDFC4":"1f3c4","\uD83C\uDFC6":"1f3c6","\uD83C\uDFC8":"1f3c8","\uD83C\uDFCA":"1f3ca","\uD83C\uDFE0":"1f3e0","\uD83C\uDFE1":"1f3e1","\uD83C\uDFE2":"1f3e2","\uD83C\uDFE3":"1f3e3","\uD83C\uDFE5":"1f3e5","\uD83C\uDFE6":"1f3e6","\uD83C\uDFE7":"1f3e7","\uD83C\uDFE8":"1f3e8","\uD83C\uDFE9":"1f3e9","\uD83C\uDFEA":"1f3ea","\uD83C\uDFEB":"1f3eb","\uD83C\uDFEC":"1f3ec","\uD83E\uDD20":"1f920","\uD83C\uDFED":"1f3ed","\uD83C\uDFEE":"1f3ee","\uD83C\uDFEF":"1f3ef","\uD83C\uDFF0":"1f3f0","\uD83D\uDC0C":"1f40c","\uD83D\uDC0D":"1f40d","\uD83D\uDC0E":"1f40e","\uD83D\uDC11":"1f411","\uD83D\uDC12":"1f412","\uD83D\uDC14":"1f414","\uD83D\uDC17":"1f417","\uD83D\uDC18":"1f418","\uD83D\uDC19":"1f419","\uD83D\uDC1A":"1f41a","\uD83D\uDC1B":"1f41b","\uD83D\uDC1C":"1f41c","\uD83D\uDC1D":"1f41d","\uD83D\uDC1E":"1f41e","\uD83D\uDC1F":"1f41f","\uD83D\uDC20":"1f420","\uD83D\uDC21":"1f421","\uD83D\uDC22":"1f422","\uD83D\uDC23":"1f423","\uD83D\uDC24":"1f424","\uD83D\uDC25":"1f425","\uD83D\uDC26":"1f426","\uD83D\uDC27":"1f427","\uD83D\uDC28":"1f428","\uD83D\uDC29":"1f429","\uD83D\uDC2B":"1f42b","\uD83D\uDC2C":"1f42c","\uD83D\uDC2D":"1f42d","\uD83D\uDC2E":"1f42e","\uD83D\uDC2F":"1f42f","\uD83D\uDC30":"1f430","\uD83D\uDC31":"1f431","\uD83D\uDC32":"1f432","\uD83D\uDC33":"1f433","\uD83D\uDC34":"1f434","\uD83D\uDC35":"1f435","\uD83D\uDC36":"1f436","\uD83D\uDC37":"1f437","\uD83D\uDC38":"1f438","\uD83D\uDC39":"1f439","\uD83D\uDC3A":"1f43a","\uD83D\uDC3B":"1f43b","\uD83D\uDC3C":"1f43c","\uD83D\uDC3D":"1f43d","\uD83D\uDC3E":"1f43e","\uD83D\uDC40":"1f440","\uD83D\uDC42":"1f442","\uD83D\uDC43":"1f443","\uD83D\uDC44":"1f444","\uD83D\uDC45":"1f445","\uD83D\uDC46":"1f446","\uD83D\uDC47":"1f447","\uD83D\uDC48":"1f448","\uD83D\uDC49":"1f449","\uD83D\uDC4A":"1f44a","\uD83D\uDC4B":"1f44b","\uD83D\uDC4C":"1f44c","\uD83D\uDC4D":"1f44d","\uD83D\uDC4E":"1f44e","\uD83D\uDC4F":"1f44f","\uD83D\uDC50":"1f450","\uD83D\uDC51":"1f451","\uD83D\uDC52":"1f452","\uD83D\uDC53":"1f453","\uD83D\uDC54":"1f454","\uD83D\uDC55":"1f455","\uD83D\uDC56":"1f456","\uD83D\uDC57":"1f457","\uD83D\uDC58":"1f458","\uD83D\uDC59":"1f459","\uD83D\uDC5A":"1f45a","\uD83D\uDC5B":"1f45b","\uD83D\uDC5C":"1f45c","\uD83D\uDC5D":"1f45d","\uD83D\uDC5E":"1f45e","\uD83D\uDC5F":"1f45f","\uD83D\uDC60":"1f460","\uD83D\uDC61":"1f461","\uD83D\uDC62":"1f462","\uD83D\uDC63":"1f463","\uD83D\uDC64":"1f464","\uD83D\uDC66":"1f466","\uD83D\uDC67":"1f467","\uD83D\uDC68":"1f468","\uD83D\uDC69":"1f469","\uD83D\uDC6A":"1f46a","\uD83D\uDC6B":"1f46b","\uD83D\uDC6E":"1f46e","\uD83D\uDC6F":"1f46f","\uD83D\uDC70":"1f470","\uD83D\uDC71":"1f471","\uD83D\uDC72":"1f472","\uD83D\uDC73":"1f473","\uD83D\uDC74":"1f474","\uD83D\uDC75":"1f475","\uD83D\uDC76":"1f476","\uD83D\uDC77":"1f477","\uD83D\uDC78":"1f478","\uD83D\uDC79":"1f479","\uD83D\uDC7A":"1f47a","\uD83D\uDC7B":"1f47b","\uD83D\uDC7C":"1f47c","\uD83D\uDC7D":"1f47d","\uD83D\uDC7E":"1f47e","\uD83D\uDC7F":"1f47f","\uD83D\uDC80":"1f480","\uD83D\uDCC7":"1f4c7","\uD83D\uDC81":"1f481","\uD83D\uDC82":"1f482","\uD83D\uDC83":"1f483","\uD83D\uDC84":"1f484","\uD83D\uDC85":"1f485","\uD83D\uDCD2":"1f4d2","\uD83D\uDC86":"1f486","\uD83D\uDCD3":"1f4d3","\uD83D\uDC87":"1f487","\uD83D\uDCD4":"1f4d4","\uD83D\uDC88":"1f488","\uD83D\uDCD5":"1f4d5","\uD83D\uDC89":"1f489","\uD83D\uDCD6":"1f4d6","\uD83D\uDC8A":"1f48a","\uD83D\uDCD7":"1f4d7","\uD83D\uDC8B":"1f48b","\uD83D\uDCD8":"1f4d8","\uD83D\uDC8C":"1f48c","\uD83D\uDCD9":"1f4d9","\uD83D\uDC8D":"1f48d","\uD83D\uDCDA":"1f4da","\uD83D\uDC8E":"1f48e","\uD83D\uDCDB":"1f4db","\uD83D\uDC8F":"1f48f","\uD83D\uDCDC":"1f4dc","\uD83D\uDC90":"1f490","\uD83D\uDCDD":"1f4dd","\uD83D\uDC91":"1f491","\uD83D\uDCDE":"1f4de","\uD83D\uDC92":"1f492","\uD83D\uDCDF":"1f4df","\uD83D\uDCE0":"1f4e0","\uD83D\uDC93":"1f493","\uD83D\uDCE1":"1f4e1","\uD83D\uDCE2":"1f4e2","\uD83D\uDC94":"1f494","\uD83D\uDCE3":"1f4e3","\uD83D\uDCE4":"1f4e4","\uD83D\uDC95":"1f495","\uD83D\uDCE5":"1f4e5","\uD83D\uDCE6":"1f4e6","\uD83D\uDC96":"1f496","\uD83D\uDCE7":"1f4e7","\uD83D\uDCE8":"1f4e8","\uD83D\uDC97":"1f497","\uD83D\uDCE9":"1f4e9","\uD83D\uDCEA":"1f4ea","\uD83D\uDC98":"1f498","\uD83D\uDCEB":"1f4eb","\uD83D\uDCEE":"1f4ee","\uD83D\uDC99":"1f499","\uD83D\uDCF0":"1f4f0","\uD83D\uDCF1":"1f4f1","\uD83D\uDC9A":"1f49a","\uD83D\uDCF2":"1f4f2","\uD83D\uDCF3":"1f4f3","\uD83D\uDC9B":"1f49b","\uD83D\uDCF4":"1f4f4","\uD83D\uDCF6":"1f4f6","\uD83D\uDC9C":"1f49c","\uD83D\uDCF7":"1f4f7","\uD83D\uDCF9":"1f4f9","\uD83D\uDC9D":"1f49d","\uD83D\uDCFA":"1f4fa","\uD83D\uDCFB":"1f4fb","\uD83D\uDC9E":"1f49e","\uD83D\uDCFC":"1f4fc","\uD83D\uDD03":"1f503","\uD83D\uDC9F":"1f49f","\uD83D\uDD0A":"1f50a","\uD83D\uDD0B":"1f50b","\uD83D\uDCA0":"1f4a0","\uD83D\uDD0C":"1f50c","\uD83D\uDD0D":"1f50d","\uD83D\uDCA1":"1f4a1","\uD83D\uDD0E":"1f50e","\uD83D\uDD0F":"1f50f","\uD83D\uDCA2":"1f4a2","\uD83D\uDD10":"1f510","\uD83D\uDD11":"1f511","\uD83D\uDCA3":"1f4a3","\uD83D\uDD12":"1f512","\uD83D\uDD13":"1f513","\uD83D\uDCA4":"1f4a4","\uD83D\uDD14":"1f514","\uD83D\uDD16":"1f516","\uD83D\uDCA5":"1f4a5","\uD83D\uDD17":"1f517","\uD83D\uDD18":"1f518","\uD83D\uDCA6":"1f4a6","\uD83D\uDD19":"1f519","\uD83D\uDD1A":"1f51a","\uD83D\uDCA7":"1f4a7","\uD83D\uDD1B":"1f51b","\uD83D\uDD1C":"1f51c","\uD83D\uDCA8":"1f4a8","\uD83D\uDD1D":"1f51d","\uD83D\uDD1E":"1f51e","\uD83D\uDCA9":"1f4a9","\uD83D\uDD1F":"1f51f","\uD83D\uDCAA":"1f4aa","\uD83D\uDD20":"1f520","\uD83D\uDD21":"1f521","\uD83D\uDCAB":"1f4ab","\uD83D\uDD22":"1f522","\uD83D\uDD23":"1f523","\uD83D\uDCAC":"1f4ac","\uD83D\uDD24":"1f524","\uD83D\uDD25":"1f525","\uD83D\uDCAE":"1f4ae","\uD83D\uDD26":"1f526","\uD83D\uDD27":"1f527","\uD83D\uDCAF":"1f4af","\uD83D\uDD28":"1f528","\uD83D\uDD29":"1f529","\uD83D\uDCB0":"1f4b0","\uD83D\uDD2A":"1f52a","\uD83D\uDD2B":"1f52b","\uD83D\uDCB1":"1f4b1","\uD83D\uDD2E":"1f52e","\uD83D\uDCB2":"1f4b2","\uD83D\uDD2F":"1f52f","\uD83D\uDCB3":"1f4b3","\uD83D\uDD30":"1f530","\uD83D\uDD31":"1f531","\uD83D\uDCB4":"1f4b4","\uD83D\uDD32":"1f532","\uD83D\uDD33":"1f533","\uD83D\uDCB5":"1f4b5","\uD83D\uDD34":"1f534","\uD83D\uDD35":"1f535","\uD83D\uDCB8":"1f4b8","\uD83D\uDD36":"1f536","\uD83D\uDD37":"1f537","\uD83D\uDCB9":"1f4b9","\uD83D\uDD38":"1f538","\uD83D\uDD39":"1f539","\uD83D\uDCBA":"1f4ba","\uD83D\uDD3A":"1f53a","\uD83D\uDD3B":"1f53b","\uD83D\uDCBB":"1f4bb","\uD83D\uDD3C":"1f53c","\uD83D\uDCBC":"1f4bc","\uD83D\uDD3D":"1f53d","\uD83D\uDD50":"1f550","\uD83D\uDCBD":"1f4bd","\uD83D\uDD51":"1f551","\uD83D\uDCBE":"1f4be","\uD83D\uDD52":"1f552","\uD83D\uDCBF":"1f4bf","\uD83D\uDD53":"1f553","\uD83D\uDCC0":"1f4c0","\uD83D\uDD54":"1f554","\uD83D\uDD55":"1f555","\uD83D\uDCC1":"1f4c1","\uD83D\uDD56":"1f556","\uD83D\uDD57":"1f557","\uD83D\uDCC2":"1f4c2","\uD83D\uDD58":"1f558","\uD83D\uDD59":"1f559","\uD83D\uDCC3":"1f4c3","\uD83D\uDD5A":"1f55a","\uD83D\uDD5B":"1f55b","\uD83D\uDCC4":"1f4c4","\uD83D\uDDFB":"1f5fb","\uD83D\uDDFC":"1f5fc","\uD83D\uDCC5":"1f4c5","\uD83D\uDDFD":"1f5fd","\uD83D\uDDFE":"1f5fe","\uD83D\uDCC6":"1f4c6","\uD83D\uDDFF":"1f5ff","\uD83D\uDE01":"1f601","\uD83D\uDE02":"1f602","\uD83D\uDE03":"1f603","\uD83D\uDCC8":"1f4c8","\uD83D\uDE04":"1f604","\uD83D\uDE05":"1f605","\uD83D\uDCC9":"1f4c9","\uD83D\uDE06":"1f606","\uD83D\uDE09":"1f609","\uD83D\uDCCA":"1f4ca","\uD83D\uDE0A":"1f60a","\uD83D\uDE0B":"1f60b","\uD83D\uDCCB":"1f4cb","\uD83D\uDE0C":"1f60c","\uD83D\uDE0D":"1f60d","\uD83D\uDCCC":"1f4cc","\uD83D\uDE0F":"1f60f","\uD83D\uDE12":"1f612","\uD83D\uDCCD":"1f4cd","\uD83D\uDE13":"1f613","\uD83D\uDE14":"1f614","\uD83D\uDCCE":"1f4ce","\uD83D\uDE16":"1f616","\uD83D\uDE18":"1f618","\uD83D\uDCCF":"1f4cf","\uD83D\uDE1A":"1f61a","\uD83D\uDE1C":"1f61c","\uD83D\uDCD0":"1f4d0","\uD83D\uDE1D":"1f61d","\uD83D\uDE1E":"1f61e","\uD83D\uDCD1":"1f4d1","\uD83D\uDE20":"1f620","\uD83D\uDE21":"1f621","\uD83D\uDE22":"1f622","\uD83D\uDE23":"1f623","\uD83D\uDE24":"1f624","\uD83D\uDE25":"1f625","\uD83D\uDE28":"1f628","\uD83D\uDE29":"1f629","\uD83D\uDE2A":"1f62a","\uD83D\uDE2B":"1f62b","\uD83D\uDE2D":"1f62d","\uD83D\uDE30":"1f630","\uD83D\uDE31":"1f631","\uD83D\uDE32":"1f632","\uD83D\uDE33":"1f633","\uD83D\uDE35":"1f635","\uD83D\uDE37":"1f637","\uD83D\uDE38":"1f638","\uD83D\uDE39":"1f639","\uD83D\uDE3A":"1f63a","\uD83D\uDE3B":"1f63b","\uD83D\uDE3C":"1f63c","\uD83D\uDE3D":"1f63d","\uD83D\uDE3E":"1f63e","\uD83D\uDE3F":"1f63f","\uD83D\uDE40":"1f640","\uD83D\uDE45":"1f645","\uD83D\uDE46":"1f646","\uD83D\uDE47":"1f647","\uD83D\uDE48":"1f648","\uD83D\uDE49":"1f649","\uD83D\uDE4A":"1f64a","\uD83D\uDE4B":"1f64b","\uD83D\uDE4C":"1f64c","\uD83D\uDE4D":"1f64d","\uD83D\uDE4E":"1f64e","\uD83D\uDE4F":"1f64f","\uD83D\uDE80":"1f680","\uD83D\uDE83":"1f683","\uD83D\uDE84":"1f684","\uD83D\uDE85":"1f685","\uD83D\uDE87":"1f687","\uD83D\uDE89":"1f689","\uD83D\uDE8C":"1f68c","\uD83D\uDE8F":"1f68f","\uD83D\uDE91":"1f691","\uD83D\uDE92":"1f692","\uD83D\uDE93":"1f693","\uD83D\uDE95":"1f695","\uD83D\uDE97":"1f697","\uD83D\uDE99":"1f699","\uD83D\uDE9A":"1f69a","\uD83D\uDEA2":"1f6a2","\uD83D\uDEA4":"1f6a4","\uD83D\uDEA5":"1f6a5","\uD83D\uDEA7":"1f6a7","\uD83D\uDEA8":"1f6a8","\uD83D\uDEA9":"1f6a9","\uD83D\uDEAA":"1f6aa","\uD83D\uDEAB":"1f6ab","\uD83D\uDEAC":"1f6ac","\uD83D\uDEAD":"1f6ad","\uD83D\uDEB2":"1f6b2","\uD83D\uDEB6":"1f6b6","\uD83D\uDEB9":"1f6b9","\uD83D\uDEBA":"1f6ba","\uD83D\uDEBB":"1f6bb","\uD83D\uDEBC":"1f6bc","\uD83D\uDEBD":"1f6bd","\uD83D\uDEBE":"1f6be","\uD83D\uDEC0":"1f6c0","\uD83E\uDD18":"1f918","\uD83D\uDE00":"1f600","\uD83D\uDE07":"1f607","\uD83D\uDE08":"1f608","\uD83D\uDE0E":"1f60e","\uD83D\uDE10":"1f610","\uD83D\uDE11":"1f611","\uD83D\uDE15":"1f615","\uD83D\uDE17":"1f617","\uD83D\uDE19":"1f619","\uD83D\uDE1B":"1f61b","\uD83D\uDE1F":"1f61f","\uD83D\uDE26":"1f626","\uD83D\uDE27":"1f627","\uD83D\uDE2C":"1f62c","\uD83D\uDE2E":"1f62e","\uD83D\uDE2F":"1f62f","\uD83D\uDE34":"1f634","\uD83D\uDE36":"1f636","\uD83D\uDE81":"1f681","\uD83D\uDE82":"1f682","\uD83D\uDE86":"1f686","\uD83D\uDE88":"1f688","\uD83D\uDE8A":"1f68a","\uD83D\uDE8D":"1f68d","\uD83D\uDE8E":"1f68e","\uD83D\uDE90":"1f690","\uD83D\uDE94":"1f694","\uD83D\uDE96":"1f696","\uD83D\uDE98":"1f698","\uD83D\uDE9B":"1f69b","\uD83D\uDE9C":"1f69c","\uD83D\uDE9D":"1f69d","\uD83D\uDE9E":"1f69e","\uD83D\uDE9F":"1f69f","\uD83D\uDEA0":"1f6a0","\uD83D\uDEA1":"1f6a1","\uD83D\uDEA3":"1f6a3","\uD83D\uDEA6":"1f6a6","\uD83D\uDEAE":"1f6ae","\uD83D\uDEAF":"1f6af","\uD83D\uDEB0":"1f6b0","\uD83D\uDEB1":"1f6b1","\uD83D\uDEB3":"1f6b3","\uD83D\uDEB4":"1f6b4","\uD83D\uDEB5":"1f6b5","\uD83D\uDEB7":"1f6b7","\uD83D\uDEB8":"1f6b8","\uD83D\uDEBF":"1f6bf","\uD83D\uDEC1":"1f6c1","\uD83D\uDEC2":"1f6c2","\uD83D\uDEC3":"1f6c3","\uD83D\uDEC4":"1f6c4","\uD83D\uDEC5":"1f6c5","\uD83C\uDF0D":"1f30d","\uD83C\uDF0E":"1f30e","\uD83C\uDF10":"1f310","\uD83C\uDF12":"1f312","\uD83C\uDF16":"1f316","\uD83C\uDF17":"1f317","\uD83C\uDF18":"1f318","\uD83C\uDF1A":"1f31a","\uD83C\uDF1C":"1f31c","\uD83C\uDF1D":"1f31d","\uD83C\uDF1E":"1f31e","\uD83C\uDF32":"1f332","\uD83C\uDF33":"1f333","\uD83C\uDF4B":"1f34b","\uD83C\uDF50":"1f350","\uD83C\uDF7C":"1f37c","\uD83C\uDFC7":"1f3c7","\uD83C\uDFC9":"1f3c9","\uD83C\uDFE4":"1f3e4","\uD83D\uDC00":"1f400","\uD83D\uDC01":"1f401","\uD83D\uDC02":"1f402","\uD83D\uDC03":"1f403","\uD83D\uDC04":"1f404","\uD83D\uDC05":"1f405","\uD83D\uDC06":"1f406","\uD83D\uDC07":"1f407","\uD83D\uDC08":"1f408","\uD83D\uDC09":"1f409","\uD83D\uDC0A":"1f40a","\uD83D\uDC0B":"1f40b","\uD83D\uDC0F":"1f40f","\uD83D\uDC10":"1f410","\uD83D\uDC13":"1f413","\uD83D\uDC15":"1f415","\uD83D\uDC16":"1f416","\uD83D\uDC2A":"1f42a","\uD83D\uDC65":"1f465","\uD83D\uDC6C":"1f46c","\uD83D\uDC6D":"1f46d","\uD83D\uDCAD":"1f4ad","\uD83D\uDCB6":"1f4b6","\uD83D\uDCB7":"1f4b7","\uD83D\uDCEC":"1f4ec","\uD83D\uDCED":"1f4ed","\uD83D\uDCEF":"1f4ef","\uD83D\uDCF5":"1f4f5","\uD83D\uDD00":"1f500","\uD83D\uDD01":"1f501","\uD83D\uDD02":"1f502","\uD83D\uDD04":"1f504","\uD83D\uDD05":"1f505","\uD83D\uDD06":"1f506","\uD83D\uDD07":"1f507","\uD83D\uDD09":"1f509","\uD83D\uDD15":"1f515","\uD83D\uDD2C":"1f52c","\uD83D\uDD2D":"1f52d","\uD83D\uDD5C":"1f55c","\uD83D\uDD5D":"1f55d","\uD83D\uDD5E":"1f55e","\uD83D\uDD5F":"1f55f","\uD83D\uDD60":"1f560","\uD83D\uDD61":"1f561","\uD83D\uDD62":"1f562","\uD83D\uDD63":"1f563","\uD83D\uDD64":"1f564","\uD83D\uDD65":"1f565","\uD83D\uDD66":"1f566","\uD83D\uDD67":"1f567","\uD83D\uDD08":"1f508","\uD83D\uDE8B":"1f68b","\uD83C\uDFC5":"1f3c5","\uD83C\uDFF4":"1f3f4","\uD83D\uDCF8":"1f4f8","\uD83D\uDECC":"1f6cc","\uD83D\uDD95":"1f595","\uD83D\uDD96":"1f596","\uD83D\uDE41":"1f641","\uD83D\uDE42":"1f642","\uD83D\uDEEB":"1f6eb","\uD83D\uDEEC":"1f6ec","\uD83C\uDFFB":"1f3fb","\uD83C\uDFFC":"1f3fc","\uD83C\uDFFD":"1f3fd","\uD83C\uDFFE":"1f3fe","\uD83C\uDFFF":"1f3ff","\uD83D\uDE43":"1f643","\uD83E\uDD11":"1f911","\uD83E\uDD13":"1f913","\uD83E\uDD17":"1f917","\uD83D\uDE44":"1f644","\uD83E\uDD14":"1f914","\uD83E\uDD10":"1f910","\uD83E\uDD12":"1f912","\uD83E\uDD15":"1f915","\uD83E\uDD16":"1f916","\uD83E\uDD81":"1f981","\uD83E\uDD84":"1f984","\uD83E\uDD82":"1f982","\uD83E\uDD80":"1f980","\uD83E\uDD83":"1f983","\uD83E\uDDC0":"1f9c0","\uD83C\uDF2D":"1f32d","\uD83C\uDF2E":"1f32e","\uD83C\uDF2F":"1f32f","\uD83C\uDF7F":"1f37f","\uD83C\uDF7E":"1f37e","\uD83C\uDFF9":"1f3f9","\uD83C\uDFFA":"1f3fa","\uD83D\uDED0":"1f6d0","\uD83D\uDD4B":"1f54b","\uD83D\uDD4C":"1f54c","\uD83D\uDD4D":"1f54d","\uD83D\uDD4E":"1f54e","\uD83D\uDCFF":"1f4ff","\uD83C\uDFCF":"1f3cf","\uD83C\uDFD0":"1f3d0","\uD83C\uDFD1":"1f3d1","\uD83C\uDFD2":"1f3d2","\uD83C\uDFD3":"1f3d3","\uD83C\uDFF8":"1f3f8","\uD83E\uDD41":"1f941","\uD83E\uDD90":"1f990","\uD83E\uDD91":"1f991","\uD83E\uDD5A":"1f95a","\uD83E\uDD5B":"1f95b","\uD83E\uDD5C":"1f95c","\uD83E\uDD5D":"1f95d","\uD83E\uDD5E":"1f95e","\uD83C\uDDFC":"1f1fc","\uD83C\uDDFB":"1f1fb","\uD83C\uDDFA":"1f1fa","\uD83C\uDDF9":"1f1f9","\uD83C\uDDF8":"1f1f8","\uD83C\uDDF7":"1f1f7","\uD83C\uDDF6":"1f1f6","\uD83C\uDDF5":"1f1f5","\uD83C\uDDF4":"1f1f4","\uD83C\uDDF3":"1f1f3","\uD83C\uDDF2":"1f1f2","\uD83C\uDDF1":"1f1f1","\uD83C\uDDF0":"1f1f0","\uD83C\uDDEF":"1f1ef","\uD83C\uDDEE":"1f1ee","\uD83C\uDDED":"1f1ed","\uD83C\uDDEC":"1f1ec","\uD83C\uDDEB":"1f1eb","\uD83C\uDDEA":"1f1ea","\uD83C\uDDE9":"1f1e9","\uD83C\uDDE8":"1f1e8","\uD83C\uDDE7":"1f1e7","\uD83C\uDDE6":"1f1e6","\u23E9":"23e9","\u23EA":"23ea","\u23EB":"23eb","\u23EC":"23ec","\u23F0":"23f0","\u23F3":"23f3","\u26CE":"26ce","\u2705":"2705","\u270A":"270a","\u270B":"270b","\u2728":"2728","\u274C":"274c","\u274E":"274e","\u2753":"2753","\u2754":"2754","\u2755":"2755","\u2795":"2795","\u2796":"2796","\u2797":"2797","\u27B0":"27b0","\u27BF":"27bf","\u00A9":"00a9","\u00AE":"00ae","\u203C":"203c","\u2049":"2049","\u2122":"2122","\u2139":"2139","\u2194":"2194","\u2195":"2195","\u2196":"2196","\u2197":"2197","\u2198":"2198","\u2199":"2199","\u21A9":"21a9","\u21AA":"21aa","\u231A":"231a","\u231B":"231b","\u24C2":"24c2","\u25AA":"25aa","\u25AB":"25ab","\u25B6":"25b6","\u25C0":"25c0","\u25FB":"25fb","\u25FC":"25fc","\u25FD":"25fd","\u25FE":"25fe","\u2600":"2600","\u2601":"2601","\u260E":"260e","\u2611":"2611","\u2614":"2614","\u2615":"2615","\u261D":"261d","\u263A":"263a","\u2648":"2648","\u2649":"2649","\u264A":"264a","\u264B":"264b","\u264C":"264c","\u264D":"264d","\u264E":"264e","\u264F":"264f","\u2650":"2650","\u2651":"2651","\u2652":"2652","\u2653":"2653","\u2660":"2660","\u2663":"2663","\u2665":"2665","\u2666":"2666","\u2668":"2668","\u267B":"267b","\u267F":"267f","\u2693":"2693","\u26A0":"26a0","\u26A1":"26a1","\u26AA":"26aa","\u26AB":"26ab","\u26BD":"26bd","\u26BE":"26be","\u26C4":"26c4","\u26C5":"26c5","\u26D4":"26d4","\u26EA":"26ea","\u26F2":"26f2","\u26F3":"26f3","\u26F5":"26f5","\u26FA":"26fa","\u26FD":"26fd","\u2702":"2702","\u2708":"2708","\u2709":"2709","\u270C":"270c","\u270F":"270f","\u2712":"2712","\u2714":"2714","\u2716":"2716","\u2733":"2733","\u2734":"2734","\u2744":"2744","\u2747":"2747","\u2757":"2757","\u2764":"2764","\u27A1":"27a1","\u2934":"2934","\u2935":"2935","\u2B05":"2b05","\u2B06":"2b06","\u2B07":"2b07","\u2B1B":"2b1b","\u2B1C":"2b1c","\u2B50":"2b50","\u2B55":"2b55","\u3030":"3030","\u303D":"303d","\u3297":"3297","\u3299":"3299","\uD83C\uDC04":"1f004","\uD83C\uDD7F":"1f17f","\uD83C\uDE02":"1f202","\uD83C\uDE1A":"1f21a","\uD83C\uDE2F":"1f22f","\uD83C\uDE37":"1f237","\uD83C\uDF9E":"1f39e","\uD83C\uDF9F":"1f39f","\uD83C\uDFCB":"1f3cb","\uD83C\uDFCC":"1f3cc","\uD83C\uDFCD":"1f3cd","\uD83C\uDFCE":"1f3ce","\uD83C\uDF96":"1f396","\uD83C\uDF97":"1f397","\uD83C\uDF36":"1f336","\uD83C\uDF27":"1f327","\uD83C\uDF28":"1f328","\uD83C\uDF29":"1f329","\uD83C\uDF2A":"1f32a","\uD83C\uDF2B":"1f32b","\uD83C\uDF2C":"1f32c","\uD83D\uDC3F":"1f43f","\uD83D\uDD77":"1f577","\uD83D\uDD78":"1f578","\uD83C\uDF21":"1f321","\uD83C\uDF99":"1f399","\uD83C\uDF9A":"1f39a","\uD83C\uDF9B":"1f39b","\uD83C\uDFF3":"1f3f3","\uD83C\uDFF5":"1f3f5","\uD83C\uDFF7":"1f3f7","\uD83D\uDCFD":"1f4fd","\u271D":"271d","\uD83D\uDD49":"1f549","\uD83D\uDD4A":"1f54a","\uD83D\uDD6F":"1f56f","\uD83D\uDD70":"1f570","\uD83D\uDD73":"1f573","\uD83D\uDD76":"1f576","\uD83D\uDD79":"1f579","\uD83D\uDD87":"1f587","\uD83D\uDD8A":"1f58a","\uD83D\uDD8B":"1f58b","\uD83D\uDD8C":"1f58c","\uD83D\uDD8D":"1f58d","\uD83D\uDDA5":"1f5a5","\uD83D\uDDA8":"1f5a8","\u2328":"2328","\uD83D\uDDB2":"1f5b2","\uD83D\uDDBC":"1f5bc","\uD83D\uDDC2":"1f5c2","\uD83D\uDDC3":"1f5c3","\uD83D\uDDC4":"1f5c4","\uD83D\uDDD1":"1f5d1","\uD83D\uDDD2":"1f5d2","\uD83D\uDDD3":"1f5d3","\uD83D\uDDDC":"1f5dc","\uD83D\uDDDD":"1f5dd","\uD83D\uDDDE":"1f5de","\uD83D\uDDE1":"1f5e1","\uD83D\uDDE3":"1f5e3","\uD83D\uDDE8":"1f5e8","\uD83D\uDDEF":"1f5ef","\uD83D\uDDF3":"1f5f3","\uD83D\uDDFA":"1f5fa","\uD83D\uDEE0":"1f6e0","\uD83D\uDEE1":"1f6e1","\uD83D\uDEE2":"1f6e2","\uD83D\uDEF0":"1f6f0","\uD83C\uDF7D":"1f37d","\uD83D\uDC41":"1f441","\uD83D\uDD74":"1f574","\uD83D\uDD75":"1f575","\u270D":"270d","\uD83D\uDD90":"1f590","\uD83C\uDFD4":"1f3d4","\uD83C\uDFD5":"1f3d5","\uD83C\uDFD6":"1f3d6","\uD83C\uDFD7":"1f3d7","\uD83C\uDFD8":"1f3d8","\uD83C\uDFD9":"1f3d9","\uD83C\uDFDA":"1f3da","\uD83C\uDFDB":"1f3db","\uD83C\uDFDC":"1f3dc","\uD83C\uDFDD":"1f3dd","\uD83C\uDFDE":"1f3de","\uD83C\uDFDF":"1f3df","\uD83D\uDECB":"1f6cb","\uD83D\uDECD":"1f6cd","\uD83D\uDECE":"1f6ce","\uD83D\uDECF":"1f6cf","\uD83D\uDEE3":"1f6e3","\uD83D\uDEE4":"1f6e4","\uD83D\uDEE5":"1f6e5","\uD83D\uDEE9":"1f6e9","\uD83D\uDEF3":"1f6f3","\u23CF":"23cf","\u23ED":"23ed","\u23EE":"23ee","\u23EF":"23ef","\u23F1":"23f1","\u23F2":"23f2","\u23F8":"23f8","\u23F9":"23f9","\u23FA":"23fa","\u2602":"2602","\u2603":"2603","\u2604":"2604","\u2618":"2618","\u2620":"2620","\u2622":"2622","\u2623":"2623","\u2626":"2626","\u262A":"262a","\u262E":"262e","\u262F":"262f","\u2638":"2638","\u2639":"2639","\u2692":"2692","\u2694":"2694","\u2696":"2696","\u2697":"2697","\u2699":"2699","\u269B":"269b","\u269C":"269c","\u26B0":"26b0","\u26B1":"26b1","\u26C8":"26c8","\u26CF":"26cf","\u26D1":"26d1","\u26D3":"26d3","\u26E9":"26e9","\u26F0":"26f0","\u26F1":"26f1","\u26F4":"26f4","\u26F7":"26f7","\u26F8":"26f8","\u26F9":"26f9","\u2721":"2721","\u2763":"2763","\uD83C\uDF24":"1f324","\uD83C\uDF25":"1f325","\uD83C\uDF26":"1f326","\uD83D\uDDB1":"1f5b1"};
    ns.imagePathPNG = 'https://cdn.jsdelivr.net/emojione/assets/png/';
    ns.imagePathSVG = 'https://cdn.jsdelivr.net/emojione/assets/svg/';
    ns.imagePathSVGSprites = './../assets/sprites/emojione.sprites.svg';
    ns.imageType = 'png'; // or svg
    ns.imageTitleTag = true; //set to false to remove title attribute from img tag
    ns.sprites = false; // if this is true then sprite markup will be used (if SVG image type is set then you must include the SVG sprite file locally)
    ns.unicodeAlt = true; // use the unicode char as the alt attribute (makes copy and pasting the resulting text better)
    ns.ascii = false; // change to true to convert ascii smileys
    ns.cacheBustParam = '?v=2.2.7'; // you can [optionally] modify this to force browsers to refresh their cache. it will be appended to the send of the filenames

    ns.regShortNames = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+ns.shortnames+")", "gi");
    ns.regAscii = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)"+ns.asciiRegexp+"(?=\\s|$|[!,.?]))", "g");
    ns.regUnicode = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+ns.unicodeRegexp+")", "gi");

    ns.toImage = function(str) {
        str = ns.unicodeToImage(str);
        str = ns.shortnameToImage(str);
        return str;
    };

    // Uses toShort to transform all unicode into a standard shortname
    // then transforms the shortname into unicode
    // This is done for standardization when converting several unicode types
    ns.unifyUnicode = function(str) {
        str = ns.toShort(str);
        str = ns.shortnameToUnicode(str);
        return str;
    };

    // Replace shortnames (:wink:) with Ascii equivalents ( ;^) )
    // Useful for systems that dont support unicode nor images
    ns.shortnameToAscii = function(str) {
        var unicode,
        // something to keep in mind here is that array flip will destroy
        // half of the ascii text "emojis" because the unicode numbers are duplicated
        // this is ok for what it's being used for
            unicodeToAscii = ns.objectFlip(ns.asciiList);

        str = str.replace(ns.regShortNames, function(shortname) {
            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
                // if the shortname doesnt exist just return the entire match
                return shortname;
            }
            else {
                unicode = ns.emojioneList[shortname].unicode[ns.emojioneList[shortname].unicode.length-1];
                if(typeof unicodeToAscii[unicode] !== 'undefined') {
                    return unicodeToAscii[unicode];
                } else {
                    return shortname;
                }
            }
        });
        return str;
    };

    // will output unicode from shortname
    // useful for sending emojis back to mobile devices
    ns.shortnameToUnicode = function(str) {
        // replace regular shortnames first
        var unicode,fname,uc;
        str = str.replace(ns.regShortNames, function(shortname) {
            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
                // if the shortname doesnt exist just return the entire match
                return shortname;
            }
            unicode = ns.emojioneList[shortname].unicode[0].toUpperCase();
            fname = ns.emojioneList[shortname].fname;
            uc = ns.emojioneList[shortname].uc;
            //return ns.convert(unicode);
            return ns.convert(uc);
        });

        // if ascii smileys are turned on, then we'll replace them!
        if (ns.ascii) {

            str = str.replace(ns.regAscii, function(entire, m1, m2, m3) {
                if( (typeof m3 === 'undefined') || (m3 === '') || (!(ns.unescapeHTML(m3) in ns.asciiList)) ) {
                    // if the shortname doesnt exist just return the entire match
                    return entire;
                }

                m3 = ns.unescapeHTML(m3);
                unicode = ns.asciiList[m3].toUpperCase();
                return m2+ns.convert(unicode);
            });
        }

        return str;
    };

    ns.shortnameToImage = function(str) {
        // replace regular shortnames first
        var replaceWith,unicode,alt,title;
        str = str.replace(ns.regShortNames, function(shortname) {
            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
                // if the shortname doesnt exist just return the entire match
                return shortname;
            }
            else {
                unicode = ns.emojioneList[shortname].unicode[ns.emojioneList[shortname].unicode.length-1];
                title = ns.imageTitleTag ? 'title="'+shortname+'"' : '';

                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : shortname;

                if(ns.imageType === 'png') {
                    if(ns.sprites) {
                        replaceWith = '<span class="emojione emojione-'+unicode+'" ' + title + '>'+alt+'</span>';
                    }
                    else {
                        replaceWith = '<img class="emojione" alt="'+alt+'" ' + title + ' src="'+ns.imagePathPNG+unicode+'.png'+ns.cacheBustParam+'"/>';
                    }
                }
                else {
                    // svg
                    if(ns.sprites) {
                        replaceWith = '<svg class="emojione"><description>'+alt+'</description><use xlink:href="'+ns.imagePathSVGSprites+'#emoji-'+unicode+'"></use></svg>';
                    }
                    else {
                        replaceWith = '<object class="emojione" data="'+ns.imagePathSVG+unicode+'.svg'+ns.cacheBustParam+'" type="image/svg+xml" standby="'+alt+'">'+alt+'</object>';
                    }
                }

                return replaceWith;
            }
        });

        // if ascii smileys are turned on, then we'll replace them!
        if (ns.ascii) {

            str = str.replace(ns.regAscii, function(entire, m1, m2, m3) {
                if( (typeof m3 === 'undefined') || (m3 === '') || (!(ns.unescapeHTML(m3) in ns.asciiList)) ) {
                    // if the ascii doesnt exist just return the entire match
                    return entire;
                }

                m3 = ns.unescapeHTML(m3);
                unicode = ns.asciiList[m3];
                title = ns.imageTitleTag ? 'title="'+ns.escapeHTML(m3)+'"' : '';

                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : ns.escapeHTML(m3);

                if(ns.imageType === 'png') {
                    if(ns.sprites) {
                        replaceWith = m2+'<span class="emojione emojione-'+unicode+'"  ' + title + '>'+alt+'</span>';
                    }
                    else {
                        replaceWith = m2+'<img class="emojione" alt="'+alt+'" ' + title + ' src="'+ns.imagePathPNG+unicode+'.png'+ns.cacheBustParam+'"/>';
                    }
                }
                else {
                    // svg
                    if(ns.sprites) {
                        replaceWith = '<svg class="emojione"><description>'+alt+'</description><use xlink:href="'+ns.imagePathSVGSprites+'#emoji-'+unicode+'"></use></svg>';
                    }
                    else {
                        replaceWith = m2+'<object class="emojione" data="'+ns.imagePathSVG+unicode+'.svg'+ns.cacheBustParam+'" type="image/svg+xml" standby="'+alt+'">'+alt+'</object>';
                    }
                }

                return replaceWith;
            });
        }

        return str;
    };

    ns.unicodeToImage = function(str) {

        var replaceWith,unicode,short,fname,alt,title;
        var mappedUnicode = ns.mapUnicodeToShort();
        str = str.replace(ns.regUnicode, function(unicodeChar) {
            if( (typeof unicodeChar === 'undefined') || (unicodeChar === '') || (!(unicodeChar in ns.jsEscapeMap)) ) {
                // if the unicodeChar doesnt exist just return the entire match
                return unicodeChar;
            }
            else {
                // get the unicode codepoint from the actual char
                unicode = ns.jsEscapeMap[unicodeChar];

                //then map to shortname and locate the filename
                short = mappedUnicode[unicode];
                fname = ns.emojioneList[short].fname;

                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : short;
                title = ns.imageTitleTag ? 'title="'+short+'"' : '';

                if(ns.imageType === 'png') {
                    if(ns.sprites) {
                        replaceWith = '<span class="emojione emojione-'+unicode+'" ' + title + '>'+alt+'</span>';
                    }
                    else {
                        replaceWith = '<img class="emojione" alt="'+alt+'" ' + title + ' src="'+ns.imagePathPNG+fname+'.png'+ns.cacheBustParam+'"/>';
                    }
                }
                else {
                    // svg
                    if(ns.sprites) {
                        replaceWith = '<svg class="emojione"><description>'+alt+'</description><use xlink:href="'+ns.imagePathSVGSprites+'#emoji-'+unicode+'"></use></svg>';
                    }
                    else {
                        replaceWith = '<img class="emojione" alt="'+alt+'" ' + title + ' src="'+ns.imagePathSVG+fname+'.svg'+ns.cacheBustParam+'"/>';
                    }
                }

                return replaceWith;
            }
        });

        return str;
    };

    // this is really just unicodeToShortname() but I opted for the shorthand name to match toImage()
    ns.toShort = function(str) {
        var find = ns.getUnicodeReplacementRegEx(),
            replacementList = ns.mapUnicodeCharactersToShort();
        return  ns.replaceAll(str, find,replacementList);
    };

    // for converting unicode code points and code pairs to their respective characters
    ns.convert = function(unicode) {
        if(unicode.indexOf("-") > -1) {
            var parts = [];
            var s = unicode.split('-');
            for(var i = 0; i < s.length; i++) {
                var part = parseInt(s[i], 16);
                if (part >= 0x10000 && part <= 0x10FFFF) {
                    var hi = Math.floor((part - 0x10000) / 0x400) + 0xD800;
                    var lo = ((part - 0x10000) % 0x400) + 0xDC00;
                    part = (String.fromCharCode(hi) + String.fromCharCode(lo));
                }
                else {
                    part = String.fromCharCode(part);
                }
                parts.push(part);
            }
            return parts.join('');
        }
        else {
            var s = parseInt(unicode, 16);
            if (s >= 0x10000 && s <= 0x10FFFF) {
                var hi = Math.floor((s - 0x10000) / 0x400) + 0xD800;
                var lo = ((s - 0x10000) % 0x400) + 0xDC00;
                return (String.fromCharCode(hi) + String.fromCharCode(lo));
            }
            else {
                return String.fromCharCode(s);
            }
        }
    };

    ns.escapeHTML = function (string) {
        var escaped = {
            '&' : '&amp;',
            '<' : '&lt;',
            '>' : '&gt;',
            '"' : '&quot;',
            '\'': '&#039;'
        };

        return string.replace(/[&<>"']/g, function (match) {
            return escaped[match];
        });
    };
    ns.unescapeHTML = function (string) {
        var unescaped = {
            '&amp;'  : '&',
            '&#38;'  : '&',
            '&#x26;' : '&',
            '&lt;'   : '<',
            '&#60;'  : '<',
            '&#x3C;' : '<',
            '&gt;'   : '>',
            '&#62;'  : '>',
            '&#x3E;' : '>',
            '&quot;' : '"',
            '&#34;'  : '"',
            '&#x22;' : '"',
            '&apos;' : '\'',
            '&#39;'  : '\'',
            '&#x27;' : '\''
        };

        return string.replace(/&(?:amp|#38|#x26|lt|#60|#x3C|gt|#62|#x3E|apos|#39|#x27|quot|#34|#x22);/ig, function (match) {
            return unescaped[match];
        });
    };

    ns.mapEmojioneList = function (addToMapStorage) {
        for (var shortname in ns.emojioneList) {
            if (!ns.emojioneList.hasOwnProperty(shortname)) { continue; }
            for (var i = 0, len = ns.emojioneList[shortname].unicode.length; i < len; i++) {
                var unicode = ns.emojioneList[shortname].unicode[i];
                addToMapStorage(unicode, shortname);
            }
        }
    };

    ns.mapUnicodeToShort = function() {
        if (!ns.memMapShortToUnicode) {
            ns.memMapShortToUnicode = {};
            ns.mapEmojioneList(function (unicode, shortname) {
                ns.memMapShortToUnicode[unicode] = shortname;
            });
        }
        return ns.memMapShortToUnicode;
    };

    ns.memoizeReplacement = function() {
        if (!ns.unicodeReplacementRegEx || !ns.memMapShortToUnicodeCharacters) {
            var unicodeList = [];
            ns.memMapShortToUnicodeCharacters = {};
            ns.mapEmojioneList(function (unicode, shortname) {
                var emojiCharacter = ns.convert(unicode);
                if(ns.emojioneList[shortname].isCanonical) {
                    ns.memMapShortToUnicodeCharacters[emojiCharacter] = shortname;
                }
                unicodeList.push(emojiCharacter);
            });
            ns.unicodeReplacementRegEx = unicodeList.join('|');
        }
    };

    ns.mapUnicodeCharactersToShort = function() {
        ns.memoizeReplacement();
        return ns.memMapShortToUnicodeCharacters;
    };

    ns.getUnicodeReplacementRegEx = function() {
        ns.memoizeReplacement();
        return ns.unicodeReplacementRegEx;
    };

    //reverse an object
    ns.objectFlip = function (obj) {
        var key, tmp_obj = {};

        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                tmp_obj[obj[key]] = key;
            }
        }

        return tmp_obj;
    };

    ns.escapeRegExp = function(string) {
        return string.replace(/[-[\]{}()*+?.,;:&\\^$#\s]/g, "\\$&");
    };

    ns.replaceAll = function(string, find, replacementList) {
        var escapedFind = ns.escapeRegExp(find);
        var search = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+escapedFind+")", "gi");

        // callback prevents replacing anything inside of these common html tags as well as between an <object></object> tag
        var replace = function(entire, m1) {
            return ((typeof m1 === 'undefined') || (m1 === '')) ? entire : replacementList[m1];
        };

        return string.replace(search,replace);
    };

}(this.emojione = this.emojione || {}));
if(true) module.exports = this.emojione;

/***/ }),
/* 923 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1003),
    createBaseEach = __webpack_require__(1014);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1006),
    isArguments = __webpack_require__(892),
    isArray = __webpack_require__(864),
    isBuffer = __webpack_require__(893),
    isIndex = __webpack_require__(882),
    isTypedArray = __webpack_require__(926);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1009),
    baseUnary = __webpack_require__(1010),
    nodeUtil = __webpack_require__(1011);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(330),
    isObject = __webpack_require__(114);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1016),
    baseMatchesProperty = __webpack_require__(1058),
    identity = __webpack_require__(896),
    isArray = __webpack_require__(864),
    property = __webpack_require__(1067);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1044),
    isObjectLike = __webpack_require__(331);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1045),
    arraySome = __webpack_require__(1048),
    cacheHas = __webpack_require__(1049);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(177);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 935 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(937),
    getSymbols = __webpack_require__(902),
    keys = __webpack_require__(871);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(901),
    isArray = __webpack_require__(864);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1053),
    Map = __webpack_require__(899),
    Promise = __webpack_require__(1054),
    Set = __webpack_require__(1055),
    WeakMap = __webpack_require__(1056),
    baseGetTag = __webpack_require__(330),
    toSource = __webpack_require__(930);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 941 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1065),
    hasPath = __webpack_require__(1066);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(944);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(925),
    baseKeysIn = __webpack_require__(1075),
    isArrayLike = __webpack_require__(874);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(901),
    getPrototype = __webpack_require__(905),
    getSymbols = __webpack_require__(902),
    stubArray = __webpack_require__(938);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(937),
    getSymbolsIn = __webpack_require__(946),
    keysIn = __webpack_require__(945);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 948 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1098),
    overRest = __webpack_require__(1101),
    setToString = __webpack_require__(1103);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pick = __webpack_require__(1108);

var _pick2 = _interopRequireDefault(_pick);

var _emojione = __webpack_require__(922);

var _emojione2 = _interopRequireDefault(_emojione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Emoji = function (_Component) {
  _inherits(Emoji, _Component);

  function Emoji() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Emoji);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Emoji.__proto__ || Object.getPrototypeOf(Emoji)).call.apply(_ref, [this].concat(args))), _this), _this._handleKeyUp = function (ev) {
      ev.preventDefault();
      if (ev.key === "Enter" || ev.key === " ") {
        _this._handleClick(ev);
      }
    }, _this._handleClick = function (ev) {
      _this.props.onSelect(ev, (0, _pick2.default)(_this.props, "shortname", "aliases", "aliases_ascii", "category", "name", "shortcode", "unicode", "unicode_alternates", "keywords"));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Emoji, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // avoid rerendering the Emoji component if the shortname hasn't changed
      return nextProps.shortname !== this.props.shortname;
    }
  }, {
    key: "createMarkup",
    value: function createMarkup() {
      return { __html: _emojione2.default.shortnameToImage(this.props.shortname) };
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", {
        onKeyUp: this._handleKeyUp,
        onClick: this._handleClick,
        tabIndex: "0",
        className: "emoji",
        "aria-label": this.props.ariaLabel,
        title: this.props.name,
        role: this.props.role,
        dangerouslySetInnerHTML: this.createMarkup()
      });
    }
  }]);

  return Emoji;
}(_react.Component);

Emoji.propTypes = {
  ariaLabel: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onSelect: _propTypes2.default.func.isRequired,
  shortname: _propTypes2.default.string,
  title: _propTypes2.default.string,
  role: _propTypes2.default.string
};
exports.default = Emoji;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultOverscanIndicesGetter;
var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 *
 * @param direction One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
 * @param cellCount Number of rows or columns in the current axis
 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
 * @param overscanCellsCount Maximum number of cells to over-render in either direction
 * @param startIndex Begin of range of visible cells
 * @param stopIndex End of range of visible cells
 */
function defaultOverscanIndicesGetter(_ref) {
  var direction = _ref.direction,
      cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  var overscanStartIndex = void 0;
  var overscanStopIndex = void 0;

  switch (scrollDirection) {
    case SCROLL_DIRECTION_FORWARD:
      overscanStartIndex = startIndex;
      overscanStopIndex = stopIndex + overscanCellsCount;
      break;
    case SCROLL_DIRECTION_BACKWARD:
      overscanStartIndex = startIndex - overscanCellsCount;
      overscanStopIndex = stopIndex;
      break;
  }

  return {
    overscanStartIndex: Math.max(0, overscanStartIndex),
    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
  };
}

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultCellRangeRenderer;

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      scrollLeft = _ref.scrollLeft,
      scrollTop = _ref.scrollTop,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var deferredMode = typeof deferredMeasurementCache !== 'undefined';

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMode && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1129);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shallowCompare
 */



var shallowEqual = __webpack_require__(125);

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.store = factory();
  }
}(this, function () {
	
	// Store.js
	var store = {},
		win = (typeof window != 'undefined' ? window : global),
		doc = win.document,
		localStorageName = 'localStorage',
		scriptTag = 'script',
		storage

	store.disabled = false
	store.version = '1.3.20'
	store.set = function(key, value) {}
	store.get = function(key, defaultVal) {}
	store.has = function(key) { return store.get(key) !== undefined }
	store.remove = function(key) {}
	store.clear = function() {}
	store.transact = function(key, defaultVal, transactionFn) {
		if (transactionFn == null) {
			transactionFn = defaultVal
			defaultVal = null
		}
		if (defaultVal == null) {
			defaultVal = {}
		}
		var val = store.get(key, defaultVal)
		transactionFn(val)
		store.set(key, val)
	}
	store.getAll = function() {}
	store.forEach = function() {}

	store.serialize = function(value) {
		return JSON.stringify(value)
	}
	store.deserialize = function(value) {
		if (typeof value != 'string') { return undefined }
		try { return JSON.parse(value) }
		catch(e) { return value || undefined }
	}

	// Functions to encapsulate questionable FireFox 3.6.13 behavior
	// when about.config::dom.storage.enabled === false
	// See https://github.com/marcuswestin/store.js/issues#issue/13
	function isLocalStorageNameSupported() {
		try { return (localStorageName in win && win[localStorageName]) }
		catch(err) { return false }
	}

	if (isLocalStorageNameSupported()) {
		storage = win[localStorageName]
		store.set = function(key, val) {
			if (val === undefined) { return store.remove(key) }
			storage.setItem(key, store.serialize(val))
			return val
		}
		store.get = function(key, defaultVal) {
			var val = store.deserialize(storage.getItem(key))
			return (val === undefined ? defaultVal : val)
		}
		store.remove = function(key) { storage.removeItem(key) }
		store.clear = function() { storage.clear() }
		store.getAll = function() {
			var ret = {}
			store.forEach(function(key, val) {
				ret[key] = val
			})
			return ret
		}
		store.forEach = function(callback) {
			for (var i=0; i<storage.length; i++) {
				var key = storage.key(i)
				callback(key, store.get(key))
			}
		}
	} else if (doc && doc.documentElement.addBehavior) {
		var storageOwner,
			storageContainer
		// Since #userData storage applies only to specific paths, we need to
		// somehow link our data to a specific path.  We choose /favicon.ico
		// as a pretty safe option, since all browsers already make a request to
		// this URL anyway and being a 404 will not hurt us here.  We wrap an
		// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
		// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
		// since the iframe access rules appear to allow direct access and
		// manipulation of the document element, even for a 404 page.  This
		// document can be used instead of the current document (which would
		// have been limited to the current path) to perform #userData storage.
		try {
			storageContainer = new ActiveXObject('htmlfile')
			storageContainer.open()
			storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
			storageContainer.close()
			storageOwner = storageContainer.w.frames[0].document
			storage = storageOwner.createElement('div')
		} catch(e) {
			// somehow ActiveXObject instantiation failed (perhaps some special
			// security settings or otherwse), fall back to per-path storage
			storage = doc.createElement('div')
			storageOwner = doc.body
		}
		var withIEStorage = function(storeFunction) {
			return function() {
				var args = Array.prototype.slice.call(arguments, 0)
				args.unshift(storage)
				// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
				// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
				storageOwner.appendChild(storage)
				storage.addBehavior('#default#userData')
				storage.load(localStorageName)
				var result = storeFunction.apply(store, args)
				storageOwner.removeChild(storage)
				return result
			}
		}

		// In IE7, keys cannot start with a digit or contain certain chars.
		// See https://github.com/marcuswestin/store.js/issues/40
		// See https://github.com/marcuswestin/store.js/issues/83
		var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
		var ieKeyFix = function(key) {
			return key.replace(/^d/, '___$&').replace(forbiddenCharsRegex, '___')
		}
		store.set = withIEStorage(function(storage, key, val) {
			key = ieKeyFix(key)
			if (val === undefined) { return store.remove(key) }
			storage.setAttribute(key, store.serialize(val))
			storage.save(localStorageName)
			return val
		})
		store.get = withIEStorage(function(storage, key, defaultVal) {
			key = ieKeyFix(key)
			var val = store.deserialize(storage.getAttribute(key))
			return (val === undefined ? defaultVal : val)
		})
		store.remove = withIEStorage(function(storage, key) {
			key = ieKeyFix(key)
			storage.removeAttribute(key)
			storage.save(localStorageName)
		})
		store.clear = withIEStorage(function(storage) {
			var attributes = storage.XMLDocument.documentElement.attributes
			storage.load(localStorageName)
			for (var i=attributes.length-1; i>=0; i--) {
				storage.removeAttribute(attributes[i].name)
			}
			storage.save(localStorageName)
		})
		store.getAll = function(storage) {
			var ret = {}
			store.forEach(function(key, val) {
				ret[key] = val
			})
			return ret
		}
		store.forEach = withIEStorage(function(storage, callback) {
			var attributes = storage.XMLDocument.documentElement.attributes
			for (var i=0, attr; attr=attributes[i]; ++i) {
				callback(attr.name, store.deserialize(storage.getAttribute(attr.name)))
			}
		})
	}

	try {
		var testKey = '__storejs__'
		store.set(testKey, testKey)
		if (store.get(testKey) != testKey) { store.disabled = true }
		store.remove(testKey)
	} catch(e) {
		store.disabled = true
	}
	store.enabled = !store.disabled
	
	return store
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1002);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(923),
    baseEach = __webpack_require__(924),
    castFunction = __webpack_require__(1015),
    isArray = __webpack_require__(864);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1004),
    keys = __webpack_require__(871);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1005);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(330),
    isObjectLike = __webpack_require__(331);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(330),
    isLength = __webpack_require__(894),
    isObjectLike = __webpack_require__(331);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(425);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(185)(module)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(895),
    nativeKeys = __webpack_require__(1013);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(927);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(874);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(896);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1017),
    getMatchData = __webpack_require__(1057),
    matchesStrictComparable = __webpack_require__(941);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(898),
    baseIsEqual = __webpack_require__(931);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(885);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(885);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(885);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(885);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(884);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1026 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(884),
    Map = __webpack_require__(899),
    MapCache = __webpack_require__(900);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(928),
    isMasked = __webpack_require__(1029),
    isObject = __webpack_require__(114),
    toSource = __webpack_require__(930);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1030);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(177);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1033),
    ListCache = __webpack_require__(884),
    Map = __webpack_require__(899);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1034),
    hashDelete = __webpack_require__(1035),
    hashGet = __webpack_require__(1036),
    hashHas = __webpack_require__(1037),
    hashSet = __webpack_require__(1038);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(887);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(887);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(887);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(887);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(888);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(888);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(888);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(888);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(898),
    equalArrays = __webpack_require__(932),
    equalByTag = __webpack_require__(1050),
    equalObjects = __webpack_require__(1051),
    getTag = __webpack_require__(939),
    isArray = __webpack_require__(864),
    isBuffer = __webpack_require__(893),
    isTypedArray = __webpack_require__(926);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(900),
    setCacheAdd = __webpack_require__(1046),
    setCacheHas = __webpack_require__(1047);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186),
    Uint8Array = __webpack_require__(933),
    eq = __webpack_require__(886),
    equalArrays = __webpack_require__(932),
    mapToArray = __webpack_require__(934),
    setToArray = __webpack_require__(935);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(936);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866),
    root = __webpack_require__(177);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866),
    root = __webpack_require__(177);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866),
    root = __webpack_require__(177);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(866),
    root = __webpack_require__(177);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(940),
    keys = __webpack_require__(871);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(931),
    get = __webpack_require__(1059),
    hasIn = __webpack_require__(942),
    isKey = __webpack_require__(903),
    isStrictComparable = __webpack_require__(940),
    matchesStrictComparable = __webpack_require__(941),
    toKey = __webpack_require__(873);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(889);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1061);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1062);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(900);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1064);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186),
    arrayMap = __webpack_require__(883),
    isArray = __webpack_require__(864),
    isSymbol = __webpack_require__(421);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(872),
    isArguments = __webpack_require__(892),
    isArray = __webpack_require__(864),
    isIndex = __webpack_require__(882),
    isLength = __webpack_require__(894),
    toKey = __webpack_require__(873);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1068),
    basePropertyDeep = __webpack_require__(1069),
    isKey = __webpack_require__(903),
    toKey = __webpack_require__(873);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(889);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(924),
    isArrayLike = __webpack_require__(874);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(883),
    baseClone = __webpack_require__(1072),
    baseUnset = __webpack_require__(1093),
    castPath = __webpack_require__(872),
    copyObject = __webpack_require__(875),
    customOmitClone = __webpack_require__(1096),
    flatRest = __webpack_require__(950),
    getAllKeysIn = __webpack_require__(947);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(898),
    arrayEach = __webpack_require__(923),
    assignValue = __webpack_require__(904),
    baseAssign = __webpack_require__(1073),
    baseAssignIn = __webpack_require__(1074),
    cloneBuffer = __webpack_require__(1077),
    copyArray = __webpack_require__(1078),
    copySymbols = __webpack_require__(1079),
    copySymbolsIn = __webpack_require__(1080),
    getAllKeys = __webpack_require__(936),
    getAllKeysIn = __webpack_require__(947),
    getTag = __webpack_require__(939),
    initCloneArray = __webpack_require__(1081),
    initCloneByTag = __webpack_require__(1082),
    initCloneObject = __webpack_require__(1091),
    isArray = __webpack_require__(864),
    isBuffer = __webpack_require__(893),
    isObject = __webpack_require__(114),
    keys = __webpack_require__(871);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(875),
    keys = __webpack_require__(871);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(875),
    keysIn = __webpack_require__(945);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114),
    isPrototype = __webpack_require__(895),
    nativeKeysIn = __webpack_require__(1076);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1076 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(177);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(185)(module)))

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(875),
    getSymbols = __webpack_require__(902);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(875),
    getSymbolsIn = __webpack_require__(946);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(906),
    cloneDataView = __webpack_require__(1083),
    cloneMap = __webpack_require__(1084),
    cloneRegExp = __webpack_require__(1086),
    cloneSet = __webpack_require__(1087),
    cloneSymbol = __webpack_require__(1089),
    cloneTypedArray = __webpack_require__(1090);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(906);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1085),
    arrayReduce = __webpack_require__(948),
    mapToArray = __webpack_require__(934);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1088),
    arrayReduce = __webpack_require__(948),
    setToArray = __webpack_require__(935);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(906);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1092),
    getPrototype = __webpack_require__(905),
    isPrototype = __webpack_require__(895);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(872),
    last = __webpack_require__(1094),
    parent = __webpack_require__(1095),
    toKey = __webpack_require__(873);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(889),
    baseSlice = __webpack_require__(949);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(1097);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(330),
    getPrototype = __webpack_require__(905),
    isObjectLike = __webpack_require__(331);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1099);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(901),
    isFlattenable = __webpack_require__(1100);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(186),
    isArguments = __webpack_require__(892),
    isArray = __webpack_require__(864);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1102);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1104),
    shortOut = __webpack_require__(1106);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1105),
    defineProperty = __webpack_require__(944),
    identity = __webpack_require__(896);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = {
	"100": {
		"unicode": "1f4af",
		"unicode_alt": "",
		"code_decimal": "&#128175;",
		"name": "hundred points symbol",
		"shortname": ":100:",
		"category": "symbols",
		"emoji_order": "2119",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"wow",
			"win",
			"perfect",
			"parties"
		]
	},
	"1234": {
		"unicode": "1f522",
		"unicode_alt": "",
		"code_decimal": "&#128290;",
		"name": "input symbol for numbers",
		"shortname": ":1234:",
		"category": "symbols",
		"emoji_order": "2122",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"grinning": {
		"unicode": "1f600",
		"unicode_alt": "",
		"code_decimal": "&#128512;",
		"name": "grinning face",
		"shortname": ":grinning:",
		"category": "people",
		"emoji_order": "1",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"smiley",
			"emotion"
		]
	},
	"grin": {
		"unicode": "1f601",
		"unicode_alt": "",
		"code_decimal": "&#128513;",
		"name": "grinning face with smiling eyes",
		"shortname": ":grin:",
		"category": "people",
		"emoji_order": "2",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"silly",
			"smiley",
			"emotion",
			"good",
			"selfie"
		]
	},
	"joy": {
		"unicode": "1f602",
		"unicode_alt": "",
		"code_decimal": "&#128514;",
		"name": "face with tears of joy",
		"shortname": ":joy:",
		"category": "people",
		"emoji_order": "3",
		"aliases": [],
		"aliases_ascii": [
			":')",
			":'-)"
		],
		"keywords": [
			"happy",
			"silly",
			"smiley",
			"cry",
			"laugh",
			"emotion",
			"sarcastic"
		]
	},
	"rofl": {
		"unicode": "1f923",
		"unicode_alt": "",
		"code_decimal": "&#129315;",
		"name": "rolling on the floor laughing",
		"shortname": ":rofl:",
		"category": "people",
		"emoji_order": "4",
		"aliases": [
			":rolling_on_the_floor_laughing:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"smiley": {
		"unicode": "1f603",
		"unicode_alt": "",
		"code_decimal": "&#128515;",
		"name": "smiling face with open mouth",
		"shortname": ":smiley:",
		"category": "people",
		"emoji_order": "5",
		"aliases": [],
		"aliases_ascii": [
			":D",
			":-D",
			"=D"
		],
		"keywords": [
			"happy",
			"smiley",
			"emotion",
			"good"
		]
	},
	"smile": {
		"unicode": "1f604",
		"unicode_alt": "",
		"code_decimal": "&#128516;",
		"name": "smiling face with open mouth and smiling eyes",
		"shortname": ":smile:",
		"category": "people",
		"emoji_order": "6",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"smiley",
			"emotion"
		]
	},
	"sweat_smile": {
		"unicode": "1f605",
		"unicode_alt": "",
		"code_decimal": "&#128517;",
		"name": "smiling face with open mouth and cold sweat",
		"shortname": ":sweat_smile:",
		"category": "people",
		"emoji_order": "7",
		"aliases": [],
		"aliases_ascii": [
			"':)",
			"':-)",
			"'=)",
			"':D",
			"':-D",
			"'=D"
		],
		"keywords": [
			"smiley",
			"workout",
			"sweat",
			"emotion"
		]
	},
	"laughing": {
		"unicode": "1f606",
		"unicode_alt": "",
		"code_decimal": "&#128518;",
		"name": "smiling face with open mouth and tightly-closed eyes",
		"shortname": ":laughing:",
		"category": "people",
		"emoji_order": "8",
		"aliases": [
			":satisfied:"
		],
		"aliases_ascii": [
			">:)",
			">;)",
			">:-)",
			">=)"
		],
		"keywords": [
			"happy",
			"smiley",
			"laugh",
			"emotion"
		]
	},
	"wink": {
		"unicode": "1f609",
		"unicode_alt": "",
		"code_decimal": "&#128521;",
		"name": "winking face",
		"shortname": ":wink:",
		"category": "people",
		"emoji_order": "9",
		"aliases": [],
		"aliases_ascii": [
			";)",
			";-)",
			"*-)",
			"*)",
			";-]",
			";]",
			";D",
			";^)"
		],
		"keywords": [
			"silly",
			"smiley",
			"emotion"
		]
	},
	"blush": {
		"unicode": "1f60a",
		"unicode_alt": "",
		"code_decimal": "&#128522;",
		"name": "smiling face with smiling eyes",
		"shortname": ":blush:",
		"category": "people",
		"emoji_order": "10",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"smiley",
			"emotion",
			"good",
			"beautiful"
		]
	},
	"yum": {
		"unicode": "1f60b",
		"unicode_alt": "",
		"code_decimal": "&#128523;",
		"name": "face savouring delicious food",
		"shortname": ":yum:",
		"category": "people",
		"emoji_order": "11",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"silly",
			"smiley",
			"emotion",
			"sarcastic",
			"good"
		]
	},
	"sunglasses": {
		"unicode": "1f60e",
		"unicode_alt": "",
		"code_decimal": "&#128526;",
		"name": "smiling face with sunglasses",
		"shortname": ":sunglasses:",
		"category": "people",
		"emoji_order": "12",
		"aliases": [],
		"aliases_ascii": [
			"B-)",
			"B)",
			"8)",
			"8-)",
			"B-D",
			"8-D"
		],
		"keywords": [
			"silly",
			"smiley",
			"emojione",
			"glasses",
			"boys night"
		]
	},
	"heart_eyes": {
		"unicode": "1f60d",
		"unicode_alt": "",
		"code_decimal": "&#128525;",
		"name": "smiling face with heart-shaped eyes",
		"shortname": ":heart_eyes:",
		"category": "people",
		"emoji_order": "13",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"smiley",
			"love",
			"sex",
			"heart eyes",
			"emotion",
			"beautiful"
		]
	},
	"kissing_heart": {
		"unicode": "1f618",
		"unicode_alt": "",
		"code_decimal": "&#128536;",
		"name": "face throwing a kiss",
		"shortname": ":kissing_heart:",
		"category": "people",
		"emoji_order": "14",
		"aliases": [],
		"aliases_ascii": [
			":*",
			":-*",
			"=*",
			":^*"
		],
		"keywords": [
			"smiley",
			"love",
			"sexy"
		]
	},
	"kissing": {
		"unicode": "1f617",
		"unicode_alt": "",
		"code_decimal": "&#128535;",
		"name": "kissing face",
		"shortname": ":kissing:",
		"category": "people",
		"emoji_order": "15",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"sexy"
		]
	},
	"kissing_smiling_eyes": {
		"unicode": "1f619",
		"unicode_alt": "",
		"code_decimal": "&#128537;",
		"name": "kissing face with smiling eyes",
		"shortname": ":kissing_smiling_eyes:",
		"category": "people",
		"emoji_order": "16",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"sexy"
		]
	},
	"kissing_closed_eyes": {
		"unicode": "1f61a",
		"unicode_alt": "",
		"code_decimal": "&#128538;",
		"name": "kissing face with closed eyes",
		"shortname": ":kissing_closed_eyes:",
		"category": "people",
		"emoji_order": "17",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"sexy"
		]
	},
	"relaxed": {
		"unicode": "263a",
		"unicode_alt": "263a-fe0f",
		"code_decimal": "&#9786;",
		"name": "white smiling face",
		"shortname": ":relaxed:",
		"category": "people",
		"emoji_order": "18",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"smiley"
		]
	},
	"slight_smile": {
		"unicode": "1f642",
		"unicode_alt": "",
		"code_decimal": "&#128578;",
		"name": "slightly smiling face",
		"shortname": ":slight_smile:",
		"category": "people",
		"emoji_order": "19",
		"aliases": [
			":slightly_smiling_face:"
		],
		"aliases_ascii": [
			":)",
			":-)",
			"=]",
			"=)",
			":]"
		],
		"keywords": [
			"happy",
			"smiley"
		]
	},
	"hugging": {
		"unicode": "1f917",
		"unicode_alt": "",
		"code_decimal": "&#129303;",
		"name": "hugging face",
		"shortname": ":hugging:",
		"category": "people",
		"emoji_order": "20",
		"aliases": [
			":hugging_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"hug",
			"thank you"
		]
	},
	"thinking": {
		"unicode": "1f914",
		"unicode_alt": "",
		"code_decimal": "&#129300;",
		"name": "thinking face",
		"shortname": ":thinking:",
		"category": "people",
		"emoji_order": "21",
		"aliases": [
			":thinking_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"thinking",
			"boys night"
		]
	},
	"neutral_face": {
		"unicode": "1f610",
		"unicode_alt": "",
		"code_decimal": "&#128528;",
		"name": "neutral face",
		"shortname": ":neutral_face:",
		"category": "people",
		"emoji_order": "22",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"mad",
			"smiley",
			"shrug",
			"neutral",
			"emotion"
		]
	},
	"expressionless": {
		"unicode": "1f611",
		"unicode_alt": "",
		"code_decimal": "&#128529;",
		"name": "expressionless face",
		"shortname": ":expressionless:",
		"category": "people",
		"emoji_order": "23",
		"aliases": [],
		"aliases_ascii": [
			"-_-",
			"-__-",
			"-___-"
		],
		"keywords": [
			"mad",
			"smiley",
			"neutral",
			"emotion"
		]
	},
	"no_mouth": {
		"unicode": "1f636",
		"unicode_alt": "",
		"code_decimal": "&#128566;",
		"name": "face without mouth",
		"shortname": ":no_mouth:",
		"category": "people",
		"emoji_order": "24",
		"aliases": [],
		"aliases_ascii": [
			":-X",
			":X",
			":-#",
			":#",
			"=X",
			"=x",
			":x",
			":-x",
			"=#"
		],
		"keywords": [
			"mad",
			"smiley",
			"neutral",
			"emotion"
		]
	},
	"rolling_eyes": {
		"unicode": "1f644",
		"unicode_alt": "",
		"code_decimal": "&#128580;",
		"name": "face with rolling eyes",
		"shortname": ":rolling_eyes:",
		"category": "people",
		"emoji_order": "25",
		"aliases": [
			":face_with_rolling_eyes:"
		],
		"aliases_ascii": [],
		"keywords": [
			"mad",
			"smiley",
			"rolling eyes",
			"emotion",
			"sarcastic"
		]
	},
	"smirk": {
		"unicode": "1f60f",
		"unicode_alt": "",
		"code_decimal": "&#128527;",
		"name": "smirking face",
		"shortname": ":smirk:",
		"category": "people",
		"emoji_order": "26",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"silly",
			"smiley",
			"sexy",
			"sarcastic"
		]
	},
	"persevere": {
		"unicode": "1f623",
		"unicode_alt": "",
		"code_decimal": "&#128547;",
		"name": "persevering face",
		"shortname": ":persevere:",
		"category": "people",
		"emoji_order": "27",
		"aliases": [],
		"aliases_ascii": [
			">.<"
		],
		"keywords": [
			"sad",
			"smiley",
			"angry",
			"emotion"
		]
	},
	"disappointed_relieved": {
		"unicode": "1f625",
		"unicode_alt": "",
		"code_decimal": "&#128549;",
		"name": "disappointed but relieved face",
		"shortname": ":disappointed_relieved:",
		"category": "people",
		"emoji_order": "28",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"stressed",
			"sweat",
			"cry",
			"emotion"
		]
	},
	"open_mouth": {
		"unicode": "1f62e",
		"unicode_alt": "",
		"code_decimal": "&#128558;",
		"name": "face with open mouth",
		"shortname": ":open_mouth:",
		"category": "people",
		"emoji_order": "29",
		"aliases": [],
		"aliases_ascii": [
			":-O",
			":O",
			":-o",
			":o",
			"O_O",
			">:O"
		],
		"keywords": [
			"smiley",
			"surprised",
			"wow",
			"emotion"
		]
	},
	"zipper_mouth": {
		"unicode": "1f910",
		"unicode_alt": "",
		"code_decimal": "&#129296;",
		"name": "zipper-mouth face",
		"shortname": ":zipper_mouth:",
		"category": "people",
		"emoji_order": "30",
		"aliases": [
			":zipper_mouth_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"mad",
			"smiley"
		]
	},
	"hushed": {
		"unicode": "1f62f",
		"unicode_alt": "",
		"code_decimal": "&#128559;",
		"name": "hushed face",
		"shortname": ":hushed:",
		"category": "people",
		"emoji_order": "31",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"surprised",
			"wow"
		]
	},
	"sleepy": {
		"unicode": "1f62a",
		"unicode_alt": "",
		"code_decimal": "&#128554;",
		"name": "sleepy face",
		"shortname": ":sleepy:",
		"category": "people",
		"emoji_order": "32",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"sick",
			"emotion"
		]
	},
	"tired_face": {
		"unicode": "1f62b",
		"unicode_alt": "",
		"code_decimal": "&#128555;",
		"name": "tired face",
		"shortname": ":tired_face:",
		"category": "people",
		"emoji_order": "33",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"tired",
			"emotion"
		]
	},
	"sleeping": {
		"unicode": "1f634",
		"unicode_alt": "",
		"code_decimal": "&#128564;",
		"name": "sleeping face",
		"shortname": ":sleeping:",
		"category": "people",
		"emoji_order": "34",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"tired",
			"emotion",
			"goodnight"
		]
	},
	"relieved": {
		"unicode": "1f60c",
		"unicode_alt": "",
		"code_decimal": "&#128524;",
		"name": "relieved face",
		"shortname": ":relieved:",
		"category": "people",
		"emoji_order": "35",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"emotion"
		]
	},
	"nerd": {
		"unicode": "1f913",
		"unicode_alt": "",
		"code_decimal": "&#129299;",
		"name": "nerd face",
		"shortname": ":nerd:",
		"category": "people",
		"emoji_order": "36",
		"aliases": [
			":nerd_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"glasses"
		]
	},
	"stuck_out_tongue": {
		"unicode": "1f61b",
		"unicode_alt": "",
		"code_decimal": "&#128539;",
		"name": "face with stuck-out tongue",
		"shortname": ":stuck_out_tongue:",
		"category": "people",
		"emoji_order": "37",
		"aliases": [],
		"aliases_ascii": [
			":P",
			":-P",
			"=P",
			":-p",
			":p",
			"=p",
			":-Þ",
			":Þ",
			":þ",
			":-þ",
			":-b",
			":b",
			"d:"
		],
		"keywords": [
			"smiley",
			"sex",
			"emotion"
		]
	},
	"stuck_out_tongue_winking_eye": {
		"unicode": "1f61c",
		"unicode_alt": "",
		"code_decimal": "&#128540;",
		"name": "face with stuck-out tongue and winking eye",
		"shortname": ":stuck_out_tongue_winking_eye:",
		"category": "people",
		"emoji_order": "38",
		"aliases": [],
		"aliases_ascii": [
			">:P",
			"X-P",
			"x-p"
		],
		"keywords": [
			"happy",
			"smiley",
			"emotion",
			"parties"
		]
	},
	"stuck_out_tongue_closed_eyes": {
		"unicode": "1f61d",
		"unicode_alt": "",
		"code_decimal": "&#128541;",
		"name": "face with stuck-out tongue and tightly-closed eyes",
		"shortname": ":stuck_out_tongue_closed_eyes:",
		"category": "people",
		"emoji_order": "39",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"smiley",
			"emotion"
		]
	},
	"drooling_face": {
		"unicode": "1f924",
		"unicode_alt": "",
		"code_decimal": "&#129316;",
		"name": "drooling face",
		"shortname": ":drooling_face:",
		"category": "people",
		"emoji_order": "40",
		"aliases": [
			":drool:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"unamused": {
		"unicode": "1f612",
		"unicode_alt": "",
		"code_decimal": "&#128530;",
		"name": "unamused face",
		"shortname": ":unamused:",
		"category": "people",
		"emoji_order": "41",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"mad",
			"smiley",
			"tired",
			"emotion"
		]
	},
	"sweat": {
		"unicode": "1f613",
		"unicode_alt": "",
		"code_decimal": "&#128531;",
		"name": "face with cold sweat",
		"shortname": ":sweat:",
		"category": "people",
		"emoji_order": "42",
		"aliases": [],
		"aliases_ascii": [
			"':(",
			"':-(",
			"'=("
		],
		"keywords": [
			"sad",
			"smiley",
			"stressed",
			"sweat",
			"emotion"
		]
	},
	"pensive": {
		"unicode": "1f614",
		"unicode_alt": "",
		"code_decimal": "&#128532;",
		"name": "pensive face",
		"shortname": ":pensive:",
		"category": "people",
		"emoji_order": "43",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"emotion",
			"rip"
		]
	},
	"confused": {
		"unicode": "1f615",
		"unicode_alt": "",
		"code_decimal": "&#128533;",
		"name": "confused face",
		"shortname": ":confused:",
		"category": "people",
		"emoji_order": "44",
		"aliases": [],
		"aliases_ascii": [
			">:\\",
			">:/",
			":-/",
			":-.",
			":/",
			":\\",
			"=/",
			"=\\",
			":L",
			"=L"
		],
		"keywords": [
			"smiley",
			"surprised",
			"emotion"
		]
	},
	"upside_down": {
		"unicode": "1f643",
		"unicode_alt": "",
		"code_decimal": "&#128579;",
		"name": "upside-down face",
		"shortname": ":upside_down:",
		"category": "people",
		"emoji_order": "45",
		"aliases": [
			":upside_down_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"silly",
			"smiley",
			"sarcastic"
		]
	},
	"money_mouth": {
		"unicode": "1f911",
		"unicode_alt": "",
		"code_decimal": "&#129297;",
		"name": "money-mouth face",
		"shortname": ":money_mouth:",
		"category": "people",
		"emoji_order": "46",
		"aliases": [
			":money_mouth_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"win",
			"money",
			"emotion",
			"boys night"
		]
	},
	"astonished": {
		"unicode": "1f632",
		"unicode_alt": "",
		"code_decimal": "&#128562;",
		"name": "astonished face",
		"shortname": ":astonished:",
		"category": "people",
		"emoji_order": "47",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"surprised",
			"wow",
			"emotion",
			"omg"
		]
	},
	"frowning2": {
		"unicode": "2639",
		"unicode_alt": "2639-fe0f",
		"code_decimal": "&#9785;",
		"name": "white frowning face",
		"shortname": ":frowning2:",
		"category": "people",
		"emoji_order": "48",
		"aliases": [
			":white_frowning_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"emotion"
		]
	},
	"slight_frown": {
		"unicode": "1f641",
		"unicode_alt": "",
		"code_decimal": "&#128577;",
		"name": "slightly frowning face",
		"shortname": ":slight_frown:",
		"category": "people",
		"emoji_order": "49",
		"aliases": [
			":slightly_frowning_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"emotion"
		]
	},
	"confounded": {
		"unicode": "1f616",
		"unicode_alt": "",
		"code_decimal": "&#128534;",
		"name": "confounded face",
		"shortname": ":confounded:",
		"category": "people",
		"emoji_order": "50",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"angry",
			"emotion"
		]
	},
	"disappointed": {
		"unicode": "1f61e",
		"unicode_alt": "",
		"code_decimal": "&#128542;",
		"name": "disappointed face",
		"shortname": ":disappointed:",
		"category": "people",
		"emoji_order": "51",
		"aliases": [],
		"aliases_ascii": [
			">:[",
			":-(",
			":(",
			":-[",
			":[",
			"=("
		],
		"keywords": [
			"sad",
			"smiley",
			"tired",
			"emotion"
		]
	},
	"worried": {
		"unicode": "1f61f",
		"unicode_alt": "",
		"code_decimal": "&#128543;",
		"name": "worried face",
		"shortname": ":worried:",
		"category": "people",
		"emoji_order": "52",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"emotion"
		]
	},
	"triumph": {
		"unicode": "1f624",
		"unicode_alt": "",
		"code_decimal": "&#128548;",
		"name": "face with look of triumph",
		"shortname": ":triumph:",
		"category": "people",
		"emoji_order": "53",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"mad",
			"smiley",
			"angry",
			"emotion",
			"steam"
		]
	},
	"cry": {
		"unicode": "1f622",
		"unicode_alt": "",
		"code_decimal": "&#128546;",
		"name": "crying face",
		"shortname": ":cry:",
		"category": "people",
		"emoji_order": "54",
		"aliases": [],
		"aliases_ascii": [
			":'(",
			":'-(",
			";(",
			";-("
		],
		"keywords": [
			"sad",
			"smiley",
			"cry",
			"emotion",
			"rip",
			"heartbreak"
		]
	},
	"sob": {
		"unicode": "1f62d",
		"unicode_alt": "",
		"code_decimal": "&#128557;",
		"name": "loudly crying face",
		"shortname": ":sob:",
		"category": "people",
		"emoji_order": "55",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"cry",
			"emotion",
			"heartbreak"
		]
	},
	"frowning": {
		"unicode": "1f626",
		"unicode_alt": "",
		"code_decimal": "&#128550;",
		"name": "frowning face with open mouth",
		"shortname": ":frowning:",
		"category": "people",
		"emoji_order": "56",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"surprised",
			"emotion"
		]
	},
	"anguished": {
		"unicode": "1f627",
		"unicode_alt": "",
		"code_decimal": "&#128551;",
		"name": "anguished face",
		"shortname": ":anguished:",
		"category": "people",
		"emoji_order": "57",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"surprised",
			"emotion"
		]
	},
	"fearful": {
		"unicode": "1f628",
		"unicode_alt": "",
		"code_decimal": "&#128552;",
		"name": "fearful face",
		"shortname": ":fearful:",
		"category": "people",
		"emoji_order": "58",
		"aliases": [],
		"aliases_ascii": [
			"D:"
		],
		"keywords": [
			"smiley",
			"surprised",
			"emotion"
		]
	},
	"weary": {
		"unicode": "1f629",
		"unicode_alt": "",
		"code_decimal": "&#128553;",
		"name": "weary face",
		"shortname": ":weary:",
		"category": "people",
		"emoji_order": "59",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sad",
			"smiley",
			"tired",
			"stressed",
			"emotion"
		]
	},
	"grimacing": {
		"unicode": "1f62c",
		"unicode_alt": "",
		"code_decimal": "&#128556;",
		"name": "grimacing face",
		"shortname": ":grimacing:",
		"category": "people",
		"emoji_order": "60",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"silly",
			"smiley",
			"emotion",
			"selfie"
		]
	},
	"cold_sweat": {
		"unicode": "1f630",
		"unicode_alt": "",
		"code_decimal": "&#128560;",
		"name": "face with open mouth and cold sweat",
		"shortname": ":cold_sweat:",
		"category": "people",
		"emoji_order": "61",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"sweat",
			"emotion"
		]
	},
	"scream": {
		"unicode": "1f631",
		"unicode_alt": "",
		"code_decimal": "&#128561;",
		"name": "face screaming in fear",
		"shortname": ":scream:",
		"category": "people",
		"emoji_order": "62",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"surprised",
			"wow",
			"emotion",
			"omg"
		]
	},
	"flushed": {
		"unicode": "1f633",
		"unicode_alt": "",
		"code_decimal": "&#128563;",
		"name": "flushed face",
		"shortname": ":flushed:",
		"category": "people",
		"emoji_order": "63",
		"aliases": [],
		"aliases_ascii": [
			":$",
			"=$"
		],
		"keywords": [
			"smiley",
			"emotion",
			"omg"
		]
	},
	"dizzy_face": {
		"unicode": "1f635",
		"unicode_alt": "",
		"code_decimal": "&#128565;",
		"name": "dizzy face",
		"shortname": ":dizzy_face:",
		"category": "people",
		"emoji_order": "64",
		"aliases": [],
		"aliases_ascii": [
			"#-)",
			"#)",
			"%-)",
			"%)",
			"X)",
			"X-)"
		],
		"keywords": [
			"smiley",
			"surprised",
			"dead",
			"wow",
			"emotion",
			"omg"
		]
	},
	"rage": {
		"unicode": "1f621",
		"unicode_alt": "",
		"code_decimal": "&#128545;",
		"name": "pouting face",
		"shortname": ":rage:",
		"category": "people",
		"emoji_order": "65",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"mad",
			"smiley",
			"angry",
			"emotion"
		]
	},
	"angry": {
		"unicode": "1f620",
		"unicode_alt": "",
		"code_decimal": "&#128544;",
		"name": "angry face",
		"shortname": ":angry:",
		"category": "people",
		"emoji_order": "66",
		"aliases": [],
		"aliases_ascii": [
			">:(",
			">:-(",
			":@"
		],
		"keywords": [
			"mad",
			"smiley",
			"emotion"
		]
	},
	"innocent": {
		"unicode": "1f607",
		"unicode_alt": "",
		"code_decimal": "&#128519;",
		"name": "smiling face with halo",
		"shortname": ":innocent:",
		"category": "people",
		"emoji_order": "67",
		"aliases": [],
		"aliases_ascii": [
			"O:-)",
			"0:-3",
			"0:3",
			"0:-)",
			"0:)",
			"0;^)",
			"O:)",
			"O;-)",
			"O=)",
			"0;-)",
			"O:-3",
			"O:3"
		],
		"keywords": [
			"smiley",
			"emotion"
		]
	},
	"cowboy": {
		"unicode": "1f920",
		"unicode_alt": "",
		"code_decimal": "&#129312;",
		"name": "face with cowboy hat",
		"shortname": ":cowboy:",
		"category": "people",
		"emoji_order": "68",
		"aliases": [
			":face_with_cowboy_hat:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"clown": {
		"unicode": "1f921",
		"unicode_alt": "",
		"code_decimal": "&#129313;",
		"name": "clown face",
		"shortname": ":clown:",
		"category": "people",
		"emoji_order": "69",
		"aliases": [
			":clown_face:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"lying_face": {
		"unicode": "1f925",
		"unicode_alt": "",
		"code_decimal": "&#129317;",
		"name": "lying face",
		"shortname": ":lying_face:",
		"category": "people",
		"emoji_order": "70",
		"aliases": [
			":liar:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mask": {
		"unicode": "1f637",
		"unicode_alt": "",
		"code_decimal": "&#128567;",
		"name": "face with medical mask",
		"shortname": ":mask:",
		"category": "people",
		"emoji_order": "71",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"dead",
			"health",
			"sick"
		]
	},
	"thermometer_face": {
		"unicode": "1f912",
		"unicode_alt": "",
		"code_decimal": "&#129298;",
		"name": "face with thermometer",
		"shortname": ":thermometer_face:",
		"category": "people",
		"emoji_order": "72",
		"aliases": [
			":face_with_thermometer:"
		],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"health",
			"sick",
			"emotion"
		]
	},
	"head_bandage": {
		"unicode": "1f915",
		"unicode_alt": "",
		"code_decimal": "&#129301;",
		"name": "face with head-bandage",
		"shortname": ":head_bandage:",
		"category": "people",
		"emoji_order": "73",
		"aliases": [
			":face_with_head_bandage:"
		],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"health",
			"sick",
			"emotion"
		]
	},
	"nauseated_face": {
		"unicode": "1f922",
		"unicode_alt": "",
		"code_decimal": "&#129314;",
		"name": "nauseated face",
		"shortname": ":nauseated_face:",
		"category": "people",
		"emoji_order": "74",
		"aliases": [
			":sick:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"sneezing_face": {
		"unicode": "1f927",
		"unicode_alt": "",
		"code_decimal": "&#129319;",
		"name": "sneezing face",
		"shortname": ":sneezing_face:",
		"category": "people",
		"emoji_order": "75",
		"aliases": [
			":sneeze:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"smiling_imp": {
		"unicode": "1f608",
		"unicode_alt": "",
		"code_decimal": "&#128520;",
		"name": "smiling face with horns",
		"shortname": ":smiling_imp:",
		"category": "people",
		"emoji_order": "76",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"silly",
			"smiley",
			"angry",
			"monster",
			"devil",
			"boys night"
		]
	},
	"imp": {
		"unicode": "1f47f",
		"unicode_alt": "",
		"code_decimal": "&#128127;",
		"name": "imp",
		"shortname": ":imp:",
		"category": "people",
		"emoji_order": "77",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"smiley",
			"monster",
			"devil",
			"wth"
		]
	},
	"japanese_ogre": {
		"unicode": "1f479",
		"unicode_alt": "",
		"code_decimal": "&#128121;",
		"name": "japanese ogre",
		"shortname": ":japanese_ogre:",
		"category": "people",
		"emoji_order": "78",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"monster"
		]
	},
	"japanese_goblin": {
		"unicode": "1f47a",
		"unicode_alt": "",
		"code_decimal": "&#128122;",
		"name": "japanese goblin",
		"shortname": ":japanese_goblin:",
		"category": "people",
		"emoji_order": "79",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"angry",
			"monster"
		]
	},
	"skull": {
		"unicode": "1f480",
		"unicode_alt": "",
		"code_decimal": "&#128128;",
		"name": "skull",
		"shortname": ":skull:",
		"category": "people",
		"emoji_order": "80",
		"aliases": [
			":skeleton:"
		],
		"aliases_ascii": [],
		"keywords": [
			"dead",
			"halloween",
			"skull"
		]
	},
	"skull_crossbones": {
		"unicode": "2620",
		"unicode_alt": "2620-fe0f",
		"code_decimal": "&#9760;",
		"name": "skull and crossbones",
		"shortname": ":skull_crossbones:",
		"category": "objects",
		"emoji_order": "81",
		"aliases": [
			":skull_and_crossbones:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"dead",
			"skull"
		]
	},
	"ghost": {
		"unicode": "1f47b",
		"unicode_alt": "",
		"code_decimal": "&#128123;",
		"name": "ghost",
		"shortname": ":ghost:",
		"category": "people",
		"emoji_order": "82",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"holidays",
			"halloween",
			"monster"
		]
	},
	"alien": {
		"unicode": "1f47d",
		"unicode_alt": "",
		"code_decimal": "&#128125;",
		"name": "extraterrestrial alien",
		"shortname": ":alien:",
		"category": "people",
		"emoji_order": "83",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"monster",
			"alien",
			"scientology"
		]
	},
	"space_invader": {
		"unicode": "1f47e",
		"unicode_alt": "",
		"code_decimal": "&#128126;",
		"name": "alien monster",
		"shortname": ":space_invader:",
		"category": "activity",
		"emoji_order": "84",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"monster",
			"alien"
		]
	},
	"robot": {
		"unicode": "1f916",
		"unicode_alt": "",
		"code_decimal": "&#129302;",
		"name": "robot face",
		"shortname": ":robot:",
		"category": "people",
		"emoji_order": "85",
		"aliases": [
			":robot_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"monster",
			"robot"
		]
	},
	"poop": {
		"unicode": "1f4a9",
		"unicode_alt": "",
		"code_decimal": "&#128169;",
		"name": "pile of poo",
		"shortname": ":poop:",
		"category": "people",
		"emoji_order": "86",
		"aliases": [
			":shit:",
			":hankey:",
			":poo:"
		],
		"aliases_ascii": [],
		"keywords": [
			"bathroom",
			"shit",
			"sol",
			"diarrhea"
		]
	},
	"smiley_cat": {
		"unicode": "1f63a",
		"unicode_alt": "",
		"code_decimal": "&#128570;",
		"name": "smiling cat face with open mouth",
		"shortname": ":smiley_cat:",
		"category": "people",
		"emoji_order": "87",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"cat",
			"animal"
		]
	},
	"smile_cat": {
		"unicode": "1f638",
		"unicode_alt": "",
		"code_decimal": "&#128568;",
		"name": "grinning cat face with smiling eyes",
		"shortname": ":smile_cat:",
		"category": "people",
		"emoji_order": "88",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"cat",
			"animal"
		]
	},
	"joy_cat": {
		"unicode": "1f639",
		"unicode_alt": "",
		"code_decimal": "&#128569;",
		"name": "cat face with tears of joy",
		"shortname": ":joy_cat:",
		"category": "people",
		"emoji_order": "89",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"happy",
			"silly",
			"cry",
			"laugh",
			"cat",
			"animal",
			"sarcastic"
		]
	},
	"heart_eyes_cat": {
		"unicode": "1f63b",
		"unicode_alt": "",
		"code_decimal": "&#128571;",
		"name": "smiling cat face with heart-shaped eyes",
		"shortname": ":heart_eyes_cat:",
		"category": "people",
		"emoji_order": "90",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"heart eyes",
			"cat",
			"animal",
			"beautiful"
		]
	},
	"smirk_cat": {
		"unicode": "1f63c",
		"unicode_alt": "",
		"code_decimal": "&#128572;",
		"name": "cat face with wry smile",
		"shortname": ":smirk_cat:",
		"category": "people",
		"emoji_order": "91",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cat",
			"animal"
		]
	},
	"kissing_cat": {
		"unicode": "1f63d",
		"unicode_alt": "",
		"code_decimal": "&#128573;",
		"name": "kissing cat face with closed eyes",
		"shortname": ":kissing_cat:",
		"category": "people",
		"emoji_order": "92",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cat",
			"animal"
		]
	},
	"scream_cat": {
		"unicode": "1f640",
		"unicode_alt": "",
		"code_decimal": "&#128576;",
		"name": "weary cat face",
		"shortname": ":scream_cat:",
		"category": "people",
		"emoji_order": "93",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cat",
			"animal"
		]
	},
	"crying_cat_face": {
		"unicode": "1f63f",
		"unicode_alt": "",
		"code_decimal": "&#128575;",
		"name": "crying cat face",
		"shortname": ":crying_cat_face:",
		"category": "people",
		"emoji_order": "94",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cry",
			"cat",
			"animal"
		]
	},
	"pouting_cat": {
		"unicode": "1f63e",
		"unicode_alt": "",
		"code_decimal": "&#128574;",
		"name": "pouting cat face",
		"shortname": ":pouting_cat:",
		"category": "people",
		"emoji_order": "95",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cat",
			"animal"
		]
	},
	"see_no_evil": {
		"unicode": "1f648",
		"unicode_alt": "",
		"code_decimal": "&#128584;",
		"name": "see-no-evil monkey",
		"shortname": ":see_no_evil:",
		"category": "nature",
		"emoji_order": "96",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"hear_no_evil": {
		"unicode": "1f649",
		"unicode_alt": "",
		"code_decimal": "&#128585;",
		"name": "hear-no-evil monkey",
		"shortname": ":hear_no_evil:",
		"category": "nature",
		"emoji_order": "97",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"speak_no_evil": {
		"unicode": "1f64a",
		"unicode_alt": "",
		"code_decimal": "&#128586;",
		"name": "speak-no-evil monkey",
		"shortname": ":speak_no_evil:",
		"category": "nature",
		"emoji_order": "98",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"boy": {
		"unicode": "1f466",
		"unicode_alt": "",
		"code_decimal": "&#128102;",
		"name": "boy",
		"shortname": ":boy:",
		"category": "people",
		"emoji_order": "99",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"baby",
			"diversity"
		]
	},
	"boy_tone1": {
		"unicode": "1f466-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128102;&#127995;",
		"name": "boy tone 1",
		"shortname": ":boy_tone1:",
		"category": "people",
		"emoji_order": "100",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"boy_tone2": {
		"unicode": "1f466-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128102;&#127996;",
		"name": "boy tone 2",
		"shortname": ":boy_tone2:",
		"category": "people",
		"emoji_order": "101",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"boy_tone3": {
		"unicode": "1f466-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128102;&#127997;",
		"name": "boy tone 3",
		"shortname": ":boy_tone3:",
		"category": "people",
		"emoji_order": "102",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"boy_tone4": {
		"unicode": "1f466-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128102;&#127998;",
		"name": "boy tone 4",
		"shortname": ":boy_tone4:",
		"category": "people",
		"emoji_order": "103",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"boy_tone5": {
		"unicode": "1f466-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128102;&#127999;",
		"name": "boy tone 5",
		"shortname": ":boy_tone5:",
		"category": "people",
		"emoji_order": "104",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"girl": {
		"unicode": "1f467",
		"unicode_alt": "",
		"code_decimal": "&#128103;",
		"name": "girl",
		"shortname": ":girl:",
		"category": "people",
		"emoji_order": "105",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"baby",
			"diversity"
		]
	},
	"girl_tone1": {
		"unicode": "1f467-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128103;&#127995;",
		"name": "girl tone 1",
		"shortname": ":girl_tone1:",
		"category": "people",
		"emoji_order": "106",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"girl_tone2": {
		"unicode": "1f467-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128103;&#127996;",
		"name": "girl tone 2",
		"shortname": ":girl_tone2:",
		"category": "people",
		"emoji_order": "107",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"girl_tone3": {
		"unicode": "1f467-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128103;&#127997;",
		"name": "girl tone 3",
		"shortname": ":girl_tone3:",
		"category": "people",
		"emoji_order": "108",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"girl_tone4": {
		"unicode": "1f467-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128103;&#127998;",
		"name": "girl tone 4",
		"shortname": ":girl_tone4:",
		"category": "people",
		"emoji_order": "109",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"girl_tone5": {
		"unicode": "1f467-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128103;&#127999;",
		"name": "girl tone 5",
		"shortname": ":girl_tone5:",
		"category": "people",
		"emoji_order": "110",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man": {
		"unicode": "1f468",
		"unicode_alt": "",
		"code_decimal": "&#128104;",
		"name": "man",
		"shortname": ":man:",
		"category": "people",
		"emoji_order": "111",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"men",
			"sex",
			"diversity",
			"selfie",
			"boys night"
		]
	},
	"man_tone1": {
		"unicode": "1f468-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128104;&#127995;",
		"name": "man tone 1",
		"shortname": ":man_tone1:",
		"category": "people",
		"emoji_order": "112",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_tone2": {
		"unicode": "1f468-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128104;&#127996;",
		"name": "man tone 2",
		"shortname": ":man_tone2:",
		"category": "people",
		"emoji_order": "113",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_tone3": {
		"unicode": "1f468-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128104;&#127997;",
		"name": "man tone 3",
		"shortname": ":man_tone3:",
		"category": "people",
		"emoji_order": "114",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_tone4": {
		"unicode": "1f468-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128104;&#127998;",
		"name": "man tone 4",
		"shortname": ":man_tone4:",
		"category": "people",
		"emoji_order": "115",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_tone5": {
		"unicode": "1f468-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128104;&#127999;",
		"name": "man tone 5",
		"shortname": ":man_tone5:",
		"category": "people",
		"emoji_order": "116",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"woman": {
		"unicode": "1f469",
		"unicode_alt": "",
		"code_decimal": "&#128105;",
		"name": "woman",
		"shortname": ":woman:",
		"category": "people",
		"emoji_order": "117",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"sex",
			"diversity",
			"feminist",
			"selfie",
			"girls night"
		]
	},
	"woman_tone1": {
		"unicode": "1f469-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128105;&#127995;",
		"name": "woman tone 1",
		"shortname": ":woman_tone1:",
		"category": "people",
		"emoji_order": "118",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"woman_tone2": {
		"unicode": "1f469-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128105;&#127996;",
		"name": "woman tone 2",
		"shortname": ":woman_tone2:",
		"category": "people",
		"emoji_order": "119",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"woman_tone3": {
		"unicode": "1f469-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128105;&#127997;",
		"name": "woman tone 3",
		"shortname": ":woman_tone3:",
		"category": "people",
		"emoji_order": "120",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"woman_tone4": {
		"unicode": "1f469-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128105;&#127998;",
		"name": "woman tone 4",
		"shortname": ":woman_tone4:",
		"category": "people",
		"emoji_order": "121",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"woman_tone5": {
		"unicode": "1f469-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128105;&#127999;",
		"name": "woman tone 5",
		"shortname": ":woman_tone5:",
		"category": "people",
		"emoji_order": "122",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_man": {
		"unicode": "1f474",
		"unicode_alt": "",
		"code_decimal": "&#128116;",
		"name": "older man",
		"shortname": ":older_man:",
		"category": "people",
		"emoji_order": "123",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"men",
			"old people",
			"diversity"
		]
	},
	"older_man_tone1": {
		"unicode": "1f474-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128116;&#127995;",
		"name": "older man tone 1",
		"shortname": ":older_man_tone1:",
		"category": "people",
		"emoji_order": "124",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_man_tone2": {
		"unicode": "1f474-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128116;&#127996;",
		"name": "older man tone 2",
		"shortname": ":older_man_tone2:",
		"category": "people",
		"emoji_order": "125",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_man_tone3": {
		"unicode": "1f474-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128116;&#127997;",
		"name": "older man tone 3",
		"shortname": ":older_man_tone3:",
		"category": "people",
		"emoji_order": "126",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_man_tone4": {
		"unicode": "1f474-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128116;&#127998;",
		"name": "older man tone 4",
		"shortname": ":older_man_tone4:",
		"category": "people",
		"emoji_order": "127",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_man_tone5": {
		"unicode": "1f474-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128116;&#127999;",
		"name": "older man tone 5",
		"shortname": ":older_man_tone5:",
		"category": "people",
		"emoji_order": "128",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_woman": {
		"unicode": "1f475",
		"unicode_alt": "",
		"code_decimal": "&#128117;",
		"name": "older woman",
		"shortname": ":older_woman:",
		"category": "people",
		"emoji_order": "129",
		"aliases": [
			":grandma:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"old people",
			"diversity"
		]
	},
	"older_woman_tone1": {
		"unicode": "1f475-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128117;&#127995;",
		"name": "older woman tone 1",
		"shortname": ":older_woman_tone1:",
		"category": "people",
		"emoji_order": "130",
		"aliases": [
			":grandma_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_woman_tone2": {
		"unicode": "1f475-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128117;&#127996;",
		"name": "older woman tone 2",
		"shortname": ":older_woman_tone2:",
		"category": "people",
		"emoji_order": "131",
		"aliases": [
			":grandma_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_woman_tone3": {
		"unicode": "1f475-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128117;&#127997;",
		"name": "older woman tone 3",
		"shortname": ":older_woman_tone3:",
		"category": "people",
		"emoji_order": "132",
		"aliases": [
			":grandma_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_woman_tone4": {
		"unicode": "1f475-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128117;&#127998;",
		"name": "older woman tone 4",
		"shortname": ":older_woman_tone4:",
		"category": "people",
		"emoji_order": "133",
		"aliases": [
			":grandma_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"older_woman_tone5": {
		"unicode": "1f475-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128117;&#127999;",
		"name": "older woman tone 5",
		"shortname": ":older_woman_tone5:",
		"category": "people",
		"emoji_order": "134",
		"aliases": [
			":grandma_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"baby": {
		"unicode": "1f476",
		"unicode_alt": "",
		"code_decimal": "&#128118;",
		"name": "baby",
		"shortname": ":baby:",
		"category": "people",
		"emoji_order": "135",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"baby",
			"diversity"
		]
	},
	"baby_tone1": {
		"unicode": "1f476-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128118;&#127995;",
		"name": "baby tone 1",
		"shortname": ":baby_tone1:",
		"category": "people",
		"emoji_order": "136",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"baby_tone2": {
		"unicode": "1f476-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128118;&#127996;",
		"name": "baby tone 2",
		"shortname": ":baby_tone2:",
		"category": "people",
		"emoji_order": "137",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"baby_tone3": {
		"unicode": "1f476-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128118;&#127997;",
		"name": "baby tone 3",
		"shortname": ":baby_tone3:",
		"category": "people",
		"emoji_order": "138",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"baby_tone4": {
		"unicode": "1f476-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128118;&#127998;",
		"name": "baby tone 4",
		"shortname": ":baby_tone4:",
		"category": "people",
		"emoji_order": "139",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"baby_tone5": {
		"unicode": "1f476-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128118;&#127999;",
		"name": "baby tone 5",
		"shortname": ":baby_tone5:",
		"category": "people",
		"emoji_order": "140",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"angel": {
		"unicode": "1f47c",
		"unicode_alt": "",
		"code_decimal": "&#128124;",
		"name": "baby angel",
		"shortname": ":angel:",
		"category": "people",
		"emoji_order": "141",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"diversity",
			"omg"
		]
	},
	"angel_tone1": {
		"unicode": "1f47c-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128124;&#127995;",
		"name": "baby angel tone 1",
		"shortname": ":angel_tone1:",
		"category": "people",
		"emoji_order": "142",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"angel_tone2": {
		"unicode": "1f47c-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128124;&#127996;",
		"name": "baby angel tone 2",
		"shortname": ":angel_tone2:",
		"category": "people",
		"emoji_order": "143",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"angel_tone3": {
		"unicode": "1f47c-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128124;&#127997;",
		"name": "baby angel tone 3",
		"shortname": ":angel_tone3:",
		"category": "people",
		"emoji_order": "144",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"angel_tone4": {
		"unicode": "1f47c-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128124;&#127998;",
		"name": "baby angel tone 4",
		"shortname": ":angel_tone4:",
		"category": "people",
		"emoji_order": "145",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"angel_tone5": {
		"unicode": "1f47c-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128124;&#127999;",
		"name": "baby angel tone 5",
		"shortname": ":angel_tone5:",
		"category": "people",
		"emoji_order": "146",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cop": {
		"unicode": "1f46e",
		"unicode_alt": "",
		"code_decimal": "&#128110;",
		"name": "police officer",
		"shortname": ":cop:",
		"category": "people",
		"emoji_order": "339",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"men",
			"diversity",
			"job",
			"police",
			"911"
		]
	},
	"cop_tone1": {
		"unicode": "1f46e-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128110;&#127995;",
		"name": "police officer tone 1",
		"shortname": ":cop_tone1:",
		"category": "people",
		"emoji_order": "340",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cop_tone2": {
		"unicode": "1f46e-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128110;&#127996;",
		"name": "police officer tone 2",
		"shortname": ":cop_tone2:",
		"category": "people",
		"emoji_order": "341",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cop_tone3": {
		"unicode": "1f46e-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128110;&#127997;",
		"name": "police officer tone 3",
		"shortname": ":cop_tone3:",
		"category": "people",
		"emoji_order": "342",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cop_tone4": {
		"unicode": "1f46e-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128110;&#127998;",
		"name": "police officer tone 4",
		"shortname": ":cop_tone4:",
		"category": "people",
		"emoji_order": "343",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cop_tone5": {
		"unicode": "1f46e-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128110;&#127999;",
		"name": "police officer tone 5",
		"shortname": ":cop_tone5:",
		"category": "people",
		"emoji_order": "344",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"spy": {
		"unicode": "1f575",
		"unicode_alt": "1f575-fe0f",
		"code_decimal": "&#128373;",
		"name": "sleuth or spy",
		"shortname": ":spy:",
		"category": "people",
		"emoji_order": "357",
		"aliases": [
			":sleuth_or_spy:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"men",
			"glasses",
			"diversity",
			"job"
		]
	},
	"spy_tone1": {
		"unicode": "1f575-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128373;&#127995;",
		"name": "sleuth or spy tone 1",
		"shortname": ":spy_tone1:",
		"category": "people",
		"emoji_order": "358",
		"aliases": [
			":sleuth_or_spy_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"spy_tone2": {
		"unicode": "1f575-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128373;&#127996;",
		"name": "sleuth or spy tone 2",
		"shortname": ":spy_tone2:",
		"category": "people",
		"emoji_order": "359",
		"aliases": [
			":sleuth_or_spy_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"spy_tone3": {
		"unicode": "1f575-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128373;&#127997;",
		"name": "sleuth or spy tone 3",
		"shortname": ":spy_tone3:",
		"category": "people",
		"emoji_order": "360",
		"aliases": [
			":sleuth_or_spy_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"spy_tone4": {
		"unicode": "1f575-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128373;&#127998;",
		"name": "sleuth or spy tone 4",
		"shortname": ":spy_tone4:",
		"category": "people",
		"emoji_order": "361",
		"aliases": [
			":sleuth_or_spy_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"spy_tone5": {
		"unicode": "1f575-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128373;&#127999;",
		"name": "sleuth or spy tone 5",
		"shortname": ":spy_tone5:",
		"category": "people",
		"emoji_order": "362",
		"aliases": [
			":sleuth_or_spy_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"guardsman": {
		"unicode": "1f482",
		"unicode_alt": "",
		"code_decimal": "&#128130;",
		"name": "guardsman",
		"shortname": ":guardsman:",
		"category": "people",
		"emoji_order": "375",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"men",
			"diversity",
			"job"
		]
	},
	"guardsman_tone1": {
		"unicode": "1f482-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128130;&#127995;",
		"name": "guardsman tone 1",
		"shortname": ":guardsman_tone1:",
		"category": "people",
		"emoji_order": "376",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"guardsman_tone2": {
		"unicode": "1f482-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128130;&#127996;",
		"name": "guardsman tone 2",
		"shortname": ":guardsman_tone2:",
		"category": "people",
		"emoji_order": "377",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"guardsman_tone3": {
		"unicode": "1f482-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128130;&#127997;",
		"name": "guardsman tone 3",
		"shortname": ":guardsman_tone3:",
		"category": "people",
		"emoji_order": "378",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"guardsman_tone4": {
		"unicode": "1f482-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128130;&#127998;",
		"name": "guardsman tone 4",
		"shortname": ":guardsman_tone4:",
		"category": "people",
		"emoji_order": "379",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"guardsman_tone5": {
		"unicode": "1f482-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128130;&#127999;",
		"name": "guardsman tone 5",
		"shortname": ":guardsman_tone5:",
		"category": "people",
		"emoji_order": "380",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"construction_worker": {
		"unicode": "1f477",
		"unicode_alt": "",
		"code_decimal": "&#128119;",
		"name": "construction worker",
		"shortname": ":construction_worker:",
		"category": "people",
		"emoji_order": "393",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"men",
			"diversity",
			"job"
		]
	},
	"construction_worker_tone1": {
		"unicode": "1f477-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128119;&#127995;",
		"name": "construction worker tone 1",
		"shortname": ":construction_worker_tone1:",
		"category": "people",
		"emoji_order": "394",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"construction_worker_tone2": {
		"unicode": "1f477-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128119;&#127996;",
		"name": "construction worker tone 2",
		"shortname": ":construction_worker_tone2:",
		"category": "people",
		"emoji_order": "395",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"construction_worker_tone3": {
		"unicode": "1f477-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128119;&#127997;",
		"name": "construction worker tone 3",
		"shortname": ":construction_worker_tone3:",
		"category": "people",
		"emoji_order": "396",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"construction_worker_tone4": {
		"unicode": "1f477-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128119;&#127998;",
		"name": "construction worker tone 4",
		"shortname": ":construction_worker_tone4:",
		"category": "people",
		"emoji_order": "397",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"construction_worker_tone5": {
		"unicode": "1f477-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128119;&#127999;",
		"name": "construction worker tone 5",
		"shortname": ":construction_worker_tone5:",
		"category": "people",
		"emoji_order": "398",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_turban": {
		"unicode": "1f473",
		"unicode_alt": "",
		"code_decimal": "&#128115;",
		"name": "man with turban",
		"shortname": ":man_with_turban:",
		"category": "people",
		"emoji_order": "411",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"diversity"
		]
	},
	"man_with_turban_tone1": {
		"unicode": "1f473-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128115;&#127995;",
		"name": "man with turban tone 1",
		"shortname": ":man_with_turban_tone1:",
		"category": "people",
		"emoji_order": "412",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_turban_tone2": {
		"unicode": "1f473-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128115;&#127996;",
		"name": "man with turban tone 2",
		"shortname": ":man_with_turban_tone2:",
		"category": "people",
		"emoji_order": "413",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_turban_tone3": {
		"unicode": "1f473-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128115;&#127997;",
		"name": "man with turban tone 3",
		"shortname": ":man_with_turban_tone3:",
		"category": "people",
		"emoji_order": "414",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_turban_tone4": {
		"unicode": "1f473-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128115;&#127998;",
		"name": "man with turban tone 4",
		"shortname": ":man_with_turban_tone4:",
		"category": "people",
		"emoji_order": "415",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_turban_tone5": {
		"unicode": "1f473-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128115;&#127999;",
		"name": "man with turban tone 5",
		"shortname": ":man_with_turban_tone5:",
		"category": "people",
		"emoji_order": "416",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_blond_hair": {
		"unicode": "1f471",
		"unicode_alt": "",
		"code_decimal": "&#128113;",
		"name": "person with blond hair",
		"shortname": ":person_with_blond_hair:",
		"category": "people",
		"emoji_order": "429",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"men",
			"diversity"
		]
	},
	"person_with_blond_hair_tone1": {
		"unicode": "1f471-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128113;&#127995;",
		"name": "person with blond hair tone 1",
		"shortname": ":person_with_blond_hair_tone1:",
		"category": "people",
		"emoji_order": "430",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_blond_hair_tone2": {
		"unicode": "1f471-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128113;&#127996;",
		"name": "person with blond hair tone 2",
		"shortname": ":person_with_blond_hair_tone2:",
		"category": "people",
		"emoji_order": "431",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_blond_hair_tone3": {
		"unicode": "1f471-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128113;&#127997;",
		"name": "person with blond hair tone 3",
		"shortname": ":person_with_blond_hair_tone3:",
		"category": "people",
		"emoji_order": "432",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_blond_hair_tone4": {
		"unicode": "1f471-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128113;&#127998;",
		"name": "person with blond hair tone 4",
		"shortname": ":person_with_blond_hair_tone4:",
		"category": "people",
		"emoji_order": "433",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_blond_hair_tone5": {
		"unicode": "1f471-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128113;&#127999;",
		"name": "person with blond hair tone 5",
		"shortname": ":person_with_blond_hair_tone5:",
		"category": "people",
		"emoji_order": "434",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"santa": {
		"unicode": "1f385",
		"unicode_alt": "",
		"code_decimal": "&#127877;",
		"name": "father christmas",
		"shortname": ":santa:",
		"category": "people",
		"emoji_order": "447",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"winter",
			"holidays",
			"christmas",
			"diversity",
			"santa"
		]
	},
	"santa_tone1": {
		"unicode": "1f385-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127877;&#127995;",
		"name": "father christmas tone 1",
		"shortname": ":santa_tone1:",
		"category": "people",
		"emoji_order": "448",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"santa_tone2": {
		"unicode": "1f385-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127877;&#127996;",
		"name": "father christmas tone 2",
		"shortname": ":santa_tone2:",
		"category": "people",
		"emoji_order": "449",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"santa_tone3": {
		"unicode": "1f385-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127877;&#127997;",
		"name": "father christmas tone 3",
		"shortname": ":santa_tone3:",
		"category": "people",
		"emoji_order": "450",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"santa_tone4": {
		"unicode": "1f385-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127877;&#127998;",
		"name": "father christmas tone 4",
		"shortname": ":santa_tone4:",
		"category": "people",
		"emoji_order": "451",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"santa_tone5": {
		"unicode": "1f385-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127877;&#127999;",
		"name": "father christmas tone 5",
		"shortname": ":santa_tone5:",
		"category": "people",
		"emoji_order": "452",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mrs_claus": {
		"unicode": "1f936",
		"unicode_alt": "",
		"code_decimal": "&#129334;",
		"name": "mother christmas",
		"shortname": ":mrs_claus:",
		"category": "people",
		"emoji_order": "453",
		"aliases": [
			":mother_christmas:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mrs_claus_tone1": {
		"unicode": "1f936-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129334;&#127995;",
		"name": "mother christmas tone 1",
		"shortname": ":mrs_claus_tone1:",
		"category": "people",
		"emoji_order": "454",
		"aliases": [
			":mother_christmas_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mrs_claus_tone2": {
		"unicode": "1f936-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129334;&#127996;",
		"name": "mother christmas tone 2",
		"shortname": ":mrs_claus_tone2:",
		"category": "people",
		"emoji_order": "455",
		"aliases": [
			":mother_christmas_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mrs_claus_tone3": {
		"unicode": "1f936-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129334;&#127997;",
		"name": "mother christmas tone 3",
		"shortname": ":mrs_claus_tone3:",
		"category": "people",
		"emoji_order": "456",
		"aliases": [
			":mother_christmas_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mrs_claus_tone4": {
		"unicode": "1f936-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129334;&#127998;",
		"name": "mother christmas tone 4",
		"shortname": ":mrs_claus_tone4:",
		"category": "people",
		"emoji_order": "457",
		"aliases": [
			":mother_christmas_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mrs_claus_tone5": {
		"unicode": "1f936-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129334;&#127999;",
		"name": "mother christmas tone 5",
		"shortname": ":mrs_claus_tone5:",
		"category": "people",
		"emoji_order": "458",
		"aliases": [
			":mother_christmas_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"princess": {
		"unicode": "1f478",
		"unicode_alt": "",
		"code_decimal": "&#128120;",
		"name": "princess",
		"shortname": ":princess:",
		"category": "people",
		"emoji_order": "459",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity",
			"beautiful",
			"girls night"
		]
	},
	"princess_tone1": {
		"unicode": "1f478-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128120;&#127995;",
		"name": "princess tone 1",
		"shortname": ":princess_tone1:",
		"category": "people",
		"emoji_order": "460",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"princess_tone2": {
		"unicode": "1f478-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128120;&#127996;",
		"name": "princess tone 2",
		"shortname": ":princess_tone2:",
		"category": "people",
		"emoji_order": "461",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"princess_tone3": {
		"unicode": "1f478-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128120;&#127997;",
		"name": "princess tone 3",
		"shortname": ":princess_tone3:",
		"category": "people",
		"emoji_order": "462",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"princess_tone4": {
		"unicode": "1f478-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128120;&#127998;",
		"name": "princess tone 4",
		"shortname": ":princess_tone4:",
		"category": "people",
		"emoji_order": "463",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"princess_tone5": {
		"unicode": "1f478-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128120;&#127999;",
		"name": "princess tone 5",
		"shortname": ":princess_tone5:",
		"category": "people",
		"emoji_order": "464",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"prince": {
		"unicode": "1f934",
		"unicode_alt": "",
		"code_decimal": "&#129332;",
		"name": "prince",
		"shortname": ":prince:",
		"category": "people",
		"emoji_order": "465",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"prince_tone1": {
		"unicode": "1f934-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129332;&#127995;",
		"name": "prince tone 1",
		"shortname": ":prince_tone1:",
		"category": "people",
		"emoji_order": "466",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"prince_tone2": {
		"unicode": "1f934-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129332;&#127996;",
		"name": "prince tone 2",
		"shortname": ":prince_tone2:",
		"category": "people",
		"emoji_order": "467",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"prince_tone3": {
		"unicode": "1f934-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129332;&#127997;",
		"name": "prince tone 3",
		"shortname": ":prince_tone3:",
		"category": "people",
		"emoji_order": "468",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"prince_tone4": {
		"unicode": "1f934-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129332;&#127998;",
		"name": "prince tone 4",
		"shortname": ":prince_tone4:",
		"category": "people",
		"emoji_order": "469",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"prince_tone5": {
		"unicode": "1f934-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129332;&#127999;",
		"name": "prince tone 5",
		"shortname": ":prince_tone5:",
		"category": "people",
		"emoji_order": "470",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bride_with_veil": {
		"unicode": "1f470",
		"unicode_alt": "",
		"code_decimal": "&#128112;",
		"name": "bride with veil",
		"shortname": ":bride_with_veil:",
		"category": "people",
		"emoji_order": "471",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"wedding",
			"women",
			"diversity"
		]
	},
	"bride_with_veil_tone1": {
		"unicode": "1f470-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128112;&#127995;",
		"name": "bride with veil tone 1",
		"shortname": ":bride_with_veil_tone1:",
		"category": "people",
		"emoji_order": "472",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bride_with_veil_tone2": {
		"unicode": "1f470-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128112;&#127996;",
		"name": "bride with veil tone 2",
		"shortname": ":bride_with_veil_tone2:",
		"category": "people",
		"emoji_order": "473",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bride_with_veil_tone3": {
		"unicode": "1f470-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128112;&#127997;",
		"name": "bride with veil tone 3",
		"shortname": ":bride_with_veil_tone3:",
		"category": "people",
		"emoji_order": "474",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bride_with_veil_tone4": {
		"unicode": "1f470-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128112;&#127998;",
		"name": "bride with veil tone 4",
		"shortname": ":bride_with_veil_tone4:",
		"category": "people",
		"emoji_order": "475",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bride_with_veil_tone5": {
		"unicode": "1f470-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128112;&#127999;",
		"name": "bride with veil tone 5",
		"shortname": ":bride_with_veil_tone5:",
		"category": "people",
		"emoji_order": "476",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_in_tuxedo": {
		"unicode": "1f935",
		"unicode_alt": "",
		"code_decimal": "&#129333;",
		"name": "man in tuxedo",
		"shortname": ":man_in_tuxedo:",
		"category": "people",
		"emoji_order": "477",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_in_tuxedo_tone1": {
		"unicode": "1f935-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129333;&#127995;",
		"name": "man in tuxedo tone 1",
		"shortname": ":man_in_tuxedo_tone1:",
		"category": "people",
		"emoji_order": "478",
		"aliases": [
			":tuxedo_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_in_tuxedo_tone2": {
		"unicode": "1f935-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129333;&#127996;",
		"name": "man in tuxedo tone 2",
		"shortname": ":man_in_tuxedo_tone2:",
		"category": "people",
		"emoji_order": "479",
		"aliases": [
			":tuxedo_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_in_tuxedo_tone3": {
		"unicode": "1f935-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129333;&#127997;",
		"name": "man in tuxedo tone 3",
		"shortname": ":man_in_tuxedo_tone3:",
		"category": "people",
		"emoji_order": "480",
		"aliases": [
			":tuxedo_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_in_tuxedo_tone4": {
		"unicode": "1f935-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129333;&#127998;",
		"name": "man in tuxedo tone 4",
		"shortname": ":man_in_tuxedo_tone4:",
		"category": "people",
		"emoji_order": "481",
		"aliases": [
			":tuxedo_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_in_tuxedo_tone5": {
		"unicode": "1f935-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129333;&#127999;",
		"name": "man in tuxedo tone 5",
		"shortname": ":man_in_tuxedo_tone5:",
		"category": "people",
		"emoji_order": "482",
		"aliases": [
			":tuxedo_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pregnant_woman": {
		"unicode": "1f930",
		"unicode_alt": "",
		"code_decimal": "&#129328;",
		"name": "pregnant woman",
		"shortname": ":pregnant_woman:",
		"category": "people",
		"emoji_order": "483",
		"aliases": [
			":expecting_woman:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pregnant_woman_tone1": {
		"unicode": "1f930-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129328;&#127995;",
		"name": "pregnant woman tone 1",
		"shortname": ":pregnant_woman_tone1:",
		"category": "people",
		"emoji_order": "484",
		"aliases": [
			":expecting_woman_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pregnant_woman_tone2": {
		"unicode": "1f930-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129328;&#127996;",
		"name": "pregnant woman tone 2",
		"shortname": ":pregnant_woman_tone2:",
		"category": "people",
		"emoji_order": "485",
		"aliases": [
			":expecting_woman_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pregnant_woman_tone3": {
		"unicode": "1f930-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129328;&#127997;",
		"name": "pregnant woman tone 3",
		"shortname": ":pregnant_woman_tone3:",
		"category": "people",
		"emoji_order": "486",
		"aliases": [
			":expecting_woman_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pregnant_woman_tone4": {
		"unicode": "1f930-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129328;&#127998;",
		"name": "pregnant woman tone 4",
		"shortname": ":pregnant_woman_tone4:",
		"category": "people",
		"emoji_order": "487",
		"aliases": [
			":expecting_woman_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pregnant_woman_tone5": {
		"unicode": "1f930-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129328;&#127999;",
		"name": "pregnant woman tone 5",
		"shortname": ":pregnant_woman_tone5:",
		"category": "people",
		"emoji_order": "488",
		"aliases": [
			":expecting_woman_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_gua_pi_mao": {
		"unicode": "1f472",
		"unicode_alt": "",
		"code_decimal": "&#128114;",
		"name": "man with gua pi mao",
		"shortname": ":man_with_gua_pi_mao:",
		"category": "people",
		"emoji_order": "489",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"hat",
			"men",
			"diversity"
		]
	},
	"man_with_gua_pi_mao_tone1": {
		"unicode": "1f472-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128114;&#127995;",
		"name": "man with gua pi mao tone 1",
		"shortname": ":man_with_gua_pi_mao_tone1:",
		"category": "people",
		"emoji_order": "490",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_gua_pi_mao_tone2": {
		"unicode": "1f472-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128114;&#127996;",
		"name": "man with gua pi mao tone 2",
		"shortname": ":man_with_gua_pi_mao_tone2:",
		"category": "people",
		"emoji_order": "491",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_gua_pi_mao_tone3": {
		"unicode": "1f472-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128114;&#127997;",
		"name": "man with gua pi mao tone 3",
		"shortname": ":man_with_gua_pi_mao_tone3:",
		"category": "people",
		"emoji_order": "492",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_gua_pi_mao_tone4": {
		"unicode": "1f472-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128114;&#127998;",
		"name": "man with gua pi mao tone 4",
		"shortname": ":man_with_gua_pi_mao_tone4:",
		"category": "people",
		"emoji_order": "493",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_with_gua_pi_mao_tone5": {
		"unicode": "1f472-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128114;&#127999;",
		"name": "man with gua pi mao tone 5",
		"shortname": ":man_with_gua_pi_mao_tone5:",
		"category": "people",
		"emoji_order": "494",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_frowning": {
		"unicode": "1f64d",
		"unicode_alt": "",
		"code_decimal": "&#128589;",
		"name": "person frowning",
		"shortname": ":person_frowning:",
		"category": "people",
		"emoji_order": "495",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"person_frowning_tone1": {
		"unicode": "1f64d-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128589;&#127995;",
		"name": "person frowning tone 1",
		"shortname": ":person_frowning_tone1:",
		"category": "people",
		"emoji_order": "496",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_frowning_tone2": {
		"unicode": "1f64d-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128589;&#127996;",
		"name": "person frowning tone 2",
		"shortname": ":person_frowning_tone2:",
		"category": "people",
		"emoji_order": "497",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_frowning_tone3": {
		"unicode": "1f64d-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128589;&#127997;",
		"name": "person frowning tone 3",
		"shortname": ":person_frowning_tone3:",
		"category": "people",
		"emoji_order": "498",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_frowning_tone4": {
		"unicode": "1f64d-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128589;&#127998;",
		"name": "person frowning tone 4",
		"shortname": ":person_frowning_tone4:",
		"category": "people",
		"emoji_order": "499",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_frowning_tone5": {
		"unicode": "1f64d-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128589;&#127999;",
		"name": "person frowning tone 5",
		"shortname": ":person_frowning_tone5:",
		"category": "people",
		"emoji_order": "500",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_pouting_face": {
		"unicode": "1f64e",
		"unicode_alt": "",
		"code_decimal": "&#128590;",
		"name": "person with pouting face",
		"shortname": ":person_with_pouting_face:",
		"category": "people",
		"emoji_order": "513",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"person_with_pouting_face_tone1": {
		"unicode": "1f64e-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128590;&#127995;",
		"name": "person with pouting face tone1",
		"shortname": ":person_with_pouting_face_tone1:",
		"category": "people",
		"emoji_order": "514",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_pouting_face_tone2": {
		"unicode": "1f64e-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128590;&#127996;",
		"name": "person with pouting face tone2",
		"shortname": ":person_with_pouting_face_tone2:",
		"category": "people",
		"emoji_order": "515",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_pouting_face_tone3": {
		"unicode": "1f64e-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128590;&#127997;",
		"name": "person with pouting face tone3",
		"shortname": ":person_with_pouting_face_tone3:",
		"category": "people",
		"emoji_order": "516",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_pouting_face_tone4": {
		"unicode": "1f64e-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128590;&#127998;",
		"name": "person with pouting face tone4",
		"shortname": ":person_with_pouting_face_tone4:",
		"category": "people",
		"emoji_order": "517",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"person_with_pouting_face_tone5": {
		"unicode": "1f64e-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128590;&#127999;",
		"name": "person with pouting face tone5",
		"shortname": ":person_with_pouting_face_tone5:",
		"category": "people",
		"emoji_order": "518",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"no_good": {
		"unicode": "1f645",
		"unicode_alt": "",
		"code_decimal": "&#128581;",
		"name": "face with no good gesture",
		"shortname": ":no_good:",
		"category": "people",
		"emoji_order": "531",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity",
			"girls night"
		]
	},
	"no_good_tone1": {
		"unicode": "1f645-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128581;&#127995;",
		"name": "face with no good gesture tone 1",
		"shortname": ":no_good_tone1:",
		"category": "people",
		"emoji_order": "532",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"no_good_tone2": {
		"unicode": "1f645-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128581;&#127996;",
		"name": "face with no good gesture tone 2",
		"shortname": ":no_good_tone2:",
		"category": "people",
		"emoji_order": "533",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"no_good_tone3": {
		"unicode": "1f645-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128581;&#127997;",
		"name": "face with no good gesture tone 3",
		"shortname": ":no_good_tone3:",
		"category": "people",
		"emoji_order": "534",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"no_good_tone4": {
		"unicode": "1f645-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128581;&#127998;",
		"name": "face with no good gesture tone 4",
		"shortname": ":no_good_tone4:",
		"category": "people",
		"emoji_order": "535",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"no_good_tone5": {
		"unicode": "1f645-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128581;&#127999;",
		"name": "face with no good gesture tone 5",
		"shortname": ":no_good_tone5:",
		"category": "people",
		"emoji_order": "536",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_woman": {
		"unicode": "1f646",
		"unicode_alt": "",
		"code_decimal": "&#128582;",
		"name": "face with ok gesture",
		"shortname": ":ok_woman:",
		"category": "people",
		"emoji_order": "549",
		"aliases": [],
		"aliases_ascii": [
			"*\\0/*",
			"\\0/",
			"*\\O/*",
			"\\O/"
		],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"ok_woman_tone1": {
		"unicode": "1f646-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128582;&#127995;",
		"name": "face with ok gesture tone1",
		"shortname": ":ok_woman_tone1:",
		"category": "people",
		"emoji_order": "550",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_woman_tone2": {
		"unicode": "1f646-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128582;&#127996;",
		"name": "face with ok gesture tone2",
		"shortname": ":ok_woman_tone2:",
		"category": "people",
		"emoji_order": "551",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_woman_tone3": {
		"unicode": "1f646-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128582;&#127997;",
		"name": "face with ok gesture tone3",
		"shortname": ":ok_woman_tone3:",
		"category": "people",
		"emoji_order": "552",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_woman_tone4": {
		"unicode": "1f646-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128582;&#127998;",
		"name": "face with ok gesture tone4",
		"shortname": ":ok_woman_tone4:",
		"category": "people",
		"emoji_order": "553",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_woman_tone5": {
		"unicode": "1f646-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128582;&#127999;",
		"name": "face with ok gesture tone5",
		"shortname": ":ok_woman_tone5:",
		"category": "people",
		"emoji_order": "554",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"information_desk_person": {
		"unicode": "1f481",
		"unicode_alt": "",
		"code_decimal": "&#128129;",
		"name": "information desk person",
		"shortname": ":information_desk_person:",
		"category": "people",
		"emoji_order": "567",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"information_desk_person_tone1": {
		"unicode": "1f481-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128129;&#127995;",
		"name": "information desk person tone 1",
		"shortname": ":information_desk_person_tone1:",
		"category": "people",
		"emoji_order": "568",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"information_desk_person_tone2": {
		"unicode": "1f481-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128129;&#127996;",
		"name": "information desk person tone 2",
		"shortname": ":information_desk_person_tone2:",
		"category": "people",
		"emoji_order": "569",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"information_desk_person_tone3": {
		"unicode": "1f481-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128129;&#127997;",
		"name": "information desk person tone 3",
		"shortname": ":information_desk_person_tone3:",
		"category": "people",
		"emoji_order": "570",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"information_desk_person_tone4": {
		"unicode": "1f481-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128129;&#127998;",
		"name": "information desk person tone 4",
		"shortname": ":information_desk_person_tone4:",
		"category": "people",
		"emoji_order": "571",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"information_desk_person_tone5": {
		"unicode": "1f481-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128129;&#127999;",
		"name": "information desk person tone 5",
		"shortname": ":information_desk_person_tone5:",
		"category": "people",
		"emoji_order": "572",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raising_hand": {
		"unicode": "1f64b",
		"unicode_alt": "",
		"code_decimal": "&#128587;",
		"name": "happy person raising one hand",
		"shortname": ":raising_hand:",
		"category": "people",
		"emoji_order": "585",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"raising_hand_tone1": {
		"unicode": "1f64b-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128587;&#127995;",
		"name": "happy person raising one hand tone1",
		"shortname": ":raising_hand_tone1:",
		"category": "people",
		"emoji_order": "586",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raising_hand_tone2": {
		"unicode": "1f64b-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128587;&#127996;",
		"name": "happy person raising one hand tone2",
		"shortname": ":raising_hand_tone2:",
		"category": "people",
		"emoji_order": "587",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raising_hand_tone3": {
		"unicode": "1f64b-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128587;&#127997;",
		"name": "happy person raising one hand tone3",
		"shortname": ":raising_hand_tone3:",
		"category": "people",
		"emoji_order": "588",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raising_hand_tone4": {
		"unicode": "1f64b-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128587;&#127998;",
		"name": "happy person raising one hand tone4",
		"shortname": ":raising_hand_tone4:",
		"category": "people",
		"emoji_order": "589",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raising_hand_tone5": {
		"unicode": "1f64b-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128587;&#127999;",
		"name": "happy person raising one hand tone5",
		"shortname": ":raising_hand_tone5:",
		"category": "people",
		"emoji_order": "590",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bow": {
		"unicode": "1f647",
		"unicode_alt": "",
		"code_decimal": "&#128583;",
		"name": "person bowing deeply",
		"shortname": ":bow:",
		"category": "people",
		"emoji_order": "603",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"pray",
			"diversity"
		]
	},
	"bow_tone1": {
		"unicode": "1f647-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128583;&#127995;",
		"name": "person bowing deeply tone 1",
		"shortname": ":bow_tone1:",
		"category": "people",
		"emoji_order": "604",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bow_tone2": {
		"unicode": "1f647-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128583;&#127996;",
		"name": "person bowing deeply tone 2",
		"shortname": ":bow_tone2:",
		"category": "people",
		"emoji_order": "605",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bow_tone3": {
		"unicode": "1f647-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128583;&#127997;",
		"name": "person bowing deeply tone 3",
		"shortname": ":bow_tone3:",
		"category": "people",
		"emoji_order": "606",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bow_tone4": {
		"unicode": "1f647-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128583;&#127998;",
		"name": "person bowing deeply tone 4",
		"shortname": ":bow_tone4:",
		"category": "people",
		"emoji_order": "607",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bow_tone5": {
		"unicode": "1f647-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128583;&#127999;",
		"name": "person bowing deeply tone 5",
		"shortname": ":bow_tone5:",
		"category": "people",
		"emoji_order": "608",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"face_palm": {
		"unicode": "1f926",
		"unicode_alt": "",
		"code_decimal": "&#129318;",
		"name": "face palm",
		"shortname": ":face_palm:",
		"category": "people",
		"emoji_order": "621",
		"aliases": [
			":facepalm:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"face_palm_tone1": {
		"unicode": "1f926-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129318;&#127995;",
		"name": "face palm tone 1",
		"shortname": ":face_palm_tone1:",
		"category": "people",
		"emoji_order": "622",
		"aliases": [
			":facepalm_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"face_palm_tone2": {
		"unicode": "1f926-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129318;&#127996;",
		"name": "face palm tone 2",
		"shortname": ":face_palm_tone2:",
		"category": "people",
		"emoji_order": "623",
		"aliases": [
			":facepalm_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"face_palm_tone3": {
		"unicode": "1f926-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129318;&#127997;",
		"name": "face palm tone 3",
		"shortname": ":face_palm_tone3:",
		"category": "people",
		"emoji_order": "624",
		"aliases": [
			":facepalm_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"face_palm_tone4": {
		"unicode": "1f926-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129318;&#127998;",
		"name": "face palm tone 4",
		"shortname": ":face_palm_tone4:",
		"category": "people",
		"emoji_order": "625",
		"aliases": [
			":facepalm_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"face_palm_tone5": {
		"unicode": "1f926-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129318;&#127999;",
		"name": "face palm tone 5",
		"shortname": ":face_palm_tone5:",
		"category": "people",
		"emoji_order": "626",
		"aliases": [
			":facepalm_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"shrug": {
		"unicode": "1f937",
		"unicode_alt": "",
		"code_decimal": "&#129335;",
		"name": "shrug",
		"shortname": ":shrug:",
		"category": "people",
		"emoji_order": "639",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"shrug_tone1": {
		"unicode": "1f937-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129335;&#127995;",
		"name": "shrug tone 1",
		"shortname": ":shrug_tone1:",
		"category": "people",
		"emoji_order": "640",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"shrug_tone2": {
		"unicode": "1f937-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129335;&#127996;",
		"name": "shrug tone 2",
		"shortname": ":shrug_tone2:",
		"category": "people",
		"emoji_order": "641",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"shrug_tone3": {
		"unicode": "1f937-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129335;&#127997;",
		"name": "shrug tone 3",
		"shortname": ":shrug_tone3:",
		"category": "people",
		"emoji_order": "642",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"shrug_tone4": {
		"unicode": "1f937-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129335;&#127998;",
		"name": "shrug tone 4",
		"shortname": ":shrug_tone4:",
		"category": "people",
		"emoji_order": "643",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"shrug_tone5": {
		"unicode": "1f937-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129335;&#127999;",
		"name": "shrug tone 5",
		"shortname": ":shrug_tone5:",
		"category": "people",
		"emoji_order": "644",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"massage": {
		"unicode": "1f486",
		"unicode_alt": "",
		"code_decimal": "&#128134;",
		"name": "face massage",
		"shortname": ":massage:",
		"category": "people",
		"emoji_order": "657",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"massage_tone1": {
		"unicode": "1f486-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128134;&#127995;",
		"name": "face massage tone 1",
		"shortname": ":massage_tone1:",
		"category": "people",
		"emoji_order": "658",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"massage_tone2": {
		"unicode": "1f486-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128134;&#127996;",
		"name": "face massage tone 2",
		"shortname": ":massage_tone2:",
		"category": "people",
		"emoji_order": "659",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"massage_tone3": {
		"unicode": "1f486-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128134;&#127997;",
		"name": "face massage tone 3",
		"shortname": ":massage_tone3:",
		"category": "people",
		"emoji_order": "660",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"massage_tone4": {
		"unicode": "1f486-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128134;&#127998;",
		"name": "face massage tone 4",
		"shortname": ":massage_tone4:",
		"category": "people",
		"emoji_order": "661",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"massage_tone5": {
		"unicode": "1f486-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128134;&#127999;",
		"name": "face massage tone 5",
		"shortname": ":massage_tone5:",
		"category": "people",
		"emoji_order": "662",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"haircut": {
		"unicode": "1f487",
		"unicode_alt": "",
		"code_decimal": "&#128135;",
		"name": "haircut",
		"shortname": ":haircut:",
		"category": "people",
		"emoji_order": "675",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"diversity"
		]
	},
	"haircut_tone1": {
		"unicode": "1f487-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128135;&#127995;",
		"name": "haircut tone 1",
		"shortname": ":haircut_tone1:",
		"category": "people",
		"emoji_order": "676",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"haircut_tone2": {
		"unicode": "1f487-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128135;&#127996;",
		"name": "haircut tone 2",
		"shortname": ":haircut_tone2:",
		"category": "people",
		"emoji_order": "677",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"haircut_tone3": {
		"unicode": "1f487-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128135;&#127997;",
		"name": "haircut tone 3",
		"shortname": ":haircut_tone3:",
		"category": "people",
		"emoji_order": "678",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"haircut_tone4": {
		"unicode": "1f487-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128135;&#127998;",
		"name": "haircut tone 4",
		"shortname": ":haircut_tone4:",
		"category": "people",
		"emoji_order": "679",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"haircut_tone5": {
		"unicode": "1f487-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128135;&#127999;",
		"name": "haircut tone 5",
		"shortname": ":haircut_tone5:",
		"category": "people",
		"emoji_order": "680",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"walking": {
		"unicode": "1f6b6",
		"unicode_alt": "",
		"code_decimal": "&#128694;",
		"name": "pedestrian",
		"shortname": ":walking:",
		"category": "people",
		"emoji_order": "693",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"men",
			"diversity"
		]
	},
	"walking_tone1": {
		"unicode": "1f6b6-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128694;&#127995;",
		"name": "pedestrian tone 1",
		"shortname": ":walking_tone1:",
		"category": "people",
		"emoji_order": "694",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"walking_tone2": {
		"unicode": "1f6b6-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128694;&#127996;",
		"name": "pedestrian tone 2",
		"shortname": ":walking_tone2:",
		"category": "people",
		"emoji_order": "695",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"walking_tone3": {
		"unicode": "1f6b6-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128694;&#127997;",
		"name": "pedestrian tone 3",
		"shortname": ":walking_tone3:",
		"category": "people",
		"emoji_order": "696",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"walking_tone4": {
		"unicode": "1f6b6-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128694;&#127998;",
		"name": "pedestrian tone 4",
		"shortname": ":walking_tone4:",
		"category": "people",
		"emoji_order": "697",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"walking_tone5": {
		"unicode": "1f6b6-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128694;&#127999;",
		"name": "pedestrian tone 5",
		"shortname": ":walking_tone5:",
		"category": "people",
		"emoji_order": "698",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"runner": {
		"unicode": "1f3c3",
		"unicode_alt": "",
		"code_decimal": "&#127939;",
		"name": "runner",
		"shortname": ":runner:",
		"category": "people",
		"emoji_order": "711",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"men",
			"diversity",
			"boys night",
			"run"
		]
	},
	"runner_tone1": {
		"unicode": "1f3c3-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127939;&#127995;",
		"name": "runner tone 1",
		"shortname": ":runner_tone1:",
		"category": "people",
		"emoji_order": "712",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"runner_tone2": {
		"unicode": "1f3c3-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127939;&#127996;",
		"name": "runner tone 2",
		"shortname": ":runner_tone2:",
		"category": "people",
		"emoji_order": "713",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"runner_tone3": {
		"unicode": "1f3c3-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127939;&#127997;",
		"name": "runner tone 3",
		"shortname": ":runner_tone3:",
		"category": "people",
		"emoji_order": "714",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"runner_tone4": {
		"unicode": "1f3c3-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127939;&#127998;",
		"name": "runner tone 4",
		"shortname": ":runner_tone4:",
		"category": "people",
		"emoji_order": "715",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"runner_tone5": {
		"unicode": "1f3c3-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127939;&#127999;",
		"name": "runner tone 5",
		"shortname": ":runner_tone5:",
		"category": "people",
		"emoji_order": "716",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"dancer": {
		"unicode": "1f483",
		"unicode_alt": "",
		"code_decimal": "&#128131;",
		"name": "dancer",
		"shortname": ":dancer:",
		"category": "people",
		"emoji_order": "729",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"sexy",
			"diversity",
			"girls night",
			"dance"
		]
	},
	"dancer_tone1": {
		"unicode": "1f483-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128131;&#127995;",
		"name": "dancer tone 1",
		"shortname": ":dancer_tone1:",
		"category": "people",
		"emoji_order": "730",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"dancer_tone2": {
		"unicode": "1f483-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128131;&#127996;",
		"name": "dancer tone 2",
		"shortname": ":dancer_tone2:",
		"category": "people",
		"emoji_order": "731",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"dancer_tone3": {
		"unicode": "1f483-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128131;&#127997;",
		"name": "dancer tone 3",
		"shortname": ":dancer_tone3:",
		"category": "people",
		"emoji_order": "732",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"dancer_tone4": {
		"unicode": "1f483-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128131;&#127998;",
		"name": "dancer tone 4",
		"shortname": ":dancer_tone4:",
		"category": "people",
		"emoji_order": "733",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"dancer_tone5": {
		"unicode": "1f483-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128131;&#127999;",
		"name": "dancer tone 5",
		"shortname": ":dancer_tone5:",
		"category": "people",
		"emoji_order": "734",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_dancing": {
		"unicode": "1f57a",
		"unicode_alt": "",
		"code_decimal": "&#128378;",
		"name": "man dancing",
		"shortname": ":man_dancing:",
		"category": "people",
		"emoji_order": "735",
		"aliases": [
			":male_dancer:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_dancing_tone1": {
		"unicode": "1f57a-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128378;&#127995;",
		"name": "man dancing tone 1",
		"shortname": ":man_dancing_tone1:",
		"category": "people",
		"emoji_order": "736",
		"aliases": [
			":male_dancer_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_dancing_tone2": {
		"unicode": "1f57a-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128378;&#127996;",
		"name": "man dancing tone 2",
		"shortname": ":man_dancing_tone2:",
		"category": "people",
		"emoji_order": "737",
		"aliases": [
			":male_dancer_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_dancing_tone3": {
		"unicode": "1f57a-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128378;&#127997;",
		"name": "man dancing tone 3",
		"shortname": ":man_dancing_tone3:",
		"category": "people",
		"emoji_order": "738",
		"aliases": [
			":male_dancer_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_dancing_tone4": {
		"unicode": "1f57a-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128378;&#127998;",
		"name": "man dancing tone 4",
		"shortname": ":man_dancing_tone4:",
		"category": "people",
		"emoji_order": "739",
		"aliases": [
			":male_dancer_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"man_dancing_tone5": {
		"unicode": "1f57a-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128378;&#127999;",
		"name": "man dancing tone 5",
		"shortname": ":man_dancing_tone5:",
		"category": "people",
		"emoji_order": "740",
		"aliases": [
			":male_dancer_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"dancers": {
		"unicode": "1f46f",
		"unicode_alt": "",
		"code_decimal": "&#128111;",
		"name": "woman with bunny ears",
		"shortname": ":dancers:",
		"category": "people",
		"emoji_order": "741",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"sexy",
			"girls night",
			"boys night",
			"parties",
			"dance"
		]
	},
	"levitate": {
		"unicode": "1f574",
		"unicode_alt": "1f574-fe0f",
		"code_decimal": "&#128372;",
		"name": "man in business suit levitating",
		"shortname": ":levitate:",
		"category": "activity",
		"emoji_order": "759",
		"aliases": [
			":man_in_business_suit_levitating:"
		],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"job"
		]
	},
	"speaking_head": {
		"unicode": "1f5e3",
		"unicode_alt": "1f5e3-fe0f",
		"code_decimal": "&#128483;",
		"name": "speaking head in silhouette",
		"shortname": ":speaking_head:",
		"category": "people",
		"emoji_order": "765",
		"aliases": [
			":speaking_head_in_silhouette:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"talk"
		]
	},
	"bust_in_silhouette": {
		"unicode": "1f464",
		"unicode_alt": "",
		"code_decimal": "&#128100;",
		"name": "bust in silhouette",
		"shortname": ":bust_in_silhouette:",
		"category": "people",
		"emoji_order": "766",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people"
		]
	},
	"busts_in_silhouette": {
		"unicode": "1f465",
		"unicode_alt": "",
		"code_decimal": "&#128101;",
		"name": "busts in silhouette",
		"shortname": ":busts_in_silhouette:",
		"category": "people",
		"emoji_order": "767",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people"
		]
	},
	"fencer": {
		"unicode": "1f93a",
		"unicode_alt": "",
		"code_decimal": "&#129338;",
		"name": "fencer",
		"shortname": ":fencer:",
		"category": "activity",
		"emoji_order": "768",
		"aliases": [
			":fencing:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"horse_racing": {
		"unicode": "1f3c7",
		"unicode_alt": "",
		"code_decimal": "&#127943;",
		"name": "horse racing",
		"shortname": ":horse_racing:",
		"category": "activity",
		"emoji_order": "769",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"sport",
			"horse racing"
		]
	},
	"horse_racing_tone1": {
		"unicode": "1f3c7-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127943;&#127995;",
		"name": "horse racing tone 1",
		"shortname": ":horse_racing_tone1:",
		"category": "activity",
		"emoji_order": "770",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"horse_racing_tone2": {
		"unicode": "1f3c7-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127943;&#127996;",
		"name": "horse racing tone 2",
		"shortname": ":horse_racing_tone2:",
		"category": "activity",
		"emoji_order": "771",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"horse_racing_tone3": {
		"unicode": "1f3c7-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127943;&#127997;",
		"name": "horse racing tone 3",
		"shortname": ":horse_racing_tone3:",
		"category": "activity",
		"emoji_order": "772",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"horse_racing_tone4": {
		"unicode": "1f3c7-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127943;&#127998;",
		"name": "horse racing tone 4",
		"shortname": ":horse_racing_tone4:",
		"category": "activity",
		"emoji_order": "773",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"horse_racing_tone5": {
		"unicode": "1f3c7-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127943;&#127999;",
		"name": "horse racing tone 5",
		"shortname": ":horse_racing_tone5:",
		"category": "activity",
		"emoji_order": "774",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"skier": {
		"unicode": "26f7",
		"unicode_alt": "26f7-fe0f",
		"code_decimal": "&#9975;",
		"name": "skier",
		"shortname": ":skier:",
		"category": "activity",
		"emoji_order": "775",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"hat",
			"vacation",
			"cold",
			"sport",
			"skiing"
		]
	},
	"snowboarder": {
		"unicode": "1f3c2",
		"unicode_alt": "",
		"code_decimal": "&#127938;",
		"name": "snowboarder",
		"shortname": ":snowboarder:",
		"category": "activity",
		"emoji_order": "776",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"hat",
			"vacation",
			"cold",
			"sport",
			"snowboarding"
		]
	},
	"golfer": {
		"unicode": "1f3cc",
		"unicode_alt": "1f3cc-fe0f",
		"code_decimal": "&#127948;",
		"name": "golfer",
		"shortname": ":golfer:",
		"category": "activity",
		"emoji_order": "782",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"game",
			"ball",
			"vacation",
			"sport",
			"golf"
		]
	},
	"surfer": {
		"unicode": "1f3c4",
		"unicode_alt": "",
		"code_decimal": "&#127940;",
		"name": "surfer",
		"shortname": ":surfer:",
		"category": "activity",
		"emoji_order": "800",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"vacation",
			"tropical",
			"sport",
			"diversity"
		]
	},
	"surfer_tone1": {
		"unicode": "1f3c4-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127940;&#127995;",
		"name": "surfer tone 1",
		"shortname": ":surfer_tone1:",
		"category": "activity",
		"emoji_order": "801",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"surfer_tone2": {
		"unicode": "1f3c4-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127940;&#127996;",
		"name": "surfer tone 2",
		"shortname": ":surfer_tone2:",
		"category": "activity",
		"emoji_order": "802",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"surfer_tone3": {
		"unicode": "1f3c4-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127940;&#127997;",
		"name": "surfer tone 3",
		"shortname": ":surfer_tone3:",
		"category": "activity",
		"emoji_order": "803",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"surfer_tone4": {
		"unicode": "1f3c4-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127940;&#127998;",
		"name": "surfer tone 4",
		"shortname": ":surfer_tone4:",
		"category": "activity",
		"emoji_order": "804",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"surfer_tone5": {
		"unicode": "1f3c4-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127940;&#127999;",
		"name": "surfer tone 5",
		"shortname": ":surfer_tone5:",
		"category": "activity",
		"emoji_order": "805",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"rowboat": {
		"unicode": "1f6a3",
		"unicode_alt": "",
		"code_decimal": "&#128675;",
		"name": "rowboat",
		"shortname": ":rowboat:",
		"category": "activity",
		"emoji_order": "818",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"workout",
			"sport",
			"rowing",
			"diversity"
		]
	},
	"rowboat_tone1": {
		"unicode": "1f6a3-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128675;&#127995;",
		"name": "rowboat tone 1",
		"shortname": ":rowboat_tone1:",
		"category": "activity",
		"emoji_order": "819",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"rowboat_tone2": {
		"unicode": "1f6a3-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128675;&#127996;",
		"name": "rowboat tone 2",
		"shortname": ":rowboat_tone2:",
		"category": "activity",
		"emoji_order": "820",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"rowboat_tone3": {
		"unicode": "1f6a3-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128675;&#127997;",
		"name": "rowboat tone 3",
		"shortname": ":rowboat_tone3:",
		"category": "activity",
		"emoji_order": "821",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"rowboat_tone4": {
		"unicode": "1f6a3-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128675;&#127998;",
		"name": "rowboat tone 4",
		"shortname": ":rowboat_tone4:",
		"category": "activity",
		"emoji_order": "822",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"rowboat_tone5": {
		"unicode": "1f6a3-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128675;&#127999;",
		"name": "rowboat tone 5",
		"shortname": ":rowboat_tone5:",
		"category": "activity",
		"emoji_order": "823",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"swimmer": {
		"unicode": "1f3ca",
		"unicode_alt": "",
		"code_decimal": "&#127946;",
		"name": "swimmer",
		"shortname": ":swimmer:",
		"category": "activity",
		"emoji_order": "836",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"workout",
			"sport",
			"swim",
			"diversity"
		]
	},
	"swimmer_tone1": {
		"unicode": "1f3ca-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127946;&#127995;",
		"name": "swimmer tone 1",
		"shortname": ":swimmer_tone1:",
		"category": "activity",
		"emoji_order": "837",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"swimmer_tone2": {
		"unicode": "1f3ca-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127946;&#127996;",
		"name": "swimmer tone 2",
		"shortname": ":swimmer_tone2:",
		"category": "activity",
		"emoji_order": "838",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"swimmer_tone3": {
		"unicode": "1f3ca-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127946;&#127997;",
		"name": "swimmer tone 3",
		"shortname": ":swimmer_tone3:",
		"category": "activity",
		"emoji_order": "839",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"swimmer_tone4": {
		"unicode": "1f3ca-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127946;&#127998;",
		"name": "swimmer tone 4",
		"shortname": ":swimmer_tone4:",
		"category": "activity",
		"emoji_order": "840",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"swimmer_tone5": {
		"unicode": "1f3ca-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127946;&#127999;",
		"name": "swimmer tone 5",
		"shortname": ":swimmer_tone5:",
		"category": "activity",
		"emoji_order": "841",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"basketball_player": {
		"unicode": "26f9",
		"unicode_alt": "26f9-fe0f",
		"code_decimal": "&#9977;",
		"name": "person with ball",
		"shortname": ":basketball_player:",
		"category": "activity",
		"emoji_order": "854",
		"aliases": [
			":person_with_ball:"
		],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"game",
			"ball",
			"sport",
			"basketball",
			"diversity"
		]
	},
	"basketball_player_tone1": {
		"unicode": "26f9-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#9977;&#127995;",
		"name": "person with ball tone 1",
		"shortname": ":basketball_player_tone1:",
		"category": "activity",
		"emoji_order": "855",
		"aliases": [
			":person_with_ball_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"basketball_player_tone2": {
		"unicode": "26f9-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#9977;&#127996;",
		"name": "person with ball tone 2",
		"shortname": ":basketball_player_tone2:",
		"category": "activity",
		"emoji_order": "856",
		"aliases": [
			":person_with_ball_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"basketball_player_tone3": {
		"unicode": "26f9-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#9977;&#127997;",
		"name": "person with ball tone 3",
		"shortname": ":basketball_player_tone3:",
		"category": "activity",
		"emoji_order": "857",
		"aliases": [
			":person_with_ball_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"basketball_player_tone4": {
		"unicode": "26f9-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#9977;&#127998;",
		"name": "person with ball tone 4",
		"shortname": ":basketball_player_tone4:",
		"category": "activity",
		"emoji_order": "858",
		"aliases": [
			":person_with_ball_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"basketball_player_tone5": {
		"unicode": "26f9-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#9977;&#127999;",
		"name": "person with ball tone 5",
		"shortname": ":basketball_player_tone5:",
		"category": "activity",
		"emoji_order": "859",
		"aliases": [
			":person_with_ball_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"lifter": {
		"unicode": "1f3cb",
		"unicode_alt": "1f3cb-fe0f",
		"code_decimal": "&#127947;",
		"name": "weight lifter",
		"shortname": ":lifter:",
		"category": "activity",
		"emoji_order": "872",
		"aliases": [
			":weight_lifter:"
		],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"workout",
			"flex",
			"sport",
			"weight lifting",
			"win",
			"diversity"
		]
	},
	"lifter_tone1": {
		"unicode": "1f3cb-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127947;&#127995;",
		"name": "weight lifter tone 1",
		"shortname": ":lifter_tone1:",
		"category": "activity",
		"emoji_order": "873",
		"aliases": [
			":weight_lifter_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"lifter_tone2": {
		"unicode": "1f3cb-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127947;&#127996;",
		"name": "weight lifter tone 2",
		"shortname": ":lifter_tone2:",
		"category": "activity",
		"emoji_order": "874",
		"aliases": [
			":weight_lifter_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"lifter_tone3": {
		"unicode": "1f3cb-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127947;&#127997;",
		"name": "weight lifter tone 3",
		"shortname": ":lifter_tone3:",
		"category": "activity",
		"emoji_order": "875",
		"aliases": [
			":weight_lifter_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"lifter_tone4": {
		"unicode": "1f3cb-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127947;&#127998;",
		"name": "weight lifter tone 4",
		"shortname": ":lifter_tone4:",
		"category": "activity",
		"emoji_order": "876",
		"aliases": [
			":weight_lifter_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"lifter_tone5": {
		"unicode": "1f3cb-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127947;&#127999;",
		"name": "weight lifter tone 5",
		"shortname": ":lifter_tone5:",
		"category": "activity",
		"emoji_order": "877",
		"aliases": [
			":weight_lifter_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"bicyclist": {
		"unicode": "1f6b4",
		"unicode_alt": "",
		"code_decimal": "&#128692;",
		"name": "bicyclist",
		"shortname": ":bicyclist:",
		"category": "activity",
		"emoji_order": "890",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"workout",
			"sport",
			"bike",
			"diversity"
		]
	},
	"bicyclist_tone1": {
		"unicode": "1f6b4-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128692;&#127995;",
		"name": "bicyclist tone 1",
		"shortname": ":bicyclist_tone1:",
		"category": "activity",
		"emoji_order": "891",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bicyclist_tone2": {
		"unicode": "1f6b4-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128692;&#127996;",
		"name": "bicyclist tone 2",
		"shortname": ":bicyclist_tone2:",
		"category": "activity",
		"emoji_order": "892",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bicyclist_tone3": {
		"unicode": "1f6b4-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128692;&#127997;",
		"name": "bicyclist tone 3",
		"shortname": ":bicyclist_tone3:",
		"category": "activity",
		"emoji_order": "893",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bicyclist_tone4": {
		"unicode": "1f6b4-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128692;&#127998;",
		"name": "bicyclist tone 4",
		"shortname": ":bicyclist_tone4:",
		"category": "activity",
		"emoji_order": "894",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bicyclist_tone5": {
		"unicode": "1f6b4-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128692;&#127999;",
		"name": "bicyclist tone 5",
		"shortname": ":bicyclist_tone5:",
		"category": "activity",
		"emoji_order": "895",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mountain_bicyclist": {
		"unicode": "1f6b5",
		"unicode_alt": "",
		"code_decimal": "&#128693;",
		"name": "mountain bicyclist",
		"shortname": ":mountain_bicyclist:",
		"category": "activity",
		"emoji_order": "908",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"men",
			"sport",
			"bike",
			"diversity"
		]
	},
	"mountain_bicyclist_tone1": {
		"unicode": "1f6b5-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128693;&#127995;",
		"name": "mountain bicyclist tone 1",
		"shortname": ":mountain_bicyclist_tone1:",
		"category": "activity",
		"emoji_order": "909",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mountain_bicyclist_tone2": {
		"unicode": "1f6b5-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128693;&#127996;",
		"name": "mountain bicyclist tone 2",
		"shortname": ":mountain_bicyclist_tone2:",
		"category": "activity",
		"emoji_order": "910",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mountain_bicyclist_tone3": {
		"unicode": "1f6b5-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128693;&#127997;",
		"name": "mountain bicyclist tone 3",
		"shortname": ":mountain_bicyclist_tone3:",
		"category": "activity",
		"emoji_order": "911",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mountain_bicyclist_tone4": {
		"unicode": "1f6b5-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128693;&#127998;",
		"name": "mountain bicyclist tone 4",
		"shortname": ":mountain_bicyclist_tone4:",
		"category": "activity",
		"emoji_order": "912",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mountain_bicyclist_tone5": {
		"unicode": "1f6b5-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128693;&#127999;",
		"name": "mountain bicyclist tone 5",
		"shortname": ":mountain_bicyclist_tone5:",
		"category": "activity",
		"emoji_order": "913",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"race_car": {
		"unicode": "1f3ce",
		"unicode_alt": "1f3ce-fe0f",
		"code_decimal": "&#127950;",
		"name": "racing car",
		"shortname": ":race_car:",
		"category": "travel",
		"emoji_order": "926",
		"aliases": [
			":racing_car:"
		],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car"
		]
	},
	"motorcycle": {
		"unicode": "1f3cd",
		"unicode_alt": "1f3cd-fe0f",
		"code_decimal": "&#127949;",
		"name": "racing motorcycle",
		"shortname": ":motorcycle:",
		"category": "travel",
		"emoji_order": "927",
		"aliases": [
			":racing_motorcycle:"
		],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"bike"
		]
	},
	"cartwheel": {
		"unicode": "1f938",
		"unicode_alt": "",
		"code_decimal": "&#129336;",
		"name": "person doing cartwheel",
		"shortname": ":cartwheel:",
		"category": "activity",
		"emoji_order": "928",
		"aliases": [
			":person_doing_cartwheel:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cartwheel_tone1": {
		"unicode": "1f938-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129336;&#127995;",
		"name": "person doing cartwheel tone 1",
		"shortname": ":cartwheel_tone1:",
		"category": "activity",
		"emoji_order": "929",
		"aliases": [
			":person_doing_cartwheel_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cartwheel_tone2": {
		"unicode": "1f938-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129336;&#127996;",
		"name": "person doing cartwheel tone 2",
		"shortname": ":cartwheel_tone2:",
		"category": "activity",
		"emoji_order": "930",
		"aliases": [
			":person_doing_cartwheel_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cartwheel_tone3": {
		"unicode": "1f938-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129336;&#127997;",
		"name": "person doing cartwheel tone 3",
		"shortname": ":cartwheel_tone3:",
		"category": "activity",
		"emoji_order": "931",
		"aliases": [
			":person_doing_cartwheel_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cartwheel_tone4": {
		"unicode": "1f938-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129336;&#127998;",
		"name": "person doing cartwheel tone 4",
		"shortname": ":cartwheel_tone4:",
		"category": "activity",
		"emoji_order": "932",
		"aliases": [
			":person_doing_cartwheel_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cartwheel_tone5": {
		"unicode": "1f938-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129336;&#127999;",
		"name": "person doing cartwheel tone 5",
		"shortname": ":cartwheel_tone5:",
		"category": "activity",
		"emoji_order": "933",
		"aliases": [
			":person_doing_cartwheel_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wrestlers": {
		"unicode": "1f93c",
		"unicode_alt": "",
		"code_decimal": "&#129340;",
		"name": "wrestlers",
		"shortname": ":wrestlers:",
		"category": "activity",
		"emoji_order": "946",
		"aliases": [
			":wrestling:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wrestlers_tone1": {
		"unicode": "1f93c-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129340;&#127995;",
		"name": "wrestlers tone 1",
		"shortname": ":wrestlers_tone1:",
		"category": "activity",
		"emoji_order": "947",
		"aliases": [
			":wrestling_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wrestlers_tone2": {
		"unicode": "1f93c-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129340;&#127996;",
		"name": "wrestlers tone 2",
		"shortname": ":wrestlers_tone2:",
		"category": "activity",
		"emoji_order": "948",
		"aliases": [
			":wrestling_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wrestlers_tone3": {
		"unicode": "1f93c-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129340;&#127997;",
		"name": "wrestlers tone 3",
		"shortname": ":wrestlers_tone3:",
		"category": "activity",
		"emoji_order": "949",
		"aliases": [
			":wrestling_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wrestlers_tone4": {
		"unicode": "1f93c-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129340;&#127998;",
		"name": "wrestlers tone 4",
		"shortname": ":wrestlers_tone4:",
		"category": "activity",
		"emoji_order": "950",
		"aliases": [
			":wrestling_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wrestlers_tone5": {
		"unicode": "1f93c-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129340;&#127999;",
		"name": "wrestlers tone 5",
		"shortname": ":wrestlers_tone5:",
		"category": "activity",
		"emoji_order": "951",
		"aliases": [
			":wrestling_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"water_polo": {
		"unicode": "1f93d",
		"unicode_alt": "",
		"code_decimal": "&#129341;",
		"name": "water polo",
		"shortname": ":water_polo:",
		"category": "activity",
		"emoji_order": "964",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"water_polo_tone1": {
		"unicode": "1f93d-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129341;&#127995;",
		"name": "water polo tone 1",
		"shortname": ":water_polo_tone1:",
		"category": "activity",
		"emoji_order": "965",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"water_polo_tone2": {
		"unicode": "1f93d-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129341;&#127996;",
		"name": "water polo tone 2",
		"shortname": ":water_polo_tone2:",
		"category": "activity",
		"emoji_order": "966",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"water_polo_tone3": {
		"unicode": "1f93d-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129341;&#127997;",
		"name": "water polo tone 3",
		"shortname": ":water_polo_tone3:",
		"category": "activity",
		"emoji_order": "967",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"water_polo_tone4": {
		"unicode": "1f93d-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129341;&#127998;",
		"name": "water polo tone 4",
		"shortname": ":water_polo_tone4:",
		"category": "activity",
		"emoji_order": "968",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"water_polo_tone5": {
		"unicode": "1f93d-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129341;&#127999;",
		"name": "water polo tone 5",
		"shortname": ":water_polo_tone5:",
		"category": "activity",
		"emoji_order": "969",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handball": {
		"unicode": "1f93e",
		"unicode_alt": "",
		"code_decimal": "&#129342;",
		"name": "handball",
		"shortname": ":handball:",
		"category": "activity",
		"emoji_order": "982",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handball_tone1": {
		"unicode": "1f93e-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129342;&#127995;",
		"name": "handball tone 1",
		"shortname": ":handball_tone1:",
		"category": "activity",
		"emoji_order": "983",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handball_tone2": {
		"unicode": "1f93e-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129342;&#127996;",
		"name": "handball tone 2",
		"shortname": ":handball_tone2:",
		"category": "activity",
		"emoji_order": "984",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handball_tone3": {
		"unicode": "1f93e-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129342;&#127997;",
		"name": "handball tone 3",
		"shortname": ":handball_tone3:",
		"category": "activity",
		"emoji_order": "985",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handball_tone4": {
		"unicode": "1f93e-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129342;&#127998;",
		"name": "handball tone 4",
		"shortname": ":handball_tone4:",
		"category": "activity",
		"emoji_order": "986",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handball_tone5": {
		"unicode": "1f93e-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129342;&#127999;",
		"name": "handball tone 5",
		"shortname": ":handball_tone5:",
		"category": "activity",
		"emoji_order": "987",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"juggling": {
		"unicode": "1f939",
		"unicode_alt": "",
		"code_decimal": "&#129337;",
		"name": "juggling",
		"shortname": ":juggling:",
		"category": "activity",
		"emoji_order": "1000",
		"aliases": [
			":juggler:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"juggling_tone1": {
		"unicode": "1f939-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129337;&#127995;",
		"name": "juggling tone 1",
		"shortname": ":juggling_tone1:",
		"category": "activity",
		"emoji_order": "1001",
		"aliases": [
			":juggler_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"juggling_tone2": {
		"unicode": "1f939-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129337;&#127996;",
		"name": "juggling tone 2",
		"shortname": ":juggling_tone2:",
		"category": "activity",
		"emoji_order": "1002",
		"aliases": [
			":juggler_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"juggling_tone3": {
		"unicode": "1f939-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129337;&#127997;",
		"name": "juggling tone 3",
		"shortname": ":juggling_tone3:",
		"category": "activity",
		"emoji_order": "1003",
		"aliases": [
			":juggler_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"juggling_tone4": {
		"unicode": "1f939-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129337;&#127998;",
		"name": "juggling tone 4",
		"shortname": ":juggling_tone4:",
		"category": "activity",
		"emoji_order": "1004",
		"aliases": [
			":juggler_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"juggling_tone5": {
		"unicode": "1f939-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129337;&#127999;",
		"name": "juggling tone 5",
		"shortname": ":juggling_tone5:",
		"category": "activity",
		"emoji_order": "1005",
		"aliases": [
			":juggler_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"couple": {
		"unicode": "1f46b",
		"unicode_alt": "",
		"code_decimal": "&#128107;",
		"name": "man and woman holding hands",
		"shortname": ":couple:",
		"category": "people",
		"emoji_order": "1018",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"sex",
			"creationism"
		]
	},
	"two_men_holding_hands": {
		"unicode": "1f46c",
		"unicode_alt": "",
		"code_decimal": "&#128108;",
		"name": "two men holding hands",
		"shortname": ":two_men_holding_hands:",
		"category": "people",
		"emoji_order": "1024",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"men",
			"sex",
			"lgbt"
		]
	},
	"two_women_holding_hands": {
		"unicode": "1f46d",
		"unicode_alt": "",
		"code_decimal": "&#128109;",
		"name": "two women holding hands",
		"shortname": ":two_women_holding_hands:",
		"category": "people",
		"emoji_order": "1030",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"sex",
			"lgbt",
			"lesbian",
			"girls night"
		]
	},
	"couplekiss": {
		"unicode": "1f48f",
		"unicode_alt": "",
		"code_decimal": "&#128143;",
		"name": "kiss",
		"shortname": ":couplekiss:",
		"category": "people",
		"emoji_order": "1036",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"love",
			"sex"
		]
	},
	"kiss_mm": {
		"unicode": "1f468-2764-1f48b-1f468",
		"unicode_alt": "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
		"code_decimal": "&#128104;&#10084;&#128139;&#128104;",
		"name": "kiss (man,man)",
		"shortname": ":kiss_mm:",
		"category": "people",
		"emoji_order": "1038",
		"aliases": [
			":couplekiss_mm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"men",
			"love",
			"sex",
			"lgbt"
		]
	},
	"kiss_ww": {
		"unicode": "1f469-2764-1f48b-1f469",
		"unicode_alt": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
		"code_decimal": "&#128105;&#10084;&#128139;&#128105;",
		"name": "kiss (woman,woman)",
		"shortname": ":kiss_ww:",
		"category": "people",
		"emoji_order": "1039",
		"aliases": [
			":couplekiss_ww:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"love",
			"sex",
			"lgbt",
			"lesbian"
		]
	},
	"couple_with_heart": {
		"unicode": "1f491",
		"unicode_alt": "",
		"code_decimal": "&#128145;",
		"name": "couple with heart",
		"shortname": ":couple_with_heart:",
		"category": "people",
		"emoji_order": "1040",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"love",
			"sex"
		]
	},
	"couple_mm": {
		"unicode": "1f468-2764-1f468",
		"unicode_alt": "1f468-200d-2764-fe0f-200d-1f468",
		"code_decimal": "&#128104;&#10084;&#128104;",
		"name": "couple (man,man)",
		"shortname": ":couple_mm:",
		"category": "people",
		"emoji_order": "1042",
		"aliases": [
			":couple_with_heart_mm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"men",
			"love",
			"sex",
			"lgbt"
		]
	},
	"couple_ww": {
		"unicode": "1f469-2764-1f469",
		"unicode_alt": "1f469-200d-2764-fe0f-200d-1f469",
		"code_decimal": "&#128105;&#10084;&#128105;",
		"name": "couple (woman,woman)",
		"shortname": ":couple_ww:",
		"category": "people",
		"emoji_order": "1043",
		"aliases": [
			":couple_with_heart_ww:"
		],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"women",
			"love",
			"sex",
			"lgbt"
		]
	},
	"family": {
		"unicode": "1f46a",
		"unicode_alt": "",
		"code_decimal": "&#128106;",
		"name": "family",
		"shortname": ":family:",
		"category": "people",
		"emoji_order": "1044",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"baby"
		]
	},
	"family_mwg": {
		"unicode": "1f468-1f469-1f467",
		"unicode_alt": "1f468-200d-1f469-200d-1f467",
		"code_decimal": "&#128104;&#128105;&#128103;",
		"name": "family (man,woman,girl)",
		"shortname": ":family_mwg:",
		"category": "people",
		"emoji_order": "1051",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"baby"
		]
	},
	"family_mwgb": {
		"unicode": "1f468-1f469-1f467-1f466",
		"unicode_alt": "1f468-200d-1f469-200d-1f467-200d-1f466",
		"code_decimal": "&#128104;&#128105;&#128103;&#128102;",
		"name": "family (man,woman,girl,boy)",
		"shortname": ":family_mwgb:",
		"category": "people",
		"emoji_order": "1052",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"baby"
		]
	},
	"family_mwbb": {
		"unicode": "1f468-1f469-1f466-1f466",
		"unicode_alt": "1f468-200d-1f469-200d-1f466-200d-1f466",
		"code_decimal": "&#128104;&#128105;&#128102;&#128102;",
		"name": "family (man,woman,boy,boy)",
		"shortname": ":family_mwbb:",
		"category": "people",
		"emoji_order": "1053",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"baby"
		]
	},
	"family_mwgg": {
		"unicode": "1f468-1f469-1f467-1f467",
		"unicode_alt": "1f468-200d-1f469-200d-1f467-200d-1f467",
		"code_decimal": "&#128104;&#128105;&#128103;&#128103;",
		"name": "family (man,woman,girl,girl)",
		"shortname": ":family_mwgg:",
		"category": "people",
		"emoji_order": "1054",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"baby"
		]
	},
	"family_mmb": {
		"unicode": "1f468-1f468-1f466",
		"unicode_alt": "1f468-200d-1f468-200d-1f466",
		"code_decimal": "&#128104;&#128104;&#128102;",
		"name": "family (man,man,boy)",
		"shortname": ":family_mmb:",
		"category": "people",
		"emoji_order": "1055",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"family",
			"men",
			"baby",
			"lgbt"
		]
	},
	"family_mmg": {
		"unicode": "1f468-1f468-1f467",
		"unicode_alt": "1f468-200d-1f468-200d-1f467",
		"code_decimal": "&#128104;&#128104;&#128103;",
		"name": "family (man,man,girl)",
		"shortname": ":family_mmg:",
		"category": "people",
		"emoji_order": "1056",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"family",
			"men",
			"baby",
			"lgbt"
		]
	},
	"family_mmgb": {
		"unicode": "1f468-1f468-1f467-1f466",
		"unicode_alt": "1f468-200d-1f468-200d-1f467-200d-1f466",
		"code_decimal": "&#128104;&#128104;&#128103;&#128102;",
		"name": "family (man,man,girl,boy)",
		"shortname": ":family_mmgb:",
		"category": "people",
		"emoji_order": "1057",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"family",
			"men",
			"baby",
			"lgbt"
		]
	},
	"family_mmbb": {
		"unicode": "1f468-1f468-1f466-1f466",
		"unicode_alt": "1f468-200d-1f468-200d-1f466-200d-1f466",
		"code_decimal": "&#128104;&#128104;&#128102;&#128102;",
		"name": "family (man,man,boy,boy)",
		"shortname": ":family_mmbb:",
		"category": "people",
		"emoji_order": "1058",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"family",
			"men",
			"baby",
			"lgbt"
		]
	},
	"family_mmgg": {
		"unicode": "1f468-1f468-1f467-1f467",
		"unicode_alt": "1f468-200d-1f468-200d-1f467-200d-1f467",
		"code_decimal": "&#128104;&#128104;&#128103;&#128103;",
		"name": "family (man,man,girl,girl)",
		"shortname": ":family_mmgg:",
		"category": "people",
		"emoji_order": "1059",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"gay",
			"family",
			"men",
			"baby",
			"lgbt"
		]
	},
	"family_wwb": {
		"unicode": "1f469-1f469-1f466",
		"unicode_alt": "1f469-200d-1f469-200d-1f466",
		"code_decimal": "&#128105;&#128105;&#128102;",
		"name": "family (woman,woman,boy)",
		"shortname": ":family_wwb:",
		"category": "people",
		"emoji_order": "1060",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"women",
			"baby",
			"lgbt",
			"lesbian"
		]
	},
	"family_wwg": {
		"unicode": "1f469-1f469-1f467",
		"unicode_alt": "1f469-200d-1f469-200d-1f467",
		"code_decimal": "&#128105;&#128105;&#128103;",
		"name": "family (woman,woman,girl)",
		"shortname": ":family_wwg:",
		"category": "people",
		"emoji_order": "1061",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"women",
			"baby",
			"lgbt",
			"lesbian"
		]
	},
	"family_wwgb": {
		"unicode": "1f469-1f469-1f467-1f466",
		"unicode_alt": "1f469-200d-1f469-200d-1f467-200d-1f466",
		"code_decimal": "&#128105;&#128105;&#128103;&#128102;",
		"name": "family (woman,woman,girl,boy)",
		"shortname": ":family_wwgb:",
		"category": "people",
		"emoji_order": "1062",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"women",
			"baby",
			"lgbt",
			"lesbian"
		]
	},
	"family_wwbb": {
		"unicode": "1f469-1f469-1f466-1f466",
		"unicode_alt": "1f469-200d-1f469-200d-1f466-200d-1f466",
		"code_decimal": "&#128105;&#128105;&#128102;&#128102;",
		"name": "family (woman,woman,boy,boy)",
		"shortname": ":family_wwbb:",
		"category": "people",
		"emoji_order": "1063",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"women",
			"baby",
			"lgbt",
			"lesbian"
		]
	},
	"family_wwgg": {
		"unicode": "1f469-1f469-1f467-1f467",
		"unicode_alt": "1f469-200d-1f469-200d-1f467-200d-1f467",
		"code_decimal": "&#128105;&#128105;&#128103;&#128103;",
		"name": "family (woman,woman,girl,girl)",
		"shortname": ":family_wwgg:",
		"category": "people",
		"emoji_order": "1064",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"family",
			"women",
			"baby",
			"lgbt",
			"lesbian"
		]
	},
	"tone1": {
		"unicode": "1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#127995;",
		"name": "emoji modifier Fitzpatrick type-1-2",
		"shortname": ":tone1:",
		"category": "modifier",
		"emoji_order": "1075",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"tone2": {
		"unicode": "1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#127996;",
		"name": "emoji modifier Fitzpatrick type-3",
		"shortname": ":tone2:",
		"category": "modifier",
		"emoji_order": "1076",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"tone3": {
		"unicode": "1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#127997;",
		"name": "emoji modifier Fitzpatrick type-4",
		"shortname": ":tone3:",
		"category": "modifier",
		"emoji_order": "1077",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"tone4": {
		"unicode": "1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#127998;",
		"name": "emoji modifier Fitzpatrick type-5",
		"shortname": ":tone4:",
		"category": "modifier",
		"emoji_order": "1078",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"tone5": {
		"unicode": "1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#127999;",
		"name": "emoji modifier Fitzpatrick type-6",
		"shortname": ":tone5:",
		"category": "modifier",
		"emoji_order": "1079",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"muscle": {
		"unicode": "1f4aa",
		"unicode_alt": "",
		"code_decimal": "&#128170;",
		"name": "flexed biceps",
		"shortname": ":muscle:",
		"category": "people",
		"emoji_order": "1080",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"workout",
			"flex",
			"win",
			"diversity",
			"feminist",
			"boys night"
		]
	},
	"muscle_tone1": {
		"unicode": "1f4aa-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128170;&#127995;",
		"name": "flexed biceps tone 1",
		"shortname": ":muscle_tone1:",
		"category": "people",
		"emoji_order": "1081",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"muscle_tone2": {
		"unicode": "1f4aa-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128170;&#127996;",
		"name": "flexed biceps tone 2",
		"shortname": ":muscle_tone2:",
		"category": "people",
		"emoji_order": "1082",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"muscle_tone3": {
		"unicode": "1f4aa-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128170;&#127997;",
		"name": "flexed biceps tone 3",
		"shortname": ":muscle_tone3:",
		"category": "people",
		"emoji_order": "1083",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"muscle_tone4": {
		"unicode": "1f4aa-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128170;&#127998;",
		"name": "flexed biceps tone 4",
		"shortname": ":muscle_tone4:",
		"category": "people",
		"emoji_order": "1084",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"muscle_tone5": {
		"unicode": "1f4aa-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128170;&#127999;",
		"name": "flexed biceps tone 5",
		"shortname": ":muscle_tone5:",
		"category": "people",
		"emoji_order": "1085",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"selfie": {
		"unicode": "1f933",
		"unicode_alt": "",
		"code_decimal": "&#129331;",
		"name": "selfie",
		"shortname": ":selfie:",
		"category": "people",
		"emoji_order": "1086",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"selfie_tone1": {
		"unicode": "1f933-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129331;&#127995;",
		"name": "selfie tone 1",
		"shortname": ":selfie_tone1:",
		"category": "people",
		"emoji_order": "1087",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"selfie_tone2": {
		"unicode": "1f933-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129331;&#127996;",
		"name": "selfie tone 2",
		"shortname": ":selfie_tone2:",
		"category": "people",
		"emoji_order": "1088",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"selfie_tone3": {
		"unicode": "1f933-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129331;&#127997;",
		"name": "selfie tone 3",
		"shortname": ":selfie_tone3:",
		"category": "people",
		"emoji_order": "1089",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"selfie_tone4": {
		"unicode": "1f933-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129331;&#127998;",
		"name": "selfie tone 4",
		"shortname": ":selfie_tone4:",
		"category": "people",
		"emoji_order": "1090",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"selfie_tone5": {
		"unicode": "1f933-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129331;&#127999;",
		"name": "selfie tone 5",
		"shortname": ":selfie_tone5:",
		"category": "people",
		"emoji_order": "1091",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_left": {
		"unicode": "1f448",
		"unicode_alt": "",
		"code_decimal": "&#128072;",
		"name": "white left pointing backhand index",
		"shortname": ":point_left:",
		"category": "people",
		"emoji_order": "1092",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity"
		]
	},
	"point_left_tone1": {
		"unicode": "1f448-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128072;&#127995;",
		"name": "white left pointing backhand index tone 1",
		"shortname": ":point_left_tone1:",
		"category": "people",
		"emoji_order": "1093",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_left_tone2": {
		"unicode": "1f448-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128072;&#127996;",
		"name": "white left pointing backhand index tone 2",
		"shortname": ":point_left_tone2:",
		"category": "people",
		"emoji_order": "1094",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_left_tone3": {
		"unicode": "1f448-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128072;&#127997;",
		"name": "white left pointing backhand index tone 3",
		"shortname": ":point_left_tone3:",
		"category": "people",
		"emoji_order": "1095",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_left_tone4": {
		"unicode": "1f448-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128072;&#127998;",
		"name": "white left pointing backhand index tone 4",
		"shortname": ":point_left_tone4:",
		"category": "people",
		"emoji_order": "1096",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_left_tone5": {
		"unicode": "1f448-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128072;&#127999;",
		"name": "white left pointing backhand index tone 5",
		"shortname": ":point_left_tone5:",
		"category": "people",
		"emoji_order": "1097",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_right": {
		"unicode": "1f449",
		"unicode_alt": "",
		"code_decimal": "&#128073;",
		"name": "white right pointing backhand index",
		"shortname": ":point_right:",
		"category": "people",
		"emoji_order": "1098",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity"
		]
	},
	"point_right_tone1": {
		"unicode": "1f449-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128073;&#127995;",
		"name": "white right pointing backhand index tone 1",
		"shortname": ":point_right_tone1:",
		"category": "people",
		"emoji_order": "1099",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_right_tone2": {
		"unicode": "1f449-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128073;&#127996;",
		"name": "white right pointing backhand index tone 2",
		"shortname": ":point_right_tone2:",
		"category": "people",
		"emoji_order": "1100",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_right_tone3": {
		"unicode": "1f449-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128073;&#127997;",
		"name": "white right pointing backhand index tone 3",
		"shortname": ":point_right_tone3:",
		"category": "people",
		"emoji_order": "1101",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_right_tone4": {
		"unicode": "1f449-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128073;&#127998;",
		"name": "white right pointing backhand index tone 4",
		"shortname": ":point_right_tone4:",
		"category": "people",
		"emoji_order": "1102",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_right_tone5": {
		"unicode": "1f449-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128073;&#127999;",
		"name": "white right pointing backhand index tone 5",
		"shortname": ":point_right_tone5:",
		"category": "people",
		"emoji_order": "1103",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up": {
		"unicode": "261d",
		"unicode_alt": "261d-fe0f",
		"code_decimal": "&#9757;",
		"name": "white up pointing index",
		"shortname": ":point_up:",
		"category": "people",
		"emoji_order": "1104",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"emojione",
			"diversity"
		]
	},
	"point_up_tone1": {
		"unicode": "261d-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#9757;&#127995;",
		"name": "white up pointing index tone 1",
		"shortname": ":point_up_tone1:",
		"category": "people",
		"emoji_order": "1105",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_tone2": {
		"unicode": "261d-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#9757;&#127996;",
		"name": "white up pointing index tone 2",
		"shortname": ":point_up_tone2:",
		"category": "people",
		"emoji_order": "1106",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_tone3": {
		"unicode": "261d-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#9757;&#127997;",
		"name": "white up pointing index tone 3",
		"shortname": ":point_up_tone3:",
		"category": "people",
		"emoji_order": "1107",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_tone4": {
		"unicode": "261d-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#9757;&#127998;",
		"name": "white up pointing index tone 4",
		"shortname": ":point_up_tone4:",
		"category": "people",
		"emoji_order": "1108",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_tone5": {
		"unicode": "261d-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#9757;&#127999;",
		"name": "white up pointing index tone 5",
		"shortname": ":point_up_tone5:",
		"category": "people",
		"emoji_order": "1109",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_2": {
		"unicode": "1f446",
		"unicode_alt": "",
		"code_decimal": "&#128070;",
		"name": "white up pointing backhand index",
		"shortname": ":point_up_2:",
		"category": "people",
		"emoji_order": "1110",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"diversity"
		]
	},
	"point_up_2_tone1": {
		"unicode": "1f446-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128070;&#127995;",
		"name": "white up pointing backhand index tone 1",
		"shortname": ":point_up_2_tone1:",
		"category": "people",
		"emoji_order": "1111",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_2_tone2": {
		"unicode": "1f446-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128070;&#127996;",
		"name": "white up pointing backhand index tone 2",
		"shortname": ":point_up_2_tone2:",
		"category": "people",
		"emoji_order": "1112",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_2_tone3": {
		"unicode": "1f446-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128070;&#127997;",
		"name": "white up pointing backhand index tone 3",
		"shortname": ":point_up_2_tone3:",
		"category": "people",
		"emoji_order": "1113",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_2_tone4": {
		"unicode": "1f446-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128070;&#127998;",
		"name": "white up pointing backhand index tone 4",
		"shortname": ":point_up_2_tone4:",
		"category": "people",
		"emoji_order": "1114",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_up_2_tone5": {
		"unicode": "1f446-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128070;&#127999;",
		"name": "white up pointing backhand index tone 5",
		"shortname": ":point_up_2_tone5:",
		"category": "people",
		"emoji_order": "1115",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"middle_finger": {
		"unicode": "1f595",
		"unicode_alt": "",
		"code_decimal": "&#128405;",
		"name": "reversed hand with middle finger extended",
		"shortname": ":middle_finger:",
		"category": "people",
		"emoji_order": "1116",
		"aliases": [
			":reversed_hand_with_middle_finger_extended:"
		],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"middle finger",
			"diversity"
		]
	},
	"middle_finger_tone1": {
		"unicode": "1f595-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128405;&#127995;",
		"name": "reversed hand with middle finger extended tone 1",
		"shortname": ":middle_finger_tone1:",
		"category": "people",
		"emoji_order": "1117",
		"aliases": [
			":reversed_hand_with_middle_finger_extended_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"middle_finger_tone2": {
		"unicode": "1f595-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128405;&#127996;",
		"name": "reversed hand with middle finger extended tone 2",
		"shortname": ":middle_finger_tone2:",
		"category": "people",
		"emoji_order": "1118",
		"aliases": [
			":reversed_hand_with_middle_finger_extended_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"middle_finger_tone3": {
		"unicode": "1f595-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128405;&#127997;",
		"name": "reversed hand with middle finger extended tone 3",
		"shortname": ":middle_finger_tone3:",
		"category": "people",
		"emoji_order": "1119",
		"aliases": [
			":reversed_hand_with_middle_finger_extended_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"middle_finger_tone4": {
		"unicode": "1f595-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128405;&#127998;",
		"name": "reversed hand with middle finger extended tone 4",
		"shortname": ":middle_finger_tone4:",
		"category": "people",
		"emoji_order": "1120",
		"aliases": [
			":reversed_hand_with_middle_finger_extended_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"middle_finger_tone5": {
		"unicode": "1f595-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128405;&#127999;",
		"name": "reversed hand with middle finger extended tone 5",
		"shortname": ":middle_finger_tone5:",
		"category": "people",
		"emoji_order": "1121",
		"aliases": [
			":reversed_hand_with_middle_finger_extended_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_down": {
		"unicode": "1f447",
		"unicode_alt": "",
		"code_decimal": "&#128071;",
		"name": "white down pointing backhand index",
		"shortname": ":point_down:",
		"category": "people",
		"emoji_order": "1122",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"diversity"
		]
	},
	"point_down_tone1": {
		"unicode": "1f447-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128071;&#127995;",
		"name": "white down pointing backhand index tone 1",
		"shortname": ":point_down_tone1:",
		"category": "people",
		"emoji_order": "1123",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_down_tone2": {
		"unicode": "1f447-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128071;&#127996;",
		"name": "white down pointing backhand index tone 2",
		"shortname": ":point_down_tone2:",
		"category": "people",
		"emoji_order": "1124",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_down_tone3": {
		"unicode": "1f447-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128071;&#127997;",
		"name": "white down pointing backhand index tone 3",
		"shortname": ":point_down_tone3:",
		"category": "people",
		"emoji_order": "1125",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_down_tone4": {
		"unicode": "1f447-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128071;&#127998;",
		"name": "white down pointing backhand index tone 4",
		"shortname": ":point_down_tone4:",
		"category": "people",
		"emoji_order": "1126",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"point_down_tone5": {
		"unicode": "1f447-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128071;&#127999;",
		"name": "white down pointing backhand index tone 5",
		"shortname": ":point_down_tone5:",
		"category": "people",
		"emoji_order": "1127",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"v": {
		"unicode": "270c",
		"unicode_alt": "270c-fe0f",
		"code_decimal": "&#9996;",
		"name": "victory hand",
		"shortname": ":v:",
		"category": "people",
		"emoji_order": "1128",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"thank you",
			"peace",
			"diversity",
			"girls night"
		]
	},
	"v_tone1": {
		"unicode": "270c-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#9996;&#127995;",
		"name": "victory hand tone 1",
		"shortname": ":v_tone1:",
		"category": "people",
		"emoji_order": "1129",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"v_tone2": {
		"unicode": "270c-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#9996;&#127996;",
		"name": "victory hand tone 2",
		"shortname": ":v_tone2:",
		"category": "people",
		"emoji_order": "1130",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"v_tone3": {
		"unicode": "270c-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#9996;&#127997;",
		"name": "victory hand tone 3",
		"shortname": ":v_tone3:",
		"category": "people",
		"emoji_order": "1131",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"v_tone4": {
		"unicode": "270c-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#9996;&#127998;",
		"name": "victory hand tone 4",
		"shortname": ":v_tone4:",
		"category": "people",
		"emoji_order": "1132",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"v_tone5": {
		"unicode": "270c-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#9996;&#127999;",
		"name": "victory hand tone 5",
		"shortname": ":v_tone5:",
		"category": "people",
		"emoji_order": "1133",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"fingers_crossed": {
		"unicode": "1f91e",
		"unicode_alt": "",
		"code_decimal": "&#129310;",
		"name": "hand with first and index finger crossed",
		"shortname": ":fingers_crossed:",
		"category": "people",
		"emoji_order": "1134",
		"aliases": [
			":hand_with_index_and_middle_finger_crossed:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"fingers_crossed_tone1": {
		"unicode": "1f91e-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129310;&#127995;",
		"name": "hand with index and middle fingers crossed tone 1",
		"shortname": ":fingers_crossed_tone1:",
		"category": "people",
		"emoji_order": "1135",
		"aliases": [
			":hand_with_index_and_middle_fingers_crossed_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"fingers_crossed_tone2": {
		"unicode": "1f91e-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129310;&#127996;",
		"name": "hand with index and middle fingers crossed tone 2",
		"shortname": ":fingers_crossed_tone2:",
		"category": "people",
		"emoji_order": "1136",
		"aliases": [
			":hand_with_index_and_middle_fingers_crossed_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"fingers_crossed_tone3": {
		"unicode": "1f91e-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129310;&#127997;",
		"name": "hand with index and middle fingers crossed tone 3",
		"shortname": ":fingers_crossed_tone3:",
		"category": "people",
		"emoji_order": "1137",
		"aliases": [
			":hand_with_index_and_middle_fingers_crossed_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"fingers_crossed_tone4": {
		"unicode": "1f91e-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129310;&#127998;",
		"name": "hand with index and middle fingers crossed tone 4",
		"shortname": ":fingers_crossed_tone4:",
		"category": "people",
		"emoji_order": "1138",
		"aliases": [
			":hand_with_index_and_middle_fingers_crossed_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"fingers_crossed_tone5": {
		"unicode": "1f91e-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129310;&#127999;",
		"name": "hand with index and middle fingers crossed tone 5",
		"shortname": ":fingers_crossed_tone5:",
		"category": "people",
		"emoji_order": "1139",
		"aliases": [
			":hand_with_index_and_middle_fingers_crossed_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"vulcan": {
		"unicode": "1f596",
		"unicode_alt": "",
		"code_decimal": "&#128406;",
		"name": "raised hand with part between middle and ring fingers",
		"shortname": ":vulcan:",
		"category": "people",
		"emoji_order": "1140",
		"aliases": [
			":raised_hand_with_part_between_middle_and_ring_fingers:"
		],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity"
		]
	},
	"vulcan_tone1": {
		"unicode": "1f596-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128406;&#127995;",
		"name": "raised hand with part between middle and ring fingers tone 1",
		"shortname": ":vulcan_tone1:",
		"category": "people",
		"emoji_order": "1141",
		"aliases": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"vulcan_tone2": {
		"unicode": "1f596-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128406;&#127996;",
		"name": "raised hand with part between middle and ring fingers tone 2",
		"shortname": ":vulcan_tone2:",
		"category": "people",
		"emoji_order": "1142",
		"aliases": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"vulcan_tone3": {
		"unicode": "1f596-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128406;&#127997;",
		"name": "raised hand with part between middle and ring fingers tone 3",
		"shortname": ":vulcan_tone3:",
		"category": "people",
		"emoji_order": "1143",
		"aliases": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"vulcan_tone4": {
		"unicode": "1f596-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128406;&#127998;",
		"name": "raised hand with part between middle and ring fingers tone 4",
		"shortname": ":vulcan_tone4:",
		"category": "people",
		"emoji_order": "1144",
		"aliases": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"vulcan_tone5": {
		"unicode": "1f596-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128406;&#127999;",
		"name": "raised hand with part between middle and ring fingers tone 5",
		"shortname": ":vulcan_tone5:",
		"category": "people",
		"emoji_order": "1145",
		"aliases": [
			":raised_hand_with_part_between_middle_and_ring_fingers_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"metal": {
		"unicode": "1f918",
		"unicode_alt": "",
		"code_decimal": "&#129304;",
		"name": "sign of the horns",
		"shortname": ":metal:",
		"category": "people",
		"emoji_order": "1146",
		"aliases": [
			":sign_of_the_horns:"
		],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity",
			"boys night",
			"parties"
		]
	},
	"metal_tone1": {
		"unicode": "1f918-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129304;&#127995;",
		"name": "sign of the horns tone 1",
		"shortname": ":metal_tone1:",
		"category": "people",
		"emoji_order": "1147",
		"aliases": [
			":sign_of_the_horns_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"metal_tone2": {
		"unicode": "1f918-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129304;&#127996;",
		"name": "sign of the horns tone 2",
		"shortname": ":metal_tone2:",
		"category": "people",
		"emoji_order": "1148",
		"aliases": [
			":sign_of_the_horns_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"metal_tone3": {
		"unicode": "1f918-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129304;&#127997;",
		"name": "sign of the horns tone 3",
		"shortname": ":metal_tone3:",
		"category": "people",
		"emoji_order": "1149",
		"aliases": [
			":sign_of_the_horns_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"metal_tone4": {
		"unicode": "1f918-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129304;&#127998;",
		"name": "sign of the horns tone 4",
		"shortname": ":metal_tone4:",
		"category": "people",
		"emoji_order": "1150",
		"aliases": [
			":sign_of_the_horns_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"metal_tone5": {
		"unicode": "1f918-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129304;&#127999;",
		"name": "sign of the horns tone 5",
		"shortname": ":metal_tone5:",
		"category": "people",
		"emoji_order": "1151",
		"aliases": [
			":sign_of_the_horns_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"call_me": {
		"unicode": "1f919",
		"unicode_alt": "",
		"code_decimal": "&#129305;",
		"name": "call me hand",
		"shortname": ":call_me:",
		"category": "people",
		"emoji_order": "1152",
		"aliases": [
			":call_me_hand:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"call_me_tone1": {
		"unicode": "1f919-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129305;&#127995;",
		"name": "call me hand tone 1",
		"shortname": ":call_me_tone1:",
		"category": "people",
		"emoji_order": "1153",
		"aliases": [
			":call_me_hand_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"call_me_tone2": {
		"unicode": "1f919-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129305;&#127996;",
		"name": "call me hand tone 2",
		"shortname": ":call_me_tone2:",
		"category": "people",
		"emoji_order": "1154",
		"aliases": [
			":call_me_hand_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"call_me_tone3": {
		"unicode": "1f919-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129305;&#127997;",
		"name": "call me hand tone 3",
		"shortname": ":call_me_tone3:",
		"category": "people",
		"emoji_order": "1155",
		"aliases": [
			":call_me_hand_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"call_me_tone4": {
		"unicode": "1f919-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129305;&#127998;",
		"name": "call me hand tone 4",
		"shortname": ":call_me_tone4:",
		"category": "people",
		"emoji_order": "1156",
		"aliases": [
			":call_me_hand_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"call_me_tone5": {
		"unicode": "1f919-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129305;&#127999;",
		"name": "call me hand tone 5",
		"shortname": ":call_me_tone5:",
		"category": "people",
		"emoji_order": "1157",
		"aliases": [
			":call_me_hand_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"hand_splayed": {
		"unicode": "1f590",
		"unicode_alt": "1f590-fe0f",
		"code_decimal": "&#128400;",
		"name": "raised hand with fingers splayed",
		"shortname": ":hand_splayed:",
		"category": "people",
		"emoji_order": "1158",
		"aliases": [
			":raised_hand_with_fingers_splayed:"
		],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity"
		]
	},
	"hand_splayed_tone1": {
		"unicode": "1f590-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128400;&#127995;",
		"name": "raised hand with fingers splayed tone 1",
		"shortname": ":hand_splayed_tone1:",
		"category": "people",
		"emoji_order": "1159",
		"aliases": [
			":raised_hand_with_fingers_splayed_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"hand_splayed_tone2": {
		"unicode": "1f590-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128400;&#127996;",
		"name": "raised hand with fingers splayed tone 2",
		"shortname": ":hand_splayed_tone2:",
		"category": "people",
		"emoji_order": "1160",
		"aliases": [
			":raised_hand_with_fingers_splayed_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"hand_splayed_tone3": {
		"unicode": "1f590-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128400;&#127997;",
		"name": "raised hand with fingers splayed tone 3",
		"shortname": ":hand_splayed_tone3:",
		"category": "people",
		"emoji_order": "1161",
		"aliases": [
			":raised_hand_with_fingers_splayed_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"hand_splayed_tone4": {
		"unicode": "1f590-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128400;&#127998;",
		"name": "raised hand with fingers splayed tone 4",
		"shortname": ":hand_splayed_tone4:",
		"category": "people",
		"emoji_order": "1162",
		"aliases": [
			":raised_hand_with_fingers_splayed_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"hand_splayed_tone5": {
		"unicode": "1f590-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128400;&#127999;",
		"name": "raised hand with fingers splayed tone 5",
		"shortname": ":hand_splayed_tone5:",
		"category": "people",
		"emoji_order": "1163",
		"aliases": [
			":raised_hand_with_fingers_splayed_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hand": {
		"unicode": "270b",
		"unicode_alt": "",
		"code_decimal": "&#9995;",
		"name": "raised hand",
		"shortname": ":raised_hand:",
		"category": "people",
		"emoji_order": "1164",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity",
			"girls night"
		]
	},
	"raised_hand_tone1": {
		"unicode": "270b-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#9995;&#127995;",
		"name": "raised hand tone 1",
		"shortname": ":raised_hand_tone1:",
		"category": "people",
		"emoji_order": "1165",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hand_tone2": {
		"unicode": "270b-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#9995;&#127996;",
		"name": "raised hand tone 2",
		"shortname": ":raised_hand_tone2:",
		"category": "people",
		"emoji_order": "1166",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hand_tone3": {
		"unicode": "270b-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#9995;&#127997;",
		"name": "raised hand tone 3",
		"shortname": ":raised_hand_tone3:",
		"category": "people",
		"emoji_order": "1167",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hand_tone4": {
		"unicode": "270b-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#9995;&#127998;",
		"name": "raised hand tone 4",
		"shortname": ":raised_hand_tone4:",
		"category": "people",
		"emoji_order": "1168",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hand_tone5": {
		"unicode": "270b-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#9995;&#127999;",
		"name": "raised hand tone 5",
		"shortname": ":raised_hand_tone5:",
		"category": "people",
		"emoji_order": "1169",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_hand": {
		"unicode": "1f44c",
		"unicode_alt": "",
		"code_decimal": "&#128076;",
		"name": "ok hand sign",
		"shortname": ":ok_hand:",
		"category": "people",
		"emoji_order": "1170",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity",
			"perfect",
			"good",
			"beautiful"
		]
	},
	"ok_hand_tone1": {
		"unicode": "1f44c-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128076;&#127995;",
		"name": "ok hand sign tone 1",
		"shortname": ":ok_hand_tone1:",
		"category": "people",
		"emoji_order": "1171",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_hand_tone2": {
		"unicode": "1f44c-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128076;&#127996;",
		"name": "ok hand sign tone 2",
		"shortname": ":ok_hand_tone2:",
		"category": "people",
		"emoji_order": "1172",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_hand_tone3": {
		"unicode": "1f44c-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128076;&#127997;",
		"name": "ok hand sign tone 3",
		"shortname": ":ok_hand_tone3:",
		"category": "people",
		"emoji_order": "1173",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_hand_tone4": {
		"unicode": "1f44c-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128076;&#127998;",
		"name": "ok hand sign tone 4",
		"shortname": ":ok_hand_tone4:",
		"category": "people",
		"emoji_order": "1174",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ok_hand_tone5": {
		"unicode": "1f44c-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128076;&#127999;",
		"name": "ok hand sign tone 5",
		"shortname": ":ok_hand_tone5:",
		"category": "people",
		"emoji_order": "1175",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsup": {
		"unicode": "1f44d",
		"unicode_alt": "",
		"code_decimal": "&#128077;",
		"name": "thumbs up sign",
		"shortname": ":thumbsup:",
		"category": "people",
		"emoji_order": "1176",
		"aliases": [
			":+1:",
			":thumbup:"
		],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"luck",
			"thank you",
			"diversity",
			"perfect",
			"good",
			"beautiful"
		]
	},
	"thumbsup_tone1": {
		"unicode": "1f44d-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128077;&#127995;",
		"name": "thumbs up sign tone 1",
		"shortname": ":thumbsup_tone1:",
		"category": "people",
		"emoji_order": "1177",
		"aliases": [
			":+1_tone1:",
			":thumbup_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsup_tone2": {
		"unicode": "1f44d-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128077;&#127996;",
		"name": "thumbs up sign tone 2",
		"shortname": ":thumbsup_tone2:",
		"category": "people",
		"emoji_order": "1178",
		"aliases": [
			":+1_tone2:",
			":thumbup_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsup_tone3": {
		"unicode": "1f44d-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128077;&#127997;",
		"name": "thumbs up sign tone 3",
		"shortname": ":thumbsup_tone3:",
		"category": "people",
		"emoji_order": "1179",
		"aliases": [
			":+1_tone3:",
			":thumbup_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsup_tone4": {
		"unicode": "1f44d-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128077;&#127998;",
		"name": "thumbs up sign tone 4",
		"shortname": ":thumbsup_tone4:",
		"category": "people",
		"emoji_order": "1180",
		"aliases": [
			":+1_tone4:",
			":thumbup_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsup_tone5": {
		"unicode": "1f44d-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128077;&#127999;",
		"name": "thumbs up sign tone 5",
		"shortname": ":thumbsup_tone5:",
		"category": "people",
		"emoji_order": "1181",
		"aliases": [
			":+1_tone5:",
			":thumbup_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsdown": {
		"unicode": "1f44e",
		"unicode_alt": "",
		"code_decimal": "&#128078;",
		"name": "thumbs down sign",
		"shortname": ":thumbsdown:",
		"category": "people",
		"emoji_order": "1182",
		"aliases": [
			":-1:",
			":thumbdown:"
		],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"diversity"
		]
	},
	"thumbsdown_tone1": {
		"unicode": "1f44e-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128078;&#127995;",
		"name": "thumbs down sign tone 1",
		"shortname": ":thumbsdown_tone1:",
		"category": "people",
		"emoji_order": "1183",
		"aliases": [
			":-1_tone1:",
			":thumbdown_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsdown_tone2": {
		"unicode": "1f44e-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128078;&#127996;",
		"name": "thumbs down sign tone 2",
		"shortname": ":thumbsdown_tone2:",
		"category": "people",
		"emoji_order": "1184",
		"aliases": [
			":-1_tone2:",
			":thumbdown_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsdown_tone3": {
		"unicode": "1f44e-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128078;&#127997;",
		"name": "thumbs down sign tone 3",
		"shortname": ":thumbsdown_tone3:",
		"category": "people",
		"emoji_order": "1185",
		"aliases": [
			":-1_tone3:",
			":thumbdown_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsdown_tone4": {
		"unicode": "1f44e-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128078;&#127998;",
		"name": "thumbs down sign tone 4",
		"shortname": ":thumbsdown_tone4:",
		"category": "people",
		"emoji_order": "1186",
		"aliases": [
			":-1_tone4:",
			":thumbdown_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"thumbsdown_tone5": {
		"unicode": "1f44e-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128078;&#127999;",
		"name": "thumbs down sign tone 5",
		"shortname": ":thumbsdown_tone5:",
		"category": "people",
		"emoji_order": "1187",
		"aliases": [
			":-1_tone5:",
			":thumbdown_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"fist": {
		"unicode": "270a",
		"unicode_alt": "",
		"code_decimal": "&#9994;",
		"name": "raised fist",
		"shortname": ":fist:",
		"category": "people",
		"emoji_order": "1188",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"fist bump",
			"diversity",
			"condolence"
		]
	},
	"fist_tone1": {
		"unicode": "270a-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#9994;&#127995;",
		"name": "raised fist tone 1",
		"shortname": ":fist_tone1:",
		"category": "people",
		"emoji_order": "1189",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"fist_tone2": {
		"unicode": "270a-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#9994;&#127996;",
		"name": "raised fist tone 2",
		"shortname": ":fist_tone2:",
		"category": "people",
		"emoji_order": "1190",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"fist_tone3": {
		"unicode": "270a-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#9994;&#127997;",
		"name": "raised fist tone 3",
		"shortname": ":fist_tone3:",
		"category": "people",
		"emoji_order": "1191",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"fist_tone4": {
		"unicode": "270a-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#9994;&#127998;",
		"name": "raised fist tone 4",
		"shortname": ":fist_tone4:",
		"category": "people",
		"emoji_order": "1192",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"fist_tone5": {
		"unicode": "270a-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#9994;&#127999;",
		"name": "raised fist tone 5",
		"shortname": ":fist_tone5:",
		"category": "people",
		"emoji_order": "1193",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"punch": {
		"unicode": "1f44a",
		"unicode_alt": "",
		"code_decimal": "&#128074;",
		"name": "fisted hand sign",
		"shortname": ":punch:",
		"category": "people",
		"emoji_order": "1194",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"fist bump",
			"diversity",
			"boys night"
		]
	},
	"punch_tone1": {
		"unicode": "1f44a-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128074;&#127995;",
		"name": "fisted hand sign tone 1",
		"shortname": ":punch_tone1:",
		"category": "people",
		"emoji_order": "1195",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"punch_tone2": {
		"unicode": "1f44a-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128074;&#127996;",
		"name": "fisted hand sign tone 2",
		"shortname": ":punch_tone2:",
		"category": "people",
		"emoji_order": "1196",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"punch_tone3": {
		"unicode": "1f44a-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128074;&#127997;",
		"name": "fisted hand sign tone 3",
		"shortname": ":punch_tone3:",
		"category": "people",
		"emoji_order": "1197",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"punch_tone4": {
		"unicode": "1f44a-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128074;&#127998;",
		"name": "fisted hand sign tone 4",
		"shortname": ":punch_tone4:",
		"category": "people",
		"emoji_order": "1198",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"punch_tone5": {
		"unicode": "1f44a-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128074;&#127999;",
		"name": "fisted hand sign tone 5",
		"shortname": ":punch_tone5:",
		"category": "people",
		"emoji_order": "1199",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"left_facing_fist": {
		"unicode": "1f91b",
		"unicode_alt": "",
		"code_decimal": "&#129307;",
		"name": "left-facing fist",
		"shortname": ":left_facing_fist:",
		"category": "people",
		"emoji_order": "1200",
		"aliases": [
			":left_fist:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"left_facing_fist_tone1": {
		"unicode": "1f91b-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129307;&#127995;",
		"name": "left facing fist tone 1",
		"shortname": ":left_facing_fist_tone1:",
		"category": "people",
		"emoji_order": "1201",
		"aliases": [
			":left_fist_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"left_facing_fist_tone2": {
		"unicode": "1f91b-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129307;&#127996;",
		"name": "left facing fist tone 2",
		"shortname": ":left_facing_fist_tone2:",
		"category": "people",
		"emoji_order": "1202",
		"aliases": [
			":left_fist_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"left_facing_fist_tone3": {
		"unicode": "1f91b-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129307;&#127997;",
		"name": "left facing fist tone 3",
		"shortname": ":left_facing_fist_tone3:",
		"category": "people",
		"emoji_order": "1203",
		"aliases": [
			":left_fist_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"left_facing_fist_tone4": {
		"unicode": "1f91b-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129307;&#127998;",
		"name": "left facing fist tone 4",
		"shortname": ":left_facing_fist_tone4:",
		"category": "people",
		"emoji_order": "1204",
		"aliases": [
			":left_fist_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"left_facing_fist_tone5": {
		"unicode": "1f91b-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129307;&#127999;",
		"name": "left facing fist tone 5",
		"shortname": ":left_facing_fist_tone5:",
		"category": "people",
		"emoji_order": "1205",
		"aliases": [
			":left_fist_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"right_facing_fist": {
		"unicode": "1f91c",
		"unicode_alt": "",
		"code_decimal": "&#129308;",
		"name": "right-facing fist",
		"shortname": ":right_facing_fist:",
		"category": "people",
		"emoji_order": "1206",
		"aliases": [
			":right_fist:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"right_facing_fist_tone1": {
		"unicode": "1f91c-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129308;&#127995;",
		"name": "right facing fist tone 1",
		"shortname": ":right_facing_fist_tone1:",
		"category": "people",
		"emoji_order": "1207",
		"aliases": [
			":right_fist_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"right_facing_fist_tone2": {
		"unicode": "1f91c-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129308;&#127996;",
		"name": "right facing fist tone 2",
		"shortname": ":right_facing_fist_tone2:",
		"category": "people",
		"emoji_order": "1208",
		"aliases": [
			":right_fist_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"right_facing_fist_tone3": {
		"unicode": "1f91c-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129308;&#127997;",
		"name": "right facing fist tone 3",
		"shortname": ":right_facing_fist_tone3:",
		"category": "people",
		"emoji_order": "1209",
		"aliases": [
			":right_fist_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"right_facing_fist_tone4": {
		"unicode": "1f91c-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129308;&#127998;",
		"name": "right facing fist tone 4",
		"shortname": ":right_facing_fist_tone4:",
		"category": "people",
		"emoji_order": "1210",
		"aliases": [
			":right_fist_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"right_facing_fist_tone5": {
		"unicode": "1f91c-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129308;&#127999;",
		"name": "right facing fist tone 5",
		"shortname": ":right_facing_fist_tone5:",
		"category": "people",
		"emoji_order": "1211",
		"aliases": [
			":right_fist_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_back_of_hand": {
		"unicode": "1f91a",
		"unicode_alt": "",
		"code_decimal": "&#129306;",
		"name": "raised back of hand",
		"shortname": ":raised_back_of_hand:",
		"category": "people",
		"emoji_order": "1212",
		"aliases": [
			":back_of_hand:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_back_of_hand_tone1": {
		"unicode": "1f91a-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129306;&#127995;",
		"name": "raised back of hand tone 1",
		"shortname": ":raised_back_of_hand_tone1:",
		"category": "people",
		"emoji_order": "1213",
		"aliases": [
			":back_of_hand_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_back_of_hand_tone2": {
		"unicode": "1f91a-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129306;&#127996;",
		"name": "raised back of hand tone 2",
		"shortname": ":raised_back_of_hand_tone2:",
		"category": "people",
		"emoji_order": "1214",
		"aliases": [
			":back_of_hand_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_back_of_hand_tone3": {
		"unicode": "1f91a-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129306;&#127997;",
		"name": "raised back of hand tone 3",
		"shortname": ":raised_back_of_hand_tone3:",
		"category": "people",
		"emoji_order": "1215",
		"aliases": [
			":back_of_hand_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_back_of_hand_tone4": {
		"unicode": "1f91a-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129306;&#127998;",
		"name": "raised back of hand tone 4",
		"shortname": ":raised_back_of_hand_tone4:",
		"category": "people",
		"emoji_order": "1216",
		"aliases": [
			":back_of_hand_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_back_of_hand_tone5": {
		"unicode": "1f91a-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129306;&#127999;",
		"name": "raised back of hand tone 5",
		"shortname": ":raised_back_of_hand_tone5:",
		"category": "people",
		"emoji_order": "1217",
		"aliases": [
			":back_of_hand_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"wave": {
		"unicode": "1f44b",
		"unicode_alt": "",
		"code_decimal": "&#128075;",
		"name": "waving hand sign",
		"shortname": ":wave:",
		"category": "people",
		"emoji_order": "1218",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"diversity"
		]
	},
	"wave_tone1": {
		"unicode": "1f44b-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128075;&#127995;",
		"name": "waving hand sign tone 1",
		"shortname": ":wave_tone1:",
		"category": "people",
		"emoji_order": "1219",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"wave_tone2": {
		"unicode": "1f44b-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128075;&#127996;",
		"name": "waving hand sign tone 2",
		"shortname": ":wave_tone2:",
		"category": "people",
		"emoji_order": "1220",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"wave_tone3": {
		"unicode": "1f44b-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128075;&#127997;",
		"name": "waving hand sign tone 3",
		"shortname": ":wave_tone3:",
		"category": "people",
		"emoji_order": "1221",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"wave_tone4": {
		"unicode": "1f44b-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128075;&#127998;",
		"name": "waving hand sign tone 4",
		"shortname": ":wave_tone4:",
		"category": "people",
		"emoji_order": "1222",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"wave_tone5": {
		"unicode": "1f44b-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128075;&#127999;",
		"name": "waving hand sign tone 5",
		"shortname": ":wave_tone5:",
		"category": "people",
		"emoji_order": "1223",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"clap": {
		"unicode": "1f44f",
		"unicode_alt": "",
		"code_decimal": "&#128079;",
		"name": "clapping hands sign",
		"shortname": ":clap:",
		"category": "people",
		"emoji_order": "1224",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"win",
			"diversity",
			"good",
			"beautiful"
		]
	},
	"clap_tone1": {
		"unicode": "1f44f-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128079;&#127995;",
		"name": "clapping hands sign tone 1",
		"shortname": ":clap_tone1:",
		"category": "people",
		"emoji_order": "1225",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"clap_tone2": {
		"unicode": "1f44f-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128079;&#127996;",
		"name": "clapping hands sign tone 2",
		"shortname": ":clap_tone2:",
		"category": "people",
		"emoji_order": "1226",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"clap_tone3": {
		"unicode": "1f44f-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128079;&#127997;",
		"name": "clapping hands sign tone 3",
		"shortname": ":clap_tone3:",
		"category": "people",
		"emoji_order": "1227",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"clap_tone4": {
		"unicode": "1f44f-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128079;&#127998;",
		"name": "clapping hands sign tone 4",
		"shortname": ":clap_tone4:",
		"category": "people",
		"emoji_order": "1228",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"clap_tone5": {
		"unicode": "1f44f-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128079;&#127999;",
		"name": "clapping hands sign tone 5",
		"shortname": ":clap_tone5:",
		"category": "people",
		"emoji_order": "1229",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"writing_hand": {
		"unicode": "270d",
		"unicode_alt": "270d-fe0f",
		"code_decimal": "&#9997;",
		"name": "writing hand",
		"shortname": ":writing_hand:",
		"category": "people",
		"emoji_order": "1230",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"write",
			"diversity"
		]
	},
	"writing_hand_tone1": {
		"unicode": "270d-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#9997;&#127995;",
		"name": "writing hand tone 1",
		"shortname": ":writing_hand_tone1:",
		"category": "people",
		"emoji_order": "1231",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"writing_hand_tone2": {
		"unicode": "270d-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#9997;&#127996;",
		"name": "writing hand tone 2",
		"shortname": ":writing_hand_tone2:",
		"category": "people",
		"emoji_order": "1232",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"writing_hand_tone3": {
		"unicode": "270d-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#9997;&#127997;",
		"name": "writing hand tone 3",
		"shortname": ":writing_hand_tone3:",
		"category": "people",
		"emoji_order": "1233",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"writing_hand_tone4": {
		"unicode": "270d-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#9997;&#127998;",
		"name": "writing hand tone 4",
		"shortname": ":writing_hand_tone4:",
		"category": "people",
		"emoji_order": "1234",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"writing_hand_tone5": {
		"unicode": "270d-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#9997;&#127999;",
		"name": "writing hand tone 5",
		"shortname": ":writing_hand_tone5:",
		"category": "people",
		"emoji_order": "1235",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"open_hands": {
		"unicode": "1f450",
		"unicode_alt": "",
		"code_decimal": "&#128080;",
		"name": "open hands sign",
		"shortname": ":open_hands:",
		"category": "people",
		"emoji_order": "1236",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"diversity",
			"condolence"
		]
	},
	"open_hands_tone1": {
		"unicode": "1f450-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128080;&#127995;",
		"name": "open hands sign tone 1",
		"shortname": ":open_hands_tone1:",
		"category": "people",
		"emoji_order": "1237",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"open_hands_tone2": {
		"unicode": "1f450-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128080;&#127996;",
		"name": "open hands sign tone 2",
		"shortname": ":open_hands_tone2:",
		"category": "people",
		"emoji_order": "1238",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"open_hands_tone3": {
		"unicode": "1f450-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128080;&#127997;",
		"name": "open hands sign tone 3",
		"shortname": ":open_hands_tone3:",
		"category": "people",
		"emoji_order": "1239",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"open_hands_tone4": {
		"unicode": "1f450-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128080;&#127998;",
		"name": "open hands sign tone 4",
		"shortname": ":open_hands_tone4:",
		"category": "people",
		"emoji_order": "1240",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"open_hands_tone5": {
		"unicode": "1f450-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128080;&#127999;",
		"name": "open hands sign tone 5",
		"shortname": ":open_hands_tone5:",
		"category": "people",
		"emoji_order": "1241",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hands": {
		"unicode": "1f64c",
		"unicode_alt": "",
		"code_decimal": "&#128588;",
		"name": "person raising both hands in celebration",
		"shortname": ":raised_hands:",
		"category": "people",
		"emoji_order": "1242",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"diversity",
			"perfect",
			"good",
			"parties"
		]
	},
	"raised_hands_tone1": {
		"unicode": "1f64c-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128588;&#127995;",
		"name": "person raising both hands in celebration tone 1",
		"shortname": ":raised_hands_tone1:",
		"category": "people",
		"emoji_order": "1243",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hands_tone2": {
		"unicode": "1f64c-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128588;&#127996;",
		"name": "person raising both hands in celebration tone 2",
		"shortname": ":raised_hands_tone2:",
		"category": "people",
		"emoji_order": "1244",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hands_tone3": {
		"unicode": "1f64c-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128588;&#127997;",
		"name": "person raising both hands in celebration tone 3",
		"shortname": ":raised_hands_tone3:",
		"category": "people",
		"emoji_order": "1245",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hands_tone4": {
		"unicode": "1f64c-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128588;&#127998;",
		"name": "person raising both hands in celebration tone 4",
		"shortname": ":raised_hands_tone4:",
		"category": "people",
		"emoji_order": "1246",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"raised_hands_tone5": {
		"unicode": "1f64c-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128588;&#127999;",
		"name": "person raising both hands in celebration tone 5",
		"shortname": ":raised_hands_tone5:",
		"category": "people",
		"emoji_order": "1247",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"pray": {
		"unicode": "1f64f",
		"unicode_alt": "",
		"code_decimal": "&#128591;",
		"name": "person with folded hands",
		"shortname": ":pray:",
		"category": "people",
		"emoji_order": "1248",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"hands",
			"hi",
			"luck",
			"thank you",
			"pray",
			"diversity",
			"scientology"
		]
	},
	"pray_tone1": {
		"unicode": "1f64f-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128591;&#127995;",
		"name": "person with folded hands tone 1",
		"shortname": ":pray_tone1:",
		"category": "people",
		"emoji_order": "1249",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"pray_tone2": {
		"unicode": "1f64f-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128591;&#127996;",
		"name": "person with folded hands tone 2",
		"shortname": ":pray_tone2:",
		"category": "people",
		"emoji_order": "1250",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"pray_tone3": {
		"unicode": "1f64f-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128591;&#127997;",
		"name": "person with folded hands tone 3",
		"shortname": ":pray_tone3:",
		"category": "people",
		"emoji_order": "1251",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"pray_tone4": {
		"unicode": "1f64f-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128591;&#127998;",
		"name": "person with folded hands tone 4",
		"shortname": ":pray_tone4:",
		"category": "people",
		"emoji_order": "1252",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"pray_tone5": {
		"unicode": "1f64f-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128591;&#127999;",
		"name": "person with folded hands tone 5",
		"shortname": ":pray_tone5:",
		"category": "people",
		"emoji_order": "1253",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"handshake": {
		"unicode": "1f91d",
		"unicode_alt": "",
		"code_decimal": "&#129309;",
		"name": "handshake",
		"shortname": ":handshake:",
		"category": "people",
		"emoji_order": "1254",
		"aliases": [
			":shaking_hands:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"handshake_tone1": {
		"unicode": "1f91d-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#129309;&#127995;",
		"name": "handshake tone 1",
		"shortname": ":handshake_tone1:",
		"category": "people",
		"emoji_order": "1255",
		"aliases": [
			":shaking_hands_tone1:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"handshake_tone2": {
		"unicode": "1f91d-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#129309;&#127996;",
		"name": "handshake tone 2",
		"shortname": ":handshake_tone2:",
		"category": "people",
		"emoji_order": "1256",
		"aliases": [
			":shaking_hands_tone2:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"handshake_tone3": {
		"unicode": "1f91d-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#129309;&#127997;",
		"name": "handshake tone 3",
		"shortname": ":handshake_tone3:",
		"category": "people",
		"emoji_order": "1257",
		"aliases": [
			":shaking_hands_tone3:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"handshake_tone4": {
		"unicode": "1f91d-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#129309;&#127998;",
		"name": "handshake tone 4",
		"shortname": ":handshake_tone4:",
		"category": "people",
		"emoji_order": "1258",
		"aliases": [
			":shaking_hands_tone4:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"handshake_tone5": {
		"unicode": "1f91d-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#129309;&#127999;",
		"name": "handshake tone 5",
		"shortname": ":handshake_tone5:",
		"category": "people",
		"emoji_order": "1259",
		"aliases": [
			":shaking_hands_tone5:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"nail_care": {
		"unicode": "1f485",
		"unicode_alt": "",
		"code_decimal": "&#128133;",
		"name": "nail polish",
		"shortname": ":nail_care:",
		"category": "people",
		"emoji_order": "1260",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"body",
			"hands",
			"nailpolish",
			"diversity",
			"girls night"
		]
	},
	"nail_care_tone1": {
		"unicode": "1f485-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128133;&#127995;",
		"name": "nail polish tone 1",
		"shortname": ":nail_care_tone1:",
		"category": "people",
		"emoji_order": "1261",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nail_care_tone2": {
		"unicode": "1f485-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128133;&#127996;",
		"name": "nail polish tone 2",
		"shortname": ":nail_care_tone2:",
		"category": "people",
		"emoji_order": "1262",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nail_care_tone3": {
		"unicode": "1f485-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128133;&#127997;",
		"name": "nail polish tone 3",
		"shortname": ":nail_care_tone3:",
		"category": "people",
		"emoji_order": "1263",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nail_care_tone4": {
		"unicode": "1f485-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128133;&#127998;",
		"name": "nail polish tone 4",
		"shortname": ":nail_care_tone4:",
		"category": "people",
		"emoji_order": "1264",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nail_care_tone5": {
		"unicode": "1f485-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128133;&#127999;",
		"name": "nail polish tone 5",
		"shortname": ":nail_care_tone5:",
		"category": "people",
		"emoji_order": "1265",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ear": {
		"unicode": "1f442",
		"unicode_alt": "",
		"code_decimal": "&#128066;",
		"name": "ear",
		"shortname": ":ear:",
		"category": "people",
		"emoji_order": "1266",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"diversity"
		]
	},
	"ear_tone1": {
		"unicode": "1f442-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128066;&#127995;",
		"name": "ear tone 1",
		"shortname": ":ear_tone1:",
		"category": "people",
		"emoji_order": "1267",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ear_tone2": {
		"unicode": "1f442-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128066;&#127996;",
		"name": "ear tone 2",
		"shortname": ":ear_tone2:",
		"category": "people",
		"emoji_order": "1268",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ear_tone3": {
		"unicode": "1f442-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128066;&#127997;",
		"name": "ear tone 3",
		"shortname": ":ear_tone3:",
		"category": "people",
		"emoji_order": "1269",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ear_tone4": {
		"unicode": "1f442-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128066;&#127998;",
		"name": "ear tone 4",
		"shortname": ":ear_tone4:",
		"category": "people",
		"emoji_order": "1270",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"ear_tone5": {
		"unicode": "1f442-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128066;&#127999;",
		"name": "ear tone 5",
		"shortname": ":ear_tone5:",
		"category": "people",
		"emoji_order": "1271",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nose": {
		"unicode": "1f443",
		"unicode_alt": "",
		"code_decimal": "&#128067;",
		"name": "nose",
		"shortname": ":nose:",
		"category": "people",
		"emoji_order": "1272",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"diversity"
		]
	},
	"nose_tone1": {
		"unicode": "1f443-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128067;&#127995;",
		"name": "nose tone 1",
		"shortname": ":nose_tone1:",
		"category": "people",
		"emoji_order": "1273",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nose_tone2": {
		"unicode": "1f443-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128067;&#127996;",
		"name": "nose tone 2",
		"shortname": ":nose_tone2:",
		"category": "people",
		"emoji_order": "1274",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nose_tone3": {
		"unicode": "1f443-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128067;&#127997;",
		"name": "nose tone 3",
		"shortname": ":nose_tone3:",
		"category": "people",
		"emoji_order": "1275",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nose_tone4": {
		"unicode": "1f443-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128067;&#127998;",
		"name": "nose tone 4",
		"shortname": ":nose_tone4:",
		"category": "people",
		"emoji_order": "1276",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"nose_tone5": {
		"unicode": "1f443-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128067;&#127999;",
		"name": "nose tone 5",
		"shortname": ":nose_tone5:",
		"category": "people",
		"emoji_order": "1277",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"footprints": {
		"unicode": "1f463",
		"unicode_alt": "",
		"code_decimal": "&#128099;",
		"name": "footprints",
		"shortname": ":footprints:",
		"category": "people",
		"emoji_order": "1278",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"eyes": {
		"unicode": "1f440",
		"unicode_alt": "",
		"code_decimal": "&#128064;",
		"name": "eyes",
		"shortname": ":eyes:",
		"category": "people",
		"emoji_order": "1279",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"eyes"
		]
	},
	"eye": {
		"unicode": "1f441",
		"unicode_alt": "1f441-fe0f",
		"code_decimal": "&#128065;",
		"name": "eye",
		"shortname": ":eye:",
		"category": "people",
		"emoji_order": "1280",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"eyes"
		]
	},
	"eye_in_speech_bubble": {
		"unicode": "1f441-1f5e8",
		"unicode_alt": "1f441-200d-1f5e8",
		"code_decimal": "&#128065;&#128488;",
		"name": "eye in speech bubble",
		"shortname": ":eye_in_speech_bubble:",
		"category": "symbols",
		"emoji_order": "1281",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"symbol",
			"eyes",
			"talk"
		]
	},
	"tongue": {
		"unicode": "1f445",
		"unicode_alt": "",
		"code_decimal": "&#128069;",
		"name": "tongue",
		"shortname": ":tongue:",
		"category": "people",
		"emoji_order": "1282",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"body",
			"sexy",
			"lip"
		]
	},
	"lips": {
		"unicode": "1f444",
		"unicode_alt": "",
		"code_decimal": "&#128068;",
		"name": "mouth",
		"shortname": ":lips:",
		"category": "people",
		"emoji_order": "1283",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"body",
			"sexy",
			"lip"
		]
	},
	"kiss": {
		"unicode": "1f48b",
		"unicode_alt": "",
		"code_decimal": "&#128139;",
		"name": "kiss mark",
		"shortname": ":kiss:",
		"category": "people",
		"emoji_order": "1284",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"love",
			"sexy",
			"lip",
			"beautiful",
			"girls night"
		]
	},
	"cupid": {
		"unicode": "1f498",
		"unicode_alt": "",
		"code_decimal": "&#128152;",
		"name": "heart with arrow",
		"shortname": ":cupid:",
		"category": "symbols",
		"emoji_order": "1285",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"heart": {
		"unicode": "2764",
		"unicode_alt": "2764-fe0f",
		"code_decimal": "&#10084;",
		"name": "heavy black heart",
		"shortname": ":heart:",
		"category": "symbols",
		"emoji_order": "1286",
		"aliases": [],
		"aliases_ascii": [
			"<3"
		],
		"keywords": [
			"love",
			"symbol",
			"parties"
		]
	},
	"heartbeat": {
		"unicode": "1f493",
		"unicode_alt": "",
		"code_decimal": "&#128147;",
		"name": "beating heart",
		"shortname": ":heartbeat:",
		"category": "symbols",
		"emoji_order": "1287",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"broken_heart": {
		"unicode": "1f494",
		"unicode_alt": "",
		"code_decimal": "&#128148;",
		"name": "broken heart",
		"shortname": ":broken_heart:",
		"category": "symbols",
		"emoji_order": "1288",
		"aliases": [],
		"aliases_ascii": [
			"</3"
		],
		"keywords": [
			"love",
			"symbol",
			"heartbreak"
		]
	},
	"two_hearts": {
		"unicode": "1f495",
		"unicode_alt": "",
		"code_decimal": "&#128149;",
		"name": "two hearts",
		"shortname": ":two_hearts:",
		"category": "symbols",
		"emoji_order": "1289",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"sparkling_heart": {
		"unicode": "1f496",
		"unicode_alt": "",
		"code_decimal": "&#128150;",
		"name": "sparkling heart",
		"shortname": ":sparkling_heart:",
		"category": "symbols",
		"emoji_order": "1290",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol",
			"girls night"
		]
	},
	"heartpulse": {
		"unicode": "1f497",
		"unicode_alt": "",
		"code_decimal": "&#128151;",
		"name": "growing heart",
		"shortname": ":heartpulse:",
		"category": "symbols",
		"emoji_order": "1291",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"blue_heart": {
		"unicode": "1f499",
		"unicode_alt": "",
		"code_decimal": "&#128153;",
		"name": "blue heart",
		"shortname": ":blue_heart:",
		"category": "symbols",
		"emoji_order": "1292",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"green_heart": {
		"unicode": "1f49a",
		"unicode_alt": "",
		"code_decimal": "&#128154;",
		"name": "green heart",
		"shortname": ":green_heart:",
		"category": "symbols",
		"emoji_order": "1293",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"yellow_heart": {
		"unicode": "1f49b",
		"unicode_alt": "",
		"code_decimal": "&#128155;",
		"name": "yellow heart",
		"shortname": ":yellow_heart:",
		"category": "symbols",
		"emoji_order": "1294",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"purple_heart": {
		"unicode": "1f49c",
		"unicode_alt": "",
		"code_decimal": "&#128156;",
		"name": "purple heart",
		"shortname": ":purple_heart:",
		"category": "symbols",
		"emoji_order": "1295",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"black_heart": {
		"unicode": "1f5a4",
		"unicode_alt": "",
		"code_decimal": "&#128420;",
		"name": "black heart",
		"shortname": ":black_heart:",
		"category": "symbols",
		"emoji_order": "1296",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"gift_heart": {
		"unicode": "1f49d",
		"unicode_alt": "",
		"code_decimal": "&#128157;",
		"name": "heart with ribbon",
		"shortname": ":gift_heart:",
		"category": "symbols",
		"emoji_order": "1297",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol",
			"condolence"
		]
	},
	"revolving_hearts": {
		"unicode": "1f49e",
		"unicode_alt": "",
		"code_decimal": "&#128158;",
		"name": "revolving hearts",
		"shortname": ":revolving_hearts:",
		"category": "symbols",
		"emoji_order": "1298",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"heart_decoration": {
		"unicode": "1f49f",
		"unicode_alt": "",
		"code_decimal": "&#128159;",
		"name": "heart decoration",
		"shortname": ":heart_decoration:",
		"category": "symbols",
		"emoji_order": "1299",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"heart_exclamation": {
		"unicode": "2763",
		"unicode_alt": "2763-fe0f",
		"code_decimal": "&#10083;",
		"name": "heavy heart exclamation mark ornament",
		"shortname": ":heart_exclamation:",
		"category": "symbols",
		"emoji_order": "1300",
		"aliases": [
			":heavy_heart_exclamation_mark_ornament:"
		],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol"
		]
	},
	"love_letter": {
		"unicode": "1f48c",
		"unicode_alt": "",
		"code_decimal": "&#128140;",
		"name": "love letter",
		"shortname": ":love_letter:",
		"category": "objects",
		"emoji_order": "1301",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"zzz": {
		"unicode": "1f4a4",
		"unicode_alt": "",
		"code_decimal": "&#128164;",
		"name": "sleeping symbol",
		"shortname": ":zzz:",
		"category": "people",
		"emoji_order": "1302",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"tired",
			"goodnight"
		]
	},
	"anger": {
		"unicode": "1f4a2",
		"unicode_alt": "",
		"code_decimal": "&#128162;",
		"name": "anger symbol",
		"shortname": ":anger:",
		"category": "symbols",
		"emoji_order": "1303",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"bomb": {
		"unicode": "1f4a3",
		"unicode_alt": "",
		"code_decimal": "&#128163;",
		"name": "bomb",
		"shortname": ":bomb:",
		"category": "objects",
		"emoji_order": "1304",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon",
			"dead",
			"blast"
		]
	},
	"boom": {
		"unicode": "1f4a5",
		"unicode_alt": "",
		"code_decimal": "&#128165;",
		"name": "collision symbol",
		"shortname": ":boom:",
		"category": "symbols",
		"emoji_order": "1305",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"blast"
		]
	},
	"sweat_drops": {
		"unicode": "1f4a6",
		"unicode_alt": "",
		"code_decimal": "&#128166;",
		"name": "splashing sweat symbol",
		"shortname": ":sweat_drops:",
		"category": "nature",
		"emoji_order": "1306",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"rain",
			"stressed",
			"sweat"
		]
	},
	"dash": {
		"unicode": "1f4a8",
		"unicode_alt": "",
		"code_decimal": "&#128168;",
		"name": "dash symbol",
		"shortname": ":dash:",
		"category": "nature",
		"emoji_order": "1307",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cloud",
			"cold",
			"smoking"
		]
	},
	"dizzy": {
		"unicode": "1f4ab",
		"unicode_alt": "",
		"code_decimal": "&#128171;",
		"name": "dizzy symbol",
		"shortname": ":dizzy:",
		"category": "symbols",
		"emoji_order": "1308",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"star",
			"symbol"
		]
	},
	"speech_balloon": {
		"unicode": "1f4ac",
		"unicode_alt": "",
		"code_decimal": "&#128172;",
		"name": "speech balloon",
		"shortname": ":speech_balloon:",
		"category": "symbols",
		"emoji_order": "1309",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"free speech"
		]
	},
	"speech_left": {
		"unicode": "1f5e8",
		"unicode_alt": "1f5e8-fe0f",
		"code_decimal": "&#128488;",
		"name": "left speech bubble",
		"shortname": ":speech_left:",
		"category": "symbols",
		"emoji_order": "1310",
		"aliases": [
			":left_speech_bubble:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"anger_right": {
		"unicode": "1f5ef",
		"unicode_alt": "1f5ef-fe0f",
		"code_decimal": "&#128495;",
		"name": "right anger bubble",
		"shortname": ":anger_right:",
		"category": "symbols",
		"emoji_order": "1311",
		"aliases": [
			":right_anger_bubble:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"thought_balloon": {
		"unicode": "1f4ad",
		"unicode_alt": "",
		"code_decimal": "&#128173;",
		"name": "thought balloon",
		"shortname": ":thought_balloon:",
		"category": "symbols",
		"emoji_order": "1312",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"hole": {
		"unicode": "1f573",
		"unicode_alt": "1f573-fe0f",
		"code_decimal": "&#128371;",
		"name": "hole",
		"shortname": ":hole:",
		"category": "objects",
		"emoji_order": "1313",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"eyeglasses": {
		"unicode": "1f453",
		"unicode_alt": "",
		"code_decimal": "&#128083;",
		"name": "eyeglasses",
		"shortname": ":eyeglasses:",
		"category": "people",
		"emoji_order": "1314",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion",
			"glasses",
			"accessories"
		]
	},
	"dark_sunglasses": {
		"unicode": "1f576",
		"unicode_alt": "1f576-fe0f",
		"code_decimal": "&#128374;",
		"name": "dark sunglasses",
		"shortname": ":dark_sunglasses:",
		"category": "people",
		"emoji_order": "1315",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion",
			"glasses",
			"accessories"
		]
	},
	"necktie": {
		"unicode": "1f454",
		"unicode_alt": "",
		"code_decimal": "&#128084;",
		"name": "necktie",
		"shortname": ":necktie:",
		"category": "people",
		"emoji_order": "1316",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion"
		]
	},
	"shirt": {
		"unicode": "1f455",
		"unicode_alt": "",
		"code_decimal": "&#128085;",
		"name": "t-shirt",
		"shortname": ":shirt:",
		"category": "people",
		"emoji_order": "1317",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion"
		]
	},
	"jeans": {
		"unicode": "1f456",
		"unicode_alt": "",
		"code_decimal": "&#128086;",
		"name": "jeans",
		"shortname": ":jeans:",
		"category": "people",
		"emoji_order": "1318",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion"
		]
	},
	"dress": {
		"unicode": "1f457",
		"unicode_alt": "",
		"code_decimal": "&#128087;",
		"name": "dress",
		"shortname": ":dress:",
		"category": "people",
		"emoji_order": "1319",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"fashion",
			"sexy",
			"girls night"
		]
	},
	"kimono": {
		"unicode": "1f458",
		"unicode_alt": "",
		"code_decimal": "&#128088;",
		"name": "kimono",
		"shortname": ":kimono:",
		"category": "people",
		"emoji_order": "1320",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion"
		]
	},
	"bikini": {
		"unicode": "1f459",
		"unicode_alt": "",
		"code_decimal": "&#128089;",
		"name": "bikini",
		"shortname": ":bikini:",
		"category": "people",
		"emoji_order": "1321",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"fashion",
			"sexy",
			"vacation",
			"tropical",
			"swim"
		]
	},
	"womans_clothes": {
		"unicode": "1f45a",
		"unicode_alt": "",
		"code_decimal": "&#128090;",
		"name": "womans clothes",
		"shortname": ":womans_clothes:",
		"category": "people",
		"emoji_order": "1322",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"fashion"
		]
	},
	"purse": {
		"unicode": "1f45b",
		"unicode_alt": "",
		"code_decimal": "&#128091;",
		"name": "purse",
		"shortname": ":purse:",
		"category": "people",
		"emoji_order": "1323",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bag",
			"women",
			"fashion",
			"accessories",
			"money"
		]
	},
	"handbag": {
		"unicode": "1f45c",
		"unicode_alt": "",
		"code_decimal": "&#128092;",
		"name": "handbag",
		"shortname": ":handbag:",
		"category": "people",
		"emoji_order": "1324",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bag",
			"women",
			"fashion",
			"vacation",
			"accessories"
		]
	},
	"pouch": {
		"unicode": "1f45d",
		"unicode_alt": "",
		"code_decimal": "&#128093;",
		"name": "pouch",
		"shortname": ":pouch:",
		"category": "people",
		"emoji_order": "1325",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bag",
			"women",
			"fashion",
			"accessories"
		]
	},
	"shopping_bags": {
		"unicode": "1f6cd",
		"unicode_alt": "1f6cd-fe0f",
		"code_decimal": "&#128717;",
		"name": "shopping bags",
		"shortname": ":shopping_bags:",
		"category": "objects",
		"emoji_order": "1326",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"birthday",
			"parties"
		]
	},
	"school_satchel": {
		"unicode": "1f392",
		"unicode_alt": "",
		"code_decimal": "&#127890;",
		"name": "school satchel",
		"shortname": ":school_satchel:",
		"category": "people",
		"emoji_order": "1327",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bag",
			"fashion",
			"office",
			"vacation",
			"accessories"
		]
	},
	"mans_shoe": {
		"unicode": "1f45e",
		"unicode_alt": "",
		"code_decimal": "&#128094;",
		"name": "mans shoe",
		"shortname": ":mans_shoe:",
		"category": "people",
		"emoji_order": "1328",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion",
			"shoe",
			"accessories"
		]
	},
	"athletic_shoe": {
		"unicode": "1f45f",
		"unicode_alt": "",
		"code_decimal": "&#128095;",
		"name": "athletic shoe",
		"shortname": ":athletic_shoe:",
		"category": "people",
		"emoji_order": "1329",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion",
			"shoe",
			"accessories",
			"boys night"
		]
	},
	"high_heel": {
		"unicode": "1f460",
		"unicode_alt": "",
		"code_decimal": "&#128096;",
		"name": "high-heeled shoe",
		"shortname": ":high_heel:",
		"category": "people",
		"emoji_order": "1330",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"fashion",
			"shoe",
			"sexy",
			"accessories",
			"girls night"
		]
	},
	"sandal": {
		"unicode": "1f461",
		"unicode_alt": "",
		"code_decimal": "&#128097;",
		"name": "womans sandal",
		"shortname": ":sandal:",
		"category": "people",
		"emoji_order": "1331",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fashion",
			"shoe",
			"accessories"
		]
	},
	"boot": {
		"unicode": "1f462",
		"unicode_alt": "",
		"code_decimal": "&#128098;",
		"name": "womans boots",
		"shortname": ":boot:",
		"category": "people",
		"emoji_order": "1332",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"fashion",
			"shoe",
			"sexy",
			"accessories"
		]
	},
	"crown": {
		"unicode": "1f451",
		"unicode_alt": "",
		"code_decimal": "&#128081;",
		"name": "crown",
		"shortname": ":crown:",
		"category": "people",
		"emoji_order": "1333",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"gem",
			"accessories"
		]
	},
	"womans_hat": {
		"unicode": "1f452",
		"unicode_alt": "",
		"code_decimal": "&#128082;",
		"name": "womans hat",
		"shortname": ":womans_hat:",
		"category": "people",
		"emoji_order": "1334",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"women",
			"fashion",
			"accessories"
		]
	},
	"tophat": {
		"unicode": "1f3a9",
		"unicode_alt": "",
		"code_decimal": "&#127913;",
		"name": "top hat",
		"shortname": ":tophat:",
		"category": "people",
		"emoji_order": "1335",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"hat",
			"fashion",
			"accessories"
		]
	},
	"mortar_board": {
		"unicode": "1f393",
		"unicode_alt": "",
		"code_decimal": "&#127891;",
		"name": "graduation cap",
		"shortname": ":mortar_board:",
		"category": "people",
		"emoji_order": "1336",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"hat",
			"office",
			"accessories"
		]
	},
	"helmet_with_cross": {
		"unicode": "26d1",
		"unicode_alt": "26d1-fe0f",
		"code_decimal": "&#9937;",
		"name": "helmet with white cross",
		"shortname": ":helmet_with_cross:",
		"category": "people",
		"emoji_order": "1337",
		"aliases": [
			":helmet_with_white_cross:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"hat",
			"accessories",
			"job"
		]
	},
	"prayer_beads": {
		"unicode": "1f4ff",
		"unicode_alt": "",
		"code_decimal": "&#128255;",
		"name": "prayer beads",
		"shortname": ":prayer_beads:",
		"category": "objects",
		"emoji_order": "1338",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"rosary"
		]
	},
	"lipstick": {
		"unicode": "1f484",
		"unicode_alt": "",
		"code_decimal": "&#128132;",
		"name": "lipstick",
		"shortname": ":lipstick:",
		"category": "people",
		"emoji_order": "1339",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"women",
			"fashion",
			"sexy",
			"lip"
		]
	},
	"ring": {
		"unicode": "1f48d",
		"unicode_alt": "",
		"code_decimal": "&#128141;",
		"name": "ring",
		"shortname": ":ring:",
		"category": "people",
		"emoji_order": "1340",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wedding",
			"object",
			"fashion",
			"gem",
			"accessories"
		]
	},
	"gem": {
		"unicode": "1f48e",
		"unicode_alt": "",
		"code_decimal": "&#128142;",
		"name": "gem stone",
		"shortname": ":gem:",
		"category": "objects",
		"emoji_order": "1341",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"gem"
		]
	},
	"monkey_face": {
		"unicode": "1f435",
		"unicode_alt": "",
		"code_decimal": "&#128053;",
		"name": "monkey face",
		"shortname": ":monkey_face:",
		"category": "nature",
		"emoji_order": "1342",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"monkey": {
		"unicode": "1f412",
		"unicode_alt": "",
		"code_decimal": "&#128018;",
		"name": "monkey",
		"shortname": ":monkey:",
		"category": "nature",
		"emoji_order": "1343",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"gorilla": {
		"unicode": "1f98d",
		"unicode_alt": "",
		"code_decimal": "&#129421;",
		"name": "gorilla",
		"shortname": ":gorilla:",
		"category": "nature",
		"emoji_order": "1344",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"dog": {
		"unicode": "1f436",
		"unicode_alt": "",
		"code_decimal": "&#128054;",
		"name": "dog face",
		"shortname": ":dog:",
		"category": "nature",
		"emoji_order": "1345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"dog",
			"pug",
			"animal"
		]
	},
	"dog2": {
		"unicode": "1f415",
		"unicode_alt": "",
		"code_decimal": "&#128021;",
		"name": "dog",
		"shortname": ":dog2:",
		"category": "nature",
		"emoji_order": "1346",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"dog",
			"pug",
			"animal"
		]
	},
	"poodle": {
		"unicode": "1f429",
		"unicode_alt": "",
		"code_decimal": "&#128041;",
		"name": "poodle",
		"shortname": ":poodle:",
		"category": "nature",
		"emoji_order": "1347",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"dog",
			"animal"
		]
	},
	"wolf": {
		"unicode": "1f43a",
		"unicode_alt": "",
		"code_decimal": "&#128058;",
		"name": "wolf face",
		"shortname": ":wolf:",
		"category": "nature",
		"emoji_order": "1348",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"animal"
		]
	},
	"fox": {
		"unicode": "1f98a",
		"unicode_alt": "",
		"code_decimal": "&#129418;",
		"name": "fox face",
		"shortname": ":fox:",
		"category": "nature",
		"emoji_order": "1349",
		"aliases": [
			":fox_face:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cat": {
		"unicode": "1f431",
		"unicode_alt": "",
		"code_decimal": "&#128049;",
		"name": "cat face",
		"shortname": ":cat:",
		"category": "nature",
		"emoji_order": "1350",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"halloween",
			"vagina",
			"cat",
			"animal"
		]
	},
	"cat2": {
		"unicode": "1f408",
		"unicode_alt": "",
		"code_decimal": "&#128008;",
		"name": "cat",
		"shortname": ":cat2:",
		"category": "nature",
		"emoji_order": "1351",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"halloween",
			"cat",
			"animal"
		]
	},
	"lion_face": {
		"unicode": "1f981",
		"unicode_alt": "",
		"code_decimal": "&#129409;",
		"name": "lion face",
		"shortname": ":lion_face:",
		"category": "nature",
		"emoji_order": "1352",
		"aliases": [
			":lion:"
		],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"cat",
			"animal"
		]
	},
	"tiger": {
		"unicode": "1f42f",
		"unicode_alt": "",
		"code_decimal": "&#128047;",
		"name": "tiger face",
		"shortname": ":tiger:",
		"category": "nature",
		"emoji_order": "1353",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"cat",
			"animal"
		]
	},
	"tiger2": {
		"unicode": "1f405",
		"unicode_alt": "",
		"code_decimal": "&#128005;",
		"name": "tiger",
		"shortname": ":tiger2:",
		"category": "nature",
		"emoji_order": "1354",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"animal"
		]
	},
	"leopard": {
		"unicode": "1f406",
		"unicode_alt": "",
		"code_decimal": "&#128006;",
		"name": "leopard",
		"shortname": ":leopard:",
		"category": "nature",
		"emoji_order": "1355",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"animal"
		]
	},
	"horse": {
		"unicode": "1f434",
		"unicode_alt": "",
		"code_decimal": "&#128052;",
		"name": "horse face",
		"shortname": ":horse:",
		"category": "nature",
		"emoji_order": "1356",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"racehorse": {
		"unicode": "1f40e",
		"unicode_alt": "",
		"code_decimal": "&#128014;",
		"name": "horse",
		"shortname": ":racehorse:",
		"category": "nature",
		"emoji_order": "1357",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"deer": {
		"unicode": "1f98c",
		"unicode_alt": "",
		"code_decimal": "&#129420;",
		"name": "deer",
		"shortname": ":deer:",
		"category": "nature",
		"emoji_order": "1358",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"unicorn": {
		"unicode": "1f984",
		"unicode_alt": "",
		"code_decimal": "&#129412;",
		"name": "unicorn face",
		"shortname": ":unicorn:",
		"category": "nature",
		"emoji_order": "1359",
		"aliases": [
			":unicorn_face:"
		],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"cow": {
		"unicode": "1f42e",
		"unicode_alt": "",
		"code_decimal": "&#128046;",
		"name": "cow face",
		"shortname": ":cow:",
		"category": "nature",
		"emoji_order": "1360",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"ox": {
		"unicode": "1f402",
		"unicode_alt": "",
		"code_decimal": "&#128002;",
		"name": "ox",
		"shortname": ":ox:",
		"category": "nature",
		"emoji_order": "1361",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"water_buffalo": {
		"unicode": "1f403",
		"unicode_alt": "",
		"code_decimal": "&#128003;",
		"name": "water buffalo",
		"shortname": ":water_buffalo:",
		"category": "nature",
		"emoji_order": "1362",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"cow2": {
		"unicode": "1f404",
		"unicode_alt": "",
		"code_decimal": "&#128004;",
		"name": "cow",
		"shortname": ":cow2:",
		"category": "nature",
		"emoji_order": "1363",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"pig": {
		"unicode": "1f437",
		"unicode_alt": "",
		"code_decimal": "&#128055;",
		"name": "pig face",
		"shortname": ":pig:",
		"category": "nature",
		"emoji_order": "1364",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"pig2": {
		"unicode": "1f416",
		"unicode_alt": "",
		"code_decimal": "&#128022;",
		"name": "pig",
		"shortname": ":pig2:",
		"category": "nature",
		"emoji_order": "1365",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"boar": {
		"unicode": "1f417",
		"unicode_alt": "",
		"code_decimal": "&#128023;",
		"name": "boar",
		"shortname": ":boar:",
		"category": "nature",
		"emoji_order": "1366",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"pig_nose": {
		"unicode": "1f43d",
		"unicode_alt": "",
		"code_decimal": "&#128061;",
		"name": "pig nose",
		"shortname": ":pig_nose:",
		"category": "nature",
		"emoji_order": "1367",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"ram": {
		"unicode": "1f40f",
		"unicode_alt": "",
		"code_decimal": "&#128015;",
		"name": "ram",
		"shortname": ":ram:",
		"category": "nature",
		"emoji_order": "1368",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"sheep": {
		"unicode": "1f411",
		"unicode_alt": "",
		"code_decimal": "&#128017;",
		"name": "sheep",
		"shortname": ":sheep:",
		"category": "nature",
		"emoji_order": "1369",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"goat": {
		"unicode": "1f410",
		"unicode_alt": "",
		"code_decimal": "&#128016;",
		"name": "goat",
		"shortname": ":goat:",
		"category": "nature",
		"emoji_order": "1370",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"dromedary_camel": {
		"unicode": "1f42a",
		"unicode_alt": "",
		"code_decimal": "&#128042;",
		"name": "dromedary camel",
		"shortname": ":dromedary_camel:",
		"category": "nature",
		"emoji_order": "1371",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"camel": {
		"unicode": "1f42b",
		"unicode_alt": "",
		"code_decimal": "&#128043;",
		"name": "bactrian camel",
		"shortname": ":camel:",
		"category": "nature",
		"emoji_order": "1372",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal",
			"hump day"
		]
	},
	"elephant": {
		"unicode": "1f418",
		"unicode_alt": "",
		"code_decimal": "&#128024;",
		"name": "elephant",
		"shortname": ":elephant:",
		"category": "nature",
		"emoji_order": "1373",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"rhino": {
		"unicode": "1f98f",
		"unicode_alt": "",
		"code_decimal": "&#129423;",
		"name": "rhinoceros",
		"shortname": ":rhino:",
		"category": "nature",
		"emoji_order": "1374",
		"aliases": [
			":rhinoceros:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"mouse": {
		"unicode": "1f42d",
		"unicode_alt": "",
		"code_decimal": "&#128045;",
		"name": "mouse face",
		"shortname": ":mouse:",
		"category": "nature",
		"emoji_order": "1375",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"mouse2": {
		"unicode": "1f401",
		"unicode_alt": "",
		"code_decimal": "&#128001;",
		"name": "mouse",
		"shortname": ":mouse2:",
		"category": "nature",
		"emoji_order": "1376",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"rat": {
		"unicode": "1f400",
		"unicode_alt": "",
		"code_decimal": "&#128000;",
		"name": "rat",
		"shortname": ":rat:",
		"category": "nature",
		"emoji_order": "1377",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"hamster": {
		"unicode": "1f439",
		"unicode_alt": "",
		"code_decimal": "&#128057;",
		"name": "hamster face",
		"shortname": ":hamster:",
		"category": "nature",
		"emoji_order": "1378",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"rabbit": {
		"unicode": "1f430",
		"unicode_alt": "",
		"code_decimal": "&#128048;",
		"name": "rabbit face",
		"shortname": ":rabbit:",
		"category": "nature",
		"emoji_order": "1379",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"rabbit2": {
		"unicode": "1f407",
		"unicode_alt": "",
		"code_decimal": "&#128007;",
		"name": "rabbit",
		"shortname": ":rabbit2:",
		"category": "nature",
		"emoji_order": "1380",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"chipmunk": {
		"unicode": "1f43f",
		"unicode_alt": "1f43f-fe0f",
		"code_decimal": "&#128063;",
		"name": "chipmunk",
		"shortname": ":chipmunk:",
		"category": "nature",
		"emoji_order": "1381",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"bat": {
		"unicode": "1f987",
		"unicode_alt": "",
		"code_decimal": "&#129415;",
		"name": "bat",
		"shortname": ":bat:",
		"category": "nature",
		"emoji_order": "1382",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bear": {
		"unicode": "1f43b",
		"unicode_alt": "",
		"code_decimal": "&#128059;",
		"name": "bear face",
		"shortname": ":bear:",
		"category": "nature",
		"emoji_order": "1383",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"animal"
		]
	},
	"koala": {
		"unicode": "1f428",
		"unicode_alt": "",
		"code_decimal": "&#128040;",
		"name": "koala",
		"shortname": ":koala:",
		"category": "nature",
		"emoji_order": "1384",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"panda_face": {
		"unicode": "1f43c",
		"unicode_alt": "",
		"code_decimal": "&#128060;",
		"name": "panda face",
		"shortname": ":panda_face:",
		"category": "nature",
		"emoji_order": "1385",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"roar",
			"animal"
		]
	},
	"feet": {
		"unicode": "1f43e",
		"unicode_alt": "",
		"code_decimal": "&#128062;",
		"name": "paw prints",
		"shortname": ":feet:",
		"category": "nature",
		"emoji_order": "1386",
		"aliases": [
			":paw_prints:"
		],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"turkey": {
		"unicode": "1f983",
		"unicode_alt": "",
		"code_decimal": "&#129411;",
		"name": "turkey",
		"shortname": ":turkey:",
		"category": "nature",
		"emoji_order": "1387",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"chicken": {
		"unicode": "1f414",
		"unicode_alt": "",
		"code_decimal": "&#128020;",
		"name": "chicken",
		"shortname": ":chicken:",
		"category": "nature",
		"emoji_order": "1388",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal",
			"chicken"
		]
	},
	"rooster": {
		"unicode": "1f413",
		"unicode_alt": "",
		"code_decimal": "&#128019;",
		"name": "rooster",
		"shortname": ":rooster:",
		"category": "nature",
		"emoji_order": "1389",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"hatching_chick": {
		"unicode": "1f423",
		"unicode_alt": "",
		"code_decimal": "&#128035;",
		"name": "hatching chick",
		"shortname": ":hatching_chick:",
		"category": "nature",
		"emoji_order": "1390",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal",
			"chicken"
		]
	},
	"baby_chick": {
		"unicode": "1f424",
		"unicode_alt": "",
		"code_decimal": "&#128036;",
		"name": "baby chick",
		"shortname": ":baby_chick:",
		"category": "nature",
		"emoji_order": "1391",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal",
			"chicken"
		]
	},
	"hatched_chick": {
		"unicode": "1f425",
		"unicode_alt": "",
		"code_decimal": "&#128037;",
		"name": "front-facing baby chick",
		"shortname": ":hatched_chick:",
		"category": "nature",
		"emoji_order": "1392",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"animal",
			"chicken"
		]
	},
	"bird": {
		"unicode": "1f426",
		"unicode_alt": "",
		"code_decimal": "&#128038;",
		"name": "bird",
		"shortname": ":bird:",
		"category": "nature",
		"emoji_order": "1393",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"penguin": {
		"unicode": "1f427",
		"unicode_alt": "",
		"code_decimal": "&#128039;",
		"name": "penguin",
		"shortname": ":penguin:",
		"category": "nature",
		"emoji_order": "1394",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"dove": {
		"unicode": "1f54a",
		"unicode_alt": "1f54a-fe0f",
		"code_decimal": "&#128330;",
		"name": "dove of peace",
		"shortname": ":dove:",
		"category": "nature",
		"emoji_order": "1395",
		"aliases": [
			":dove_of_peace:"
		],
		"aliases_ascii": [],
		"keywords": [
			"animal"
		]
	},
	"eagle": {
		"unicode": "1f985",
		"unicode_alt": "",
		"code_decimal": "&#129413;",
		"name": "eagle",
		"shortname": ":eagle:",
		"category": "nature",
		"emoji_order": "1396",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"duck": {
		"unicode": "1f986",
		"unicode_alt": "",
		"code_decimal": "&#129414;",
		"name": "duck",
		"shortname": ":duck:",
		"category": "nature",
		"emoji_order": "1397",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"owl": {
		"unicode": "1f989",
		"unicode_alt": "",
		"code_decimal": "&#129417;",
		"name": "owl",
		"shortname": ":owl:",
		"category": "nature",
		"emoji_order": "1398",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"frog": {
		"unicode": "1f438",
		"unicode_alt": "",
		"code_decimal": "&#128056;",
		"name": "frog face",
		"shortname": ":frog:",
		"category": "nature",
		"emoji_order": "1399",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"crocodile": {
		"unicode": "1f40a",
		"unicode_alt": "",
		"code_decimal": "&#128010;",
		"name": "crocodile",
		"shortname": ":crocodile:",
		"category": "nature",
		"emoji_order": "1400",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"reptile",
			"animal"
		]
	},
	"turtle": {
		"unicode": "1f422",
		"unicode_alt": "",
		"code_decimal": "&#128034;",
		"name": "turtle",
		"shortname": ":turtle:",
		"category": "nature",
		"emoji_order": "1401",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"reptile",
			"animal"
		]
	},
	"lizard": {
		"unicode": "1f98e",
		"unicode_alt": "",
		"code_decimal": "&#129422;",
		"name": "lizard",
		"shortname": ":lizard:",
		"category": "nature",
		"emoji_order": "1402",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"snake": {
		"unicode": "1f40d",
		"unicode_alt": "",
		"code_decimal": "&#128013;",
		"name": "snake",
		"shortname": ":snake:",
		"category": "nature",
		"emoji_order": "1403",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"reptile",
			"animal",
			"creationism"
		]
	},
	"dragon_face": {
		"unicode": "1f432",
		"unicode_alt": "",
		"code_decimal": "&#128050;",
		"name": "dragon face",
		"shortname": ":dragon_face:",
		"category": "nature",
		"emoji_order": "1404",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"roar",
			"monster",
			"reptile",
			"animal"
		]
	},
	"dragon": {
		"unicode": "1f409",
		"unicode_alt": "",
		"code_decimal": "&#128009;",
		"name": "dragon",
		"shortname": ":dragon:",
		"category": "nature",
		"emoji_order": "1405",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"roar",
			"reptile",
			"animal"
		]
	},
	"whale": {
		"unicode": "1f433",
		"unicode_alt": "",
		"code_decimal": "&#128051;",
		"name": "spouting whale",
		"shortname": ":whale:",
		"category": "nature",
		"emoji_order": "1406",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"tropical",
			"whales",
			"animal"
		]
	},
	"whale2": {
		"unicode": "1f40b",
		"unicode_alt": "",
		"code_decimal": "&#128011;",
		"name": "whale",
		"shortname": ":whale2:",
		"category": "nature",
		"emoji_order": "1407",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"tropical",
			"whales",
			"animal"
		]
	},
	"dolphin": {
		"unicode": "1f42c",
		"unicode_alt": "",
		"code_decimal": "&#128044;",
		"name": "dolphin",
		"shortname": ":dolphin:",
		"category": "nature",
		"emoji_order": "1408",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"tropical",
			"animal"
		]
	},
	"fish": {
		"unicode": "1f41f",
		"unicode_alt": "",
		"code_decimal": "&#128031;",
		"name": "fish",
		"shortname": ":fish:",
		"category": "nature",
		"emoji_order": "1409",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"tropical_fish": {
		"unicode": "1f420",
		"unicode_alt": "",
		"code_decimal": "&#128032;",
		"name": "tropical fish",
		"shortname": ":tropical_fish:",
		"category": "nature",
		"emoji_order": "1410",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"blowfish": {
		"unicode": "1f421",
		"unicode_alt": "",
		"code_decimal": "&#128033;",
		"name": "blowfish",
		"shortname": ":blowfish:",
		"category": "nature",
		"emoji_order": "1411",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"shark": {
		"unicode": "1f988",
		"unicode_alt": "",
		"code_decimal": "&#129416;",
		"name": "shark",
		"shortname": ":shark:",
		"category": "nature",
		"emoji_order": "1412",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"octopus": {
		"unicode": "1f419",
		"unicode_alt": "",
		"code_decimal": "&#128025;",
		"name": "octopus",
		"shortname": ":octopus:",
		"category": "nature",
		"emoji_order": "1413",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"wildlife",
			"animal"
		]
	},
	"shell": {
		"unicode": "1f41a",
		"unicode_alt": "",
		"code_decimal": "&#128026;",
		"name": "spiral shell",
		"shortname": ":shell:",
		"category": "nature",
		"emoji_order": "1414",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"crab": {
		"unicode": "1f980",
		"unicode_alt": "",
		"code_decimal": "&#129408;",
		"name": "crab",
		"shortname": ":crab:",
		"category": "nature",
		"emoji_order": "1415",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"tropical",
			"animal"
		]
	},
	"shrimp": {
		"unicode": "1f990",
		"unicode_alt": "",
		"code_decimal": "&#129424;",
		"name": "shrimp",
		"shortname": ":shrimp:",
		"category": "nature",
		"emoji_order": "1416",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"squid": {
		"unicode": "1f991",
		"unicode_alt": "",
		"code_decimal": "&#129425;",
		"name": "squid",
		"shortname": ":squid:",
		"category": "nature",
		"emoji_order": "1417",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"butterfly": {
		"unicode": "1f98b",
		"unicode_alt": "",
		"code_decimal": "&#129419;",
		"name": "butterfly",
		"shortname": ":butterfly:",
		"category": "nature",
		"emoji_order": "1418",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"snail": {
		"unicode": "1f40c",
		"unicode_alt": "",
		"code_decimal": "&#128012;",
		"name": "snail",
		"shortname": ":snail:",
		"category": "nature",
		"emoji_order": "1419",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"animal"
		]
	},
	"bug": {
		"unicode": "1f41b",
		"unicode_alt": "",
		"code_decimal": "&#128027;",
		"name": "bug",
		"shortname": ":bug:",
		"category": "nature",
		"emoji_order": "1420",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"animal"
		]
	},
	"ant": {
		"unicode": "1f41c",
		"unicode_alt": "",
		"code_decimal": "&#128028;",
		"name": "ant",
		"shortname": ":ant:",
		"category": "nature",
		"emoji_order": "1421",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"animal"
		]
	},
	"bee": {
		"unicode": "1f41d",
		"unicode_alt": "",
		"code_decimal": "&#128029;",
		"name": "honeybee",
		"shortname": ":bee:",
		"category": "nature",
		"emoji_order": "1422",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"animal"
		]
	},
	"beetle": {
		"unicode": "1f41e",
		"unicode_alt": "",
		"code_decimal": "&#128030;",
		"name": "lady beetle",
		"shortname": ":beetle:",
		"category": "nature",
		"emoji_order": "1423",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"animal"
		]
	},
	"spider": {
		"unicode": "1f577",
		"unicode_alt": "1f577-fe0f",
		"code_decimal": "&#128375;",
		"name": "spider",
		"shortname": ":spider:",
		"category": "nature",
		"emoji_order": "1424",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"halloween",
			"animal"
		]
	},
	"spider_web": {
		"unicode": "1f578",
		"unicode_alt": "1f578-fe0f",
		"code_decimal": "&#128376;",
		"name": "spider web",
		"shortname": ":spider_web:",
		"category": "nature",
		"emoji_order": "1425",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"halloween"
		]
	},
	"scorpion": {
		"unicode": "1f982",
		"unicode_alt": "",
		"code_decimal": "&#129410;",
		"name": "scorpion",
		"shortname": ":scorpion:",
		"category": "nature",
		"emoji_order": "1426",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"insects",
			"reptile",
			"animal"
		]
	},
	"bouquet": {
		"unicode": "1f490",
		"unicode_alt": "",
		"code_decimal": "&#128144;",
		"name": "bouquet",
		"shortname": ":bouquet:",
		"category": "nature",
		"emoji_order": "1427",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant",
			"rip",
			"condolence"
		]
	},
	"cherry_blossom": {
		"unicode": "1f338",
		"unicode_alt": "",
		"code_decimal": "&#127800;",
		"name": "cherry blossom",
		"shortname": ":cherry_blossom:",
		"category": "nature",
		"emoji_order": "1428",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant",
			"tropical"
		]
	},
	"white_flower": {
		"unicode": "1f4ae",
		"unicode_alt": "",
		"code_decimal": "&#128174;",
		"name": "white flower",
		"shortname": ":white_flower:",
		"category": "symbols",
		"emoji_order": "1429",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"flower",
			"symbol"
		]
	},
	"rosette": {
		"unicode": "1f3f5",
		"unicode_alt": "1f3f5-fe0f",
		"code_decimal": "&#127989;",
		"name": "rosette",
		"shortname": ":rosette:",
		"category": "nature",
		"emoji_order": "1430",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"tropical"
		]
	},
	"rose": {
		"unicode": "1f339",
		"unicode_alt": "",
		"code_decimal": "&#127801;",
		"name": "rose",
		"shortname": ":rose:",
		"category": "nature",
		"emoji_order": "1431",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant",
			"rip",
			"condolence",
			"beautiful"
		]
	},
	"wilted_rose": {
		"unicode": "1f940",
		"unicode_alt": "",
		"code_decimal": "&#129344;",
		"name": "wilted flower",
		"shortname": ":wilted_rose:",
		"category": "nature",
		"emoji_order": "1432",
		"aliases": [
			":wilted_flower:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"hibiscus": {
		"unicode": "1f33a",
		"unicode_alt": "",
		"code_decimal": "&#127802;",
		"name": "hibiscus",
		"shortname": ":hibiscus:",
		"category": "nature",
		"emoji_order": "1433",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant",
			"tropical"
		]
	},
	"sunflower": {
		"unicode": "1f33b",
		"unicode_alt": "",
		"code_decimal": "&#127803;",
		"name": "sunflower",
		"shortname": ":sunflower:",
		"category": "nature",
		"emoji_order": "1434",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant"
		]
	},
	"blossom": {
		"unicode": "1f33c",
		"unicode_alt": "",
		"code_decimal": "&#127804;",
		"name": "blossom",
		"shortname": ":blossom:",
		"category": "nature",
		"emoji_order": "1435",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant"
		]
	},
	"tulip": {
		"unicode": "1f337",
		"unicode_alt": "",
		"code_decimal": "&#127799;",
		"name": "tulip",
		"shortname": ":tulip:",
		"category": "nature",
		"emoji_order": "1436",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"flower",
			"plant",
			"vagina",
			"girls night"
		]
	},
	"seedling": {
		"unicode": "1f331",
		"unicode_alt": "",
		"code_decimal": "&#127793;",
		"name": "seedling",
		"shortname": ":seedling:",
		"category": "nature",
		"emoji_order": "1437",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"leaf"
		]
	},
	"evergreen_tree": {
		"unicode": "1f332",
		"unicode_alt": "",
		"code_decimal": "&#127794;",
		"name": "evergreen tree",
		"shortname": ":evergreen_tree:",
		"category": "nature",
		"emoji_order": "1438",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"holidays",
			"christmas",
			"camp",
			"trees"
		]
	},
	"deciduous_tree": {
		"unicode": "1f333",
		"unicode_alt": "",
		"code_decimal": "&#127795;",
		"name": "deciduous tree",
		"shortname": ":deciduous_tree:",
		"category": "nature",
		"emoji_order": "1439",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"camp",
			"trees"
		]
	},
	"palm_tree": {
		"unicode": "1f334",
		"unicode_alt": "",
		"code_decimal": "&#127796;",
		"name": "palm tree",
		"shortname": ":palm_tree:",
		"category": "nature",
		"emoji_order": "1440",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"tropical",
			"trees"
		]
	},
	"cactus": {
		"unicode": "1f335",
		"unicode_alt": "",
		"code_decimal": "&#127797;",
		"name": "cactus",
		"shortname": ":cactus:",
		"category": "nature",
		"emoji_order": "1441",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"trees"
		]
	},
	"ear_of_rice": {
		"unicode": "1f33e",
		"unicode_alt": "",
		"code_decimal": "&#127806;",
		"name": "ear of rice",
		"shortname": ":ear_of_rice:",
		"category": "nature",
		"emoji_order": "1442",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"leaf"
		]
	},
	"herb": {
		"unicode": "1f33f",
		"unicode_alt": "",
		"code_decimal": "&#127807;",
		"name": "herb",
		"shortname": ":herb:",
		"category": "nature",
		"emoji_order": "1443",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"leaf"
		]
	},
	"shamrock": {
		"unicode": "2618",
		"unicode_alt": "2618-fe0f",
		"code_decimal": "&#9752;",
		"name": "shamrock",
		"shortname": ":shamrock:",
		"category": "nature",
		"emoji_order": "1444",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"luck",
			"leaf"
		]
	},
	"four_leaf_clover": {
		"unicode": "1f340",
		"unicode_alt": "",
		"code_decimal": "&#127808;",
		"name": "four leaf clover",
		"shortname": ":four_leaf_clover:",
		"category": "nature",
		"emoji_order": "1445",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"luck",
			"leaf",
			"sol"
		]
	},
	"maple_leaf": {
		"unicode": "1f341",
		"unicode_alt": "",
		"code_decimal": "&#127809;",
		"name": "maple leaf",
		"shortname": ":maple_leaf:",
		"category": "nature",
		"emoji_order": "1446",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"leaf"
		]
	},
	"fallen_leaf": {
		"unicode": "1f342",
		"unicode_alt": "",
		"code_decimal": "&#127810;",
		"name": "fallen leaf",
		"shortname": ":fallen_leaf:",
		"category": "nature",
		"emoji_order": "1447",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"leaf"
		]
	},
	"leaves": {
		"unicode": "1f343",
		"unicode_alt": "",
		"code_decimal": "&#127811;",
		"name": "leaf fluttering in wind",
		"shortname": ":leaves:",
		"category": "nature",
		"emoji_order": "1448",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"leaf"
		]
	},
	"grapes": {
		"unicode": "1f347",
		"unicode_alt": "",
		"code_decimal": "&#127815;",
		"name": "grapes",
		"shortname": ":grapes:",
		"category": "food",
		"emoji_order": "1449",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"melon": {
		"unicode": "1f348",
		"unicode_alt": "",
		"code_decimal": "&#127816;",
		"name": "melon",
		"shortname": ":melon:",
		"category": "food",
		"emoji_order": "1450",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"boobs",
			"food"
		]
	},
	"watermelon": {
		"unicode": "1f349",
		"unicode_alt": "",
		"code_decimal": "&#127817;",
		"name": "watermelon",
		"shortname": ":watermelon:",
		"category": "food",
		"emoji_order": "1451",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"tangerine": {
		"unicode": "1f34a",
		"unicode_alt": "",
		"code_decimal": "&#127818;",
		"name": "tangerine",
		"shortname": ":tangerine:",
		"category": "food",
		"emoji_order": "1452",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"lemon": {
		"unicode": "1f34b",
		"unicode_alt": "",
		"code_decimal": "&#127819;",
		"name": "lemon",
		"shortname": ":lemon:",
		"category": "food",
		"emoji_order": "1453",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"banana": {
		"unicode": "1f34c",
		"unicode_alt": "",
		"code_decimal": "&#127820;",
		"name": "banana",
		"shortname": ":banana:",
		"category": "food",
		"emoji_order": "1454",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"penis",
			"food"
		]
	},
	"pineapple": {
		"unicode": "1f34d",
		"unicode_alt": "",
		"code_decimal": "&#127821;",
		"name": "pineapple",
		"shortname": ":pineapple:",
		"category": "food",
		"emoji_order": "1455",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food",
			"tropical"
		]
	},
	"apple": {
		"unicode": "1f34e",
		"unicode_alt": "",
		"code_decimal": "&#127822;",
		"name": "red apple",
		"shortname": ":apple:",
		"category": "food",
		"emoji_order": "1456",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food",
			"creationism"
		]
	},
	"green_apple": {
		"unicode": "1f34f",
		"unicode_alt": "",
		"code_decimal": "&#127823;",
		"name": "green apple",
		"shortname": ":green_apple:",
		"category": "food",
		"emoji_order": "1457",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"pear": {
		"unicode": "1f350",
		"unicode_alt": "",
		"code_decimal": "&#127824;",
		"name": "pear",
		"shortname": ":pear:",
		"category": "food",
		"emoji_order": "1458",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"peach": {
		"unicode": "1f351",
		"unicode_alt": "",
		"code_decimal": "&#127825;",
		"name": "peach",
		"shortname": ":peach:",
		"category": "food",
		"emoji_order": "1459",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"butt",
			"food"
		]
	},
	"cherries": {
		"unicode": "1f352",
		"unicode_alt": "",
		"code_decimal": "&#127826;",
		"name": "cherries",
		"shortname": ":cherries:",
		"category": "food",
		"emoji_order": "1460",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"strawberry": {
		"unicode": "1f353",
		"unicode_alt": "",
		"code_decimal": "&#127827;",
		"name": "strawberry",
		"shortname": ":strawberry:",
		"category": "food",
		"emoji_order": "1461",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"food"
		]
	},
	"kiwi": {
		"unicode": "1f95d",
		"unicode_alt": "",
		"code_decimal": "&#129373;",
		"name": "kiwifruit",
		"shortname": ":kiwi:",
		"category": "food",
		"emoji_order": "1462",
		"aliases": [
			":kiwifruit:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"tomato": {
		"unicode": "1f345",
		"unicode_alt": "",
		"code_decimal": "&#127813;",
		"name": "tomato",
		"shortname": ":tomato:",
		"category": "food",
		"emoji_order": "1463",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"fruit",
			"vegetables",
			"food"
		]
	},
	"avocado": {
		"unicode": "1f951",
		"unicode_alt": "",
		"code_decimal": "&#129361;",
		"name": "avocado",
		"shortname": ":avocado:",
		"category": "food",
		"emoji_order": "1464",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"eggplant": {
		"unicode": "1f346",
		"unicode_alt": "",
		"code_decimal": "&#127814;",
		"name": "aubergine",
		"shortname": ":eggplant:",
		"category": "food",
		"emoji_order": "1465",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"vegetables",
			"penis",
			"food"
		]
	},
	"potato": {
		"unicode": "1f954",
		"unicode_alt": "",
		"code_decimal": "&#129364;",
		"name": "potato",
		"shortname": ":potato:",
		"category": "food",
		"emoji_order": "1466",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"carrot": {
		"unicode": "1f955",
		"unicode_alt": "",
		"code_decimal": "&#129365;",
		"name": "carrot",
		"shortname": ":carrot:",
		"category": "food",
		"emoji_order": "1467",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"corn": {
		"unicode": "1f33d",
		"unicode_alt": "",
		"code_decimal": "&#127805;",
		"name": "ear of maize",
		"shortname": ":corn:",
		"category": "food",
		"emoji_order": "1468",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"vegetables",
			"food"
		]
	},
	"hot_pepper": {
		"unicode": "1f336",
		"unicode_alt": "1f336-fe0f",
		"code_decimal": "&#127798;",
		"name": "hot pepper",
		"shortname": ":hot_pepper:",
		"category": "food",
		"emoji_order": "1469",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"vegetables",
			"food"
		]
	},
	"cucumber": {
		"unicode": "1f952",
		"unicode_alt": "",
		"code_decimal": "&#129362;",
		"name": "cucumber",
		"shortname": ":cucumber:",
		"category": "food",
		"emoji_order": "1470",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"mushroom": {
		"unicode": "1f344",
		"unicode_alt": "",
		"code_decimal": "&#127812;",
		"name": "mushroom",
		"shortname": ":mushroom:",
		"category": "nature",
		"emoji_order": "1471",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"drugs"
		]
	},
	"peanuts": {
		"unicode": "1f95c",
		"unicode_alt": "",
		"code_decimal": "&#129372;",
		"name": "peanuts",
		"shortname": ":peanuts:",
		"category": "food",
		"emoji_order": "1472",
		"aliases": [
			":shelled_peanut:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"chestnut": {
		"unicode": "1f330",
		"unicode_alt": "",
		"code_decimal": "&#127792;",
		"name": "chestnut",
		"shortname": ":chestnut:",
		"category": "nature",
		"emoji_order": "1473",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant"
		]
	},
	"bread": {
		"unicode": "1f35e",
		"unicode_alt": "",
		"code_decimal": "&#127838;",
		"name": "bread",
		"shortname": ":bread:",
		"category": "food",
		"emoji_order": "1474",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"croissant": {
		"unicode": "1f950",
		"unicode_alt": "",
		"code_decimal": "&#129360;",
		"name": "croissant",
		"shortname": ":croissant:",
		"category": "food",
		"emoji_order": "1475",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"french_bread": {
		"unicode": "1f956",
		"unicode_alt": "",
		"code_decimal": "&#129366;",
		"name": "baguette bread",
		"shortname": ":french_bread:",
		"category": "food",
		"emoji_order": "1476",
		"aliases": [
			":baguette_bread:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"pancakes": {
		"unicode": "1f95e",
		"unicode_alt": "",
		"code_decimal": "&#129374;",
		"name": "pancakes",
		"shortname": ":pancakes:",
		"category": "food",
		"emoji_order": "1477",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cheese": {
		"unicode": "1f9c0",
		"unicode_alt": "",
		"code_decimal": "&#129472;",
		"name": "cheese wedge",
		"shortname": ":cheese:",
		"category": "food",
		"emoji_order": "1478",
		"aliases": [
			":cheese_wedge:"
		],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"meat_on_bone": {
		"unicode": "1f356",
		"unicode_alt": "",
		"code_decimal": "&#127830;",
		"name": "meat on bone",
		"shortname": ":meat_on_bone:",
		"category": "food",
		"emoji_order": "1479",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"poultry_leg": {
		"unicode": "1f357",
		"unicode_alt": "",
		"code_decimal": "&#127831;",
		"name": "poultry leg",
		"shortname": ":poultry_leg:",
		"category": "food",
		"emoji_order": "1480",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"holidays"
		]
	},
	"bacon": {
		"unicode": "1f953",
		"unicode_alt": "",
		"code_decimal": "&#129363;",
		"name": "bacon",
		"shortname": ":bacon:",
		"category": "food",
		"emoji_order": "1481",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"pig"
		]
	},
	"hamburger": {
		"unicode": "1f354",
		"unicode_alt": "",
		"code_decimal": "&#127828;",
		"name": "hamburger",
		"shortname": ":hamburger:",
		"category": "food",
		"emoji_order": "1482",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"america",
			"food"
		]
	},
	"fries": {
		"unicode": "1f35f",
		"unicode_alt": "",
		"code_decimal": "&#127839;",
		"name": "french fries",
		"shortname": ":fries:",
		"category": "food",
		"emoji_order": "1483",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"america",
			"food"
		]
	},
	"pizza": {
		"unicode": "1f355",
		"unicode_alt": "",
		"code_decimal": "&#127829;",
		"name": "slice of pizza",
		"shortname": ":pizza:",
		"category": "food",
		"emoji_order": "1484",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"italian",
			"food",
			"boys night"
		]
	},
	"hotdog": {
		"unicode": "1f32d",
		"unicode_alt": "",
		"code_decimal": "&#127789;",
		"name": "hot dog",
		"shortname": ":hotdog:",
		"category": "food",
		"emoji_order": "1485",
		"aliases": [
			":hot_dog:"
		],
		"aliases_ascii": [],
		"keywords": [
			"america",
			"food"
		]
	},
	"taco": {
		"unicode": "1f32e",
		"unicode_alt": "",
		"code_decimal": "&#127790;",
		"name": "taco",
		"shortname": ":taco:",
		"category": "food",
		"emoji_order": "1486",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"mexican",
			"vagina"
		]
	},
	"burrito": {
		"unicode": "1f32f",
		"unicode_alt": "",
		"code_decimal": "&#127791;",
		"name": "burrito",
		"shortname": ":burrito:",
		"category": "food",
		"emoji_order": "1487",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"mexican"
		]
	},
	"stuffed_flatbread": {
		"unicode": "1f959",
		"unicode_alt": "",
		"code_decimal": "&#129369;",
		"name": "stuffed flatbread",
		"shortname": ":stuffed_flatbread:",
		"category": "food",
		"emoji_order": "1488",
		"aliases": [
			":stuffed_pita:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"egg": {
		"unicode": "1f95a",
		"unicode_alt": "",
		"code_decimal": "&#129370;",
		"name": "egg",
		"shortname": ":egg:",
		"category": "food",
		"emoji_order": "1489",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"cooking": {
		"unicode": "1f373",
		"unicode_alt": "",
		"code_decimal": "&#127859;",
		"name": "cooking",
		"shortname": ":cooking:",
		"category": "food",
		"emoji_order": "1490",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"shallow_pan_of_food": {
		"unicode": "1f958",
		"unicode_alt": "",
		"code_decimal": "&#129368;",
		"name": "shallow pan of food",
		"shortname": ":shallow_pan_of_food:",
		"category": "food",
		"emoji_order": "1491",
		"aliases": [
			":paella:"
		],
		"aliases_ascii": [],
		"keywords": [
			"pan of food"
		]
	},
	"stew": {
		"unicode": "1f372",
		"unicode_alt": "",
		"code_decimal": "&#127858;",
		"name": "pot of food",
		"shortname": ":stew:",
		"category": "food",
		"emoji_order": "1492",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"steam"
		]
	},
	"salad": {
		"unicode": "1f957",
		"unicode_alt": "",
		"code_decimal": "&#129367;",
		"name": "green salad",
		"shortname": ":salad:",
		"category": "food",
		"emoji_order": "1493",
		"aliases": [
			":green_salad:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"popcorn": {
		"unicode": "1f37f",
		"unicode_alt": "",
		"code_decimal": "&#127871;",
		"name": "popcorn",
		"shortname": ":popcorn:",
		"category": "food",
		"emoji_order": "1494",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"parties"
		]
	},
	"bento": {
		"unicode": "1f371",
		"unicode_alt": "",
		"code_decimal": "&#127857;",
		"name": "bento box",
		"shortname": ":bento:",
		"category": "food",
		"emoji_order": "1495",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"sushi",
			"japan",
			"food"
		]
	},
	"rice_cracker": {
		"unicode": "1f358",
		"unicode_alt": "",
		"code_decimal": "&#127832;",
		"name": "rice cracker",
		"shortname": ":rice_cracker:",
		"category": "food",
		"emoji_order": "1496",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sushi",
			"food"
		]
	},
	"rice_ball": {
		"unicode": "1f359",
		"unicode_alt": "",
		"code_decimal": "&#127833;",
		"name": "rice ball",
		"shortname": ":rice_ball:",
		"category": "food",
		"emoji_order": "1497",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sushi",
			"japan",
			"food"
		]
	},
	"rice": {
		"unicode": "1f35a",
		"unicode_alt": "",
		"code_decimal": "&#127834;",
		"name": "cooked rice",
		"shortname": ":rice:",
		"category": "food",
		"emoji_order": "1498",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sushi",
			"japan",
			"food"
		]
	},
	"curry": {
		"unicode": "1f35b",
		"unicode_alt": "",
		"code_decimal": "&#127835;",
		"name": "curry and rice",
		"shortname": ":curry:",
		"category": "food",
		"emoji_order": "1499",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"ramen": {
		"unicode": "1f35c",
		"unicode_alt": "",
		"code_decimal": "&#127836;",
		"name": "steaming bowl",
		"shortname": ":ramen:",
		"category": "food",
		"emoji_order": "1500",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"noodles",
			"ramen",
			"japan",
			"food"
		]
	},
	"spaghetti": {
		"unicode": "1f35d",
		"unicode_alt": "",
		"code_decimal": "&#127837;",
		"name": "spaghetti",
		"shortname": ":spaghetti:",
		"category": "food",
		"emoji_order": "1501",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"noodles",
			"pasta",
			"italian",
			"food"
		]
	},
	"sweet_potato": {
		"unicode": "1f360",
		"unicode_alt": "",
		"code_decimal": "&#127840;",
		"name": "roasted sweet potato",
		"shortname": ":sweet_potato:",
		"category": "food",
		"emoji_order": "1502",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"vegetables",
			"food"
		]
	},
	"oden": {
		"unicode": "1f362",
		"unicode_alt": "",
		"code_decimal": "&#127842;",
		"name": "oden",
		"shortname": ":oden:",
		"category": "food",
		"emoji_order": "1503",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"sushi": {
		"unicode": "1f363",
		"unicode_alt": "",
		"code_decimal": "&#127843;",
		"name": "sushi",
		"shortname": ":sushi:",
		"category": "food",
		"emoji_order": "1504",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sushi",
			"japan",
			"food"
		]
	},
	"fried_shrimp": {
		"unicode": "1f364",
		"unicode_alt": "",
		"code_decimal": "&#127844;",
		"name": "fried shrimp",
		"shortname": ":fried_shrimp:",
		"category": "food",
		"emoji_order": "1505",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"fish_cake": {
		"unicode": "1f365",
		"unicode_alt": "",
		"code_decimal": "&#127845;",
		"name": "fish cake with swirl design",
		"shortname": ":fish_cake:",
		"category": "food",
		"emoji_order": "1506",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sushi",
			"food"
		]
	},
	"dango": {
		"unicode": "1f361",
		"unicode_alt": "",
		"code_decimal": "&#127841;",
		"name": "dango",
		"shortname": ":dango:",
		"category": "food",
		"emoji_order": "1507",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"icecream": {
		"unicode": "1f366",
		"unicode_alt": "",
		"code_decimal": "&#127846;",
		"name": "soft ice cream",
		"shortname": ":icecream:",
		"category": "food",
		"emoji_order": "1508",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"shaved_ice": {
		"unicode": "1f367",
		"unicode_alt": "",
		"code_decimal": "&#127847;",
		"name": "shaved ice",
		"shortname": ":shaved_ice:",
		"category": "food",
		"emoji_order": "1509",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"ice_cream": {
		"unicode": "1f368",
		"unicode_alt": "",
		"code_decimal": "&#127848;",
		"name": "ice cream",
		"shortname": ":ice_cream:",
		"category": "food",
		"emoji_order": "1510",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"doughnut": {
		"unicode": "1f369",
		"unicode_alt": "",
		"code_decimal": "&#127849;",
		"name": "doughnut",
		"shortname": ":doughnut:",
		"category": "food",
		"emoji_order": "1511",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"cookie": {
		"unicode": "1f36a",
		"unicode_alt": "",
		"code_decimal": "&#127850;",
		"name": "cookie",
		"shortname": ":cookie:",
		"category": "food",
		"emoji_order": "1512",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"vagina"
		]
	},
	"birthday": {
		"unicode": "1f382",
		"unicode_alt": "",
		"code_decimal": "&#127874;",
		"name": "birthday cake",
		"shortname": ":birthday:",
		"category": "food",
		"emoji_order": "1513",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"birthday",
			"food",
			"parties"
		]
	},
	"cake": {
		"unicode": "1f370",
		"unicode_alt": "",
		"code_decimal": "&#127856;",
		"name": "shortcake",
		"shortname": ":cake:",
		"category": "food",
		"emoji_order": "1514",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"chocolate_bar": {
		"unicode": "1f36b",
		"unicode_alt": "",
		"code_decimal": "&#127851;",
		"name": "chocolate bar",
		"shortname": ":chocolate_bar:",
		"category": "food",
		"emoji_order": "1515",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"halloween"
		]
	},
	"candy": {
		"unicode": "1f36c",
		"unicode_alt": "",
		"code_decimal": "&#127852;",
		"name": "candy",
		"shortname": ":candy:",
		"category": "food",
		"emoji_order": "1516",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"halloween"
		]
	},
	"lollipop": {
		"unicode": "1f36d",
		"unicode_alt": "",
		"code_decimal": "&#127853;",
		"name": "lollipop",
		"shortname": ":lollipop:",
		"category": "food",
		"emoji_order": "1517",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"halloween"
		]
	},
	"custard": {
		"unicode": "1f36e",
		"unicode_alt": "",
		"code_decimal": "&#127854;",
		"name": "custard",
		"shortname": ":custard:",
		"category": "food",
		"emoji_order": "1518",
		"aliases": [
			":pudding:",
			":flan:"
		],
		"aliases_ascii": [],
		"keywords": [
			"food"
		]
	},
	"honey_pot": {
		"unicode": "1f36f",
		"unicode_alt": "",
		"code_decimal": "&#127855;",
		"name": "honey pot",
		"shortname": ":honey_pot:",
		"category": "food",
		"emoji_order": "1519",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"food",
			"vagina"
		]
	},
	"baby_bottle": {
		"unicode": "1f37c",
		"unicode_alt": "",
		"code_decimal": "&#127868;",
		"name": "baby bottle",
		"shortname": ":baby_bottle:",
		"category": "food",
		"emoji_order": "1520",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"object",
			"food",
			"baby"
		]
	},
	"milk": {
		"unicode": "1f95b",
		"unicode_alt": "",
		"code_decimal": "&#129371;",
		"name": "glass of milk",
		"shortname": ":milk:",
		"category": "food",
		"emoji_order": "1521",
		"aliases": [
			":glass_of_milk:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"coffee": {
		"unicode": "2615",
		"unicode_alt": "2615-fe0f",
		"code_decimal": "&#9749;",
		"name": "hot beverage",
		"shortname": ":coffee:",
		"category": "food",
		"emoji_order": "1522",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"caffeine",
			"steam",
			"morning"
		]
	},
	"tea": {
		"unicode": "1f375",
		"unicode_alt": "",
		"code_decimal": "&#127861;",
		"name": "teacup without handle",
		"shortname": ":tea:",
		"category": "food",
		"emoji_order": "1523",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"japan",
			"caffeine",
			"steam",
			"morning"
		]
	},
	"sake": {
		"unicode": "1f376",
		"unicode_alt": "",
		"code_decimal": "&#127862;",
		"name": "sake bottle and cup",
		"shortname": ":sake:",
		"category": "food",
		"emoji_order": "1524",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"japan",
			"sake",
			"alcohol",
			"girls night"
		]
	},
	"champagne": {
		"unicode": "1f37e",
		"unicode_alt": "",
		"code_decimal": "&#127870;",
		"name": "bottle with popping cork",
		"shortname": ":champagne:",
		"category": "food",
		"emoji_order": "1525",
		"aliases": [
			":bottle_with_popping_cork:"
		],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"cheers",
			"alcohol",
			"parties"
		]
	},
	"wine_glass": {
		"unicode": "1f377",
		"unicode_alt": "",
		"code_decimal": "&#127863;",
		"name": "wine glass",
		"shortname": ":wine_glass:",
		"category": "food",
		"emoji_order": "1526",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"italian",
			"alcohol",
			"girls night",
			"parties"
		]
	},
	"cocktail": {
		"unicode": "1f378",
		"unicode_alt": "",
		"code_decimal": "&#127864;",
		"name": "cocktail glass",
		"shortname": ":cocktail:",
		"category": "food",
		"emoji_order": "1527",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"cocktail",
			"alcohol",
			"girls night",
			"parties"
		]
	},
	"tropical_drink": {
		"unicode": "1f379",
		"unicode_alt": "",
		"code_decimal": "&#127865;",
		"name": "tropical drink",
		"shortname": ":tropical_drink:",
		"category": "food",
		"emoji_order": "1528",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"cocktail",
			"tropical",
			"alcohol"
		]
	},
	"beer": {
		"unicode": "1f37a",
		"unicode_alt": "",
		"code_decimal": "&#127866;",
		"name": "beer mug",
		"shortname": ":beer:",
		"category": "food",
		"emoji_order": "1529",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"beer",
			"alcohol",
			"parties"
		]
	},
	"beers": {
		"unicode": "1f37b",
		"unicode_alt": "",
		"code_decimal": "&#127867;",
		"name": "clinking beer mugs",
		"shortname": ":beers:",
		"category": "food",
		"emoji_order": "1530",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"drink",
			"cheers",
			"beer",
			"alcohol",
			"thank you",
			"boys night",
			"parties"
		]
	},
	"champagne_glass": {
		"unicode": "1f942",
		"unicode_alt": "",
		"code_decimal": "&#129346;",
		"name": "clinking glasses",
		"shortname": ":champagne_glass:",
		"category": "food",
		"emoji_order": "1531",
		"aliases": [
			":clinking_glass:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"tumbler_glass": {
		"unicode": "1f943",
		"unicode_alt": "",
		"code_decimal": "&#129347;",
		"name": "tumbler glass",
		"shortname": ":tumbler_glass:",
		"category": "food",
		"emoji_order": "1532",
		"aliases": [
			":whisky:"
		],
		"aliases_ascii": [],
		"keywords": [
			"booze"
		]
	},
	"fork_knife_plate": {
		"unicode": "1f37d",
		"unicode_alt": "1f37d-fe0f",
		"code_decimal": "&#127869;",
		"name": "fork and knife with plate",
		"shortname": ":fork_knife_plate:",
		"category": "food",
		"emoji_order": "1533",
		"aliases": [
			":fork_and_knife_with_plate:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"food"
		]
	},
	"fork_and_knife": {
		"unicode": "1f374",
		"unicode_alt": "",
		"code_decimal": "&#127860;",
		"name": "fork and knife",
		"shortname": ":fork_and_knife:",
		"category": "food",
		"emoji_order": "1534",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon",
			"food"
		]
	},
	"spoon": {
		"unicode": "1f944",
		"unicode_alt": "",
		"code_decimal": "&#129348;",
		"name": "spoon",
		"shortname": ":spoon:",
		"category": "food",
		"emoji_order": "1535",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"knife": {
		"unicode": "1f52a",
		"unicode_alt": "",
		"code_decimal": "&#128298;",
		"name": "hocho",
		"shortname": ":knife:",
		"category": "objects",
		"emoji_order": "1536",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon"
		]
	},
	"amphora": {
		"unicode": "1f3fa",
		"unicode_alt": "",
		"code_decimal": "&#127994;",
		"name": "amphora",
		"shortname": ":amphora:",
		"category": "objects",
		"emoji_order": "1537",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"earth_africa": {
		"unicode": "1f30d",
		"unicode_alt": "",
		"code_decimal": "&#127757;",
		"name": "earth globe europe-africa",
		"shortname": ":earth_africa:",
		"category": "nature",
		"emoji_order": "1538",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"map",
			"vacation",
			"globe"
		]
	},
	"earth_americas": {
		"unicode": "1f30e",
		"unicode_alt": "",
		"code_decimal": "&#127758;",
		"name": "earth globe americas",
		"shortname": ":earth_americas:",
		"category": "nature",
		"emoji_order": "1539",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"map",
			"vacation",
			"globe"
		]
	},
	"earth_asia": {
		"unicode": "1f30f",
		"unicode_alt": "",
		"code_decimal": "&#127759;",
		"name": "earth globe asia-australia",
		"shortname": ":earth_asia:",
		"category": "nature",
		"emoji_order": "1540",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"map",
			"vacation",
			"globe"
		]
	},
	"globe_with_meridians": {
		"unicode": "1f310",
		"unicode_alt": "",
		"code_decimal": "&#127760;",
		"name": "globe with meridians",
		"shortname": ":globe_with_meridians:",
		"category": "symbols",
		"emoji_order": "1541",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"globe"
		]
	},
	"map": {
		"unicode": "1f5fa",
		"unicode_alt": "1f5fa-fe0f",
		"code_decimal": "&#128506;",
		"name": "world map",
		"shortname": ":map:",
		"category": "objects",
		"emoji_order": "1542",
		"aliases": [
			":world_map:"
		],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"map",
			"vacation"
		]
	},
	"japan": {
		"unicode": "1f5fe",
		"unicode_alt": "",
		"code_decimal": "&#128510;",
		"name": "silhouette of japan",
		"shortname": ":japan:",
		"category": "travel",
		"emoji_order": "1543",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"map",
			"vacation",
			"tropical"
		]
	},
	"mountain_snow": {
		"unicode": "1f3d4",
		"unicode_alt": "1f3d4-fe0f",
		"code_decimal": "&#127956;",
		"name": "snow capped mountain",
		"shortname": ":mountain_snow:",
		"category": "travel",
		"emoji_order": "1544",
		"aliases": [
			":snow_capped_mountain:"
		],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"cold",
			"camp"
		]
	},
	"mountain": {
		"unicode": "26f0",
		"unicode_alt": "26f0-fe0f",
		"code_decimal": "&#9968;",
		"name": "mountain",
		"shortname": ":mountain:",
		"category": "travel",
		"emoji_order": "1545",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"camp"
		]
	},
	"volcano": {
		"unicode": "1f30b",
		"unicode_alt": "",
		"code_decimal": "&#127755;",
		"name": "volcano",
		"shortname": ":volcano:",
		"category": "travel",
		"emoji_order": "1546",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"tropical"
		]
	},
	"mount_fuji": {
		"unicode": "1f5fb",
		"unicode_alt": "",
		"code_decimal": "&#128507;",
		"name": "mount fuji",
		"shortname": ":mount_fuji:",
		"category": "travel",
		"emoji_order": "1547",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"cold",
			"camp"
		]
	},
	"camping": {
		"unicode": "1f3d5",
		"unicode_alt": "1f3d5-fe0f",
		"code_decimal": "&#127957;",
		"name": "camping",
		"shortname": ":camping:",
		"category": "travel",
		"emoji_order": "1548",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"camp"
		]
	},
	"beach": {
		"unicode": "1f3d6",
		"unicode_alt": "1f3d6-fe0f",
		"code_decimal": "&#127958;",
		"name": "beach with umbrella",
		"shortname": ":beach:",
		"category": "travel",
		"emoji_order": "1549",
		"aliases": [
			":beach_with_umbrella:"
		],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"tropical",
			"beach",
			"swim"
		]
	},
	"desert": {
		"unicode": "1f3dc",
		"unicode_alt": "1f3dc-fe0f",
		"code_decimal": "&#127964;",
		"name": "desert",
		"shortname": ":desert:",
		"category": "travel",
		"emoji_order": "1550",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"hot"
		]
	},
	"island": {
		"unicode": "1f3dd",
		"unicode_alt": "1f3dd-fe0f",
		"code_decimal": "&#127965;",
		"name": "desert island",
		"shortname": ":island:",
		"category": "travel",
		"emoji_order": "1551",
		"aliases": [
			":desert_island:"
		],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"tropical",
			"beach",
			"swim"
		]
	},
	"park": {
		"unicode": "1f3de",
		"unicode_alt": "1f3de-fe0f",
		"code_decimal": "&#127966;",
		"name": "national park",
		"shortname": ":park:",
		"category": "travel",
		"emoji_order": "1552",
		"aliases": [
			":national_park:"
		],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"vacation",
			"park",
			"camp"
		]
	},
	"stadium": {
		"unicode": "1f3df",
		"unicode_alt": "1f3df-fe0f",
		"code_decimal": "&#127967;",
		"name": "stadium",
		"shortname": ":stadium:",
		"category": "travel",
		"emoji_order": "1553",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"travel",
			"vacation",
			"boys night"
		]
	},
	"classical_building": {
		"unicode": "1f3db",
		"unicode_alt": "1f3db-fe0f",
		"code_decimal": "&#127963;",
		"name": "classical building",
		"shortname": ":classical_building:",
		"category": "travel",
		"emoji_order": "1554",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"travel",
			"vacation"
		]
	},
	"construction_site": {
		"unicode": "1f3d7",
		"unicode_alt": "1f3d7-fe0f",
		"code_decimal": "&#127959;",
		"name": "building construction",
		"shortname": ":construction_site:",
		"category": "travel",
		"emoji_order": "1555",
		"aliases": [
			":building_construction:"
		],
		"aliases_ascii": [],
		"keywords": [
			"building",
			"crane"
		]
	},
	"homes": {
		"unicode": "1f3d8",
		"unicode_alt": "1f3d8-fe0f",
		"code_decimal": "&#127960;",
		"name": "house buildings",
		"shortname": ":homes:",
		"category": "travel",
		"emoji_order": "1556",
		"aliases": [
			":house_buildings:"
		],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"house"
		]
	},
	"cityscape": {
		"unicode": "1f3d9",
		"unicode_alt": "1f3d9-fe0f",
		"code_decimal": "&#127961;",
		"name": "cityscape",
		"shortname": ":cityscape:",
		"category": "travel",
		"emoji_order": "1557",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"vacation"
		]
	},
	"house_abandoned": {
		"unicode": "1f3da",
		"unicode_alt": "1f3da-fe0f",
		"code_decimal": "&#127962;",
		"name": "derelict house building",
		"shortname": ":house_abandoned:",
		"category": "travel",
		"emoji_order": "1558",
		"aliases": [
			":derelict_house_building:"
		],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"house"
		]
	},
	"house": {
		"unicode": "1f3e0",
		"unicode_alt": "",
		"code_decimal": "&#127968;",
		"name": "house building",
		"shortname": ":house:",
		"category": "travel",
		"emoji_order": "1559",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"house"
		]
	},
	"house_with_garden": {
		"unicode": "1f3e1",
		"unicode_alt": "",
		"code_decimal": "&#127969;",
		"name": "house with garden",
		"shortname": ":house_with_garden:",
		"category": "travel",
		"emoji_order": "1560",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"house"
		]
	},
	"office": {
		"unicode": "1f3e2",
		"unicode_alt": "",
		"code_decimal": "&#127970;",
		"name": "office building",
		"shortname": ":office:",
		"category": "travel",
		"emoji_order": "1561",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"work"
		]
	},
	"post_office": {
		"unicode": "1f3e3",
		"unicode_alt": "",
		"code_decimal": "&#127971;",
		"name": "japanese post office",
		"shortname": ":post_office:",
		"category": "travel",
		"emoji_order": "1562",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"post office"
		]
	},
	"european_post_office": {
		"unicode": "1f3e4",
		"unicode_alt": "",
		"code_decimal": "&#127972;",
		"name": "european post office",
		"shortname": ":european_post_office:",
		"category": "travel",
		"emoji_order": "1563",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"post office"
		]
	},
	"hospital": {
		"unicode": "1f3e5",
		"unicode_alt": "",
		"code_decimal": "&#127973;",
		"name": "hospital",
		"shortname": ":hospital:",
		"category": "travel",
		"emoji_order": "1564",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"health",
			"911"
		]
	},
	"bank": {
		"unicode": "1f3e6",
		"unicode_alt": "",
		"code_decimal": "&#127974;",
		"name": "bank",
		"shortname": ":bank:",
		"category": "travel",
		"emoji_order": "1565",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building"
		]
	},
	"hotel": {
		"unicode": "1f3e8",
		"unicode_alt": "",
		"code_decimal": "&#127976;",
		"name": "hotel",
		"shortname": ":hotel:",
		"category": "travel",
		"emoji_order": "1566",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"vacation"
		]
	},
	"love_hotel": {
		"unicode": "1f3e9",
		"unicode_alt": "",
		"code_decimal": "&#127977;",
		"name": "love hotel",
		"shortname": ":love_hotel:",
		"category": "travel",
		"emoji_order": "1567",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"love"
		]
	},
	"convenience_store": {
		"unicode": "1f3ea",
		"unicode_alt": "",
		"code_decimal": "&#127978;",
		"name": "convenience store",
		"shortname": ":convenience_store:",
		"category": "travel",
		"emoji_order": "1568",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building"
		]
	},
	"school": {
		"unicode": "1f3eb",
		"unicode_alt": "",
		"code_decimal": "&#127979;",
		"name": "school",
		"shortname": ":school:",
		"category": "travel",
		"emoji_order": "1569",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building"
		]
	},
	"department_store": {
		"unicode": "1f3ec",
		"unicode_alt": "",
		"code_decimal": "&#127980;",
		"name": "department store",
		"shortname": ":department_store:",
		"category": "travel",
		"emoji_order": "1570",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building"
		]
	},
	"factory": {
		"unicode": "1f3ed",
		"unicode_alt": "",
		"code_decimal": "&#127981;",
		"name": "factory",
		"shortname": ":factory:",
		"category": "travel",
		"emoji_order": "1571",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"travel",
			"steam"
		]
	},
	"japanese_castle": {
		"unicode": "1f3ef",
		"unicode_alt": "",
		"code_decimal": "&#127983;",
		"name": "japanese castle",
		"shortname": ":japanese_castle:",
		"category": "travel",
		"emoji_order": "1572",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"travel",
			"vacation"
		]
	},
	"european_castle": {
		"unicode": "1f3f0",
		"unicode_alt": "",
		"code_decimal": "&#127984;",
		"name": "european castle",
		"shortname": ":european_castle:",
		"category": "travel",
		"emoji_order": "1573",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"travel",
			"vacation"
		]
	},
	"wedding": {
		"unicode": "1f492",
		"unicode_alt": "",
		"code_decimal": "&#128146;",
		"name": "wedding",
		"shortname": ":wedding:",
		"category": "travel",
		"emoji_order": "1574",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"wedding",
			"building",
			"love",
			"parties"
		]
	},
	"tokyo_tower": {
		"unicode": "1f5fc",
		"unicode_alt": "",
		"code_decimal": "&#128508;",
		"name": "tokyo tower",
		"shortname": ":tokyo_tower:",
		"category": "travel",
		"emoji_order": "1575",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"eiffel tower"
		]
	},
	"statue_of_liberty": {
		"unicode": "1f5fd",
		"unicode_alt": "",
		"code_decimal": "&#128509;",
		"name": "statue of liberty",
		"shortname": ":statue_of_liberty:",
		"category": "travel",
		"emoji_order": "1576",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"america",
			"travel",
			"vacation",
			"statue of liberty",
			"free speech"
		]
	},
	"church": {
		"unicode": "26ea",
		"unicode_alt": "26ea-fe0f",
		"code_decimal": "&#9962;",
		"name": "church",
		"shortname": ":church:",
		"category": "travel",
		"emoji_order": "1577",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"wedding",
			"religion",
			"building",
			"condolence"
		]
	},
	"mosque": {
		"unicode": "1f54c",
		"unicode_alt": "",
		"code_decimal": "&#128332;",
		"name": "mosque",
		"shortname": ":mosque:",
		"category": "travel",
		"emoji_order": "1578",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"religion",
			"building",
			"vacation",
			"condolence"
		]
	},
	"synagogue": {
		"unicode": "1f54d",
		"unicode_alt": "",
		"code_decimal": "&#128333;",
		"name": "synagogue",
		"shortname": ":synagogue:",
		"category": "travel",
		"emoji_order": "1579",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"religion",
			"building",
			"travel",
			"vacation",
			"condolence"
		]
	},
	"shinto_shrine": {
		"unicode": "26e9",
		"unicode_alt": "26e9-fe0f",
		"code_decimal": "&#9961;",
		"name": "shinto shrine",
		"shortname": ":shinto_shrine:",
		"category": "travel",
		"emoji_order": "1580",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"travel",
			"vacation"
		]
	},
	"kaaba": {
		"unicode": "1f54b",
		"unicode_alt": "",
		"code_decimal": "&#128331;",
		"name": "kaaba",
		"shortname": ":kaaba:",
		"category": "travel",
		"emoji_order": "1581",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"religion",
			"building",
			"condolence"
		]
	},
	"fountain": {
		"unicode": "26f2",
		"unicode_alt": "26f2-fe0f",
		"code_decimal": "&#9970;",
		"name": "fountain",
		"shortname": ":fountain:",
		"category": "travel",
		"emoji_order": "1582",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"vacation"
		]
	},
	"tent": {
		"unicode": "26fa",
		"unicode_alt": "26fa-fe0f",
		"code_decimal": "&#9978;",
		"name": "tent",
		"shortname": ":tent:",
		"category": "travel",
		"emoji_order": "1583",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"camp"
		]
	},
	"foggy": {
		"unicode": "1f301",
		"unicode_alt": "",
		"code_decimal": "&#127745;",
		"name": "foggy",
		"shortname": ":foggy:",
		"category": "travel",
		"emoji_order": "1584",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"sky",
			"travel",
			"vacation"
		]
	},
	"night_with_stars": {
		"unicode": "1f303",
		"unicode_alt": "",
		"code_decimal": "&#127747;",
		"name": "night with stars",
		"shortname": ":night_with_stars:",
		"category": "travel",
		"emoji_order": "1585",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"sky",
			"vacation",
			"goodnight"
		]
	},
	"sunrise_over_mountains": {
		"unicode": "1f304",
		"unicode_alt": "",
		"code_decimal": "&#127748;",
		"name": "sunrise over mountains",
		"shortname": ":sunrise_over_mountains:",
		"category": "travel",
		"emoji_order": "1586",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"sky",
			"travel",
			"vacation",
			"day",
			"sun",
			"camp",
			"morning"
		]
	},
	"sunrise": {
		"unicode": "1f305",
		"unicode_alt": "",
		"code_decimal": "&#127749;",
		"name": "sunrise",
		"shortname": ":sunrise:",
		"category": "travel",
		"emoji_order": "1587",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"sky",
			"travel",
			"vacation",
			"tropical",
			"day",
			"sun",
			"hump day",
			"morning"
		]
	},
	"city_dusk": {
		"unicode": "1f306",
		"unicode_alt": "",
		"code_decimal": "&#127750;",
		"name": "cityscape at dusk",
		"shortname": ":city_dusk:",
		"category": "travel",
		"emoji_order": "1588",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building"
		]
	},
	"city_sunset": {
		"unicode": "1f307",
		"unicode_alt": "",
		"code_decimal": "&#127751;",
		"name": "sunset over buildings",
		"shortname": ":city_sunset:",
		"category": "travel",
		"emoji_order": "1589",
		"aliases": [
			":city_sunrise:"
		],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"building",
			"sky",
			"vacation"
		]
	},
	"bridge_at_night": {
		"unicode": "1f309",
		"unicode_alt": "",
		"code_decimal": "&#127753;",
		"name": "bridge at night",
		"shortname": ":bridge_at_night:",
		"category": "travel",
		"emoji_order": "1590",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"travel",
			"vacation",
			"goodnight"
		]
	},
	"hotsprings": {
		"unicode": "2668",
		"unicode_alt": "2668-fe0f",
		"code_decimal": "&#9832;",
		"name": "hot springs",
		"shortname": ":hotsprings:",
		"category": "symbols",
		"emoji_order": "1591",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"milky_way": {
		"unicode": "1f30c",
		"unicode_alt": "",
		"code_decimal": "&#127756;",
		"name": "milky way",
		"shortname": ":milky_way:",
		"category": "travel",
		"emoji_order": "1592",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"space",
			"sky",
			"travel",
			"vacation"
		]
	},
	"carousel_horse": {
		"unicode": "1f3a0",
		"unicode_alt": "",
		"code_decimal": "&#127904;",
		"name": "carousel horse",
		"shortname": ":carousel_horse:",
		"category": "travel",
		"emoji_order": "1593",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"object",
			"vacation",
			"roller coaster",
			"carousel"
		]
	},
	"ferris_wheel": {
		"unicode": "1f3a1",
		"unicode_alt": "",
		"code_decimal": "&#127905;",
		"name": "ferris wheel",
		"shortname": ":ferris_wheel:",
		"category": "travel",
		"emoji_order": "1594",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"vacation",
			"ferris wheel"
		]
	},
	"roller_coaster": {
		"unicode": "1f3a2",
		"unicode_alt": "",
		"code_decimal": "&#127906;",
		"name": "roller coaster",
		"shortname": ":roller_coaster:",
		"category": "travel",
		"emoji_order": "1595",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"vacation",
			"roller coaster"
		]
	},
	"barber": {
		"unicode": "1f488",
		"unicode_alt": "",
		"code_decimal": "&#128136;",
		"name": "barber pole",
		"shortname": ":barber:",
		"category": "objects",
		"emoji_order": "1596",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"circus_tent": {
		"unicode": "1f3aa",
		"unicode_alt": "",
		"code_decimal": "&#127914;",
		"name": "circus tent",
		"shortname": ":circus_tent:",
		"category": "activity",
		"emoji_order": "1597",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"circus tent"
		]
	},
	"performing_arts": {
		"unicode": "1f3ad",
		"unicode_alt": "",
		"code_decimal": "&#127917;",
		"name": "performing arts",
		"shortname": ":performing_arts:",
		"category": "activity",
		"emoji_order": "1598",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"theatre",
			"movie"
		]
	},
	"frame_photo": {
		"unicode": "1f5bc",
		"unicode_alt": "1f5bc-fe0f",
		"code_decimal": "&#128444;",
		"name": "frame with picture",
		"shortname": ":frame_photo:",
		"category": "objects",
		"emoji_order": "1599",
		"aliases": [
			":frame_with_picture:"
		],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"vacation"
		]
	},
	"art": {
		"unicode": "1f3a8",
		"unicode_alt": "",
		"code_decimal": "&#127912;",
		"name": "artist palette",
		"shortname": ":art:",
		"category": "activity",
		"emoji_order": "1600",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"slot_machine": {
		"unicode": "1f3b0",
		"unicode_alt": "",
		"code_decimal": "&#127920;",
		"name": "slot machine",
		"shortname": ":slot_machine:",
		"category": "activity",
		"emoji_order": "1601",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"boys night"
		]
	},
	"steam_locomotive": {
		"unicode": "1f682",
		"unicode_alt": "",
		"code_decimal": "&#128642;",
		"name": "steam locomotive",
		"shortname": ":steam_locomotive:",
		"category": "travel",
		"emoji_order": "1602",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train",
			"steam"
		]
	},
	"railway_car": {
		"unicode": "1f683",
		"unicode_alt": "",
		"code_decimal": "&#128643;",
		"name": "railway car",
		"shortname": ":railway_car:",
		"category": "travel",
		"emoji_order": "1603",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"bullettrain_side": {
		"unicode": "1f684",
		"unicode_alt": "",
		"code_decimal": "&#128644;",
		"name": "high-speed train",
		"shortname": ":bullettrain_side:",
		"category": "travel",
		"emoji_order": "1604",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"bullettrain_front": {
		"unicode": "1f685",
		"unicode_alt": "",
		"code_decimal": "&#128645;",
		"name": "high-speed train with bullet nose",
		"shortname": ":bullettrain_front:",
		"category": "travel",
		"emoji_order": "1605",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"train2": {
		"unicode": "1f686",
		"unicode_alt": "",
		"code_decimal": "&#128646;",
		"name": "train",
		"shortname": ":train2:",
		"category": "travel",
		"emoji_order": "1606",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"metro": {
		"unicode": "1f687",
		"unicode_alt": "",
		"code_decimal": "&#128647;",
		"name": "metro",
		"shortname": ":metro:",
		"category": "travel",
		"emoji_order": "1607",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"light_rail": {
		"unicode": "1f688",
		"unicode_alt": "",
		"code_decimal": "&#128648;",
		"name": "light rail",
		"shortname": ":light_rail:",
		"category": "travel",
		"emoji_order": "1608",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"station": {
		"unicode": "1f689",
		"unicode_alt": "",
		"code_decimal": "&#128649;",
		"name": "station",
		"shortname": ":station:",
		"category": "travel",
		"emoji_order": "1609",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"tram": {
		"unicode": "1f68a",
		"unicode_alt": "",
		"code_decimal": "&#128650;",
		"name": "tram",
		"shortname": ":tram:",
		"category": "travel",
		"emoji_order": "1610",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"monorail": {
		"unicode": "1f69d",
		"unicode_alt": "",
		"code_decimal": "&#128669;",
		"name": "monorail",
		"shortname": ":monorail:",
		"category": "travel",
		"emoji_order": "1611",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train",
			"vacation"
		]
	},
	"mountain_railway": {
		"unicode": "1f69e",
		"unicode_alt": "",
		"code_decimal": "&#128670;",
		"name": "mountain railway",
		"shortname": ":mountain_railway:",
		"category": "travel",
		"emoji_order": "1612",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"train": {
		"unicode": "1f68b",
		"unicode_alt": "",
		"code_decimal": "&#128651;",
		"name": "tram car",
		"shortname": ":train:",
		"category": "travel",
		"emoji_order": "1613",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"bus": {
		"unicode": "1f68c",
		"unicode_alt": "",
		"code_decimal": "&#128652;",
		"name": "bus",
		"shortname": ":bus:",
		"category": "travel",
		"emoji_order": "1614",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"bus",
			"office"
		]
	},
	"oncoming_bus": {
		"unicode": "1f68d",
		"unicode_alt": "",
		"code_decimal": "&#128653;",
		"name": "oncoming bus",
		"shortname": ":oncoming_bus:",
		"category": "travel",
		"emoji_order": "1615",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"bus",
			"travel"
		]
	},
	"trolleybus": {
		"unicode": "1f68e",
		"unicode_alt": "",
		"code_decimal": "&#128654;",
		"name": "trolleybus",
		"shortname": ":trolleybus:",
		"category": "travel",
		"emoji_order": "1616",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"bus",
			"travel"
		]
	},
	"minibus": {
		"unicode": "1f690",
		"unicode_alt": "",
		"code_decimal": "&#128656;",
		"name": "minibus",
		"shortname": ":minibus:",
		"category": "travel",
		"emoji_order": "1617",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"bus"
		]
	},
	"ambulance": {
		"unicode": "1f691",
		"unicode_alt": "",
		"code_decimal": "&#128657;",
		"name": "ambulance",
		"shortname": ":ambulance:",
		"category": "travel",
		"emoji_order": "1618",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"911"
		]
	},
	"fire_engine": {
		"unicode": "1f692",
		"unicode_alt": "",
		"code_decimal": "&#128658;",
		"name": "fire engine",
		"shortname": ":fire_engine:",
		"category": "travel",
		"emoji_order": "1619",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"truck",
			"911"
		]
	},
	"police_car": {
		"unicode": "1f693",
		"unicode_alt": "",
		"code_decimal": "&#128659;",
		"name": "police car",
		"shortname": ":police_car:",
		"category": "travel",
		"emoji_order": "1620",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"police",
			"911"
		]
	},
	"oncoming_police_car": {
		"unicode": "1f694",
		"unicode_alt": "",
		"code_decimal": "&#128660;",
		"name": "oncoming police car",
		"shortname": ":oncoming_police_car:",
		"category": "travel",
		"emoji_order": "1621",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"police",
			"911"
		]
	},
	"taxi": {
		"unicode": "1f695",
		"unicode_alt": "",
		"code_decimal": "&#128661;",
		"name": "taxi",
		"shortname": ":taxi:",
		"category": "travel",
		"emoji_order": "1622",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"travel"
		]
	},
	"oncoming_taxi": {
		"unicode": "1f696",
		"unicode_alt": "",
		"code_decimal": "&#128662;",
		"name": "oncoming taxi",
		"shortname": ":oncoming_taxi:",
		"category": "travel",
		"emoji_order": "1623",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"travel"
		]
	},
	"red_car": {
		"unicode": "1f697",
		"unicode_alt": "",
		"code_decimal": "&#128663;",
		"name": "automobile",
		"shortname": ":red_car:",
		"category": "travel",
		"emoji_order": "1624",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"travel"
		]
	},
	"oncoming_automobile": {
		"unicode": "1f698",
		"unicode_alt": "",
		"code_decimal": "&#128664;",
		"name": "oncoming automobile",
		"shortname": ":oncoming_automobile:",
		"category": "travel",
		"emoji_order": "1625",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"travel"
		]
	},
	"blue_car": {
		"unicode": "1f699",
		"unicode_alt": "",
		"code_decimal": "&#128665;",
		"name": "recreational vehicle",
		"shortname": ":blue_car:",
		"category": "travel",
		"emoji_order": "1626",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"car",
			"travel"
		]
	},
	"truck": {
		"unicode": "1f69a",
		"unicode_alt": "",
		"code_decimal": "&#128666;",
		"name": "delivery truck",
		"shortname": ":truck:",
		"category": "travel",
		"emoji_order": "1627",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"truck"
		]
	},
	"articulated_lorry": {
		"unicode": "1f69b",
		"unicode_alt": "",
		"code_decimal": "&#128667;",
		"name": "articulated lorry",
		"shortname": ":articulated_lorry:",
		"category": "travel",
		"emoji_order": "1628",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"truck"
		]
	},
	"tractor": {
		"unicode": "1f69c",
		"unicode_alt": "",
		"code_decimal": "&#128668;",
		"name": "tractor",
		"shortname": ":tractor:",
		"category": "travel",
		"emoji_order": "1629",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation"
		]
	},
	"bike": {
		"unicode": "1f6b2",
		"unicode_alt": "",
		"code_decimal": "&#128690;",
		"name": "bicycle",
		"shortname": ":bike:",
		"category": "travel",
		"emoji_order": "1630",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"bike"
		]
	},
	"scooter": {
		"unicode": "1f6f4",
		"unicode_alt": "",
		"code_decimal": "&#128756;",
		"name": "scooter",
		"shortname": ":scooter:",
		"category": "travel",
		"emoji_order": "1631",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"motor_scooter": {
		"unicode": "1f6f5",
		"unicode_alt": "",
		"code_decimal": "&#128757;",
		"name": "motor scooter",
		"shortname": ":motor_scooter:",
		"category": "travel",
		"emoji_order": "1632",
		"aliases": [
			":motorbike:"
		],
		"aliases_ascii": [],
		"keywords": [
			"moped"
		]
	},
	"busstop": {
		"unicode": "1f68f",
		"unicode_alt": "",
		"code_decimal": "&#128655;",
		"name": "bus stop",
		"shortname": ":busstop:",
		"category": "travel",
		"emoji_order": "1633",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"motorway": {
		"unicode": "1f6e3",
		"unicode_alt": "1f6e3-fe0f",
		"code_decimal": "&#128739;",
		"name": "motorway",
		"shortname": ":motorway:",
		"category": "travel",
		"emoji_order": "1634",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"vacation",
			"camp"
		]
	},
	"railway_track": {
		"unicode": "1f6e4",
		"unicode_alt": "1f6e4-fe0f",
		"code_decimal": "&#128740;",
		"name": "railway track",
		"shortname": ":railway_track:",
		"category": "travel",
		"emoji_order": "1635",
		"aliases": [
			":railroad_track:"
		],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"train",
			"vacation"
		]
	},
	"fuelpump": {
		"unicode": "26fd",
		"unicode_alt": "26fd-fe0f",
		"code_decimal": "&#9981;",
		"name": "fuel pump",
		"shortname": ":fuelpump:",
		"category": "travel",
		"emoji_order": "1636",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"gas pump"
		]
	},
	"rotating_light": {
		"unicode": "1f6a8",
		"unicode_alt": "",
		"code_decimal": "&#128680;",
		"name": "police cars revolving light",
		"shortname": ":rotating_light:",
		"category": "travel",
		"emoji_order": "1637",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"object",
			"police",
			"911"
		]
	},
	"traffic_light": {
		"unicode": "1f6a5",
		"unicode_alt": "",
		"code_decimal": "&#128677;",
		"name": "horizontal traffic light",
		"shortname": ":traffic_light:",
		"category": "travel",
		"emoji_order": "1638",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"stop light"
		]
	},
	"vertical_traffic_light": {
		"unicode": "1f6a6",
		"unicode_alt": "",
		"code_decimal": "&#128678;",
		"name": "vertical traffic light",
		"shortname": ":vertical_traffic_light:",
		"category": "travel",
		"emoji_order": "1639",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"stop light"
		]
	},
	"construction": {
		"unicode": "1f6a7",
		"unicode_alt": "",
		"code_decimal": "&#128679;",
		"name": "construction sign",
		"shortname": ":construction:",
		"category": "travel",
		"emoji_order": "1640",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"octagonal_sign": {
		"unicode": "1f6d1",
		"unicode_alt": "",
		"code_decimal": "&#128721;",
		"name": "octagonal sign",
		"shortname": ":octagonal_sign:",
		"category": "symbols",
		"emoji_order": "1641",
		"aliases": [
			":stop_sign:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"anchor": {
		"unicode": "2693",
		"unicode_alt": "2693-fe0f",
		"code_decimal": "&#9875;",
		"name": "anchor",
		"shortname": ":anchor:",
		"category": "travel",
		"emoji_order": "1642",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"travel",
			"boat",
			"vacation"
		]
	},
	"sailboat": {
		"unicode": "26f5",
		"unicode_alt": "26f5-fe0f",
		"code_decimal": "&#9973;",
		"name": "sailboat",
		"shortname": ":sailboat:",
		"category": "travel",
		"emoji_order": "1643",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"boat",
			"vacation"
		]
	},
	"canoe": {
		"unicode": "1f6f6",
		"unicode_alt": "",
		"code_decimal": "&#128758;",
		"name": "canoe",
		"shortname": ":canoe:",
		"category": "travel",
		"emoji_order": "1644",
		"aliases": [
			":kayak:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"speedboat": {
		"unicode": "1f6a4",
		"unicode_alt": "",
		"code_decimal": "&#128676;",
		"name": "speedboat",
		"shortname": ":speedboat:",
		"category": "travel",
		"emoji_order": "1645",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"boat",
			"vacation",
			"tropical"
		]
	},
	"cruise_ship": {
		"unicode": "1f6f3",
		"unicode_alt": "1f6f3-fe0f",
		"code_decimal": "&#128755;",
		"name": "passenger ship",
		"shortname": ":cruise_ship:",
		"category": "travel",
		"emoji_order": "1646",
		"aliases": [
			":passenger_ship:"
		],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"boat",
			"vacation"
		]
	},
	"ferry": {
		"unicode": "26f4",
		"unicode_alt": "26f4-fe0f",
		"code_decimal": "&#9972;",
		"name": "ferry",
		"shortname": ":ferry:",
		"category": "travel",
		"emoji_order": "1647",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"boat",
			"vacation"
		]
	},
	"motorboat": {
		"unicode": "1f6e5",
		"unicode_alt": "1f6e5-fe0f",
		"code_decimal": "&#128741;",
		"name": "motorboat",
		"shortname": ":motorboat:",
		"category": "travel",
		"emoji_order": "1648",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"boat"
		]
	},
	"ship": {
		"unicode": "1f6a2",
		"unicode_alt": "",
		"code_decimal": "&#128674;",
		"name": "ship",
		"shortname": ":ship:",
		"category": "travel",
		"emoji_order": "1649",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"boat",
			"vacation"
		]
	},
	"airplane": {
		"unicode": "2708",
		"unicode_alt": "2708-fe0f",
		"code_decimal": "&#9992;",
		"name": "airplane",
		"shortname": ":airplane:",
		"category": "travel",
		"emoji_order": "1650",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"plane",
			"travel",
			"vacation",
			"fly"
		]
	},
	"airplane_small": {
		"unicode": "1f6e9",
		"unicode_alt": "1f6e9-fe0f",
		"code_decimal": "&#128745;",
		"name": "small airplane",
		"shortname": ":airplane_small:",
		"category": "travel",
		"emoji_order": "1651",
		"aliases": [
			":small_airplane:"
		],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"plane",
			"travel",
			"vacation",
			"fly"
		]
	},
	"airplane_departure": {
		"unicode": "1f6eb",
		"unicode_alt": "",
		"code_decimal": "&#128747;",
		"name": "airplane departure",
		"shortname": ":airplane_departure:",
		"category": "travel",
		"emoji_order": "1652",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"plane",
			"travel",
			"vacation",
			"fly"
		]
	},
	"airplane_arriving": {
		"unicode": "1f6ec",
		"unicode_alt": "",
		"code_decimal": "&#128748;",
		"name": "airplane arriving",
		"shortname": ":airplane_arriving:",
		"category": "travel",
		"emoji_order": "1653",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"plane",
			"travel",
			"vacation",
			"fly"
		]
	},
	"seat": {
		"unicode": "1f4ba",
		"unicode_alt": "",
		"code_decimal": "&#128186;",
		"name": "seat",
		"shortname": ":seat:",
		"category": "travel",
		"emoji_order": "1654",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"object",
			"travel",
			"vacation"
		]
	},
	"helicopter": {
		"unicode": "1f681",
		"unicode_alt": "",
		"code_decimal": "&#128641;",
		"name": "helicopter",
		"shortname": ":helicopter:",
		"category": "travel",
		"emoji_order": "1655",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"plane",
			"travel",
			"fly"
		]
	},
	"suspension_railway": {
		"unicode": "1f69f",
		"unicode_alt": "",
		"code_decimal": "&#128671;",
		"name": "suspension railway",
		"shortname": ":suspension_railway:",
		"category": "travel",
		"emoji_order": "1656",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"mountain_cableway": {
		"unicode": "1f6a0",
		"unicode_alt": "",
		"code_decimal": "&#128672;",
		"name": "mountain cableway",
		"shortname": ":mountain_cableway:",
		"category": "travel",
		"emoji_order": "1657",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"aerial_tramway": {
		"unicode": "1f6a1",
		"unicode_alt": "",
		"code_decimal": "&#128673;",
		"name": "aerial tramway",
		"shortname": ":aerial_tramway:",
		"category": "travel",
		"emoji_order": "1658",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"travel",
			"train"
		]
	},
	"rocket": {
		"unicode": "1f680",
		"unicode_alt": "",
		"code_decimal": "&#128640;",
		"name": "rocket",
		"shortname": ":rocket:",
		"category": "travel",
		"emoji_order": "1659",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"transportation",
			"object",
			"space",
			"fly",
			"blast"
		]
	},
	"satellite_orbital": {
		"unicode": "1f6f0",
		"unicode_alt": "1f6f0-fe0f",
		"code_decimal": "&#128752;",
		"name": "satellite",
		"shortname": ":satellite_orbital:",
		"category": "travel",
		"emoji_order": "1660",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"bellhop": {
		"unicode": "1f6ce",
		"unicode_alt": "1f6ce-fe0f",
		"code_decimal": "&#128718;",
		"name": "bellhop bell",
		"shortname": ":bellhop:",
		"category": "objects",
		"emoji_order": "1661",
		"aliases": [
			":bellhop_bell:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"door": {
		"unicode": "1f6aa",
		"unicode_alt": "",
		"code_decimal": "&#128682;",
		"name": "door",
		"shortname": ":door:",
		"category": "objects",
		"emoji_order": "1662",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"sleeping_accommodation": {
		"unicode": "1f6cc",
		"unicode_alt": "",
		"code_decimal": "&#128716;",
		"name": "sleeping accommodation",
		"shortname": ":sleeping_accommodation:",
		"category": "objects",
		"emoji_order": "1663",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"tired"
		]
	},
	"bed": {
		"unicode": "1f6cf",
		"unicode_alt": "1f6cf-fe0f",
		"code_decimal": "&#128719;",
		"name": "bed",
		"shortname": ":bed:",
		"category": "objects",
		"emoji_order": "1669",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tired"
		]
	},
	"couch": {
		"unicode": "1f6cb",
		"unicode_alt": "1f6cb-fe0f",
		"code_decimal": "&#128715;",
		"name": "couch and lamp",
		"shortname": ":couch:",
		"category": "objects",
		"emoji_order": "1670",
		"aliases": [
			":couch_and_lamp:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"toilet": {
		"unicode": "1f6bd",
		"unicode_alt": "",
		"code_decimal": "&#128701;",
		"name": "toilet",
		"shortname": ":toilet:",
		"category": "objects",
		"emoji_order": "1671",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"bathroom"
		]
	},
	"shower": {
		"unicode": "1f6bf",
		"unicode_alt": "",
		"code_decimal": "&#128703;",
		"name": "shower",
		"shortname": ":shower:",
		"category": "objects",
		"emoji_order": "1672",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"bathroom"
		]
	},
	"bath": {
		"unicode": "1f6c0",
		"unicode_alt": "",
		"code_decimal": "&#128704;",
		"name": "bath",
		"shortname": ":bath:",
		"category": "activity",
		"emoji_order": "1673",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bathroom",
			"tired",
			"diversity",
			"steam"
		]
	},
	"bath_tone1": {
		"unicode": "1f6c0-1f3fb",
		"unicode_alt": "",
		"code_decimal": "&#128704;&#127995;",
		"name": "bath tone 1",
		"shortname": ":bath_tone1:",
		"category": "activity",
		"emoji_order": "1674",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bath_tone2": {
		"unicode": "1f6c0-1f3fc",
		"unicode_alt": "",
		"code_decimal": "&#128704;&#127996;",
		"name": "bath tone 2",
		"shortname": ":bath_tone2:",
		"category": "activity",
		"emoji_order": "1675",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bath_tone3": {
		"unicode": "1f6c0-1f3fd",
		"unicode_alt": "",
		"code_decimal": "&#128704;&#127997;",
		"name": "bath tone 3",
		"shortname": ":bath_tone3:",
		"category": "activity",
		"emoji_order": "1676",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bath_tone4": {
		"unicode": "1f6c0-1f3fe",
		"unicode_alt": "",
		"code_decimal": "&#128704;&#127998;",
		"name": "bath tone 4",
		"shortname": ":bath_tone4:",
		"category": "activity",
		"emoji_order": "1677",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bath_tone5": {
		"unicode": "1f6c0-1f3ff",
		"unicode_alt": "",
		"code_decimal": "&#128704;&#127999;",
		"name": "bath tone 5",
		"shortname": ":bath_tone5:",
		"category": "activity",
		"emoji_order": "1678",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"bathtub": {
		"unicode": "1f6c1",
		"unicode_alt": "",
		"code_decimal": "&#128705;",
		"name": "bathtub",
		"shortname": ":bathtub:",
		"category": "objects",
		"emoji_order": "1679",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"bathroom",
			"tired",
			"steam"
		]
	},
	"hourglass": {
		"unicode": "231b",
		"unicode_alt": "231b-fe0f",
		"code_decimal": "&#8987;",
		"name": "hourglass",
		"shortname": ":hourglass:",
		"category": "objects",
		"emoji_order": "1680",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"time"
		]
	},
	"hourglass_flowing_sand": {
		"unicode": "23f3",
		"unicode_alt": "",
		"code_decimal": "&#9203;",
		"name": "hourglass with flowing sand",
		"shortname": ":hourglass_flowing_sand:",
		"category": "objects",
		"emoji_order": "1681",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"time"
		]
	},
	"watch": {
		"unicode": "231a",
		"unicode_alt": "231a-fe0f",
		"code_decimal": "&#8986;",
		"name": "watch",
		"shortname": ":watch:",
		"category": "objects",
		"emoji_order": "1682",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"time"
		]
	},
	"alarm_clock": {
		"unicode": "23f0",
		"unicode_alt": "",
		"code_decimal": "&#9200;",
		"name": "alarm clock",
		"shortname": ":alarm_clock:",
		"category": "objects",
		"emoji_order": "1683",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"time"
		]
	},
	"stopwatch": {
		"unicode": "23f1",
		"unicode_alt": "23f1-fe0f",
		"code_decimal": "&#9201;",
		"name": "stopwatch",
		"shortname": ":stopwatch:",
		"category": "objects",
		"emoji_order": "1684",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"time"
		]
	},
	"timer": {
		"unicode": "23f2",
		"unicode_alt": "23f2-fe0f",
		"code_decimal": "&#9202;",
		"name": "timer clock",
		"shortname": ":timer:",
		"category": "objects",
		"emoji_order": "1685",
		"aliases": [
			":timer_clock:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"time"
		]
	},
	"clock": {
		"unicode": "1f570",
		"unicode_alt": "1f570-fe0f",
		"code_decimal": "&#128368;",
		"name": "mantlepiece clock",
		"shortname": ":clock:",
		"category": "objects",
		"emoji_order": "1686",
		"aliases": [
			":mantlepiece_clock:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"time"
		]
	},
	"clock12": {
		"unicode": "1f55b",
		"unicode_alt": "",
		"code_decimal": "&#128347;",
		"name": "clock face twelve oclock",
		"shortname": ":clock12:",
		"category": "symbols",
		"emoji_order": "1687",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock1230": {
		"unicode": "1f567",
		"unicode_alt": "",
		"code_decimal": "&#128359;",
		"name": "clock face twelve-thirty",
		"shortname": ":clock1230:",
		"category": "symbols",
		"emoji_order": "1688",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock1": {
		"unicode": "1f550",
		"unicode_alt": "",
		"code_decimal": "&#128336;",
		"name": "clock face one oclock",
		"shortname": ":clock1:",
		"category": "symbols",
		"emoji_order": "1689",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock130": {
		"unicode": "1f55c",
		"unicode_alt": "",
		"code_decimal": "&#128348;",
		"name": "clock face one-thirty",
		"shortname": ":clock130:",
		"category": "symbols",
		"emoji_order": "1690",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock2": {
		"unicode": "1f551",
		"unicode_alt": "",
		"code_decimal": "&#128337;",
		"name": "clock face two oclock",
		"shortname": ":clock2:",
		"category": "symbols",
		"emoji_order": "1691",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock230": {
		"unicode": "1f55d",
		"unicode_alt": "",
		"code_decimal": "&#128349;",
		"name": "clock face two-thirty",
		"shortname": ":clock230:",
		"category": "symbols",
		"emoji_order": "1692",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock3": {
		"unicode": "1f552",
		"unicode_alt": "",
		"code_decimal": "&#128338;",
		"name": "clock face three oclock",
		"shortname": ":clock3:",
		"category": "symbols",
		"emoji_order": "1693",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock330": {
		"unicode": "1f55e",
		"unicode_alt": "",
		"code_decimal": "&#128350;",
		"name": "clock face three-thirty",
		"shortname": ":clock330:",
		"category": "symbols",
		"emoji_order": "1694",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock4": {
		"unicode": "1f553",
		"unicode_alt": "",
		"code_decimal": "&#128339;",
		"name": "clock face four oclock",
		"shortname": ":clock4:",
		"category": "symbols",
		"emoji_order": "1695",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock430": {
		"unicode": "1f55f",
		"unicode_alt": "",
		"code_decimal": "&#128351;",
		"name": "clock face four-thirty",
		"shortname": ":clock430:",
		"category": "symbols",
		"emoji_order": "1696",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock5": {
		"unicode": "1f554",
		"unicode_alt": "",
		"code_decimal": "&#128340;",
		"name": "clock face five oclock",
		"shortname": ":clock5:",
		"category": "symbols",
		"emoji_order": "1697",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock530": {
		"unicode": "1f560",
		"unicode_alt": "",
		"code_decimal": "&#128352;",
		"name": "clock face five-thirty",
		"shortname": ":clock530:",
		"category": "symbols",
		"emoji_order": "1698",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock6": {
		"unicode": "1f555",
		"unicode_alt": "",
		"code_decimal": "&#128341;",
		"name": "clock face six oclock",
		"shortname": ":clock6:",
		"category": "symbols",
		"emoji_order": "1699",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock630": {
		"unicode": "1f561",
		"unicode_alt": "",
		"code_decimal": "&#128353;",
		"name": "clock face six-thirty",
		"shortname": ":clock630:",
		"category": "symbols",
		"emoji_order": "1700",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock7": {
		"unicode": "1f556",
		"unicode_alt": "",
		"code_decimal": "&#128342;",
		"name": "clock face seven oclock",
		"shortname": ":clock7:",
		"category": "symbols",
		"emoji_order": "1701",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock730": {
		"unicode": "1f562",
		"unicode_alt": "",
		"code_decimal": "&#128354;",
		"name": "clock face seven-thirty",
		"shortname": ":clock730:",
		"category": "symbols",
		"emoji_order": "1702",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock8": {
		"unicode": "1f557",
		"unicode_alt": "",
		"code_decimal": "&#128343;",
		"name": "clock face eight oclock",
		"shortname": ":clock8:",
		"category": "symbols",
		"emoji_order": "1703",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock830": {
		"unicode": "1f563",
		"unicode_alt": "",
		"code_decimal": "&#128355;",
		"name": "clock face eight-thirty",
		"shortname": ":clock830:",
		"category": "symbols",
		"emoji_order": "1704",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock9": {
		"unicode": "1f558",
		"unicode_alt": "",
		"code_decimal": "&#128344;",
		"name": "clock face nine oclock",
		"shortname": ":clock9:",
		"category": "symbols",
		"emoji_order": "1705",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock930": {
		"unicode": "1f564",
		"unicode_alt": "",
		"code_decimal": "&#128356;",
		"name": "clock face nine-thirty",
		"shortname": ":clock930:",
		"category": "symbols",
		"emoji_order": "1706",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock10": {
		"unicode": "1f559",
		"unicode_alt": "",
		"code_decimal": "&#128345;",
		"name": "clock face ten oclock",
		"shortname": ":clock10:",
		"category": "symbols",
		"emoji_order": "1707",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock1030": {
		"unicode": "1f565",
		"unicode_alt": "",
		"code_decimal": "&#128357;",
		"name": "clock face ten-thirty",
		"shortname": ":clock1030:",
		"category": "symbols",
		"emoji_order": "1708",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock11": {
		"unicode": "1f55a",
		"unicode_alt": "",
		"code_decimal": "&#128346;",
		"name": "clock face eleven oclock",
		"shortname": ":clock11:",
		"category": "symbols",
		"emoji_order": "1709",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"clock1130": {
		"unicode": "1f566",
		"unicode_alt": "",
		"code_decimal": "&#128358;",
		"name": "clock face eleven-thirty",
		"shortname": ":clock1130:",
		"category": "symbols",
		"emoji_order": "1710",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"time"
		]
	},
	"new_moon": {
		"unicode": "1f311",
		"unicode_alt": "",
		"code_decimal": "&#127761;",
		"name": "new moon symbol",
		"shortname": ":new_moon:",
		"category": "nature",
		"emoji_order": "1711",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"waxing_crescent_moon": {
		"unicode": "1f312",
		"unicode_alt": "",
		"code_decimal": "&#127762;",
		"name": "waxing crescent moon symbol",
		"shortname": ":waxing_crescent_moon:",
		"category": "nature",
		"emoji_order": "1712",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"first_quarter_moon": {
		"unicode": "1f313",
		"unicode_alt": "",
		"code_decimal": "&#127763;",
		"name": "first quarter moon symbol",
		"shortname": ":first_quarter_moon:",
		"category": "nature",
		"emoji_order": "1713",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"waxing_gibbous_moon": {
		"unicode": "1f314",
		"unicode_alt": "",
		"code_decimal": "&#127764;",
		"name": "waxing gibbous moon symbol",
		"shortname": ":waxing_gibbous_moon:",
		"category": "nature",
		"emoji_order": "1714",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"full_moon": {
		"unicode": "1f315",
		"unicode_alt": "",
		"code_decimal": "&#127765;",
		"name": "full moon symbol",
		"shortname": ":full_moon:",
		"category": "nature",
		"emoji_order": "1715",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"waning_gibbous_moon": {
		"unicode": "1f316",
		"unicode_alt": "",
		"code_decimal": "&#127766;",
		"name": "waning gibbous moon symbol",
		"shortname": ":waning_gibbous_moon:",
		"category": "nature",
		"emoji_order": "1716",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"last_quarter_moon": {
		"unicode": "1f317",
		"unicode_alt": "",
		"code_decimal": "&#127767;",
		"name": "last quarter moon symbol",
		"shortname": ":last_quarter_moon:",
		"category": "nature",
		"emoji_order": "1717",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"waning_crescent_moon": {
		"unicode": "1f318",
		"unicode_alt": "",
		"code_decimal": "&#127768;",
		"name": "waning crescent moon symbol",
		"shortname": ":waning_crescent_moon:",
		"category": "nature",
		"emoji_order": "1718",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"crescent_moon": {
		"unicode": "1f319",
		"unicode_alt": "",
		"code_decimal": "&#127769;",
		"name": "crescent moon",
		"shortname": ":crescent_moon:",
		"category": "nature",
		"emoji_order": "1719",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"goodnight",
			"moon"
		]
	},
	"new_moon_with_face": {
		"unicode": "1f31a",
		"unicode_alt": "",
		"code_decimal": "&#127770;",
		"name": "new moon with face",
		"shortname": ":new_moon_with_face:",
		"category": "nature",
		"emoji_order": "1720",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"goodnight",
			"moon"
		]
	},
	"first_quarter_moon_with_face": {
		"unicode": "1f31b",
		"unicode_alt": "",
		"code_decimal": "&#127771;",
		"name": "first quarter moon with face",
		"shortname": ":first_quarter_moon_with_face:",
		"category": "nature",
		"emoji_order": "1721",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"last_quarter_moon_with_face": {
		"unicode": "1f31c",
		"unicode_alt": "",
		"code_decimal": "&#127772;",
		"name": "last quarter moon with face",
		"shortname": ":last_quarter_moon_with_face:",
		"category": "nature",
		"emoji_order": "1722",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"moon"
		]
	},
	"thermometer": {
		"unicode": "1f321",
		"unicode_alt": "1f321-fe0f",
		"code_decimal": "&#127777;",
		"name": "thermometer",
		"shortname": ":thermometer:",
		"category": "objects",
		"emoji_order": "1723",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"science",
			"health",
			"hot"
		]
	},
	"sunny": {
		"unicode": "2600",
		"unicode_alt": "2600-fe0f",
		"code_decimal": "&#9728;",
		"name": "black sun with rays",
		"shortname": ":sunny:",
		"category": "nature",
		"emoji_order": "1724",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"day",
			"sun",
			"hot",
			"morning"
		]
	},
	"full_moon_with_face": {
		"unicode": "1f31d",
		"unicode_alt": "",
		"code_decimal": "&#127773;",
		"name": "full moon with face",
		"shortname": ":full_moon_with_face:",
		"category": "nature",
		"emoji_order": "1725",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"goodnight",
			"moon"
		]
	},
	"sun_with_face": {
		"unicode": "1f31e",
		"unicode_alt": "",
		"code_decimal": "&#127774;",
		"name": "sun with face",
		"shortname": ":sun_with_face:",
		"category": "nature",
		"emoji_order": "1726",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"sky",
			"day",
			"sun",
			"hump day",
			"morning"
		]
	},
	"star": {
		"unicode": "2b50",
		"unicode_alt": "2b50-fe0f",
		"code_decimal": "&#11088;",
		"name": "white medium star",
		"shortname": ":star:",
		"category": "nature",
		"emoji_order": "1727",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"star"
		]
	},
	"star2": {
		"unicode": "1f31f",
		"unicode_alt": "",
		"code_decimal": "&#127775;",
		"name": "glowing star",
		"shortname": ":star2:",
		"category": "nature",
		"emoji_order": "1728",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky",
			"star"
		]
	},
	"stars": {
		"unicode": "1f320",
		"unicode_alt": "",
		"code_decimal": "&#127776;",
		"name": "shooting star",
		"shortname": ":stars:",
		"category": "travel",
		"emoji_order": "1729",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space"
		]
	},
	"cloud": {
		"unicode": "2601",
		"unicode_alt": "2601-fe0f",
		"code_decimal": "&#9729;",
		"name": "cloud",
		"shortname": ":cloud:",
		"category": "nature",
		"emoji_order": "1730",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"cold",
			"rain"
		]
	},
	"partly_sunny": {
		"unicode": "26c5",
		"unicode_alt": "26c5-fe0f",
		"code_decimal": "&#9925;",
		"name": "sun behind cloud",
		"shortname": ":partly_sunny:",
		"category": "nature",
		"emoji_order": "1731",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"sun"
		]
	},
	"thunder_cloud_rain": {
		"unicode": "26c8",
		"unicode_alt": "26c8-fe0f",
		"code_decimal": "&#9928;",
		"name": "thunder cloud and rain",
		"shortname": ":thunder_cloud_rain:",
		"category": "nature",
		"emoji_order": "1732",
		"aliases": [
			":thunder_cloud_and_rain:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"cold",
			"rain"
		]
	},
	"white_sun_small_cloud": {
		"unicode": "1f324",
		"unicode_alt": "1f324-fe0f",
		"code_decimal": "&#127780;",
		"name": "white sun with small cloud",
		"shortname": ":white_sun_small_cloud:",
		"category": "nature",
		"emoji_order": "1733",
		"aliases": [
			":white_sun_with_small_cloud:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"sun"
		]
	},
	"white_sun_cloud": {
		"unicode": "1f325",
		"unicode_alt": "1f325-fe0f",
		"code_decimal": "&#127781;",
		"name": "white sun behind cloud",
		"shortname": ":white_sun_cloud:",
		"category": "nature",
		"emoji_order": "1734",
		"aliases": [
			":white_sun_behind_cloud:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"cold",
			"sun"
		]
	},
	"white_sun_rain_cloud": {
		"unicode": "1f326",
		"unicode_alt": "1f326-fe0f",
		"code_decimal": "&#127782;",
		"name": "white sun behind cloud with rain",
		"shortname": ":white_sun_rain_cloud:",
		"category": "nature",
		"emoji_order": "1735",
		"aliases": [
			":white_sun_behind_cloud_with_rain:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"cold",
			"rain",
			"sun"
		]
	},
	"cloud_rain": {
		"unicode": "1f327",
		"unicode_alt": "1f327-fe0f",
		"code_decimal": "&#127783;",
		"name": "cloud with rain",
		"shortname": ":cloud_rain:",
		"category": "nature",
		"emoji_order": "1736",
		"aliases": [
			":cloud_with_rain:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"winter",
			"sky",
			"cloud",
			"cold",
			"rain"
		]
	},
	"cloud_snow": {
		"unicode": "1f328",
		"unicode_alt": "1f328-fe0f",
		"code_decimal": "&#127784;",
		"name": "cloud with snow",
		"shortname": ":cloud_snow:",
		"category": "nature",
		"emoji_order": "1737",
		"aliases": [
			":cloud_with_snow:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"winter",
			"sky",
			"cloud",
			"cold",
			"snow"
		]
	},
	"cloud_lightning": {
		"unicode": "1f329",
		"unicode_alt": "1f329-fe0f",
		"code_decimal": "&#127785;",
		"name": "cloud with lightning",
		"shortname": ":cloud_lightning:",
		"category": "nature",
		"emoji_order": "1738",
		"aliases": [
			":cloud_with_lightning:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cloud",
			"cold",
			"rain"
		]
	},
	"cloud_tornado": {
		"unicode": "1f32a",
		"unicode_alt": "1f32a-fe0f",
		"code_decimal": "&#127786;",
		"name": "cloud with tornado",
		"shortname": ":cloud_tornado:",
		"category": "nature",
		"emoji_order": "1739",
		"aliases": [
			":cloud_with_tornado:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cold"
		]
	},
	"fog": {
		"unicode": "1f32b",
		"unicode_alt": "1f32b-fe0f",
		"code_decimal": "&#127787;",
		"name": "fog",
		"shortname": ":fog:",
		"category": "nature",
		"emoji_order": "1740",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cold"
		]
	},
	"wind_blowing_face": {
		"unicode": "1f32c",
		"unicode_alt": "1f32c-fe0f",
		"code_decimal": "&#127788;",
		"name": "wind blowing face",
		"shortname": ":wind_blowing_face:",
		"category": "nature",
		"emoji_order": "1741",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"cold"
		]
	},
	"cyclone": {
		"unicode": "1f300",
		"unicode_alt": "",
		"code_decimal": "&#127744;",
		"name": "cyclone",
		"shortname": ":cyclone:",
		"category": "symbols",
		"emoji_order": "1742",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"drugs"
		]
	},
	"rainbow": {
		"unicode": "1f308",
		"unicode_alt": "",
		"code_decimal": "&#127752;",
		"name": "rainbow",
		"shortname": ":rainbow:",
		"category": "travel",
		"emoji_order": "1743",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"gay",
			"sky",
			"rain"
		]
	},
	"closed_umbrella": {
		"unicode": "1f302",
		"unicode_alt": "",
		"code_decimal": "&#127746;",
		"name": "closed umbrella",
		"shortname": ":closed_umbrella:",
		"category": "people",
		"emoji_order": "1744",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"sky",
			"rain",
			"accessories"
		]
	},
	"umbrella2": {
		"unicode": "2602",
		"unicode_alt": "2602-fe0f",
		"code_decimal": "&#9730;",
		"name": "umbrella",
		"shortname": ":umbrella2:",
		"category": "nature",
		"emoji_order": "1745",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"object",
			"sky",
			"cold"
		]
	},
	"umbrella": {
		"unicode": "2614",
		"unicode_alt": "2614-fe0f",
		"code_decimal": "&#9748;",
		"name": "umbrella with rain drops",
		"shortname": ":umbrella:",
		"category": "nature",
		"emoji_order": "1746",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"cold",
			"rain"
		]
	},
	"beach_umbrella": {
		"unicode": "26f1",
		"unicode_alt": "26f1-fe0f",
		"code_decimal": "&#9969;",
		"name": "umbrella on ground",
		"shortname": ":beach_umbrella:",
		"category": "objects",
		"emoji_order": "1747",
		"aliases": [
			":umbrella_on_ground:"
		],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"vacation",
			"tropical"
		]
	},
	"zap": {
		"unicode": "26a1",
		"unicode_alt": "26a1-fe0f",
		"code_decimal": "&#9889;",
		"name": "high voltage sign",
		"shortname": ":zap:",
		"category": "nature",
		"emoji_order": "1748",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"diarrhea"
		]
	},
	"snowflake": {
		"unicode": "2744",
		"unicode_alt": "2744-fe0f",
		"code_decimal": "&#10052;",
		"name": "snowflake",
		"shortname": ":snowflake:",
		"category": "nature",
		"emoji_order": "1749",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"winter",
			"sky",
			"holidays",
			"cold",
			"snow"
		]
	},
	"snowman2": {
		"unicode": "2603",
		"unicode_alt": "2603-fe0f",
		"code_decimal": "&#9731;",
		"name": "snowman",
		"shortname": ":snowman2:",
		"category": "nature",
		"emoji_order": "1750",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"winter",
			"holidays",
			"christmas",
			"cold",
			"snow"
		]
	},
	"snowman": {
		"unicode": "26c4",
		"unicode_alt": "26c4-fe0f",
		"code_decimal": "&#9924;",
		"name": "snowman without snow",
		"shortname": ":snowman:",
		"category": "nature",
		"emoji_order": "1751",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"winter",
			"holidays",
			"cold",
			"snow"
		]
	},
	"comet": {
		"unicode": "2604",
		"unicode_alt": "2604-fe0f",
		"code_decimal": "&#9732;",
		"name": "comet",
		"shortname": ":comet:",
		"category": "nature",
		"emoji_order": "1752",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"space",
			"sky"
		]
	},
	"fire": {
		"unicode": "1f525",
		"unicode_alt": "",
		"code_decimal": "&#128293;",
		"name": "fire",
		"shortname": ":fire:",
		"category": "nature",
		"emoji_order": "1753",
		"aliases": [
			":flame:"
		],
		"aliases_ascii": [],
		"keywords": [
			"wth",
			"hot"
		]
	},
	"droplet": {
		"unicode": "1f4a7",
		"unicode_alt": "",
		"code_decimal": "&#128167;",
		"name": "droplet",
		"shortname": ":droplet:",
		"category": "nature",
		"emoji_order": "1754",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"sky",
			"rain"
		]
	},
	"ocean": {
		"unicode": "1f30a",
		"unicode_alt": "",
		"code_decimal": "&#127754;",
		"name": "water wave",
		"shortname": ":ocean:",
		"category": "nature",
		"emoji_order": "1755",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"weather",
			"boat",
			"tropical",
			"swim"
		]
	},
	"jack_o_lantern": {
		"unicode": "1f383",
		"unicode_alt": "",
		"code_decimal": "&#127875;",
		"name": "jack-o-lantern",
		"shortname": ":jack_o_lantern:",
		"category": "nature",
		"emoji_order": "1756",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"holidays",
			"halloween"
		]
	},
	"christmas_tree": {
		"unicode": "1f384",
		"unicode_alt": "",
		"code_decimal": "&#127876;",
		"name": "christmas tree",
		"shortname": ":christmas_tree:",
		"category": "nature",
		"emoji_order": "1757",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"plant",
			"holidays",
			"christmas",
			"trees"
		]
	},
	"fireworks": {
		"unicode": "1f386",
		"unicode_alt": "",
		"code_decimal": "&#127878;",
		"name": "fireworks",
		"shortname": ":fireworks:",
		"category": "travel",
		"emoji_order": "1758",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"parties"
		]
	},
	"sparkler": {
		"unicode": "1f387",
		"unicode_alt": "",
		"code_decimal": "&#127879;",
		"name": "firework sparkler",
		"shortname": ":sparkler:",
		"category": "travel",
		"emoji_order": "1759",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"parties"
		]
	},
	"sparkles": {
		"unicode": "2728",
		"unicode_alt": "",
		"code_decimal": "&#10024;",
		"name": "sparkles",
		"shortname": ":sparkles:",
		"category": "nature",
		"emoji_order": "1760",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"star",
			"girls night"
		]
	},
	"balloon": {
		"unicode": "1f388",
		"unicode_alt": "",
		"code_decimal": "&#127880;",
		"name": "balloon",
		"shortname": ":balloon:",
		"category": "objects",
		"emoji_order": "1761",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"birthday",
			"good",
			"parties"
		]
	},
	"tada": {
		"unicode": "1f389",
		"unicode_alt": "",
		"code_decimal": "&#127881;",
		"name": "party popper",
		"shortname": ":tada:",
		"category": "objects",
		"emoji_order": "1762",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"birthday",
			"holidays",
			"cheers",
			"good",
			"girls night",
			"boys night",
			"parties"
		]
	},
	"confetti_ball": {
		"unicode": "1f38a",
		"unicode_alt": "",
		"code_decimal": "&#127882;",
		"name": "confetti ball",
		"shortname": ":confetti_ball:",
		"category": "objects",
		"emoji_order": "1763",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"birthday",
			"holidays",
			"cheers",
			"girls night",
			"boys night",
			"parties"
		]
	},
	"tanabata_tree": {
		"unicode": "1f38b",
		"unicode_alt": "",
		"code_decimal": "&#127883;",
		"name": "tanabata tree",
		"shortname": ":tanabata_tree:",
		"category": "nature",
		"emoji_order": "1764",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant",
			"trees"
		]
	},
	"bamboo": {
		"unicode": "1f38d",
		"unicode_alt": "",
		"code_decimal": "&#127885;",
		"name": "pine decoration",
		"shortname": ":bamboo:",
		"category": "nature",
		"emoji_order": "1765",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"nature",
			"plant"
		]
	},
	"dolls": {
		"unicode": "1f38e",
		"unicode_alt": "",
		"code_decimal": "&#127886;",
		"name": "japanese dolls",
		"shortname": ":dolls:",
		"category": "objects",
		"emoji_order": "1766",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"people",
			"japan"
		]
	},
	"flags": {
		"unicode": "1f38f",
		"unicode_alt": "",
		"code_decimal": "&#127887;",
		"name": "carp streamer",
		"shortname": ":flags:",
		"category": "objects",
		"emoji_order": "1767",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"japan"
		]
	},
	"wind_chime": {
		"unicode": "1f390",
		"unicode_alt": "",
		"code_decimal": "&#127888;",
		"name": "wind chime",
		"shortname": ":wind_chime:",
		"category": "objects",
		"emoji_order": "1768",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"japan"
		]
	},
	"rice_scene": {
		"unicode": "1f391",
		"unicode_alt": "",
		"code_decimal": "&#127889;",
		"name": "moon viewing ceremony",
		"shortname": ":rice_scene:",
		"category": "travel",
		"emoji_order": "1769",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"places",
			"space",
			"sky",
			"travel"
		]
	},
	"ribbon": {
		"unicode": "1f380",
		"unicode_alt": "",
		"code_decimal": "&#127872;",
		"name": "ribbon",
		"shortname": ":ribbon:",
		"category": "objects",
		"emoji_order": "1770",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"gift",
			"birthday"
		]
	},
	"gift": {
		"unicode": "1f381",
		"unicode_alt": "",
		"code_decimal": "&#127873;",
		"name": "wrapped present",
		"shortname": ":gift:",
		"category": "objects",
		"emoji_order": "1771",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"gift",
			"birthday",
			"holidays",
			"christmas",
			"parties"
		]
	},
	"reminder_ribbon": {
		"unicode": "1f397",
		"unicode_alt": "1f397-fe0f",
		"code_decimal": "&#127895;",
		"name": "reminder ribbon",
		"shortname": ":reminder_ribbon:",
		"category": "activity",
		"emoji_order": "1772",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"award"
		]
	},
	"tickets": {
		"unicode": "1f39f",
		"unicode_alt": "1f39f-fe0f",
		"code_decimal": "&#127903;",
		"name": "admission tickets",
		"shortname": ":tickets:",
		"category": "activity",
		"emoji_order": "1773",
		"aliases": [
			":admission_tickets:"
		],
		"aliases_ascii": [],
		"keywords": [
			"theatre",
			"movie",
			"parties"
		]
	},
	"ticket": {
		"unicode": "1f3ab",
		"unicode_alt": "",
		"code_decimal": "&#127915;",
		"name": "ticket",
		"shortname": ":ticket:",
		"category": "activity",
		"emoji_order": "1774",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"theatre",
			"movie",
			"parties"
		]
	},
	"military_medal": {
		"unicode": "1f396",
		"unicode_alt": "1f396-fe0f",
		"code_decimal": "&#127894;",
		"name": "military medal",
		"shortname": ":military_medal:",
		"category": "activity",
		"emoji_order": "1775",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"award",
			"win"
		]
	},
	"trophy": {
		"unicode": "1f3c6",
		"unicode_alt": "",
		"code_decimal": "&#127942;",
		"name": "trophy",
		"shortname": ":trophy:",
		"category": "activity",
		"emoji_order": "1776",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"game",
			"award",
			"win",
			"perfect",
			"parties"
		]
	},
	"medal": {
		"unicode": "1f3c5",
		"unicode_alt": "",
		"code_decimal": "&#127941;",
		"name": "sports medal",
		"shortname": ":medal:",
		"category": "activity",
		"emoji_order": "1777",
		"aliases": [
			":sports_medal:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"award",
			"sport",
			"win",
			"perfect"
		]
	},
	"first_place": {
		"unicode": "1f947",
		"unicode_alt": "",
		"code_decimal": "&#129351;",
		"name": "first place medal",
		"shortname": ":first_place:",
		"category": "activity",
		"emoji_order": "1778",
		"aliases": [
			":first_place_medal:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"second_place": {
		"unicode": "1f948",
		"unicode_alt": "",
		"code_decimal": "&#129352;",
		"name": "second place medal",
		"shortname": ":second_place:",
		"category": "activity",
		"emoji_order": "1779",
		"aliases": [
			":second_place_medal:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"third_place": {
		"unicode": "1f949",
		"unicode_alt": "",
		"code_decimal": "&#129353;",
		"name": "third place medal",
		"shortname": ":third_place:",
		"category": "activity",
		"emoji_order": "1780",
		"aliases": [
			":third_place_medal:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"soccer": {
		"unicode": "26bd",
		"unicode_alt": "26bd-fe0f",
		"code_decimal": "&#9917;",
		"name": "soccer ball",
		"shortname": ":soccer:",
		"category": "activity",
		"emoji_order": "1781",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"soccer",
			"football"
		]
	},
	"baseball": {
		"unicode": "26be",
		"unicode_alt": "26be-fe0f",
		"code_decimal": "&#9918;",
		"name": "baseball",
		"shortname": ":baseball:",
		"category": "activity",
		"emoji_order": "1782",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"baseball"
		]
	},
	"basketball": {
		"unicode": "1f3c0",
		"unicode_alt": "",
		"code_decimal": "&#127936;",
		"name": "basketball and hoop",
		"shortname": ":basketball:",
		"category": "activity",
		"emoji_order": "1783",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"basketball"
		]
	},
	"volleyball": {
		"unicode": "1f3d0",
		"unicode_alt": "",
		"code_decimal": "&#127952;",
		"name": "volleyball",
		"shortname": ":volleyball:",
		"category": "activity",
		"emoji_order": "1784",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"volleyball"
		]
	},
	"football": {
		"unicode": "1f3c8",
		"unicode_alt": "",
		"code_decimal": "&#127944;",
		"name": "american football",
		"shortname": ":football:",
		"category": "activity",
		"emoji_order": "1785",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"america",
			"game",
			"ball",
			"sport",
			"football"
		]
	},
	"rugby_football": {
		"unicode": "1f3c9",
		"unicode_alt": "",
		"code_decimal": "&#127945;",
		"name": "rugby football",
		"shortname": ":rugby_football:",
		"category": "activity",
		"emoji_order": "1786",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"sport",
			"football"
		]
	},
	"tennis": {
		"unicode": "1f3be",
		"unicode_alt": "",
		"code_decimal": "&#127934;",
		"name": "tennis racquet and ball",
		"shortname": ":tennis:",
		"category": "activity",
		"emoji_order": "1787",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"tennis"
		]
	},
	"8ball": {
		"unicode": "1f3b1",
		"unicode_alt": "",
		"code_decimal": "&#127921;",
		"name": "billiards",
		"shortname": ":8ball:",
		"category": "activity",
		"emoji_order": "1788",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"billiards",
			"luck",
			"boys night"
		]
	},
	"bowling": {
		"unicode": "1f3b3",
		"unicode_alt": "",
		"code_decimal": "&#127923;",
		"name": "bowling",
		"shortname": ":bowling:",
		"category": "activity",
		"emoji_order": "1789",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"boys night"
		]
	},
	"cricket": {
		"unicode": "1f3cf",
		"unicode_alt": "",
		"code_decimal": "&#127951;",
		"name": "cricket bat and ball",
		"shortname": ":cricket:",
		"category": "activity",
		"emoji_order": "1790",
		"aliases": [
			":cricket_bat_ball:"
		],
		"aliases_ascii": [],
		"keywords": [
			"ball",
			"sport",
			"cricket"
		]
	},
	"field_hockey": {
		"unicode": "1f3d1",
		"unicode_alt": "",
		"code_decimal": "&#127953;",
		"name": "field hockey stick and ball",
		"shortname": ":field_hockey:",
		"category": "activity",
		"emoji_order": "1791",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"ball",
			"sport",
			"hockey"
		]
	},
	"hockey": {
		"unicode": "1f3d2",
		"unicode_alt": "",
		"code_decimal": "&#127954;",
		"name": "ice hockey stick and puck",
		"shortname": ":hockey:",
		"category": "activity",
		"emoji_order": "1792",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"sport",
			"hockey"
		]
	},
	"ping_pong": {
		"unicode": "1f3d3",
		"unicode_alt": "",
		"code_decimal": "&#127955;",
		"name": "table tennis paddle and ball",
		"shortname": ":ping_pong:",
		"category": "activity",
		"emoji_order": "1793",
		"aliases": [
			":table_tennis:"
		],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"sport",
			"ping pong"
		]
	},
	"badminton": {
		"unicode": "1f3f8",
		"unicode_alt": "",
		"code_decimal": "&#127992;",
		"name": "badminton racquet",
		"shortname": ":badminton:",
		"category": "activity",
		"emoji_order": "1794",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"sport",
			"badminton"
		]
	},
	"boxing_glove": {
		"unicode": "1f94a",
		"unicode_alt": "",
		"code_decimal": "&#129354;",
		"name": "boxing glove",
		"shortname": ":boxing_glove:",
		"category": "activity",
		"emoji_order": "1795",
		"aliases": [
			":boxing_gloves:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"martial_arts_uniform": {
		"unicode": "1f94b",
		"unicode_alt": "",
		"code_decimal": "&#129355;",
		"name": "martial arts uniform",
		"shortname": ":martial_arts_uniform:",
		"category": "activity",
		"emoji_order": "1796",
		"aliases": [
			":karate_uniform:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"goal": {
		"unicode": "1f945",
		"unicode_alt": "",
		"code_decimal": "&#129349;",
		"name": "goal net",
		"shortname": ":goal:",
		"category": "activity",
		"emoji_order": "1797",
		"aliases": [
			":goal_net:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"dart": {
		"unicode": "1f3af",
		"unicode_alt": "",
		"code_decimal": "&#127919;",
		"name": "direct hit",
		"shortname": ":dart:",
		"category": "activity",
		"emoji_order": "1798",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"sport",
			"boys night"
		]
	},
	"golf": {
		"unicode": "26f3",
		"unicode_alt": "26f3-fe0f",
		"code_decimal": "&#9971;",
		"name": "flag in hole",
		"shortname": ":golf:",
		"category": "activity",
		"emoji_order": "1799",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"game",
			"ball",
			"vacation",
			"sport",
			"golf"
		]
	},
	"ice_skate": {
		"unicode": "26f8",
		"unicode_alt": "26f8-fe0f",
		"code_decimal": "&#9976;",
		"name": "ice skate",
		"shortname": ":ice_skate:",
		"category": "activity",
		"emoji_order": "1800",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cold",
			"sport",
			"ice skating"
		]
	},
	"fishing_pole_and_fish": {
		"unicode": "1f3a3",
		"unicode_alt": "",
		"code_decimal": "&#127907;",
		"name": "fishing pole and fish",
		"shortname": ":fishing_pole_and_fish:",
		"category": "activity",
		"emoji_order": "1801",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"vacation",
			"sport",
			"fishing"
		]
	},
	"running_shirt_with_sash": {
		"unicode": "1f3bd",
		"unicode_alt": "",
		"code_decimal": "&#127933;",
		"name": "running shirt with sash",
		"shortname": ":running_shirt_with_sash:",
		"category": "activity",
		"emoji_order": "1802",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"award"
		]
	},
	"ski": {
		"unicode": "1f3bf",
		"unicode_alt": "",
		"code_decimal": "&#127935;",
		"name": "ski and ski boot",
		"shortname": ":ski:",
		"category": "activity",
		"emoji_order": "1803",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"cold",
			"sport",
			"skiing"
		]
	},
	"video_game": {
		"unicode": "1f3ae",
		"unicode_alt": "",
		"code_decimal": "&#127918;",
		"name": "video game",
		"shortname": ":video_game:",
		"category": "activity",
		"emoji_order": "1804",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"game",
			"boys night"
		]
	},
	"joystick": {
		"unicode": "1f579",
		"unicode_alt": "1f579-fe0f",
		"code_decimal": "&#128377;",
		"name": "joystick",
		"shortname": ":joystick:",
		"category": "objects",
		"emoji_order": "1805",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"game",
			"boys night"
		]
	},
	"game_die": {
		"unicode": "1f3b2",
		"unicode_alt": "",
		"code_decimal": "&#127922;",
		"name": "game die",
		"shortname": ":game_die:",
		"category": "activity",
		"emoji_order": "1806",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"game",
			"boys night"
		]
	},
	"spades": {
		"unicode": "2660",
		"unicode_alt": "2660-fe0f",
		"code_decimal": "&spades;",
		"name": "black spade suit",
		"shortname": ":spades:",
		"category": "symbols",
		"emoji_order": "1807",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"game"
		]
	},
	"hearts": {
		"unicode": "2665",
		"unicode_alt": "2665-fe0f",
		"code_decimal": "&hearts;",
		"name": "black heart suit",
		"shortname": ":hearts:",
		"category": "symbols",
		"emoji_order": "1808",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"love",
			"symbol",
			"game"
		]
	},
	"diamonds": {
		"unicode": "2666",
		"unicode_alt": "2666-fe0f",
		"code_decimal": "&diams;",
		"name": "black diamond suit",
		"shortname": ":diamonds:",
		"category": "symbols",
		"emoji_order": "1809",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"game"
		]
	},
	"clubs": {
		"unicode": "2663",
		"unicode_alt": "2663-fe0f",
		"code_decimal": "&clubs;",
		"name": "black club suit",
		"shortname": ":clubs:",
		"category": "symbols",
		"emoji_order": "1810",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"game"
		]
	},
	"black_joker": {
		"unicode": "1f0cf",
		"unicode_alt": "",
		"code_decimal": "&#127183;",
		"name": "playing card black joker",
		"shortname": ":black_joker:",
		"category": "symbols",
		"emoji_order": "1811",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"symbol",
			"game"
		]
	},
	"mahjong": {
		"unicode": "1f004",
		"unicode_alt": "1f004-fe0f",
		"code_decimal": "&#126980;",
		"name": "mahjong tile red dragon",
		"shortname": ":mahjong:",
		"category": "symbols",
		"emoji_order": "1812",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"symbol",
			"game"
		]
	},
	"flower_playing_cards": {
		"unicode": "1f3b4",
		"unicode_alt": "",
		"code_decimal": "&#127924;",
		"name": "flower playing cards",
		"shortname": ":flower_playing_cards:",
		"category": "symbols",
		"emoji_order": "1813",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"symbol"
		]
	},
	"mute": {
		"unicode": "1f507",
		"unicode_alt": "",
		"code_decimal": "&#128263;",
		"name": "speaker with cancellation stroke",
		"shortname": ":mute:",
		"category": "symbols",
		"emoji_order": "1814",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"alarm",
			"symbol"
		]
	},
	"speaker": {
		"unicode": "1f508",
		"unicode_alt": "",
		"code_decimal": "&#128264;",
		"name": "speaker",
		"shortname": ":speaker:",
		"category": "symbols",
		"emoji_order": "1815",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"alarm",
			"symbol"
		]
	},
	"sound": {
		"unicode": "1f509",
		"unicode_alt": "",
		"code_decimal": "&#128265;",
		"name": "speaker with one sound wave",
		"shortname": ":sound:",
		"category": "symbols",
		"emoji_order": "1816",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"alarm",
			"symbol"
		]
	},
	"loud_sound": {
		"unicode": "1f50a",
		"unicode_alt": "",
		"code_decimal": "&#128266;",
		"name": "speaker with three sound waves",
		"shortname": ":loud_sound:",
		"category": "symbols",
		"emoji_order": "1817",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"alarm",
			"symbol"
		]
	},
	"loudspeaker": {
		"unicode": "1f4e2",
		"unicode_alt": "",
		"code_decimal": "&#128226;",
		"name": "public address loudspeaker",
		"shortname": ":loudspeaker:",
		"category": "symbols",
		"emoji_order": "1818",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"alarm",
			"symbol"
		]
	},
	"mega": {
		"unicode": "1f4e3",
		"unicode_alt": "",
		"code_decimal": "&#128227;",
		"name": "cheering megaphone",
		"shortname": ":mega:",
		"category": "symbols",
		"emoji_order": "1819",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"sport"
		]
	},
	"postal_horn": {
		"unicode": "1f4ef",
		"unicode_alt": "",
		"code_decimal": "&#128239;",
		"name": "postal horn",
		"shortname": ":postal_horn:",
		"category": "objects",
		"emoji_order": "1820",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"bell": {
		"unicode": "1f514",
		"unicode_alt": "",
		"code_decimal": "&#128276;",
		"name": "bell",
		"shortname": ":bell:",
		"category": "symbols",
		"emoji_order": "1821",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"alarm",
			"symbol"
		]
	},
	"no_bell": {
		"unicode": "1f515",
		"unicode_alt": "",
		"code_decimal": "&#128277;",
		"name": "bell with cancellation stroke",
		"shortname": ":no_bell:",
		"category": "symbols",
		"emoji_order": "1822",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"alarm",
			"symbol"
		]
	},
	"musical_score": {
		"unicode": "1f3bc",
		"unicode_alt": "",
		"code_decimal": "&#127932;",
		"name": "musical score",
		"shortname": ":musical_score:",
		"category": "activity",
		"emoji_order": "1823",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"musical_note": {
		"unicode": "1f3b5",
		"unicode_alt": "",
		"code_decimal": "&#127925;",
		"name": "musical note",
		"shortname": ":musical_note:",
		"category": "symbols",
		"emoji_order": "1824",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments",
			"symbol"
		]
	},
	"notes": {
		"unicode": "1f3b6",
		"unicode_alt": "",
		"code_decimal": "&#127926;",
		"name": "multiple musical notes",
		"shortname": ":notes:",
		"category": "symbols",
		"emoji_order": "1825",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments",
			"symbol"
		]
	},
	"microphone2": {
		"unicode": "1f399",
		"unicode_alt": "1f399-fe0f",
		"code_decimal": "&#127897;",
		"name": "studio microphone",
		"shortname": ":microphone2:",
		"category": "objects",
		"emoji_order": "1826",
		"aliases": [
			":studio_microphone:"
		],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"object"
		]
	},
	"level_slider": {
		"unicode": "1f39a",
		"unicode_alt": "1f39a-fe0f",
		"code_decimal": "&#127898;",
		"name": "level slider",
		"shortname": ":level_slider:",
		"category": "objects",
		"emoji_order": "1827",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"control_knobs": {
		"unicode": "1f39b",
		"unicode_alt": "1f39b-fe0f",
		"code_decimal": "&#127899;",
		"name": "control knobs",
		"shortname": ":control_knobs:",
		"category": "objects",
		"emoji_order": "1828",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"time"
		]
	},
	"microphone": {
		"unicode": "1f3a4",
		"unicode_alt": "",
		"code_decimal": "&#127908;",
		"name": "microphone",
		"shortname": ":microphone:",
		"category": "activity",
		"emoji_order": "1829",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"headphones": {
		"unicode": "1f3a7",
		"unicode_alt": "",
		"code_decimal": "&#127911;",
		"name": "headphone",
		"shortname": ":headphones:",
		"category": "activity",
		"emoji_order": "1830",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"radio": {
		"unicode": "1f4fb",
		"unicode_alt": "",
		"code_decimal": "&#128251;",
		"name": "radio",
		"shortname": ":radio:",
		"category": "objects",
		"emoji_order": "1831",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"saxophone": {
		"unicode": "1f3b7",
		"unicode_alt": "",
		"code_decimal": "&#127927;",
		"name": "saxophone",
		"shortname": ":saxophone:",
		"category": "activity",
		"emoji_order": "1832",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"guitar": {
		"unicode": "1f3b8",
		"unicode_alt": "",
		"code_decimal": "&#127928;",
		"name": "guitar",
		"shortname": ":guitar:",
		"category": "activity",
		"emoji_order": "1833",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"musical_keyboard": {
		"unicode": "1f3b9",
		"unicode_alt": "",
		"code_decimal": "&#127929;",
		"name": "musical keyboard",
		"shortname": ":musical_keyboard:",
		"category": "activity",
		"emoji_order": "1834",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"trumpet": {
		"unicode": "1f3ba",
		"unicode_alt": "",
		"code_decimal": "&#127930;",
		"name": "trumpet",
		"shortname": ":trumpet:",
		"category": "activity",
		"emoji_order": "1835",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments"
		]
	},
	"violin": {
		"unicode": "1f3bb",
		"unicode_alt": "",
		"code_decimal": "&#127931;",
		"name": "violin",
		"shortname": ":violin:",
		"category": "activity",
		"emoji_order": "1836",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"instruments",
			"sarcastic"
		]
	},
	"drum": {
		"unicode": "1f941",
		"unicode_alt": "",
		"code_decimal": "&#129345;",
		"name": "drum with drumsticks",
		"shortname": ":drum:",
		"category": "activity",
		"emoji_order": "1837",
		"aliases": [
			":drum_with_drumsticks:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"iphone": {
		"unicode": "1f4f1",
		"unicode_alt": "",
		"code_decimal": "&#128241;",
		"name": "mobile phone",
		"shortname": ":iphone:",
		"category": "objects",
		"emoji_order": "1838",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"phone",
			"selfie"
		]
	},
	"calling": {
		"unicode": "1f4f2",
		"unicode_alt": "",
		"code_decimal": "&#128242;",
		"name": "mobile phone with rightwards arrow at left",
		"shortname": ":calling:",
		"category": "objects",
		"emoji_order": "1839",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"phone",
			"selfie"
		]
	},
	"telephone": {
		"unicode": "260e",
		"unicode_alt": "260e-fe0f",
		"code_decimal": "&#9742;",
		"name": "black telephone",
		"shortname": ":telephone:",
		"category": "objects",
		"emoji_order": "1840",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"phone"
		]
	},
	"telephone_receiver": {
		"unicode": "1f4de",
		"unicode_alt": "",
		"code_decimal": "&#128222;",
		"name": "telephone receiver",
		"shortname": ":telephone_receiver:",
		"category": "objects",
		"emoji_order": "1841",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"phone"
		]
	},
	"pager": {
		"unicode": "1f4df",
		"unicode_alt": "",
		"code_decimal": "&#128223;",
		"name": "pager",
		"shortname": ":pager:",
		"category": "objects",
		"emoji_order": "1842",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work"
		]
	},
	"fax": {
		"unicode": "1f4e0",
		"unicode_alt": "",
		"code_decimal": "&#128224;",
		"name": "fax machine",
		"shortname": ":fax:",
		"category": "objects",
		"emoji_order": "1843",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work",
			"office"
		]
	},
	"battery": {
		"unicode": "1f50b",
		"unicode_alt": "",
		"code_decimal": "&#128267;",
		"name": "battery",
		"shortname": ":battery:",
		"category": "objects",
		"emoji_order": "1844",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"electric_plug": {
		"unicode": "1f50c",
		"unicode_alt": "",
		"code_decimal": "&#128268;",
		"name": "electric plug",
		"shortname": ":electric_plug:",
		"category": "objects",
		"emoji_order": "1845",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"computer": {
		"unicode": "1f4bb",
		"unicode_alt": "",
		"code_decimal": "&#128187;",
		"name": "personal computer",
		"shortname": ":computer:",
		"category": "objects",
		"emoji_order": "1846",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work",
			"office"
		]
	},
	"desktop": {
		"unicode": "1f5a5",
		"unicode_alt": "1f5a5-fe0f",
		"code_decimal": "&#128421;",
		"name": "desktop computer",
		"shortname": ":desktop:",
		"category": "objects",
		"emoji_order": "1847",
		"aliases": [
			":desktop_computer:"
		],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work"
		]
	},
	"printer": {
		"unicode": "1f5a8",
		"unicode_alt": "1f5a8-fe0f",
		"code_decimal": "&#128424;",
		"name": "printer",
		"shortname": ":printer:",
		"category": "objects",
		"emoji_order": "1848",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work",
			"office"
		]
	},
	"keyboard": {
		"unicode": "2328",
		"unicode_alt": "2328-fe0f",
		"code_decimal": "&#9000;",
		"name": "keyboard",
		"shortname": ":keyboard:",
		"category": "objects",
		"emoji_order": "1849",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work",
			"office"
		]
	},
	"mouse_three_button": {
		"unicode": "1f5b1",
		"unicode_alt": "1f5b1-fe0f",
		"code_decimal": "&#128433;",
		"name": "three button mouse",
		"shortname": ":mouse_three_button:",
		"category": "objects",
		"emoji_order": "1850",
		"aliases": [
			":three_button_mouse:"
		],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work",
			"game",
			"office"
		]
	},
	"trackball": {
		"unicode": "1f5b2",
		"unicode_alt": "1f5b2-fe0f",
		"code_decimal": "&#128434;",
		"name": "trackball",
		"shortname": ":trackball:",
		"category": "objects",
		"emoji_order": "1851",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"work",
			"game",
			"office"
		]
	},
	"minidisc": {
		"unicode": "1f4bd",
		"unicode_alt": "",
		"code_decimal": "&#128189;",
		"name": "minidisc",
		"shortname": ":minidisc:",
		"category": "objects",
		"emoji_order": "1852",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"floppy_disk": {
		"unicode": "1f4be",
		"unicode_alt": "",
		"code_decimal": "&#128190;",
		"name": "floppy disk",
		"shortname": ":floppy_disk:",
		"category": "objects",
		"emoji_order": "1853",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"office"
		]
	},
	"cd": {
		"unicode": "1f4bf",
		"unicode_alt": "",
		"code_decimal": "&#128191;",
		"name": "optical disc",
		"shortname": ":cd:",
		"category": "objects",
		"emoji_order": "1854",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"dvd": {
		"unicode": "1f4c0",
		"unicode_alt": "",
		"code_decimal": "&#128192;",
		"name": "dvd",
		"shortname": ":dvd:",
		"category": "objects",
		"emoji_order": "1855",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"movie_camera": {
		"unicode": "1f3a5",
		"unicode_alt": "",
		"code_decimal": "&#127909;",
		"name": "movie camera",
		"shortname": ":movie_camera:",
		"category": "objects",
		"emoji_order": "1856",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"camera",
			"movie"
		]
	},
	"film_frames": {
		"unicode": "1f39e",
		"unicode_alt": "1f39e-fe0f",
		"code_decimal": "&#127902;",
		"name": "film frames",
		"shortname": ":film_frames:",
		"category": "objects",
		"emoji_order": "1857",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"camera",
			"movie"
		]
	},
	"projector": {
		"unicode": "1f4fd",
		"unicode_alt": "1f4fd-fe0f",
		"code_decimal": "&#128253;",
		"name": "film projector",
		"shortname": ":projector:",
		"category": "objects",
		"emoji_order": "1858",
		"aliases": [
			":film_projector:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"camera",
			"movie"
		]
	},
	"clapper": {
		"unicode": "1f3ac",
		"unicode_alt": "",
		"code_decimal": "&#127916;",
		"name": "clapper board",
		"shortname": ":clapper:",
		"category": "activity",
		"emoji_order": "1859",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"movie"
		]
	},
	"tv": {
		"unicode": "1f4fa",
		"unicode_alt": "",
		"code_decimal": "&#128250;",
		"name": "television",
		"shortname": ":tv:",
		"category": "objects",
		"emoji_order": "1860",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"camera": {
		"unicode": "1f4f7",
		"unicode_alt": "",
		"code_decimal": "&#128247;",
		"name": "camera",
		"shortname": ":camera:",
		"category": "objects",
		"emoji_order": "1861",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"camera",
			"selfie"
		]
	},
	"camera_with_flash": {
		"unicode": "1f4f8",
		"unicode_alt": "",
		"code_decimal": "&#128248;",
		"name": "camera with flash",
		"shortname": ":camera_with_flash:",
		"category": "objects",
		"emoji_order": "1862",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"camera"
		]
	},
	"video_camera": {
		"unicode": "1f4f9",
		"unicode_alt": "",
		"code_decimal": "&#128249;",
		"name": "video camera",
		"shortname": ":video_camera:",
		"category": "objects",
		"emoji_order": "1863",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"camera",
			"movie"
		]
	},
	"vhs": {
		"unicode": "1f4fc",
		"unicode_alt": "",
		"code_decimal": "&#128252;",
		"name": "videocassette",
		"shortname": ":vhs:",
		"category": "objects",
		"emoji_order": "1864",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics"
		]
	},
	"mag": {
		"unicode": "1f50d",
		"unicode_alt": "",
		"code_decimal": "&#128269;",
		"name": "left-pointing magnifying glass",
		"shortname": ":mag:",
		"category": "objects",
		"emoji_order": "1865",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"mag_right": {
		"unicode": "1f50e",
		"unicode_alt": "",
		"code_decimal": "&#128270;",
		"name": "right-pointing magnifying glass",
		"shortname": ":mag_right:",
		"category": "objects",
		"emoji_order": "1866",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"microscope": {
		"unicode": "1f52c",
		"unicode_alt": "",
		"code_decimal": "&#128300;",
		"name": "microscope",
		"shortname": ":microscope:",
		"category": "objects",
		"emoji_order": "1867",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"science"
		]
	},
	"telescope": {
		"unicode": "1f52d",
		"unicode_alt": "",
		"code_decimal": "&#128301;",
		"name": "telescope",
		"shortname": ":telescope:",
		"category": "objects",
		"emoji_order": "1868",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"space",
			"science"
		]
	},
	"satellite": {
		"unicode": "1f4e1",
		"unicode_alt": "",
		"code_decimal": "&#128225;",
		"name": "satellite antenna",
		"shortname": ":satellite:",
		"category": "objects",
		"emoji_order": "1869",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"candle": {
		"unicode": "1f56f",
		"unicode_alt": "1f56f-fe0f",
		"code_decimal": "&#128367;",
		"name": "candle",
		"shortname": ":candle:",
		"category": "objects",
		"emoji_order": "1870",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"bulb": {
		"unicode": "1f4a1",
		"unicode_alt": "",
		"code_decimal": "&#128161;",
		"name": "electric light bulb",
		"shortname": ":bulb:",
		"category": "objects",
		"emoji_order": "1871",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"science"
		]
	},
	"flashlight": {
		"unicode": "1f526",
		"unicode_alt": "",
		"code_decimal": "&#128294;",
		"name": "electric torch",
		"shortname": ":flashlight:",
		"category": "objects",
		"emoji_order": "1872",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"object"
		]
	},
	"izakaya_lantern": {
		"unicode": "1f3ee",
		"unicode_alt": "",
		"code_decimal": "&#127982;",
		"name": "izakaya lantern",
		"shortname": ":izakaya_lantern:",
		"category": "objects",
		"emoji_order": "1873",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"japan"
		]
	},
	"notebook_with_decorative_cover": {
		"unicode": "1f4d4",
		"unicode_alt": "",
		"code_decimal": "&#128212;",
		"name": "notebook with decorative cover",
		"shortname": ":notebook_with_decorative_cover:",
		"category": "objects",
		"emoji_order": "1874",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"closed_book": {
		"unicode": "1f4d5",
		"unicode_alt": "",
		"code_decimal": "&#128213;",
		"name": "closed book",
		"shortname": ":closed_book:",
		"category": "objects",
		"emoji_order": "1875",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write",
			"book"
		]
	},
	"book": {
		"unicode": "1f4d6",
		"unicode_alt": "",
		"code_decimal": "&#128214;",
		"name": "open book",
		"shortname": ":book:",
		"category": "objects",
		"emoji_order": "1876",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write",
			"book"
		]
	},
	"green_book": {
		"unicode": "1f4d7",
		"unicode_alt": "",
		"code_decimal": "&#128215;",
		"name": "green book",
		"shortname": ":green_book:",
		"category": "objects",
		"emoji_order": "1877",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"book"
		]
	},
	"blue_book": {
		"unicode": "1f4d8",
		"unicode_alt": "",
		"code_decimal": "&#128216;",
		"name": "blue book",
		"shortname": ":blue_book:",
		"category": "objects",
		"emoji_order": "1878",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write",
			"book"
		]
	},
	"orange_book": {
		"unicode": "1f4d9",
		"unicode_alt": "",
		"code_decimal": "&#128217;",
		"name": "orange book",
		"shortname": ":orange_book:",
		"category": "objects",
		"emoji_order": "1879",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write",
			"book"
		]
	},
	"books": {
		"unicode": "1f4da",
		"unicode_alt": "",
		"code_decimal": "&#128218;",
		"name": "books",
		"shortname": ":books:",
		"category": "objects",
		"emoji_order": "1880",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write",
			"book"
		]
	},
	"notebook": {
		"unicode": "1f4d3",
		"unicode_alt": "",
		"code_decimal": "&#128211;",
		"name": "notebook",
		"shortname": ":notebook:",
		"category": "objects",
		"emoji_order": "1881",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"ledger": {
		"unicode": "1f4d2",
		"unicode_alt": "",
		"code_decimal": "&#128210;",
		"name": "ledger",
		"shortname": ":ledger:",
		"category": "objects",
		"emoji_order": "1882",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"page_with_curl": {
		"unicode": "1f4c3",
		"unicode_alt": "",
		"code_decimal": "&#128195;",
		"name": "page with curl",
		"shortname": ":page_with_curl:",
		"category": "objects",
		"emoji_order": "1883",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"office",
			"write"
		]
	},
	"scroll": {
		"unicode": "1f4dc",
		"unicode_alt": "",
		"code_decimal": "&#128220;",
		"name": "scroll",
		"shortname": ":scroll:",
		"category": "objects",
		"emoji_order": "1884",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"page_facing_up": {
		"unicode": "1f4c4",
		"unicode_alt": "",
		"code_decimal": "&#128196;",
		"name": "page facing up",
		"shortname": ":page_facing_up:",
		"category": "objects",
		"emoji_order": "1885",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office",
			"write"
		]
	},
	"newspaper": {
		"unicode": "1f4f0",
		"unicode_alt": "",
		"code_decimal": "&#128240;",
		"name": "newspaper",
		"shortname": ":newspaper:",
		"category": "objects",
		"emoji_order": "1886",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"office",
			"write"
		]
	},
	"newspaper2": {
		"unicode": "1f5de",
		"unicode_alt": "1f5de-fe0f",
		"code_decimal": "&#128478;",
		"name": "rolled-up newspaper",
		"shortname": ":newspaper2:",
		"category": "objects",
		"emoji_order": "1887",
		"aliases": [
			":rolled_up_newspaper:"
		],
		"aliases_ascii": [],
		"keywords": [
			"office",
			"write"
		]
	},
	"bookmark_tabs": {
		"unicode": "1f4d1",
		"unicode_alt": "",
		"code_decimal": "&#128209;",
		"name": "bookmark tabs",
		"shortname": ":bookmark_tabs:",
		"category": "objects",
		"emoji_order": "1888",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"office",
			"write"
		]
	},
	"bookmark": {
		"unicode": "1f516",
		"unicode_alt": "",
		"code_decimal": "&#128278;",
		"name": "bookmark",
		"shortname": ":bookmark:",
		"category": "objects",
		"emoji_order": "1889",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"book"
		]
	},
	"label": {
		"unicode": "1f3f7",
		"unicode_alt": "1f3f7-fe0f",
		"code_decimal": "&#127991;",
		"name": "label",
		"shortname": ":label:",
		"category": "objects",
		"emoji_order": "1890",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"moneybag": {
		"unicode": "1f4b0",
		"unicode_alt": "",
		"code_decimal": "&#128176;",
		"name": "money bag",
		"shortname": ":moneybag:",
		"category": "objects",
		"emoji_order": "1891",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bag",
			"award",
			"money"
		]
	},
	"yen": {
		"unicode": "1f4b4",
		"unicode_alt": "",
		"code_decimal": "&#128180;",
		"name": "banknote with yen sign",
		"shortname": ":yen:",
		"category": "objects",
		"emoji_order": "1892",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"money"
		]
	},
	"dollar": {
		"unicode": "1f4b5",
		"unicode_alt": "",
		"code_decimal": "&#128181;",
		"name": "banknote with dollar sign",
		"shortname": ":dollar:",
		"category": "objects",
		"emoji_order": "1893",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"money"
		]
	},
	"euro": {
		"unicode": "1f4b6",
		"unicode_alt": "",
		"code_decimal": "&#128182;",
		"name": "banknote with euro sign",
		"shortname": ":euro:",
		"category": "objects",
		"emoji_order": "1894",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"money"
		]
	},
	"pound": {
		"unicode": "1f4b7",
		"unicode_alt": "",
		"code_decimal": "&#128183;",
		"name": "banknote with pound sign",
		"shortname": ":pound:",
		"category": "objects",
		"emoji_order": "1895",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"money"
		]
	},
	"money_with_wings": {
		"unicode": "1f4b8",
		"unicode_alt": "",
		"code_decimal": "&#128184;",
		"name": "money with wings",
		"shortname": ":money_with_wings:",
		"category": "objects",
		"emoji_order": "1896",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"money",
			"boys night"
		]
	},
	"credit_card": {
		"unicode": "1f4b3",
		"unicode_alt": "",
		"code_decimal": "&#128179;",
		"name": "credit card",
		"shortname": ":credit_card:",
		"category": "objects",
		"emoji_order": "1897",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"money",
			"boys night"
		]
	},
	"chart": {
		"unicode": "1f4b9",
		"unicode_alt": "",
		"code_decimal": "&#128185;",
		"name": "chart with upwards trend and yen sign",
		"shortname": ":chart:",
		"category": "symbols",
		"emoji_order": "1898",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"money"
		]
	},
	"currency_exchange": {
		"unicode": "1f4b1",
		"unicode_alt": "",
		"code_decimal": "&#128177;",
		"name": "currency exchange",
		"shortname": ":currency_exchange:",
		"category": "symbols",
		"emoji_order": "1899",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"money"
		]
	},
	"heavy_dollar_sign": {
		"unicode": "1f4b2",
		"unicode_alt": "",
		"code_decimal": "&#128178;",
		"name": "heavy dollar sign",
		"shortname": ":heavy_dollar_sign:",
		"category": "symbols",
		"emoji_order": "1900",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"math",
			"symbol",
			"money"
		]
	},
	"envelope": {
		"unicode": "2709",
		"unicode_alt": "2709-fe0f",
		"code_decimal": "&#9993;",
		"name": "envelope",
		"shortname": ":envelope:",
		"category": "objects",
		"emoji_order": "1901",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"e-mail": {
		"unicode": "1f4e7",
		"unicode_alt": "",
		"code_decimal": "&#128231;",
		"name": "e-mail symbol",
		"shortname": ":e-mail:",
		"category": "objects",
		"emoji_order": "1902",
		"aliases": [
			":email:"
		],
		"aliases_ascii": [],
		"keywords": [
			"office"
		]
	},
	"incoming_envelope": {
		"unicode": "1f4e8",
		"unicode_alt": "",
		"code_decimal": "&#128232;",
		"name": "incoming envelope",
		"shortname": ":incoming_envelope:",
		"category": "objects",
		"emoji_order": "1903",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"envelope_with_arrow": {
		"unicode": "1f4e9",
		"unicode_alt": "",
		"code_decimal": "&#128233;",
		"name": "envelope with downwards arrow above",
		"shortname": ":envelope_with_arrow:",
		"category": "objects",
		"emoji_order": "1904",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"outbox_tray": {
		"unicode": "1f4e4",
		"unicode_alt": "",
		"code_decimal": "&#128228;",
		"name": "outbox tray",
		"shortname": ":outbox_tray:",
		"category": "objects",
		"emoji_order": "1905",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"inbox_tray": {
		"unicode": "1f4e5",
		"unicode_alt": "",
		"code_decimal": "&#128229;",
		"name": "inbox tray",
		"shortname": ":inbox_tray:",
		"category": "objects",
		"emoji_order": "1906",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"package": {
		"unicode": "1f4e6",
		"unicode_alt": "",
		"code_decimal": "&#128230;",
		"name": "package",
		"shortname": ":package:",
		"category": "objects",
		"emoji_order": "1907",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"gift",
			"office"
		]
	},
	"mailbox": {
		"unicode": "1f4eb",
		"unicode_alt": "",
		"code_decimal": "&#128235;",
		"name": "closed mailbox with raised flag",
		"shortname": ":mailbox:",
		"category": "objects",
		"emoji_order": "1908",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"mailbox_closed": {
		"unicode": "1f4ea",
		"unicode_alt": "",
		"code_decimal": "&#128234;",
		"name": "closed mailbox with lowered flag",
		"shortname": ":mailbox_closed:",
		"category": "objects",
		"emoji_order": "1909",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"mailbox_with_mail": {
		"unicode": "1f4ec",
		"unicode_alt": "",
		"code_decimal": "&#128236;",
		"name": "open mailbox with raised flag",
		"shortname": ":mailbox_with_mail:",
		"category": "objects",
		"emoji_order": "1910",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"mailbox_with_no_mail": {
		"unicode": "1f4ed",
		"unicode_alt": "",
		"code_decimal": "&#128237;",
		"name": "open mailbox with lowered flag",
		"shortname": ":mailbox_with_no_mail:",
		"category": "objects",
		"emoji_order": "1911",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"postbox": {
		"unicode": "1f4ee",
		"unicode_alt": "",
		"code_decimal": "&#128238;",
		"name": "postbox",
		"shortname": ":postbox:",
		"category": "objects",
		"emoji_order": "1912",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"ballot_box": {
		"unicode": "1f5f3",
		"unicode_alt": "1f5f3-fe0f",
		"code_decimal": "&#128499;",
		"name": "ballot box with ballot",
		"shortname": ":ballot_box:",
		"category": "objects",
		"emoji_order": "1913",
		"aliases": [
			":ballot_box_with_ballot:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"pencil2": {
		"unicode": "270f",
		"unicode_alt": "270f-fe0f",
		"code_decimal": "&#9999;",
		"name": "pencil",
		"shortname": ":pencil2:",
		"category": "objects",
		"emoji_order": "1914",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"black_nib": {
		"unicode": "2712",
		"unicode_alt": "2712-fe0f",
		"code_decimal": "&#10002;",
		"name": "black nib",
		"shortname": ":black_nib:",
		"category": "objects",
		"emoji_order": "1915",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"pen_fountain": {
		"unicode": "1f58b",
		"unicode_alt": "1f58b-fe0f",
		"code_decimal": "&#128395;",
		"name": "lower left fountain pen",
		"shortname": ":pen_fountain:",
		"category": "objects",
		"emoji_order": "1916",
		"aliases": [
			":lower_left_fountain_pen:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"pen_ballpoint": {
		"unicode": "1f58a",
		"unicode_alt": "1f58a-fe0f",
		"code_decimal": "&#128394;",
		"name": "lower left ballpoint pen",
		"shortname": ":pen_ballpoint:",
		"category": "objects",
		"emoji_order": "1917",
		"aliases": [
			":lower_left_ballpoint_pen:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"paintbrush": {
		"unicode": "1f58c",
		"unicode_alt": "1f58c-fe0f",
		"code_decimal": "&#128396;",
		"name": "lower left paintbrush",
		"shortname": ":paintbrush:",
		"category": "objects",
		"emoji_order": "1918",
		"aliases": [
			":lower_left_paintbrush:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"crayon": {
		"unicode": "1f58d",
		"unicode_alt": "1f58d-fe0f",
		"code_decimal": "&#128397;",
		"name": "lower left crayon",
		"shortname": ":crayon:",
		"category": "objects",
		"emoji_order": "1919",
		"aliases": [
			":lower_left_crayon:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office",
			"write"
		]
	},
	"pencil": {
		"unicode": "1f4dd",
		"unicode_alt": "",
		"code_decimal": "&#128221;",
		"name": "memo",
		"shortname": ":pencil:",
		"category": "objects",
		"emoji_order": "1920",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office",
			"write"
		]
	},
	"briefcase": {
		"unicode": "1f4bc",
		"unicode_alt": "",
		"code_decimal": "&#128188;",
		"name": "briefcase",
		"shortname": ":briefcase:",
		"category": "people",
		"emoji_order": "1921",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"bag",
			"work",
			"accessories",
			"nutcase",
			"job"
		]
	},
	"file_folder": {
		"unicode": "1f4c1",
		"unicode_alt": "",
		"code_decimal": "&#128193;",
		"name": "file folder",
		"shortname": ":file_folder:",
		"category": "objects",
		"emoji_order": "1922",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"open_file_folder": {
		"unicode": "1f4c2",
		"unicode_alt": "",
		"code_decimal": "&#128194;",
		"name": "open file folder",
		"shortname": ":open_file_folder:",
		"category": "objects",
		"emoji_order": "1923",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"dividers": {
		"unicode": "1f5c2",
		"unicode_alt": "1f5c2-fe0f",
		"code_decimal": "&#128450;",
		"name": "card index dividers",
		"shortname": ":dividers:",
		"category": "objects",
		"emoji_order": "1924",
		"aliases": [
			":card_index_dividers:"
		],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"date": {
		"unicode": "1f4c5",
		"unicode_alt": "",
		"code_decimal": "&#128197;",
		"name": "calendar",
		"shortname": ":date:",
		"category": "objects",
		"emoji_order": "1925",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"calendar": {
		"unicode": "1f4c6",
		"unicode_alt": "",
		"code_decimal": "&#128198;",
		"name": "tear-off calendar",
		"shortname": ":calendar:",
		"category": "objects",
		"emoji_order": "1926",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"notepad_spiral": {
		"unicode": "1f5d2",
		"unicode_alt": "1f5d2-fe0f",
		"code_decimal": "&#128466;",
		"name": "spiral note pad",
		"shortname": ":notepad_spiral:",
		"category": "objects",
		"emoji_order": "1927",
		"aliases": [
			":spiral_note_pad:"
		],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office",
			"write"
		]
	},
	"calendar_spiral": {
		"unicode": "1f5d3",
		"unicode_alt": "1f5d3-fe0f",
		"code_decimal": "&#128467;",
		"name": "spiral calendar pad",
		"shortname": ":calendar_spiral:",
		"category": "objects",
		"emoji_order": "1928",
		"aliases": [
			":spiral_calendar_pad:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"card_index": {
		"unicode": "1f4c7",
		"unicode_alt": "",
		"code_decimal": "&#128199;",
		"name": "card index",
		"shortname": ":card_index:",
		"category": "objects",
		"emoji_order": "1929",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work",
			"office"
		]
	},
	"chart_with_upwards_trend": {
		"unicode": "1f4c8",
		"unicode_alt": "",
		"code_decimal": "&#128200;",
		"name": "chart with upwards trend",
		"shortname": ":chart_with_upwards_trend:",
		"category": "objects",
		"emoji_order": "1930",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"chart_with_downwards_trend": {
		"unicode": "1f4c9",
		"unicode_alt": "",
		"code_decimal": "&#128201;",
		"name": "chart with downwards trend",
		"shortname": ":chart_with_downwards_trend:",
		"category": "objects",
		"emoji_order": "1931",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"bar_chart": {
		"unicode": "1f4ca",
		"unicode_alt": "",
		"code_decimal": "&#128202;",
		"name": "bar chart",
		"shortname": ":bar_chart:",
		"category": "objects",
		"emoji_order": "1932",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work",
			"office"
		]
	},
	"clipboard": {
		"unicode": "1f4cb",
		"unicode_alt": "",
		"code_decimal": "&#128203;",
		"name": "clipboard",
		"shortname": ":clipboard:",
		"category": "objects",
		"emoji_order": "1933",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work",
			"office",
			"write"
		]
	},
	"pushpin": {
		"unicode": "1f4cc",
		"unicode_alt": "",
		"code_decimal": "&#128204;",
		"name": "pushpin",
		"shortname": ":pushpin:",
		"category": "objects",
		"emoji_order": "1934",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"round_pushpin": {
		"unicode": "1f4cd",
		"unicode_alt": "",
		"code_decimal": "&#128205;",
		"name": "round pushpin",
		"shortname": ":round_pushpin:",
		"category": "objects",
		"emoji_order": "1935",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"office"
		]
	},
	"paperclip": {
		"unicode": "1f4ce",
		"unicode_alt": "",
		"code_decimal": "&#128206;",
		"name": "paperclip",
		"shortname": ":paperclip:",
		"category": "objects",
		"emoji_order": "1936",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work",
			"office"
		]
	},
	"paperclips": {
		"unicode": "1f587",
		"unicode_alt": "1f587-fe0f",
		"code_decimal": "&#128391;",
		"name": "linked paperclips",
		"shortname": ":paperclips:",
		"category": "objects",
		"emoji_order": "1937",
		"aliases": [
			":linked_paperclips:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work",
			"office"
		]
	},
	"straight_ruler": {
		"unicode": "1f4cf",
		"unicode_alt": "",
		"code_decimal": "&#128207;",
		"name": "straight ruler",
		"shortname": ":straight_ruler:",
		"category": "objects",
		"emoji_order": "1938",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"office"
		]
	},
	"triangular_ruler": {
		"unicode": "1f4d0",
		"unicode_alt": "",
		"code_decimal": "&#128208;",
		"name": "triangular ruler",
		"shortname": ":triangular_ruler:",
		"category": "objects",
		"emoji_order": "1939",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"office"
		]
	},
	"scissors": {
		"unicode": "2702",
		"unicode_alt": "2702-fe0f",
		"code_decimal": "&#9986;",
		"name": "black scissors",
		"shortname": ":scissors:",
		"category": "objects",
		"emoji_order": "1940",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"weapon",
			"office"
		]
	},
	"card_box": {
		"unicode": "1f5c3",
		"unicode_alt": "1f5c3-fe0f",
		"code_decimal": "&#128451;",
		"name": "card file box",
		"shortname": ":card_box:",
		"category": "objects",
		"emoji_order": "1941",
		"aliases": [
			":card_file_box:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work",
			"office"
		]
	},
	"file_cabinet": {
		"unicode": "1f5c4",
		"unicode_alt": "1f5c4-fe0f",
		"code_decimal": "&#128452;",
		"name": "file cabinet",
		"shortname": ":file_cabinet:",
		"category": "objects",
		"emoji_order": "1942",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work",
			"office"
		]
	},
	"wastebasket": {
		"unicode": "1f5d1",
		"unicode_alt": "1f5d1-fe0f",
		"code_decimal": "&#128465;",
		"name": "wastebasket",
		"shortname": ":wastebasket:",
		"category": "objects",
		"emoji_order": "1943",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"work"
		]
	},
	"lock": {
		"unicode": "1f512",
		"unicode_alt": "",
		"code_decimal": "&#128274;",
		"name": "lock",
		"shortname": ":lock:",
		"category": "objects",
		"emoji_order": "1944",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"lock"
		]
	},
	"unlock": {
		"unicode": "1f513",
		"unicode_alt": "",
		"code_decimal": "&#128275;",
		"name": "open lock",
		"shortname": ":unlock:",
		"category": "objects",
		"emoji_order": "1945",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"lock"
		]
	},
	"lock_with_ink_pen": {
		"unicode": "1f50f",
		"unicode_alt": "",
		"code_decimal": "&#128271;",
		"name": "lock with ink pen",
		"shortname": ":lock_with_ink_pen:",
		"category": "objects",
		"emoji_order": "1946",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"lock"
		]
	},
	"closed_lock_with_key": {
		"unicode": "1f510",
		"unicode_alt": "",
		"code_decimal": "&#128272;",
		"name": "closed lock with key",
		"shortname": ":closed_lock_with_key:",
		"category": "objects",
		"emoji_order": "1947",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"lock"
		]
	},
	"key": {
		"unicode": "1f511",
		"unicode_alt": "",
		"code_decimal": "&#128273;",
		"name": "key",
		"shortname": ":key:",
		"category": "objects",
		"emoji_order": "1948",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"lock"
		]
	},
	"key2": {
		"unicode": "1f5dd",
		"unicode_alt": "1f5dd-fe0f",
		"code_decimal": "&#128477;",
		"name": "old key",
		"shortname": ":key2:",
		"category": "objects",
		"emoji_order": "1949",
		"aliases": [
			":old_key:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"lock"
		]
	},
	"hammer": {
		"unicode": "1f528",
		"unicode_alt": "",
		"code_decimal": "&#128296;",
		"name": "hammer",
		"shortname": ":hammer:",
		"category": "objects",
		"emoji_order": "1950",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"weapon"
		]
	},
	"pick": {
		"unicode": "26cf",
		"unicode_alt": "26cf-fe0f",
		"code_decimal": "&#9935;",
		"name": "pick",
		"shortname": ":pick:",
		"category": "objects",
		"emoji_order": "1951",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"weapon"
		]
	},
	"hammer_pick": {
		"unicode": "2692",
		"unicode_alt": "2692-fe0f",
		"code_decimal": "&#9874;",
		"name": "hammer and pick",
		"shortname": ":hammer_pick:",
		"category": "objects",
		"emoji_order": "1952",
		"aliases": [
			":hammer_and_pick:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"weapon"
		]
	},
	"tools": {
		"unicode": "1f6e0",
		"unicode_alt": "1f6e0-fe0f",
		"code_decimal": "&#128736;",
		"name": "hammer and wrench",
		"shortname": ":tools:",
		"category": "objects",
		"emoji_order": "1953",
		"aliases": [
			":hammer_and_wrench:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool"
		]
	},
	"dagger": {
		"unicode": "1f5e1",
		"unicode_alt": "1f5e1-fe0f",
		"code_decimal": "&#128481;",
		"name": "dagger knife",
		"shortname": ":dagger:",
		"category": "objects",
		"emoji_order": "1954",
		"aliases": [
			":dagger_knife:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon"
		]
	},
	"crossed_swords": {
		"unicode": "2694",
		"unicode_alt": "2694-fe0f",
		"code_decimal": "&#9876;",
		"name": "crossed swords",
		"shortname": ":crossed_swords:",
		"category": "objects",
		"emoji_order": "1955",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon"
		]
	},
	"gun": {
		"unicode": "1f52b",
		"unicode_alt": "",
		"code_decimal": "&#128299;",
		"name": "pistol",
		"shortname": ":gun:",
		"category": "objects",
		"emoji_order": "1956",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon",
			"dead",
			"gun",
			"sarcastic"
		]
	},
	"bow_and_arrow": {
		"unicode": "1f3f9",
		"unicode_alt": "",
		"code_decimal": "&#127993;",
		"name": "bow and arrow",
		"shortname": ":bow_and_arrow:",
		"category": "activity",
		"emoji_order": "1957",
		"aliases": [
			":archery:"
		],
		"aliases_ascii": [],
		"keywords": [
			"weapon",
			"sport"
		]
	},
	"shield": {
		"unicode": "1f6e1",
		"unicode_alt": "1f6e1-fe0f",
		"code_decimal": "&#128737;",
		"name": "shield",
		"shortname": ":shield:",
		"category": "objects",
		"emoji_order": "1958",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"wrench": {
		"unicode": "1f527",
		"unicode_alt": "",
		"code_decimal": "&#128295;",
		"name": "wrench",
		"shortname": ":wrench:",
		"category": "objects",
		"emoji_order": "1959",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool"
		]
	},
	"nut_and_bolt": {
		"unicode": "1f529",
		"unicode_alt": "",
		"code_decimal": "&#128297;",
		"name": "nut and bolt",
		"shortname": ":nut_and_bolt:",
		"category": "objects",
		"emoji_order": "1960",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool",
			"nutcase"
		]
	},
	"gear": {
		"unicode": "2699",
		"unicode_alt": "2699-fe0f",
		"code_decimal": "&#9881;",
		"name": "gear",
		"shortname": ":gear:",
		"category": "objects",
		"emoji_order": "1961",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool"
		]
	},
	"compression": {
		"unicode": "1f5dc",
		"unicode_alt": "1f5dc-fe0f",
		"code_decimal": "&#128476;",
		"name": "compression",
		"shortname": ":compression:",
		"category": "objects",
		"emoji_order": "1962",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"alembic": {
		"unicode": "2697",
		"unicode_alt": "2697-fe0f",
		"code_decimal": "&#9879;",
		"name": "alembic",
		"shortname": ":alembic:",
		"category": "objects",
		"emoji_order": "1963",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"science"
		]
	},
	"scales": {
		"unicode": "2696",
		"unicode_alt": "2696-fe0f",
		"code_decimal": "&#9878;",
		"name": "scales",
		"shortname": ":scales:",
		"category": "objects",
		"emoji_order": "1964",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"link": {
		"unicode": "1f517",
		"unicode_alt": "",
		"code_decimal": "&#128279;",
		"name": "link symbol",
		"shortname": ":link:",
		"category": "objects",
		"emoji_order": "1965",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"office"
		]
	},
	"chains": {
		"unicode": "26d3",
		"unicode_alt": "26d3-fe0f",
		"code_decimal": "&#9939;",
		"name": "chains",
		"shortname": ":chains:",
		"category": "objects",
		"emoji_order": "1966",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"tool"
		]
	},
	"syringe": {
		"unicode": "1f489",
		"unicode_alt": "",
		"code_decimal": "&#128137;",
		"name": "syringe",
		"shortname": ":syringe:",
		"category": "objects",
		"emoji_order": "1967",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"weapon",
			"health",
			"drugs"
		]
	},
	"pill": {
		"unicode": "1f48a",
		"unicode_alt": "",
		"code_decimal": "&#128138;",
		"name": "pill",
		"shortname": ":pill:",
		"category": "objects",
		"emoji_order": "1968",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"health",
			"drugs"
		]
	},
	"smoking": {
		"unicode": "1f6ac",
		"unicode_alt": "",
		"code_decimal": "&#128684;",
		"name": "smoking symbol",
		"shortname": ":smoking:",
		"category": "objects",
		"emoji_order": "1969",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"drugs",
			"smoking"
		]
	},
	"coffin": {
		"unicode": "26b0",
		"unicode_alt": "26b0-fe0f",
		"code_decimal": "&#9904;",
		"name": "coffin",
		"shortname": ":coffin:",
		"category": "objects",
		"emoji_order": "1970",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"dead",
			"rip"
		]
	},
	"urn": {
		"unicode": "26b1",
		"unicode_alt": "26b1-fe0f",
		"code_decimal": "&#9905;",
		"name": "funeral urn",
		"shortname": ":urn:",
		"category": "objects",
		"emoji_order": "1971",
		"aliases": [
			":funeral_urn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"dead",
			"rip"
		]
	},
	"moyai": {
		"unicode": "1f5ff",
		"unicode_alt": "",
		"code_decimal": "&#128511;",
		"name": "moyai",
		"shortname": ":moyai:",
		"category": "objects",
		"emoji_order": "1972",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"travel",
			"vacation"
		]
	},
	"oil": {
		"unicode": "1f6e2",
		"unicode_alt": "1f6e2-fe0f",
		"code_decimal": "&#128738;",
		"name": "oil drum",
		"shortname": ":oil:",
		"category": "objects",
		"emoji_order": "1973",
		"aliases": [
			":oil_drum:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"crystal_ball": {
		"unicode": "1f52e",
		"unicode_alt": "",
		"code_decimal": "&#128302;",
		"name": "crystal ball",
		"shortname": ":crystal_ball:",
		"category": "objects",
		"emoji_order": "1974",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"ball"
		]
	},
	"shopping_cart": {
		"unicode": "1f6d2",
		"unicode_alt": "",
		"code_decimal": "&#128722;",
		"name": "shopping trolley",
		"shortname": ":shopping_cart:",
		"category": "objects",
		"emoji_order": "1975",
		"aliases": [
			":shopping_trolley:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"atm": {
		"unicode": "1f3e7",
		"unicode_alt": "",
		"code_decimal": "&#127975;",
		"name": "automated teller machine",
		"shortname": ":atm:",
		"category": "symbols",
		"emoji_order": "1976",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"electronics",
			"symbol",
			"money"
		]
	},
	"put_litter_in_its_place": {
		"unicode": "1f6ae",
		"unicode_alt": "",
		"code_decimal": "&#128686;",
		"name": "put litter in its place symbol",
		"shortname": ":put_litter_in_its_place:",
		"category": "symbols",
		"emoji_order": "1977",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"potable_water": {
		"unicode": "1f6b0",
		"unicode_alt": "",
		"code_decimal": "&#128688;",
		"name": "potable water symbol",
		"shortname": ":potable_water:",
		"category": "symbols",
		"emoji_order": "1978",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"wheelchair": {
		"unicode": "267f",
		"unicode_alt": "267f-fe0f",
		"code_decimal": "&#9855;",
		"name": "wheelchair symbol",
		"shortname": ":wheelchair:",
		"category": "symbols",
		"emoji_order": "1979",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"mens": {
		"unicode": "1f6b9",
		"unicode_alt": "",
		"code_decimal": "&#128697;",
		"name": "mens symbol",
		"shortname": ":mens:",
		"category": "symbols",
		"emoji_order": "1980",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"womens": {
		"unicode": "1f6ba",
		"unicode_alt": "",
		"code_decimal": "&#128698;",
		"name": "womens symbol",
		"shortname": ":womens:",
		"category": "symbols",
		"emoji_order": "1981",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"restroom": {
		"unicode": "1f6bb",
		"unicode_alt": "",
		"code_decimal": "&#128699;",
		"name": "restroom",
		"shortname": ":restroom:",
		"category": "symbols",
		"emoji_order": "1982",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"baby_symbol": {
		"unicode": "1f6bc",
		"unicode_alt": "",
		"code_decimal": "&#128700;",
		"name": "baby symbol",
		"shortname": ":baby_symbol:",
		"category": "symbols",
		"emoji_order": "1983",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"wc": {
		"unicode": "1f6be",
		"unicode_alt": "",
		"code_decimal": "&#128702;",
		"name": "water closet",
		"shortname": ":wc:",
		"category": "symbols",
		"emoji_order": "1984",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"passport_control": {
		"unicode": "1f6c2",
		"unicode_alt": "",
		"code_decimal": "&#128706;",
		"name": "passport control",
		"shortname": ":passport_control:",
		"category": "symbols",
		"emoji_order": "1985",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"customs": {
		"unicode": "1f6c3",
		"unicode_alt": "",
		"code_decimal": "&#128707;",
		"name": "customs",
		"shortname": ":customs:",
		"category": "symbols",
		"emoji_order": "1986",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"baggage_claim": {
		"unicode": "1f6c4",
		"unicode_alt": "",
		"code_decimal": "&#128708;",
		"name": "baggage claim",
		"shortname": ":baggage_claim:",
		"category": "symbols",
		"emoji_order": "1987",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"left_luggage": {
		"unicode": "1f6c5",
		"unicode_alt": "",
		"code_decimal": "&#128709;",
		"name": "left luggage",
		"shortname": ":left_luggage:",
		"category": "symbols",
		"emoji_order": "1988",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"warning": {
		"unicode": "26a0",
		"unicode_alt": "26a0-fe0f",
		"code_decimal": "&#9888;",
		"name": "warning sign",
		"shortname": ":warning:",
		"category": "symbols",
		"emoji_order": "1989",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation"
		]
	},
	"children_crossing": {
		"unicode": "1f6b8",
		"unicode_alt": "",
		"code_decimal": "&#128696;",
		"name": "children crossing",
		"shortname": ":children_crossing:",
		"category": "symbols",
		"emoji_order": "1990",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"no_entry": {
		"unicode": "26d4",
		"unicode_alt": "26d4-fe0f",
		"code_decimal": "&#9940;",
		"name": "no entry",
		"shortname": ":no_entry:",
		"category": "symbols",
		"emoji_order": "1991",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"circle"
		]
	},
	"no_entry_sign": {
		"unicode": "1f6ab",
		"unicode_alt": "",
		"code_decimal": "&#128683;",
		"name": "no entry sign",
		"shortname": ":no_entry_sign:",
		"category": "symbols",
		"emoji_order": "1992",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"circle"
		]
	},
	"no_bicycles": {
		"unicode": "1f6b3",
		"unicode_alt": "",
		"code_decimal": "&#128691;",
		"name": "no bicycles",
		"shortname": ":no_bicycles:",
		"category": "symbols",
		"emoji_order": "1993",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"no_smoking": {
		"unicode": "1f6ad",
		"unicode_alt": "",
		"code_decimal": "&#128685;",
		"name": "no smoking symbol",
		"shortname": ":no_smoking:",
		"category": "symbols",
		"emoji_order": "1994",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"smoking"
		]
	},
	"do_not_litter": {
		"unicode": "1f6af",
		"unicode_alt": "",
		"code_decimal": "&#128687;",
		"name": "do not litter symbol",
		"shortname": ":do_not_litter:",
		"category": "symbols",
		"emoji_order": "1995",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"non-potable_water": {
		"unicode": "1f6b1",
		"unicode_alt": "",
		"code_decimal": "&#128689;",
		"name": "non-potable water symbol",
		"shortname": ":non-potable_water:",
		"category": "symbols",
		"emoji_order": "1996",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"no_pedestrians": {
		"unicode": "1f6b7",
		"unicode_alt": "",
		"code_decimal": "&#128695;",
		"name": "no pedestrians",
		"shortname": ":no_pedestrians:",
		"category": "symbols",
		"emoji_order": "1997",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"no_mobile_phones": {
		"unicode": "1f4f5",
		"unicode_alt": "",
		"code_decimal": "&#128245;",
		"name": "no mobile phones",
		"shortname": ":no_mobile_phones:",
		"category": "symbols",
		"emoji_order": "1998",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"phone"
		]
	},
	"underage": {
		"unicode": "1f51e",
		"unicode_alt": "",
		"code_decimal": "&#128286;",
		"name": "no one under eighteen symbol",
		"shortname": ":underage:",
		"category": "symbols",
		"emoji_order": "1999",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"radioactive": {
		"unicode": "2622",
		"unicode_alt": "2622-fe0f",
		"code_decimal": "&#9762;",
		"name": "radioactive sign",
		"shortname": ":radioactive:",
		"category": "symbols",
		"emoji_order": "2000",
		"aliases": [
			":radioactive_sign:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"science"
		]
	},
	"biohazard": {
		"unicode": "2623",
		"unicode_alt": "2623-fe0f",
		"code_decimal": "&#9763;",
		"name": "biohazard sign",
		"shortname": ":biohazard:",
		"category": "symbols",
		"emoji_order": "2001",
		"aliases": [
			":biohazard_sign:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"science"
		]
	},
	"arrow_up": {
		"unicode": "2b06",
		"unicode_alt": "2b06-fe0f",
		"code_decimal": "&#11014;",
		"name": "upwards black arrow",
		"shortname": ":arrow_up:",
		"category": "symbols",
		"emoji_order": "2002",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_upper_right": {
		"unicode": "2197",
		"unicode_alt": "2197-fe0f",
		"code_decimal": "&#8599;",
		"name": "north east arrow",
		"shortname": ":arrow_upper_right:",
		"category": "symbols",
		"emoji_order": "2003",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_right": {
		"unicode": "27a1",
		"unicode_alt": "27a1-fe0f",
		"code_decimal": "&#10145;",
		"name": "black rightwards arrow",
		"shortname": ":arrow_right:",
		"category": "symbols",
		"emoji_order": "2004",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_lower_right": {
		"unicode": "2198",
		"unicode_alt": "2198-fe0f",
		"code_decimal": "&#8600;",
		"name": "south east arrow",
		"shortname": ":arrow_lower_right:",
		"category": "symbols",
		"emoji_order": "2005",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_down": {
		"unicode": "2b07",
		"unicode_alt": "2b07-fe0f",
		"code_decimal": "&#11015;",
		"name": "downwards black arrow",
		"shortname": ":arrow_down:",
		"category": "symbols",
		"emoji_order": "2006",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_lower_left": {
		"unicode": "2199",
		"unicode_alt": "2199-fe0f",
		"code_decimal": "&#8601;",
		"name": "south west arrow",
		"shortname": ":arrow_lower_left:",
		"category": "symbols",
		"emoji_order": "2007",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_left": {
		"unicode": "2b05",
		"unicode_alt": "2b05-fe0f",
		"code_decimal": "&#11013;",
		"name": "leftwards black arrow",
		"shortname": ":arrow_left:",
		"category": "symbols",
		"emoji_order": "2008",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_upper_left": {
		"unicode": "2196",
		"unicode_alt": "2196-fe0f",
		"code_decimal": "&#8598;",
		"name": "north west arrow",
		"shortname": ":arrow_upper_left:",
		"category": "symbols",
		"emoji_order": "2009",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_up_down": {
		"unicode": "2195",
		"unicode_alt": "2195-fe0f",
		"code_decimal": "&#8597;",
		"name": "up down arrow",
		"shortname": ":arrow_up_down:",
		"category": "symbols",
		"emoji_order": "2010",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"left_right_arrow": {
		"unicode": "2194",
		"unicode_alt": "2194-fe0f",
		"code_decimal": "&harr;",
		"name": "left right arrow",
		"shortname": ":left_right_arrow:",
		"category": "symbols",
		"emoji_order": "2011",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"leftwards_arrow_with_hook": {
		"unicode": "21a9",
		"unicode_alt": "21a9-fe0f",
		"code_decimal": "&#8617;",
		"name": "leftwards arrow with hook",
		"shortname": ":leftwards_arrow_with_hook:",
		"category": "symbols",
		"emoji_order": "2012",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_right_hook": {
		"unicode": "21aa",
		"unicode_alt": "21aa-fe0f",
		"code_decimal": "&#8618;",
		"name": "rightwards arrow with hook",
		"shortname": ":arrow_right_hook:",
		"category": "symbols",
		"emoji_order": "2013",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_heading_up": {
		"unicode": "2934",
		"unicode_alt": "2934-fe0f",
		"code_decimal": "&#10548;",
		"name": "arrow pointing rightwards then curving upwards",
		"shortname": ":arrow_heading_up:",
		"category": "symbols",
		"emoji_order": "2014",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_heading_down": {
		"unicode": "2935",
		"unicode_alt": "2935-fe0f",
		"code_decimal": "&#10549;",
		"name": "arrow pointing rightwards then curving downwards",
		"shortname": ":arrow_heading_down:",
		"category": "symbols",
		"emoji_order": "2015",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrows_clockwise": {
		"unicode": "1f503",
		"unicode_alt": "",
		"code_decimal": "&#128259;",
		"name": "clockwise downwards and upwards open circle arrows",
		"shortname": ":arrows_clockwise:",
		"category": "symbols",
		"emoji_order": "2016",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrows_counterclockwise": {
		"unicode": "1f504",
		"unicode_alt": "",
		"code_decimal": "&#128260;",
		"name": "anticlockwise downwards and upwards open circle arrows",
		"shortname": ":arrows_counterclockwise:",
		"category": "symbols",
		"emoji_order": "2017",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"back": {
		"unicode": "1f519",
		"unicode_alt": "",
		"code_decimal": "&#128281;",
		"name": "back with leftwards arrow above",
		"shortname": ":back:",
		"category": "symbols",
		"emoji_order": "2018",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"end": {
		"unicode": "1f51a",
		"unicode_alt": "",
		"code_decimal": "&#128282;",
		"name": "end with leftwards arrow above",
		"shortname": ":end:",
		"category": "symbols",
		"emoji_order": "2019",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"on": {
		"unicode": "1f51b",
		"unicode_alt": "",
		"code_decimal": "&#128283;",
		"name": "on with exclamation mark with left right arrow abo",
		"shortname": ":on:",
		"category": "symbols",
		"emoji_order": "2020",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"soon": {
		"unicode": "1f51c",
		"unicode_alt": "",
		"code_decimal": "&#128284;",
		"name": "soon with rightwards arrow above",
		"shortname": ":soon:",
		"category": "symbols",
		"emoji_order": "2021",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"top": {
		"unicode": "1f51d",
		"unicode_alt": "",
		"code_decimal": "&#128285;",
		"name": "top with upwards arrow above",
		"shortname": ":top:",
		"category": "symbols",
		"emoji_order": "2022",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"place_of_worship": {
		"unicode": "1f6d0",
		"unicode_alt": "",
		"code_decimal": "&#128720;",
		"name": "place of worship",
		"shortname": ":place_of_worship:",
		"category": "symbols",
		"emoji_order": "2023",
		"aliases": [
			":worship_symbol:"
		],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"symbol",
			"pray"
		]
	},
	"atom": {
		"unicode": "269b",
		"unicode_alt": "269b-fe0f",
		"code_decimal": "&#9883;",
		"name": "atom symbol",
		"shortname": ":atom:",
		"category": "symbols",
		"emoji_order": "2024",
		"aliases": [
			":atom_symbol:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"science"
		]
	},
	"om_symbol": {
		"unicode": "1f549",
		"unicode_alt": "1f549-fe0f",
		"code_decimal": "&#128329;",
		"name": "om symbol",
		"shortname": ":om_symbol:",
		"category": "symbols",
		"emoji_order": "2025",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"symbol"
		]
	},
	"star_of_david": {
		"unicode": "2721",
		"unicode_alt": "2721-fe0f",
		"code_decimal": "&#10017;",
		"name": "star of david",
		"shortname": ":star_of_david:",
		"category": "symbols",
		"emoji_order": "2026",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"jew",
			"star",
			"symbol"
		]
	},
	"wheel_of_dharma": {
		"unicode": "2638",
		"unicode_alt": "2638-fe0f",
		"code_decimal": "&#9784;",
		"name": "wheel of dharma",
		"shortname": ":wheel_of_dharma:",
		"category": "symbols",
		"emoji_order": "2027",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"symbol"
		]
	},
	"yin_yang": {
		"unicode": "262f",
		"unicode_alt": "262f-fe0f",
		"code_decimal": "&#9775;",
		"name": "yin yang",
		"shortname": ":yin_yang:",
		"category": "symbols",
		"emoji_order": "2028",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"cross": {
		"unicode": "271d",
		"unicode_alt": "271d-fe0f",
		"code_decimal": "&#10013;",
		"name": "latin cross",
		"shortname": ":cross:",
		"category": "symbols",
		"emoji_order": "2029",
		"aliases": [
			":latin_cross:"
		],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"symbol"
		]
	},
	"orthodox_cross": {
		"unicode": "2626",
		"unicode_alt": "2626-fe0f",
		"code_decimal": "&#9766;",
		"name": "orthodox cross",
		"shortname": ":orthodox_cross:",
		"category": "symbols",
		"emoji_order": "2030",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"symbol"
		]
	},
	"star_and_crescent": {
		"unicode": "262a",
		"unicode_alt": "262a-fe0f",
		"code_decimal": "&#9770;",
		"name": "star and crescent",
		"shortname": ":star_and_crescent:",
		"category": "symbols",
		"emoji_order": "2031",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"symbol"
		]
	},
	"peace": {
		"unicode": "262e",
		"unicode_alt": "262e-fe0f",
		"code_decimal": "&#9774;",
		"name": "peace symbol",
		"shortname": ":peace:",
		"category": "symbols",
		"emoji_order": "2032",
		"aliases": [
			":peace_symbol:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"peace",
			"drugs"
		]
	},
	"menorah": {
		"unicode": "1f54e",
		"unicode_alt": "",
		"code_decimal": "&#128334;",
		"name": "menorah with nine branches",
		"shortname": ":menorah:",
		"category": "symbols",
		"emoji_order": "2033",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"object",
			"jew",
			"symbol",
			"holidays"
		]
	},
	"six_pointed_star": {
		"unicode": "1f52f",
		"unicode_alt": "",
		"code_decimal": "&#128303;",
		"name": "six pointed star with middle dot",
		"shortname": ":six_pointed_star:",
		"category": "symbols",
		"emoji_order": "2034",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"religion",
			"jew",
			"star",
			"symbol"
		]
	},
	"aries": {
		"unicode": "2648",
		"unicode_alt": "2648-fe0f",
		"code_decimal": "&#9800;",
		"name": "aries",
		"shortname": ":aries:",
		"category": "symbols",
		"emoji_order": "2035",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"taurus": {
		"unicode": "2649",
		"unicode_alt": "2649-fe0f",
		"code_decimal": "&#9801;",
		"name": "taurus",
		"shortname": ":taurus:",
		"category": "symbols",
		"emoji_order": "2036",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"gemini": {
		"unicode": "264a",
		"unicode_alt": "264a-fe0f",
		"code_decimal": "&#9802;",
		"name": "gemini",
		"shortname": ":gemini:",
		"category": "symbols",
		"emoji_order": "2037",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"cancer": {
		"unicode": "264b",
		"unicode_alt": "264b-fe0f",
		"code_decimal": "&#9803;",
		"name": "cancer",
		"shortname": ":cancer:",
		"category": "symbols",
		"emoji_order": "2038",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"leo": {
		"unicode": "264c",
		"unicode_alt": "264c-fe0f",
		"code_decimal": "&#9804;",
		"name": "leo",
		"shortname": ":leo:",
		"category": "symbols",
		"emoji_order": "2039",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"virgo": {
		"unicode": "264d",
		"unicode_alt": "264d-fe0f",
		"code_decimal": "&#9805;",
		"name": "virgo",
		"shortname": ":virgo:",
		"category": "symbols",
		"emoji_order": "2040",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"libra": {
		"unicode": "264e",
		"unicode_alt": "264e-fe0f",
		"code_decimal": "&#9806;",
		"name": "libra",
		"shortname": ":libra:",
		"category": "symbols",
		"emoji_order": "2041",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"scorpius": {
		"unicode": "264f",
		"unicode_alt": "264f-fe0f",
		"code_decimal": "&#9807;",
		"name": "scorpius",
		"shortname": ":scorpius:",
		"category": "symbols",
		"emoji_order": "2042",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"sagittarius": {
		"unicode": "2650",
		"unicode_alt": "2650-fe0f",
		"code_decimal": "&#9808;",
		"name": "sagittarius",
		"shortname": ":sagittarius:",
		"category": "symbols",
		"emoji_order": "2043",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"capricorn": {
		"unicode": "2651",
		"unicode_alt": "2651-fe0f",
		"code_decimal": "&#9809;",
		"name": "capricorn",
		"shortname": ":capricorn:",
		"category": "symbols",
		"emoji_order": "2044",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"aquarius": {
		"unicode": "2652",
		"unicode_alt": "2652-fe0f",
		"code_decimal": "&#9810;",
		"name": "aquarius",
		"shortname": ":aquarius:",
		"category": "symbols",
		"emoji_order": "2045",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"pisces": {
		"unicode": "2653",
		"unicode_alt": "2653-fe0f",
		"code_decimal": "&#9811;",
		"name": "pisces",
		"shortname": ":pisces:",
		"category": "symbols",
		"emoji_order": "2046",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"zodiac",
			"symbol"
		]
	},
	"ophiuchus": {
		"unicode": "26ce",
		"unicode_alt": "",
		"code_decimal": "&#9934;",
		"name": "ophiuchus",
		"shortname": ":ophiuchus:",
		"category": "symbols",
		"emoji_order": "2047",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"twisted_rightwards_arrows": {
		"unicode": "1f500",
		"unicode_alt": "",
		"code_decimal": "&#128256;",
		"name": "twisted rightwards arrows",
		"shortname": ":twisted_rightwards_arrows:",
		"category": "symbols",
		"emoji_order": "2048",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"repeat": {
		"unicode": "1f501",
		"unicode_alt": "",
		"code_decimal": "&#128257;",
		"name": "clockwise rightwards and leftwards open circle arrows",
		"shortname": ":repeat:",
		"category": "symbols",
		"emoji_order": "2049",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"repeat_one": {
		"unicode": "1f502",
		"unicode_alt": "",
		"code_decimal": "&#128258;",
		"name": "clockwise rightwards and leftwards open circle arrows with circled one overlay",
		"shortname": ":repeat_one:",
		"category": "symbols",
		"emoji_order": "2050",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_forward": {
		"unicode": "25b6",
		"unicode_alt": "25b6-fe0f",
		"code_decimal": "&#9654;",
		"name": "black right-pointing triangle",
		"shortname": ":arrow_forward:",
		"category": "symbols",
		"emoji_order": "2051",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol",
			"triangle"
		]
	},
	"fast_forward": {
		"unicode": "23e9",
		"unicode_alt": "",
		"code_decimal": "&#9193;",
		"name": "black right-pointing double triangle",
		"shortname": ":fast_forward:",
		"category": "symbols",
		"emoji_order": "2052",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"track_next": {
		"unicode": "23ed",
		"unicode_alt": "23ed-fe0f",
		"code_decimal": "&#9197;",
		"name": "black right-pointing double triangle with vertical bar",
		"shortname": ":track_next:",
		"category": "symbols",
		"emoji_order": "2053",
		"aliases": [
			":next_track:"
		],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"play_pause": {
		"unicode": "23ef",
		"unicode_alt": "23ef-fe0f",
		"code_decimal": "&#9199;",
		"name": "black right-pointing double triangle with double vertical bar",
		"shortname": ":play_pause:",
		"category": "symbols",
		"emoji_order": "2054",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_backward": {
		"unicode": "25c0",
		"unicode_alt": "25c0-fe0f",
		"code_decimal": "&#9664;",
		"name": "black left-pointing triangle",
		"shortname": ":arrow_backward:",
		"category": "symbols",
		"emoji_order": "2055",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol",
			"triangle"
		]
	},
	"rewind": {
		"unicode": "23ea",
		"unicode_alt": "",
		"code_decimal": "&#9194;",
		"name": "black left-pointing double triangle",
		"shortname": ":rewind:",
		"category": "symbols",
		"emoji_order": "2056",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"track_previous": {
		"unicode": "23ee",
		"unicode_alt": "23ee-fe0f",
		"code_decimal": "&#9198;",
		"name": "black left-pointing double triangle with vertical bar",
		"shortname": ":track_previous:",
		"category": "symbols",
		"emoji_order": "2057",
		"aliases": [
			":previous_track:"
		],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_up_small": {
		"unicode": "1f53c",
		"unicode_alt": "",
		"code_decimal": "&#128316;",
		"name": "up-pointing small red triangle",
		"shortname": ":arrow_up_small:",
		"category": "symbols",
		"emoji_order": "2058",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol",
			"triangle"
		]
	},
	"arrow_double_up": {
		"unicode": "23eb",
		"unicode_alt": "",
		"code_decimal": "&#9195;",
		"name": "black up-pointing double triangle",
		"shortname": ":arrow_double_up:",
		"category": "symbols",
		"emoji_order": "2059",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"arrow_down_small": {
		"unicode": "1f53d",
		"unicode_alt": "",
		"code_decimal": "&#128317;",
		"name": "down-pointing small red triangle",
		"shortname": ":arrow_down_small:",
		"category": "symbols",
		"emoji_order": "2060",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol",
			"triangle"
		]
	},
	"arrow_double_down": {
		"unicode": "23ec",
		"unicode_alt": "",
		"code_decimal": "&#9196;",
		"name": "black down-pointing double triangle",
		"shortname": ":arrow_double_down:",
		"category": "symbols",
		"emoji_order": "2061",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"arrow",
			"symbol"
		]
	},
	"pause_button": {
		"unicode": "23f8",
		"unicode_alt": "23f8-fe0f",
		"code_decimal": "&#9208;",
		"name": "double vertical bar",
		"shortname": ":pause_button:",
		"category": "symbols",
		"emoji_order": "2062",
		"aliases": [
			":double_vertical_bar:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"stop_button": {
		"unicode": "23f9",
		"unicode_alt": "23f9-fe0f",
		"code_decimal": "&#9209;",
		"name": "black square for stop",
		"shortname": ":stop_button:",
		"category": "symbols",
		"emoji_order": "2063",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"square"
		]
	},
	"record_button": {
		"unicode": "23fa",
		"unicode_alt": "23fa-fe0f",
		"code_decimal": "&#9210;",
		"name": "black circle for record",
		"shortname": ":record_button:",
		"category": "symbols",
		"emoji_order": "2064",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"circle"
		]
	},
	"eject": {
		"unicode": "23cf",
		"unicode_alt": "23cf-fe0f",
		"code_decimal": "&#9167;",
		"name": "eject symbol",
		"shortname": ":eject:",
		"category": "symbols",
		"emoji_order": "2065",
		"aliases": [
			":eject_symbol:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"cinema": {
		"unicode": "1f3a6",
		"unicode_alt": "",
		"code_decimal": "&#127910;",
		"name": "cinema",
		"shortname": ":cinema:",
		"category": "symbols",
		"emoji_order": "2066",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"camera",
			"movie"
		]
	},
	"low_brightness": {
		"unicode": "1f505",
		"unicode_alt": "",
		"code_decimal": "&#128261;",
		"name": "low brightness symbol",
		"shortname": ":low_brightness:",
		"category": "symbols",
		"emoji_order": "2067",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"sun"
		]
	},
	"high_brightness": {
		"unicode": "1f506",
		"unicode_alt": "",
		"code_decimal": "&#128262;",
		"name": "high brightness symbol",
		"shortname": ":high_brightness:",
		"category": "symbols",
		"emoji_order": "2068",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"sun"
		]
	},
	"signal_strength": {
		"unicode": "1f4f6",
		"unicode_alt": "",
		"code_decimal": "&#128246;",
		"name": "antenna with bars",
		"shortname": ":signal_strength:",
		"category": "symbols",
		"emoji_order": "2069",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"vibration_mode": {
		"unicode": "1f4f3",
		"unicode_alt": "",
		"code_decimal": "&#128243;",
		"name": "vibration mode",
		"shortname": ":vibration_mode:",
		"category": "symbols",
		"emoji_order": "2070",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"mobile_phone_off": {
		"unicode": "1f4f4",
		"unicode_alt": "",
		"code_decimal": "&#128244;",
		"name": "mobile phone off",
		"shortname": ":mobile_phone_off:",
		"category": "symbols",
		"emoji_order": "2071",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"recycle": {
		"unicode": "267b",
		"unicode_alt": "267b-fe0f",
		"code_decimal": "&#9851;",
		"name": "black universal recycling symbol",
		"shortname": ":recycle:",
		"category": "symbols",
		"emoji_order": "2072",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"name_badge": {
		"unicode": "1f4db",
		"unicode_alt": "",
		"code_decimal": "&#128219;",
		"name": "name badge",
		"shortname": ":name_badge:",
		"category": "symbols",
		"emoji_order": "2073",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"work"
		]
	},
	"fleur-de-lis": {
		"unicode": "269c",
		"unicode_alt": "269c-fe0f",
		"code_decimal": "&#9884;",
		"name": "fleur-de-lis",
		"shortname": ":fleur-de-lis:",
		"category": "symbols",
		"emoji_order": "2074",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"symbol"
		]
	},
	"beginner": {
		"unicode": "1f530",
		"unicode_alt": "",
		"code_decimal": "&#128304;",
		"name": "japanese symbol for beginner",
		"shortname": ":beginner:",
		"category": "symbols",
		"emoji_order": "2075",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"trident": {
		"unicode": "1f531",
		"unicode_alt": "",
		"code_decimal": "&#128305;",
		"name": "trident emblem",
		"shortname": ":trident:",
		"category": "symbols",
		"emoji_order": "2076",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"symbol"
		]
	},
	"o": {
		"unicode": "2b55",
		"unicode_alt": "2b55-fe0f",
		"code_decimal": "&#11093;",
		"name": "heavy large circle",
		"shortname": ":o:",
		"category": "symbols",
		"emoji_order": "2077",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"circle"
		]
	},
	"white_check_mark": {
		"unicode": "2705",
		"unicode_alt": "",
		"code_decimal": "&#9989;",
		"name": "white heavy check mark",
		"shortname": ":white_check_mark:",
		"category": "symbols",
		"emoji_order": "2078",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"ballot_box_with_check": {
		"unicode": "2611",
		"unicode_alt": "2611-fe0f",
		"code_decimal": "&#9745;",
		"name": "ballot box with check",
		"shortname": ":ballot_box_with_check:",
		"category": "symbols",
		"emoji_order": "2079",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"heavy_check_mark": {
		"unicode": "2714",
		"unicode_alt": "2714-fe0f",
		"code_decimal": "&#10004;",
		"name": "heavy check mark",
		"shortname": ":heavy_check_mark:",
		"category": "symbols",
		"emoji_order": "2080",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"heavy_multiplication_x": {
		"unicode": "2716",
		"unicode_alt": "2716-fe0f",
		"code_decimal": "&#10006;",
		"name": "heavy multiplication x",
		"shortname": ":heavy_multiplication_x:",
		"category": "symbols",
		"emoji_order": "2081",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"math",
			"symbol"
		]
	},
	"x": {
		"unicode": "274c",
		"unicode_alt": "",
		"code_decimal": "&#10060;",
		"name": "cross mark",
		"shortname": ":x:",
		"category": "symbols",
		"emoji_order": "2082",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"sol"
		]
	},
	"negative_squared_cross_mark": {
		"unicode": "274e",
		"unicode_alt": "",
		"code_decimal": "&#10062;",
		"name": "negative squared cross mark",
		"shortname": ":negative_squared_cross_mark:",
		"category": "symbols",
		"emoji_order": "2083",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"heavy_plus_sign": {
		"unicode": "2795",
		"unicode_alt": "",
		"code_decimal": "&#10133;",
		"name": "heavy plus sign",
		"shortname": ":heavy_plus_sign:",
		"category": "symbols",
		"emoji_order": "2084",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"math",
			"symbol"
		]
	},
	"heavy_minus_sign": {
		"unicode": "2796",
		"unicode_alt": "",
		"code_decimal": "&#10134;",
		"name": "heavy minus sign",
		"shortname": ":heavy_minus_sign:",
		"category": "symbols",
		"emoji_order": "2088",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"math",
			"symbol"
		]
	},
	"heavy_division_sign": {
		"unicode": "2797",
		"unicode_alt": "",
		"code_decimal": "&#10135;",
		"name": "heavy division sign",
		"shortname": ":heavy_division_sign:",
		"category": "symbols",
		"emoji_order": "2089",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"math",
			"symbol"
		]
	},
	"curly_loop": {
		"unicode": "27b0",
		"unicode_alt": "",
		"code_decimal": "&#10160;",
		"name": "curly loop",
		"shortname": ":curly_loop:",
		"category": "symbols",
		"emoji_order": "2090",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"loop": {
		"unicode": "27bf",
		"unicode_alt": "",
		"code_decimal": "&#10175;",
		"name": "double curly loop",
		"shortname": ":loop:",
		"category": "symbols",
		"emoji_order": "2091",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"part_alternation_mark": {
		"unicode": "303d",
		"unicode_alt": "303d-fe0f",
		"code_decimal": "&#12349;",
		"name": "part alternation mark",
		"shortname": ":part_alternation_mark:",
		"category": "symbols",
		"emoji_order": "2092",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"eight_spoked_asterisk": {
		"unicode": "2733",
		"unicode_alt": "2733-fe0f",
		"code_decimal": "&#10035;",
		"name": "eight spoked asterisk",
		"shortname": ":eight_spoked_asterisk:",
		"category": "symbols",
		"emoji_order": "2093",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"eight_pointed_black_star": {
		"unicode": "2734",
		"unicode_alt": "2734-fe0f",
		"code_decimal": "&#10036;",
		"name": "eight pointed black star",
		"shortname": ":eight_pointed_black_star:",
		"category": "symbols",
		"emoji_order": "2094",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"sparkle": {
		"unicode": "2747",
		"unicode_alt": "2747-fe0f",
		"code_decimal": "&#10055;",
		"name": "sparkle",
		"shortname": ":sparkle:",
		"category": "symbols",
		"emoji_order": "2095",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"bangbang": {
		"unicode": "203c",
		"unicode_alt": "203c-fe0f",
		"code_decimal": "&#8252;",
		"name": "double exclamation mark",
		"shortname": ":bangbang:",
		"category": "symbols",
		"emoji_order": "2096",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation"
		]
	},
	"interrobang": {
		"unicode": "2049",
		"unicode_alt": "2049-fe0f",
		"code_decimal": "&#8265;",
		"name": "exclamation question mark",
		"shortname": ":interrobang:",
		"category": "symbols",
		"emoji_order": "2097",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation"
		]
	},
	"question": {
		"unicode": "2753",
		"unicode_alt": "",
		"code_decimal": "&#10067;",
		"name": "black question mark ornament",
		"shortname": ":question:",
		"category": "symbols",
		"emoji_order": "2098",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation",
			"wth"
		]
	},
	"grey_question": {
		"unicode": "2754",
		"unicode_alt": "",
		"code_decimal": "&#10068;",
		"name": "white question mark ornament",
		"shortname": ":grey_question:",
		"category": "symbols",
		"emoji_order": "2099",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation"
		]
	},
	"grey_exclamation": {
		"unicode": "2755",
		"unicode_alt": "",
		"code_decimal": "&#10069;",
		"name": "white exclamation mark ornament",
		"shortname": ":grey_exclamation:",
		"category": "symbols",
		"emoji_order": "2100",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation"
		]
	},
	"exclamation": {
		"unicode": "2757",
		"unicode_alt": "2757-fe0f",
		"code_decimal": "&#10071;",
		"name": "heavy exclamation mark symbol",
		"shortname": ":exclamation:",
		"category": "symbols",
		"emoji_order": "2101",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"punctuation"
		]
	},
	"wavy_dash": {
		"unicode": "3030",
		"unicode_alt": "3030-fe0f",
		"code_decimal": "&#12336;",
		"name": "wavy dash",
		"shortname": ":wavy_dash:",
		"category": "symbols",
		"emoji_order": "2102",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"copyright": {
		"unicode": "00a9",
		"unicode_alt": "00a9-fe0f",
		"code_decimal": "&copy;",
		"name": "copyright sign",
		"shortname": ":copyright:",
		"category": "symbols",
		"emoji_order": "2103",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"registered": {
		"unicode": "00ae",
		"unicode_alt": "00ae-fe0f",
		"code_decimal": "&reg;",
		"name": "registered sign",
		"shortname": ":registered:",
		"category": "symbols",
		"emoji_order": "2104",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"tm": {
		"unicode": "2122",
		"unicode_alt": "2122-fe0f",
		"code_decimal": "&trade;",
		"name": "trade mark sign",
		"shortname": ":tm:",
		"category": "symbols",
		"emoji_order": "2105",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"hash": {
		"unicode": "0023-20e3",
		"unicode_alt": "0023-fe0f-20e3",
		"code_decimal": "#&#8419;",
		"name": "keycap number sign",
		"shortname": ":hash:",
		"category": "symbols",
		"emoji_order": "2106",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"symbol"
		]
	},
	"asterisk": {
		"unicode": "002a-20e3",
		"unicode_alt": "002a-fe0f-20e3",
		"code_decimal": "*&#8419;",
		"name": "keycap asterisk",
		"shortname": ":asterisk:",
		"category": "symbols",
		"emoji_order": "2107",
		"aliases": [
			":keycap_asterisk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"zero": {
		"unicode": "0030-20e3",
		"unicode_alt": "0030-fe0f-20e3",
		"code_decimal": "0&#8419;",
		"name": "keycap digit zero",
		"shortname": ":zero:",
		"category": "symbols",
		"emoji_order": "2108",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"one": {
		"unicode": "0031-20e3",
		"unicode_alt": "0031-fe0f-20e3",
		"code_decimal": "1&#8419;",
		"name": "keycap digit one",
		"shortname": ":one:",
		"category": "symbols",
		"emoji_order": "2109",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"two": {
		"unicode": "0032-20e3",
		"unicode_alt": "0032-fe0f-20e3",
		"code_decimal": "2&#8419;",
		"name": "keycap digit two",
		"shortname": ":two:",
		"category": "symbols",
		"emoji_order": "2110",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"three": {
		"unicode": "0033-20e3",
		"unicode_alt": "0033-fe0f-20e3",
		"code_decimal": "3&#8419;",
		"name": "keycap digit three",
		"shortname": ":three:",
		"category": "symbols",
		"emoji_order": "2111",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"four": {
		"unicode": "0034-20e3",
		"unicode_alt": "0034-fe0f-20e3",
		"code_decimal": "4&#8419;",
		"name": "keycap digit four",
		"shortname": ":four:",
		"category": "symbols",
		"emoji_order": "2112",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"five": {
		"unicode": "0035-20e3",
		"unicode_alt": "0035-fe0f-20e3",
		"code_decimal": "5&#8419;",
		"name": "keycap digit five",
		"shortname": ":five:",
		"category": "symbols",
		"emoji_order": "2113",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"six": {
		"unicode": "0036-20e3",
		"unicode_alt": "0036-fe0f-20e3",
		"code_decimal": "6&#8419;",
		"name": "keycap digit six",
		"shortname": ":six:",
		"category": "symbols",
		"emoji_order": "2114",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"seven": {
		"unicode": "0037-20e3",
		"unicode_alt": "0037-fe0f-20e3",
		"code_decimal": "7&#8419;",
		"name": "keycap digit seven",
		"shortname": ":seven:",
		"category": "symbols",
		"emoji_order": "2115",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"eight": {
		"unicode": "0038-20e3",
		"unicode_alt": "0038-fe0f-20e3",
		"code_decimal": "8&#8419;",
		"name": "keycap digit eight",
		"shortname": ":eight:",
		"category": "symbols",
		"emoji_order": "2116",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"nine": {
		"unicode": "0039-20e3",
		"unicode_alt": "0039-fe0f-20e3",
		"code_decimal": "9&#8419;",
		"name": "keycap digit nine",
		"shortname": ":nine:",
		"category": "symbols",
		"emoji_order": "2117",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"keycap_ten": {
		"unicode": "1f51f",
		"unicode_alt": "",
		"code_decimal": "&#128287;",
		"name": "keycap ten",
		"shortname": ":keycap_ten:",
		"category": "symbols",
		"emoji_order": "2118",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"number",
			"math",
			"symbol"
		]
	},
	"capital_abcd": {
		"unicode": "1f520",
		"unicode_alt": "",
		"code_decimal": "&#128288;",
		"name": "input symbol for latin capital letters",
		"shortname": ":capital_abcd:",
		"category": "symbols",
		"emoji_order": "2120",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"abcd": {
		"unicode": "1f521",
		"unicode_alt": "",
		"code_decimal": "&#128289;",
		"name": "input symbol for latin small letters",
		"shortname": ":abcd:",
		"category": "symbols",
		"emoji_order": "2121",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"symbols": {
		"unicode": "1f523",
		"unicode_alt": "",
		"code_decimal": "&#128291;",
		"name": "input symbol for symbols",
		"shortname": ":symbols:",
		"category": "symbols",
		"emoji_order": "2123",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"abc": {
		"unicode": "1f524",
		"unicode_alt": "",
		"code_decimal": "&#128292;",
		"name": "input symbol for latin letters",
		"shortname": ":abc:",
		"category": "symbols",
		"emoji_order": "2124",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"a": {
		"unicode": "1f170",
		"unicode_alt": "",
		"code_decimal": "&#127344;",
		"name": "negative squared latin capital letter a",
		"shortname": ":a:",
		"category": "symbols",
		"emoji_order": "2125",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"ab": {
		"unicode": "1f18e",
		"unicode_alt": "",
		"code_decimal": "&#127374;",
		"name": "negative squared ab",
		"shortname": ":ab:",
		"category": "symbols",
		"emoji_order": "2126",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"b": {
		"unicode": "1f171",
		"unicode_alt": "",
		"code_decimal": "&#127345;",
		"name": "negative squared latin capital letter b",
		"shortname": ":b:",
		"category": "symbols",
		"emoji_order": "2127",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"cl": {
		"unicode": "1f191",
		"unicode_alt": "",
		"code_decimal": "&#127377;",
		"name": "squared cl",
		"shortname": ":cl:",
		"category": "symbols",
		"emoji_order": "2128",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"cool": {
		"unicode": "1f192",
		"unicode_alt": "",
		"code_decimal": "&#127378;",
		"name": "squared cool",
		"shortname": ":cool:",
		"category": "symbols",
		"emoji_order": "2129",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"free": {
		"unicode": "1f193",
		"unicode_alt": "",
		"code_decimal": "&#127379;",
		"name": "squared free",
		"shortname": ":free:",
		"category": "symbols",
		"emoji_order": "2130",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"information_source": {
		"unicode": "2139",
		"unicode_alt": "2139-fe0f",
		"code_decimal": "&#8505;",
		"name": "information source",
		"shortname": ":information_source:",
		"category": "symbols",
		"emoji_order": "2131",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"id": {
		"unicode": "1f194",
		"unicode_alt": "",
		"code_decimal": "&#127380;",
		"name": "squared id",
		"shortname": ":id:",
		"category": "symbols",
		"emoji_order": "2132",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"m": {
		"unicode": "24c2",
		"unicode_alt": "24c2-fe0f",
		"code_decimal": "&#9410;",
		"name": "circled latin capital letter m",
		"shortname": ":m:",
		"category": "symbols",
		"emoji_order": "2133",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"new": {
		"unicode": "1f195",
		"unicode_alt": "",
		"code_decimal": "&#127381;",
		"name": "squared new",
		"shortname": ":new:",
		"category": "symbols",
		"emoji_order": "2134",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"ng": {
		"unicode": "1f196",
		"unicode_alt": "",
		"code_decimal": "&#127382;",
		"name": "squared ng",
		"shortname": ":ng:",
		"category": "symbols",
		"emoji_order": "2135",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"o2": {
		"unicode": "1f17e",
		"unicode_alt": "",
		"code_decimal": "&#127358;",
		"name": "negative squared latin capital letter o",
		"shortname": ":o2:",
		"category": "symbols",
		"emoji_order": "2136",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"ok": {
		"unicode": "1f197",
		"unicode_alt": "",
		"code_decimal": "&#127383;",
		"name": "squared ok",
		"shortname": ":ok:",
		"category": "symbols",
		"emoji_order": "2137",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"parking": {
		"unicode": "1f17f",
		"unicode_alt": "1f17f-fe0f",
		"code_decimal": "&#127359;",
		"name": "negative squared latin capital letter p",
		"shortname": ":parking:",
		"category": "symbols",
		"emoji_order": "2138",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"sos": {
		"unicode": "1f198",
		"unicode_alt": "",
		"code_decimal": "&#127384;",
		"name": "squared sos",
		"shortname": ":sos:",
		"category": "symbols",
		"emoji_order": "2139",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"up": {
		"unicode": "1f199",
		"unicode_alt": "",
		"code_decimal": "&#127385;",
		"name": "squared up with exclamation mark",
		"shortname": ":up:",
		"category": "symbols",
		"emoji_order": "2140",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"vs": {
		"unicode": "1f19a",
		"unicode_alt": "",
		"code_decimal": "&#127386;",
		"name": "squared vs",
		"shortname": ":vs:",
		"category": "symbols",
		"emoji_order": "2141",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"koko": {
		"unicode": "1f201",
		"unicode_alt": "",
		"code_decimal": "&#127489;",
		"name": "squared katakana koko",
		"shortname": ":koko:",
		"category": "symbols",
		"emoji_order": "2142",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"sa": {
		"unicode": "1f202",
		"unicode_alt": "1f202-fe0f",
		"code_decimal": "&#127490;",
		"name": "squared katakana sa",
		"shortname": ":sa:",
		"category": "symbols",
		"emoji_order": "2143",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u6708": {
		"unicode": "1f237",
		"unicode_alt": "1f237-fe0f",
		"code_decimal": "&#127543;",
		"name": "squared cjk unified ideograph-6708",
		"shortname": ":u6708:",
		"category": "symbols",
		"emoji_order": "2144",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u6709": {
		"unicode": "1f236",
		"unicode_alt": "",
		"code_decimal": "&#127542;",
		"name": "squared cjk unified ideograph-6709",
		"shortname": ":u6709:",
		"category": "symbols",
		"emoji_order": "2145",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u6307": {
		"unicode": "1f22f",
		"unicode_alt": "1f22f-fe0f",
		"code_decimal": "&#127535;",
		"name": "squared cjk unified ideograph-6307",
		"shortname": ":u6307:",
		"category": "symbols",
		"emoji_order": "2146",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"ideograph_advantage": {
		"unicode": "1f250",
		"unicode_alt": "",
		"code_decimal": "&#127568;",
		"name": "circled ideograph advantage",
		"shortname": ":ideograph_advantage:",
		"category": "symbols",
		"emoji_order": "2147",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"symbol"
		]
	},
	"u5272": {
		"unicode": "1f239",
		"unicode_alt": "",
		"code_decimal": "&#127545;",
		"name": "squared cjk unified ideograph-5272",
		"shortname": ":u5272:",
		"category": "symbols",
		"emoji_order": "2148",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u7121": {
		"unicode": "1f21a",
		"unicode_alt": "1f21a-fe0f",
		"code_decimal": "&#127514;",
		"name": "squared cjk unified ideograph-7121",
		"shortname": ":u7121:",
		"category": "symbols",
		"emoji_order": "2149",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u7981": {
		"unicode": "1f232",
		"unicode_alt": "",
		"code_decimal": "&#127538;",
		"name": "squared cjk unified ideograph-7981",
		"shortname": ":u7981:",
		"category": "symbols",
		"emoji_order": "2150",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"symbol"
		]
	},
	"accept": {
		"unicode": "1f251",
		"unicode_alt": "",
		"code_decimal": "&#127569;",
		"name": "circled ideograph accept",
		"shortname": ":accept:",
		"category": "symbols",
		"emoji_order": "2151",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u7533": {
		"unicode": "1f238",
		"unicode_alt": "",
		"code_decimal": "&#127544;",
		"name": "squared cjk unified ideograph-7533",
		"shortname": ":u7533:",
		"category": "symbols",
		"emoji_order": "2152",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u5408": {
		"unicode": "1f234",
		"unicode_alt": "",
		"code_decimal": "&#127540;",
		"name": "squared cjk unified ideograph-5408",
		"shortname": ":u5408:",
		"category": "symbols",
		"emoji_order": "2153",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"symbol"
		]
	},
	"u7a7a": {
		"unicode": "1f233",
		"unicode_alt": "",
		"code_decimal": "&#127539;",
		"name": "squared cjk unified ideograph-7a7a",
		"shortname": ":u7a7a:",
		"category": "symbols",
		"emoji_order": "2154",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"congratulations": {
		"unicode": "3297",
		"unicode_alt": "3297-fe0f",
		"code_decimal": "&#12951;",
		"name": "circled ideograph congratulation",
		"shortname": ":congratulations:",
		"category": "symbols",
		"emoji_order": "2155",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"symbol"
		]
	},
	"secret": {
		"unicode": "3299",
		"unicode_alt": "3299-fe0f",
		"code_decimal": "&#12953;",
		"name": "circled ideograph secret",
		"shortname": ":secret:",
		"category": "symbols",
		"emoji_order": "2156",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"symbol"
		]
	},
	"u55b6": {
		"unicode": "1f23a",
		"unicode_alt": "",
		"code_decimal": "&#127546;",
		"name": "squared cjk unified ideograph-55b6",
		"shortname": ":u55b6:",
		"category": "symbols",
		"emoji_order": "2157",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"u6e80": {
		"unicode": "1f235",
		"unicode_alt": "",
		"code_decimal": "&#127541;",
		"name": "squared cjk unified ideograph-6e80",
		"shortname": ":u6e80:",
		"category": "symbols",
		"emoji_order": "2158",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"symbol"
		]
	},
	"black_small_square": {
		"unicode": "25aa",
		"unicode_alt": "25aa-fe0f",
		"code_decimal": "&#9642;",
		"name": "black small square",
		"shortname": ":black_small_square:",
		"category": "symbols",
		"emoji_order": "2159",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"white_small_square": {
		"unicode": "25ab",
		"unicode_alt": "25ab-fe0f",
		"code_decimal": "&#9643;",
		"name": "white small square",
		"shortname": ":white_small_square:",
		"category": "symbols",
		"emoji_order": "2160",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"white_medium_square": {
		"unicode": "25fb",
		"unicode_alt": "25fb-fe0f",
		"code_decimal": "&#9723;",
		"name": "white medium square",
		"shortname": ":white_medium_square:",
		"category": "symbols",
		"emoji_order": "2161",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"black_medium_square": {
		"unicode": "25fc",
		"unicode_alt": "25fc-fe0f",
		"code_decimal": "&#9724;",
		"name": "black medium square",
		"shortname": ":black_medium_square:",
		"category": "symbols",
		"emoji_order": "2162",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"white_medium_small_square": {
		"unicode": "25fd",
		"unicode_alt": "25fd-fe0f",
		"code_decimal": "&#9725;",
		"name": "white medium small square",
		"shortname": ":white_medium_small_square:",
		"category": "symbols",
		"emoji_order": "2163",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"black_medium_small_square": {
		"unicode": "25fe",
		"unicode_alt": "25fe-fe0f",
		"code_decimal": "&#9726;",
		"name": "black medium small square",
		"shortname": ":black_medium_small_square:",
		"category": "symbols",
		"emoji_order": "2164",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"black_large_square": {
		"unicode": "2b1b",
		"unicode_alt": "2b1b-fe0f",
		"code_decimal": "&#11035;",
		"name": "black large square",
		"shortname": ":black_large_square:",
		"category": "symbols",
		"emoji_order": "2165",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"white_large_square": {
		"unicode": "2b1c",
		"unicode_alt": "2b1c-fe0f",
		"code_decimal": "&#11036;",
		"name": "white large square",
		"shortname": ":white_large_square:",
		"category": "symbols",
		"emoji_order": "2166",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"large_orange_diamond": {
		"unicode": "1f536",
		"unicode_alt": "",
		"code_decimal": "&#128310;",
		"name": "large orange diamond",
		"shortname": ":large_orange_diamond:",
		"category": "symbols",
		"emoji_order": "2167",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol"
		]
	},
	"large_blue_diamond": {
		"unicode": "1f537",
		"unicode_alt": "",
		"code_decimal": "&#128311;",
		"name": "large blue diamond",
		"shortname": ":large_blue_diamond:",
		"category": "symbols",
		"emoji_order": "2168",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol"
		]
	},
	"small_orange_diamond": {
		"unicode": "1f538",
		"unicode_alt": "",
		"code_decimal": "&#128312;",
		"name": "small orange diamond",
		"shortname": ":small_orange_diamond:",
		"category": "symbols",
		"emoji_order": "2169",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol"
		]
	},
	"small_blue_diamond": {
		"unicode": "1f539",
		"unicode_alt": "",
		"code_decimal": "&#128313;",
		"name": "small blue diamond",
		"shortname": ":small_blue_diamond:",
		"category": "symbols",
		"emoji_order": "2170",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol"
		]
	},
	"small_red_triangle": {
		"unicode": "1f53a",
		"unicode_alt": "",
		"code_decimal": "&#128314;",
		"name": "up-pointing red triangle",
		"shortname": ":small_red_triangle:",
		"category": "symbols",
		"emoji_order": "2171",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"triangle"
		]
	},
	"small_red_triangle_down": {
		"unicode": "1f53b",
		"unicode_alt": "",
		"code_decimal": "&#128315;",
		"name": "down-pointing red triangle",
		"shortname": ":small_red_triangle_down:",
		"category": "symbols",
		"emoji_order": "2172",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"triangle"
		]
	},
	"diamond_shape_with_a_dot_inside": {
		"unicode": "1f4a0",
		"unicode_alt": "",
		"code_decimal": "&#128160;",
		"name": "diamond shape with a dot inside",
		"shortname": ":diamond_shape_with_a_dot_inside:",
		"category": "symbols",
		"emoji_order": "2173",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol"
		]
	},
	"radio_button": {
		"unicode": "1f518",
		"unicode_alt": "",
		"code_decimal": "&#128280;",
		"name": "radio button",
		"shortname": ":radio_button:",
		"category": "symbols",
		"emoji_order": "2174",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"symbol",
			"circle"
		]
	},
	"black_square_button": {
		"unicode": "1f532",
		"unicode_alt": "",
		"code_decimal": "&#128306;",
		"name": "black square button",
		"shortname": ":black_square_button:",
		"category": "symbols",
		"emoji_order": "2175",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"white_square_button": {
		"unicode": "1f533",
		"unicode_alt": "",
		"code_decimal": "&#128307;",
		"name": "white square button",
		"shortname": ":white_square_button:",
		"category": "symbols",
		"emoji_order": "2176",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"square"
		]
	},
	"white_circle": {
		"unicode": "26aa",
		"unicode_alt": "26aa-fe0f",
		"code_decimal": "&#9898;",
		"name": "white circle",
		"shortname": ":white_circle:",
		"category": "symbols",
		"emoji_order": "2177",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"circle"
		]
	},
	"black_circle": {
		"unicode": "26ab",
		"unicode_alt": "26ab-fe0f",
		"code_decimal": "&#9899;",
		"name": "black circle",
		"shortname": ":black_circle:",
		"category": "symbols",
		"emoji_order": "2178",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"circle"
		]
	},
	"red_circle": {
		"unicode": "1f534",
		"unicode_alt": "",
		"code_decimal": "&#128308;",
		"name": "red circle",
		"shortname": ":red_circle:",
		"category": "symbols",
		"emoji_order": "2179",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"circle"
		]
	},
	"blue_circle": {
		"unicode": "1f535",
		"unicode_alt": "",
		"code_decimal": "&#128309;",
		"name": "blue circle",
		"shortname": ":blue_circle:",
		"category": "symbols",
		"emoji_order": "2180",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"shapes",
			"symbol",
			"circle"
		]
	},
	"checkered_flag": {
		"unicode": "1f3c1",
		"unicode_alt": "",
		"code_decimal": "&#127937;",
		"name": "chequered flag",
		"shortname": ":checkered_flag:",
		"category": "travel",
		"emoji_order": "2181",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"triangular_flag_on_post": {
		"unicode": "1f6a9",
		"unicode_alt": "",
		"code_decimal": "&#128681;",
		"name": "triangular flag on post",
		"shortname": ":triangular_flag_on_post:",
		"category": "objects",
		"emoji_order": "2182",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"crossed_flags": {
		"unicode": "1f38c",
		"unicode_alt": "",
		"code_decimal": "&#127884;",
		"name": "crossed flags",
		"shortname": ":crossed_flags:",
		"category": "objects",
		"emoji_order": "2183",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": [
			"object",
			"japan"
		]
	},
	"flag_black": {
		"unicode": "1f3f4",
		"unicode_alt": "",
		"code_decimal": "&#127988;",
		"name": "waving black flag",
		"shortname": ":flag_black:",
		"category": "objects",
		"emoji_order": "2184",
		"aliases": [
			":waving_black_flag:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"flag_white": {
		"unicode": "1f3f3",
		"unicode_alt": "1f3f3-fe0f",
		"code_decimal": "&#127987;",
		"name": "waving white flag",
		"shortname": ":flag_white:",
		"category": "objects",
		"emoji_order": "2185",
		"aliases": [
			":waving_white_flag:"
		],
		"aliases_ascii": [],
		"keywords": [
			"object"
		]
	},
	"rainbow_flag": {
		"unicode": "1f3f3-1f308",
		"unicode_alt": "",
		"code_decimal": "&#127987;&#127752;",
		"name": "rainbow_flag",
		"shortname": ":rainbow_flag:",
		"category": "objects",
		"emoji_order": "2186",
		"aliases": [
			":gay_pride_flag:"
		],
		"aliases_ascii": [],
		"keywords": []
	},
	"flag_ac": {
		"unicode": "1f1e6-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127464;",
		"name": "ascension",
		"shortname": ":flag_ac:",
		"category": "flags",
		"emoji_order": "2187",
		"aliases": [
			":ac:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ad": {
		"unicode": "1f1e6-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127465;",
		"name": "andorra",
		"shortname": ":flag_ad:",
		"category": "flags",
		"emoji_order": "2188",
		"aliases": [
			":ad:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ae": {
		"unicode": "1f1e6-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127466;",
		"name": "the united arab emirates",
		"shortname": ":flag_ae:",
		"category": "flags",
		"emoji_order": "2189",
		"aliases": [
			":ae:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_af": {
		"unicode": "1f1e6-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127467;",
		"name": "afghanistan",
		"shortname": ":flag_af:",
		"category": "flags",
		"emoji_order": "2190",
		"aliases": [
			":af:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ag": {
		"unicode": "1f1e6-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127468;",
		"name": "antigua and barbuda",
		"shortname": ":flag_ag:",
		"category": "flags",
		"emoji_order": "2191",
		"aliases": [
			":ag:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ai": {
		"unicode": "1f1e6-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127470;",
		"name": "anguilla",
		"shortname": ":flag_ai:",
		"category": "flags",
		"emoji_order": "2192",
		"aliases": [
			":ai:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_al": {
		"unicode": "1f1e6-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127473;",
		"name": "albania",
		"shortname": ":flag_al:",
		"category": "flags",
		"emoji_order": "2193",
		"aliases": [
			":al:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_am": {
		"unicode": "1f1e6-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127474;",
		"name": "armenia",
		"shortname": ":flag_am:",
		"category": "flags",
		"emoji_order": "2194",
		"aliases": [
			":am:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ao": {
		"unicode": "1f1e6-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127476;",
		"name": "angola",
		"shortname": ":flag_ao:",
		"category": "flags",
		"emoji_order": "2195",
		"aliases": [
			":ao:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_aq": {
		"unicode": "1f1e6-1f1f6",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127478;",
		"name": "antarctica",
		"shortname": ":flag_aq:",
		"category": "flags",
		"emoji_order": "2196",
		"aliases": [
			":aq:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ar": {
		"unicode": "1f1e6-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127479;",
		"name": "argentina",
		"shortname": ":flag_ar:",
		"category": "flags",
		"emoji_order": "2197",
		"aliases": [
			":ar:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_as": {
		"unicode": "1f1e6-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127480;",
		"name": "american samoa",
		"shortname": ":flag_as:",
		"category": "flags",
		"emoji_order": "2198",
		"aliases": [
			":as:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_at": {
		"unicode": "1f1e6-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127481;",
		"name": "austria",
		"shortname": ":flag_at:",
		"category": "flags",
		"emoji_order": "2199",
		"aliases": [
			":at:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_au": {
		"unicode": "1f1e6-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127482;",
		"name": "australia",
		"shortname": ":flag_au:",
		"category": "flags",
		"emoji_order": "2200",
		"aliases": [
			":au:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_aw": {
		"unicode": "1f1e6-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127484;",
		"name": "aruba",
		"shortname": ":flag_aw:",
		"category": "flags",
		"emoji_order": "2201",
		"aliases": [
			":aw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ax": {
		"unicode": "1f1e6-1f1fd",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127485;",
		"name": "åland islands",
		"shortname": ":flag_ax:",
		"category": "flags",
		"emoji_order": "2202",
		"aliases": [
			":ax:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_az": {
		"unicode": "1f1e6-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127462;&#127487;",
		"name": "azerbaijan",
		"shortname": ":flag_az:",
		"category": "flags",
		"emoji_order": "2203",
		"aliases": [
			":az:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ba": {
		"unicode": "1f1e7-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127462;",
		"name": "bosnia and herzegovina",
		"shortname": ":flag_ba:",
		"category": "flags",
		"emoji_order": "2204",
		"aliases": [
			":ba:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bb": {
		"unicode": "1f1e7-1f1e7",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127463;",
		"name": "barbados",
		"shortname": ":flag_bb:",
		"category": "flags",
		"emoji_order": "2205",
		"aliases": [
			":bb:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bd": {
		"unicode": "1f1e7-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127465;",
		"name": "bangladesh",
		"shortname": ":flag_bd:",
		"category": "flags",
		"emoji_order": "2206",
		"aliases": [
			":bd:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_be": {
		"unicode": "1f1e7-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127466;",
		"name": "belgium",
		"shortname": ":flag_be:",
		"category": "flags",
		"emoji_order": "2207",
		"aliases": [
			":be:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bf": {
		"unicode": "1f1e7-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127467;",
		"name": "burkina faso",
		"shortname": ":flag_bf:",
		"category": "flags",
		"emoji_order": "2208",
		"aliases": [
			":bf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bg": {
		"unicode": "1f1e7-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127468;",
		"name": "bulgaria",
		"shortname": ":flag_bg:",
		"category": "flags",
		"emoji_order": "2209",
		"aliases": [
			":bg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bh": {
		"unicode": "1f1e7-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127469;",
		"name": "bahrain",
		"shortname": ":flag_bh:",
		"category": "flags",
		"emoji_order": "2210",
		"aliases": [
			":bh:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bi": {
		"unicode": "1f1e7-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127470;",
		"name": "burundi",
		"shortname": ":flag_bi:",
		"category": "flags",
		"emoji_order": "2211",
		"aliases": [
			":bi:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bj": {
		"unicode": "1f1e7-1f1ef",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127471;",
		"name": "benin",
		"shortname": ":flag_bj:",
		"category": "flags",
		"emoji_order": "2212",
		"aliases": [
			":bj:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bl": {
		"unicode": "1f1e7-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127473;",
		"name": "saint barthélemy",
		"shortname": ":flag_bl:",
		"category": "flags",
		"emoji_order": "2213",
		"aliases": [
			":bl:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bm": {
		"unicode": "1f1e7-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127474;",
		"name": "bermuda",
		"shortname": ":flag_bm:",
		"category": "flags",
		"emoji_order": "2214",
		"aliases": [
			":bm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bn": {
		"unicode": "1f1e7-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127475;",
		"name": "brunei",
		"shortname": ":flag_bn:",
		"category": "flags",
		"emoji_order": "2215",
		"aliases": [
			":bn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bo": {
		"unicode": "1f1e7-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127476;",
		"name": "bolivia",
		"shortname": ":flag_bo:",
		"category": "flags",
		"emoji_order": "2216",
		"aliases": [
			":bo:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bq": {
		"unicode": "1f1e7-1f1f6",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127478;",
		"name": "caribbean netherlands",
		"shortname": ":flag_bq:",
		"category": "flags",
		"emoji_order": "2217",
		"aliases": [
			":bq:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_br": {
		"unicode": "1f1e7-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127479;",
		"name": "brazil",
		"shortname": ":flag_br:",
		"category": "flags",
		"emoji_order": "2218",
		"aliases": [
			":br:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bs": {
		"unicode": "1f1e7-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127480;",
		"name": "the bahamas",
		"shortname": ":flag_bs:",
		"category": "flags",
		"emoji_order": "2219",
		"aliases": [
			":bs:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bt": {
		"unicode": "1f1e7-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127481;",
		"name": "bhutan",
		"shortname": ":flag_bt:",
		"category": "flags",
		"emoji_order": "2220",
		"aliases": [
			":bt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bv": {
		"unicode": "1f1e7-1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127483;",
		"name": "bouvet island",
		"shortname": ":flag_bv:",
		"category": "flags",
		"emoji_order": "2221",
		"aliases": [
			":bv:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bw": {
		"unicode": "1f1e7-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127484;",
		"name": "botswana",
		"shortname": ":flag_bw:",
		"category": "flags",
		"emoji_order": "2222",
		"aliases": [
			":bw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_by": {
		"unicode": "1f1e7-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127486;",
		"name": "belarus",
		"shortname": ":flag_by:",
		"category": "flags",
		"emoji_order": "2223",
		"aliases": [
			":by:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_bz": {
		"unicode": "1f1e7-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127463;&#127487;",
		"name": "belize",
		"shortname": ":flag_bz:",
		"category": "flags",
		"emoji_order": "2224",
		"aliases": [
			":bz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ca": {
		"unicode": "1f1e8-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127462;",
		"name": "canada",
		"shortname": ":flag_ca:",
		"category": "flags",
		"emoji_order": "2225",
		"aliases": [
			":ca:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cc": {
		"unicode": "1f1e8-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127464;",
		"name": "cocos (keeling) islands",
		"shortname": ":flag_cc:",
		"category": "flags",
		"emoji_order": "2226",
		"aliases": [
			":cc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cd": {
		"unicode": "1f1e8-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127465;",
		"name": "the democratic republic of the congo",
		"shortname": ":flag_cd:",
		"category": "flags",
		"emoji_order": "2227",
		"aliases": [
			":congo:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cf": {
		"unicode": "1f1e8-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127467;",
		"name": "central african republic",
		"shortname": ":flag_cf:",
		"category": "flags",
		"emoji_order": "2228",
		"aliases": [
			":cf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cg": {
		"unicode": "1f1e8-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127468;",
		"name": "the republic of the congo",
		"shortname": ":flag_cg:",
		"category": "flags",
		"emoji_order": "2229",
		"aliases": [
			":cg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ch": {
		"unicode": "1f1e8-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127469;",
		"name": "switzerland",
		"shortname": ":flag_ch:",
		"category": "flags",
		"emoji_order": "2230",
		"aliases": [
			":ch:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"neutral",
			"flag"
		]
	},
	"flag_ci": {
		"unicode": "1f1e8-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127470;",
		"name": "côte d’ivoire",
		"shortname": ":flag_ci:",
		"category": "flags",
		"emoji_order": "2231",
		"aliases": [
			":ci:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ck": {
		"unicode": "1f1e8-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127472;",
		"name": "cook islands",
		"shortname": ":flag_ck:",
		"category": "flags",
		"emoji_order": "2232",
		"aliases": [
			":ck:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cl": {
		"unicode": "1f1e8-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127473;",
		"name": "chile",
		"shortname": ":flag_cl:",
		"category": "flags",
		"emoji_order": "2233",
		"aliases": [
			":chile:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cm": {
		"unicode": "1f1e8-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127474;",
		"name": "cameroon",
		"shortname": ":flag_cm:",
		"category": "flags",
		"emoji_order": "2234",
		"aliases": [
			":cm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cn": {
		"unicode": "1f1e8-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127475;",
		"name": "china",
		"shortname": ":flag_cn:",
		"category": "flags",
		"emoji_order": "2235",
		"aliases": [
			":cn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_co": {
		"unicode": "1f1e8-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127476;",
		"name": "colombia",
		"shortname": ":flag_co:",
		"category": "flags",
		"emoji_order": "2236",
		"aliases": [
			":co:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cp": {
		"unicode": "1f1e8-1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127477;",
		"name": "clipperton island",
		"shortname": ":flag_cp:",
		"category": "flags",
		"emoji_order": "2237",
		"aliases": [
			":cp:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cr": {
		"unicode": "1f1e8-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127479;",
		"name": "costa rica",
		"shortname": ":flag_cr:",
		"category": "flags",
		"emoji_order": "2238",
		"aliases": [
			":cr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cu": {
		"unicode": "1f1e8-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127482;",
		"name": "cuba",
		"shortname": ":flag_cu:",
		"category": "flags",
		"emoji_order": "2239",
		"aliases": [
			":cu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cv": {
		"unicode": "1f1e8-1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127483;",
		"name": "cape verde",
		"shortname": ":flag_cv:",
		"category": "flags",
		"emoji_order": "2240",
		"aliases": [
			":cv:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cw": {
		"unicode": "1f1e8-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127484;",
		"name": "curaçao",
		"shortname": ":flag_cw:",
		"category": "flags",
		"emoji_order": "2241",
		"aliases": [
			":cw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cx": {
		"unicode": "1f1e8-1f1fd",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127485;",
		"name": "christmas island",
		"shortname": ":flag_cx:",
		"category": "flags",
		"emoji_order": "2242",
		"aliases": [
			":cx:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cy": {
		"unicode": "1f1e8-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127486;",
		"name": "cyprus",
		"shortname": ":flag_cy:",
		"category": "flags",
		"emoji_order": "2243",
		"aliases": [
			":cy:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_cz": {
		"unicode": "1f1e8-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127464;&#127487;",
		"name": "the czech republic",
		"shortname": ":flag_cz:",
		"category": "flags",
		"emoji_order": "2244",
		"aliases": [
			":cz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_de": {
		"unicode": "1f1e9-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127466;",
		"name": "germany",
		"shortname": ":flag_de:",
		"category": "flags",
		"emoji_order": "2245",
		"aliases": [
			":de:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_dg": {
		"unicode": "1f1e9-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127468;",
		"name": "diego garcia",
		"shortname": ":flag_dg:",
		"category": "flags",
		"emoji_order": "2246",
		"aliases": [
			":dg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_dj": {
		"unicode": "1f1e9-1f1ef",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127471;",
		"name": "djibouti",
		"shortname": ":flag_dj:",
		"category": "flags",
		"emoji_order": "2247",
		"aliases": [
			":dj:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_dk": {
		"unicode": "1f1e9-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127472;",
		"name": "denmark",
		"shortname": ":flag_dk:",
		"category": "flags",
		"emoji_order": "2248",
		"aliases": [
			":dk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_dm": {
		"unicode": "1f1e9-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127474;",
		"name": "dominica",
		"shortname": ":flag_dm:",
		"category": "flags",
		"emoji_order": "2249",
		"aliases": [
			":dm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_do": {
		"unicode": "1f1e9-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127476;",
		"name": "the dominican republic",
		"shortname": ":flag_do:",
		"category": "flags",
		"emoji_order": "2250",
		"aliases": [
			":do:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_dz": {
		"unicode": "1f1e9-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127465;&#127487;",
		"name": "algeria",
		"shortname": ":flag_dz:",
		"category": "flags",
		"emoji_order": "2251",
		"aliases": [
			":dz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ea": {
		"unicode": "1f1ea-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127462;",
		"name": "ceuta, melilla",
		"shortname": ":flag_ea:",
		"category": "flags",
		"emoji_order": "2252",
		"aliases": [
			":ea:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ec": {
		"unicode": "1f1ea-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127464;",
		"name": "ecuador",
		"shortname": ":flag_ec:",
		"category": "flags",
		"emoji_order": "2253",
		"aliases": [
			":ec:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ee": {
		"unicode": "1f1ea-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127466;",
		"name": "estonia",
		"shortname": ":flag_ee:",
		"category": "flags",
		"emoji_order": "2254",
		"aliases": [
			":ee:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_eg": {
		"unicode": "1f1ea-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127468;",
		"name": "egypt",
		"shortname": ":flag_eg:",
		"category": "flags",
		"emoji_order": "2255",
		"aliases": [
			":eg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_eh": {
		"unicode": "1f1ea-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127469;",
		"name": "western sahara",
		"shortname": ":flag_eh:",
		"category": "flags",
		"emoji_order": "2256",
		"aliases": [
			":eh:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_er": {
		"unicode": "1f1ea-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127479;",
		"name": "eritrea",
		"shortname": ":flag_er:",
		"category": "flags",
		"emoji_order": "2257",
		"aliases": [
			":er:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_es": {
		"unicode": "1f1ea-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127480;",
		"name": "spain",
		"shortname": ":flag_es:",
		"category": "flags",
		"emoji_order": "2258",
		"aliases": [
			":es:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_et": {
		"unicode": "1f1ea-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127481;",
		"name": "ethiopia",
		"shortname": ":flag_et:",
		"category": "flags",
		"emoji_order": "2259",
		"aliases": [
			":et:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_eu": {
		"unicode": "1f1ea-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127466;&#127482;",
		"name": "european union",
		"shortname": ":flag_eu:",
		"category": "flags",
		"emoji_order": "2260",
		"aliases": [
			":eu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_fi": {
		"unicode": "1f1eb-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127467;&#127470;",
		"name": "finland",
		"shortname": ":flag_fi:",
		"category": "flags",
		"emoji_order": "2261",
		"aliases": [
			":fi:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_fj": {
		"unicode": "1f1eb-1f1ef",
		"unicode_alt": "",
		"code_decimal": "&#127467;&#127471;",
		"name": "fiji",
		"shortname": ":flag_fj:",
		"category": "flags",
		"emoji_order": "2262",
		"aliases": [
			":fj:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_fk": {
		"unicode": "1f1eb-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127467;&#127472;",
		"name": "falkland islands",
		"shortname": ":flag_fk:",
		"category": "flags",
		"emoji_order": "2263",
		"aliases": [
			":fk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_fm": {
		"unicode": "1f1eb-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127467;&#127474;",
		"name": "micronesia",
		"shortname": ":flag_fm:",
		"category": "flags",
		"emoji_order": "2264",
		"aliases": [
			":fm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_fo": {
		"unicode": "1f1eb-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127467;&#127476;",
		"name": "faroe islands",
		"shortname": ":flag_fo:",
		"category": "flags",
		"emoji_order": "2265",
		"aliases": [
			":fo:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_fr": {
		"unicode": "1f1eb-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127467;&#127479;",
		"name": "france",
		"shortname": ":flag_fr:",
		"category": "flags",
		"emoji_order": "2266",
		"aliases": [
			":fr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ga": {
		"unicode": "1f1ec-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127462;",
		"name": "gabon",
		"shortname": ":flag_ga:",
		"category": "flags",
		"emoji_order": "2267",
		"aliases": [
			":ga:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gb": {
		"unicode": "1f1ec-1f1e7",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127463;",
		"name": "great britain",
		"shortname": ":flag_gb:",
		"category": "flags",
		"emoji_order": "2268",
		"aliases": [
			":gb:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gd": {
		"unicode": "1f1ec-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127465;",
		"name": "grenada",
		"shortname": ":flag_gd:",
		"category": "flags",
		"emoji_order": "2269",
		"aliases": [
			":gd:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ge": {
		"unicode": "1f1ec-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127466;",
		"name": "georgia",
		"shortname": ":flag_ge:",
		"category": "flags",
		"emoji_order": "2270",
		"aliases": [
			":ge:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gf": {
		"unicode": "1f1ec-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127467;",
		"name": "french guiana",
		"shortname": ":flag_gf:",
		"category": "flags",
		"emoji_order": "2271",
		"aliases": [
			":gf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gg": {
		"unicode": "1f1ec-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127468;",
		"name": "guernsey",
		"shortname": ":flag_gg:",
		"category": "flags",
		"emoji_order": "2272",
		"aliases": [
			":gg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gh": {
		"unicode": "1f1ec-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127469;",
		"name": "ghana",
		"shortname": ":flag_gh:",
		"category": "flags",
		"emoji_order": "2273",
		"aliases": [
			":gh:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gi": {
		"unicode": "1f1ec-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127470;",
		"name": "gibraltar",
		"shortname": ":flag_gi:",
		"category": "flags",
		"emoji_order": "2274",
		"aliases": [
			":gi:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gl": {
		"unicode": "1f1ec-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127473;",
		"name": "greenland",
		"shortname": ":flag_gl:",
		"category": "flags",
		"emoji_order": "2275",
		"aliases": [
			":gl:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gm": {
		"unicode": "1f1ec-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127474;",
		"name": "the gambia",
		"shortname": ":flag_gm:",
		"category": "flags",
		"emoji_order": "2276",
		"aliases": [
			":gm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gn": {
		"unicode": "1f1ec-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127475;",
		"name": "guinea",
		"shortname": ":flag_gn:",
		"category": "flags",
		"emoji_order": "2277",
		"aliases": [
			":gn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gp": {
		"unicode": "1f1ec-1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127477;",
		"name": "guadeloupe",
		"shortname": ":flag_gp:",
		"category": "flags",
		"emoji_order": "2278",
		"aliases": [
			":gp:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gq": {
		"unicode": "1f1ec-1f1f6",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127478;",
		"name": "equatorial guinea",
		"shortname": ":flag_gq:",
		"category": "flags",
		"emoji_order": "2279",
		"aliases": [
			":gq:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gr": {
		"unicode": "1f1ec-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127479;",
		"name": "greece",
		"shortname": ":flag_gr:",
		"category": "flags",
		"emoji_order": "2280",
		"aliases": [
			":gr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gs": {
		"unicode": "1f1ec-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127480;",
		"name": "south georgia",
		"shortname": ":flag_gs:",
		"category": "flags",
		"emoji_order": "2281",
		"aliases": [
			":gs:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gt": {
		"unicode": "1f1ec-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127481;",
		"name": "guatemala",
		"shortname": ":flag_gt:",
		"category": "flags",
		"emoji_order": "2282",
		"aliases": [
			":gt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gu": {
		"unicode": "1f1ec-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127482;",
		"name": "guam",
		"shortname": ":flag_gu:",
		"category": "flags",
		"emoji_order": "2283",
		"aliases": [
			":gu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gw": {
		"unicode": "1f1ec-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127484;",
		"name": "guinea-bissau",
		"shortname": ":flag_gw:",
		"category": "flags",
		"emoji_order": "2284",
		"aliases": [
			":gw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_gy": {
		"unicode": "1f1ec-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127468;&#127486;",
		"name": "guyana",
		"shortname": ":flag_gy:",
		"category": "flags",
		"emoji_order": "2285",
		"aliases": [
			":gy:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_hk": {
		"unicode": "1f1ed-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127469;&#127472;",
		"name": "hong kong",
		"shortname": ":flag_hk:",
		"category": "flags",
		"emoji_order": "2286",
		"aliases": [
			":hk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_hm": {
		"unicode": "1f1ed-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127469;&#127474;",
		"name": "heard island and mcdonald islands",
		"shortname": ":flag_hm:",
		"category": "flags",
		"emoji_order": "2287",
		"aliases": [
			":hm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_hn": {
		"unicode": "1f1ed-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127469;&#127475;",
		"name": "honduras",
		"shortname": ":flag_hn:",
		"category": "flags",
		"emoji_order": "2288",
		"aliases": [
			":hn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_hr": {
		"unicode": "1f1ed-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127469;&#127479;",
		"name": "croatia",
		"shortname": ":flag_hr:",
		"category": "flags",
		"emoji_order": "2289",
		"aliases": [
			":hr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ht": {
		"unicode": "1f1ed-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127469;&#127481;",
		"name": "haiti",
		"shortname": ":flag_ht:",
		"category": "flags",
		"emoji_order": "2290",
		"aliases": [
			":ht:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_hu": {
		"unicode": "1f1ed-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127469;&#127482;",
		"name": "hungary",
		"shortname": ":flag_hu:",
		"category": "flags",
		"emoji_order": "2291",
		"aliases": [
			":hu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ic": {
		"unicode": "1f1ee-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127464;",
		"name": "canary islands",
		"shortname": ":flag_ic:",
		"category": "flags",
		"emoji_order": "2292",
		"aliases": [
			":ic:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_id": {
		"unicode": "1f1ee-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127465;",
		"name": "indonesia",
		"shortname": ":flag_id:",
		"category": "flags",
		"emoji_order": "2293",
		"aliases": [
			":indonesia:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ie": {
		"unicode": "1f1ee-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127466;",
		"name": "ireland",
		"shortname": ":flag_ie:",
		"category": "flags",
		"emoji_order": "2294",
		"aliases": [
			":ie:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_il": {
		"unicode": "1f1ee-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127473;",
		"name": "israel",
		"shortname": ":flag_il:",
		"category": "flags",
		"emoji_order": "2295",
		"aliases": [
			":il:"
		],
		"aliases_ascii": [],
		"keywords": [
			"jew",
			"country",
			"flag"
		]
	},
	"flag_im": {
		"unicode": "1f1ee-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127474;",
		"name": "isle of man",
		"shortname": ":flag_im:",
		"category": "flags",
		"emoji_order": "2296",
		"aliases": [
			":im:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_in": {
		"unicode": "1f1ee-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127475;",
		"name": "india",
		"shortname": ":flag_in:",
		"category": "flags",
		"emoji_order": "2297",
		"aliases": [
			":in:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_io": {
		"unicode": "1f1ee-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127476;",
		"name": "british indian ocean territory",
		"shortname": ":flag_io:",
		"category": "flags",
		"emoji_order": "2298",
		"aliases": [
			":io:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_iq": {
		"unicode": "1f1ee-1f1f6",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127478;",
		"name": "iraq",
		"shortname": ":flag_iq:",
		"category": "flags",
		"emoji_order": "2299",
		"aliases": [
			":iq:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ir": {
		"unicode": "1f1ee-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127479;",
		"name": "iran",
		"shortname": ":flag_ir:",
		"category": "flags",
		"emoji_order": "2300",
		"aliases": [
			":ir:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_is": {
		"unicode": "1f1ee-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127480;",
		"name": "iceland",
		"shortname": ":flag_is:",
		"category": "flags",
		"emoji_order": "2301",
		"aliases": [
			":is:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_it": {
		"unicode": "1f1ee-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127470;&#127481;",
		"name": "italy",
		"shortname": ":flag_it:",
		"category": "flags",
		"emoji_order": "2302",
		"aliases": [
			":it:"
		],
		"aliases_ascii": [],
		"keywords": [
			"italian",
			"country",
			"flag"
		]
	},
	"flag_je": {
		"unicode": "1f1ef-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127471;&#127466;",
		"name": "jersey",
		"shortname": ":flag_je:",
		"category": "flags",
		"emoji_order": "2303",
		"aliases": [
			":je:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_jm": {
		"unicode": "1f1ef-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127471;&#127474;",
		"name": "jamaica",
		"shortname": ":flag_jm:",
		"category": "flags",
		"emoji_order": "2304",
		"aliases": [
			":jm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_jo": {
		"unicode": "1f1ef-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127471;&#127476;",
		"name": "jordan",
		"shortname": ":flag_jo:",
		"category": "flags",
		"emoji_order": "2305",
		"aliases": [
			":jo:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_jp": {
		"unicode": "1f1ef-1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127471;&#127477;",
		"name": "japan",
		"shortname": ":flag_jp:",
		"category": "flags",
		"emoji_order": "2306",
		"aliases": [
			":jp:"
		],
		"aliases_ascii": [],
		"keywords": [
			"japan",
			"country",
			"flag"
		]
	},
	"flag_ke": {
		"unicode": "1f1f0-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127466;",
		"name": "kenya",
		"shortname": ":flag_ke:",
		"category": "flags",
		"emoji_order": "2307",
		"aliases": [
			":ke:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kg": {
		"unicode": "1f1f0-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127468;",
		"name": "kyrgyzstan",
		"shortname": ":flag_kg:",
		"category": "flags",
		"emoji_order": "2308",
		"aliases": [
			":kg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kh": {
		"unicode": "1f1f0-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127469;",
		"name": "cambodia",
		"shortname": ":flag_kh:",
		"category": "flags",
		"emoji_order": "2309",
		"aliases": [
			":kh:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ki": {
		"unicode": "1f1f0-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127470;",
		"name": "kiribati",
		"shortname": ":flag_ki:",
		"category": "flags",
		"emoji_order": "2310",
		"aliases": [
			":ki:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_km": {
		"unicode": "1f1f0-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127474;",
		"name": "the comoros",
		"shortname": ":flag_km:",
		"category": "flags",
		"emoji_order": "2311",
		"aliases": [
			":km:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kn": {
		"unicode": "1f1f0-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127475;",
		"name": "saint kitts and nevis",
		"shortname": ":flag_kn:",
		"category": "flags",
		"emoji_order": "2312",
		"aliases": [
			":kn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kp": {
		"unicode": "1f1f0-1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127477;",
		"name": "north korea",
		"shortname": ":flag_kp:",
		"category": "flags",
		"emoji_order": "2313",
		"aliases": [
			":kp:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kr": {
		"unicode": "1f1f0-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127479;",
		"name": "korea",
		"shortname": ":flag_kr:",
		"category": "flags",
		"emoji_order": "2314",
		"aliases": [
			":kr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kw": {
		"unicode": "1f1f0-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127484;",
		"name": "kuwait",
		"shortname": ":flag_kw:",
		"category": "flags",
		"emoji_order": "2315",
		"aliases": [
			":kw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ky": {
		"unicode": "1f1f0-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127486;",
		"name": "cayman islands",
		"shortname": ":flag_ky:",
		"category": "flags",
		"emoji_order": "2316",
		"aliases": [
			":ky:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_kz": {
		"unicode": "1f1f0-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127472;&#127487;",
		"name": "kazakhstan",
		"shortname": ":flag_kz:",
		"category": "flags",
		"emoji_order": "2317",
		"aliases": [
			":kz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_la": {
		"unicode": "1f1f1-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127462;",
		"name": "laos",
		"shortname": ":flag_la:",
		"category": "flags",
		"emoji_order": "2318",
		"aliases": [
			":la:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lb": {
		"unicode": "1f1f1-1f1e7",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127463;",
		"name": "lebanon",
		"shortname": ":flag_lb:",
		"category": "flags",
		"emoji_order": "2319",
		"aliases": [
			":lb:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lc": {
		"unicode": "1f1f1-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127464;",
		"name": "saint lucia",
		"shortname": ":flag_lc:",
		"category": "flags",
		"emoji_order": "2320",
		"aliases": [
			":lc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_li": {
		"unicode": "1f1f1-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127470;",
		"name": "liechtenstein",
		"shortname": ":flag_li:",
		"category": "flags",
		"emoji_order": "2321",
		"aliases": [
			":li:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lk": {
		"unicode": "1f1f1-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127472;",
		"name": "sri lanka",
		"shortname": ":flag_lk:",
		"category": "flags",
		"emoji_order": "2322",
		"aliases": [
			":lk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lr": {
		"unicode": "1f1f1-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127479;",
		"name": "liberia",
		"shortname": ":flag_lr:",
		"category": "flags",
		"emoji_order": "2323",
		"aliases": [
			":lr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ls": {
		"unicode": "1f1f1-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127480;",
		"name": "lesotho",
		"shortname": ":flag_ls:",
		"category": "flags",
		"emoji_order": "2324",
		"aliases": [
			":ls:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lt": {
		"unicode": "1f1f1-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127481;",
		"name": "lithuania",
		"shortname": ":flag_lt:",
		"category": "flags",
		"emoji_order": "2325",
		"aliases": [
			":lt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lu": {
		"unicode": "1f1f1-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127482;",
		"name": "luxembourg",
		"shortname": ":flag_lu:",
		"category": "flags",
		"emoji_order": "2326",
		"aliases": [
			":lu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_lv": {
		"unicode": "1f1f1-1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127483;",
		"name": "latvia",
		"shortname": ":flag_lv:",
		"category": "flags",
		"emoji_order": "2327",
		"aliases": [
			":lv:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ly": {
		"unicode": "1f1f1-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127473;&#127486;",
		"name": "libya",
		"shortname": ":flag_ly:",
		"category": "flags",
		"emoji_order": "2328",
		"aliases": [
			":ly:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ma": {
		"unicode": "1f1f2-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127462;",
		"name": "morocco",
		"shortname": ":flag_ma:",
		"category": "flags",
		"emoji_order": "2329",
		"aliases": [
			":ma:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mc": {
		"unicode": "1f1f2-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127464;",
		"name": "monaco",
		"shortname": ":flag_mc:",
		"category": "flags",
		"emoji_order": "2330",
		"aliases": [
			":mc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_md": {
		"unicode": "1f1f2-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127465;",
		"name": "moldova",
		"shortname": ":flag_md:",
		"category": "flags",
		"emoji_order": "2331",
		"aliases": [
			":md:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_me": {
		"unicode": "1f1f2-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127466;",
		"name": "montenegro",
		"shortname": ":flag_me:",
		"category": "flags",
		"emoji_order": "2332",
		"aliases": [
			":me:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mf": {
		"unicode": "1f1f2-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127467;",
		"name": "saint martin",
		"shortname": ":flag_mf:",
		"category": "flags",
		"emoji_order": "2333",
		"aliases": [
			":mf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mg": {
		"unicode": "1f1f2-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127468;",
		"name": "madagascar",
		"shortname": ":flag_mg:",
		"category": "flags",
		"emoji_order": "2334",
		"aliases": [
			":mg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mh": {
		"unicode": "1f1f2-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127469;",
		"name": "the marshall islands",
		"shortname": ":flag_mh:",
		"category": "flags",
		"emoji_order": "2335",
		"aliases": [
			":mh:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mk": {
		"unicode": "1f1f2-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127472;",
		"name": "macedonia",
		"shortname": ":flag_mk:",
		"category": "flags",
		"emoji_order": "2336",
		"aliases": [
			":mk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ml": {
		"unicode": "1f1f2-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127473;",
		"name": "mali",
		"shortname": ":flag_ml:",
		"category": "flags",
		"emoji_order": "2337",
		"aliases": [
			":ml:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mm": {
		"unicode": "1f1f2-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127474;",
		"name": "myanmar",
		"shortname": ":flag_mm:",
		"category": "flags",
		"emoji_order": "2338",
		"aliases": [
			":mm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mn": {
		"unicode": "1f1f2-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127475;",
		"name": "mongolia",
		"shortname": ":flag_mn:",
		"category": "flags",
		"emoji_order": "2339",
		"aliases": [
			":mn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mo": {
		"unicode": "1f1f2-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127476;",
		"name": "macau",
		"shortname": ":flag_mo:",
		"category": "flags",
		"emoji_order": "2340",
		"aliases": [
			":mo:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mp": {
		"unicode": "1f1f2-1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127477;",
		"name": "northern mariana islands",
		"shortname": ":flag_mp:",
		"category": "flags",
		"emoji_order": "2341",
		"aliases": [
			":mp:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mq": {
		"unicode": "1f1f2-1f1f6",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127478;",
		"name": "martinique",
		"shortname": ":flag_mq:",
		"category": "flags",
		"emoji_order": "2342",
		"aliases": [
			":mq:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mr": {
		"unicode": "1f1f2-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127479;",
		"name": "mauritania",
		"shortname": ":flag_mr:",
		"category": "flags",
		"emoji_order": "2343",
		"aliases": [
			":mr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ms": {
		"unicode": "1f1f2-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127480;",
		"name": "montserrat",
		"shortname": ":flag_ms:",
		"category": "flags",
		"emoji_order": "2344",
		"aliases": [
			":ms:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mt": {
		"unicode": "1f1f2-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127481;",
		"name": "malta",
		"shortname": ":flag_mt:",
		"category": "flags",
		"emoji_order": "2345",
		"aliases": [
			":mt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mu": {
		"unicode": "1f1f2-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127482;",
		"name": "mauritius",
		"shortname": ":flag_mu:",
		"category": "flags",
		"emoji_order": "2346",
		"aliases": [
			":mu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mv": {
		"unicode": "1f1f2-1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127483;",
		"name": "maldives",
		"shortname": ":flag_mv:",
		"category": "flags",
		"emoji_order": "2347",
		"aliases": [
			":mv:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mw": {
		"unicode": "1f1f2-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127484;",
		"name": "malawi",
		"shortname": ":flag_mw:",
		"category": "flags",
		"emoji_order": "2348",
		"aliases": [
			":mw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mx": {
		"unicode": "1f1f2-1f1fd",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127485;",
		"name": "mexico",
		"shortname": ":flag_mx:",
		"category": "flags",
		"emoji_order": "2349",
		"aliases": [
			":mx:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"mexican",
			"flag"
		]
	},
	"flag_my": {
		"unicode": "1f1f2-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127486;",
		"name": "malaysia",
		"shortname": ":flag_my:",
		"category": "flags",
		"emoji_order": "2350",
		"aliases": [
			":my:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_mz": {
		"unicode": "1f1f2-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127474;&#127487;",
		"name": "mozambique",
		"shortname": ":flag_mz:",
		"category": "flags",
		"emoji_order": "2351",
		"aliases": [
			":mz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_na": {
		"unicode": "1f1f3-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127462;",
		"name": "namibia",
		"shortname": ":flag_na:",
		"category": "flags",
		"emoji_order": "2352",
		"aliases": [
			":na:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_nc": {
		"unicode": "1f1f3-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127464;",
		"name": "new caledonia",
		"shortname": ":flag_nc:",
		"category": "flags",
		"emoji_order": "2353",
		"aliases": [
			":nc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ne": {
		"unicode": "1f1f3-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127466;",
		"name": "niger",
		"shortname": ":flag_ne:",
		"category": "flags",
		"emoji_order": "2354",
		"aliases": [
			":ne:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_nf": {
		"unicode": "1f1f3-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127467;",
		"name": "norfolk island",
		"shortname": ":flag_nf:",
		"category": "flags",
		"emoji_order": "2355",
		"aliases": [
			":nf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ng": {
		"unicode": "1f1f3-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127468;",
		"name": "nigeria",
		"shortname": ":flag_ng:",
		"category": "flags",
		"emoji_order": "2356",
		"aliases": [
			":nigeria:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ni": {
		"unicode": "1f1f3-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127470;",
		"name": "nicaragua",
		"shortname": ":flag_ni:",
		"category": "flags",
		"emoji_order": "2357",
		"aliases": [
			":ni:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_nl": {
		"unicode": "1f1f3-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127473;",
		"name": "the netherlands",
		"shortname": ":flag_nl:",
		"category": "flags",
		"emoji_order": "2358",
		"aliases": [
			":nl:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_no": {
		"unicode": "1f1f3-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127476;",
		"name": "norway",
		"shortname": ":flag_no:",
		"category": "flags",
		"emoji_order": "2359",
		"aliases": [
			":no:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_np": {
		"unicode": "1f1f3-1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127477;",
		"name": "nepal",
		"shortname": ":flag_np:",
		"category": "flags",
		"emoji_order": "2360",
		"aliases": [
			":np:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_nr": {
		"unicode": "1f1f3-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127479;",
		"name": "nauru",
		"shortname": ":flag_nr:",
		"category": "flags",
		"emoji_order": "2361",
		"aliases": [
			":nr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_nu": {
		"unicode": "1f1f3-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127482;",
		"name": "niue",
		"shortname": ":flag_nu:",
		"category": "flags",
		"emoji_order": "2362",
		"aliases": [
			":nu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_nz": {
		"unicode": "1f1f3-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127475;&#127487;",
		"name": "new zealand",
		"shortname": ":flag_nz:",
		"category": "flags",
		"emoji_order": "2363",
		"aliases": [
			":nz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_om": {
		"unicode": "1f1f4-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127476;&#127474;",
		"name": "oman",
		"shortname": ":flag_om:",
		"category": "flags",
		"emoji_order": "2364",
		"aliases": [
			":om:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pa": {
		"unicode": "1f1f5-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127462;",
		"name": "panama",
		"shortname": ":flag_pa:",
		"category": "flags",
		"emoji_order": "2365",
		"aliases": [
			":pa:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pe": {
		"unicode": "1f1f5-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127466;",
		"name": "peru",
		"shortname": ":flag_pe:",
		"category": "flags",
		"emoji_order": "2366",
		"aliases": [
			":pe:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pf": {
		"unicode": "1f1f5-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127467;",
		"name": "french polynesia",
		"shortname": ":flag_pf:",
		"category": "flags",
		"emoji_order": "2367",
		"aliases": [
			":pf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pg": {
		"unicode": "1f1f5-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127468;",
		"name": "papua new guinea",
		"shortname": ":flag_pg:",
		"category": "flags",
		"emoji_order": "2368",
		"aliases": [
			":pg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ph": {
		"unicode": "1f1f5-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127469;",
		"name": "the philippines",
		"shortname": ":flag_ph:",
		"category": "flags",
		"emoji_order": "2369",
		"aliases": [
			":ph:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pk": {
		"unicode": "1f1f5-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127472;",
		"name": "pakistan",
		"shortname": ":flag_pk:",
		"category": "flags",
		"emoji_order": "2370",
		"aliases": [
			":pk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pl": {
		"unicode": "1f1f5-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127473;",
		"name": "poland",
		"shortname": ":flag_pl:",
		"category": "flags",
		"emoji_order": "2371",
		"aliases": [
			":pl:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pm": {
		"unicode": "1f1f5-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127474;",
		"name": "saint pierre and miquelon",
		"shortname": ":flag_pm:",
		"category": "flags",
		"emoji_order": "2372",
		"aliases": [
			":pm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pn": {
		"unicode": "1f1f5-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127475;",
		"name": "pitcairn",
		"shortname": ":flag_pn:",
		"category": "flags",
		"emoji_order": "2373",
		"aliases": [
			":pn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pr": {
		"unicode": "1f1f5-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127479;",
		"name": "puerto rico",
		"shortname": ":flag_pr:",
		"category": "flags",
		"emoji_order": "2374",
		"aliases": [
			":pr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ps": {
		"unicode": "1f1f5-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127480;",
		"name": "palestinian authority",
		"shortname": ":flag_ps:",
		"category": "flags",
		"emoji_order": "2375",
		"aliases": [
			":ps:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pt": {
		"unicode": "1f1f5-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127481;",
		"name": "portugal",
		"shortname": ":flag_pt:",
		"category": "flags",
		"emoji_order": "2376",
		"aliases": [
			":pt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_pw": {
		"unicode": "1f1f5-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127484;",
		"name": "palau",
		"shortname": ":flag_pw:",
		"category": "flags",
		"emoji_order": "2377",
		"aliases": [
			":pw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_py": {
		"unicode": "1f1f5-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127477;&#127486;",
		"name": "paraguay",
		"shortname": ":flag_py:",
		"category": "flags",
		"emoji_order": "2378",
		"aliases": [
			":py:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_qa": {
		"unicode": "1f1f6-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127478;&#127462;",
		"name": "qatar",
		"shortname": ":flag_qa:",
		"category": "flags",
		"emoji_order": "2379",
		"aliases": [
			":qa:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_re": {
		"unicode": "1f1f7-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127479;&#127466;",
		"name": "réunion",
		"shortname": ":flag_re:",
		"category": "flags",
		"emoji_order": "2380",
		"aliases": [
			":re:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ro": {
		"unicode": "1f1f7-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127479;&#127476;",
		"name": "romania",
		"shortname": ":flag_ro:",
		"category": "flags",
		"emoji_order": "2381",
		"aliases": [
			":ro:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_rs": {
		"unicode": "1f1f7-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127479;&#127480;",
		"name": "serbia",
		"shortname": ":flag_rs:",
		"category": "flags",
		"emoji_order": "2382",
		"aliases": [
			":rs:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ru": {
		"unicode": "1f1f7-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127479;&#127482;",
		"name": "russia",
		"shortname": ":flag_ru:",
		"category": "flags",
		"emoji_order": "2383",
		"aliases": [
			":ru:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_rw": {
		"unicode": "1f1f7-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127479;&#127484;",
		"name": "rwanda",
		"shortname": ":flag_rw:",
		"category": "flags",
		"emoji_order": "2384",
		"aliases": [
			":rw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sa": {
		"unicode": "1f1f8-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127462;",
		"name": "saudi arabia",
		"shortname": ":flag_sa:",
		"category": "flags",
		"emoji_order": "2385",
		"aliases": [
			":saudiarabia:",
			":saudi:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sb": {
		"unicode": "1f1f8-1f1e7",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127463;",
		"name": "the solomon islands",
		"shortname": ":flag_sb:",
		"category": "flags",
		"emoji_order": "2386",
		"aliases": [
			":sb:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sc": {
		"unicode": "1f1f8-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127464;",
		"name": "the seychelles",
		"shortname": ":flag_sc:",
		"category": "flags",
		"emoji_order": "2387",
		"aliases": [
			":sc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sd": {
		"unicode": "1f1f8-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127465;",
		"name": "sudan",
		"shortname": ":flag_sd:",
		"category": "flags",
		"emoji_order": "2388",
		"aliases": [
			":sd:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_se": {
		"unicode": "1f1f8-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127466;",
		"name": "sweden",
		"shortname": ":flag_se:",
		"category": "flags",
		"emoji_order": "2389",
		"aliases": [
			":se:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sg": {
		"unicode": "1f1f8-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127468;",
		"name": "singapore",
		"shortname": ":flag_sg:",
		"category": "flags",
		"emoji_order": "2390",
		"aliases": [
			":sg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sh": {
		"unicode": "1f1f8-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127469;",
		"name": "saint helena",
		"shortname": ":flag_sh:",
		"category": "flags",
		"emoji_order": "2391",
		"aliases": [
			":sh:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_si": {
		"unicode": "1f1f8-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127470;",
		"name": "slovenia",
		"shortname": ":flag_si:",
		"category": "flags",
		"emoji_order": "2392",
		"aliases": [
			":si:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sj": {
		"unicode": "1f1f8-1f1ef",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127471;",
		"name": "svalbard and jan mayen",
		"shortname": ":flag_sj:",
		"category": "flags",
		"emoji_order": "2393",
		"aliases": [
			":sj:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sk": {
		"unicode": "1f1f8-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127472;",
		"name": "slovakia",
		"shortname": ":flag_sk:",
		"category": "flags",
		"emoji_order": "2394",
		"aliases": [
			":sk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sl": {
		"unicode": "1f1f8-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127473;",
		"name": "sierra leone",
		"shortname": ":flag_sl:",
		"category": "flags",
		"emoji_order": "2395",
		"aliases": [
			":sl:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sm": {
		"unicode": "1f1f8-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127474;",
		"name": "san marino",
		"shortname": ":flag_sm:",
		"category": "flags",
		"emoji_order": "2396",
		"aliases": [
			":sm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sn": {
		"unicode": "1f1f8-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127475;",
		"name": "senegal",
		"shortname": ":flag_sn:",
		"category": "flags",
		"emoji_order": "2397",
		"aliases": [
			":sn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_so": {
		"unicode": "1f1f8-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127476;",
		"name": "somalia",
		"shortname": ":flag_so:",
		"category": "flags",
		"emoji_order": "2398",
		"aliases": [
			":so:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sr": {
		"unicode": "1f1f8-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127479;",
		"name": "suriname",
		"shortname": ":flag_sr:",
		"category": "flags",
		"emoji_order": "2399",
		"aliases": [
			":sr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ss": {
		"unicode": "1f1f8-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127480;",
		"name": "south sudan",
		"shortname": ":flag_ss:",
		"category": "flags",
		"emoji_order": "2400",
		"aliases": [
			":ss:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_st": {
		"unicode": "1f1f8-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127481;",
		"name": "são tomé and príncipe",
		"shortname": ":flag_st:",
		"category": "flags",
		"emoji_order": "2401",
		"aliases": [
			":st:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sv": {
		"unicode": "1f1f8-1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127483;",
		"name": "el salvador",
		"shortname": ":flag_sv:",
		"category": "flags",
		"emoji_order": "2402",
		"aliases": [
			":sv:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sx": {
		"unicode": "1f1f8-1f1fd",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127485;",
		"name": "sint maarten",
		"shortname": ":flag_sx:",
		"category": "flags",
		"emoji_order": "2403",
		"aliases": [
			":sx:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sy": {
		"unicode": "1f1f8-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127486;",
		"name": "syria",
		"shortname": ":flag_sy:",
		"category": "flags",
		"emoji_order": "2404",
		"aliases": [
			":sy:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_sz": {
		"unicode": "1f1f8-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127480;&#127487;",
		"name": "swaziland",
		"shortname": ":flag_sz:",
		"category": "flags",
		"emoji_order": "2405",
		"aliases": [
			":sz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ta": {
		"unicode": "1f1f9-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127462;",
		"name": "tristan da cunha",
		"shortname": ":flag_ta:",
		"category": "flags",
		"emoji_order": "2406",
		"aliases": [
			":ta:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tc": {
		"unicode": "1f1f9-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127464;",
		"name": "turks and caicos islands",
		"shortname": ":flag_tc:",
		"category": "flags",
		"emoji_order": "2407",
		"aliases": [
			":tc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_td": {
		"unicode": "1f1f9-1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127465;",
		"name": "chad",
		"shortname": ":flag_td:",
		"category": "flags",
		"emoji_order": "2408",
		"aliases": [
			":td:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tf": {
		"unicode": "1f1f9-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127467;",
		"name": "french southern territories",
		"shortname": ":flag_tf:",
		"category": "flags",
		"emoji_order": "2409",
		"aliases": [
			":tf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tg": {
		"unicode": "1f1f9-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127468;",
		"name": "togo",
		"shortname": ":flag_tg:",
		"category": "flags",
		"emoji_order": "2410",
		"aliases": [
			":tg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_th": {
		"unicode": "1f1f9-1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127469;",
		"name": "thailand",
		"shortname": ":flag_th:",
		"category": "flags",
		"emoji_order": "2411",
		"aliases": [
			":th:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tj": {
		"unicode": "1f1f9-1f1ef",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127471;",
		"name": "tajikistan",
		"shortname": ":flag_tj:",
		"category": "flags",
		"emoji_order": "2412",
		"aliases": [
			":tj:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tk": {
		"unicode": "1f1f9-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127472;",
		"name": "tokelau",
		"shortname": ":flag_tk:",
		"category": "flags",
		"emoji_order": "2413",
		"aliases": [
			":tk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tl": {
		"unicode": "1f1f9-1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127473;",
		"name": "timor-leste",
		"shortname": ":flag_tl:",
		"category": "flags",
		"emoji_order": "2414",
		"aliases": [
			":tl:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tm": {
		"unicode": "1f1f9-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127474;",
		"name": "turkmenistan",
		"shortname": ":flag_tm:",
		"category": "flags",
		"emoji_order": "2415",
		"aliases": [
			":turkmenistan:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tn": {
		"unicode": "1f1f9-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127475;",
		"name": "tunisia",
		"shortname": ":flag_tn:",
		"category": "flags",
		"emoji_order": "2416",
		"aliases": [
			":tn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_to": {
		"unicode": "1f1f9-1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127476;",
		"name": "tonga",
		"shortname": ":flag_to:",
		"category": "flags",
		"emoji_order": "2417",
		"aliases": [
			":to:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tr": {
		"unicode": "1f1f9-1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127479;",
		"name": "turkey",
		"shortname": ":flag_tr:",
		"category": "flags",
		"emoji_order": "2418",
		"aliases": [
			":tr:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tt": {
		"unicode": "1f1f9-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127481;",
		"name": "trinidad and tobago",
		"shortname": ":flag_tt:",
		"category": "flags",
		"emoji_order": "2419",
		"aliases": [
			":tt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tv": {
		"unicode": "1f1f9-1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127483;",
		"name": "tuvalu",
		"shortname": ":flag_tv:",
		"category": "flags",
		"emoji_order": "2420",
		"aliases": [
			":tuvalu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tw": {
		"unicode": "1f1f9-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127484;",
		"name": "the republic of china",
		"shortname": ":flag_tw:",
		"category": "flags",
		"emoji_order": "2421",
		"aliases": [
			":tw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_tz": {
		"unicode": "1f1f9-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127481;&#127487;",
		"name": "tanzania",
		"shortname": ":flag_tz:",
		"category": "flags",
		"emoji_order": "2422",
		"aliases": [
			":tz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ua": {
		"unicode": "1f1fa-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127482;&#127462;",
		"name": "ukraine",
		"shortname": ":flag_ua:",
		"category": "flags",
		"emoji_order": "2423",
		"aliases": [
			":ua:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ug": {
		"unicode": "1f1fa-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127482;&#127468;",
		"name": "uganda",
		"shortname": ":flag_ug:",
		"category": "flags",
		"emoji_order": "2424",
		"aliases": [
			":ug:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_um": {
		"unicode": "1f1fa-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127482;&#127474;",
		"name": "united states minor outlying islands",
		"shortname": ":flag_um:",
		"category": "flags",
		"emoji_order": "2425",
		"aliases": [
			":um:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_us": {
		"unicode": "1f1fa-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127482;&#127480;",
		"name": "united states",
		"shortname": ":flag_us:",
		"category": "flags",
		"emoji_order": "2427",
		"aliases": [
			":us:"
		],
		"aliases_ascii": [],
		"keywords": [
			"america",
			"country",
			"flag"
		]
	},
	"flag_uy": {
		"unicode": "1f1fa-1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127482;&#127486;",
		"name": "uruguay",
		"shortname": ":flag_uy:",
		"category": "flags",
		"emoji_order": "2428",
		"aliases": [
			":uy:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_uz": {
		"unicode": "1f1fa-1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127482;&#127487;",
		"name": "uzbekistan",
		"shortname": ":flag_uz:",
		"category": "flags",
		"emoji_order": "2429",
		"aliases": [
			":uz:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_va": {
		"unicode": "1f1fb-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127462;",
		"name": "the vatican city",
		"shortname": ":flag_va:",
		"category": "flags",
		"emoji_order": "2430",
		"aliases": [
			":va:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_vc": {
		"unicode": "1f1fb-1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127464;",
		"name": "saint vincent and the grenadines",
		"shortname": ":flag_vc:",
		"category": "flags",
		"emoji_order": "2431",
		"aliases": [
			":vc:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ve": {
		"unicode": "1f1fb-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127466;",
		"name": "venezuela",
		"shortname": ":flag_ve:",
		"category": "flags",
		"emoji_order": "2432",
		"aliases": [
			":ve:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_vg": {
		"unicode": "1f1fb-1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127468;",
		"name": "british virgin islands",
		"shortname": ":flag_vg:",
		"category": "flags",
		"emoji_order": "2433",
		"aliases": [
			":vg:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_vi": {
		"unicode": "1f1fb-1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127470;",
		"name": "u.s. virgin islands",
		"shortname": ":flag_vi:",
		"category": "flags",
		"emoji_order": "2434",
		"aliases": [
			":vi:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_vn": {
		"unicode": "1f1fb-1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127475;",
		"name": "vietnam",
		"shortname": ":flag_vn:",
		"category": "flags",
		"emoji_order": "2435",
		"aliases": [
			":vn:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_vu": {
		"unicode": "1f1fb-1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127483;&#127482;",
		"name": "vanuatu",
		"shortname": ":flag_vu:",
		"category": "flags",
		"emoji_order": "2436",
		"aliases": [
			":vu:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_wf": {
		"unicode": "1f1fc-1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127484;&#127467;",
		"name": "wallis and futuna",
		"shortname": ":flag_wf:",
		"category": "flags",
		"emoji_order": "2437",
		"aliases": [
			":wf:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ws": {
		"unicode": "1f1fc-1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127484;&#127480;",
		"name": "samoa",
		"shortname": ":flag_ws:",
		"category": "flags",
		"emoji_order": "2438",
		"aliases": [
			":ws:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_xk": {
		"unicode": "1f1fd-1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127485;&#127472;",
		"name": "kosovo",
		"shortname": ":flag_xk:",
		"category": "flags",
		"emoji_order": "2439",
		"aliases": [
			":xk:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_ye": {
		"unicode": "1f1fe-1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127486;&#127466;",
		"name": "yemen",
		"shortname": ":flag_ye:",
		"category": "flags",
		"emoji_order": "2440",
		"aliases": [
			":ye:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_yt": {
		"unicode": "1f1fe-1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127486;&#127481;",
		"name": "mayotte",
		"shortname": ":flag_yt:",
		"category": "flags",
		"emoji_order": "2441",
		"aliases": [
			":yt:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_za": {
		"unicode": "1f1ff-1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127487;&#127462;",
		"name": "south africa",
		"shortname": ":flag_za:",
		"category": "flags",
		"emoji_order": "2442",
		"aliases": [
			":za:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_zm": {
		"unicode": "1f1ff-1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127487;&#127474;",
		"name": "zambia",
		"shortname": ":flag_zm:",
		"category": "flags",
		"emoji_order": "2443",
		"aliases": [
			":zm:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"flag_zw": {
		"unicode": "1f1ff-1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127487;&#127484;",
		"name": "zimbabwe",
		"shortname": ":flag_zw:",
		"category": "flags",
		"emoji_order": "2444",
		"aliases": [
			":zw:"
		],
		"aliases_ascii": [],
		"keywords": [
			"country",
			"flag"
		]
	},
	"regional_indicator_z": {
		"unicode": "1f1ff",
		"unicode_alt": "",
		"code_decimal": "&#127487;",
		"name": "regional indicator symbol letter z",
		"shortname": ":regional_indicator_z:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_y": {
		"unicode": "1f1fe",
		"unicode_alt": "",
		"code_decimal": "&#127486;",
		"name": "regional indicator symbol letter y",
		"shortname": ":regional_indicator_y:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_x": {
		"unicode": "1f1fd",
		"unicode_alt": "",
		"code_decimal": "&#127485;",
		"name": "regional indicator symbol letter x",
		"shortname": ":regional_indicator_x:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_w": {
		"unicode": "1f1fc",
		"unicode_alt": "",
		"code_decimal": "&#127484;",
		"name": "regional indicator symbol letter w",
		"shortname": ":regional_indicator_w:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_v": {
		"unicode": "1f1fb",
		"unicode_alt": "",
		"code_decimal": "&#127483;",
		"name": "regional indicator symbol letter v",
		"shortname": ":regional_indicator_v:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_u": {
		"unicode": "1f1fa",
		"unicode_alt": "",
		"code_decimal": "&#127482;",
		"name": "regional indicator symbol letter u",
		"shortname": ":regional_indicator_u:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_t": {
		"unicode": "1f1f9",
		"unicode_alt": "",
		"code_decimal": "&#127481;",
		"name": "regional indicator symbol letter t",
		"shortname": ":regional_indicator_t:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_s": {
		"unicode": "1f1f8",
		"unicode_alt": "",
		"code_decimal": "&#127480;",
		"name": "regional indicator symbol letter s",
		"shortname": ":regional_indicator_s:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_r": {
		"unicode": "1f1f7",
		"unicode_alt": "",
		"code_decimal": "&#127479;",
		"name": "regional indicator symbol letter r",
		"shortname": ":regional_indicator_r:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_q": {
		"unicode": "1f1f6",
		"unicode_alt": "",
		"code_decimal": "&#127478;",
		"name": "regional indicator symbol letter q",
		"shortname": ":regional_indicator_q:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_p": {
		"unicode": "1f1f5",
		"unicode_alt": "",
		"code_decimal": "&#127477;",
		"name": "regional indicator symbol letter p",
		"shortname": ":regional_indicator_p:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_o": {
		"unicode": "1f1f4",
		"unicode_alt": "",
		"code_decimal": "&#127476;",
		"name": "regional indicator symbol letter o",
		"shortname": ":regional_indicator_o:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_n": {
		"unicode": "1f1f3",
		"unicode_alt": "",
		"code_decimal": "&#127475;",
		"name": "regional indicator symbol letter n",
		"shortname": ":regional_indicator_n:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_m": {
		"unicode": "1f1f2",
		"unicode_alt": "",
		"code_decimal": "&#127474;",
		"name": "regional indicator symbol letter m",
		"shortname": ":regional_indicator_m:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_l": {
		"unicode": "1f1f1",
		"unicode_alt": "",
		"code_decimal": "&#127473;",
		"name": "regional indicator symbol letter l",
		"shortname": ":regional_indicator_l:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_k": {
		"unicode": "1f1f0",
		"unicode_alt": "",
		"code_decimal": "&#127472;",
		"name": "regional indicator symbol letter k",
		"shortname": ":regional_indicator_k:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_j": {
		"unicode": "1f1ef",
		"unicode_alt": "",
		"code_decimal": "&#127471;",
		"name": "regional indicator symbol letter j",
		"shortname": ":regional_indicator_j:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_i": {
		"unicode": "1f1ee",
		"unicode_alt": "",
		"code_decimal": "&#127470;",
		"name": "regional indicator symbol letter i",
		"shortname": ":regional_indicator_i:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_h": {
		"unicode": "1f1ed",
		"unicode_alt": "",
		"code_decimal": "&#127469;",
		"name": "regional indicator symbol letter h",
		"shortname": ":regional_indicator_h:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_g": {
		"unicode": "1f1ec",
		"unicode_alt": "",
		"code_decimal": "&#127468;",
		"name": "regional indicator symbol letter g",
		"shortname": ":regional_indicator_g:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_f": {
		"unicode": "1f1eb",
		"unicode_alt": "",
		"code_decimal": "&#127467;",
		"name": "regional indicator symbol letter f",
		"shortname": ":regional_indicator_f:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_e": {
		"unicode": "1f1ea",
		"unicode_alt": "",
		"code_decimal": "&#127466;",
		"name": "regional indicator symbol letter e",
		"shortname": ":regional_indicator_e:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_d": {
		"unicode": "1f1e9",
		"unicode_alt": "",
		"code_decimal": "&#127465;",
		"name": "regional indicator symbol letter d",
		"shortname": ":regional_indicator_d:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_c": {
		"unicode": "1f1e8",
		"unicode_alt": "",
		"code_decimal": "&#127464;",
		"name": "regional indicator symbol letter c",
		"shortname": ":regional_indicator_c:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_b": {
		"unicode": "1f1e7",
		"unicode_alt": "",
		"code_decimal": "&#127463;",
		"name": "regional indicator symbol letter b",
		"shortname": ":regional_indicator_b:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	},
	"regional_indicator_a": {
		"unicode": "1f1e6",
		"unicode_alt": "",
		"code_decimal": "&#127462;",
		"name": "regional indicator symbol letter a",
		"shortname": ":regional_indicator_a:",
		"category": "regional",
		"emoji_order": "12345",
		"aliases": [],
		"aliases_ascii": [],
		"keywords": []
	}
};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1109),
    flatRest = __webpack_require__(950);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1110),
    hasIn = __webpack_require__(942);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(889),
    baseSet = __webpack_require__(1111),
    castPath = __webpack_require__(872);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(904),
    castPath = __webpack_require__(872),
    isIndex = __webpack_require__(882),
    isObject = __webpack_require__(114),
    toKey = __webpack_require__(873);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AutoSizer = __webpack_require__(1113);

var _AutoSizer2 = _interopRequireDefault(_AutoSizer);

var _List = __webpack_require__(1116);

var _List2 = _interopRequireDefault(_List);

var _findIndex = __webpack_require__(1127);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _throttle = __webpack_require__(178);

var _throttle2 = _interopRequireDefault(_throttle);

var _categoryHeader = __webpack_require__(1130);

var _categoryHeader2 = _interopRequireDefault(_categoryHeader);

var _emojiRow = __webpack_require__(1131);

var _emojiRow2 = _interopRequireDefault(_emojiRow);

var _modifiers = __webpack_require__(1132);

var _modifiers2 = _interopRequireDefault(_modifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// These height values must be kept in sync with the heights
// (margin + padding + content height) defined in CSS.
var CATEGORY_HEADER_ROW_HEIGHT = 46;
var EMOJI_ROW_HEIGHT = 32;

var Categories = function (_Component) {
  _inherits(Categories, _Component);

  function Categories(props, context) {
    _classCallCheck(this, Categories);

    var _this = _possibleConstructorReturn(this, (Categories.__proto__ || Object.getPrototypeOf(Categories)).call(this, props, context));

    _this.getActiveCategory = function () {
      return _this._getActiveCategory();
    };

    _this._setListRef = function (list) {
      _this.list = list;
    };

    _this._onScroll = (0, _throttle2.default)(function (_ref) {
      var scrollTop = _ref.scrollTop;

      var activeCategory = _this._getActiveCategory(scrollTop);
      if (activeCategory !== _this.lastActiveCategory) {
        _this.lastActiveCategory = activeCategory;
        _this.props.onActiveCategoryChange(activeCategory);
      }
    }, 100);

    _this._getActiveCategory = function () {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var rows = _this.props.rows;


      if (scrollTop === 0) {
        if (rows.length === 0) return undefined;
        return rows[0].id;
      }

      var firstFullyVisibleRowIndex = 0;
      var accumulatedScrollTop = 0;

      while (accumulatedScrollTop < scrollTop) {
        accumulatedScrollTop += _this._rowHeight({
          index: firstFullyVisibleRowIndex
        });

        if (accumulatedScrollTop <= scrollTop) {
          firstFullyVisibleRowIndex += 1;
        }
      }

      var currentRow = _this.props.rows[firstFullyVisibleRowIndex];

      if (Array.isArray(currentRow)) {
        return currentRow[0].category;
      }

      return currentRow.id;
    };

    _this._rowHeight = function (_ref2) {
      var index = _ref2.index;

      var row = _this.props.rows[index];
      return Array.isArray(row) ? EMOJI_ROW_HEIGHT : CATEGORY_HEADER_ROW_HEIGHT;
    };

    _this._rowRenderer = function (_ref3) {
      var key = _ref3.key,
          index = _ref3.index,
          style = _ref3.style;

      var row = _this.props.rows[index];
      var onChange = _this.props.onChange;


      if (Array.isArray(row)) {
        return _react2.default.createElement(_emojiRow2.default, { key: key, onChange: onChange, style: style, emojis: row });
      }

      var category = row.category,
          id = row.id;

      var attributes = {
        key: key,
        category: category,
        onChange: onChange,
        ref: _this._setCategoryRef(id),
        style: style
      };

      if (index === 0) {
        var _this$props = _this.props,
            modifier = _this$props.modifier,
            onModifierChange = _this$props.onModifierChange;


        attributes.headingDecoration = _react2.default.createElement(_modifiers2.default, { active: modifier, onChange: onModifierChange });
      }

      return _react2.default.createElement(_categoryHeader2.default, attributes);
    };

    _this._setCategoryRef = function (id) {
      return function (category) {
        _this.categories[id] = category;
      };
    };

    _this.jumpToCategory = function (id) {
      var index = (0, _findIndex2.default)(_this.props.rows, function (category) {
        return category.id === id;
      });
      _this.list.scrollToRow(index);
    };

    _this.lastActiveCategory = null;
    _this.categories = {};
    return _this;
  }

  _createClass(Categories, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.rows !== prevProps.rows || this.props.modifier !== prevProps.modifier) {
        this.list.recomputeRowHeights();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var rowCount = this.props.rows.length;

      return _react2.default.createElement(
        _AutoSizer2.default,
        { nonce: this.props.nonce },
        function (_ref4) {
          var height = _ref4.height,
              width = _ref4.width;
          return _react2.default.createElement(_List2.default, {
            height: height,
            onScroll: _this2._onScroll,
            ref: _this2._setListRef,
            rowCount: rowCount,
            rowHeight: _this2._rowHeight,
            rowRenderer: _this2._rowRenderer,
            scrollToAlignment: "start",
            tabIndex: null,
            width: width
          });
        }
      );
    }
  }]);

  return Categories;
}(_react.Component);

Categories.propTypes = {
  rows: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
    category: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.string.isRequired
  }), _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired])).isRequired,
  modifier: _propTypes2.default.string.isRequired,
  onActiveCategoryChange: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onModifierChange: _propTypes2.default.func.isRequired
};
exports.default = Categories;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSizer = exports.default = undefined;

var _AutoSizer2 = __webpack_require__(1114);

var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AutoSizer3.default;
exports.AutoSizer = _AutoSizer3.default;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _detectElementResize = __webpack_require__(1115);

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Decorator component that automatically adjusts the width and height of a single child.
 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
 * All other properties will be passed through to the child component.
 */
var AutoSizer = function (_PureComponent) {
  _inherits(AutoSizer, _PureComponent);

  function AutoSizer(props) {
    _classCallCheck(this, AutoSizer);

    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));

    _this.state = {
      height: 0,
      width: 0
    };

    _this._onResize = _this._onResize.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  _createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      // Delay access of parentNode until mount.
      // This handles edge-cases where the component has already been unmounted before its ref has been set,
      // As well as libraries like react-lite which have a slightly different lifecycle.

      this._parentNode = this._autoSizer.parentNode;

      // Defer requiring resize handler in order to support server-side rendering.
      // See issue #41
      this._detectElementResize = (0, _detectElementResize2.default)(nonce);
      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

      this._onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };

      if (!disableHeight) {
        outerStyle.height = 0;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return _react2.default.createElement(
        'div',
        {
          ref: this._setRef,
          style: outerStyle
        },
        children({ height: height, width: width })
      );
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var _props2 = this.props,
          disableHeight = _props2.disableHeight,
          disableWidth = _props2.disableWidth,
          onResize = _props2.onResize;

      // Guard against AutoSizer component being removed from the DOM immediately after being added.
      // This can result in invalid style values which can result in NaN values if we don't handle them.
      // See issue #150 for more context.

      var height = this._parentNode.offsetHeight || 0;
      var width = this._parentNode.offsetWidth || 0;

      var style = window.getComputedStyle(this._parentNode) || {};
      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
      var paddingRight = parseInt(style.paddingRight, 10) || 0;
      var paddingTop = parseInt(style.paddingTop, 10) || 0;
      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;

      var newHeight = height - paddingTop - paddingBottom;
      var newWidth = width - paddingLeft - paddingRight;

      if (!disableHeight && this.state.height !== newHeight || !disableWidth && this.state.width !== newWidth) {
        this.setState({
          height: height - paddingTop - paddingBottom,
          width: width - paddingLeft - paddingRight
        });

        onResize({ height: height, width: width });
      }
    }
  }, {
    key: '_setRef',
    value: function _setRef(autoSizer) {
      this._autoSizer = autoSizer;
    }
  }]);

  return AutoSizer;
}(_react.PureComponent);

AutoSizer.defaultProps = {
  onResize: function onResize() {}
};
exports.default = AutoSizer;
 false ? AutoSizer.propTypes = {
  /**
  * Function responsible for rendering children.
  * This function should implement the following signature:
  * ({ height, width }) => PropTypes.element
  */
  children: _propTypes2.default.func.isRequired,

  /** Disable dynamic :height property */
  disableHeight: _propTypes2.default.bool,

  /** Disable dynamic :width property */
  disableWidth: _propTypes2.default.bool,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: _propTypes2.default.string,

  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: _propTypes2.default.func.isRequired
} : void 0;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = this;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        animationstring = 'animation',
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            animationstring = pfx + 'Animation';
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles() {
    if (!document.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) element.attachEvent('onresize', fn);else {
      if (!element.__resizeTriggers__) {
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles();
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) resetTriggers(element);
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) element.detachEvent('onresize', fn);else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.default = undefined;

var _List2 = __webpack_require__(1117);

var _List3 = _interopRequireDefault(_List2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _List3.default;
exports.List = _List3.default;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Grid = __webpack_require__(1118);

var _Grid2 = _interopRequireDefault(_Grid);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */
var List = function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List(props, context) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));

    _this._cellRenderer = _this._cellRenderer.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  _createClass(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      this.Grid.forceUpdate();
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
        alignment: alignment,
        rowIndex: index
      }),
          scrollTop = _Grid$getOffsetForCel.scrollTop;

      return scrollTop;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      this.Grid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.recomputeGridSize({
        rowIndex: index
      });
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToPosition({ scrollTop: scrollTop });
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);

      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }, {
    key: '_cellRenderer',
    value: function _cellRenderer(_ref2) {
      var rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          rest = _objectWithoutProperties(_ref2, ['rowIndex', 'style']);

      var rowRenderer = this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer(_extends({
        index: rowIndex,
        style: style
      }, rest));
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }]);

  return List;
}(_react.PureComponent);

List.defaultProps = {
  estimatedRowSize: 30,
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
exports.default = List;
 false ? List.propTypes = {
  'aria-label': _propTypes2.default.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: _propTypes2.default.bool,

  /** Optional CSS class name */
  className: _propTypes2.default.string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _propTypes2.default.number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  height: _propTypes2.default.number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: _propTypes2.default.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: _propTypes2.default.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: _propTypes2.default.number.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: _propTypes2.default.func.isRequired,

  /** Number of rows in list. */
  rowCount: _propTypes2.default.number.isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: _propTypes2.default.number.isRequired,

  /** Vertical offset. */
  scrollTop: _propTypes2.default.number,

  /** Optional inline style */
  style: _propTypes2.default.object,

  /** Tab index for focus */
  tabIndex: _propTypes2.default.number,

  /** Width of list */
  width: _propTypes2.default.number.isRequired
} : void 0;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOverscanIndicesGetter = exports.defaultCellRangeRenderer = exports.accessibilityOverscanIndicesGetter = exports.Grid = exports.default = undefined;

var _Grid2 = __webpack_require__(1119);

var _Grid3 = _interopRequireDefault(_Grid2);

var _accessibilityOverscanIndicesGetter2 = __webpack_require__(1126);

var _accessibilityOverscanIndicesGetter3 = _interopRequireDefault(_accessibilityOverscanIndicesGetter2);

var _defaultCellRangeRenderer2 = __webpack_require__(953);

var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);

var _defaultOverscanIndicesGetter2 = __webpack_require__(952);

var _defaultOverscanIndicesGetter3 = _interopRequireDefault(_defaultOverscanIndicesGetter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Grid3.default;
exports.Grid = _Grid3.default;
exports.accessibilityOverscanIndicesGetter = _accessibilityOverscanIndicesGetter3.default;
exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;
exports.defaultOverscanIndicesGetter = _defaultOverscanIndicesGetter3.default;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(1120);

var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);

var _ScalingCellSizeAndPositionManager = __webpack_require__(1121);

var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);

var _createCallbackMemoizer = __webpack_require__(1123);

var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);

var _defaultOverscanIndicesGetter = __webpack_require__(952);

var _defaultOverscanIndicesGetter2 = _interopRequireDefault(_defaultOverscanIndicesGetter);

var _updateScrollIndexHelper = __webpack_require__(1124);

var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);

var _defaultCellRangeRenderer = __webpack_require__(953);

var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);

var _scrollbarSize = __webpack_require__(1125);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */

var Grid = function (_PureComponent) {
  _inherits(Grid, _PureComponent);

  function Grid(props, context) {
    _classCallCheck(this, Grid);

    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));

    _this.state = {
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0
    };

    // Invokes onSectionRendered callback only when start/stop row or column indices change
    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);

    // Bind functions to instance so they don't lose context when passed around
    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);

    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);

    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;

    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;

    var deferredMeasurementCache = props.deferredMeasurementCache;
    var deferredMode = typeof deferredMeasurementCache !== 'undefined';

    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
      batchAllCells: deferredMode && !deferredMeasurementCache.hasFixedHeight(),
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._columnWidthGetter(params);
      },
      estimatedCellSize: _this._getEstimatedColumnSize(props)
    });
    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
      batchAllCells: deferredMode && !deferredMeasurementCache.hasFixedWidth(),
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._rowHeightGetter(params);
      },
      estimatedCellSize: _this._getEstimatedRowSize(props)
    });

    // See defaultCellRangeRenderer() for more information on the usage of these caches
    _this._cellCache = {};
    _this._styleCache = {};
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  _createClass(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _extends({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = this._scrollbarSize;
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;


      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;


      this._columnSizeAndPositionManager.resetCell(columnIndex);
      this._rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._cellCache = {};
      this._styleCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1) {
        this._updateScrollLeftForScrollToColumn(_extends({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      this._updateScrollTopForScrollToRow(_extends({}, props, {
        scrollToRow: rowIndex
      }));
    }

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop;

      this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = getScrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper2.default)({
          cellSizeAndPositionManager: this._columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper2.default)({
          cellSizeAndPositionManager: this._rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getScrollbarSize = this.props.getScrollbarSize;

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()

      this._scrollbarSize = getScrollbarSize();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }

      this._calculateChildrenToRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var _state2 = this.state,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;


      if (nextProps.columnCount === 0 && scrollLeft !== 0 || nextProps.rowCount === 0 && scrollTop !== 0) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null) {
          newState.scrollLeft = nextProps.scrollLeft;
        }
        if (nextProps.scrollTop != null) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this._setScrollPosition(newState);
      }

      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
        this._styleCache = {};
      }

      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);

      this._columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
      });
      this._rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: this._getEstimatedRowSize(nextProps)
      });

      var _props6 = this.props,
          columnCount = _props6.columnCount,
          rowCount = _props6.rowCount;

      // Special case when either cols or rows were 0
      // This would prevent any cells from rendering
      // So we need to reset row scroll if cols changed from 0 (and vice versa)

      if (columnCount === 0 || rowCount === 0) {
        columnCount = 0;
        rowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && this.props.isScrolling === true) {
        this._resetStyleCache();
      }

      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
        cellCount: columnCount,
        cellSize: this.props.columnWidth,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: nextProps.columnWidth,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: this.props.scrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollLeftForScrollToColumn(nextProps, _this3.state);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
        cellCount: rowCount,
        cellSize: this.props.rowHeight,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: nextProps.rowHeight,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: this.props.scrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollTopForScrollToRow(nextProps, _this3.state);
        }
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this._calculateChildrenToRender(nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          autoContainerWidth = _props7.autoContainerWidth,
          autoHeight = _props7.autoHeight,
          autoWidth = _props7.autoWidth,
          className = _props7.className,
          containerStyle = _props7.containerStyle,
          height = _props7.height,
          id = _props7.id,
          noContentRenderer = _props7.noContentRenderer,
          role = _props7.role,
          style = _props7.style,
          tabIndex = _props7.tabIndex,
          width = _props7.width;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return _react2.default.createElement(
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: _extends({}, gridStyle, style),
          tabIndex: tabIndex
        },
        childrenToDisplay.length > 0 && _react2.default.createElement(
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            style: _extends({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle)
          },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          scrollLeft = state.scrollLeft,
          scrollTop = state.scrollTop;


      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: this._renderedColumnStartIndex,
          stopIndex: this._renderedColumnStopIndex
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: this._renderedRowStartIndex,
          stopIndex: this._renderedRowStopIndex
        });

        // Store for _invokeOnGridRenderedHelper()
        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
        this._rowStopIndex = overscanRowIndices.overscanStopIndex;

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
          columnStartIndex: this._columnStartIndex,
          columnStopIndex: this._columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          parent: this,
          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
          rowStartIndex: this._rowStartIndex,
          rowStopIndex: this._rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_debounceScrollEndedCallback',
    value: function _debounceScrollEndedCallback() {
      this._disablePointerEventsTimeoutId = null;
      this._resetStyleCache();
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */

  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnGridRenderedHelper',
    value: function _invokeOnGridRenderedHelper() {
      var onSectionRendered = this.props.onSectionRendered;


      this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: this._columnStartIndex,
          columnOverscanStopIndex: this._columnStopIndex,
          columnStartIndex: this._renderedColumnStartIndex,
          columnStopIndex: this._renderedColumnStopIndex,
          rowOverscanStartIndex: this._rowStartIndex,
          rowOverscanStopIndex: this._rowStopIndex,
          rowStartIndex: this._renderedRowStartIndex,
          rowStopIndex: this._renderedRowStopIndex
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref7) {
      var _this4 = this;

      var scrollLeft = _ref7.scrollLeft,
          scrollTop = _ref7.scrollTop,
          totalColumnsWidth = _ref7.totalColumnsWidth,
          totalRowsHeight = _ref7.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref8) {
          var scrollLeft = _ref8.scrollLeft,
              scrollTop = _ref8.scrollTop;
          var _props8 = _this4.props,
              height = _props8.height,
              onScroll = _props8.onScroll,
              width = _props8.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? props.isScrolling : state.isScrolling;
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this._scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: '_setScrollingContainerRef',
    value: function _setScrollingContainerRef(ref) {
      this._scrollingContainer = ref;
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref9) {
      var scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_wrapPropertyGetter',
    value: function _wrapPropertyGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(size) {
      return this._wrapPropertyGetter(size);
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var columnCount = props.columnCount,
          height = props.height,
          scrollToAlignment = props.scrollToAlignment,
          scrollToColumn = props.scrollToColumn,
          width = props.width;
      var scrollLeft = state.scrollLeft;


      if (scrollToColumn >= 0 && columnCount > 0) {
        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;

        return this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollLeft = state.scrollLeft;

      var calculatedScrollLeft = this._getCalculatedScrollLeft(props, state);

      if (calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        this._setScrollPosition({
          scrollLeft: calculatedScrollLeft
        });
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var height = props.height,
          rowCount = props.rowCount,
          scrollToAlignment = props.scrollToAlignment,
          scrollToRow = props.scrollToRow,
          width = props.width;
      var scrollTop = state.scrollTop;


      if (scrollToRow >= 0 && rowCount > 0) {
        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

        return this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];
        }
      }

      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollTop = state.scrollTop;

      var calculatedScrollTop = this._getCalculatedScrollTop(props, state);

      if (calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        this._setScrollPosition({
          scrollTop: calculatedScrollTop
        });
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      this.handleScrollEvent(event.target);
    }
  }]);

  return Grid;
}(_react.PureComponent);

Grid.defaultProps = {
  'aria-label': 'grid',
  cellRangeRenderer: _defaultCellRangeRenderer2.default,
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize2.default,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter2.default,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0
};
exports.default = Grid;
 false ? Grid.propTypes = {
  'aria-label': _propTypes2.default.string,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: _propTypes2.default.bool,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: _propTypes2.default.bool,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: _propTypes2.default.bool,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
   */
  cellRenderer: _propTypes2.default.func.isRequired,

  /**
   * Responsible for rendering a group of cells given their index ranges.
   * Should implement the following interface: ({
   *   cellCache: Map,
   *   cellRenderer: Function,
   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
   *   columnStartIndex: number,
   *   columnStopIndex: number,
   *   isScrolling: boolean,
   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
   *   rowStartIndex: number,
   *   rowStopIndex: number,
   *   scrollLeft: number,
   *   scrollTop: number
   * }): Array<PropTypes.node>
   */
  cellRangeRenderer: _propTypes2.default.func.isRequired,

  /**
   * Optional custom CSS class name to attach to root Grid element.
   */
  className: _propTypes2.default.string,

  /**
   * Number of columns in grid.
   */
  columnCount: _propTypes2.default.number.isRequired,

  /**
   * Either a fixed column width (number) or a function that returns the width of a column given its index.
   * Should implement the following interface: (index: number): number
   */
  columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,

  /** Optional inline style applied to inner cell-container */
  containerStyle: _propTypes2.default.object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: _propTypes2.default.object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: _propTypes2.default.number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _propTypes2.default.number.isRequired,

  /**
   * Exposed for testing purposes only.
   */
  getScrollbarSize: _propTypes2.default.func.isRequired,

  /**
   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
   */
  height: _propTypes2.default.number.isRequired,

  /**
   * Optional custom id to attach to root Grid element.
   */
  id: _propTypes2.default.string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: _propTypes2.default.bool,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
   */
  noContentRenderer: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: _propTypes2.default.func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked with information about the section of the Grid that was just rendered.
   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
   */
  onSectionRendered: _propTypes2.default.func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: _propTypes2.default.number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   * Should implement the following interface: ({
   *   cellCount: number,
   *   overscanCellsCount: number,
   *   scrollDirection: number,
   *   startIndex: number,
   *   stopIndex: number
   * }): {overscanStartIndex: number, overscanStopIndex: number}
   */
  overscanIndicesGetter: _propTypes2.default.func.isRequired,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: _propTypes2.default.number.isRequired,

  /**
   * ARIA role for the grid element.
   */
  role: _propTypes2.default.string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,

  /**
   * Number of rows in grid.
   */
  rowCount: _propTypes2.default.number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: _propTypes2.default.number,

  /** Horizontal offset. */
  scrollLeft: _propTypes2.default.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Column index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToColumn: _propTypes2.default.number.isRequired,

  /** Vertical offset. */
  scrollTop: _propTypes2.default.number,

  /**
   * Row index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToRow: _propTypes2.default.number.isRequired,

  /** Optional inline style */
  style: _propTypes2.default.object,

  /** Tab index for focus */
  tabIndex: _propTypes2.default.number,

  /**
   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
   */
  width: _propTypes2.default.number.isRequired
} : void 0;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 *
 * @param cellCount Number of rows or columns in the current axis
 * @param cellsSize Width or height of cells for the current axis
 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
 * @param nextCellsCount Newly updated number of rows or columns in the current axis
 * @param nextCellsSize Newly updated width or height of cells for the current axis
 * @param nextScrollToIndex Newly updated scroll-to-index
 * @param scrollToIndex Scroll-to-index
 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MAX_SCROLL_SIZE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CellSizeAndPositionManager = __webpack_require__(1122);

var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */
var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */

var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize,
        params = _objectWithoutProperties(_ref, ['maxScrollSize']);

    _classCallCheck(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
    this._maxScrollSize = maxScrollSize;
  }

  _createClass(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex,
          totalSize = _ref3.totalSize;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex,
        totalSize: totalSize
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager = function () {
  function CellSizeAndPositionManager(_ref) {
    var _ref$batchAllCells = _ref.batchAllCells,
        batchAllCells = _ref$batchAllCells === undefined ? false : _ref$batchAllCells,
        cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    _classCallCheck(this, CellSizeAndPositionManager);

    this._batchAllCells = batchAllCells;
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;

    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    this._cellSizeAndPositionData = {};

    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    this._lastMeasuredIndex = -1;

    // Used in deferred mode to track which cells have been queued for measurement.
    this._lastBatchedIndex = -1;
  }

  _createClass(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref3) {
      var containerSize = _ref3.containerSize,
          offset = _ref3.offset;

      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells as measured the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();

      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === undefined ? 'auto' : _ref4$align,
          containerSize = _ref4.containerSize,
          currentOffset = _ref4.currentOffset,
          targetIndex = _ref4.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
      // eg we can't know a row's height without measuring the height of all columns within that row.
      if (this._batchAllCells) {
        return {
          start: 0,
          stop: this._cellCount - 1
        };
      }

      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(_ref5) {
      var high = _ref5.high,
          low = _ref5.low,
          offset = _ref5.offset;

      var middle = void 0;
      var currentOffset = void 0;

      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(_ref6) {
      var index = _ref6.index,
          offset = _ref6.offset;

      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch({
        high: Math.min(index, this._cellCount - 1),
        low: Math.floor(index / 2),
        offset: offset
      });
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch({
          high: lastMeasuredIndex,
          low: 0,
          offset: offset
        });
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch({
          index: lastMeasuredIndex,
          offset: offset
        });
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

exports.default = CellSizeAndPositionManager;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateScrollIndexHelper;
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 *
 * @param cellsSize Width or height of cells for the current axis
 * @param cellSizeAndPositionManager Manages size and position metadata of cells
 * @param previousCellsCount Previous number of rows or columns
 * @param previousCellsSize Previous width or height of cells
 * @param previousScrollToIndex Previous scroll-to-index
 * @param previousSize Previous width or height of the virtualized container
 * @param scrollOffset Current scrollLeft or scrollTop
 * @param scrollToIndex Scroll-to-index
 * @param size Width or height of the virtualized container
 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
 */
function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(95);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultOverscanIndicesGetter;
var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 *
 * @param direction One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
 * @param cellCount Number of rows or columns in the current axis
 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
 * @param overscanCellsCount Maximum number of cells to over-render in either direction
 * @param startIndex Begin of range of visible cells
 * @param stopIndex End of range of visible cells
 */
function defaultOverscanIndicesGetter(_ref) {
  var direction = _ref.direction,
      cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  var overscanStartIndex = void 0;
  var overscanStopIndex = void 0;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  switch (scrollDirection) {
    case SCROLL_DIRECTION_FORWARD:
      overscanStartIndex = startIndex - 1;
      overscanStopIndex = stopIndex + overscanCellsCount;
      break;
    case SCROLL_DIRECTION_BACKWARD:
      overscanStartIndex = startIndex - overscanCellsCount;
      overscanStopIndex = stopIndex + 1;
      break;
  }

  return {
    overscanStartIndex: Math.max(0, overscanStartIndex),
    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
  };
}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1128),
    baseIteratee = __webpack_require__(929),
    toInteger = __webpack_require__(954);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(426);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(955);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryHeader = function (_Component) {
  _inherits(CategoryHeader, _Component);

  function CategoryHeader() {
    _classCallCheck(this, CategoryHeader);

    return _possibleConstructorReturn(this, (CategoryHeader.__proto__ || Object.getPrototypeOf(CategoryHeader)).apply(this, arguments));
  }

  _createClass(CategoryHeader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          category = _props.category,
          headingDecoration = _props.headingDecoration,
          style = _props.style;


      return _react2.default.createElement(
        "div",
        { className: "emoji-category-header", style: style },
        _react2.default.createElement(
          "h2",
          { className: "emoji-category-title" },
          category.title
        ),
        _react2.default.createElement(
          "div",
          { className: "emoji-category-heading-decoration" },
          headingDecoration
        )
      );
    }
  }]);

  return CategoryHeader;
}(_react.Component);

CategoryHeader.propTypes = {
  category: _propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired
  }).isRequired,
  headingDecoration: _propTypes2.default.node,
  onChange: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
};
exports.default = CategoryHeader;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(955);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _emoji = __webpack_require__(951);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmojiRow = function (_Component) {
  _inherits(EmojiRow, _Component);

  function EmojiRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EmojiRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmojiRow.__proto__ || Object.getPrototypeOf(EmojiRow)).call.apply(_ref, [this].concat(args))), _this), _this._handleEmojiSelect = function (ev, emoji) {
      _this.props.onChange(emoji);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EmojiRow, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          emojis = _props.emojis,
          style = _props.style;


      return _react2.default.createElement(
        "div",
        { className: "emoji-row", style: style },
        emojis.map(function (emoji) {
          return _react2.default.createElement(_emoji2.default, _extends({}, emoji, {
            ariaLabel: emoji.name,
            role: "option",
            key: emoji.unicode,
            onSelect: _this2._handleEmojiSelect
          }));
        })
      );
    }
  }]);

  return EmojiRow;
}(_react.Component);

EmojiRow.propTypes = {
  emojis: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object.isRequired
};
exports.default = EmojiRow;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = __webpack_require__(897);

var _map2 = _interopRequireDefault(_map);

var _modifier = __webpack_require__(1133);

var _modifier2 = _interopRequireDefault(_modifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modifiers = function (_Component) {
  _inherits(Modifiers, _Component);

  function Modifiers() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modifiers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modifiers.__proto__ || Object.getPrototypeOf(Modifiers)).call.apply(_ref, [this].concat(args))), _this), _this._handleModifierClick = function (ev, index) {
      _this.props.onChange(index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modifiers, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "ol",
        { className: "modifiers" },
        (0, _map2.default)(this.props.modifiers, function (hex, type) {
          return _react2.default.createElement(
            "li",
            { key: type },
            _react2.default.createElement(_modifier2.default, {
              hex: hex,
              type: type,
              active: _this2.props.active === type,
              onClick: _this2._handleModifierClick
            })
          );
        })
      );
    }
  }]);

  return Modifiers;
}(_react.Component);

Modifiers.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  modifiers: _propTypes2.default.object,
  active: _propTypes2.default.string
};
Modifiers.defaultProps = {
  active: 0,
  modifiers: {
    0: "#FFDE5C",
    1: "#FFE1BB",
    2: "#FFD0A9",
    3: "#D7A579",
    4: "#B57D52",
    5: "#8B6858"
  }
};
exports.default = Modifiers;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modifier = function (_Component) {
  _inherits(Modifier, _Component);

  function Modifier() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modifier);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modifier.__proto__ || Object.getPrototypeOf(Modifier)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (ev) {
      _this.props.onClick(ev, _this.props.type);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modifier, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("a", {
        onClick: this._handleClick,
        className: this.props.active ? "modifier active" : "modifier",
        style: { background: this.props.hex },
        "aria-label": "Fitzpatrick type " + this.props.type
      });
    }
  }]);

  return Modifier;
}(_react.Component);

Modifier.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  active: _propTypes2.default.bool,
  type: _propTypes2.default.string.isRequired,
  hex: _propTypes2.default.string.isRequired
};
exports.default = Modifier;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRowsSelector;

var _escapeStringRegexp = __webpack_require__(1135);

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

var _chunk = __webpack_require__(1136);

var _chunk2 = _interopRequireDefault(_chunk);

var _map = __webpack_require__(897);

var _map2 = _interopRequireDefault(_map);

var _values = __webpack_require__(1138);

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function rowsSelector(categories, emojisByCategory, modifier, search, term) {
  var findEmojiVariant = function findEmojiVariant(emojis) {
    return modifier && emojis[modifier] ? emojis[modifier] : emojis[0];
  };
  var searchTermRegExp = new RegExp("^(?:.* +)*" + (0, _escapeStringRegexp2.default)(term), "i");
  var keywordMatchesSearchTerm = function keywordMatchesSearchTerm(keyword) {
    return searchTermRegExp.test(keyword);
  };
  var emojiMatchesSearchTerm = function emojiMatchesSearchTerm(emoji) {
    return emoji.keywords.concat(emoji.name).some(keywordMatchesSearchTerm);
  };

  return (0, _map2.default)(categories, function (category, id) {
    var list = emojisByCategory[id] || {};
    var emojis = (0, _values2.default)(list).map(findEmojiVariant);

    if (search && term) {
      emojis = emojis.filter(emojiMatchesSearchTerm);
    }

    return {
      category: category,
      emojis: emojis,
      id: id
    };
  }).filter(function (_ref) {
    var emojis = _ref.emojis;
    return emojis.length > 0;
  }).map(function (_ref2) {
    var category = _ref2.category,
        emojis = _ref2.emojis,
        id = _ref2.id;
    return [{
      category: category,
      id: id
    }].concat(_toConsumableArray((0, _chunk2.default)(emojis, 8)));
  }).reduce(function (rows, categoryAndEmojiRows) {
    return [].concat(_toConsumableArray(rows), _toConsumableArray(categoryAndEmojiRows));
  }, []);
}

function createRowsSelector() {
  var lastCategories = void 0;
  var lastEmojisByCategory = void 0;
  var lastModifier = void 0;
  var lastSearch = void 0;
  var lastTerm = void 0;
  var lastResult = void 0;

  return function memoizedRowsSelector(categories, emojisByCategory, modifier, search, term) {
    if (categories !== lastCategories || emojisByCategory !== lastEmojisByCategory || modifier !== lastModifier || search !== lastSearch || term !== lastTerm) {
      lastResult = rowsSelector(categories, emojisByCategory, modifier, search, term);
      lastCategories = categories;
      lastEmojisByCategory = emojisByCategory;
      lastModifier = modifier;
      lastSearch = search;
      lastTerm = term;
    }

    return lastResult;
  };
}

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(949),
    isIterateeCall = __webpack_require__(1137),
    toInteger = __webpack_require__(954);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(886),
    isArrayLike = __webpack_require__(874),
    isIndex = __webpack_require__(882),
    isObject = __webpack_require__(114);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1139),
    keys = __webpack_require__(871);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(883);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createEmojisFromStrategy;
function createEmojisFromStrategy(strategy) {
  var emojis = {};

  // categorise and nest emoji
  // sort ensures that modifiers appear unmodified keys
  var keys = Object.keys(strategy);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var value = strategy[key];

      // skip unknown categories
      if (value.category !== "modifier") {
        if (!emojis[value.category]) emojis[value.category] = {};
        var match = key.match(/(.*?)_tone(.*?)$/);

        if (match) {
          // ensure the shortname is included as a keyword
          if (!value.keywords.includes(match[1])) {
            value.keywords.push(match[1]);
          }

          // this check is to stop the plugin from failing in the case that the
          // emoji strategy miscategorizes tones - which was the case here:
          // https://github.com/Ranks/emojione/pull/330
          var unmodifiedEmojiExists = !!emojis[value.category][match[1]];
          if (unmodifiedEmojiExists) {
            emojis[value.category][match[1]][match[2]] = value;
          }
        } else {
          // ensure the shortname is included as a keyword
          if (!value.keywords.includes(key)) {
            value.keywords.push(key);
          }

          emojis[value.category][key] = [value];
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return emojis;
}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultCategories = exports.defaultCategories = { // eslint-disable-line
  people: {
    title: 'People',
    emoji: 'smile'
  },
  nature: {
    title: 'Nature',
    emoji: 'hamster'
  },
  food: {
    title: 'Food & Drink',
    emoji: 'pizza'
  },
  activity: {
    title: 'Activity',
    emoji: 'soccer'
  },
  travel: {
    title: 'Travel & Places',
    emoji: 'earth_americas'
  },
  objects: {
    title: 'Objects',
    emoji: 'bulb'
  },
  symbols: {
    title: 'Symbols',
    emoji: 'clock9'
  },
  flags: {
    title: 'Flags',
    emoji: 'flag_gb'
  }
};

/***/ })
]));


// WEBPACK FOOTER //
// emojione_picker-18673c9767d98d94bf1f.js